
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4692"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4692"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aqljF", function(module, exports) {

$parcel$export(module.exports, "ExtensionType", () => $ce7403ae6d8e5ae9$export$4f037c6ec2da4eeb);
$parcel$export(module.exports, "extensions", () => $ce7403ae6d8e5ae9$export$cc3e2d3244e01b7f);
"use strict";
var $ce7403ae6d8e5ae9$export$4f037c6ec2da4eeb = /* @__PURE__ */ ((ExtensionType2)=>{
    ExtensionType2["Application"] = "application";
    ExtensionType2["WebGLPipes"] = "webgl-pipes";
    ExtensionType2["WebGLPipesAdaptor"] = "webgl-pipes-adaptor";
    ExtensionType2["WebGLSystem"] = "webgl-system";
    ExtensionType2["WebGPUPipes"] = "webgpu-pipes";
    ExtensionType2["WebGPUPipesAdaptor"] = "webgpu-pipes-adaptor";
    ExtensionType2["WebGPUSystem"] = "webgpu-system";
    ExtensionType2["CanvasSystem"] = "canvas-system";
    ExtensionType2["CanvasPipesAdaptor"] = "canvas-pipes-adaptor";
    ExtensionType2["CanvasPipes"] = "canvas-pipes";
    ExtensionType2["Asset"] = "asset";
    ExtensionType2["LoadParser"] = "load-parser";
    ExtensionType2["ResolveParser"] = "resolve-parser";
    ExtensionType2["CacheParser"] = "cache-parser";
    ExtensionType2["DetectionParser"] = "detection-parser";
    ExtensionType2["MaskEffect"] = "mask-effect";
    ExtensionType2["BlendMode"] = "blend-mode";
    ExtensionType2["TextureSource"] = "texture-source";
    ExtensionType2["Environment"] = "environment";
    return ExtensionType2;
})($ce7403ae6d8e5ae9$export$4f037c6ec2da4eeb || {});
const $ce7403ae6d8e5ae9$var$normalizeExtension = (ext)=>{
    if (typeof ext === "function" || typeof ext === "object" && ext.extension) {
        if (!ext.extension) throw new Error("Extension class must have an extension object");
        const metadata = typeof ext.extension !== "object" ? {
            type: ext.extension
        } : ext.extension;
        ext = {
            ...metadata,
            ref: ext
        };
    }
    if (typeof ext === "object") ext = {
        ...ext
    };
    else throw new Error("Invalid extension type");
    if (typeof ext.type === "string") ext.type = [
        ext.type
    ];
    return ext;
};
const $ce7403ae6d8e5ae9$export$ba4241979983e013 = (ext, defaultPriority)=>$ce7403ae6d8e5ae9$var$normalizeExtension(ext).priority ?? defaultPriority;
const $ce7403ae6d8e5ae9$export$cc3e2d3244e01b7f = {
    /** @ignore */ _addHandlers: {},
    /** @ignore */ _removeHandlers: {},
    /** @ignore */ _queue: {},
    /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed.
   * @returns {extensions} For chaining.
   */ remove (...extensions2) {
        extensions2.map($ce7403ae6d8e5ae9$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>this._removeHandlers[type]?.(ext));
        });
        return this;
    },
    /**
   * Register new extensions with PixiJS.
   * @param extensions - The spread of extensions to add to PixiJS.
   * @returns {extensions} For chaining.
   */ add (...extensions2) {
        extensions2.map($ce7403ae6d8e5ae9$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>{
                const handlers = this._addHandlers;
                const queue = this._queue;
                if (!handlers[type]) {
                    queue[type] = queue[type] || [];
                    queue[type]?.push(ext);
                } else handlers[type]?.(ext);
            });
        });
        return this;
    },
    /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function handler when extensions are added/registered {@link StrictExtensionFormat}.
   * @param onRemove  - Function handler when extensions are removed/unregistered {@link StrictExtensionFormat}.
   * @returns {extensions} For chaining.
   */ handle (type, onAdd, onRemove) {
        const addHandlers = this._addHandlers;
        const removeHandlers = this._removeHandlers;
        if (addHandlers[type] || removeHandlers[type]) throw new Error(`Extension type ${type} already has a handler`);
        addHandlers[type] = onAdd;
        removeHandlers[type] = onRemove;
        const queue = this._queue;
        if (queue[type]) {
            queue[type]?.forEach((ext)=>onAdd(ext));
            delete queue[type];
        }
        return this;
    },
    /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns {extensions} For chaining.
   */ handleByMap (type, map) {
        return this.handle(type, (extension)=>{
            if (extension.name) map[extension.name] = extension.ref;
        }, (extension)=>{
            if (extension.name) delete map[extension.name];
        });
    },
    /**
   * Handle a type, but using a list of extensions with a `name` property.
   * @param type - Type of extension to handle.
   * @param map - The array of named extensions.
   * @param defaultPriority - Fallback priority if none is defined.
   * @returns {extensions} For chaining.
   */ handleByNamedList (type, map, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            const index = map.findIndex((item)=>item.name === extension.name);
            if (index >= 0) return;
            map.push({
                name: extension.name,
                value: extension.ref
            });
            map.sort((a, b)=>$ce7403ae6d8e5ae9$export$ba4241979983e013(b.value, defaultPriority) - $ce7403ae6d8e5ae9$export$ba4241979983e013(a.value, defaultPriority));
        }, (extension)=>{
            const index = map.findIndex((item)=>item.name === extension.name);
            if (index !== -1) map.splice(index, 1);
        });
    },
    /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns {extensions} For chaining.
   */ handleByList (type, list, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            if (list.includes(extension.ref)) return;
            list.push(extension.ref);
            list.sort((a, b)=>$ce7403ae6d8e5ae9$export$ba4241979983e013(b, defaultPriority) - $ce7403ae6d8e5ae9$export$ba4241979983e013(a, defaultPriority));
        }, (extension)=>{
            const index = list.indexOf(extension.ref);
            if (index !== -1) list.splice(index, 1);
        });
    }
};

});

parcelRegister("6kAkb", function(module, exports) {

var $5xBLx = parcelRequire("5xBLx");
module.exports = Promise.all([
    $5xBLx("I6PdM"),
    $5xBLx("jgEe0"),
    $5xBLx("6GKLk")
]).then(()=>parcelRequire("dcCDc"));

});
parcelRegister("5xBLx", function(module, exports) {
"use strict";

function $408d544b68603b02$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("2y56P")).resolve(id));
}
module.exports = $408d544b68603b02$var$load;

});
parcelRegister("2y56P", function(module, exports) {

$parcel$export(module.exports, "register", () => $1db2b85679ddeeaa$export$6503ec6e8aabbaf, (v) => $1db2b85679ddeeaa$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $1db2b85679ddeeaa$export$f7ad0328861e2f03, (v) => $1db2b85679ddeeaa$export$f7ad0328861e2f03 = v);
var $1db2b85679ddeeaa$export$6503ec6e8aabbaf;
var $1db2b85679ddeeaa$export$f7ad0328861e2f03;
"use strict";
var $1db2b85679ddeeaa$var$mapping = new Map();
function $1db2b85679ddeeaa$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$1db2b85679ddeeaa$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $1db2b85679ddeeaa$var$resolve(id) {
    var resolved = $1db2b85679ddeeaa$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$1db2b85679ddeeaa$export$6503ec6e8aabbaf = $1db2b85679ddeeaa$var$register;
$1db2b85679ddeeaa$export$f7ad0328861e2f03 = $1db2b85679ddeeaa$var$resolve;

});



parcelRegister("8QmW1", function(module, exports) {

var $5xBLx = parcelRequire("5xBLx");
module.exports = Promise.all([
    $5xBLx("I6PdM"),
    $5xBLx("jgEe0"),
    $5xBLx("5kcvn")
]).then(()=>parcelRequire("iFTNw"));

});

parcelRegister("e7HG4", function(module, exports) {

var $aqljF = parcelRequire("aqljF");

var $7qUOR = parcelRequire("7qUOR");

var $iGUYs = parcelRequire("iGUYs");

var $63hmg = parcelRequire("63hmg");

var $2R8JI = parcelRequire("2R8JI");

var $keToW = parcelRequire("keToW");

var $5yirD = parcelRequire("5yirD");

var $9yTSr = parcelRequire("9yTSr");
parcelRequire("3ATmb");

"use strict";
(0, $aqljF.extensions).add((0, $7qUOR.AlphaMask), (0, $iGUYs.ColorMask), (0, $63hmg.StencilMask), (0, $9yTSr.VideoSource), (0, $5yirD.ImageSource), (0, $keToW.CanvasSource), (0, $2R8JI.BufferImageSource));

});
parcelRegister("7qUOR", function(module, exports) {

$parcel$export(module.exports, "AlphaMask", () => $b0ba60a1fccac475$export$3c32667be409917c);

var $aqljF = parcelRequire("aqljF");

var $j5g5m = parcelRequire("j5g5m");

var $fxPhW = parcelRequire("fxPhW");

var $hH44q = parcelRequire("hH44q");
"use strict";
class $b0ba60a1fccac475$export$3c32667be409917c {
    constructor(options){
        this.priority = 0;
        this.pipe = "alphaMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
        this.renderMaskToTexture = !(mask instanceof (0, $j5g5m.Sprite));
        this.mask.renderable = this.renderMaskToTexture;
        this.mask.includeInBuild = !this.renderMaskToTexture;
        this.mask.measurable = false;
    }
    reset() {
        this.mask.measurable = true;
        this.mask = null;
    }
    addBounds(bounds, skipUpdateTransform) {
        (0, $fxPhW.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $hH44q.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    destroy() {
        this.reset();
    }
    static test(mask) {
        return mask instanceof (0, $j5g5m.Sprite);
    }
}
$b0ba60a1fccac475$export$3c32667be409917c.extension = (0, $aqljF.ExtensionType).MaskEffect;

});
parcelRegister("j5g5m", function(module, exports) {

$parcel$export(module.exports, "Sprite", () => $67a722de13db7db7$export$3075603db8e6204c);

var $lej7S = parcelRequire("lej7S");

var $jollT = parcelRequire("jollT");

var $c2qdP = parcelRequire("c2qdP");

var $e0Ilp = parcelRequire("e0Ilp");
"use strict";
class $67a722de13db7db7$export$3075603db8e6204c extends (0, $e0Ilp.Container) {
    /**
   * @param options - The options for creating the sprite.
   */ constructor(options = (0, $jollT.Texture).EMPTY){
        if (options instanceof (0, $jollT.Texture)) options = {
            texture: options
        };
        const { texture: texture, anchor: anchor, roundPixels: roundPixels, width: width, height: height, ...rest } = options;
        super({
            label: "Sprite",
            ...rest
        });
        this.renderPipeId = "sprite";
        this.batched = true;
        this._didSpriteUpdate = false;
        this._bounds = {
            minX: 0,
            maxX: 1,
            minY: 0,
            maxY: 0
        };
        this._sourceBounds = {
            minX: 0,
            maxX: 1,
            minY: 0,
            maxY: 0
        };
        this._boundsDirty = true;
        this._sourceBoundsDirty = true;
        this._roundPixels = 0;
        this._anchor = new (0, $lej7S.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        else if (texture.defaultAnchor) this.anchor = texture.defaultAnchor;
        this.texture = texture;
        this.allowChildren = false;
        this.roundPixels = roundPixels ?? false;
        if (width) this.width = width;
        if (height) this.height = height;
    }
    /**
   * Helper function that creates a new sprite based on the source you provide.
   * The source can be - frame id, image, video, canvas element, video element, texture
   * @param source - Source to create texture from
   * @param [skipCache] - Whether to skip the cache or not
   * @returns The newly created sprite
   */ static from(source, skipCache = false) {
        if (source instanceof (0, $jollT.Texture)) return new $67a722de13db7db7$export$3075603db8e6204c(source);
        return new $67a722de13db7db7$export$3075603db8e6204c((0, $jollT.Texture).from(source, skipCache));
    }
    set texture(value) {
        value || (value = (0, $jollT.Texture).EMPTY);
        const currentTexture = this._texture;
        if (currentTexture === value) return;
        if (currentTexture && currentTexture.dynamic) currentTexture.off("update", this.onViewUpdate, this);
        if (value.dynamic) value.on("update", this.onViewUpdate, this);
        this._texture = value;
        this.onViewUpdate();
    }
    /** The texture that the sprite is using. */ get texture() {
        return this._texture;
    }
    /**
   * The local bounds of the sprite.
   * @type {rendering.Bounds}
   */ get bounds() {
        if (this._boundsDirty) {
            this._updateBounds();
            this._boundsDirty = false;
        }
        return this._bounds;
    }
    /**
   * The bounds of the sprite, taking the texture's trim into account.
   * @type {rendering.Bounds}
   */ get sourceBounds() {
        if (this._sourceBoundsDirty) {
            this._updateSourceBounds();
            this._sourceBoundsDirty = false;
        }
        return this._sourceBounds;
    }
    /**
   * Checks if the object contains the given point.
   * @param point - The point to check
   */ containsPoint(point) {
        const bounds = this.sourceBounds;
        if (point.x >= bounds.maxX && point.x <= bounds.minX) {
            if (point.y >= bounds.maxY && point.y <= bounds.minY) return true;
        }
        return false;
    }
    /**
   * Adds the bounds of this object to the bounds object.
   * @param bounds - The output bounds object.
   */ addBounds(bounds) {
        const _bounds = this._texture.trim ? this.sourceBounds : this.bounds;
        bounds.addFrame(_bounds.minX, _bounds.minY, _bounds.maxX, _bounds.maxY);
    }
    onViewUpdate() {
        this._didChangeId += 4096;
        this._didSpriteUpdate = true;
        this._sourceBoundsDirty = this._boundsDirty = true;
        if (this.didViewUpdate) return;
        this.didViewUpdate = true;
        if (this.renderGroup) this.renderGroup.onChildViewUpdate(this);
    }
    _updateBounds() {
        (0, $c2qdP.updateQuadBounds)(this._bounds, this._anchor, this._texture, 0);
    }
    _updateSourceBounds() {
        const anchor = this._anchor;
        const texture = this._texture;
        const sourceBounds = this._sourceBounds;
        const { width: width, height: height } = texture.orig;
        sourceBounds.maxX = -anchor._x * width;
        sourceBounds.minX = sourceBounds.maxX + width;
        sourceBounds.maxY = -anchor._y * height;
        sourceBounds.minY = sourceBounds.maxY + height;
    }
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the renderable as well
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the renderable as well
   */ destroy(options = false) {
        super.destroy(options);
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            this._texture.destroy(destroyTextureSource);
        }
        this._texture = null;
        this._bounds = null;
        this._sourceBounds = null;
        this._anchor = null;
    }
    /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * The default is `(0,0)`, this means the sprite's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite({texture: Texture.WHITE});
   * sprite.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   *  Whether or not to round the x/y position of the sprite.
   * @type {boolean}
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    set roundPixels(value) {
        this._roundPixels = value ? 1 : 0;
    }
    /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */ get width() {
        return Math.abs(this.scale.x) * this._texture.orig.width;
    }
    set width(value) {
        this._setWidth(value, this._texture.orig.width);
    }
    /** The height of the sprite, setting this will actually modify the scale to achieve the value set. */ get height() {
        return Math.abs(this.scale.y) * this._texture.orig.height;
    }
    set height(value) {
        this._setHeight(value, this._texture.orig.height);
    }
    /**
   * Retrieves the size of the Sprite as a [Size]{@link Size} object.
   * This is faster than get the width and height separately.
   * @param out - Optional object to store the size in.
   * @returns - The size of the Sprite.
   */ getSize(out) {
        if (!out) out = {};
        out.width = Math.abs(this.scale.x) * this._texture.orig.width;
        out.height = Math.abs(this.scale.y) * this._texture.orig.height;
        return out;
    }
    /**
   * Sets the size of the Sprite to the specified width and height.
   * This is faster than setting the width and height separately.
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */ setSize(value, height) {
        let convertedWidth;
        let convertedHeight;
        if (typeof value !== "object") {
            convertedWidth = value;
            convertedHeight = height ?? value;
        } else {
            convertedWidth = value.width;
            convertedHeight = value.height ?? value.width;
        }
        if (convertedWidth !== void 0) this._setWidth(convertedWidth, this._texture.orig.width);
        if (convertedHeight !== void 0) this._setHeight(convertedHeight, this._texture.orig.height);
    }
}

});
parcelRegister("lej7S", function(module, exports) {

$parcel$export(module.exports, "ObservablePoint", () => $dc55c9d115ce0251$export$3755aaad3fd42e52);
"use strict";
class $dc55c9d115ce0251$export$3755aaad3fd42e52 {
    /**
   * Creates a new `ObservablePoint`
   * @param observer - Observer to pass to listen for change events.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(observer, x, y){
        this._x = x || 0;
        this._y = y || 0;
        this._observer = observer;
    }
    /**
   * Creates a clone of this point.
   * @param observer - Optional observer to pass to the new observable point.
   * @returns a copy of this observable point
   */ clone(observer) {
        return new $dc55c9d115ce0251$export$3755aaad3fd42e52(observer ?? this._observer, this._x, this._y);
    }
    /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=x] - position of the point on the y axis
   * @returns The observable point instance itself
   */ set(x = 0, y = x) {
        if (this._x !== x || this._y !== y) {
            this._x = x;
            this._y = y;
            this._observer._onUpdate(this);
        }
        return this;
    }
    /**
   * Copies x and y from the given point (`p`)
   * @param p - The point to copy from. Can be any of type that is or extends `PointData`
   * @returns The observable point instance itself
   */ copyFrom(p) {
        if (this._x !== p.x || this._y !== p.y) {
            this._x = p.x;
            this._y = p.y;
            this._observer._onUpdate(this);
        }
        return this;
    }
    /**
   * Copies this point's x and y into that of the given point (`p`)
   * @param p - The point to copy to. Can be any of type that is or extends `PointData`
   * @returns The point (`p`) with values updated
   */ copyTo(p) {
        p.set(this._x, this._y);
        return p;
    }
    /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */ equals(p) {
        return p.x === this._x && p.y === this._y;
    }
    toString() {
        return `[pixi.js/math:ObservablePoint x=${0} y=${0} scope=${this._observer}]`;
    }
    /** Position of the observable point on the x axis. */ get x() {
        return this._x;
    }
    set x(value) {
        if (this._x !== value) {
            this._x = value;
            this._observer._onUpdate(this);
        }
    }
    /** Position of the observable point on the y axis. */ get y() {
        return this._y;
    }
    set y(value) {
        if (this._y !== value) {
            this._y = value;
            this._observer._onUpdate(this);
        }
    }
}

});

parcelRegister("jollT", function(module, exports) {

$parcel$export(module.exports, "Texture", () => $3206fee81954f0b6$export$5431306cf43de24a);

var $gpXaq = parcelRequire("gpXaq");

var $2RpbF = parcelRequire("2RpbF");

var $hFBUu = parcelRequire("hFBUu");

var $by5BM = parcelRequire("by5BM");

var $j0fPb = parcelRequire("j0fPb");

var $cP4xy = parcelRequire("cP4xy");

var $2R8JI = parcelRequire("2R8JI");

var $eIuJW = parcelRequire("eIuJW");

var $jxdeQ = parcelRequire("jxdeQ");
"use strict";
class $3206fee81954f0b6$export$5431306cf43de24a extends (0, (/*@__PURE__*/$parcel$interopDefault($gpXaq))) {
    /**
   * @param {TextureOptions} param0 - Options for the texture
   */ constructor({ source: source, label: label, frame: frame, orig: orig, trim: trim, defaultAnchor: defaultAnchor, defaultBorders: defaultBorders, rotate: rotate, dynamic: dynamic } = {}){
        super();
        /** unique id for this texture */ this.uid = (0, $by5BM.uid)("texture");
        /** A uvs object based on the given frame and the texture source */ this.uvs = {
            x0: 0,
            y0: 0,
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            x3: 0,
            y3: 0
        };
        /**
     * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
     * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
     */ this.frame = new (0, $hFBUu.Rectangle)();
        /**
     * Does this Texture have any frame data assigned to it?
     *
     * This mode is enabled automatically if no frame was passed inside constructor.
     *
     * In this mode texture is subscribed to baseTexture events, and fires `update` on any change.
     *
     * Beware, after loading or resize of baseTexture event can fired two times!
     * If you want more control, subscribe on baseTexture itself.
     * @example
     * texture.on('update', () => {});
     */ this.noFrame = false;
        /**
     * Set to true if you plan on modifying the uvs of this texture.
     * When this is the case, sprites and other objects using the texture will
     * make sure to listen for changes to the uvs and update their vertices accordingly.
     */ this.dynamic = false;
        /** is it a texture? yes! used for type checking */ this.isTexture = true;
        this.label = label;
        this.source = source?.source ?? new (0, $eIuJW.TextureSource)();
        this.noFrame = !frame;
        if (frame) this.frame.copyFrom(frame);
        else {
            const { width: width, height: height } = this._source;
            this.frame.width = width;
            this.frame.height = height;
        }
        this.orig = orig || this.frame;
        this.trim = trim;
        this.rotate = rotate ?? 0;
        this.defaultAnchor = defaultAnchor;
        this.defaultBorders = defaultBorders;
        this.destroyed = false;
        this.dynamic = dynamic || false;
        this.updateUvs();
    }
    set source(value) {
        if (this._source) this._source.off("resize", this.update, this);
        this._source = value;
        value.on("resize", this.update, this);
        this.emit("update", this);
    }
    /** the underlying source of the texture (equivalent of baseTexture in v7) */ get source() {
        return this._source;
    }
    /** returns a TextureMatrix instance for this texture. By default, that object is not created because its heavy. */ get textureMatrix() {
        if (!this._textureMatrix) this._textureMatrix = new (0, $jxdeQ.TextureMatrix)(this);
        return this._textureMatrix;
    }
    /** The width of the Texture in pixels. */ get width() {
        return this.orig.width;
    }
    /** The height of the Texture in pixels. */ get height() {
        return this.orig.height;
    }
    /** Call this function when you have modified the frame of this texture. */ updateUvs() {
        const { uvs: uvs, frame: frame } = this;
        const { width: width, height: height } = this._source;
        const nX = frame.x / width;
        const nY = frame.y / height;
        const nW = frame.width / width;
        const nH = frame.height / height;
        let rotate = this.rotate;
        if (rotate) {
            const w2 = nW / 2;
            const h2 = nH / 2;
            const cX = nX + w2;
            const cY = nY + h2;
            rotate = (0, $2RpbF.groupD8).add(rotate, (0, $2RpbF.groupD8).NW);
            uvs.x0 = cX + w2 * (0, $2RpbF.groupD8).uX(rotate);
            uvs.y0 = cY + h2 * (0, $2RpbF.groupD8).uY(rotate);
            rotate = (0, $2RpbF.groupD8).add(rotate, 2);
            uvs.x1 = cX + w2 * (0, $2RpbF.groupD8).uX(rotate);
            uvs.y1 = cY + h2 * (0, $2RpbF.groupD8).uY(rotate);
            rotate = (0, $2RpbF.groupD8).add(rotate, 2);
            uvs.x2 = cX + w2 * (0, $2RpbF.groupD8).uX(rotate);
            uvs.y2 = cY + h2 * (0, $2RpbF.groupD8).uY(rotate);
            rotate = (0, $2RpbF.groupD8).add(rotate, 2);
            uvs.x3 = cX + w2 * (0, $2RpbF.groupD8).uX(rotate);
            uvs.y3 = cY + h2 * (0, $2RpbF.groupD8).uY(rotate);
        } else {
            uvs.x0 = nX;
            uvs.y0 = nY;
            uvs.x1 = nX + nW;
            uvs.y1 = nY;
            uvs.x2 = nX + nW;
            uvs.y2 = nY + nH;
            uvs.x3 = nX;
            uvs.y3 = nY + nH;
        }
    }
    /**
   * Destroys this texture
   * @param destroySource - Destroy the source when the texture is destroyed.
   */ destroy(destroySource = false) {
        if (this._source) {
            if (destroySource) {
                this._source.destroy();
                this._source = null;
            }
        }
        this._textureMatrix = null;
        this.destroyed = true;
        this.emit("destroy", this);
        this.removeAllListeners();
    }
    /** call this if you have modified the `texture outside` of the constructor */ update() {
        if (this.noFrame) {
            this.frame.width = this._source.width;
            this.frame.height = this._source.height;
        }
        this.updateUvs();
        this.emit("update", this);
    }
    /** @deprecated since 8.0.0 */ get baseTexture() {
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "Texture.baseTexture is now Texture.source");
        return this._source;
    }
}
$3206fee81954f0b6$export$5431306cf43de24a.EMPTY = new $3206fee81954f0b6$export$5431306cf43de24a({
    label: "EMPTY",
    source: new (0, $eIuJW.TextureSource)({
        label: "EMPTY"
    })
});
$3206fee81954f0b6$export$5431306cf43de24a.EMPTY.destroy = (0, $cP4xy.NOOP);
$3206fee81954f0b6$export$5431306cf43de24a.WHITE = new $3206fee81954f0b6$export$5431306cf43de24a({
    source: new (0, $2R8JI.BufferImageSource)({
        resource: new Uint8Array([
            255,
            255,
            255,
            255
        ]),
        width: 1,
        height: 1,
        alphaMode: "premultiply-alpha-on-upload",
        label: "WHITE"
    }),
    label: "WHITE"
});
$3206fee81954f0b6$export$5431306cf43de24a.WHITE.destroy = (0, $cP4xy.NOOP);

});
parcelRegister("gpXaq", function(module, exports) {
"use strict";
var $bf3ce0801cd2364b$var$has = Object.prototype.hasOwnProperty, $bf3ce0801cd2364b$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $bf3ce0801cd2364b$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $bf3ce0801cd2364b$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $bf3ce0801cd2364b$var$Events().__proto__) $bf3ce0801cd2364b$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $bf3ce0801cd2364b$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $bf3ce0801cd2364b$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $bf3ce0801cd2364b$var$EE(fn, context || emitter, once), evt = $bf3ce0801cd2364b$var$prefix ? $bf3ce0801cd2364b$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $bf3ce0801cd2364b$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $bf3ce0801cd2364b$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $bf3ce0801cd2364b$var$EventEmitter() {
    this._events = new $bf3ce0801cd2364b$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $bf3ce0801cd2364b$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($bf3ce0801cd2364b$var$has.call(events, name)) names.push($bf3ce0801cd2364b$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $bf3ce0801cd2364b$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $bf3ce0801cd2364b$var$prefix ? $bf3ce0801cd2364b$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $bf3ce0801cd2364b$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $bf3ce0801cd2364b$var$prefix ? $bf3ce0801cd2364b$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $bf3ce0801cd2364b$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $bf3ce0801cd2364b$var$prefix ? $bf3ce0801cd2364b$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $bf3ce0801cd2364b$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $bf3ce0801cd2364b$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $bf3ce0801cd2364b$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $bf3ce0801cd2364b$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $bf3ce0801cd2364b$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $bf3ce0801cd2364b$var$prefix ? $bf3ce0801cd2364b$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $bf3ce0801cd2364b$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $bf3ce0801cd2364b$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $bf3ce0801cd2364b$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $bf3ce0801cd2364b$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $bf3ce0801cd2364b$var$prefix ? $bf3ce0801cd2364b$var$prefix + event : event;
        if (this._events[evt]) $bf3ce0801cd2364b$var$clearEvent(this, evt);
    } else {
        this._events = new $bf3ce0801cd2364b$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$bf3ce0801cd2364b$var$EventEmitter.prototype.off = $bf3ce0801cd2364b$var$EventEmitter.prototype.removeListener;
$bf3ce0801cd2364b$var$EventEmitter.prototype.addListener = $bf3ce0801cd2364b$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$bf3ce0801cd2364b$var$EventEmitter.prefixed = $bf3ce0801cd2364b$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$bf3ce0801cd2364b$var$EventEmitter.EventEmitter = $bf3ce0801cd2364b$var$EventEmitter;
module.exports = $bf3ce0801cd2364b$var$EventEmitter;

});

parcelRegister("2RpbF", function(module, exports) {

$parcel$export(module.exports, "groupD8", () => $387b4a5144b76bb4$export$b7bb6a2a8d203102);

var $3kR0G = parcelRequire("3kR0G");
"use strict";
const $387b4a5144b76bb4$var$ux = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1
];
const $387b4a5144b76bb4$var$uy = [
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $387b4a5144b76bb4$var$vx = [
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $387b4a5144b76bb4$var$vy = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1
];
const $387b4a5144b76bb4$var$rotationCayley = [];
const $387b4a5144b76bb4$var$rotationMatrices = [];
const $387b4a5144b76bb4$var$signum = Math.sign;
function $387b4a5144b76bb4$var$init() {
    for(let i = 0; i < 16; i++){
        const row = [];
        $387b4a5144b76bb4$var$rotationCayley.push(row);
        for(let j = 0; j < 16; j++){
            const _ux = $387b4a5144b76bb4$var$signum($387b4a5144b76bb4$var$ux[i] * $387b4a5144b76bb4$var$ux[j] + $387b4a5144b76bb4$var$vx[i] * $387b4a5144b76bb4$var$uy[j]);
            const _uy = $387b4a5144b76bb4$var$signum($387b4a5144b76bb4$var$uy[i] * $387b4a5144b76bb4$var$ux[j] + $387b4a5144b76bb4$var$vy[i] * $387b4a5144b76bb4$var$uy[j]);
            const _vx = $387b4a5144b76bb4$var$signum($387b4a5144b76bb4$var$ux[i] * $387b4a5144b76bb4$var$vx[j] + $387b4a5144b76bb4$var$vx[i] * $387b4a5144b76bb4$var$vy[j]);
            const _vy = $387b4a5144b76bb4$var$signum($387b4a5144b76bb4$var$uy[i] * $387b4a5144b76bb4$var$vx[j] + $387b4a5144b76bb4$var$vy[i] * $387b4a5144b76bb4$var$vy[j]);
            for(let k = 0; k < 16; k++)if ($387b4a5144b76bb4$var$ux[k] === _ux && $387b4a5144b76bb4$var$uy[k] === _uy && $387b4a5144b76bb4$var$vx[k] === _vx && $387b4a5144b76bb4$var$vy[k] === _vy) {
                row.push(k);
                break;
            }
        }
    }
    for(let i = 0; i < 16; i++){
        const mat = new (0, $3kR0G.Matrix)();
        mat.set($387b4a5144b76bb4$var$ux[i], $387b4a5144b76bb4$var$uy[i], $387b4a5144b76bb4$var$vx[i], $387b4a5144b76bb4$var$vy[i], 0, 0);
        $387b4a5144b76bb4$var$rotationMatrices.push(mat);
    }
}
$387b4a5144b76bb4$var$init();
const $387b4a5144b76bb4$export$b7bb6a2a8d203102 = {
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ E: 0,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ SE: 1,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ S: 2,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ SW: 3,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ W: 4,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ NW: 5,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ N: 6,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ NE: 7,
    /**
   * Reflection about Y-axis.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ MIRROR_VERTICAL: 8,
    /**
   * Reflection about the main diagonal.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ MAIN_DIAGONAL: 10,
    /**
   * Reflection about X-axis.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ MIRROR_HORIZONTAL: 12,
    /**
   * Reflection about reverse diagonal.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ REVERSE_DIAGONAL: 14,
    /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */ uX: (ind)=>$387b4a5144b76bb4$var$ux[ind],
    /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */ uY: (ind)=>$387b4a5144b76bb4$var$uy[ind],
    /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */ vX: (ind)=>$387b4a5144b76bb4$var$vx[ind],
    /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */ vY: (ind)=>$387b4a5144b76bb4$var$vy[ind],
    /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {GD8Symmetry} The opposite symmetry of `rotation`
   */ inv: (rotation)=>{
        if (rotation & 8) return rotation & 15;
        return -rotation & 7;
    },
    /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {GD8Symmetry} Composed operation
   */ add: (rotationSecond, rotationFirst)=>$387b4a5144b76bb4$var$rotationCayley[rotationSecond][rotationFirst],
    /**
   * Reverse of `add`.
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation
   * @param {GD8Symmetry} rotationFirst - First operation
   * @returns {GD8Symmetry} Result
   */ sub: (rotationSecond, rotationFirst)=>$387b4a5144b76bb4$var$rotationCayley[rotationSecond][$387b4a5144b76bb4$export$b7bb6a2a8d203102.inv(rotationFirst)],
    /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @memberof maths.groupD8
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */ rotate180: (rotation)=>rotation ^ 4,
    /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */ isVertical: (rotation)=>(rotation & 3) === 2,
    // rotation % 4 === 2
    /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @memberof maths.groupD8
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */ byDirection: (dx, dy)=>{
        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
            if (dy >= 0) return $387b4a5144b76bb4$export$b7bb6a2a8d203102.S;
            return $387b4a5144b76bb4$export$b7bb6a2a8d203102.N;
        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
            if (dx > 0) return $387b4a5144b76bb4$export$b7bb6a2a8d203102.E;
            return $387b4a5144b76bb4$export$b7bb6a2a8d203102.W;
        } else if (dy > 0) {
            if (dx > 0) return $387b4a5144b76bb4$export$b7bb6a2a8d203102.SE;
            return $387b4a5144b76bb4$export$b7bb6a2a8d203102.SW;
        } else if (dx > 0) return $387b4a5144b76bb4$export$b7bb6a2a8d203102.NE;
        return $387b4a5144b76bb4$export$b7bb6a2a8d203102.NW;
    },
    /**
   * Helps sprite to compensate texture packer rotation.
   * @memberof maths.groupD8
   * @param {Matrix} matrix - sprite world matrix
   * @param {GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   */ matrixAppendRotationInv: (matrix, rotation, tx = 0, ty = 0)=>{
        const mat = $387b4a5144b76bb4$var$rotationMatrices[$387b4a5144b76bb4$export$b7bb6a2a8d203102.inv(rotation)];
        mat.tx = tx;
        mat.ty = ty;
        matrix.append(mat);
    }
};

});
parcelRegister("3kR0G", function(module, exports) {

$parcel$export(module.exports, "Matrix", () => $710eea9fd231a218$export$5b12bf1653c0dd85);

var $l8FfC = parcelRequire("l8FfC");

var $bwMhC = parcelRequire("bwMhC");
"use strict";
class $710eea9fd231a218$export$5b12bf1653c0dd85 {
    /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */ constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0){
        /** An array of the current matrix. Only populated when `toArray` is called */ this.array = null;
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
    }
    /**
   * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
   *
   * a = array[0]
   * b = array[1]
   * c = array[3]
   * d = array[4]
   * tx = array[2]
   * ty = array[5]
   * @param array - The array that the matrix will be populated from.
   */ fromArray(array) {
        this.a = array[0];
        this.b = array[1];
        this.c = array[3];
        this.d = array[4];
        this.tx = array[2];
        this.ty = array[5];
    }
    /**
   * Sets the matrix properties.
   * @param a - Matrix component
   * @param b - Matrix component
   * @param c - Matrix component
   * @param d - Matrix component
   * @param tx - Matrix component
   * @param ty - Matrix component
   * @returns This matrix. Good for chaining method calls.
   */ set(a, b, c, d, tx, ty) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
        return this;
    }
    /**
   * Creates an array from the current Matrix object.
   * @param transpose - Whether we need to transpose the matrix or not
   * @param [out=new Float32Array(9)] - If provided the array will be assigned to out
   * @returns The newly created array which contains the matrix
   */ toArray(transpose, out) {
        if (!this.array) this.array = new Float32Array(9);
        const array = out || this.array;
        if (transpose) {
            array[0] = this.a;
            array[1] = this.b;
            array[2] = 0;
            array[3] = this.c;
            array[4] = this.d;
            array[5] = 0;
            array[6] = this.tx;
            array[7] = this.ty;
            array[8] = 1;
        } else {
            array[0] = this.a;
            array[1] = this.c;
            array[2] = this.tx;
            array[3] = this.b;
            array[4] = this.d;
            array[5] = this.ty;
            array[6] = 0;
            array[7] = 0;
            array[8] = 1;
        }
        return array;
    }
    /**
   * Get a new position with the current transformation applied.
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @param pos - The origin
   * @param {Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {Point} The new point, transformed through this matrix
   */ apply(pos, newPos) {
        newPos = newPos || new (0, $bwMhC.Point)();
        const x = pos.x;
        const y = pos.y;
        newPos.x = this.a * x + this.c * y + this.tx;
        newPos.y = this.b * x + this.d * y + this.ty;
        return newPos;
    }
    /**
   * Get a new position with the inverse of the current transformation applied.
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @param pos - The origin
   * @param {Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {Point} The new point, inverse-transformed through this matrix
   */ applyInverse(pos, newPos) {
        newPos = newPos || new (0, $bwMhC.Point)();
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const tx = this.tx;
        const ty = this.ty;
        const id = 1 / (a * d + c * -b);
        const x = pos.x;
        const y = pos.y;
        newPos.x = d * id * x + -c * id * y + (ty * c - tx * d) * id;
        newPos.y = a * id * y + -b * id * x + (-ty * a + tx * b) * id;
        return newPos;
    }
    /**
   * Translates the matrix on the x and y.
   * @param x - How much to translate x by
   * @param y - How much to translate y by
   * @returns This matrix. Good for chaining method calls.
   */ translate(x, y) {
        this.tx += x;
        this.ty += y;
        return this;
    }
    /**
   * Applies a scale transformation to the matrix.
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   */ scale(x, y) {
        this.a *= x;
        this.d *= y;
        this.c *= x;
        this.b *= y;
        this.tx *= x;
        this.ty *= y;
        return this;
    }
    /**
   * Applies a rotation transformation to the matrix.
   * @param angle - The angle in radians.
   * @returns This matrix. Good for chaining method calls.
   */ rotate(angle) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const a1 = this.a;
        const c1 = this.c;
        const tx1 = this.tx;
        this.a = a1 * cos - this.b * sin;
        this.b = a1 * sin + this.b * cos;
        this.c = c1 * cos - this.d * sin;
        this.d = c1 * sin + this.d * cos;
        this.tx = tx1 * cos - this.ty * sin;
        this.ty = tx1 * sin + this.ty * cos;
        return this;
    }
    /**
   * Appends the given Matrix to this Matrix.
   * @param matrix - The matrix to append.
   * @returns This matrix. Good for chaining method calls.
   */ append(matrix) {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        this.a = matrix.a * a1 + matrix.b * c1;
        this.b = matrix.a * b1 + matrix.b * d1;
        this.c = matrix.c * a1 + matrix.d * c1;
        this.d = matrix.c * b1 + matrix.d * d1;
        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
        return this;
    }
    /**
   * Appends two matrix's and sets the result to this matrix. AB = A * B
   * @param a - The matrix to append.
   * @param b - The matrix to append.
   * @returns This matrix. Good for chaining method calls.
   */ appendFrom(a, b) {
        const a1 = a.a;
        const b1 = a.b;
        const c1 = a.c;
        const d1 = a.d;
        const tx = a.tx;
        const ty = a.ty;
        const a2 = b.a;
        const b2 = b.b;
        const c2 = b.c;
        const d2 = b.d;
        this.a = a1 * a2 + b1 * c2;
        this.b = a1 * b2 + b1 * d2;
        this.c = c1 * a2 + d1 * c2;
        this.d = c1 * b2 + d1 * d2;
        this.tx = tx * a2 + ty * c2 + b.tx;
        this.ty = tx * b2 + ty * d2 + b.ty;
        return this;
    }
    /**
   * Sets the matrix based on all the available properties
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   */ setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
        this.a = Math.cos(rotation + skewY) * scaleX;
        this.b = Math.sin(rotation + skewY) * scaleX;
        this.c = -Math.sin(rotation - skewX) * scaleY;
        this.d = Math.cos(rotation - skewX) * scaleY;
        this.tx = x - (pivotX * this.a + pivotY * this.c);
        this.ty = y - (pivotX * this.b + pivotY * this.d);
        return this;
    }
    /**
   * Prepends the given Matrix to this Matrix.
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   */ prepend(matrix) {
        const tx1 = this.tx;
        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            const a1 = this.a;
            const c1 = this.c;
            this.a = a1 * matrix.a + this.b * matrix.c;
            this.b = a1 * matrix.b + this.b * matrix.d;
            this.c = c1 * matrix.a + this.d * matrix.c;
            this.d = c1 * matrix.b + this.d * matrix.d;
        }
        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
        return this;
    }
    /**
   * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
   * @param transform - The transform to apply the properties to.
   * @returns The transform with the newly applied properties
   */ decompose(transform) {
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const pivot = transform.pivot;
        const skewX = -Math.atan2(-c, d);
        const skewY = Math.atan2(b, a);
        const delta = Math.abs(skewX + skewY);
        if (delta < 1e-5 || Math.abs((0, $l8FfC.PI_2) - delta) < 1e-5) {
            transform.rotation = skewY;
            transform.skew.x = transform.skew.y = 0;
        } else {
            transform.rotation = 0;
            transform.skew.x = skewX;
            transform.skew.y = skewY;
        }
        transform.scale.x = Math.sqrt(a * a + b * b);
        transform.scale.y = Math.sqrt(c * c + d * d);
        transform.position.x = this.tx + (pivot.x * a + pivot.y * c);
        transform.position.y = this.ty + (pivot.x * b + pivot.y * d);
        return transform;
    }
    /**
   * Inverts this matrix
   * @returns This matrix. Good for chaining method calls.
   */ invert() {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        const tx1 = this.tx;
        const n = a1 * d1 - b1 * c1;
        this.a = d1 / n;
        this.b = -b1 / n;
        this.c = -c1 / n;
        this.d = a1 / n;
        this.tx = (c1 * this.ty - d1 * tx1) / n;
        this.ty = -(a1 * this.ty - b1 * tx1) / n;
        return this;
    }
    /** Checks if this matrix is an identity matrix */ isIdentity() {
        return this.a === 1 && this.b === 0 && this.c === 0 && this.d === 1 && this.tx === 0 && this.ty === 0;
    }
    /**
   * Resets this Matrix to an identity (default) matrix.
   * @returns This matrix. Good for chaining method calls.
   */ identity() {
        this.a = 1;
        this.b = 0;
        this.c = 0;
        this.d = 1;
        this.tx = 0;
        this.ty = 0;
        return this;
    }
    /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */ clone() {
        const matrix = new $710eea9fd231a218$export$5b12bf1653c0dd85();
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    /**
   * Changes the values of the given matrix to be the same as the ones in this matrix
   * @param matrix - The matrix to copy to.
   * @returns The matrix given in parameter with its values updated.
   */ copyTo(matrix) {
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    /**
   * Changes the values of the matrix to be the same as the ones in given matrix
   * @param matrix - The matrix to copy from.
   * @returns this
   */ copyFrom(matrix) {
        this.a = matrix.a;
        this.b = matrix.b;
        this.c = matrix.c;
        this.d = matrix.d;
        this.tx = matrix.tx;
        this.ty = matrix.ty;
        return this;
    }
    /**
   * check to see if two matrices are the same
   * @param matrix - The matrix to compare to.
   */ equals(matrix) {
        return matrix.a === this.a && matrix.b === this.b && matrix.c === this.c && matrix.d === this.d && matrix.tx === this.tx && matrix.ty === this.ty;
    }
    toString() {
        return `[pixi.js:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
    }
    /**
   * A default (identity) matrix.
   *
   * This is a shared object, if you want to modify it consider creating a new `Matrix`
   * @readonly
   */ static get IDENTITY() {
        return $710eea9fd231a218$var$identityMatrix.identity();
    }
    /**
   * A static Matrix that can be used to avoid creating new objects.
   * Will always ensure the matrix is reset to identity when requested.
   * Use this object for fast but temporary calculations, as it may be mutated later on.
   * This is a different object to the `IDENTITY` object and so can be modified without changing `IDENTITY`.
   * @readonly
   */ static get shared() {
        return $710eea9fd231a218$var$tempMatrix.identity();
    }
}
const $710eea9fd231a218$var$tempMatrix = new $710eea9fd231a218$export$5b12bf1653c0dd85();
const $710eea9fd231a218$var$identityMatrix = new $710eea9fd231a218$export$5b12bf1653c0dd85();

});
parcelRegister("l8FfC", function(module, exports) {

$parcel$export(module.exports, "PI_2", () => $6a01042cd92c97e2$export$59ed0a0a5de1084b);
$parcel$export(module.exports, "RAD_TO_DEG", () => $6a01042cd92c97e2$export$3f91627dc85c5d57);
$parcel$export(module.exports, "DEG_TO_RAD", () => $6a01042cd92c97e2$export$870617f62e3187f1);
"use strict";
const $6a01042cd92c97e2$export$59ed0a0a5de1084b = Math.PI * 2;
const $6a01042cd92c97e2$export$3f91627dc85c5d57 = 180 / Math.PI;
const $6a01042cd92c97e2$export$870617f62e3187f1 = Math.PI / 180;

});

parcelRegister("bwMhC", function(module, exports) {

$parcel$export(module.exports, "Point", () => $8184e431f9da2d78$export$baf26146a414f24a);
"use strict";
class $8184e431f9da2d78$export$baf26146a414f24a {
    /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(x = 0, y = 0){
        /** Position of the point on the x axis */ this.x = 0;
        /** Position of the point on the y axis */ this.y = 0;
        this.x = x;
        this.y = y;
    }
    /**
   * Creates a clone of this point
   * @returns A clone of this point
   */ clone() {
        return new $8184e431f9da2d78$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * Copies `x` and `y` from the given point into this point
   * @param p - The point to copy from
   * @returns The point instance itself
   */ copyFrom(p) {
        this.set(p.x, p.y);
        return this;
    }
    /**
   * Copies this point's x and y into the given point (`p`).
   * @param p - The point to copy to. Can be any of type that is or extends `PointData`
   * @returns The point (`p`) with values updated
   */ copyTo(p) {
        p.set(this.x, this.y);
        return p;
    }
    /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */ equals(p) {
        return p.x === this.x && p.y === this.y;
    }
    /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the `x` axis
   * @param {number} [y=x] - position of the point on the `y` axis
   * @returns The point instance itself
   */ set(x = 0, y = x) {
        this.x = x;
        this.y = y;
        return this;
    }
    toString() {
        return `[pixi.js/math:Point x=${this.x} y=${this.y}]`;
    }
    /**
   * A static Point object with `x` and `y` values of `0`. Can be used to avoid creating new objects multiple times.
   * @readonly
   */ static get shared() {
        $8184e431f9da2d78$var$tempPoint.x = 0;
        $8184e431f9da2d78$var$tempPoint.y = 0;
        return $8184e431f9da2d78$var$tempPoint;
    }
}
const $8184e431f9da2d78$var$tempPoint = new $8184e431f9da2d78$export$baf26146a414f24a();

});



parcelRegister("hFBUu", function(module, exports) {

$parcel$export(module.exports, "Rectangle", () => $0c25f8d05b74c796$export$4617fb02663045ef);

var $bwMhC = parcelRequire("bwMhC");
"use strict";
const $0c25f8d05b74c796$var$tempPoints = [
    new (0, $bwMhC.Point)(),
    new (0, $bwMhC.Point)(),
    new (0, $bwMhC.Point)(),
    new (0, $bwMhC.Point)()
];
class $0c25f8d05b74c796$export$4617fb02663045ef {
    /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */ constructor(x = 0, y = 0, width = 0, height = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @default 'rectangle'
     */ this.type = "rectangle";
        this.x = Number(x);
        this.y = Number(y);
        this.width = Number(width);
        this.height = Number(height);
    }
    /** Returns the left edge of the rectangle. */ get left() {
        return this.x;
    }
    /** Returns the right edge of the rectangle. */ get right() {
        return this.x + this.width;
    }
    /** Returns the top edge of the rectangle. */ get top() {
        return this.y;
    }
    /** Returns the bottom edge of the rectangle. */ get bottom() {
        return this.y + this.height;
    }
    /** Determines whether the Rectangle is empty. */ isEmpty() {
        return this.left === this.right || this.top === this.bottom;
    }
    /** A constant empty rectangle. This is a new object every time the property is accessed */ static get EMPTY() {
        return new $0c25f8d05b74c796$export$4617fb02663045ef(0, 0, 0, 0);
    }
    /**
   * Creates a clone of this Rectangle
   * @returns a copy of the rectangle
   */ clone() {
        return new $0c25f8d05b74c796$export$4617fb02663045ef(this.x, this.y, this.width, this.height);
    }
    /**
   * Converts a Bounds object to a Rectangle object.
   * @param bounds - The bounds to copy and convert to a rectangle.
   * @returns Returns itself.
   */ copyFromBounds(bounds) {
        this.x = bounds.minX;
        this.y = bounds.minY;
        this.width = bounds.maxX - bounds.minX;
        this.height = bounds.maxY - bounds.minY;
        return this;
    }
    /**
   * Copies another rectangle to this one.
   * @param rectangle - The rectangle to copy from.
   * @returns Returns itself.
   */ copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    /**
   * Copies this rectangle to another one.
   * @param rectangle - The rectangle to copy to.
   * @returns Returns given parameter.
   */ copyTo(rectangle) {
        rectangle.copyFrom(this);
        return rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x < this.x + this.width) {
            if (y >= this.y && y < this.y + this.height) return true;
        }
        return false;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @returns Whether the x/y coordinates are within this rectangle
   */ strokeContains(x, y, strokeWidth) {
        const { width: width, height: height } = this;
        if (width <= 0 || height <= 0) return false;
        const _x = this.x;
        const _y = this.y;
        const outerLeft = _x - strokeWidth / 2;
        const outerRight = _x + width + strokeWidth / 2;
        const outerTop = _y - strokeWidth / 2;
        const outerBottom = _y + height + strokeWidth / 2;
        const innerLeft = _x + strokeWidth / 2;
        const innerRight = _x + width - strokeWidth / 2;
        const innerTop = _y + strokeWidth / 2;
        const innerBottom = _y + height - strokeWidth / 2;
        return x >= outerLeft && x <= outerRight && y >= outerTop && y <= outerBottom && !(x > innerLeft && x < innerRight && y > innerTop && y < innerBottom);
    }
    /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */ intersects(other, transform) {
        if (!transform) {
            const x02 = this.x < other.x ? other.x : this.x;
            const x12 = this.right > other.right ? other.right : this.right;
            if (x12 <= x02) return false;
            const y02 = this.y < other.y ? other.y : this.y;
            const y12 = this.bottom > other.bottom ? other.bottom : this.bottom;
            return y12 > y02;
        }
        const x0 = this.left;
        const x1 = this.right;
        const y0 = this.top;
        const y1 = this.bottom;
        if (x1 <= x0 || y1 <= y0) return false;
        const lt = $0c25f8d05b74c796$var$tempPoints[0].set(other.left, other.top);
        const lb = $0c25f8d05b74c796$var$tempPoints[1].set(other.left, other.bottom);
        const rt = $0c25f8d05b74c796$var$tempPoints[2].set(other.right, other.top);
        const rb = $0c25f8d05b74c796$var$tempPoints[3].set(other.right, other.bottom);
        if (rt.x <= lt.x || lb.y <= lt.y) return false;
        const s = Math.sign(transform.a * transform.d - transform.b * transform.c);
        if (s === 0) return false;
        transform.apply(lt, lt);
        transform.apply(lb, lb);
        transform.apply(rt, rt);
        transform.apply(rb, rb);
        if (Math.max(lt.x, lb.x, rt.x, rb.x) <= x0 || Math.min(lt.x, lb.x, rt.x, rb.x) >= x1 || Math.max(lt.y, lb.y, rt.y, rb.y) <= y0 || Math.min(lt.y, lb.y, rt.y, rb.y) >= y1) return false;
        const nx = s * (lb.y - lt.y);
        const ny = s * (lt.x - lb.x);
        const n00 = nx * x0 + ny * y0;
        const n10 = nx * x1 + ny * y0;
        const n01 = nx * x0 + ny * y1;
        const n11 = nx * x1 + ny * y1;
        if (Math.max(n00, n10, n01, n11) <= nx * lt.x + ny * lt.y || Math.min(n00, n10, n01, n11) >= nx * rb.x + ny * rb.y) return false;
        const mx = s * (lt.y - rt.y);
        const my = s * (rt.x - lt.x);
        const m00 = mx * x0 + my * y0;
        const m10 = mx * x1 + my * y0;
        const m01 = mx * x0 + my * y1;
        const m11 = mx * x1 + my * y1;
        if (Math.max(m00, m10, m01, m11) <= mx * lt.x + my * lt.y || Math.min(m00, m10, m01, m11) >= mx * rb.x + my * rb.y) return false;
        return true;
    }
    /**
   * Pads the rectangle making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   * @returns Returns itself.
   */ pad(paddingX = 0, paddingY = paddingX) {
        this.x -= paddingX;
        this.y -= paddingY;
        this.width += paddingX * 2;
        this.height += paddingY * 2;
        return this;
    }
    /**
   * Fits this rectangle around the passed one.
   * @param rectangle - The rectangle to fit.
   * @returns Returns itself.
   */ fit(rectangle) {
        const x1 = Math.max(this.x, rectangle.x);
        const x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.max(this.y, rectangle.y);
        const y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = Math.max(x2 - x1, 0);
        this.y = y1;
        this.height = Math.max(y2 - y1, 0);
        return this;
    }
    /**
   * Enlarges rectangle that way its corners lie on grid
   * @param resolution - resolution
   * @param eps - precision
   * @returns Returns itself.
   */ ceil(resolution = 1, eps = 1e-3) {
        const x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution;
        const y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;
        this.x = Math.floor((this.x + eps) * resolution) / resolution;
        this.y = Math.floor((this.y + eps) * resolution) / resolution;
        this.width = x2 - this.x;
        this.height = y2 - this.y;
        return this;
    }
    /**
   * Enlarges this rectangle to include the passed rectangle.
   * @param rectangle - The rectangle to include.
   * @returns Returns itself.
   */ enlarge(rectangle) {
        const x1 = Math.min(this.x, rectangle.x);
        const x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.min(this.y, rectangle.y);
        const y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = x2 - x1;
        this.y = y1;
        this.height = y2 - y1;
        return this;
    }
    /**
   * Returns the framing rectangle of the rectangle as a Rectangle object
   * @param out - optional rectangle to store the result
   * @returns The framing rectangle
   */ getBounds(out) {
        out = out || new $0c25f8d05b74c796$export$4617fb02663045ef();
        out.copyFrom(this);
        return out;
    }
    toString() {
        return `[pixi.js/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
    }
}

});

parcelRegister("by5BM", function(module, exports) {

$parcel$export(module.exports, "uid", () => $19e2775b62233a1b$export$e2a22331486dcca0);
"use strict";
const $19e2775b62233a1b$var$uidCache = {
    default: -1
};
function $19e2775b62233a1b$export$e2a22331486dcca0(name = "default") {
    if ($19e2775b62233a1b$var$uidCache[name] === void 0) $19e2775b62233a1b$var$uidCache[name] = -1;
    return ++$19e2775b62233a1b$var$uidCache[name];
}
function $19e2775b62233a1b$export$220409b686c277d0() {
    for(const key in $19e2775b62233a1b$var$uidCache)delete $19e2775b62233a1b$var$uidCache[key];
}

});

parcelRegister("j0fPb", function(module, exports) {

$parcel$export(module.exports, "v8_0_0", () => $df558718b9c4f5e7$export$dc79da96439604f0);
$parcel$export(module.exports, "deprecation", () => $df558718b9c4f5e7$export$afd31d834b512e89);
"use strict";
const $df558718b9c4f5e7$var$warnings = {};
const $df558718b9c4f5e7$export$dc79da96439604f0 = "8.0.0";
function $df558718b9c4f5e7$export$afd31d834b512e89(version, message, ignoreDepth = 3) {
    if ($df558718b9c4f5e7$var$warnings[message]) return;
    let stack = new Error().stack;
    if (typeof stack === "undefined") console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`);
    else {
        stack = stack.split("\n").splice(ignoreDepth).join("\n");
        if (console.groupCollapsed) {
            console.groupCollapsed("%cPixiJS Deprecation Warning: %c%s", "color:#614108;background:#fffbe6", "font-weight:normal;color:#614108;background:#fffbe6", `${message}
Deprecated since v${version}`);
            console.warn(stack);
            console.groupEnd();
        } else {
            console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`);
            console.warn(stack);
        }
    }
    $df558718b9c4f5e7$var$warnings[message] = true;
}

});

parcelRegister("cP4xy", function(module, exports) {

$parcel$export(module.exports, "NOOP", () => $502a5736953c32b5$export$5702a91a6f42969f);
"use strict";
const $502a5736953c32b5$export$5702a91a6f42969f = ()=>{};

});

parcelRegister("2R8JI", function(module, exports) {

$parcel$export(module.exports, "BufferImageSource", () => $6666f63f01638cbf$export$1872462350fcb7cd);

var $aqljF = parcelRequire("aqljF");

var $eIuJW = parcelRequire("eIuJW");
"use strict";
class $6666f63f01638cbf$export$1872462350fcb7cd extends (0, $eIuJW.TextureSource) {
    constructor(options){
        const buffer = options.resource || new Float32Array(options.width * options.height * 4);
        let format = options.format;
        if (!format) {
            if (buffer instanceof Float32Array) format = "rgba32float";
            else if (buffer instanceof Int32Array) format = "rgba32uint";
            else if (buffer instanceof Uint32Array) format = "rgba32uint";
            else if (buffer instanceof Int16Array) format = "rgba16uint";
            else if (buffer instanceof Uint16Array) format = "rgba16uint";
            else if (buffer instanceof Int8Array) format = "bgra8unorm";
            else format = "bgra8unorm";
        }
        super({
            ...options,
            resource: buffer,
            format: format
        });
        this.uploadMethodId = "buffer";
    }
    static test(resource) {
        return resource instanceof Int8Array || resource instanceof Uint8Array || resource instanceof Uint8ClampedArray || resource instanceof Int16Array || resource instanceof Uint16Array || resource instanceof Int32Array || resource instanceof Uint32Array || resource instanceof Float32Array;
    }
}
$6666f63f01638cbf$export$1872462350fcb7cd.extension = (0, $aqljF.ExtensionType).TextureSource;

});
parcelRegister("eIuJW", function(module, exports) {

$parcel$export(module.exports, "TextureSource", () => $af5b35fcfdc794cd$export$8498e6a2e655d3d8);

var $gpXaq = parcelRequire("gpXaq");

var $b2FIe = parcelRequire("b2FIe");

var $8Smpw = parcelRequire("8Smpw");

var $by5BM = parcelRequire("by5BM");

var $6hTB1 = parcelRequire("6hTB1");
"use strict";
const $af5b35fcfdc794cd$var$_TextureSource = class _TextureSource extends (0, (/*@__PURE__*/$parcel$interopDefault($gpXaq))) {
    /**
   * @param options - options for creating a new TextureSource
   */ constructor(options = {}){
        super();
        this.options = options;
        /** unique id for this Texture source */ this.uid = (0, $by5BM.uid)("textureSource");
        /**
     * The resource type used by this TextureSource. This is used by the bind groups to determine
     * how to handle this resource.
     * @ignore
     * @internal
     */ this._resourceType = "textureSource";
        /**
     * i unique resource id, used by the bind group systems.
     * This can change if the texture is resized or its resource changes
     */ this._resourceId = (0, $by5BM.uid)("resource");
        /**
     * this is how the backends know how to upload this texture to the GPU
     * It changes depending on the resource type. Classes that extend TextureSource
     * should override this property.
     * @ignore
     * @internal
     */ this.uploadMethodId = "unknown";
        // dimensions
        this._resolution = 1;
        /** the pixel width of this texture source. This is the REAL pure number, not accounting resolution */ this.pixelWidth = 1;
        /** the pixel height of this texture source. This is the REAL pure number, not accounting resolution */ this.pixelHeight = 1;
        /**
     * the width of this texture source, accounting for resolution
     * eg pixelWidth 200, resolution 2, then width will be 100
     */ this.width = 1;
        /**
     * the height of this texture source, accounting for resolution
     * eg pixelHeight 200, resolution 2, then height will be 100
     */ this.height = 1;
        /**
     * The number of samples of a multisample texture. This is always 1 for non-multisample textures.
     * To enable multisample for a texture, set antialias to true
     * @internal
     * @ignore
     */ this.sampleCount = 1;
        /** The number of mip levels to generate for this texture. this is  overridden if autoGenerateMipmaps is true */ this.mipLevelCount = 1;
        /**
     * Should we auto generate mipmaps for this texture? This will automatically generate mipmaps
     * for this texture when uploading to the GPU. Mipmapped textures take up more memory, but
     * can look better when scaled down.
     *
     * For performance reasons, it is recommended to NOT use this with RenderTextures, as they are often updated every frame.
     * If you do, make sure to call `updateMipmaps` after you update the texture.
     */ this.autoGenerateMipmaps = false;
        /** the format that the texture data has */ this.format = "rgba8unorm";
        /** how many dimensions does this texture have? currently v8 only supports 2d */ this.dimension = "2d";
        /**
     * Only really affects RenderTextures.
     * Should we use antialiasing for this texture. It will look better, but may impact performance as a
     * Blit operation will be required to resolve the texture.
     */ this.antialias = false;
        /**
     * Used by automatic texture Garbage Collection, stores last GC tick when it was bound
     * @protected
     */ this._touched = 0;
        /**
     * Used by the batcher to build texture batches. faster to have the variable here!
     * @protected
     */ this._batchTick = -1;
        /**
     * A temporary batch location for the texture batching. Here for performance reasons only!
     * @protected
     */ this._textureBindLocation = -1;
        options = {
            ..._TextureSource.defaultOptions,
            ...options
        };
        this.label = options.label ?? "";
        this.resource = options.resource;
        this.autoGarbageCollect = options.autoGarbageCollect;
        this._resolution = options.resolution;
        if (options.width) this.pixelWidth = options.width * this._resolution;
        else this.pixelWidth = this.resource ? this.resourceWidth ?? 1 : 1;
        if (options.height) this.pixelHeight = options.height * this._resolution;
        else this.pixelHeight = this.resource ? this.resourceHeight ?? 1 : 1;
        this.width = this.pixelWidth / this._resolution;
        this.height = this.pixelHeight / this._resolution;
        this.format = options.format;
        this.dimension = options.dimensions;
        this.mipLevelCount = options.mipLevelCount;
        this.autoGenerateMipmaps = options.autoGenerateMipmaps;
        this.sampleCount = options.sampleCount;
        this.antialias = options.antialias;
        this.alphaMode = options.alphaMode;
        this.style = new (0, $6hTB1.TextureStyle)((0, $8Smpw.definedProps)(options));
        this.destroyed = false;
        this._refreshPOT();
    }
    /** returns itself */ get source() {
        return this;
    }
    /** the style of the texture */ get style() {
        return this._style;
    }
    set style(value) {
        if (this.style === value) return;
        this._style?.off("change", this._onStyleChange, this);
        this._style = value;
        this._style?.on("change", this._onStyleChange, this);
        this._onStyleChange();
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get addressMode() {
        return this._style.addressMode;
    }
    set addressMode(value) {
        this._style.addressMode = value;
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get repeatMode() {
        return this._style.addressMode;
    }
    set repeatMode(value) {
        this._style.addressMode = value;
    }
    /** Specifies the sampling behavior when the sample footprint is smaller than or equal to one texel. */ get magFilter() {
        return this._style.magFilter;
    }
    set magFilter(value) {
        this._style.magFilter = value;
    }
    /** Specifies the sampling behavior when the sample footprint is larger than one texel. */ get minFilter() {
        return this._style.minFilter;
    }
    set minFilter(value) {
        this._style.minFilter = value;
    }
    /** Specifies behavior for sampling between mipmap levels. */ get mipmapFilter() {
        return this._style.mipmapFilter;
    }
    set mipmapFilter(value) {
        this._style.mipmapFilter = value;
    }
    /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */ get lodMinClamp() {
        return this._style.lodMinClamp;
    }
    set lodMinClamp(value) {
        this._style.lodMinClamp = value;
    }
    /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */ get lodMaxClamp() {
        return this._style.lodMaxClamp;
    }
    set lodMaxClamp(value) {
        this._style.lodMaxClamp = value;
    }
    _onStyleChange() {
        this.emit("styleChange", this);
    }
    /** call this if you have modified the texture outside of the constructor */ update() {
        if (this.resource) {
            const resolution = this._resolution;
            const didResize = this.resize(this.resourceWidth / resolution, this.resourceHeight / resolution);
            if (didResize) return;
        }
        this.emit("update", this);
    }
    /** Destroys this texture source */ destroy() {
        this.destroyed = true;
        this.emit("destroy", this);
        this.emit("change", this);
        if (this._style) {
            this._style.destroy();
            this._style = null;
        }
        this.uploadMethodId = null;
        this.resource = null;
        this.removeAllListeners();
    }
    /**
   * This will unload the Texture source from the GPU. This will free up the GPU memory
   * As soon as it is required fore rendering, it will be re-uploaded.
   */ unload() {
        this._resourceId = (0, $by5BM.uid)("resource");
        this.emit("change", this);
        this.emit("unload", this);
    }
    /** the width of the resource. This is the REAL pure number, not accounting resolution   */ get resourceWidth() {
        const { resource: resource } = this;
        return resource.naturalWidth || resource.videoWidth || resource.displayWidth || resource.width;
    }
    /** the height of the resource. This is the REAL pure number, not accounting resolution */ get resourceHeight() {
        const { resource: resource } = this;
        return resource.naturalHeight || resource.videoHeight || resource.displayHeight || resource.height;
    }
    /**
   * the resolution of the texture. Changing this number, will not change the number of pixels in the actual texture
   * but will the size of the texture when rendered.
   *
   * changing the resolution of this texture to 2 for example will make it appear twice as small when rendered (as pixel
   * density will have increased)
   */ get resolution() {
        return this._resolution;
    }
    set resolution(resolution) {
        if (this._resolution === resolution) return;
        this._resolution = resolution;
        this.width = this.pixelWidth / resolution;
        this.height = this.pixelHeight / resolution;
    }
    /**
   * Resize the texture, this is handy if you want to use the texture as a render texture
   * @param width - the new width of the texture
   * @param height - the new height of the texture
   * @param resolution - the new resolution of the texture
   * @returns - if the texture was resized
   */ resize(width, height, resolution) {
        resolution = resolution || this._resolution;
        width = width || this.width;
        height = height || this.height;
        const newPixelWidth = Math.round(width * resolution);
        const newPixelHeight = Math.round(height * resolution);
        this.width = newPixelWidth / resolution;
        this.height = newPixelHeight / resolution;
        this._resolution = resolution;
        if (this.pixelWidth === newPixelWidth && this.pixelHeight === newPixelHeight) return false;
        this._refreshPOT();
        this.pixelWidth = newPixelWidth;
        this.pixelHeight = newPixelHeight;
        this.emit("resize", this);
        this._resourceId = (0, $by5BM.uid)("resource");
        this.emit("change", this);
        return true;
    }
    /**
   * Lets the renderer know that this texture has been updated and its mipmaps should be re-generated.
   * This is only important for RenderTexture instances, as standard Texture instances will have their
   * mipmaps generated on upload. You should call this method after you make any change to the texture
   *
   * The reason for this is is can be quite expensive to update mipmaps for a texture. So by default,
   * We want you, the developer to specify when this action should happen.
   *
   * Generally you don't want to have mipmaps generated on Render targets that are changed every frame,
   */ updateMipmaps() {
        if (this.autoGenerateMipmaps && this.mipLevelCount > 1) this.emit("updateMipmaps", this);
    }
    set wrapMode(value) {
        this._style.wrapMode = value;
    }
    get wrapMode() {
        return this._style.wrapMode;
    }
    set scaleMode(value) {
        this._style.scaleMode = value;
    }
    /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */ get scaleMode() {
        return this._style.scaleMode;
    }
    /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */ _refreshPOT() {
        this.isPowerOfTwo = (0, $b2FIe.isPow2)(this.pixelWidth) && (0, $b2FIe.isPow2)(this.pixelHeight);
    }
    static test(_resource) {
        throw new Error("Unimplemented");
    }
};
/** The default options used when creating a new TextureSource. override these to add your own defaults */ $af5b35fcfdc794cd$var$_TextureSource.defaultOptions = {
    resolution: 1,
    format: "bgra8unorm",
    alphaMode: "premultiply-alpha-on-upload",
    dimensions: "2d",
    mipLevelCount: 1,
    autoGenerateMipmaps: false,
    sampleCount: 1,
    antialias: false,
    autoGarbageCollect: false
};
let $af5b35fcfdc794cd$export$8498e6a2e655d3d8 = $af5b35fcfdc794cd$var$_TextureSource;

});
parcelRegister("b2FIe", function(module, exports) {

$parcel$export(module.exports, "nextPow2", () => $64c3c5fdb85b4f43$export$f0d90cf68bd426eb);
$parcel$export(module.exports, "isPow2", () => $64c3c5fdb85b4f43$export$eb50b9c078eb6ae7);
"use strict";
function $64c3c5fdb85b4f43$export$f0d90cf68bd426eb(v) {
    v += v === 0 ? 1 : 0;
    --v;
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v + 1;
}
function $64c3c5fdb85b4f43$export$eb50b9c078eb6ae7(v) {
    return !(v & v - 1) && !!v;
}
function $64c3c5fdb85b4f43$export$b9fae0bba9d9094d(v) {
    let r = (v > 65535 ? 1 : 0) << 4;
    v >>>= r;
    let shift = (v > 255 ? 1 : 0) << 3;
    v >>>= shift;
    r |= shift;
    shift = (v > 15 ? 1 : 0) << 2;
    v >>>= shift;
    r |= shift;
    shift = (v > 3 ? 1 : 0) << 1;
    v >>>= shift;
    r |= shift;
    return r | v >> 1;
}

});

parcelRegister("8Smpw", function(module, exports) {

$parcel$export(module.exports, "definedProps", () => $8b7de420e206fea8$export$801feaffb936a09d);
"use strict";
function $8b7de420e206fea8$export$801feaffb936a09d(obj) {
    const result = {};
    for(const key in obj)if (obj[key] !== void 0) result[key] = obj[key];
    return result;
}

});

parcelRegister("6hTB1", function(module, exports) {

$parcel$export(module.exports, "TextureStyle", () => $e3027afd471d21bd$export$1ce1d0c10d3de5d5);

var $gpXaq = parcelRequire("gpXaq");

var $by5BM = parcelRequire("by5BM");

var $j0fPb = parcelRequire("j0fPb");
"use strict";
const $e3027afd471d21bd$var$idHash = /* @__PURE__ */ Object.create(null);
function $e3027afd471d21bd$var$createResourceIdFromString(value) {
    const id = $e3027afd471d21bd$var$idHash[value];
    if (id === void 0) $e3027afd471d21bd$var$idHash[value] = (0, $by5BM.uid)("resource");
    return id;
}
const $e3027afd471d21bd$var$_TextureStyle = class _TextureStyle extends (0, (/*@__PURE__*/$parcel$interopDefault($gpXaq))) {
    /**
   * @param options - options for the style
   */ constructor(options = {}){
        super();
        this._resourceType = "textureSampler";
        this._touched = 0;
        /**
     * Specifies the maximum anisotropy value clamp used by the sampler.
     * Note: Most implementations support {@link GPUSamplerDescriptor#maxAnisotropy} values in range
     * between 1 and 16, inclusive. The used value of {@link GPUSamplerDescriptor#maxAnisotropy} will
     * be clamped to the maximum value that the platform supports.
     * @internal
     * @ignore
     */ this._maxAnisotropy = 1;
        /**
     * Has the style been destroyed?
     * @readonly
     */ this.destroyed = false;
        options = {
            ..._TextureStyle.defaultOptions,
            ...options
        };
        this.addressMode = options.addressMode;
        this.addressModeU = options.addressModeU ?? this.addressModeU;
        this.addressModeV = options.addressModeV ?? this.addressModeV;
        this.addressModeW = options.addressModeW ?? this.addressModeW;
        this.scaleMode = options.scaleMode;
        this.magFilter = options.magFilter ?? this.magFilter;
        this.minFilter = options.minFilter ?? this.minFilter;
        this.mipmapFilter = options.mipmapFilter ?? this.mipmapFilter;
        this.lodMinClamp = options.lodMinClamp;
        this.lodMaxClamp = options.lodMaxClamp;
        this.compare = options.compare;
        this.maxAnisotropy = options.maxAnisotropy ?? 1;
    }
    set addressMode(value) {
        this.addressModeU = value;
        this.addressModeV = value;
        this.addressModeW = value;
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get addressMode() {
        return this.addressModeU;
    }
    set wrapMode(value) {
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "TextureStyle.wrapMode is now TextureStyle.addressMode");
        this.addressMode = value;
    }
    get wrapMode() {
        return this.addressMode;
    }
    set scaleMode(value) {
        this.magFilter = value;
        this.minFilter = value;
        this.mipmapFilter = value;
    }
    /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */ get scaleMode() {
        return this.magFilter;
    }
    /** Specifies the maximum anisotropy value clamp used by the sampler. */ set maxAnisotropy(value) {
        this._maxAnisotropy = Math.min(value, 16);
        if (this._maxAnisotropy > 1) this.scaleMode = "linear";
    }
    get maxAnisotropy() {
        return this._maxAnisotropy;
    }
    // TODO - move this to WebGL?
    get _resourceId() {
        return this._sharedResourceId || this._generateResourceId();
    }
    update() {
        this.emit("change", this);
        this._sharedResourceId = null;
    }
    _generateResourceId() {
        const bigKey = `${this.addressModeU}-${this.addressModeV}-${this.addressModeW}-${this.magFilter}-${this.minFilter}-${this.mipmapFilter}-${this.lodMinClamp}-${this.lodMaxClamp}-${this.compare}-${this._maxAnisotropy}`;
        this._sharedResourceId = $e3027afd471d21bd$var$createResourceIdFromString(bigKey);
        return this._resourceId;
    }
    /** Destroys the style */ destroy() {
        this.destroyed = true;
        this.emit("destroy", this);
        this.emit("change", this);
        this.removeAllListeners();
    }
};
/** default options for the style */ $e3027afd471d21bd$var$_TextureStyle.defaultOptions = {
    addressMode: "clamp-to-edge",
    scaleMode: "linear"
};
let $e3027afd471d21bd$export$1ce1d0c10d3de5d5 = $e3027afd471d21bd$var$_TextureStyle;

});



parcelRegister("jxdeQ", function(module, exports) {

$parcel$export(module.exports, "TextureMatrix", () => $753a15bf4415e3e6$export$dbea3135e9da48cb);

var $3kR0G = parcelRequire("3kR0G");
"use strict";
const $753a15bf4415e3e6$var$tempMat = new (0, $3kR0G.Matrix)();
class $753a15bf4415e3e6$export$dbea3135e9da48cb {
    /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */ constructor(texture, clampMargin){
        this.mapCoord = new (0, $3kR0G.Matrix)();
        this.uClampFrame = new Float32Array(4);
        this.uClampOffset = new Float32Array(2);
        this._textureID = -1;
        this._updateID = 0;
        this.clampOffset = 0;
        if (typeof clampMargin === "undefined") this.clampMargin = texture.width < 10 ? 0 : 0.5;
        else this.clampMargin = clampMargin;
        this.isSimple = false;
        this.texture = texture;
    }
    /** Texture property. */ get texture() {
        return this._texture;
    }
    set texture(value) {
        if (this.texture === value) return;
        this._texture?.removeListener("update", this.update, this);
        this._texture = value;
        this._texture.addListener("update", this.update, this);
        this.update();
    }
    /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */ multiplyUvs(uvs, out) {
        if (out === void 0) out = uvs;
        const mat = this.mapCoord;
        for(let i = 0; i < uvs.length; i += 2){
            const x = uvs[i];
            const y = uvs[i + 1];
            out[i] = x * mat.a + y * mat.c + mat.tx;
            out[i + 1] = x * mat.b + y * mat.d + mat.ty;
        }
        return out;
    }
    /**
   * Updates matrices if texture was changed
   * @returns - whether or not it was updated
   */ update() {
        const tex = this._texture;
        this._updateID++;
        const uvs = tex.uvs;
        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
        const orig = tex.orig;
        const trim = tex.trim;
        if (trim) {
            $753a15bf4415e3e6$var$tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
            this.mapCoord.append($753a15bf4415e3e6$var$tempMat);
        }
        const texBase = tex.source;
        const frame = this.uClampFrame;
        const margin = this.clampMargin / texBase._resolution;
        const offset = this.clampOffset;
        frame[0] = (tex.frame.x + margin + offset) / texBase.width;
        frame[1] = (tex.frame.y + margin + offset) / texBase.height;
        frame[2] = (tex.frame.x + tex.frame.width - margin + offset) / texBase.width;
        frame[3] = (tex.frame.y + tex.frame.height - margin + offset) / texBase.height;
        this.uClampOffset[0] = offset / texBase.pixelWidth;
        this.uClampOffset[1] = offset / texBase.pixelHeight;
        this.isSimple = tex.frame.width === texBase.width && tex.frame.height === texBase.height && tex.rotate === 0;
        return true;
    }
}

});


parcelRegister("c2qdP", function(module, exports) {

$parcel$export(module.exports, "updateQuadBounds", () => $85ebc1fa2da74cb8$export$558ce66aa5723f1d);
"use strict";
function $85ebc1fa2da74cb8$export$558ce66aa5723f1d(bounds, anchor, texture, padding) {
    const { width: width, height: height } = texture.orig;
    const trim = texture.trim;
    if (trim) {
        const sourceWidth = trim.width;
        const sourceHeight = trim.height;
        bounds.minX = trim.x - anchor._x * width - padding;
        bounds.maxX = bounds.minX + sourceWidth;
        bounds.minY = trim.y - anchor._y * height - padding;
        bounds.maxY = bounds.minY + sourceHeight;
    } else {
        bounds.minX = -anchor._x * width - padding;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height - padding;
        bounds.maxY = bounds.minY + height;
    }
    return;
}

});

parcelRegister("e0Ilp", function(module, exports) {

$parcel$export(module.exports, "UPDATE_COLOR", () => $bde11428fb3b9d0f$export$f8ede8d8bf091ab5);
$parcel$export(module.exports, "UPDATE_BLEND", () => $bde11428fb3b9d0f$export$e4801e7edc7582f);
$parcel$export(module.exports, "UPDATE_VISIBLE", () => $bde11428fb3b9d0f$export$83db162b74637ea);
$parcel$export(module.exports, "Container", () => $bde11428fb3b9d0f$export$42a852a2b6b56249);

var $gpXaq = parcelRequire("gpXaq");

var $bEj7k = parcelRequire("bEj7k");

var $ePggP = parcelRequire("ePggP");

var $3kR0G = parcelRequire("3kR0G");

var $l8FfC = parcelRequire("l8FfC");

var $lej7S = parcelRequire("lej7S");

var $by5BM = parcelRequire("by5BM");

var $j0fPb = parcelRequire("j0fPb");

var $eyE4K = parcelRequire("eyE4K");

var $ciSyt = parcelRequire("ciSyt");

var $bAxpT = parcelRequire("bAxpT");

var $jcDhb = parcelRequire("jcDhb");

var $eHXIU = parcelRequire("eHXIU");

var $1gQ49 = parcelRequire("1gQ49");

var $iOqZ3 = parcelRequire("iOqZ3");

var $j4LQZ = parcelRequire("j4LQZ");

var $1HWH3 = parcelRequire("1HWH3");
"use strict";
const $bde11428fb3b9d0f$var$defaultSkew = new (0, $lej7S.ObservablePoint)(null);
const $bde11428fb3b9d0f$var$defaultPivot = new (0, $lej7S.ObservablePoint)(null);
const $bde11428fb3b9d0f$var$defaultScale = new (0, $lej7S.ObservablePoint)(null, 1, 1);
const $bde11428fb3b9d0f$export$f8ede8d8bf091ab5 = 1;
const $bde11428fb3b9d0f$export$e4801e7edc7582f = 2;
const $bde11428fb3b9d0f$export$83db162b74637ea = 4;
const $bde11428fb3b9d0f$export$8363b5079568fbee = 8;
class $bde11428fb3b9d0f$export$42a852a2b6b56249 extends (0, (/*@__PURE__*/$parcel$interopDefault($gpXaq))) {
    constructor(options = {}){
        super();
        /** @private */ this.uid = (0, $by5BM.uid)("renderable");
        /** @private */ this._updateFlags = 15;
        // is this container the root of a renderGroup?
        // TODO implement this in a few more places
        /** @private */ this.isRenderGroupRoot = false;
        // the render group this container belongs to OR owns
        /** @private */ this.renderGroup = null;
        // set to true if the container has changed. It is reset once the changes have been applied
        // by the transform system
        // its here to stop ensure that when things change, only one update gets registers with the transform system
        /** @private */ this.didChange = false;
        // same as above, but for the renderable
        /** @private */ this.didViewUpdate = false;
        // how deep is the container relative to its render group..
        // unless the element is the root render group - it will be relative to its parent
        /** @private */ this.relativeRenderGroupDepth = 0;
        /**
     * The array of children of this container.
     * @readonly
     */ this.children = [];
        /** The display object container that contains this display object. */ this.parent = null;
        // used internally for changing up the render order.. mainly for masks and filters
        // TODO setting this should cause a rebuild??
        /** @private */ this.includeInBuild = true;
        /** @private */ this.measurable = true;
        /** @private */ this.isSimple = true;
        // / /////////////Transform related props//////////////
        // used by the transform system to check if a container needs to be updated that frame
        // if the tick matches the current transform system tick, it is not updated again
        /**
     * @internal
     * @ignore
     */ this.updateTick = -1;
        /**
     * Current transform of the object based on local factors: position, scale, other stuff.
     * @readonly
     */ this.localTransform = new (0, $3kR0G.Matrix)();
        /**
     * The relative group transform is a transform relative to the render group it belongs too. It will include all parent
     * transforms and up to the render group (think of it as kind of like a stage - but the stage can be nested).
     * If this container is is self a render group matrix will be relative to its parent render group
     * @readonly
     */ this.relativeGroupTransform = new (0, $3kR0G.Matrix)();
        /**
     * The group transform is a transform relative to the render group it belongs too.
     * If this container is render group then this will be an identity matrix. other wise it
     * will be the same as the relativeGroupTransform.
     * Use this value when actually rendering things to the screen
     * @readonly
     */ this.groupTransform = this.relativeGroupTransform;
        /** If the object has been destroyed via destroy(). If true, it should not be used. */ this.destroyed = false;
        // transform data..
        /**
     * The coordinate of the object relative to the local coordinates of the parent.
     * @internal
     * @ignore
     */ this._position = new (0, $lej7S.ObservablePoint)(this, 0, 0);
        /**
     * The scale factor of the object.
     * @internal
     * @ignore
     */ this._scale = $bde11428fb3b9d0f$var$defaultScale;
        /**
     * The pivot point of the container that it rotates around.
     * @internal
     * @ignore
     */ this._pivot = $bde11428fb3b9d0f$var$defaultPivot;
        /**
     * The skew amount, on the x and y axis.
     * @internal
     * @ignore
     */ this._skew = $bde11428fb3b9d0f$var$defaultSkew;
        /**
     * The X-coordinate value of the normalized local X axis,
     * the first column of the local transformation matrix without a scale.
     * @internal
     * @ignore
     */ this._cx = 1;
        /**
     * The Y-coordinate value of the normalized local X axis,
     * the first column of the local transformation matrix without a scale.
     * @internal
     * @ignore
     */ this._sx = 0;
        /**
     * The X-coordinate value of the normalized local Y axis,
     * the second column of the local transformation matrix without a scale.
     * @internal
     * @ignore
     */ this._cy = 0;
        /**
     * The Y-coordinate value of the normalized local Y axis,
     * the second column of the local transformation matrix without a scale.
     * @internal
     * @ignore
     */ this._sy = 1;
        /**
     * The rotation amount.
     * @internal
     * @ignore
     */ this._rotation = 0;
        // / COLOR related props //////////////
        // color stored as ABGR
        this.localColor = 16777215;
        this.localAlpha = 1;
        this.groupAlpha = 1;
        // A
        this.groupColor = 16777215;
        // BGR
        this.groupColorAlpha = 4294967295;
        // ABGR
        // / BLEND related props //////////////
        /**
     * @internal
     * @ignore
     */ this.localBlendMode = "inherit";
        /**
     * @internal
     * @ignore
     */ this.groupBlendMode = "normal";
        // / VISIBILITY related props //////////////
        // visibility
        // 0b11
        // first bit is visible, second bit is renderable
        /**
     * This property holds three bits: culled, visible, renderable
     * the third bit represents culling (0 = culled, 1 = not culled) 0b100
     * the second bit represents visibility (0 = not visible, 1 = visible) 0b010
     * the first bit represents renderable (0 = renderable, 1 = not renderable) 0b001
     * @internal
     * @ignore
     */ this.localDisplayStatus = 7;
        // 0b11 | 0b10 | 0b01 | 0b00
        /**
     * @internal
     * @ignore
     */ this.globalDisplayStatus = 7;
        /**
     * A value that increments each time the container is modified
     * the first 12 bits represent the container changes (eg transform, alpha, visible etc)
     * the second 12 bits represent:
     *      - for view changes (eg texture swap, geometry change etc)
     *      - containers changes (eg children added, removed etc)
     *
     *  view          container
     * [000000000000][00000000000]
     * @ignore
     */ this._didChangeId = 0;
        /**
     * property that tracks if the container transform has changed
     * @ignore
     */ this._didLocalTransformChangeId = -1;
        (0, $1HWH3.assignWithIgnore)(this, options, {
            children: true,
            parent: true,
            effects: true
        });
        options.children?.forEach((child)=>this.addChild(child));
        this.effects = [];
        options.parent?.addChild(this);
    }
    /**
   * Mixes all enumerable properties and methods from a source object to Container.
   * @param source - The source of properties and methods to mix in.
   */ static mixin(source) {
        Object.defineProperties($bde11428fb3b9d0f$export$42a852a2b6b56249.prototype, Object.getOwnPropertyDescriptors(source));
    }
    /**
   * Adds one or more children to the container.
   *
   * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
   * @param {...Container} children - The Container(s) to add to the container
   * @returns {Container} - The first child that was added.
   */ addChild(...children) {
        if (!this.allowChildren) (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "addChild: Only Containers will be allowed to add children in v8.0.0");
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.addChild(children[i]);
            return children[0];
        }
        const child = children[0];
        if (child.parent === this) {
            this.children.splice(this.children.indexOf(child), 1);
            this.children.push(child);
            if (this.renderGroup && !this.isRenderGroupRoot) this.renderGroup.structureDidChange = true;
            return child;
        }
        if (child.parent) child.parent.removeChild(child);
        this.children.push(child);
        if (this.sortableChildren) this.sortDirty = true;
        child.parent = this;
        child.didChange = true;
        child.didViewUpdate = false;
        child._updateFlags = 15;
        if (this.renderGroup) this.renderGroup.addChild(child);
        this.emit("childAdded", child, this, this.children.length - 1);
        child.emit("added", this);
        this._didChangeId += 4096;
        if (child._zIndex !== 0) child.depthOfChildModified();
        return child;
    }
    /**
   * Removes one or more children from the container.
   * @param {...Container} children - The Container(s) to remove
   * @returns {Container} The first child that was removed.
   */ removeChild(...children) {
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
            return children[0];
        }
        const child = children[0];
        const index = this.children.indexOf(child);
        if (index > -1) {
            this._didChangeId += 4096;
            this.children.splice(index, 1);
            if (this.renderGroup) this.renderGroup.removeChild(child);
            child.parent = null;
            this.emit("childRemoved", child, this, index);
            child.emit("removed", this);
        }
        return child;
    }
    /** @ignore */ _onUpdate(point) {
        if (point) {
            if (point === this._skew) this._updateSkew();
        }
        this._didChangeId++;
        if (this.didChange) return;
        this.didChange = true;
        if (this.isRenderGroupRoot) {
            const renderGroupParent = this.renderGroup.renderGroupParent;
            if (renderGroupParent) renderGroupParent.onChildUpdate(this);
        } else if (this.renderGroup) this.renderGroup.onChildUpdate(this);
    }
    set isRenderGroup(value) {
        if (this.isRenderGroupRoot && value === false) throw new Error("[Pixi] cannot undo a render group just yet");
        if (value) this.enableRenderGroup();
    }
    /**
   * Returns true if this container is a render group.
   * This means that it will be rendered as a separate pass, with its own set of instructions
   */ get isRenderGroup() {
        return this.isRenderGroupRoot;
    }
    /** This enables the container to be rendered as a render group. */ enableRenderGroup() {
        if (this.renderGroup && this.renderGroup.root === this) return;
        this.isRenderGroupRoot = true;
        const parentRenderGroup = this.renderGroup;
        if (parentRenderGroup) parentRenderGroup.removeChild(this);
        this.renderGroup = new (0, $j4LQZ.RenderGroup)(this);
        if (parentRenderGroup) {
            for(let i = 0; i < parentRenderGroup.renderGroupChildren.length; i++){
                const childRenderGroup = parentRenderGroup.renderGroupChildren[i];
                let parent = childRenderGroup.root;
                while(parent){
                    if (parent === this) {
                        this.renderGroup.addRenderGroupChild(childRenderGroup);
                        break;
                    }
                    parent = parent.parent;
                }
            }
            parentRenderGroup.addRenderGroupChild(this.renderGroup);
        }
        this._updateIsSimple();
        this.groupTransform = (0, $3kR0G.Matrix).IDENTITY;
    }
    /** @ignore */ _updateIsSimple() {
        this.isSimple = !this.isRenderGroupRoot && this.effects.length === 0;
    }
    /**
   * Current transform of the object based on world (parent) factors.
   * @readonly
   */ get worldTransform() {
        this._worldTransform || (this._worldTransform = new (0, $3kR0G.Matrix)());
        if (this.renderGroup) {
            if (this.isRenderGroupRoot) this._worldTransform.copyFrom(this.renderGroup.worldTransform);
            else this._worldTransform.appendFrom(this.relativeGroupTransform, this.renderGroup.worldTransform);
        }
        return this._worldTransform;
    }
    // / ////// transform related stuff
    /**
   * The position of the container on the x axis relative to the local coordinates of the parent.
   * An alias to position.x
   */ get x() {
        return this._position.x;
    }
    set x(value) {
        this._position.x = value;
    }
    /**
   * The position of the container on the y axis relative to the local coordinates of the parent.
   * An alias to position.y
   */ get y() {
        return this._position.y;
    }
    set y(value) {
        this._position.y = value;
    }
    /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @since 4.0.0
   */ get position() {
        return this._position;
    }
    set position(value) {
        this._position.copyFrom(value);
    }
    /**
   * The rotation of the object in radians.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */ get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        if (this._rotation !== value) {
            this._rotation = value;
            this._onUpdate(this._skew);
        }
    }
    /**
   * The angle of the object in degrees.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */ get angle() {
        return this.rotation * (0, $l8FfC.RAD_TO_DEG);
    }
    set angle(value) {
        this.rotation = value * (0, $l8FfC.DEG_TO_RAD);
    }
    /**
   * The center of rotation, scaling, and skewing for this display object in its local space. The `position`
   * is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @since 4.0.0
   */ get pivot() {
        if (this._pivot === $bde11428fb3b9d0f$var$defaultPivot) this._pivot = new (0, $lej7S.ObservablePoint)(this, 0, 0);
        return this._pivot;
    }
    set pivot(value) {
        if (this._pivot === $bde11428fb3b9d0f$var$defaultPivot) this._pivot = new (0, $lej7S.ObservablePoint)(this, 0, 0);
        typeof value === "number" ? this._pivot.set(value) : this._pivot.copyFrom(value);
    }
    /**
   * The skew factor for the object in radians.
   * @since 4.0.0
   */ get skew() {
        if (this._skew === $bde11428fb3b9d0f$var$defaultSkew) this._skew = new (0, $lej7S.ObservablePoint)(this, 0, 0);
        return this._skew;
    }
    set skew(value) {
        if (this._skew === $bde11428fb3b9d0f$var$defaultSkew) this._skew = new (0, $lej7S.ObservablePoint)(this, 0, 0);
        this._skew.copyFrom(value);
    }
    /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @since 4.0.0
   */ get scale() {
        if (this._scale === $bde11428fb3b9d0f$var$defaultScale) this._scale = new (0, $lej7S.ObservablePoint)(this, 1, 1);
        return this._scale;
    }
    set scale(value) {
        if (this._scale === $bde11428fb3b9d0f$var$defaultScale) this._scale = new (0, $lej7S.ObservablePoint)(this, 0, 0);
        typeof value === "number" ? this._scale.set(value) : this._scale.copyFrom(value);
    }
    /**
   * The width of the Container, setting this will actually modify the scale to achieve the value set.
   * @memberof scene.Container#
   */ get width() {
        return Math.abs(this.scale.x * this.getLocalBounds().width);
    }
    set width(value) {
        const localWidth = this.getLocalBounds().width;
        this._setWidth(value, localWidth);
    }
    /**
   * The height of the Container, setting this will actually modify the scale to achieve the value set.
   * @memberof scene.Container#
   */ get height() {
        return Math.abs(this.scale.y * this.getLocalBounds().height);
    }
    set height(value) {
        const localHeight = this.getLocalBounds().height;
        this._setHeight(value, localHeight);
    }
    /**
   * Retrieves the size of the container as a [Size]{@link Size} object.
   * This is faster than get the width and height separately.
   * @param out - Optional object to store the size in.
   * @returns - The size of the container.
   * @memberof scene.Container#
   */ getSize(out) {
        if (!out) out = {};
        const bounds = this.getLocalBounds();
        out.width = Math.abs(this.scale.x * bounds.width);
        out.height = Math.abs(this.scale.y * bounds.height);
        return out;
    }
    /**
   * Sets the size of the container to the specified width and height.
   * This is faster than setting the width and height separately.
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   * @memberof scene.Container#
   */ setSize(value, height) {
        const size = this.getLocalBounds();
        let convertedWidth;
        let convertedHeight;
        if (typeof value !== "object") {
            convertedWidth = value;
            convertedHeight = height ?? value;
        } else {
            convertedWidth = value.width;
            convertedHeight = value.height ?? value.width;
        }
        if (convertedWidth !== void 0) this._setWidth(convertedWidth, size.width);
        if (convertedHeight !== void 0) this._setHeight(convertedHeight, size.height);
    }
    /** Called when the skew or the rotation changes. */ _updateSkew() {
        const rotation = this._rotation;
        const skew = this._skew;
        this._cx = Math.cos(rotation + skew._y);
        this._sx = Math.sin(rotation + skew._y);
        this._cy = -Math.sin(rotation - skew._x);
        this._sy = Math.cos(rotation - skew._x);
    }
    /**
   * Updates the transform properties of the container (accepts partial values).
   * @param {object} opts - The options for updating the transform.
   * @param {number} opts.x - The x position of the container.
   * @param {number} opts.y - The y position of the container.
   * @param {number} opts.scaleX - The scale factor on the x-axis.
   * @param {number} opts.scaleY - The scale factor on the y-axis.
   * @param {number} opts.rotation - The rotation of the container, in radians.
   * @param {number} opts.skewX - The skew factor on the x-axis.
   * @param {number} opts.skewY - The skew factor on the y-axis.
   * @param {number} opts.pivotX - The x coordinate of the pivot point.
   * @param {number} opts.pivotY - The y coordinate of the pivot point.
   */ updateTransform(opts) {
        this.position.set(typeof opts.x === "number" ? opts.x : this.position.x, typeof opts.y === "number" ? opts.y : this.position.y);
        this.scale.set(typeof opts.scaleX === "number" ? opts.scaleX || 1 : this.scale.x, typeof opts.scaleY === "number" ? opts.scaleY || 1 : this.scale.y);
        this.rotation = typeof opts.rotation === "number" ? opts.rotation : this.rotation;
        this.skew.set(typeof opts.skewX === "number" ? opts.skewX : this.skew.x, typeof opts.skewY === "number" ? opts.skewY : this.skew.y);
        this.pivot.set(typeof opts.pivotX === "number" ? opts.pivotX : this.pivot.x, typeof opts.pivotY === "number" ? opts.pivotY : this.pivot.y);
        return this;
    }
    /**
   * Updates the local transform using the given matrix.
   * @param matrix - The matrix to use for updating the transform.
   */ setFromMatrix(matrix) {
        matrix.decompose(this);
    }
    /** Updates the local transform. */ updateLocalTransform() {
        if ((this._didLocalTransformChangeId & 15) === this._didChangeId) return;
        this._didLocalTransformChangeId = this._didChangeId;
        const lt = this.localTransform;
        const scale = this._scale;
        const pivot = this._pivot;
        const position = this._position;
        const sx = scale._x;
        const sy = scale._y;
        const px = pivot._x;
        const py = pivot._y;
        lt.a = this._cx * sx;
        lt.b = this._sx * sx;
        lt.c = this._cy * sy;
        lt.d = this._sy * sy;
        lt.tx = position._x - (px * lt.a + py * lt.c);
        lt.ty = position._y - (px * lt.b + py * lt.d);
    }
    // / ///// color related stuff
    set alpha(value) {
        if (value === this.localAlpha) return;
        this.localAlpha = value;
        this._updateFlags |= $bde11428fb3b9d0f$export$f8ede8d8bf091ab5;
        this._onUpdate();
    }
    /** The opacity of the object. */ get alpha() {
        return this.localAlpha;
    }
    set tint(value) {
        const tempColor = (0, $bEj7k.Color).shared.setValue(value ?? 16777215);
        const bgr = tempColor.toBgrNumber();
        if (bgr === this.localColor) return;
        this.localColor = bgr;
        this._updateFlags |= $bde11428fb3b9d0f$export$f8ede8d8bf091ab5;
        this._onUpdate();
    }
    /**
   * The tint applied to the sprite. This is a hex value.
   *
   * A value of 0xFFFFFF will remove any tint effect.
   * @default 0xFFFFFF
   */ get tint() {
        const bgr = this.localColor;
        return ((bgr & 255) << 16) + (bgr & 65280) + (bgr >> 16 & 255);
    }
    // / //////////////// blend related stuff
    set blendMode(value) {
        if (this.localBlendMode === value) return;
        if (this.renderGroup && !this.isRenderGroupRoot) this.renderGroup.structureDidChange = true;
        this._updateFlags |= $bde11428fb3b9d0f$export$e4801e7edc7582f;
        this.localBlendMode = value;
        this._onUpdate();
    }
    /**
   * The blend mode to be applied to the sprite. Apply a value of `'normal'` to reset the blend mode.
   * @default 'normal'
   */ get blendMode() {
        return this.localBlendMode;
    }
    // / ///////// VISIBILITY / RENDERABLE /////////////////
    /** The visibility of the object. If false the object will not be drawn, and the transform will not be updated. */ get visible() {
        return !!(this.localDisplayStatus & 2);
    }
    set visible(value) {
        const valueNumber = value ? 1 : 0;
        if ((this.localDisplayStatus & 2) >> 1 === valueNumber) return;
        if (this.renderGroup && !this.isRenderGroupRoot) this.renderGroup.structureDidChange = true;
        this._updateFlags |= $bde11428fb3b9d0f$export$83db162b74637ea;
        this.localDisplayStatus ^= 2;
        this._onUpdate();
    }
    /** @ignore */ get culled() {
        return !(this.localDisplayStatus & 4);
    }
    /** @ignore */ set culled(value) {
        const valueNumber = value ? 1 : 0;
        if ((this.localDisplayStatus & 4) >> 2 === valueNumber) return;
        if (this.renderGroup && !this.isRenderGroupRoot) this.renderGroup.structureDidChange = true;
        this._updateFlags |= $bde11428fb3b9d0f$export$83db162b74637ea;
        this.localDisplayStatus ^= 4;
        this._onUpdate();
    }
    /** Can this object be rendered, if false the object will not be drawn but the transform will still be updated. */ get renderable() {
        return !!(this.localDisplayStatus & 1);
    }
    set renderable(value) {
        const valueNumber = value ? 1 : 0;
        if ((this.localDisplayStatus & 1) === valueNumber) return;
        this._updateFlags |= $bde11428fb3b9d0f$export$83db162b74637ea;
        this.localDisplayStatus ^= 1;
        if (this.renderGroup && !this.isRenderGroupRoot) this.renderGroup.structureDidChange = true;
        this._onUpdate();
    }
    /** Whether or not the object should be rendered. */ get isRenderable() {
        return this.localDisplayStatus === 7 && this.groupAlpha > 0;
    }
    /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
   *  method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for children with textures e.g. Sprites. If options.children
   * is set to true it should destroy the texture of the child sprite
   * @param {boolean} [options.textureSource=false] - Only used for children with textures e.g. Sprites.
   * If options.children is set to true it should destroy the texture source of the child sprite
   * @param {boolean} [options.context=false] - Only used for children with graphicsContexts e.g. Graphics.
   * If options.children is set to true it should destroy the context of the child graphics
   */ destroy(options = false) {
        if (this.destroyed) return;
        this.destroyed = true;
        this.removeFromParent();
        this.parent = null;
        this._mask = null;
        this._filters = null;
        this.effects = null;
        this._position = null;
        this._scale = null;
        this._pivot = null;
        this._skew = null;
        this.emit("destroyed", this);
        this.removeAllListeners();
        const destroyChildren = typeof options === "boolean" ? options : options?.children;
        const oldChildren = this.removeChildren(0, this.children.length);
        if (destroyChildren) for(let i = 0; i < oldChildren.length; ++i)oldChildren[i].destroy(options);
    }
}
$bde11428fb3b9d0f$export$42a852a2b6b56249.mixin((0, $eyE4K.childrenHelperMixin));
$bde11428fb3b9d0f$export$42a852a2b6b56249.mixin((0, $iOqZ3.toLocalGlobalMixin));
$bde11428fb3b9d0f$export$42a852a2b6b56249.mixin((0, $eHXIU.onRenderMixin));
$bde11428fb3b9d0f$export$42a852a2b6b56249.mixin((0, $jcDhb.measureMixin));
$bde11428fb3b9d0f$export$42a852a2b6b56249.mixin((0, $ciSyt.effectsMixin));
$bde11428fb3b9d0f$export$42a852a2b6b56249.mixin((0, $bAxpT.findMixin));
$bde11428fb3b9d0f$export$42a852a2b6b56249.mixin((0, $1gQ49.sortMixin));
$bde11428fb3b9d0f$export$42a852a2b6b56249.mixin((0, $ePggP.cullingMixin));

});
parcelRegister("bEj7k", function(module, exports) {

$parcel$export(module.exports, "Color", () => $6769fc4d3f5ca42f$export$892596cec99bc70e);

var $jyvmC = parcelRequire("jyvmC");

var $flk9m = parcelRequire("flk9m");
"use strict";
(0, $jyvmC.extend)([
    (0, $flk9m.default)
]);
const $6769fc4d3f5ca42f$var$_Color = class _Color {
    /**
   * @param {ColorSource} value - Optional value to use, if not provided, white is used.
   */ constructor(value = 16777215){
        this._value = null;
        this._components = new Float32Array(4);
        this._components.fill(1);
        this._int = 16777215;
        this.value = value;
    }
    /** Get red component (0 - 1) */ get red() {
        return this._components[0];
    }
    /** Get green component (0 - 1) */ get green() {
        return this._components[1];
    }
    /** Get blue component (0 - 1) */ get blue() {
        return this._components[2];
    }
    /** Get alpha component (0 - 1) */ get alpha() {
        return this._components[3];
    }
    /**
   * Set the value, suitable for chaining
   * @param value
   * @see Color.value
   */ setValue(value) {
        this.value = value;
        return this;
    }
    /**
   * The current color source.
   *
   * When setting:
   * - Setting to an instance of `Color` will copy its color source and components.
   * - Otherwise, `Color` will try to normalize the color source and set the components.
   *   If the color source is invalid, an `Error` will be thrown and the `Color` will left unchanged.
   *
   * Note: The `null` in the setter's parameter type is added to match the TypeScript rule: return type of getter
   * must be assignable to its setter's parameter type. Setting `value` to `null` will throw an `Error`.
   *
   * When getting:
   * - A return value of `null` means the previous value was overridden (e.g., {@link Color.multiply multiply},
   *   {@link Color.premultiply premultiply} or {@link Color.round round}).
   * - Otherwise, the color source used when setting is returned.
   */ set value(value) {
        if (value instanceof _Color) {
            this._value = this._cloneSource(value._value);
            this._int = value._int;
            this._components.set(value._components);
        } else if (value === null) throw new Error("Cannot set Color#value to null");
        else if (this._value === null || !this._isSourceEqual(this._value, value)) {
            this._normalize(value);
            this._value = this._cloneSource(value);
        }
    }
    get value() {
        return this._value;
    }
    /**
   * Copy a color source internally.
   * @param value - Color source
   */ _cloneSource(value) {
        if (typeof value === "string" || typeof value === "number" || value instanceof Number || value === null) return value;
        else if (Array.isArray(value) || ArrayBuffer.isView(value)) return value.slice(0);
        else if (typeof value === "object" && value !== null) return {
            ...value
        };
        return value;
    }
    /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */ _isSourceEqual(value1, value2) {
        const type1 = typeof value1;
        const type2 = typeof value2;
        if (type1 !== type2) return false;
        else if (type1 === "number" || type1 === "string" || value1 instanceof Number) return value1 === value2;
        else if (Array.isArray(value1) && Array.isArray(value2) || ArrayBuffer.isView(value1) && ArrayBuffer.isView(value2)) {
            if (value1.length !== value2.length) return false;
            return value1.every((v, i)=>v === value2[i]);
        } else if (value1 !== null && value2 !== null) {
            const keys1 = Object.keys(value1);
            const keys2 = Object.keys(value2);
            if (keys1.length !== keys2.length) return false;
            return keys1.every((key)=>value1[key] === value2[key]);
        }
        return value1 === value2;
    }
    /**
   * Convert to a RGBA color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1, a: 1 }
   */ toRgba() {
        const [r, g, b, a] = this._components;
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    }
    /**
   * Convert to a RGB color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1 }
   */ toRgb() {
        const [r, g, b] = this._components;
        return {
            r: r,
            g: g,
            b: b
        };
    }
    /** Convert to a CSS-style rgba string: `rgba(255,255,255,1.0)`. */ toRgbaString() {
        const [r, g, b] = this.toUint8RgbArray();
        return `rgba(${r},${g},${b},${this.alpha})`;
    }
    toUint8RgbArray(out) {
        const [r, g, b] = this._components;
        if (!this._arrayRgb) this._arrayRgb = [];
        out = out || this._arrayRgb;
        out[0] = Math.round(r * 255);
        out[1] = Math.round(g * 255);
        out[2] = Math.round(b * 255);
        return out;
    }
    toArray(out) {
        if (!this._arrayRgba) this._arrayRgba = [];
        out = out || this._arrayRgba;
        const [r, g, b, a] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        out[3] = a;
        return out;
    }
    toRgbArray(out) {
        if (!this._arrayRgb) this._arrayRgb = [];
        out = out || this._arrayRgb;
        const [r, g, b] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        return out;
    }
    /**
   * Convert to a hexadecimal number.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toNumber(); // returns 16777215
   */ toNumber() {
        return this._int;
    }
    /**
   * Convert to a BGR number
   * @example
   * import { Color } from 'pixi.js';
   * new Color(0xffcc99).toBgrNumber(); // returns 0x99ccff
   */ toBgrNumber() {
        const [r, g, b] = this.toUint8RgbArray();
        return (b << 16) + (g << 8) + r;
    }
    /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   * @example
   * import { Color } from 'pixi.js';
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   * @returns {number} - The color as a number in little endian format.
   */ toLittleEndianNumber() {
        const value = this._int;
        return (value >> 16) + (value & 65280) + ((value & 255) << 16);
    }
    /**
   * Multiply with another color. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param {ColorSource} value - The color to multiply by.
   */ multiply(value) {
        const [r, g, b, a] = _Color._temp.setValue(value)._components;
        this._components[0] *= r;
        this._components[1] *= g;
        this._components[2] *= b;
        this._components[3] *= a;
        this._refreshInt();
        this._value = null;
        return this;
    }
    /**
   * Converts color to a premultiplied alpha format. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {Color} - Itself.
   */ premultiply(alpha, applyToRGB = true) {
        if (applyToRGB) {
            this._components[0] *= alpha;
            this._components[1] *= alpha;
            this._components[2] *= alpha;
        }
        this._components[3] = alpha;
        this._refreshInt();
        this._value = null;
        return this;
    }
    /**
   * Premultiplies alpha with current color.
   * @param {number} alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {number} tint multiplied by alpha
   */ toPremultiplied(alpha, applyToRGB = true) {
        if (alpha === 1) return -16777216 + this._int;
        if (alpha === 0) return applyToRGB ? 0 : this._int;
        let r = this._int >> 16 & 255;
        let g = this._int >> 8 & 255;
        let b = this._int & 255;
        if (applyToRGB) {
            r = r * alpha + 0.5 | 0;
            g = g * alpha + 0.5 | 0;
            b = b * alpha + 0.5 | 0;
        }
        return (alpha * 255 << 24) + (r << 16) + (g << 8) + b;
    }
    /**
   * Convert to a hexidecimal string.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHex(); // returns "#ffffff"
   */ toHex() {
        const hexString = this._int.toString(16);
        return `#${"000000".substring(0, 6 - hexString.length) + hexString}`;
    }
    /**
   * Convert to a hexidecimal string with alpha.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHexa(); // returns "#ffffffff"
   */ toHexa() {
        const alphaValue = Math.round(this._components[3] * 255);
        const alphaString = alphaValue.toString(16);
        return this.toHex() + "00".substring(0, 2 - alphaString.length) + alphaString;
    }
    /**
   * Set alpha, suitable for chaining.
   * @param alpha
   */ setAlpha(alpha) {
        this._components[3] = this._clamp(alpha);
        return this;
    }
    /**
   * Normalize the input value into rgba
   * @param value - Input value
   */ _normalize(value) {
        let r;
        let g;
        let b;
        let a;
        if ((typeof value === "number" || value instanceof Number) && value >= 0 && value <= 16777215) {
            const int = value;
            r = (int >> 16 & 255) / 255;
            g = (int >> 8 & 255) / 255;
            b = (int & 255) / 255;
            a = 1;
        } else if ((Array.isArray(value) || value instanceof Float32Array) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value);
            [r, g, b, a = 1] = value;
        } else if ((value instanceof Uint8Array || value instanceof Uint8ClampedArray) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value, 0, 255);
            [r, g, b, a = 255] = value;
            r /= 255;
            g /= 255;
            b /= 255;
            a /= 255;
        } else if (typeof value === "string" || typeof value === "object") {
            if (typeof value === "string") {
                const match = _Color.HEX_PATTERN.exec(value);
                if (match) value = `#${match[2]}`;
            }
            const color = (0, $jyvmC.colord)(value);
            if (color.isValid()) {
                ({ r: r, g: g, b: b, a: a } = color.rgba);
                r /= 255;
                g /= 255;
                b /= 255;
            }
        }
        if (r !== void 0) {
            this._components[0] = r;
            this._components[1] = g;
            this._components[2] = b;
            this._components[3] = a;
            this._refreshInt();
        } else throw new Error(`Unable to convert color ${value}`);
    }
    /** Refresh the internal color rgb number */ _refreshInt() {
        this._clamp(this._components);
        const [r, g, b] = this._components;
        this._int = (r * 255 << 16) + (g * 255 << 8) + (b * 255 | 0);
    }
    /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */ _clamp(value, min = 0, max = 1) {
        if (typeof value === "number") return Math.min(Math.max(value, min), max);
        value.forEach((v, i)=>{
            value[i] = Math.min(Math.max(v, min), max);
        });
        return value;
    }
    /**
   * Check if the value is a color-like object
   * @param value - Value to check
   * @returns True if the value is a color-like object
   * @static
   * @example
   * import { Color } from 'pixi.js';
   * Color.isColorLike('white'); // returns true
   * Color.isColorLike(0xffffff); // returns true
   * Color.isColorLike([1, 1, 1]); // returns true
   */ static isColorLike(value) {
        return typeof value === "number" || typeof value === "string" || value instanceof Number || value instanceof _Color || Array.isArray(value) || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Float32Array || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 && value.a !== void 0;
    }
};
/**
 * Default Color object for static uses
 * @example
 * import { Color } from 'pixi.js';
 * Color.shared.setValue(0xffffff).toHex(); // '#ffffff'
 */ $6769fc4d3f5ca42f$var$_Color.shared = new $6769fc4d3f5ca42f$var$_Color();
/**
 * Temporary Color object for static uses internally.
 * As to not conflict with Color.shared.
 * @ignore
 */ $6769fc4d3f5ca42f$var$_Color._temp = new $6769fc4d3f5ca42f$var$_Color();
/** Pattern for hex strings */ // eslint-disable-next-line @typescript-eslint/naming-convention
$6769fc4d3f5ca42f$var$_Color.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let $6769fc4d3f5ca42f$export$892596cec99bc70e = $6769fc4d3f5ca42f$var$_Color;

});
parcelRegister("jyvmC", function(module, exports) {

$parcel$export(module.exports, "colord", () => $34b99b961acc9a90$export$c8efe09109f9cb9e);
$parcel$export(module.exports, "extend", () => $34b99b961acc9a90$export$8b58be045bf06082);
var $34b99b961acc9a90$var$r = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $34b99b961acc9a90$var$t = function(r) {
    return "string" == typeof r ? r.length > 0 : "number" == typeof r;
}, $34b99b961acc9a90$var$n = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = Math.pow(10, t)), Math.round(n * r) / n + 0;
}, $34b99b961acc9a90$var$e = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = 1), r > n ? n : r > t ? r : t;
}, $34b99b961acc9a90$var$u = function(r) {
    return (r = isFinite(r) ? r % 360 : 0) > 0 ? r : r + 360;
}, $34b99b961acc9a90$var$a = function(r) {
    return {
        r: $34b99b961acc9a90$var$e(r.r, 0, 255),
        g: $34b99b961acc9a90$var$e(r.g, 0, 255),
        b: $34b99b961acc9a90$var$e(r.b, 0, 255),
        a: $34b99b961acc9a90$var$e(r.a)
    };
}, $34b99b961acc9a90$var$o = function(r) {
    return {
        r: $34b99b961acc9a90$var$n(r.r),
        g: $34b99b961acc9a90$var$n(r.g),
        b: $34b99b961acc9a90$var$n(r.b),
        a: $34b99b961acc9a90$var$n(r.a, 3)
    };
}, $34b99b961acc9a90$var$i = /^#([0-9a-f]{3,8})$/i, $34b99b961acc9a90$var$s = function(r) {
    var t = r.toString(16);
    return t.length < 2 ? "0" + t : t;
}, $34b99b961acc9a90$var$h = function(r) {
    var t = r.r, n = r.g, e = r.b, u = r.a, a = Math.max(t, n, e), o = a - Math.min(t, n, e), i = o ? a === t ? (n - e) / o : a === n ? 2 + (e - t) / o : 4 + (t - n) / o : 0;
    return {
        h: 60 * (i < 0 ? i + 6 : i),
        s: a ? o / a * 100 : 0,
        v: a / 255 * 100,
        a: u
    };
}, $34b99b961acc9a90$var$b = function(r) {
    var t = r.h, n = r.s, e = r.v, u = r.a;
    t = t / 360 * 6, n /= 100, e /= 100;
    var a = Math.floor(t), o = e * (1 - n), i = e * (1 - (t - a) * n), s = e * (1 - (1 - t + a) * n), h = a % 6;
    return {
        r: 255 * [
            e,
            i,
            o,
            o,
            s,
            e
        ][h],
        g: 255 * [
            s,
            e,
            e,
            i,
            o,
            o
        ][h],
        b: 255 * [
            o,
            o,
            s,
            e,
            e,
            i
        ][h],
        a: u
    };
}, $34b99b961acc9a90$var$g = function(r) {
    return {
        h: $34b99b961acc9a90$var$u(r.h),
        s: $34b99b961acc9a90$var$e(r.s, 0, 100),
        l: $34b99b961acc9a90$var$e(r.l, 0, 100),
        a: $34b99b961acc9a90$var$e(r.a)
    };
}, $34b99b961acc9a90$var$d = function(r) {
    return {
        h: $34b99b961acc9a90$var$n(r.h),
        s: $34b99b961acc9a90$var$n(r.s),
        l: $34b99b961acc9a90$var$n(r.l),
        a: $34b99b961acc9a90$var$n(r.a, 3)
    };
}, $34b99b961acc9a90$var$f = function(r) {
    var t, n, e;
    return $34b99b961acc9a90$var$b((n = (t = r).s, {
        h: t.h,
        s: (n *= ((e = t.l) < 50 ? e : 100 - e) / 100) > 0 ? 2 * n / (e + n) * 100 : 0,
        v: e + n,
        a: t.a
    }));
}, $34b99b961acc9a90$var$c = function(r) {
    var t, n, e, u;
    return {
        h: (t = $34b99b961acc9a90$var$h(r)).h,
        s: (u = (200 - (n = t.s)) * (e = t.v) / 100) > 0 && u < 200 ? n * e / 100 / (u <= 100 ? u : 200 - u) * 100 : 0,
        l: u / 2,
        a: t.a
    };
}, $34b99b961acc9a90$var$l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $34b99b961acc9a90$var$p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $34b99b961acc9a90$var$v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $34b99b961acc9a90$var$m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $34b99b961acc9a90$var$y = {
    string: [
        [
            function(r) {
                var t = $34b99b961acc9a90$var$i.exec(r);
                return t ? (r = t[1]).length <= 4 ? {
                    r: parseInt(r[0] + r[0], 16),
                    g: parseInt(r[1] + r[1], 16),
                    b: parseInt(r[2] + r[2], 16),
                    a: 4 === r.length ? $34b99b961acc9a90$var$n(parseInt(r[3] + r[3], 16) / 255, 2) : 1
                } : 6 === r.length || 8 === r.length ? {
                    r: parseInt(r.substr(0, 2), 16),
                    g: parseInt(r.substr(2, 2), 16),
                    b: parseInt(r.substr(4, 2), 16),
                    a: 8 === r.length ? $34b99b961acc9a90$var$n(parseInt(r.substr(6, 2), 16) / 255, 2) : 1
                } : null : null;
            },
            "hex"
        ],
        [
            function(r) {
                var t = $34b99b961acc9a90$var$v.exec(r) || $34b99b961acc9a90$var$m.exec(r);
                return t ? t[2] !== t[4] || t[4] !== t[6] ? null : $34b99b961acc9a90$var$a({
                    r: Number(t[1]) / (t[2] ? 100 / 255 : 1),
                    g: Number(t[3]) / (t[4] ? 100 / 255 : 1),
                    b: Number(t[5]) / (t[6] ? 100 / 255 : 1),
                    a: void 0 === t[7] ? 1 : Number(t[7]) / (t[8] ? 100 : 1)
                }) : null;
            },
            "rgb"
        ],
        [
            function(t) {
                var n = $34b99b961acc9a90$var$l.exec(t) || $34b99b961acc9a90$var$p.exec(t);
                if (!n) return null;
                var e, u, a = $34b99b961acc9a90$var$g({
                    h: (e = n[1], u = n[2], void 0 === u && (u = "deg"), Number(e) * ($34b99b961acc9a90$var$r[u] || 1)),
                    s: Number(n[3]),
                    l: Number(n[4]),
                    a: void 0 === n[5] ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
                return $34b99b961acc9a90$var$f(a);
            },
            "hsl"
        ]
    ],
    object: [
        [
            function(r) {
                var n = r.r, e = r.g, u = r.b, o = r.a, i = void 0 === o ? 1 : o;
                return $34b99b961acc9a90$var$t(n) && $34b99b961acc9a90$var$t(e) && $34b99b961acc9a90$var$t(u) ? $34b99b961acc9a90$var$a({
                    r: Number(n),
                    g: Number(e),
                    b: Number(u),
                    a: Number(i)
                }) : null;
            },
            "rgb"
        ],
        [
            function(r) {
                var n = r.h, e = r.s, u = r.l, a = r.a, o = void 0 === a ? 1 : a;
                if (!$34b99b961acc9a90$var$t(n) || !$34b99b961acc9a90$var$t(e) || !$34b99b961acc9a90$var$t(u)) return null;
                var i = $34b99b961acc9a90$var$g({
                    h: Number(n),
                    s: Number(e),
                    l: Number(u),
                    a: Number(o)
                });
                return $34b99b961acc9a90$var$f(i);
            },
            "hsl"
        ],
        [
            function(r) {
                var n = r.h, a = r.s, o = r.v, i = r.a, s = void 0 === i ? 1 : i;
                if (!$34b99b961acc9a90$var$t(n) || !$34b99b961acc9a90$var$t(a) || !$34b99b961acc9a90$var$t(o)) return null;
                var h = function(r) {
                    return {
                        h: $34b99b961acc9a90$var$u(r.h),
                        s: $34b99b961acc9a90$var$e(r.s, 0, 100),
                        v: $34b99b961acc9a90$var$e(r.v, 0, 100),
                        a: $34b99b961acc9a90$var$e(r.a)
                    };
                }({
                    h: Number(n),
                    s: Number(a),
                    v: Number(o),
                    a: Number(s)
                });
                return $34b99b961acc9a90$var$b(h);
            },
            "hsv"
        ]
    ]
}, $34b99b961acc9a90$var$N = function(r, t) {
    for(var n = 0; n < t.length; n++){
        var e = t[n][0](r);
        if (e) return [
            e,
            t[n][1]
        ];
    }
    return [
        null,
        void 0
    ];
}, $34b99b961acc9a90$var$x = function(r) {
    return "string" == typeof r ? $34b99b961acc9a90$var$N(r.trim(), $34b99b961acc9a90$var$y.string) : "object" == typeof r && null !== r ? $34b99b961acc9a90$var$N(r, $34b99b961acc9a90$var$y.object) : [
        null,
        void 0
    ];
}, $34b99b961acc9a90$export$f61ac8b6f1f46202 = function(r) {
    return $34b99b961acc9a90$var$x(r)[1];
}, $34b99b961acc9a90$var$M = function(r, t) {
    var n = $34b99b961acc9a90$var$c(r);
    return {
        h: n.h,
        s: $34b99b961acc9a90$var$e(n.s + 100 * t, 0, 100),
        l: n.l,
        a: n.a
    };
}, $34b99b961acc9a90$var$H = function(r) {
    return (299 * r.r + 587 * r.g + 114 * r.b) / 1e3 / 255;
}, $34b99b961acc9a90$var$$ = function(r, t) {
    var n = $34b99b961acc9a90$var$c(r);
    return {
        h: n.h,
        s: n.s,
        l: $34b99b961acc9a90$var$e(n.l + 100 * t, 0, 100),
        a: n.a
    };
}, $34b99b961acc9a90$export$4d30ed660ff08d0 = function() {
    function r(r) {
        this.parsed = $34b99b961acc9a90$var$x(r)[0], this.rgba = this.parsed || {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    return r.prototype.isValid = function() {
        return null !== this.parsed;
    }, r.prototype.brightness = function() {
        return $34b99b961acc9a90$var$n($34b99b961acc9a90$var$H(this.rgba), 2);
    }, r.prototype.isDark = function() {
        return $34b99b961acc9a90$var$H(this.rgba) < .5;
    }, r.prototype.isLight = function() {
        return $34b99b961acc9a90$var$H(this.rgba) >= .5;
    }, r.prototype.toHex = function() {
        var r, t, e, u, a, i;
        return r = $34b99b961acc9a90$var$o(this.rgba), t = r.r, e = r.g, u = r.b, i = (a = r.a) < 1 ? $34b99b961acc9a90$var$s($34b99b961acc9a90$var$n(255 * a)) : "", "#" + $34b99b961acc9a90$var$s(t) + $34b99b961acc9a90$var$s(e) + $34b99b961acc9a90$var$s(u) + i;
    }, r.prototype.toRgb = function() {
        return $34b99b961acc9a90$var$o(this.rgba);
    }, r.prototype.toRgbString = function() {
        var r, t, n, e, u;
        return r = $34b99b961acc9a90$var$o(this.rgba), t = r.r, n = r.g, e = r.b, (u = r.a) < 1 ? "rgba(" + t + ", " + n + ", " + e + ", " + u + ")" : "rgb(" + t + ", " + n + ", " + e + ")";
    }, r.prototype.toHsl = function() {
        return $34b99b961acc9a90$var$d($34b99b961acc9a90$var$c(this.rgba));
    }, r.prototype.toHslString = function() {
        var r, t, n, e, u;
        return r = $34b99b961acc9a90$var$d($34b99b961acc9a90$var$c(this.rgba)), t = r.h, n = r.s, e = r.l, (u = r.a) < 1 ? "hsla(" + t + ", " + n + "%, " + e + "%, " + u + ")" : "hsl(" + t + ", " + n + "%, " + e + "%)";
    }, r.prototype.toHsv = function() {
        var r;
        return r = $34b99b961acc9a90$var$h(this.rgba), {
            h: $34b99b961acc9a90$var$n(r.h),
            s: $34b99b961acc9a90$var$n(r.s),
            v: $34b99b961acc9a90$var$n(r.v),
            a: $34b99b961acc9a90$var$n(r.a, 3)
        };
    }, r.prototype.invert = function() {
        var r;
        return $34b99b961acc9a90$export$c8efe09109f9cb9e({
            r: 255 - (r = this.rgba).r,
            g: 255 - r.g,
            b: 255 - r.b,
            a: r.a
        });
    }, r.prototype.saturate = function(r) {
        return void 0 === r && (r = .1), $34b99b961acc9a90$export$c8efe09109f9cb9e($34b99b961acc9a90$var$M(this.rgba, r));
    }, r.prototype.desaturate = function(r) {
        return void 0 === r && (r = .1), $34b99b961acc9a90$export$c8efe09109f9cb9e($34b99b961acc9a90$var$M(this.rgba, -r));
    }, r.prototype.grayscale = function() {
        return $34b99b961acc9a90$export$c8efe09109f9cb9e($34b99b961acc9a90$var$M(this.rgba, -1));
    }, r.prototype.lighten = function(r) {
        return void 0 === r && (r = .1), $34b99b961acc9a90$export$c8efe09109f9cb9e($34b99b961acc9a90$var$$(this.rgba, r));
    }, r.prototype.darken = function(r) {
        return void 0 === r && (r = .1), $34b99b961acc9a90$export$c8efe09109f9cb9e($34b99b961acc9a90$var$$(this.rgba, -r));
    }, r.prototype.rotate = function(r) {
        return void 0 === r && (r = 15), this.hue(this.hue() + r);
    }, r.prototype.alpha = function(r) {
        var t;
        return "number" == typeof r ? $34b99b961acc9a90$export$c8efe09109f9cb9e({
            r: (t = this.rgba).r,
            g: t.g,
            b: t.b,
            a: r
        }) : $34b99b961acc9a90$var$n(this.rgba.a, 3);
    }, r.prototype.hue = function(r) {
        var t = $34b99b961acc9a90$var$c(this.rgba);
        return "number" == typeof r ? $34b99b961acc9a90$export$c8efe09109f9cb9e({
            h: r,
            s: t.s,
            l: t.l,
            a: t.a
        }) : $34b99b961acc9a90$var$n(t.h);
    }, r.prototype.isEqual = function(r) {
        return this.toHex() === $34b99b961acc9a90$export$c8efe09109f9cb9e(r).toHex();
    }, r;
}(), $34b99b961acc9a90$export$c8efe09109f9cb9e = function(r) {
    return r instanceof $34b99b961acc9a90$export$4d30ed660ff08d0 ? r : new $34b99b961acc9a90$export$4d30ed660ff08d0(r);
}, $34b99b961acc9a90$var$S = [], $34b99b961acc9a90$export$8b58be045bf06082 = function(r) {
    r.forEach(function(r) {
        $34b99b961acc9a90$var$S.indexOf(r) < 0 && (r($34b99b961acc9a90$export$4d30ed660ff08d0, $34b99b961acc9a90$var$y), $34b99b961acc9a90$var$S.push(r));
    });
}, $34b99b961acc9a90$export$4385e60b38654f68 = function() {
    return new $34b99b961acc9a90$export$4d30ed660ff08d0({
        r: 255 * Math.random(),
        g: 255 * Math.random(),
        b: 255 * Math.random()
    });
};

});

parcelRegister("flk9m", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d738a730be80407$export$2e2bcd8739ae039);
function $6d738a730be80407$export$2e2bcd8739ae039(e, f) {
    var a = {
        white: "#ffffff",
        bisque: "#ffe4c4",
        blue: "#0000ff",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        azure: "#f0ffff",
        whitesmoke: "#f5f5f5",
        papayawhip: "#ffefd5",
        plum: "#dda0dd",
        blanchedalmond: "#ffebcd",
        black: "#000000",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gainsboro: "#dcdcdc",
        cornsilk: "#fff8dc",
        cornflowerblue: "#6495ed",
        burlywood: "#deb887",
        aquamarine: "#7fffd4",
        beige: "#f5f5dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkkhaki: "#bdb76b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        peachpuff: "#ffdab9",
        darkmagenta: "#8b008b",
        darkred: "#8b0000",
        darkorchid: "#9932cc",
        darkorange: "#ff8c00",
        darkslateblue: "#483d8b",
        gray: "#808080",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        wheat: "#f5deb3",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        ghostwhite: "#f8f8ff",
        darkviolet: "#9400d3",
        magenta: "#ff00ff",
        green: "#008000",
        dodgerblue: "#1e90ff",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        blueviolet: "#8a2be2",
        forestgreen: "#228b22",
        lawngreen: "#7cfc00",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        fuchsia: "#ff00ff",
        brown: "#a52a2a",
        maroon: "#800000",
        mediumblue: "#0000cd",
        lightcoral: "#f08080",
        darkturquoise: "#00ced1",
        lightcyan: "#e0ffff",
        ivory: "#fffff0",
        lightyellow: "#ffffe0",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        linen: "#faf0e6",
        mediumaquamarine: "#66cdaa",
        lemonchiffon: "#fffacd",
        lime: "#00ff00",
        khaki: "#f0e68c",
        mediumseagreen: "#3cb371",
        limegreen: "#32cd32",
        mediumspringgreen: "#00fa9a",
        lightskyblue: "#87cefa",
        lightblue: "#add8e6",
        midnightblue: "#191970",
        lightpink: "#ffb6c1",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        mintcream: "#f5fffa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        navajowhite: "#ffdead",
        navy: "#000080",
        mediumvioletred: "#c71585",
        powderblue: "#b0e0e6",
        palegoldenrod: "#eee8aa",
        oldlace: "#fdf5e6",
        paleturquoise: "#afeeee",
        mediumturquoise: "#48d1cc",
        mediumorchid: "#ba55d3",
        rebeccapurple: "#663399",
        lightsteelblue: "#b0c4de",
        mediumslateblue: "#7b68ee",
        thistle: "#d8bfd8",
        tan: "#d2b48c",
        orchid: "#da70d6",
        mediumpurple: "#9370db",
        purple: "#800080",
        pink: "#ffc0cb",
        skyblue: "#87ceeb",
        springgreen: "#00ff7f",
        palegreen: "#98fb98",
        red: "#ff0000",
        yellow: "#ffff00",
        slateblue: "#6a5acd",
        lavenderblush: "#fff0f5",
        peru: "#cd853f",
        palevioletred: "#db7093",
        violet: "#ee82ee",
        teal: "#008080",
        slategray: "#708090",
        slategrey: "#708090",
        aliceblue: "#f0f8ff",
        darkseagreen: "#8fbc8f",
        darkolivegreen: "#556b2f",
        greenyellow: "#adff2f",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        tomato: "#ff6347",
        silver: "#c0c0c0",
        sienna: "#a0522d",
        lavender: "#e6e6fa",
        lightgreen: "#90ee90",
        orange: "#ffa500",
        orangered: "#ff4500",
        steelblue: "#4682b4",
        royalblue: "#4169e1",
        turquoise: "#40e0d0",
        yellowgreen: "#9acd32",
        salmon: "#fa8072",
        saddlebrown: "#8b4513",
        sandybrown: "#f4a460",
        rosybrown: "#bc8f8f",
        darksalmon: "#e9967a",
        lightgoldenrodyellow: "#fafad2",
        snow: "#fffafa",
        lightgrey: "#d3d3d3",
        lightgray: "#d3d3d3",
        dimgray: "#696969",
        dimgrey: "#696969",
        olivedrab: "#6b8e23",
        olive: "#808000"
    }, r = {};
    for(var d in a)r[a[d]] = d;
    var l = {};
    e.prototype.toName = function(f) {
        if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
        var d, i, n = r[this.toHex()];
        if (n) return n;
        if (null == f ? void 0 : f.closest) {
            var o = this.toRgb(), t = 1 / 0, b = "black";
            if (!l.length) for(var c in a)l[c] = new e(a[c]).toRgb();
            for(var g in a){
                var u = (d = o, i = l[g], Math.pow(d.r - i.r, 2) + Math.pow(d.g - i.g, 2) + Math.pow(d.b - i.b, 2));
                u < t && (t = u, b = g);
            }
            return b;
        }
    };
    f.string.push([
        function(f) {
            var r = f.toLowerCase(), d = "transparent" === r ? "#0000" : a[r];
            return d ? new e(d).toRgb() : null;
        },
        "name"
    ]);
}

});


parcelRegister("ePggP", function(module, exports) {

$parcel$export(module.exports, "cullingMixin", () => $0551e35207296e63$export$dce76d4f0fd249ed);
"use strict";
const $0551e35207296e63$export$dce76d4f0fd249ed = {
    cullArea: null,
    cullable: false,
    cullableChildren: true
};

});

parcelRegister("eyE4K", function(module, exports) {

$parcel$export(module.exports, "childrenHelperMixin", () => $49ac741b368031e6$export$64cca9f0c2df174a);

var $14w7G = parcelRequire("14w7G");

var $j0fPb = parcelRequire("j0fPb");
"use strict";
const $49ac741b368031e6$export$64cca9f0c2df174a = {
    allowChildren: true,
    /**
   * Removes all children from this container that are within the begin and end indexes.
   * @param beginIndex - The beginning position.
   * @param endIndex - The ending position. Default value is size of the container.
   * @returns - List of removed children
   * @memberof scene.Container#
   */ removeChildren (beginIndex = 0, endIndex) {
        const end = endIndex ?? this.children.length;
        const range = end - beginIndex;
        const removed = [];
        if (range > 0 && range <= end) {
            for(let i = end - 1; i >= beginIndex; i--){
                const child = this.children[i];
                if (!child) continue;
                if (this.renderGroup) this.renderGroup.removeChild(child);
                removed.push(child);
                child.parent = null;
            }
            (0, $14w7G.removeItems)(this.children, beginIndex, end);
            for(let i = 0; i < removed.length; ++i){
                this.emit("childRemoved", removed[i], this, i);
                removed[i].emit("removed", this);
            }
            return removed;
        } else if (range === 0 && this.children.length === 0) return removed;
        throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
    },
    /**
   * Removes a child from the specified index position.
   * @param index - The index to get the child from
   * @returns The child that was removed.
   * @memberof scene.Container#
   */ removeChildAt (index) {
        const child = this.getChildAt(index);
        return this.removeChild(child);
    },
    /**
   * Returns the child at the specified index
   * @param index - The index to get the child at
   * @returns - The child at the given index, if any.
   * @memberof scene.Container#
   */ getChildAt (index) {
        if (index < 0 || index >= this.children.length) throw new Error(`getChildAt: Index (${index}) does not exist.`);
        return this.children[index];
    },
    /**
   * Changes the position of an existing child in the container container
   * @param child - The child Container instance for which you want to change the index number
   * @param index - The resulting index number for the child container
   * @memberof scene.Container#
   */ setChildIndex (child, index) {
        if (index < 0 || index >= this.children.length) throw new Error(`The index ${index} supplied is out of bounds ${this.children.length}`);
        this.getChildIndex(child);
        this.addChildAt(child, index);
    },
    /**
   * Returns the index position of a child Container instance
   * @param child - The Container instance to identify
   * @returns - The index position of the child container to identify
   * @memberof scene.Container#
   */ getChildIndex (child) {
        const index = this.children.indexOf(child);
        if (index === -1) throw new Error("The supplied Container must be a child of the caller");
        return index;
    },
    /**
   * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown.
   * If the child is already in this container, it will be moved to the specified index.
   * @param {Container} child - The child to add.
   * @param {number} index - The absolute index where the child will be positioned at the end of the operation.
   * @returns {Container} The child that was added.
   * @memberof scene.Container#
   */ addChildAt (child, index) {
        if (!this.allowChildren) (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "addChildAt: Only Containers will be allowed to add children in v8.0.0");
        const { children: children } = this;
        if (index < 0 || index > children.length) throw new Error(`${child}addChildAt: The index ${index} supplied is out of bounds ${children.length}`);
        if (child.parent) {
            const currentIndex = child.parent.children.indexOf(child);
            if (child.parent === this && currentIndex === index) return child;
            if (currentIndex !== -1) child.parent.children.splice(currentIndex, 1);
        }
        if (index === children.length) children.push(child);
        else children.splice(index, 0, child);
        child.parent = this;
        child.didChange = true;
        child.didViewUpdate = false;
        child._updateFlags = 15;
        if (this.renderGroup) this.renderGroup.addChild(child);
        if (this.sortableChildren) this.sortDirty = true;
        this.emit("childAdded", child, this, index);
        child.emit("added", this);
        return child;
    },
    /**
   * Swaps the position of 2 Containers within this container.
   * @param child - First container to swap
   * @param child2 - Second container to swap
   */ swapChildren (child, child2) {
        if (child === child2) return;
        const index1 = this.getChildIndex(child);
        const index2 = this.getChildIndex(child2);
        this.children[index1] = child2;
        this.children[index2] = child;
    },
    /**
   * Remove the Container from its parent Container. If the Container has no parent, do nothing.
   * @memberof scene.Container#
   */ removeFromParent () {
        this.parent?.removeChild(this);
    }
};

});
parcelRegister("14w7G", function(module, exports) {

$parcel$export(module.exports, "removeItems", () => $c224a0ac5efc9ea6$export$8d47c0e1ce445404);
"use strict";
function $c224a0ac5efc9ea6$export$8d47c0e1ce445404(arr, startIdx, removeCount) {
    const length = arr.length;
    let i;
    if (startIdx >= length || removeCount === 0) return;
    removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    const len = length - removeCount;
    for(i = startIdx; i < len; ++i)arr[i] = arr[i + removeCount];
    arr.length = len;
}

});


parcelRegister("ciSyt", function(module, exports) {

$parcel$export(module.exports, "effectsMixin", () => $372212f64a9193bb$export$eec5e288a9d02a7c);

var $4aorF = parcelRequire("4aorF");

var $1l1Cc = parcelRequire("1l1Cc");

var $8ZHaq = parcelRequire("8ZHaq");
"use strict";
const $372212f64a9193bb$export$eec5e288a9d02a7c = {
    _mask: null,
    _filters: null,
    /**
   * @todo Needs docs.
   * @memberof scene.Container#
   * @type {Array<Effect>}
   */ effects: [],
    /**
   * @todo Needs docs.
   * @param effect - The effect to add.
   * @memberof scene.Container#
   * @ignore
   */ addEffect (effect) {
        const index = this.effects.indexOf(effect);
        if (index !== -1) return;
        this.effects.push(effect);
        this.effects.sort((a, b)=>a.priority - b.priority);
        if (this.renderGroup) this.renderGroup.structureDidChange = true;
        this._updateIsSimple();
    },
    /**
   * @todo Needs docs.
   * @param effect - The effect to remove.
   * @memberof scene.Container#
   * @ignore
   */ removeEffect (effect) {
        const index = this.effects.indexOf(effect);
        if (index === -1) return;
        this.effects.splice(index, 1);
        if (!this.isRenderGroupRoot && this.renderGroup) this.renderGroup.structureDidChange = true;
        this._updateIsSimple();
    },
    set mask (value){
        this._mask || (this._mask = {
            mask: null,
            effect: null
        });
        if (this._mask.mask === value) return;
        if (this._mask.effect) {
            this.removeEffect(this._mask.effect);
            (0, $1l1Cc.MaskEffectManager).returnMaskEffect(this._mask.effect);
            this._mask.effect = null;
        }
        this._mask.mask = value;
        if (value === null || value === void 0) return;
        const effect = (0, $1l1Cc.MaskEffectManager).getMaskEffect(value);
        this._mask.effect = effect;
        this.addEffect(effect);
    },
    /**
   * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
   * object to the shape of the mask applied to it. In PixiJS a regular mask must be a
   * {@link Graphics} or a {@link Sprite} object. This allows for much faster masking in canvas as it
   * utilities shape clipping. Furthermore, a mask of an object must be in the subtree of its parent.
   * Otherwise, `getLocalBounds` may calculate incorrect bounds, which makes the container's width and height wrong.
   * To remove a mask, set this property to `null`.
   *
   * For sprite mask both alpha and red channel are used. Black mask is the same as transparent mask.
   * @example
   * import { Graphics, Sprite } from 'pixi.js';
   *
   * const graphics = new Graphics();
   * graphics.beginFill(0xFF3300);
   * graphics.drawRect(50, 250, 100, 100);
   * graphics.endFill();
   *
   * const sprite = new Sprite(texture);
   * sprite.mask = graphics;
   * @memberof scene.Container#
   */ get mask () {
        return this._mask?.mask;
    },
    set filters (value){
        if (!Array.isArray(value) && value) value = [
            value
        ];
        value;
        this._filters || (this._filters = {
            filters: null,
            effect: null,
            filterArea: null
        });
        const hasFilters = value?.length > 0;
        const didChange = this._filters.effect && !hasFilters || !this._filters.effect && hasFilters;
        value = Array.isArray(value) ? value.slice(0) : value;
        this._filters.filters = Object.freeze(value);
        if (didChange) {
            if (hasFilters) {
                const effect = (0, $8ZHaq.BigPool).get((0, $4aorF.FilterEffect));
                this._filters.effect = effect;
                this.addEffect(effect);
            } else {
                const effect = this._filters.effect;
                this.removeEffect(effect);
                effect.filterArea = null;
                effect.filters = null;
                this._filters.effect = null;
                (0, $8ZHaq.BigPool).return(effect);
            }
        }
        if (hasFilters) {
            this._filters.effect.filters = value;
            this._filters.effect.filterArea = this.filterArea;
        }
    },
    /**
   * Sets the filters for the displayObject.
   * IMPORTANT: This is a WebGL only feature and will be ignored by the canvas renderer.
   * To remove filters simply set this property to `'null'`.
   * @memberof scene.Container#
   */ get filters () {
        return this._filters?.filters;
    },
    set filterArea (value){
        this._filters || (this._filters = {
            filters: null,
            effect: null,
            filterArea: null
        });
        this._filters.filterArea = value;
    },
    /**
   * The area the filter is applied to. This is used as more of an optimization
   * rather than figuring out the dimensions of the displayObject each frame you can set this rectangle.
   *
   * Also works as an interaction mask.
   * @memberof scene.Container#
   */ get filterArea () {
        return this._filters?.filterArea;
    }
};

});
parcelRegister("4aorF", function(module, exports) {

$parcel$export(module.exports, "FilterEffect", () => $96a5b35e926e1788$export$d66c06ffe23037ab);
"use strict";
class $96a5b35e926e1788$export$d66c06ffe23037ab {
    constructor(options){
        this.pipe = "filter";
        this.priority = 1;
        this.filters = options?.filters;
        this.filterArea = options?.filterArea;
    }
    destroy() {
        for(let i = 0; i < this.filters.length; i++)this.filters[i].destroy();
        this.filters = null;
        this.filterArea = null;
    }
}

});

parcelRegister("1l1Cc", function(module, exports) {

$parcel$export(module.exports, "MaskEffectManager", () => $0b92202cb4087826$export$1eb319167fe02d04);

var $aqljF = parcelRequire("aqljF");

var $8ZHaq = parcelRequire("8ZHaq");
"use strict";
class $0b92202cb4087826$export$3b0749bf144d4b29 {
    constructor(){
        /**
     * @private
     */ this._effectClasses = [];
        this._tests = [];
        this._initialized = false;
    }
    init() {
        if (this._initialized) return;
        this._initialized = true;
        this._effectClasses.forEach((test)=>{
            this.add({
                test: test.test,
                maskClass: test
            });
        });
    }
    add(test) {
        this._tests.push(test);
    }
    getMaskEffect(item) {
        if (!this._initialized) this.init();
        for(let i = 0; i < this._tests.length; i++){
            const test = this._tests[i];
            if (test.test(item)) return (0, $8ZHaq.BigPool).get(test.maskClass, item);
        }
        return item;
    }
    returnMaskEffect(effect) {
        (0, $8ZHaq.BigPool).return(effect);
    }
}
const $0b92202cb4087826$export$1eb319167fe02d04 = new $0b92202cb4087826$export$3b0749bf144d4b29();
(0, $aqljF.extensions).handleByList((0, $aqljF.ExtensionType).MaskEffect, $0b92202cb4087826$export$1eb319167fe02d04._effectClasses);

});
parcelRegister("8ZHaq", function(module, exports) {

$parcel$export(module.exports, "BigPool", () => $b9097416ff606be2$export$8249372279066210);

var $kf88W = parcelRequire("kf88W");
"use strict";
class $b9097416ff606be2$export$866836a21808b71c {
    constructor(){
        /**
     * A map to store the pools by their class type.
     * @private
     */ this._poolsByClass = /* @__PURE__ */ new Map();
    }
    /**
   * Prepopulates a specific pool with a given number of items.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {number} total - The number of items to add to the pool.
   */ prepopulate(Class, total) {
        const classPool = this.getPool(Class);
        classPool.prepopulate(total);
    }
    /**
   * Gets an item from a specific pool.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */ get(Class, data) {
        const pool = this.getPool(Class);
        return pool.get(data);
    }
    /**
   * Returns an item to its respective pool.
   * @param {PoolItem} item - The item to return to the pool.
   */ return(item) {
        const pool = this.getPool(item.constructor);
        pool.return(item);
    }
    /**
   * Gets a specific pool based on the class type.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} ClassType - The constructor of the items in the pool.
   * @returns {Pool<T>} The pool of the given class type.
   */ getPool(ClassType) {
        if (!this._poolsByClass.has(ClassType)) this._poolsByClass.set(ClassType, new (0, $kf88W.Pool)(ClassType));
        return this._poolsByClass.get(ClassType);
    }
    /** gets the usage stats of each pool in the system */ stats() {
        const stats = {};
        this._poolsByClass.forEach((pool)=>{
            const name = stats[pool._classType.name] ? pool._classType.name + pool._classType.ID : pool._classType.name;
            stats[name] = {
                free: pool.totalFree,
                used: pool.totalUsed,
                size: pool.totalSize
            };
        });
        return stats;
    }
}
const $b9097416ff606be2$export$8249372279066210 = new $b9097416ff606be2$export$866836a21808b71c();

});
parcelRegister("kf88W", function(module, exports) {

$parcel$export(module.exports, "Pool", () => $ecc64dc23af17d8f$export$14963ee5c8637e11);
"use strict";
class $ecc64dc23af17d8f$export$14963ee5c8637e11 {
    /**
   * Constructs a new Pool.
   * @param ClassType - The constructor of the items in the pool.
   * @param {number} [initialSize] - The initial size of the pool.
   */ constructor(ClassType, initialSize){
        this._pool = [];
        this._count = 0;
        this._index = 0;
        this._classType = ClassType;
        if (initialSize) this.prepopulate(initialSize);
    }
    /**
   * Prepopulates the pool with a given number of items.
   * @param total - The number of items to add to the pool.
   */ prepopulate(total) {
        for(let i = 0; i < total; i++)this._pool[this._index++] = new this._classType();
        this._count += total;
    }
    /**
   * Gets an item from the pool. Calls the item's `init` method if it exists.
   * If there are no items left in the pool, a new one will be created.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */ get(data) {
        let item;
        if (this._index > 0) item = this._pool[--this._index];
        else item = new this._classType();
        item.init?.(data);
        return item;
    }
    /**
   * Returns an item to the pool. Calls the item's `reset` method if it exists.
   * @param {T} item - The item to return to the pool.
   */ return(item) {
        item.reset?.();
        this._pool[this._index++] = item;
    }
    /**
   * Gets the number of items in the pool.
   * @readonly
   * @member {number}
   */ get totalSize() {
        return this._count;
    }
    /**
   * Gets the number of items in the pool that are free to use without needing to create more.
   * @readonly
   * @member {number}
   */ get totalFree() {
        return this._index;
    }
    /**
   * Gets the number of items in the pool that are currently in use.
   * @readonly
   * @member {number}
   */ get totalUsed() {
        return this._count - this._index;
    }
}

});




parcelRegister("bAxpT", function(module, exports) {

$parcel$export(module.exports, "findMixin", () => $095a0788d10ad896$export$468b0762e1bfbd64);

var $j0fPb = parcelRequire("j0fPb");
"use strict";
const $095a0788d10ad896$export$468b0762e1bfbd64 = {
    /**
   * The instance label of the object.
   * @memberof scene.Container#
   * @member {string} label
   */ label: null,
    /**
   * The instance name of the object.
   * @deprecated since 8.0.0
   * @see scene.Container#label
   * @member {string} name
   * @memberof scene.Container#
   */ get name () {
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "Container.name property has been removed, use Container.label instead");
        return this.label;
    },
    set name (value){
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "Container.name property has been removed, use Container.label instead");
        this.label = value;
    },
    /**
   * @method getChildByName
   * @deprecated since 8.0.0
   * @param {string} name - Instance name.
   * @param {boolean}[deep=false] - Whether to search recursively
   * @returns {Container} The child with the specified name.
   * @see scene.Container#getChildByLabel
   * @memberof scene.Container#
   */ getChildByName (name, deep = false) {
        return this.getChildByLabel(name, deep);
    },
    /**
   * Returns the first child in the container with the specified label.
   *
   * Recursive searches are done in a pre-order traversal.
   * @memberof scene.Container#
   * @param {string|RegExp} label - Instance label.
   * @param {boolean}[deep=false] - Whether to search recursively
   * @returns {Container} The child with the specified label.
   */ getChildByLabel (label, deep = false) {
        const children = this.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.label === label || label instanceof RegExp && label.test(child.label)) return child;
        }
        if (deep) for(let i = 0; i < children.length; i++){
            const child = children[i];
            const found = child.getChildByLabel(label, true);
            if (found) return found;
        }
        return null;
    },
    /**
   * Returns all children in the container with the specified label.
   * @memberof scene.Container#
   * @param {string|RegExp} label - Instance label.
   * @param {boolean}[deep=false] - Whether to search recursively
   * @param {Container[]} [out=[]] - The array to store matching children in.
   * @returns {Container[]} An array of children with the specified label.
   */ getChildrenByLabel (label, deep = false, out = []) {
        const children = this.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.label === label || label instanceof RegExp && label.test(child.label)) out.push(child);
        }
        if (deep) for(let i = 0; i < children.length; i++)children[i].getChildrenByLabel(label, true, out);
        return out;
    }
};

});

parcelRegister("jcDhb", function(module, exports) {

$parcel$export(module.exports, "measureMixin", () => $1b30ce65161b48fb$export$285e6e72e8e62f0);

var $3kR0G = parcelRequire("3kR0G");

var $3vloD = parcelRequire("3vloD");

var $1866D = parcelRequire("1866D");

var $5Vl3K = parcelRequire("5Vl3K");

var $1hhiu = parcelRequire("1hhiu");
"use strict";
const $1b30ce65161b48fb$var$tempMatrix = new (0, $3kR0G.Matrix)();
const $1b30ce65161b48fb$export$285e6e72e8e62f0 = {
    _localBoundsCacheId: -1,
    _localBoundsCacheData: null,
    _setWidth (value, localWidth) {
        const sign = Math.sign(this.scale.x) || 1;
        if (localWidth !== 0) this.scale.x = value / localWidth * sign;
        else this.scale.x = sign;
    },
    _setHeight (value, localHeight) {
        const sign = Math.sign(this.scale.y) || 1;
        if (localHeight !== 0) this.scale.y = value / localHeight * sign;
        else this.scale.y = sign;
    },
    /**
   * Retrieves the local bounds of the container as a Bounds object.
   * @returns - The bounding area.
   * @memberof scene.Container#
   */ getLocalBounds () {
        if (!this._localBoundsCacheData) this._localBoundsCacheData = {
            data: [],
            index: 1,
            didChange: false,
            localBounds: new (0, $3vloD.Bounds)()
        };
        const localBoundsCacheData = this._localBoundsCacheData;
        localBoundsCacheData.index = 1;
        localBoundsCacheData.didChange = false;
        if (localBoundsCacheData.data[0] !== this._didChangeId >> 12) {
            localBoundsCacheData.didChange = true;
            localBoundsCacheData.data[0] = this._didChangeId >> 12;
        }
        (0, $1hhiu.checkChildrenDidChange)(this, localBoundsCacheData);
        if (localBoundsCacheData.didChange) (0, $5Vl3K.getLocalBounds)(this, localBoundsCacheData.localBounds, $1b30ce65161b48fb$var$tempMatrix);
        return localBoundsCacheData.localBounds;
    },
    /**
   * Calculates and returns the (world) bounds of the display object as a [Rectangle]{@link Rectangle}.
   * @param skipUpdate - Setting to `true` will stop the transforms of the scene graph from
   *  being updated. This means the calculation returned MAY be out of date BUT will give you a
   *  nice performance boost.
   * @param bounds - Optional bounds to store the result of the bounds calculation.
   * @returns - The minimum axis-aligned rectangle in world space that fits around this object.
   * @memberof scene.Container#
   */ getBounds (skipUpdate, bounds) {
        return (0, $1866D.getGlobalBounds)(this, skipUpdate, bounds || new (0, $3vloD.Bounds)());
    }
};

});
parcelRegister("3vloD", function(module, exports) {

$parcel$export(module.exports, "Bounds", () => $61e354cf34f4c5db$export$c4e9d269599ab4b4);

var $3kR0G = parcelRequire("3kR0G");

var $hFBUu = parcelRequire("hFBUu");
"use strict";
const $61e354cf34f4c5db$var$defaultMatrix = new (0, $3kR0G.Matrix)();
class $61e354cf34f4c5db$export$c4e9d269599ab4b4 {
    constructor(minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity){
        /** @default Infinity */ this.minX = Infinity;
        /** @default Infinity */ this.minY = Infinity;
        /** @default -Infinity */ this.maxX = -Infinity;
        /** @default -Infinity */ this.maxY = -Infinity;
        this.matrix = $61e354cf34f4c5db$var$defaultMatrix;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Checks if bounds are empty.
   * @returns - True if empty.
   */ isEmpty() {
        return this.minX > this.maxX || this.minY > this.maxY;
    }
    /** The bounding rectangle of the bounds. */ get rectangle() {
        if (!this._rectangle) this._rectangle = new (0, $hFBUu.Rectangle)();
        const rectangle = this._rectangle;
        if (this.minX > this.maxX || this.minY > this.maxY) {
            rectangle.x = 0;
            rectangle.y = 0;
            rectangle.width = 0;
            rectangle.height = 0;
        } else rectangle.copyFromBounds(this);
        return rectangle;
    }
    /** Clears the bounds and resets. */ clear() {
        this.minX = Infinity;
        this.minY = Infinity;
        this.maxX = -Infinity;
        this.maxY = -Infinity;
        this.matrix = $61e354cf34f4c5db$var$defaultMatrix;
        return this;
    }
    /**
   * Sets the bounds.
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   */ set(x0, y0, x1, y1) {
        this.minX = x0;
        this.minY = y0;
        this.maxX = x1;
        this.maxY = y1;
    }
    /**
   * Adds sprite frame
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   * @param matrix
   */ addFrame(x0, y0, x1, y1, matrix) {
        matrix || (matrix = this.matrix);
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        let x = a * x0 + c * y0 + tx;
        let y = b * x0 + d * y0 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x1 + c * y0 + tx;
        y = b * x1 + d * y0 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x0 + c * y1 + tx;
        y = b * x0 + d * y1 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x1 + c * y1 + tx;
        y = b * x1 + d * y1 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Adds a rectangle to the bounds.
   * @param rect - The rectangle to be added.
   * @param matrix - The matrix to apply to the bounds.
   */ addRect(rect, matrix) {
        this.addFrame(rect.x, rect.y, rect.x + rect.width, rect.y + rect.height, matrix);
    }
    /**
   * Adds other {@link Bounds}.
   * @param bounds - The Bounds to be added
   * @param matrix
   */ addBounds(bounds, matrix) {
        this.addFrame(bounds.minX, bounds.minY, bounds.maxX, bounds.maxY, matrix);
    }
    /**
   * Adds other Bounds, masked with Bounds.
   * @param mask - The Bounds to be added.
   */ addBoundsMask(mask) {
        this.minX = this.minX > mask.minX ? this.minX : mask.minX;
        this.minY = this.minY > mask.minY ? this.minY : mask.minY;
        this.maxX = this.maxX < mask.maxX ? this.maxX : mask.maxX;
        this.maxY = this.maxY < mask.maxY ? this.maxY : mask.maxY;
    }
    /**
   * Adds other Bounds, multiplied with matrix.
   * @param matrix - The matrix to apply to the bounds.
   */ applyMatrix(matrix) {
        const minX = this.minX;
        const minY = this.minY;
        const maxX = this.maxX;
        const maxY = this.maxY;
        const { a: a, b: b, c: c, d: d, tx: tx, ty: ty } = matrix;
        let x = a * minX + c * minY + tx;
        let y = b * minX + d * minY + ty;
        this.minX = x;
        this.minY = y;
        this.maxX = x;
        this.maxY = y;
        x = a * maxX + c * minY + tx;
        y = b * maxX + d * minY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
        x = a * minX + c * maxY + tx;
        y = b * minX + d * maxY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
        x = a * maxX + c * maxY + tx;
        y = b * maxX + d * maxY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
    }
    /**
   * Resizes the bounds object to include the given rectangle.
   * @param rect - The rectangle to be included.
   */ fit(rect) {
        if (this.minX < rect.left) this.minX = rect.left;
        if (this.maxX > rect.right) this.maxX = rect.right;
        if (this.minY < rect.top) this.minY = rect.top;
        if (this.maxY > rect.bottom) this.maxY = rect.bottom;
        return this;
    }
    /**
   * Resizes the bounds object to include the given bounds.
   * @param left - The left value of the bounds.
   * @param right - The right value of the bounds.
   * @param top - The top value of the bounds.
   * @param bottom - The bottom value of the bounds.
   */ fitBounds(left, right, top, bottom) {
        if (this.minX < left) this.minX = left;
        if (this.maxX > right) this.maxX = right;
        if (this.minY < top) this.minY = top;
        if (this.maxY > bottom) this.maxY = bottom;
        return this;
    }
    /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   */ pad(paddingX, paddingY = paddingX) {
        this.minX -= paddingX;
        this.maxX += paddingX;
        this.minY -= paddingY;
        this.maxY += paddingY;
        return this;
    }
    /** Ceils the bounds. */ ceil() {
        this.minX = Math.floor(this.minX);
        this.minY = Math.floor(this.minY);
        this.maxX = Math.ceil(this.maxX);
        this.maxY = Math.ceil(this.maxY);
        return this;
    }
    /** Clones the bounds. */ clone() {
        return new $61e354cf34f4c5db$export$c4e9d269599ab4b4(this.minX, this.minY, this.maxX, this.maxY);
    }
    /**
   * Scales the bounds by the given values
   * @param x - The X value to scale by.
   * @param y - The Y value to scale by.
   */ scale(x, y = x) {
        this.minX *= x;
        this.minY *= y;
        this.maxX *= x;
        this.maxY *= y;
        return this;
    }
    /** the x value of the bounds. */ get x() {
        return this.minX;
    }
    set x(value) {
        const width = this.maxX - this.minX;
        this.minX = value;
        this.maxX = value + width;
    }
    /** the y value of the bounds. */ get y() {
        return this.minY;
    }
    set y(value) {
        const height = this.maxY - this.minY;
        this.minY = value;
        this.maxY = value + height;
    }
    /** the width value of the bounds. */ get width() {
        return this.maxX - this.minX;
    }
    set width(value) {
        this.maxX = this.minX + value;
    }
    /** the height value of the bounds. */ get height() {
        return this.maxY - this.minY;
    }
    set height(value) {
        this.maxY = this.minY + value;
    }
    /** the left value of the bounds. */ get left() {
        return this.minX;
    }
    /** the right value of the bounds. */ get right() {
        return this.maxX;
    }
    /** the top value of the bounds. */ get top() {
        return this.minY;
    }
    /** the bottom value of the bounds. */ get bottom() {
        return this.maxY;
    }
    /** Is the bounds positive. */ get isPositive() {
        return this.maxX - this.minX > 0 && this.maxY - this.minY > 0;
    }
    get isValid() {
        return this.minX + this.minY !== Infinity;
    }
    /**
   * Adds screen vertices from array
   * @param vertexData - calculated vertices
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   * @param matrix
   */ addVertexData(vertexData, beginOffset, endOffset, matrix) {
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        matrix || (matrix = this.matrix);
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        for(let i = beginOffset; i < endOffset; i += 2){
            const localX = vertexData[i];
            const localY = vertexData[i + 1];
            const x = a * localX + c * localY + tx;
            const y = b * localX + d * localY + ty;
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Checks if the point is contained within the bounds.
   * @param x - x coordinate
   * @param y - y coordinate
   */ containsPoint(x, y) {
        if (this.minX <= x && this.minY <= y && this.maxX >= x && this.maxY >= y) return true;
        return false;
    }
    toString() {
        return `[pixi.js:Bounds minX=${this.minX} minY=${this.minY} maxX=${this.maxX} maxY=${this.maxY} width=${this.width} height=${this.height}]`;
    }
}

});

parcelRegister("1866D", function(module, exports) {

$parcel$export(module.exports, "getGlobalBounds", () => $538083d64a4aac22$export$f4412a6981d97baa);
$parcel$export(module.exports, "updateTransformBackwards", () => $538083d64a4aac22$export$2022bc48a49dd6d2);

var $3kR0G = parcelRequire("3kR0G");

var $6s37R = parcelRequire("6s37R");
"use strict";
function $538083d64a4aac22$export$f4412a6981d97baa(target, skipUpdateTransform, bounds) {
    bounds.clear();
    let parentTransform;
    let pooledMatrix;
    if (target.parent) {
        if (!skipUpdateTransform) {
            pooledMatrix = (0, $6s37R.matrixPool).get().identity();
            parentTransform = $538083d64a4aac22$export$2022bc48a49dd6d2(target, pooledMatrix);
        } else parentTransform = target.parent.worldTransform;
    } else parentTransform = (0, $3kR0G.Matrix).IDENTITY;
    $538083d64a4aac22$export$ca70956e64971628(target, bounds, parentTransform, skipUpdateTransform);
    if (pooledMatrix) (0, $6s37R.matrixPool).return(pooledMatrix);
    if (!bounds.isValid) bounds.set(0, 0, 0, 0);
    return bounds;
}
function $538083d64a4aac22$export$ca70956e64971628(target, bounds, parentTransform, skipUpdateTransform) {
    if (!target.visible || !target.measurable) return;
    let worldTransform;
    if (!skipUpdateTransform) {
        target.updateLocalTransform();
        worldTransform = (0, $6s37R.matrixPool).get();
        worldTransform.appendFrom(target.localTransform, parentTransform);
    } else worldTransform = target.worldTransform;
    const parentBounds = bounds;
    const preserveBounds = !!target.effects.length;
    if (preserveBounds) bounds = (0, $6s37R.boundsPool).get().clear();
    if (target.boundsArea) bounds.addRect(target.boundsArea, worldTransform);
    else {
        if (target.addBounds) {
            bounds.matrix = worldTransform;
            target.addBounds(bounds);
        }
        for(let i = 0; i < target.children.length; i++)$538083d64a4aac22$export$ca70956e64971628(target.children[i], bounds, worldTransform, skipUpdateTransform);
    }
    if (preserveBounds) {
        for(let i = 0; i < target.effects.length; i++)target.effects[i].addBounds?.(bounds);
        parentBounds.addBounds(bounds, (0, $3kR0G.Matrix).IDENTITY);
        (0, $6s37R.boundsPool).return(bounds);
    }
    if (!skipUpdateTransform) (0, $6s37R.matrixPool).return(worldTransform);
}
function $538083d64a4aac22$export$2022bc48a49dd6d2(target, parentTransform) {
    const parent = target.parent;
    if (parent) {
        $538083d64a4aac22$export$2022bc48a49dd6d2(parent, parentTransform);
        parent.updateLocalTransform();
        parentTransform.append(parent.localTransform);
    }
    return parentTransform;
}

});
parcelRegister("6s37R", function(module, exports) {

$parcel$export(module.exports, "matrixPool", () => $c439ac49e883b9d2$export$3849005ba4dacf72);
$parcel$export(module.exports, "boundsPool", () => $c439ac49e883b9d2$export$9194656040c1dc42);

var $3kR0G = parcelRequire("3kR0G");

var $kf88W = parcelRequire("kf88W");

var $3vloD = parcelRequire("3vloD");
"use strict";
const $c439ac49e883b9d2$export$3849005ba4dacf72 = new (0, $kf88W.Pool)((0, $3kR0G.Matrix));
const $c439ac49e883b9d2$export$9194656040c1dc42 = new (0, $kf88W.Pool)((0, $3vloD.Bounds));

});


parcelRegister("5Vl3K", function(module, exports) {

$parcel$export(module.exports, "getLocalBounds", () => $b11e5fea5e78d284$export$ffaf4f504c4c5c9c);

var $3kR0G = parcelRequire("3kR0G");

var $1q6Bk = parcelRequire("1q6Bk");

var $6s37R = parcelRequire("6s37R");
"use strict";
function $b11e5fea5e78d284$export$ffaf4f504c4c5c9c(target, bounds, relativeMatrix) {
    bounds.clear();
    relativeMatrix || (relativeMatrix = (0, $3kR0G.Matrix).IDENTITY);
    $b11e5fea5e78d284$var$_getLocalBounds(target, bounds, relativeMatrix, target, true);
    if (!bounds.isValid) bounds.set(0, 0, 0, 0);
    return bounds;
}
function $b11e5fea5e78d284$var$_getLocalBounds(target, bounds, parentTransform, rootContainer, isRoot) {
    let relativeTransform;
    if (!isRoot) {
        if (!target.visible || !target.measurable) return;
        target.updateLocalTransform();
        const localTransform = target.localTransform;
        relativeTransform = (0, $6s37R.matrixPool).get();
        relativeTransform.appendFrom(localTransform, parentTransform);
    } else {
        relativeTransform = (0, $6s37R.matrixPool).get();
        relativeTransform = parentTransform.copyTo(relativeTransform);
    }
    const parentBounds = bounds;
    const preserveBounds = !!target.effects.length;
    if (preserveBounds) bounds = (0, $6s37R.boundsPool).get().clear();
    if (target.boundsArea) bounds.addRect(target.boundsArea, relativeTransform);
    else {
        if (target.renderPipeId) {
            bounds.matrix = relativeTransform;
            target.addBounds(bounds);
        }
        const children = target.children;
        for(let i = 0; i < children.length; i++)$b11e5fea5e78d284$var$_getLocalBounds(children[i], bounds, relativeTransform, rootContainer, false);
    }
    if (preserveBounds) {
        for(let i = 0; i < target.effects.length; i++)target.effects[i].addLocalBounds?.(bounds, rootContainer);
        parentBounds.addBounds(bounds, (0, $3kR0G.Matrix).IDENTITY);
        (0, $6s37R.boundsPool).return(bounds);
    }
    (0, $6s37R.matrixPool).return(relativeTransform);
}
function $b11e5fea5e78d284$export$58081aedf094d85b(target, root, matrix) {
    const parent = target.parent;
    if (!parent) {
        (0, $1q6Bk.warn)("Item is not inside the root container");
        return;
    }
    if (parent !== root) {
        $b11e5fea5e78d284$export$58081aedf094d85b(parent, root, matrix);
        parent.updateLocalTransform();
        matrix.append(parent.localTransform);
    }
}

});
parcelRegister("1q6Bk", function(module, exports) {

$parcel$export(module.exports, "warn", () => $97eb27926294e5e8$export$c106dd0671a0fc2d);
"use strict";
let $97eb27926294e5e8$var$warnCount = 0;
const $97eb27926294e5e8$var$maxWarnings = 500;
function $97eb27926294e5e8$export$c106dd0671a0fc2d(...args) {
    if ($97eb27926294e5e8$var$warnCount === $97eb27926294e5e8$var$maxWarnings) return;
    $97eb27926294e5e8$var$warnCount++;
    if ($97eb27926294e5e8$var$warnCount === $97eb27926294e5e8$var$maxWarnings) console.warn("PixiJS Warning: too many warnings, no more warnings will be reported to the console by PixiJS.");
    else console.warn("PixiJS Warning: ", ...args);
}

});


parcelRegister("1hhiu", function(module, exports) {

$parcel$export(module.exports, "checkChildrenDidChange", () => $c2fd43df2b747c5d$export$fd5aadbd3827bcf1);
"use strict";
function $c2fd43df2b747c5d$export$fd5aadbd3827bcf1(container, previousData) {
    const children = container.children;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        const changeId = (child.uid & 255) << 24 | child._didChangeId & 16777215;
        if (previousData.data[previousData.index] !== changeId) {
            previousData.data[previousData.index] = changeId;
            previousData.didChange = true;
        }
        previousData.index++;
        if (child.children.length) $c2fd43df2b747c5d$export$fd5aadbd3827bcf1(child, previousData);
    }
    return previousData.didChange;
}

});


parcelRegister("eHXIU", function(module, exports) {

$parcel$export(module.exports, "onRenderMixin", () => $d2aaf9aea2058770$export$2a5246d1114cb81d);
"use strict";
const $d2aaf9aea2058770$export$2a5246d1114cb81d = {
    _onRender: null,
    set onRender (func){
        const renderGroup = this.renderGroup;
        if (!func) {
            if (this._onRender) renderGroup?.removeOnRender(this);
            this._onRender = null;
            return;
        }
        if (!this._onRender) renderGroup?.addOnRender(this);
        this._onRender = func;
    },
    /**
   * This callback is used when the container is rendered. This is where you should add your custom
   * logic that is needed to be run every frame.
   *
   * In v7 many users used `updateTransform` for this, however the way v8 renders objects is different
   * and "updateTransform" is no longer called every frame
   * @example
   * const container = new Container();
   * container.onRender = () => {
   *    container.rotation += 0.01;
   * };
   * @memberof scene.Container#
   */ get onRender () {
        return this._onRender;
    }
};

});

parcelRegister("1gQ49", function(module, exports) {

$parcel$export(module.exports, "sortMixin", () => $7dee3d5e3c4cb965$export$eb4acdd9f4781aed);
"use strict";
const $7dee3d5e3c4cb965$export$eb4acdd9f4781aed = {
    _zIndex: 0,
    /**
   * Should children be sorted by zIndex at the next render call.
   *
   * Will get automatically set to true if a new child is added, or if a child's zIndex changes.
   * @type {boolean}
   * @memberof scene.Container#
   */ sortDirty: false,
    /**
   * If set to true, the container will sort its children by `zIndex` value
   * when the next render is called, or manually if `sortChildren()` is called.
   *
   * This actually changes the order of elements in the array, so should be treated
   * as a basic solution that is not performant compared to other solutions,
   * such as {@link https://github.com/pixijs/layers PixiJS Layers}
   *
   * Also be aware of that this may not work nicely with the `addChildAt()` function,
   * as the `zIndex` sorting may cause the child to automatically sorted to another position.
   * @type {boolean}
   * @memberof scene.Container#
   */ sortableChildren: false,
    /**
   * The zIndex of the container.
   *
   * Setting this value, will automatically set the parent to be sortable. Children will be automatically
   * sorted by zIndex value; a higher value will mean it will be moved towards the end of the array,
   * and thus rendered on top of other display objects within the same container.
   * @see scene.Container#sortableChildren
   * @memberof scene.Container#
   */ get zIndex () {
        return this._zIndex;
    },
    set zIndex (value){
        if (this._zIndex === value) return;
        this._zIndex = value;
        this.depthOfChildModified();
    },
    depthOfChildModified () {
        if (this.parent) {
            this.parent.sortableChildren = true;
            this.parent.sortDirty = true;
        }
        if (this.renderGroup && !this.isRenderGroupRoot) this.renderGroup.structureDidChange = true;
    },
    /**
   * Sorts children by zIndex.
   * @memberof scene.Container#
   */ sortChildren () {
        if (!this.sortDirty) return;
        this.sortDirty = false;
        this.children.sort($7dee3d5e3c4cb965$var$sortChildren);
    }
};
function $7dee3d5e3c4cb965$var$sortChildren(a, b) {
    return a._zIndex - b._zIndex;
}

});

parcelRegister("iOqZ3", function(module, exports) {

$parcel$export(module.exports, "toLocalGlobalMixin", () => $4c17d9bea5f4d6a9$export$38fa7a987602e8dd);

var $3kR0G = parcelRequire("3kR0G");

var $bwMhC = parcelRequire("bwMhC");

var $1866D = parcelRequire("1866D");
"use strict";
const $4c17d9bea5f4d6a9$export$38fa7a987602e8dd = {
    /**
   * Returns the global position of the container.
   * @param point - The optional point to write the global value to.
   * @param skipUpdate - Should we skip the update transform.
   * @returns - The updated point.
   * @memberof scene.Container#
   */ getGlobalPosition (point = new (0, $bwMhC.Point)(), skipUpdate = false) {
        if (this.parent) this.parent.toGlobal(this._position, point, skipUpdate);
        else {
            point.x = this._position.x;
            point.y = this._position.y;
        }
        return point;
    },
    /**
   * Calculates the global position of the container.
   * @param position - The world origin to calculate from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform.
   * @returns - A point object representing the position of this object.
   * @memberof scene.Container#
   */ toGlobal (position, point, skipUpdate = false) {
        if (!skipUpdate) {
            this.updateLocalTransform();
            const globalMatrix = (0, $1866D.updateTransformBackwards)(this, new (0, $3kR0G.Matrix)());
            globalMatrix.append(this.localTransform);
            return globalMatrix.apply(position, point);
        }
        return this.worldTransform.apply(position, point);
    },
    /**
   * Calculates the local position of the container relative to another point.
   * @param position - The world origin to calculate from.
   * @param from - The Container to calculate the global position from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform
   * @returns - A point object representing the position of this object
   * @memberof scene.Container#
   */ toLocal (position, from, point, skipUpdate) {
        if (from) position = from.toGlobal(position, point, skipUpdate);
        if (!skipUpdate) {
            this.updateLocalTransform();
            const globalMatrix = (0, $1866D.updateTransformBackwards)(this, new (0, $3kR0G.Matrix)());
            globalMatrix.append(this.localTransform);
            return globalMatrix.applyInverse(position, point);
        }
        return this.worldTransform.applyInverse(position, point);
    }
};

});

parcelRegister("j4LQZ", function(module, exports) {

$parcel$export(module.exports, "RenderGroup", () => $be5c3cd254c919dc$export$94d273f8d74f2a5);

var $3kR0G = parcelRequire("3kR0G");

var $5GFMM = parcelRequire("5GFMM");
"use strict";
class $be5c3cd254c919dc$export$94d273f8d74f2a5 {
    constructor(root){
        this.renderPipeId = "renderGroup";
        this.root = null;
        this.canBundle = false;
        this.renderGroupParent = null;
        this.renderGroupChildren = [];
        this._children = [];
        this.worldTransform = new (0, $3kR0G.Matrix)();
        this.worldColorAlpha = 4294967295;
        this.worldColor = 16777215;
        this.worldAlpha = 1;
        // these updates are transform changes..
        this.childrenToUpdate = /* @__PURE__ */ Object.create(null);
        this.updateTick = 0;
        // these update are renderable changes..
        this.childrenRenderablesToUpdate = {
            list: [],
            index: 0
        };
        // other
        this.structureDidChange = true;
        this.instructionSet = new (0, $5GFMM.InstructionSet)();
        this._onRenderContainers = [];
        this.root = root;
        this.addChild(root);
    }
    get localTransform() {
        return this.root.localTransform;
    }
    addRenderGroupChild(renderGroupChild) {
        if (renderGroupChild.renderGroupParent) renderGroupChild.renderGroupParent._removeRenderGroupChild(renderGroupChild);
        renderGroupChild.renderGroupParent = this;
        this.onChildUpdate(renderGroupChild.root);
        this.renderGroupChildren.push(renderGroupChild);
    }
    _removeRenderGroupChild(renderGroupChild) {
        if (renderGroupChild.root.didChange) this._removeChildFromUpdate(renderGroupChild.root);
        const index = this.renderGroupChildren.indexOf(renderGroupChild);
        if (index > -1) this.renderGroupChildren.splice(index, 1);
        renderGroupChild.renderGroupParent = null;
    }
    addChild(child) {
        this.structureDidChange = true;
        if (child !== this.root) {
            this._children.push(child);
            child.updateTick = -1;
            if (child.parent === this.root) child.relativeRenderGroupDepth = 1;
            else child.relativeRenderGroupDepth = child.parent.relativeRenderGroupDepth + 1;
        }
        if (child.renderGroup) {
            if (child.renderGroup.root === child) {
                this.addRenderGroupChild(child.renderGroup);
                return;
            }
        } else {
            child.renderGroup = this;
            child.didChange = true;
        }
        if (child._onRender) {
            if (!child.isRenderGroupRoot) this.addOnRender(child);
            else if (child.renderGroup.root === child) this.addOnRender(child);
        }
        const children = child.children;
        if (!child.isRenderGroupRoot) this.onChildUpdate(child);
        for(let i = 0; i < children.length; i++)this.addChild(children[i]);
    }
    removeChild(child) {
        this.structureDidChange = true;
        if (child._onRender) {
            if (!child.isRenderGroupRoot) this.removeOnRender(child);
            else if (child.renderGroup.root === child) this.removeOnRender(child);
        }
        if (child.renderGroup.root !== child) {
            const children = child.children;
            for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
            if (child.didChange) child.renderGroup._removeChildFromUpdate(child);
            child.renderGroup = null;
        } else this._removeRenderGroupChild(child.renderGroup);
        const index = this._children.indexOf(child);
        if (index > -1) this._children.splice(index, 1);
    }
    onChildUpdate(child) {
        let childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth];
        if (!childrenToUpdate) childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth] = {
            index: 0,
            list: []
        };
        childrenToUpdate.list[childrenToUpdate.index++] = child;
    }
    // SHOULD THIS BE HERE?
    updateRenderable(container) {
        if (container.globalDisplayStatus < 7) return;
        container.didViewUpdate = false;
        this.instructionSet.renderPipes[container.renderPipeId].updateRenderable(container);
    }
    onChildViewUpdate(child) {
        this.childrenRenderablesToUpdate.list[this.childrenRenderablesToUpdate.index++] = child;
    }
    _removeChildFromUpdate(child) {
        const childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth];
        if (!childrenToUpdate) return;
        const index = childrenToUpdate.list.indexOf(child);
        if (index > -1) childrenToUpdate.list.splice(index, 1);
        childrenToUpdate.index--;
    }
    get isRenderable() {
        return this.root.localDisplayStatus === 7 && this.worldAlpha > 0;
    }
    /**
   * adding a container to the onRender list will make sure the user function
   * passed in to the user defined 'onRender` callBack
   * @param container - the container to add to the onRender list
   */ addOnRender(container) {
        this._onRenderContainers.push(container);
    }
    removeOnRender(container) {
        this._onRenderContainers.splice(this._onRenderContainers.indexOf(container), 1);
    }
    runOnRender() {
        for(let i = 0; i < this._onRenderContainers.length; i++)this._onRenderContainers[i]._onRender();
    }
}

});
parcelRegister("5GFMM", function(module, exports) {

$parcel$export(module.exports, "InstructionSet", () => $3e93bd5385f84a10$export$2946bd01f10dd922);

var $by5BM = parcelRequire("by5BM");
"use strict";
class $3e93bd5385f84a10$export$2946bd01f10dd922 {
    constructor(){
        /** a unique id for this instruction set used through the renderer */ this.uid = (0, $by5BM.uid)("instructionSet");
        /** the array of instructions */ this.instructions = [];
        /** the actual size of the array (any instructions passed this should be ignored) */ this.instructionSize = 0;
    }
    /** reset the instruction set so it can be reused set size back to 0 */ reset() {
        this.instructionSize = 0;
    }
    /**
   * Add an instruction to the set
   * @param instruction - add an instruction to the set
   */ add(instruction) {
        this.instructions[this.instructionSize++] = instruction;
    }
    /**
   * Log the instructions to the console (for debugging)
   * @internal
   * @ignore
   */ log() {
        this.instructions.length = this.instructionSize;
        console.table(this.instructions, [
            "type",
            "action"
        ]);
    }
}

});


parcelRegister("1HWH3", function(module, exports) {

$parcel$export(module.exports, "assignWithIgnore", () => $7c8a4f29cc1f8f4d$export$59d0441a278e5935);
"use strict";
function $7c8a4f29cc1f8f4d$export$59d0441a278e5935(target, options, ignore = {}) {
    for(const key in options)if (!ignore[key] && options[key] !== void 0) target[key] = options[key];
}

});



parcelRegister("fxPhW", function(module, exports) {

$parcel$export(module.exports, "addMaskBounds", () => $53218aaf70cf662c$export$12af48852c6ac574);

var $3vloD = parcelRequire("3vloD");

var $1866D = parcelRequire("1866D");
"use strict";
const $53218aaf70cf662c$var$tempBounds = new (0, $3vloD.Bounds)();
function $53218aaf70cf662c$export$12af48852c6ac574(mask, bounds, skipUpdateTransform) {
    const boundsToMask = $53218aaf70cf662c$var$tempBounds;
    mask.measurable = true;
    (0, $1866D.getGlobalBounds)(mask, skipUpdateTransform, boundsToMask);
    bounds.addBoundsMask(boundsToMask);
    mask.measurable = false;
}

});

parcelRegister("hH44q", function(module, exports) {

$parcel$export(module.exports, "addMaskLocalBounds", () => $6def52987b2a928f$export$7416ac774b1f1a33);

var $5Vl3K = parcelRequire("5Vl3K");

var $6s37R = parcelRequire("6s37R");

var $1q6Bk = parcelRequire("1q6Bk");
"use strict";
function $6def52987b2a928f$export$7416ac774b1f1a33(mask, bounds, localRoot) {
    const boundsToMask = (0, $6s37R.boundsPool).get();
    mask.measurable = true;
    const tempMatrix = (0, $6s37R.matrixPool).get().identity();
    const relativeMask = $6def52987b2a928f$export$1536bde1a0bf3cb9(mask, localRoot, tempMatrix);
    (0, $5Vl3K.getLocalBounds)(mask, boundsToMask, relativeMask);
    mask.measurable = false;
    bounds.addBoundsMask(boundsToMask);
    (0, $6s37R.matrixPool).return(tempMatrix);
    (0, $6s37R.boundsPool).return(boundsToMask);
}
function $6def52987b2a928f$export$1536bde1a0bf3cb9(target, root, matrix) {
    if (!target) {
        (0, $1q6Bk.warn)("Mask bounds, renderable is not inside the root container");
        return matrix;
    }
    if (target !== root) {
        $6def52987b2a928f$export$1536bde1a0bf3cb9(target.parent, root, matrix);
        target.updateLocalTransform();
        matrix.append(target.localTransform);
    }
    return matrix;
}

});


parcelRegister("iGUYs", function(module, exports) {

$parcel$export(module.exports, "ColorMask", () => $7bbaa62bc1abcbe0$export$1e2a2c76374c2542);

var $aqljF = parcelRequire("aqljF");
"use strict";
class $7bbaa62bc1abcbe0$export$1e2a2c76374c2542 {
    constructor(options){
        this.priority = 0;
        this.pipe = "colorMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
    }
    destroy() {}
    static test(mask) {
        return typeof mask === "number";
    }
}
$7bbaa62bc1abcbe0$export$1e2a2c76374c2542.extension = (0, $aqljF.ExtensionType).MaskEffect;

});

parcelRegister("63hmg", function(module, exports) {

$parcel$export(module.exports, "StencilMask", () => $f4f06382199b8ae2$export$abd85894695764cb);

var $aqljF = parcelRequire("aqljF");

var $e0Ilp = parcelRequire("e0Ilp");

var $fxPhW = parcelRequire("fxPhW");

var $hH44q = parcelRequire("hH44q");
"use strict";
class $f4f06382199b8ae2$export$abd85894695764cb {
    constructor(options){
        this.priority = 0;
        this.pipe = "stencilMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
        this.mask.includeInBuild = false;
        this.mask.measurable = false;
    }
    reset() {
        this.mask.measurable = true;
        this.mask.includeInBuild = true;
        this.mask = null;
    }
    addBounds(bounds, skipUpdateTransform) {
        (0, $fxPhW.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $hH44q.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    destroy() {
        this.reset();
    }
    static test(mask) {
        return mask instanceof (0, $e0Ilp.Container);
    }
}
$f4f06382199b8ae2$export$abd85894695764cb.extension = (0, $aqljF.ExtensionType).MaskEffect;

});

parcelRegister("keToW", function(module, exports) {

$parcel$export(module.exports, "CanvasSource", () => $644eb8060e5cdf42$export$ca65ccf5708c6a0c);

var $2NruG = parcelRequire("2NruG");

var $aqljF = parcelRequire("aqljF");

var $eIuJW = parcelRequire("eIuJW");
"use strict";
class $644eb8060e5cdf42$export$ca65ccf5708c6a0c extends (0, $eIuJW.TextureSource) {
    constructor(options){
        if (!options.resource) options.resource = (0, $2NruG.DOMAdapter).get().createCanvas();
        if (!options.width) {
            options.width = options.resource.width;
            if (!options.autoDensity) options.width /= options.resolution;
        }
        if (!options.height) {
            options.height = options.resource.height;
            if (!options.autoDensity) options.height /= options.resolution;
        }
        super(options);
        this.uploadMethodId = "image";
        this.autoDensity = options.autoDensity;
        const canvas = options.resource;
        if (this.pixelWidth !== canvas.width || this.pixelWidth !== canvas.height) this.resizeCanvas();
        this.transparent = !!options.transparent;
    }
    resizeCanvas() {
        if (this.autoDensity) {
            this.resource.style.width = `${this.width}px`;
            this.resource.style.height = `${this.height}px`;
        }
        if (this.resource.width !== this.pixelWidth || this.resource.height !== this.pixelHeight) {
            this.resource.width = this.pixelWidth;
            this.resource.height = this.pixelHeight;
        }
    }
    resize(width = this.width, height = this.height, resolution = this._resolution) {
        const didResize = super.resize(width, height, resolution);
        if (didResize) this.resizeCanvas();
        return didResize;
    }
    static test(resource) {
        return globalThis.HTMLCanvasElement && resource instanceof HTMLCanvasElement || globalThis.OffscreenCanvas && resource instanceof OffscreenCanvas;
    }
}
$644eb8060e5cdf42$export$ca65ccf5708c6a0c.extension = (0, $aqljF.ExtensionType).TextureSource;

});
parcelRegister("2NruG", function(module, exports) {

$parcel$export(module.exports, "DOMAdapter", () => $7eb9454d10c41f16$export$d988306fa84f7b44);

var $1kU5V = parcelRequire("1kU5V");
"use strict";
let $7eb9454d10c41f16$var$currentAdapter = (0, $1kU5V.BrowserAdapter);
const $7eb9454d10c41f16$export$d988306fa84f7b44 = {
    /**
   * Returns the current adapter.
   * @returns {environment.Adapter} The current adapter.
   */ get () {
        return $7eb9454d10c41f16$var$currentAdapter;
    },
    /**
   * Sets the current adapter.
   * @param adapter - The new adapter.
   */ set (adapter) {
        $7eb9454d10c41f16$var$currentAdapter = adapter;
    }
};

});
parcelRegister("1kU5V", function(module, exports) {

$parcel$export(module.exports, "BrowserAdapter", () => $a252e2e09508a884$export$e467cc3399500025);
"use strict";
const $a252e2e09508a884$export$e467cc3399500025 = {
    createCanvas: (width, height)=>{
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    },
    getCanvasRenderingContext2D: ()=>CanvasRenderingContext2D,
    getWebGLRenderingContext: ()=>WebGLRenderingContext,
    getNavigator: ()=>navigator,
    getBaseUrl: ()=>document.baseURI ?? window.location.href,
    getFontFaceSet: ()=>document.fonts,
    fetch: (url, options)=>fetch(url, options),
    parseXML: (xml)=>{
        const parser = new DOMParser();
        return parser.parseFromString(xml, "text/xml");
    }
};

});



parcelRegister("5yirD", function(module, exports) {

$parcel$export(module.exports, "ImageSource", () => $d290cf757d9a8ea6$export$280e9a68c3ffd919);

var $2NruG = parcelRequire("2NruG");

var $aqljF = parcelRequire("aqljF");

var $1q6Bk = parcelRequire("1q6Bk");

var $eIuJW = parcelRequire("eIuJW");
"use strict";
class $d290cf757d9a8ea6$export$280e9a68c3ffd919 extends (0, $eIuJW.TextureSource) {
    constructor(options){
        if (options.resource && globalThis.HTMLImageElement && options.resource instanceof HTMLImageElement) {
            const canvas = (0, $2NruG.DOMAdapter).get().createCanvas(options.resource.width, options.resource.height);
            const context = canvas.getContext("2d");
            context.drawImage(options.resource, 0, 0);
            options.resource = canvas;
            (0, $1q6Bk.warn)("ImageSource: Image element passed, converting to canvas. Use CanvasSource instead.");
        }
        super(options);
        this.uploadMethodId = "image";
        this.autoGarbageCollect = true;
    }
    static test(resource) {
        return globalThis.HTMLImageElement && resource instanceof HTMLImageElement || typeof ImageBitmap !== "undefined" && resource instanceof ImageBitmap;
    }
}
$d290cf757d9a8ea6$export$280e9a68c3ffd919.extension = (0, $aqljF.ExtensionType).TextureSource;

});

parcelRegister("9yTSr", function(module, exports) {

$parcel$export(module.exports, "VideoSource", () => $eed3fbe8e44bbb1b$export$f3a17123d80000c5);

var $aqljF = parcelRequire("aqljF");

var $4CJdx = parcelRequire("4CJdx");

var $6SWkW = parcelRequire("6SWkW");

var $eIuJW = parcelRequire("eIuJW");
"use strict";
const $eed3fbe8e44bbb1b$var$_VideoSource = class _VideoSource extends (0, $eIuJW.TextureSource) {
    constructor(options){
        super(options);
        // Public
        /** Whether or not the video is ready to play. */ this.isReady = false;
        /** The upload method for this texture. */ this.uploadMethodId = "video";
        options = {
            ..._VideoSource.defaultOptions,
            ...options
        };
        this._autoUpdate = true;
        this._isConnectedToTicker = false;
        this._updateFPS = options.updateFPS || 0;
        this._msToNextUpdate = 0;
        this.autoPlay = options.autoPlay !== false;
        this.alphaMode = options.alphaMode ?? "premultiply-alpha-on-upload";
        this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this);
        this._videoFrameRequestCallbackHandle = null;
        this._load = null;
        this._resolve = null;
        this._reject = null;
        this._onCanPlay = this._onCanPlay.bind(this);
        this._onCanPlayThrough = this._onCanPlayThrough.bind(this);
        this._onError = this._onError.bind(this);
        this._onPlayStart = this._onPlayStart.bind(this);
        this._onPlayStop = this._onPlayStop.bind(this);
        this._onSeeked = this._onSeeked.bind(this);
        if (options.autoLoad !== false) this.load();
    }
    /** Update the video frame if the source is not destroyed and meets certain conditions. */ updateFrame() {
        if (this.destroyed) return;
        if (this._updateFPS) {
            const elapsedMS = (0, $4CJdx.Ticker).shared.elapsedMS * this.resource.playbackRate;
            this._msToNextUpdate = Math.floor(this._msToNextUpdate - elapsedMS);
        }
        if (!this._updateFPS || this._msToNextUpdate <= 0) this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0;
        if (this.isValid) this.update();
    }
    /** Callback to update the video frame and potentially request the next frame update. */ _videoFrameRequestCallback() {
        this.updateFrame();
        if (this.destroyed) this._videoFrameRequestCallbackHandle = null;
        else this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(this._videoFrameRequestCallback);
    }
    /**
   * Checks if the resource has valid dimensions.
   * @returns {boolean} True if width and height are set, otherwise false.
   */ get isValid() {
        return !!this.resource.videoWidth && !!this.resource.videoHeight;
    }
    /**
   * Start preloading the video resource.
   * @returns {Promise<this>} Handle the validate event
   */ async load() {
        if (this._load) return this._load;
        const source = this.resource;
        const options = this.options;
        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) source.complete = true;
        source.addEventListener("play", this._onPlayStart);
        source.addEventListener("pause", this._onPlayStop);
        source.addEventListener("seeked", this._onSeeked);
        if (!this._isSourceReady()) {
            if (!options.preload) source.addEventListener("canplay", this._onCanPlay);
            source.addEventListener("canplaythrough", this._onCanPlayThrough);
            source.addEventListener("error", this._onError, true);
        } else this._mediaReady();
        this.alphaMode = await (0, $6SWkW.detectVideoAlphaMode)();
        this._load = new Promise((resolve, reject)=>{
            if (this.isValid) resolve(this);
            else {
                this._resolve = resolve;
                this._reject = reject;
                if (options.preloadTimeoutMs !== void 0) this._preloadTimeout = setTimeout(()=>{
                    this._onError(new ErrorEvent(`Preload exceeded timeout of ${options.preloadTimeoutMs}ms`));
                });
                source.load();
            }
        });
        return this._load;
    }
    /**
   * Handle video error events.
   * @param event - The error event
   */ _onError(event) {
        this.resource.removeEventListener("error", this._onError, true);
        this.emit("error", event);
        if (this._reject) {
            this._reject(event);
            this._reject = null;
            this._resolve = null;
        }
    }
    /**
   * Checks if the underlying source is playing.
   * @returns True if playing.
   */ _isSourcePlaying() {
        const source = this.resource;
        return !source.paused && !source.ended;
    }
    /**
   * Checks if the underlying source is ready for playing.
   * @returns True if ready.
   */ _isSourceReady() {
        const source = this.resource;
        return source.readyState > 2;
    }
    /** Runs the update loop when the video is ready to play. */ _onPlayStart() {
        if (!this.isValid) this._mediaReady();
        this._configureAutoUpdate();
    }
    /** Stops the update loop when a pause event is triggered. */ _onPlayStop() {
        this._configureAutoUpdate();
    }
    /** Handles behavior when the video completes seeking to the current playback position. */ _onSeeked() {
        if (this._autoUpdate && !this._isSourcePlaying()) {
            this._msToNextUpdate = 0;
            this.updateFrame();
            this._msToNextUpdate = 0;
        }
    }
    _onCanPlay() {
        const source = this.resource;
        source.removeEventListener("canplay", this._onCanPlay);
        this._mediaReady();
    }
    _onCanPlayThrough() {
        const source = this.resource;
        source.removeEventListener("canplaythrough", this._onCanPlay);
        if (this._preloadTimeout) {
            clearTimeout(this._preloadTimeout);
            this._preloadTimeout = void 0;
        }
        this._mediaReady();
    }
    /** Fired when the video is loaded and ready to play. */ _mediaReady() {
        const source = this.resource;
        if (this.isValid) {
            this.isReady = true;
            this.resize(source.videoWidth, source.videoHeight);
        }
        this._msToNextUpdate = 0;
        this.updateFrame();
        this._msToNextUpdate = 0;
        if (this._resolve) {
            this._resolve(this);
            this._resolve = null;
            this._reject = null;
        }
        if (this._isSourcePlaying()) this._onPlayStart();
        else if (this.autoPlay) this.resource.play();
    }
    /** Cleans up resources and event listeners associated with this texture. */ destroy() {
        this._configureAutoUpdate();
        const source = this.resource;
        if (source) {
            source.removeEventListener("play", this._onPlayStart);
            source.removeEventListener("pause", this._onPlayStop);
            source.removeEventListener("seeked", this._onSeeked);
            source.removeEventListener("canplay", this._onCanPlay);
            source.removeEventListener("canplaythrough", this._onCanPlayThrough);
            source.removeEventListener("error", this._onError, true);
            source.pause();
            source.src = "";
            source.load();
        }
        super.destroy();
    }
    /** Should the base texture automatically update itself, set to true by default. */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        if (value !== this._autoUpdate) {
            this._autoUpdate = value;
            this._configureAutoUpdate();
        }
    }
    /**
   * How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */ get updateFPS() {
        return this._updateFPS;
    }
    set updateFPS(value) {
        if (value !== this._updateFPS) {
            this._updateFPS = value;
            this._configureAutoUpdate();
        }
    }
    /**
   * Configures the updating mechanism based on the current state and settings.
   *
   * This method decides between using the browser's native video frame callback or a custom ticker
   * for updating the video frame. It ensures optimal performance and responsiveness
   * based on the video's state, playback status, and the desired frames-per-second setting.
   *
   * - If `_autoUpdate` is enabled and the video source is playing:
   *   - It will prefer the native video frame callback if available and no specific FPS is set.
   *   - Otherwise, it will use a custom ticker for manual updates.
   * - If `_autoUpdate` is disabled or the video isn't playing, any active update mechanisms are halted.
   */ _configureAutoUpdate() {
        if (this._autoUpdate && this._isSourcePlaying()) {
            if (!this._updateFPS && this.resource.requestVideoFrameCallback) {
                if (this._isConnectedToTicker) {
                    (0, $4CJdx.Ticker).shared.remove(this.updateFrame, this);
                    this._isConnectedToTicker = false;
                    this._msToNextUpdate = 0;
                }
                if (this._videoFrameRequestCallbackHandle === null) this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(this._videoFrameRequestCallback);
            } else {
                if (this._videoFrameRequestCallbackHandle !== null) {
                    this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
                    this._videoFrameRequestCallbackHandle = null;
                }
                if (!this._isConnectedToTicker) {
                    (0, $4CJdx.Ticker).shared.add(this.updateFrame, this);
                    this._isConnectedToTicker = true;
                    this._msToNextUpdate = 0;
                }
            }
        } else {
            if (this._videoFrameRequestCallbackHandle !== null) {
                this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
                this._videoFrameRequestCallbackHandle = null;
            }
            if (this._isConnectedToTicker) {
                (0, $4CJdx.Ticker).shared.remove(this.updateFrame, this);
                this._isConnectedToTicker = false;
                this._msToNextUpdate = 0;
            }
        }
    }
    static test(resource) {
        return globalThis.HTMLVideoElement && resource instanceof HTMLVideoElement || globalThis.VideoFrame && resource instanceof VideoFrame;
    }
};
$eed3fbe8e44bbb1b$var$_VideoSource.extension = (0, $aqljF.ExtensionType).TextureSource;
/** The default options for video sources. */ $eed3fbe8e44bbb1b$var$_VideoSource.defaultOptions = {
    ...(0, $eIuJW.TextureSource).defaultOptions,
    /** If true, the video will start loading immediately. */ autoLoad: true,
    /** If true, the video will start playing as soon as it is loaded. */ autoPlay: true,
    /** The number of times a second to update the texture from the video. Leave at 0 to update at every render. */ updateFPS: 0,
    /** If true, the video will be loaded with the `crossorigin` attribute. */ crossorigin: true,
    /** If true, the video will loop when it ends. */ loop: false,
    /** If true, the video will be muted. */ muted: true,
    /** If true, the video will play inline. */ playsinline: true,
    /** If true, the video will be preloaded. */ preload: false
};
/**
 * Map of video MIME types that can't be directly derived from file extensions.
 * @readonly
 */ $eed3fbe8e44bbb1b$var$_VideoSource.MIME_TYPES = {
    ogv: "video/ogg",
    mov: "video/quicktime",
    m4v: "video/mp4"
};
let $eed3fbe8e44bbb1b$export$f3a17123d80000c5 = $eed3fbe8e44bbb1b$var$_VideoSource;

});
parcelRegister("4CJdx", function(module, exports) {

$parcel$export(module.exports, "Ticker", () => $cbe2cc59a6b858e3$export$39c54bcc89dcee11);

var $cuDRd = parcelRequire("cuDRd");

var $fykGH = parcelRequire("fykGH");
"use strict";
const $cbe2cc59a6b858e3$var$_Ticker = class _Ticker {
    constructor(){
        /**
     * Whether or not this ticker should invoke the method
     * {@link ticker.Ticker#start|start} automatically when a listener is added.
     */ this.autoStart = false;
        /**
     * Scalar time value from last frame to this frame.
     * This value is capped by setting {@link ticker.Ticker#minFPS|minFPS}
     * and is scaled with {@link ticker.Ticker#speed|speed}.
     * **Note:** The cap may be exceeded by scaling.
     */ this.deltaTime = 1;
        /**
     * The last time {@link ticker.Ticker#update|update} was invoked.
     * This value is also reset internally outside of invoking
     * update, but only when a new animation frame is requested.
     * If the platform supports DOMHighResTimeStamp,
     * this value will have a precision of 1 µs.
     */ this.lastTime = -1;
        /**
     * Factor of current {@link ticker.Ticker#deltaTime|deltaTime}.
     * @example
     * // Scales ticker.deltaTime to what would be
     * // the equivalent of approximately 120 FPS
     * ticker.speed = 2;
     */ this.speed = 1;
        /**
     * Whether or not this ticker has been started.
     * `true` if {@link ticker.Ticker#start|start} has been called.
     * `false` if {@link ticker.Ticker#stop|Stop} has been called.
     * While `false`, this value may change to `true` in the
     * event of {@link ticker.Ticker#autoStart|autoStart} being `true`
     * and a listener is added.
     */ this.started = false;
        /** Internal current frame request ID */ this._requestId = null;
        /**
     * Internal value managed by minFPS property setter and getter.
     * This is the maximum allowed milliseconds between updates.
     */ this._maxElapsedMS = 100;
        /**
     * Internal value managed by minFPS property setter and getter.
     * This is the minimum allowed milliseconds between updates.
     */ this._minElapsedMS = 0;
        /** If enabled, deleting is disabled.*/ this._protected = false;
        /** The last time keyframe was executed. Maintains a relatively fixed interval with the previous value. */ this._lastFrame = -1;
        this._head = new (0, $fykGH.TickerListener)(null, null, Infinity);
        this.deltaMS = 1 / _Ticker.targetFPMS;
        this.elapsedMS = 1 / _Ticker.targetFPMS;
        this._tick = (time)=>{
            this._requestId = null;
            if (this.started) {
                this.update(time);
                if (this.started && this._requestId === null && this._head.next) this._requestId = requestAnimationFrame(this._tick);
            }
        };
    }
    /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   * @private
   */ _requestIfNeeded() {
        if (this._requestId === null && this._head.next) {
            this.lastTime = performance.now();
            this._lastFrame = this.lastTime;
            this._requestId = requestAnimationFrame(this._tick);
        }
    }
    /**
   * Conditionally cancels a pending animation frame.
   * @private
   */ _cancelIfNeeded() {
        if (this._requestId !== null) {
            cancelAnimationFrame(this._requestId);
            this._requestId = null;
        }
    }
    /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   * @private
   */ _startIfPossible() {
        if (this.started) this._requestIfNeeded();
        else if (this.autoStart) this.start();
    }
    /**
   * Register a handler for tick events. Calls continuously unless
   * it is removed or the ticker is stopped.
   * @param fn - The listener function to be added for updates
   * @param context - The listener context
   * @param {number} [priority=UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */ add(fn, context, priority = (0, $cuDRd.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $fykGH.TickerListener)(fn, context, priority));
    }
    /**
   * Add a handler for the tick event which is only execute once.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param {number} [priority=UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */ addOnce(fn, context, priority = (0, $cuDRd.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $fykGH.TickerListener)(fn, context, priority, true));
    }
    /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */ _addListener(listener) {
        let current = this._head.next;
        let previous = this._head;
        if (!current) listener.connect(previous);
        else {
            while(current){
                if (listener.priority > current.priority) {
                    listener.connect(previous);
                    break;
                }
                previous = current;
                current = current.next;
            }
            if (!listener.previous) listener.connect(previous);
        }
        this._startIfPossible();
        return this;
    }
    /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   */ remove(fn, context) {
        let listener = this._head.next;
        while(listener)if (listener.match(fn, context)) listener = listener.destroy();
        else listener = listener.next;
        if (!this._head.next) this._cancelIfNeeded();
        return this;
    }
    /**
   * The number of listeners on this ticker, calculated by walking through linked list
   * @readonly
   * @member {number}
   */ get count() {
        if (!this._head) return 0;
        let count = 0;
        let current = this._head;
        while(current = current.next)count++;
        return count;
    }
    /** Starts the ticker. If the ticker has listeners a new animation frame is requested at this point. */ start() {
        if (!this.started) {
            this.started = true;
            this._requestIfNeeded();
        }
    }
    /** Stops the ticker. If the ticker has requested an animation frame it is canceled at this point. */ stop() {
        if (this.started) {
            this.started = false;
            this._cancelIfNeeded();
        }
    }
    /** Destroy the ticker and don't use after this. Calling this method removes all references to internal events. */ destroy() {
        if (!this._protected) {
            this.stop();
            let listener = this._head.next;
            while(listener)listener = listener.destroy(true);
            this._head.destroy();
            this._head = null;
        }
    }
    /**
   * Triggers an update. An update entails setting the
   * current {@link ticker.Ticker#elapsedMS|elapsedMS},
   * the current {@link ticker.Ticker#deltaTime|deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link ticker.Ticker#lastTime|lastTime}
   * with the value of currentTime that was provided.
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @param {number} [currentTime=performance.now()] - the current time of execution
   */ update(currentTime = performance.now()) {
        let elapsedMS;
        if (currentTime > this.lastTime) {
            elapsedMS = this.elapsedMS = currentTime - this.lastTime;
            if (elapsedMS > this._maxElapsedMS) elapsedMS = this._maxElapsedMS;
            elapsedMS *= this.speed;
            if (this._minElapsedMS) {
                const delta = currentTime - this._lastFrame | 0;
                if (delta < this._minElapsedMS) return;
                this._lastFrame = currentTime - delta % this._minElapsedMS;
            }
            this.deltaMS = elapsedMS;
            this.deltaTime = this.deltaMS * _Ticker.targetFPMS;
            const head = this._head;
            let listener = head.next;
            while(listener)listener = listener.emit(this);
            if (!head.next) this._cancelIfNeeded();
        } else this.deltaTime = this.deltaMS = this.elapsedMS = 0;
        this.lastTime = currentTime;
    }
    /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * **Note:** This does not factor in the value of
   * {@link ticker.Ticker#speed|speed}, which is specific
   * to scaling {@link ticker.Ticker#deltaTime|deltaTime}.
   * @member {number}
   * @readonly
   */ get FPS() {
        return 1e3 / this.elapsedMS;
    }
    /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link ticker.Ticker#update|update}.
   * This value is used to cap {@link ticker.Ticker#deltaTime|deltaTime},
   * but does not effect the measured value of {@link ticker.Ticker#FPS|FPS}.
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000`.
   * @member {number}
   * @default 10
   */ get minFPS() {
        return 1e3 / this._maxElapsedMS;
    }
    set minFPS(fps) {
        const minFPS = Math.min(this.maxFPS, fps);
        const minFPMS = Math.min(Math.max(0, minFPS) / 1e3, _Ticker.targetFPMS);
        this._maxElapsedMS = 1 / minFPMS;
    }
    /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link ticker.Ticker#update|update}.
   * This will effect the measured value of {@link ticker.Ticker#FPS|FPS}.
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`
   * @member {number}
   * @default 0
   */ get maxFPS() {
        if (this._minElapsedMS) return Math.round(1e3 / this._minElapsedMS);
        return 0;
    }
    set maxFPS(fps) {
        if (fps === 0) this._minElapsedMS = 0;
        else {
            const maxFPS = Math.max(this.minFPS, fps);
            this._minElapsedMS = 1 / (maxFPS / 1e3);
        }
    }
    /**
   * The shared ticker instance used by {@link AnimatedSprite} and by
   * {@link VideoResource} to update animation frames / video textures.
   *
   * It may also be used by {@link Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link ticker.Ticker#autoStart|autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @member {ticker.Ticker}
   * @readonly
   * @static
   */ static get shared() {
        if (!_Ticker._shared) {
            const shared = _Ticker._shared = new _Ticker();
            shared.autoStart = true;
            shared._protected = true;
        }
        return _Ticker._shared;
    }
    /**
   * The system ticker instance used by {@link BasePrepare} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link ticker.Ticker#autoStart|autoStart} is set to `true` for this instance.
   * @member {ticker.Ticker}
   * @readonly
   * @static
   */ static get system() {
        if (!_Ticker._system) {
            const system = _Ticker._system = new _Ticker();
            system.autoStart = true;
            system._protected = true;
        }
        return _Ticker._system;
    }
};
/**
 * Target frames per millisecond.
 * @static
 */ $cbe2cc59a6b858e3$var$_Ticker.targetFPMS = 0.06;
let $cbe2cc59a6b858e3$export$39c54bcc89dcee11 = $cbe2cc59a6b858e3$var$_Ticker;

});
parcelRegister("cuDRd", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PRIORITY", () => $b1b6a4c45289bab1$export$688aaf132ba9b379);
"use strict";
var $b1b6a4c45289bab1$export$688aaf132ba9b379 = /* @__PURE__ */ ((UPDATE_PRIORITY2)=>{
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["INTERACTION"] = 50] = "INTERACTION";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["HIGH"] = 25] = "HIGH";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["NORMAL"] = 0] = "NORMAL";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["LOW"] = -25] = "LOW";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["UTILITY"] = -50] = "UTILITY";
    return UPDATE_PRIORITY2;
})($b1b6a4c45289bab1$export$688aaf132ba9b379 || {});

});

parcelRegister("fykGH", function(module, exports) {

$parcel$export(module.exports, "TickerListener", () => $a599850ca8986be9$export$579021a5759a260f);
"use strict";
class $a599850ca8986be9$export$579021a5759a260f {
    /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */ constructor(fn, context = null, priority = 0, once = false){
        /** The next item in chain. */ this.next = null;
        /** The previous item in chain. */ this.previous = null;
        /** `true` if this listener has been destroyed already. */ this._destroyed = false;
        this._fn = fn;
        this._context = context;
        this.priority = priority;
        this._once = once;
    }
    /**
   * Simple compare function to figure out if a function and context match.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */ match(fn, context = null) {
        return this._fn === fn && this._context === context;
    }
    /**
   * Emit by calling the current function.
   * @param ticker - The ticker emitting.
   * @returns Next ticker
   */ emit(ticker) {
        if (this._fn) {
            if (this._context) this._fn.call(this._context, ticker);
            else this._fn(ticker);
        }
        const redirect = this.next;
        if (this._once) this.destroy(true);
        if (this._destroyed) this.next = null;
        return redirect;
    }
    /**
   * Connect to the list.
   * @param previous - Input node, previous listener
   */ connect(previous) {
        this.previous = previous;
        if (previous.next) previous.next.previous = this;
        this.next = previous.next;
        previous.next = this;
    }
    /**
   * Destroy and don't use after this.
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */ destroy(hard = false) {
        this._destroyed = true;
        this._fn = null;
        this._context = null;
        if (this.previous) this.previous.next = this.next;
        if (this.next) this.next.previous = this.previous;
        const redirect = this.next;
        this.next = hard ? null : redirect;
        this.previous = null;
        return redirect;
    }
}

});


parcelRegister("6SWkW", function(module, exports) {

$parcel$export(module.exports, "detectVideoAlphaMode", () => $c140f9236d52a9c5$export$8df68d58aae31877);
"use strict";
let $c140f9236d52a9c5$var$promise;
async function $c140f9236d52a9c5$export$8df68d58aae31877() {
    $c140f9236d52a9c5$var$promise ?? ($c140f9236d52a9c5$var$promise = (async ()=>{
        const canvas = document.createElement("canvas");
        const gl = canvas.getContext("webgl");
        if (!gl) return "premultiply-alpha-on-upload";
        const video = await new Promise((resolve)=>{
            const video2 = document.createElement("video");
            video2.onloadeddata = ()=>resolve(video2);
            video2.onerror = ()=>resolve(null);
            video2.autoplay = false;
            video2.crossOrigin = "anonymous";
            video2.preload = "auto";
            video2.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=";
            video2.load();
        });
        if (!video) return "premultiply-alpha-on-upload";
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        const framebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video);
        const pixel = new Uint8Array(4);
        gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel);
        gl.deleteFramebuffer(framebuffer);
        gl.deleteTexture(texture);
        gl.getExtension("WEBGL_lose_context")?.loseContext();
        return pixel[0] <= pixel[3] ? "premultiplied-alpha" : "premultiply-alpha-on-upload";
    })());
    return $c140f9236d52a9c5$var$promise;
}

});


parcelRegister("3ATmb", function(module, exports) {

var $1qKFs = parcelRequire("1qKFs");

var $aqljF = parcelRequire("aqljF");

var $eIuJW = parcelRequire("eIuJW");

var $jollT = parcelRequire("jollT");
"use strict";
const $60f030a86d13680f$var$sources = [];
(0, $aqljF.extensions).handleByList((0, $aqljF.ExtensionType).TextureSource, $60f030a86d13680f$var$sources);
function $60f030a86d13680f$export$688bcf31fbf7eb15(options = {}) {
    const hasResource = options && options.resource;
    const res = hasResource ? options.resource : options;
    const opts = hasResource ? options : {
        resource: options
    };
    for(let i = 0; i < $60f030a86d13680f$var$sources.length; i++){
        const Source = $60f030a86d13680f$var$sources[i];
        if (Source.test(res)) return new Source(opts);
    }
    throw new Error(`Could not find a source type for resource: ${opts.resource}`);
}
function $60f030a86d13680f$export$3b748ed6327ec85b(options = {}, skipCache = false) {
    const hasResource = options && options.resource;
    const resource = hasResource ? options.resource : options;
    const opts = hasResource ? options : {
        resource: options
    };
    if (!skipCache && (0, $1qKFs.Cache).has(resource)) return (0, $1qKFs.Cache).get(resource);
    const texture = new (0, $jollT.Texture)({
        source: $60f030a86d13680f$export$688bcf31fbf7eb15(opts)
    });
    texture.on("destroy", ()=>{
        if ((0, $1qKFs.Cache).has(resource)) (0, $1qKFs.Cache).remove(resource);
    });
    if (!skipCache) (0, $1qKFs.Cache).set(resource, texture);
    return texture;
}
function $60f030a86d13680f$export$4266177d9730bb1(id, skipCache = false) {
    if (typeof id === "string") return (0, $1qKFs.Cache).get(id);
    else if (id instanceof (0, $eIuJW.TextureSource)) return new (0, $jollT.Texture)({
        source: id
    });
    return $60f030a86d13680f$export$3b748ed6327ec85b(id, skipCache);
}
(0, $jollT.Texture).from = $60f030a86d13680f$export$4266177d9730bb1;

});
parcelRegister("1qKFs", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $d3966645ba1cf08d$export$94affb487e701bf2);

var $1q6Bk = parcelRequire("1q6Bk");

var $8o3Sc = parcelRequire("8o3Sc");
"use strict";
class $d3966645ba1cf08d$var$CacheClass {
    constructor(){
        this._parsers = [];
        this._cache = /* @__PURE__ */ new Map();
        this._cacheMap = /* @__PURE__ */ new Map();
    }
    /** Clear all entries. */ reset() {
        this._cacheMap.clear();
        this._cache.clear();
    }
    /**
   * Check if the key exists
   * @param key - The key to check
   */ has(key) {
        return this._cache.has(key);
    }
    /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */ get(key) {
        const result = this._cache.get(key);
        if (!result) (0, $1q6Bk.warn)(`[Assets] Asset id ${key} was not found in the Cache`);
        return result;
    }
    /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */ set(key, value) {
        const keys = (0, $8o3Sc.convertToList)(key);
        let cacheableAssets;
        for(let i = 0; i < this.parsers.length; i++){
            const parser = this.parsers[i];
            if (parser.test(value)) {
                cacheableAssets = parser.getCacheableAssets(keys, value);
                break;
            }
        }
        const cacheableMap = new Map(Object.entries(cacheableAssets || {}));
        if (!cacheableAssets) keys.forEach((key2)=>{
            cacheableMap.set(key2, value);
        });
        const cacheKeys = [
            ...cacheableMap.keys()
        ];
        const cachedAssets = {
            cacheKeys: cacheKeys,
            keys: keys
        };
        keys.forEach((key2)=>{
            this._cacheMap.set(key2, cachedAssets);
        });
        cacheKeys.forEach((key2)=>{
            const val = cacheableAssets ? cacheableAssets[key2] : value;
            if (this._cache.has(key2) && this._cache.get(key2) !== val) (0, $1q6Bk.warn)("[Cache] already has key:", key2);
            this._cache.set(key2, cacheableMap.get(key2));
        });
    }
    /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */ remove(key) {
        if (!this._cacheMap.has(key)) {
            (0, $1q6Bk.warn)(`[Assets] Asset id ${key} was not found in the Cache`);
            return;
        }
        const cacheMap = this._cacheMap.get(key);
        const cacheKeys = cacheMap.cacheKeys;
        cacheKeys.forEach((key2)=>{
            this._cache.delete(key2);
        });
        cacheMap.keys.forEach((key2)=>{
            this._cacheMap.delete(key2);
        });
    }
    /** All loader parsers registered */ get parsers() {
        return this._parsers;
    }
}
const $d3966645ba1cf08d$export$94affb487e701bf2 = new $d3966645ba1cf08d$var$CacheClass();

});
parcelRegister("8o3Sc", function(module, exports) {

$parcel$export(module.exports, "convertToList", () => $320fcafcfc362dc9$export$b01be8e180bf3d9b);
"use strict";
const $320fcafcfc362dc9$export$b01be8e180bf3d9b = (input, transform, forceTransform = false)=>{
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!transform) return input;
    return input.map((item)=>{
        if (typeof item === "string" || forceTransform) return transform(item);
        return item;
    });
};

});




parcelRegister("a6zwA", function(module, exports) {

var $aqljF = parcelRequire("aqljF");

var $1oofS = parcelRequire("1oofS");
"use strict";
(0, $aqljF.extensions).add((0, $1oofS.spritesheetAsset));

});
parcelRegister("1oofS", function(module, exports) {

$parcel$export(module.exports, "spritesheetAsset", () => $02d05592a23927ad$export$46dcda4f1cdd80fe);

var $9uHEw = parcelRequire("9uHEw");

var $6yskn = parcelRequire("6yskn");

var $8b3nx = parcelRequire("8b3nx");

var $aqljF = parcelRequire("aqljF");

var $jollT = parcelRequire("jollT");

var $6sETp = parcelRequire("6sETp");

var $jxXUM = parcelRequire("jxXUM");
"use strict";
const $02d05592a23927ad$var$validImages = [
    "jpg",
    "png",
    "jpeg",
    "avif",
    "webp",
    "basis",
    "etc2",
    "bc7",
    "bc6h",
    "bc5",
    "bc4",
    "bc3",
    "bc2",
    "bc1",
    "eac",
    "astc"
];
function $02d05592a23927ad$var$getCacheableAssets(keys, asset, ignoreMultiPack) {
    const out = {};
    keys.forEach((key)=>{
        out[key] = asset;
    });
    Object.keys(asset.textures).forEach((key)=>{
        out[key] = asset.textures[key];
    });
    if (!ignoreMultiPack) {
        const basePath = (0, $6sETp.path).dirname(keys[0]);
        asset.linkedSheets.forEach((item, i)=>{
            const out2 = $02d05592a23927ad$var$getCacheableAssets([
                `${basePath}/${asset.data.meta.related_multi_packs[i]}`
            ], item, true);
            Object.assign(out, out2);
        });
    }
    return out;
}
const $02d05592a23927ad$export$46dcda4f1cdd80fe = {
    extension: (0, $aqljF.ExtensionType).Asset,
    /** Handle the caching of the related Spritesheet Textures */ cache: {
        test: (asset)=>asset instanceof (0, $jxXUM.Spritesheet),
        getCacheableAssets: (keys, asset)=>$02d05592a23927ad$var$getCacheableAssets(keys, asset, false)
    },
    /** Resolve the resolution of the asset. */ resolver: {
        test: (value)=>{
            const tempURL = value.split("?")[0];
            const split = tempURL.split(".");
            const extension = split.pop();
            const format = split.pop();
            return extension === "json" && $02d05592a23927ad$var$validImages.includes(format);
        },
        parse: (value)=>{
            const split = value.split(".");
            return {
                resolution: parseFloat((0, $6yskn.Resolver).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
                format: split[split.length - 2],
                src: value
            };
        }
    },
    /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into Spritesheet
   * All textures in the sprite sheet are then added to the cache
   */ loader: {
        name: "spritesheetLoader",
        extension: {
            type: (0, $aqljF.ExtensionType).LoadParser,
            priority: (0, $9uHEw.LoaderParserPriority).Normal
        },
        async testParse (asset, options) {
            return (0, $6sETp.path).extname(options.src).toLowerCase() === ".json" && !!asset.frames;
        },
        async parse (asset, options, loader) {
            const { texture: imageTexture, imageFilename: // if user need to use preloaded texture
            imageFilename } = options?.data ?? {};
            let basePath = (0, $6sETp.path).dirname(options.src);
            if (basePath && basePath.lastIndexOf("/") !== basePath.length - 1) basePath += "/";
            let texture;
            if (imageTexture instanceof (0, $jollT.Texture)) texture = imageTexture;
            else {
                const imagePath = (0, $8b3nx.copySearchParams)(basePath + (imageFilename ?? asset.meta.image), options.src);
                const assets = await loader.load([
                    imagePath
                ]);
                texture = assets[imagePath];
            }
            const spritesheet = new (0, $jxXUM.Spritesheet)(texture.source, asset);
            await spritesheet.parse();
            const multiPacks = asset?.meta?.related_multi_packs;
            if (Array.isArray(multiPacks)) {
                const promises = [];
                for (const item of multiPacks){
                    if (typeof item !== "string") continue;
                    let itemUrl = basePath + item;
                    if (options.data?.ignoreMultiPack) continue;
                    itemUrl = (0, $8b3nx.copySearchParams)(itemUrl, options.src);
                    promises.push(loader.load({
                        src: itemUrl,
                        data: {
                            ignoreMultiPack: true
                        }
                    }));
                }
                const res = await Promise.all(promises);
                spritesheet.linkedSheets = res;
                res.forEach((item)=>{
                    item.linkedSheets = [
                        spritesheet
                    ].concat(spritesheet.linkedSheets.filter((sp)=>sp !== item));
                });
            }
            return spritesheet;
        },
        async unload (spritesheet, _resolvedAsset, loader) {
            await loader.unload(spritesheet.textureSource._sourceOrigin);
            spritesheet.destroy(false);
        }
    }
};

});
parcelRegister("9uHEw", function(module, exports) {

$parcel$export(module.exports, "LoaderParserPriority", () => $ac527582a890a9a5$export$820ed6348c4f2750);
"use strict";
var $ac527582a890a9a5$export$820ed6348c4f2750 = /* @__PURE__ */ ((LoaderParserPriority2)=>{
    LoaderParserPriority2[LoaderParserPriority2["Low"] = 0] = "Low";
    LoaderParserPriority2[LoaderParserPriority2["Normal"] = 1] = "Normal";
    LoaderParserPriority2[LoaderParserPriority2["High"] = 2] = "High";
    return LoaderParserPriority2;
})($ac527582a890a9a5$export$820ed6348c4f2750 || {});

});

parcelRegister("6yskn", function(module, exports) {

$parcel$export(module.exports, "Resolver", () => $23519f6837f41bd2$export$8b4c839865b08288);

var $1q6Bk = parcelRequire("1q6Bk");

var $6sETp = parcelRequire("6sETp");

var $8o3Sc = parcelRequire("8o3Sc");

var $d3F8A = parcelRequire("d3F8A");

var $b9HvA = parcelRequire("b9HvA");
"use strict";
class $23519f6837f41bd2$export$8b4c839865b08288 {
    constructor(){
        this._defaultBundleIdentifierOptions = {
            connector: "-",
            createBundleAssetId: (bundleId, assetId)=>`${bundleId}${this._bundleIdConnector}${assetId}`,
            extractAssetIdFromBundle: (bundleId, assetBundleId)=>assetBundleId.replace(`${bundleId}${this._bundleIdConnector}`, "")
        };
        /** The character that is used to connect the bundleId and the assetId when generating a bundle asset id key */ this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector;
        /**
     * A function that generates a bundle asset id key from a bundleId and an assetId
     * @param bundleId - the bundleId
     * @param assetId  - the assetId
     * @returns the bundle asset id key
     */ this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId;
        /**
     * A function that generates an assetId from a bundle asset id key. This is the reverse of generateBundleAssetId
     * @param bundleId - the bundleId
     * @param assetBundleId - the bundle asset id key
     * @returns the assetId
     */ this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle;
        this._assetMap = {};
        this._preferredOrder = [];
        this._parsers = [];
        this._resolverHash = {};
        this._bundles = {};
    }
    /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */ setBundleIdentifier(bundleIdentifier) {
        this._bundleIdConnector = bundleIdentifier.connector ?? this._bundleIdConnector;
        this._createBundleAssetId = bundleIdentifier.createBundleAssetId ?? this._createBundleAssetId;
        this._extractAssetIdFromBundle = bundleIdentifier.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle;
        if (this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar") throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
    }
    /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */ prefer(...preferOrders) {
        preferOrders.forEach((prefer)=>{
            this._preferredOrder.push(prefer);
            if (!prefer.priority) prefer.priority = Object.keys(prefer.params);
        });
        this._resolverHash = {};
    }
    /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */ set basePath(basePath) {
        this._basePath = basePath;
    }
    get basePath() {
        return this._basePath;
    }
    /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */ set rootPath(rootPath) {
        this._rootPath = rootPath;
    }
    get rootPath() {
        return this._rootPath;
    }
    /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(Resolver.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */ get parsers() {
        return this._parsers;
    }
    /** Used for testing, this resets the resolver to its initial state */ reset() {
        this.setBundleIdentifier(this._defaultBundleIdentifierOptions);
        this._assetMap = {};
        this._preferredOrder = [];
        this._resolverHash = {};
        this._rootPath = null;
        this._basePath = null;
        this._manifest = null;
        this._bundles = {};
        this._defaultSearchParams = null;
    }
    /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */ setDefaultSearchParams(searchParams) {
        if (typeof searchParams === "string") this._defaultSearchParams = searchParams;
        else {
            const queryValues = searchParams;
            this._defaultSearchParams = Object.keys(queryValues).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(queryValues[key])}`).join("&");
        }
    }
    /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */ getAlias(asset) {
        const { alias: alias, src: src } = asset;
        const aliasesToUse = (0, $8o3Sc.convertToList)(alias || src, (value)=>{
            if (typeof value === "string") return value;
            if (Array.isArray(value)) return value.map((v)=>v?.src ?? v);
            if (value?.src) return value.src;
            return value;
        }, true);
        return aliasesToUse;
    }
    /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */ addManifest(manifest) {
        if (this._manifest) (0, $1q6Bk.warn)("[Resolver] Manifest already exists, this will be overwritten");
        this._manifest = manifest;
        manifest.bundles.forEach((bundle)=>{
            this.addBundle(bundle.name, bundle.assets);
        });
    }
    /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */ addBundle(bundleId, assets) {
        const assetNames = [];
        let convertedAssets = assets;
        if (!Array.isArray(assets)) convertedAssets = Object.entries(assets).map(([alias, src])=>{
            if (typeof src === "string" || Array.isArray(src)) return {
                alias: alias,
                src: src
            };
            return {
                alias: alias,
                ...src
            };
        });
        convertedAssets.forEach((asset)=>{
            const srcs = asset.src;
            const aliases = asset.alias;
            let ids;
            if (typeof aliases === "string") {
                const bundleAssetId = this._createBundleAssetId(bundleId, aliases);
                assetNames.push(bundleAssetId);
                ids = [
                    aliases,
                    bundleAssetId
                ];
            } else {
                const bundleIds = aliases.map((name)=>this._createBundleAssetId(bundleId, name));
                assetNames.push(...bundleIds);
                ids = [
                    ...aliases,
                    ...bundleIds
                ];
            }
            this.add({
                ...asset,
                alias: ids,
                src: srcs
            });
        });
        this._bundles[bundleId] = assetNames;
    }
    /**
   * Tells the resolver what keys are associated with witch asset.
   * The most important thing the resolver does
   * @example
   * // Single key, single asset:
   * resolver.add({alias: 'foo', src: 'bar.png');
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Multiple keys, single asset:
   * resolver.add({alias: ['foo', 'boo'], src: 'bar.png'});
   * resolver.resolveUrl('foo') // => 'bar.png'
   * resolver.resolveUrl('boo') // => 'bar.png'
   *
   * // Multiple keys, multiple assets:
   * resolver.add({alias: ['foo', 'boo'], src: ['bar.png', 'bar.webp']});
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Add custom data attached to the resolver
   * Resolver.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode:SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * resolver.resolve('bunnyBooBooSmooth') // => { src: 'bunny.png', data: { scaleMode: SCALE_MODES.NEAREST } }
   * @param aliases - the UnresolvedAsset or array of UnresolvedAssets to add to the resolver
   */ add(aliases) {
        const assets = [];
        if (Array.isArray(aliases)) assets.push(...aliases);
        else assets.push(aliases);
        let keyCheck;
        keyCheck = (key)=>{
            if (this.hasKey(key)) (0, $1q6Bk.warn)(`[Resolver] already has key: ${key} overwriting`);
        };
        const assetArray = (0, $8o3Sc.convertToList)(assets);
        assetArray.forEach((asset)=>{
            const { src: src } = asset;
            let { data: data, format: format, loadParser: loadParser } = asset;
            const srcsToUse = (0, $8o3Sc.convertToList)(src).map((src2)=>{
                if (typeof src2 === "string") return (0, $d3F8A.createStringVariations)(src2);
                return Array.isArray(src2) ? src2 : [
                    src2
                ];
            });
            const aliasesToUse = this.getAlias(asset);
            Array.isArray(aliasesToUse) ? aliasesToUse.forEach(keyCheck) : keyCheck(aliasesToUse);
            const resolvedAssets = [];
            srcsToUse.forEach((srcs)=>{
                srcs.forEach((src2)=>{
                    let formattedAsset = {};
                    if (typeof src2 !== "object") {
                        formattedAsset.src = src2;
                        for(let i = 0; i < this._parsers.length; i++){
                            const parser = this._parsers[i];
                            if (parser.test(src2)) {
                                formattedAsset = parser.parse(src2);
                                break;
                            }
                        }
                    } else {
                        data = src2.data ?? data;
                        format = src2.format ?? format;
                        loadParser = src2.loadParser ?? loadParser;
                        formattedAsset = {
                            ...formattedAsset,
                            ...src2
                        };
                    }
                    if (!aliasesToUse) throw new Error(`[Resolver] alias is undefined for this asset: ${formattedAsset.src}`);
                    formattedAsset = this._buildResolvedAsset(formattedAsset, {
                        aliases: aliasesToUse,
                        data: data,
                        format: format,
                        loadParser: loadParser
                    });
                    resolvedAssets.push(formattedAsset);
                });
            });
            aliasesToUse.forEach((alias)=>{
                this._assetMap[alias] = resolvedAssets;
            });
        });
    }
    // TODO: this needs an overload like load did in Assets
    /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */ resolveBundle(bundleIds) {
        const singleAsset = (0, $b9HvA.isSingleItem)(bundleIds);
        bundleIds = (0, $8o3Sc.convertToList)(bundleIds);
        const out = {};
        bundleIds.forEach((bundleId)=>{
            const assetNames = this._bundles[bundleId];
            if (assetNames) {
                const results = this.resolve(assetNames);
                const assets = {};
                for(const key in results){
                    const asset = results[key];
                    assets[this._extractAssetIdFromBundle(bundleId, key)] = asset;
                }
                out[bundleId] = assets;
            }
        });
        return singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */ resolveUrl(key) {
        const result = this.resolve(key);
        if (typeof key !== "string") {
            const out = {};
            for(const i in result)out[i] = result[i].src;
            return out;
        }
        return result.src;
    }
    resolve(keys) {
        const singleAsset = (0, $b9HvA.isSingleItem)(keys);
        keys = (0, $8o3Sc.convertToList)(keys);
        const result = {};
        keys.forEach((key)=>{
            if (!this._resolverHash[key]) {
                if (this._assetMap[key]) {
                    let assets = this._assetMap[key];
                    const preferredOrder = this._getPreferredOrder(assets);
                    preferredOrder?.priority.forEach((priorityKey)=>{
                        preferredOrder.params[priorityKey].forEach((value)=>{
                            const filteredAssets = assets.filter((asset)=>{
                                if (asset[priorityKey]) return asset[priorityKey] === value;
                                return false;
                            });
                            if (filteredAssets.length) assets = filteredAssets;
                        });
                    });
                    this._resolverHash[key] = assets[0];
                } else this._resolverHash[key] = this._buildResolvedAsset({
                    alias: [
                        key
                    ],
                    src: key
                }, {});
            }
            result[key] = this._resolverHash[key];
        });
        return singleAsset ? result[keys[0]] : result;
    }
    /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */ hasKey(key) {
        return !!this._assetMap[key];
    }
    /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */ hasBundle(key) {
        return !!this._bundles[key];
    }
    /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */ _getPreferredOrder(assets) {
        for(let i = 0; i < assets.length; i++){
            const asset = assets[0];
            const preferred = this._preferredOrder.find((preference)=>preference.params.format.includes(asset.format));
            if (preferred) return preferred;
        }
        return this._preferredOrder[0];
    }
    /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */ _appendDefaultSearchParams(url) {
        if (!this._defaultSearchParams) return url;
        const paramConnector = /\?/.test(url) ? "&" : "?";
        return `${url}${paramConnector}${this._defaultSearchParams}`;
    }
    _buildResolvedAsset(formattedAsset, data) {
        const { aliases: aliases, data: assetData, loadParser: loadParser, format: format } = data;
        if (this._basePath || this._rootPath) formattedAsset.src = (0, $6sETp.path).toAbsolute(formattedAsset.src, this._basePath, this._rootPath);
        formattedAsset.alias = aliases ?? formattedAsset.alias ?? [
            formattedAsset.src
        ];
        formattedAsset.src = this._appendDefaultSearchParams(formattedAsset.src);
        formattedAsset.data = {
            ...assetData || {},
            ...formattedAsset.data
        };
        formattedAsset.loadParser = loadParser ?? formattedAsset.loadParser;
        formattedAsset.format = format ?? formattedAsset.format ?? $23519f6837f41bd2$export$4bb0ea38086a2ed5(formattedAsset.src);
        return formattedAsset;
    }
}
/**
 * The prefix that denotes a URL is for a retina asset.
 * @static
 * @name RETINA_PREFIX
 * @type {RegExp}
 * @default /@([0-9\.]+)x/
 * @example `@2x`
 */ $23519f6837f41bd2$export$8b4c839865b08288.RETINA_PREFIX = /@([0-9\.]+)x/;
function $23519f6837f41bd2$export$4bb0ea38086a2ed5(url) {
    return url.split(".").pop().split("?").shift().split("#").shift();
}

});
parcelRegister("6sETp", function(module, exports) {

$parcel$export(module.exports, "path", () => $535b8b62b9e191bd$export$bb654e07daaf8c3a);

var $2NruG = parcelRequire("2NruG");
"use strict";
function $535b8b62b9e191bd$var$assertPath(path2) {
    if (typeof path2 !== "string") throw new TypeError(`Path must be a string. Received ${JSON.stringify(path2)}`);
}
function $535b8b62b9e191bd$var$removeUrlParams(url) {
    const re = url.split("?")[0];
    return re.split("#")[0];
}
function $535b8b62b9e191bd$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $535b8b62b9e191bd$var$replaceAll(str, find, replace) {
    return str.replace(new RegExp($535b8b62b9e191bd$var$escapeRegExp(find), "g"), replace);
}
function $535b8b62b9e191bd$var$normalizeStringPosix(path2, allowAboveRoot) {
    let res = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let code = -1;
    for(let i = 0; i <= path2.length; ++i){
        if (i < path2.length) code = path2.charCodeAt(i);
        else if (code === 47) break;
        else code = 47;
        if (code === 47) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
                    if (res.length > 2) {
                        const lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += `/${path2.slice(lastSlash + 1, i)}`;
                else res = path2.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
const $535b8b62b9e191bd$export$bb654e07daaf8c3a = {
    /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   */ toPosix (path2) {
        return $535b8b62b9e191bd$var$replaceAll(path2, "\\", "/");
    },
    /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   */ isUrl (path2) {
        return /^https?:/.test(this.toPosix(path2));
    },
    /**
   * Checks if the path is a data URL
   * @param path - The path to check
   */ isDataUrl (path2) {
        return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(path2);
    },
    /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   */ isBlobUrl (path2) {
        return path2.startsWith("blob:");
    },
    /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   */ hasProtocol (path2) {
        return /^[^/:]+:/.test(this.toPosix(path2));
    },
    /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   */ getProtocol (path2) {
        $535b8b62b9e191bd$var$assertPath(path2);
        path2 = this.toPosix(path2);
        const matchFile = /^file:\/\/\//.exec(path2);
        if (matchFile) return matchFile[0];
        const matchProtocol = /^[^/:]+:\/{0,2}/.exec(path2);
        if (matchProtocol) return matchProtocol[0];
        return "";
    },
    /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   */ toAbsolute (url, customBaseUrl, customRootUrl) {
        $535b8b62b9e191bd$var$assertPath(url);
        if (this.isDataUrl(url) || this.isBlobUrl(url)) return url;
        const baseUrl = $535b8b62b9e191bd$var$removeUrlParams(this.toPosix(customBaseUrl ?? (0, $2NruG.DOMAdapter).get().getBaseUrl()));
        const rootUrl = $535b8b62b9e191bd$var$removeUrlParams(this.toPosix(customRootUrl ?? this.rootname(baseUrl)));
        url = this.toPosix(url);
        if (url.startsWith("/")) return $535b8b62b9e191bd$export$bb654e07daaf8c3a.join(rootUrl, url.slice(1));
        const absolutePath = this.isAbsolute(url) ? url : this.join(baseUrl, url);
        return absolutePath;
    },
    /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   */ normalize (path2) {
        $535b8b62b9e191bd$var$assertPath(path2);
        if (path2.length === 0) return ".";
        if (this.isDataUrl(path2) || this.isBlobUrl(path2)) return path2;
        path2 = this.toPosix(path2);
        let protocol = "";
        const isAbsolute = path2.startsWith("/");
        if (this.hasProtocol(path2)) {
            protocol = this.rootname(path2);
            path2 = path2.slice(protocol.length);
        }
        const trailingSeparator = path2.endsWith("/");
        path2 = $535b8b62b9e191bd$var$normalizeStringPosix(path2, false);
        if (path2.length > 0 && trailingSeparator) path2 += "/";
        if (isAbsolute) return `/${path2}`;
        return protocol + path2;
    },
    /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   */ isAbsolute (path2) {
        $535b8b62b9e191bd$var$assertPath(path2);
        path2 = this.toPosix(path2);
        if (this.hasProtocol(path2)) return true;
        return path2.startsWith("/");
    },
    /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   */ join (...segments) {
        if (segments.length === 0) return ".";
        let joined;
        for(let i = 0; i < segments.length; ++i){
            const arg = segments[i];
            $535b8b62b9e191bd$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === void 0) joined = arg;
                else {
                    const prevArg = segments[i - 1] ?? "";
                    if (this.joinExtensions.includes(this.extname(prevArg).toLowerCase())) joined += `/../${arg}`;
                    else joined += `/${arg}`;
                }
            }
        }
        if (joined === void 0) return ".";
        return this.normalize(joined);
    },
    /**
   * Returns the directory name of a path
   * @param path - The path to parse
   */ dirname (path2) {
        $535b8b62b9e191bd$var$assertPath(path2);
        if (path2.length === 0) return ".";
        path2 = this.toPosix(path2);
        let code = path2.charCodeAt(0);
        const hasRoot = code === 47;
        let end = -1;
        let matchedSlash = true;
        const proto = this.getProtocol(path2);
        const origpath = path2;
        path2 = path2.slice(proto.length);
        for(let i = path2.length - 1; i >= 1; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : this.isUrl(origpath) ? proto + path2 : proto;
        if (hasRoot && end === 1) return "//";
        return proto + path2.slice(0, end);
    },
    /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   */ rootname (path2) {
        $535b8b62b9e191bd$var$assertPath(path2);
        path2 = this.toPosix(path2);
        let root = "";
        if (path2.startsWith("/")) root = "/";
        else root = this.getProtocol(path2);
        if (this.isUrl(path2)) {
            const index = path2.indexOf("/", root.length);
            if (index !== -1) root = path2.slice(0, index);
            else root = path2;
            if (!root.endsWith("/")) root += "/";
        }
        return root;
    },
    /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   */ basename (path2, ext) {
        $535b8b62b9e191bd$var$assertPath(path2);
        if (ext) $535b8b62b9e191bd$var$assertPath(ext);
        path2 = $535b8b62b9e191bd$var$removeUrlParams(this.toPosix(path2));
        let start = 0;
        let end = -1;
        let matchedSlash = true;
        let i;
        if (ext !== void 0 && ext.length > 0 && ext.length <= path2.length) {
            if (ext.length === path2.length && ext === path2) return "";
            let extIdx = ext.length - 1;
            let firstNonSlashEnd = -1;
            for(i = path2.length - 1; i >= 0; --i){
                const code = path2.charCodeAt(i);
                if (code === 47) {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) end = i;
                        } else {
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path2.length;
            return path2.slice(start, end);
        }
        for(i = path2.length - 1; i >= 0; --i){
            if (path2.charCodeAt(i) === 47) {
                if (!matchedSlash) {
                    start = i + 1;
                    break;
                }
            } else if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
        }
        if (end === -1) return "";
        return path2.slice(start, end);
    },
    /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   */ extname (path2) {
        $535b8b62b9e191bd$var$assertPath(path2);
        path2 = $535b8b62b9e191bd$var$removeUrlParams(this.toPosix(path2));
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let preDotState = 0;
        for(let i = path2.length - 1; i >= 0; --i){
            const code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path2.slice(startDot, end);
    },
    /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   */ parse (path2) {
        $535b8b62b9e191bd$var$assertPath(path2);
        const ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path2.length === 0) return ret;
        path2 = $535b8b62b9e191bd$var$removeUrlParams(this.toPosix(path2));
        let code = path2.charCodeAt(0);
        const isAbsolute = this.isAbsolute(path2);
        let start;
        const protocol = "";
        ret.root = this.rootname(path2);
        if (isAbsolute || this.hasProtocol(path2)) start = 1;
        else start = 0;
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let i = path2.length - 1;
        let preDotState = 0;
        for(; i >= start; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path2.slice(1, end);
                else ret.base = ret.name = path2.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path2.slice(1, startDot);
                ret.base = path2.slice(1, end);
            } else {
                ret.name = path2.slice(startPart, startDot);
                ret.base = path2.slice(startPart, end);
            }
            ret.ext = path2.slice(startDot, end);
        }
        ret.dir = this.dirname(path2);
        if (protocol) ret.dir = protocol + ret.dir;
        return ret;
    },
    sep: "/",
    delimiter: ":",
    joinExtensions: [
        ".html"
    ]
};

});

parcelRegister("d3F8A", function(module, exports) {

$parcel$export(module.exports, "createStringVariations", () => $223f29658bb9ac42$export$738117acc6638004);
"use strict";
function $223f29658bb9ac42$var$processX(base, ids, depth, result, tags) {
    const id = ids[depth];
    for(let i = 0; i < id.length; i++){
        const value = id[i];
        if (depth < ids.length - 1) $223f29658bb9ac42$var$processX(base.replace(result[depth], value), ids, depth + 1, result, tags);
        else tags.push(base.replace(result[depth], value));
    }
}
function $223f29658bb9ac42$export$738117acc6638004(string) {
    const regex = /\{(.*?)\}/g;
    const result = string.match(regex);
    const tags = [];
    if (result) {
        const ids = [];
        result.forEach((vars)=>{
            const split = vars.substring(1, vars.length - 1).split(",");
            ids.push(split);
        });
        $223f29658bb9ac42$var$processX(string, ids, 0, result, tags);
    } else tags.push(string);
    return tags;
}

});

parcelRegister("b9HvA", function(module, exports) {

$parcel$export(module.exports, "isSingleItem", () => $beac8df077bb5d6c$export$16a80d27953452d4);
"use strict";
const $beac8df077bb5d6c$export$16a80d27953452d4 = (item)=>!Array.isArray(item);

});


parcelRegister("8b3nx", function(module, exports) {

$parcel$export(module.exports, "copySearchParams", () => $0a28801a8aef8630$export$f57b97ef8be10dda);
"use strict";
const $0a28801a8aef8630$export$f57b97ef8be10dda = (targetUrl, sourceUrl)=>{
    const searchParams = sourceUrl.split("?")[1];
    if (searchParams) targetUrl += `?${searchParams}`;
    return targetUrl;
};

});

parcelRegister("jxXUM", function(module, exports) {

$parcel$export(module.exports, "Spritesheet", () => $deb4aa483dc95aee$export$674d2eb4debbef0c);

var $hFBUu = parcelRequire("hFBUu");

var $jollT = parcelRequire("jollT");
"use strict";
const $deb4aa483dc95aee$var$_Spritesheet = class _Spritesheet {
    /**
   * @param texture - Reference to the source BaseTexture object.
   * @param {object} data - Spritesheet image data.
   */ constructor(texture, data){
        /** For multi-packed spritesheets, this contains a reference to all the other spritesheets it depends on. */ this.linkedSheets = [];
        this._texture = texture instanceof (0, $jollT.Texture) ? texture : null;
        this.textureSource = texture.source;
        this.textures = {};
        this.animations = {};
        this.data = data;
        const metaResolution = parseFloat(data.meta.scale);
        if (metaResolution) {
            this.resolution = metaResolution;
            texture.source.resolution = this.resolution;
        } else this.resolution = texture.source._resolution;
        this._frames = this.data.frames;
        this._frameKeys = Object.keys(this._frames);
        this._batchIndex = 0;
        this._callback = null;
    }
    /**
   * Parser spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   */ parse() {
        return new Promise((resolve)=>{
            this._callback = resolve;
            this._batchIndex = 0;
            if (this._frameKeys.length <= _Spritesheet.BATCH_SIZE) {
                this._processFrames(0);
                this._processAnimations();
                this._parseComplete();
            } else this._nextBatch();
        });
    }
    /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   */ _processFrames(initialFrameIndex) {
        let frameIndex = initialFrameIndex;
        const maxFrames = _Spritesheet.BATCH_SIZE;
        while(frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length){
            const i = this._frameKeys[frameIndex];
            const data = this._frames[i];
            const rect = data.frame;
            if (rect) {
                let frame = null;
                let trim = null;
                const sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;
                const orig = new (0, $hFBUu.Rectangle)(0, 0, Math.floor(sourceSize.w) / this.resolution, Math.floor(sourceSize.h) / this.resolution);
                if (data.rotated) frame = new (0, $hFBUu.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.h) / this.resolution, Math.floor(rect.w) / this.resolution);
                else frame = new (0, $hFBUu.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                if (data.trimmed !== false && data.spriteSourceSize) trim = new (0, $hFBUu.Rectangle)(Math.floor(data.spriteSourceSize.x) / this.resolution, Math.floor(data.spriteSourceSize.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                this.textures[i] = new (0, $jollT.Texture)({
                    source: this.textureSource,
                    frame: frame,
                    orig: orig,
                    trim: trim,
                    rotate: data.rotated ? 2 : 0,
                    defaultAnchor: data.anchor,
                    defaultBorders: data.borders,
                    label: i.toString()
                });
            }
            frameIndex++;
        }
    }
    /** Parse animations config. */ _processAnimations() {
        const animations = this.data.animations || {};
        for(const animName in animations){
            this.animations[animName] = [];
            for(let i = 0; i < animations[animName].length; i++){
                const frameName = animations[animName][i];
                this.animations[animName].push(this.textures[frameName]);
            }
        }
    }
    /** The parse has completed. */ _parseComplete() {
        const callback = this._callback;
        this._callback = null;
        this._batchIndex = 0;
        callback.call(this, this.textures);
    }
    /** Begin the next batch of textures. */ _nextBatch() {
        this._processFrames(this._batchIndex * _Spritesheet.BATCH_SIZE);
        this._batchIndex++;
        setTimeout(()=>{
            if (this._batchIndex * _Spritesheet.BATCH_SIZE < this._frameKeys.length) this._nextBatch();
            else {
                this._processAnimations();
                this._parseComplete();
            }
        }, 0);
    }
    /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */ destroy(destroyBase = false) {
        for(const i in this.textures)this.textures[i].destroy();
        this._frames = null;
        this._frameKeys = null;
        this.data = null;
        this.textures = null;
        if (destroyBase) {
            this._texture?.destroy();
            this.textureSource.destroy();
        }
        this._texture = null;
        this.textureSource = null;
        this.linkedSheets = [];
    }
};
/** The maximum number of Textures to build per process. */ $deb4aa483dc95aee$var$_Spritesheet.BATCH_SIZE = 1e3;
let $deb4aa483dc95aee$export$674d2eb4debbef0c = $deb4aa483dc95aee$var$_Spritesheet;

});



parcelRegister("lxavo", function(module, exports) {

$parcel$export(module.exports, "AbstractRenderer", () => $809d6488275fc714$export$58ab3ed211eed562);

var $bEj7k = parcelRequire("bEj7k");

var $e0Ilp = parcelRequire("e0Ilp");

var $92wAN = parcelRequire("92wAN");

var $j0fPb = parcelRequire("j0fPb");


var $7ItRq = parcelRequire("7ItRq");

var $abOdb = parcelRequire("abOdb");

var $gpXaq = parcelRequire("gpXaq");
"use strict";
const $809d6488275fc714$var$defaultRunners = [
    "init",
    "destroy",
    "contextChange",
    "resolutionChange",
    "reset",
    "renderEnd",
    "renderStart",
    "render",
    "update",
    "postrender",
    "prerender"
];
const $809d6488275fc714$var$_AbstractRenderer = class _AbstractRenderer extends (0, (/*@__PURE__*/$parcel$interopDefault($gpXaq))) {
    /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */ constructor(config){
        super();
        this.runners = /* @__PURE__ */ Object.create(null);
        this.renderPipes = /* @__PURE__ */ Object.create(null);
        this._initOptions = {};
        this._systemsHash = /* @__PURE__ */ Object.create(null);
        this.type = config.type;
        this.name = config.name;
        const combinedRunners = [
            ...$809d6488275fc714$var$defaultRunners,
            ...config.runners ?? []
        ];
        this._addRunners(...combinedRunners);
        this._addSystems(config.systems);
        this._addPipes(config.renderPipes, config.renderPipeAdaptors);
        this._unsafeEvalCheck();
    }
    /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */ async init(options = {}) {
        for(const systemName in this._systemsHash){
            const system = this._systemsHash[systemName];
            const defaultSystemOptions = system.constructor.defaultOptions;
            options = {
                ...defaultSystemOptions,
                ...options
            };
        }
        options = {
            ..._AbstractRenderer.defaultOptions,
            ...options
        };
        this._roundPixels = options.roundPixels ? 1 : 0;
        for(let i = 0; i < this.runners.init.items.length; i++)await this.runners.init.items[i].init(options);
        this._initOptions = options;
    }
    render(args, deprecated) {
        let options = args;
        if (options instanceof (0, $e0Ilp.Container)) {
            options = {
                container: options
            };
            if (deprecated) {
                (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "passing a second argument is deprecated, please use render options instead");
                options.target = deprecated.renderTexture;
            }
        }
        options.target || (options.target = this.view.renderTarget);
        if (options.target === this.view.renderTarget) {
            this._lastObjectRendered = options.container;
            options.clearColor = this.background.colorRgba;
        }
        if (options.clearColor) {
            const isRGBAArray = Array.isArray(options.clearColor) && options.clearColor.length === 4;
            options.clearColor = isRGBAArray ? options.clearColor : (0, $bEj7k.Color).shared.setValue(options.clearColor).toArray();
        }
        if (!options.transform) {
            options.container.updateLocalTransform();
            options.transform = options.container.localTransform;
        }
        this.runners.prerender.emit(options);
        this.runners.renderStart.emit(options);
        this.runners.render.emit(options);
        this.runners.renderEnd.emit(options);
        this.runners.postrender.emit(options);
    }
    /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */ resize(desiredScreenWidth, desiredScreenHeight, resolution) {
        this.view.resize(desiredScreenWidth, desiredScreenHeight, resolution);
        this.emit("resize", this.view.screen.width, this.view.screen.height);
    }
    clear(options = {}) {
        const renderer = this;
        options.target || (options.target = renderer.renderTarget.renderTarget);
        options.clearColor || (options.clearColor = this.background.colorRgba);
        options.clear ?? (options.clear = (0, $7ItRq.CLEAR).ALL);
        const { clear: clear, clearColor: clearColor, target: target } = options;
        (0, $bEj7k.Color).shared.setValue(clearColor ?? this.background.colorRgba);
        renderer.renderTarget.clear(target, clear, (0, $bEj7k.Color).shared.toArray());
    }
    /** The resolution / device pixel ratio of the renderer. */ get resolution() {
        return this.view.resolution;
    }
    set resolution(value) {
        this.view.resolution = value;
        this.runners.resolutionChange.emit(value);
    }
    /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @member {number}
   * @readonly
   * @default 800
   */ get width() {
        return this.view.texture.frame.width;
    }
    /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */ get height() {
        return this.view.texture.frame.height;
    }
    // NOTE: this was `view` in v7
    /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */ get canvas() {
        return this.view.canvas;
    }
    /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */ get lastObjectRendered() {
        return this._lastObjectRendered;
    }
    /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */ get renderingToScreen() {
        const renderer = this;
        return renderer.renderTarget.renderingToScreen;
    }
    /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */ get screen() {
        return this.view.screen;
    }
    /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */ _addRunners(...runnerIds) {
        runnerIds.forEach((runnerId)=>{
            this.runners[runnerId] = new (0, $abOdb.SystemRunner)(runnerId);
        });
    }
    _addSystems(systems) {
        let i;
        for(i in systems){
            const val = systems[i];
            this._addSystem(val.value, val.name);
        }
    }
    /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */ _addSystem(ClassRef, name) {
        const system = new ClassRef(this);
        if (this[name]) throw new Error(`Whoops! The name "${name}" is already in use`);
        this[name] = system;
        this._systemsHash[name] = system;
        for(const i in this.runners)this.runners[i].add(system);
        return this;
    }
    _addPipes(pipes, pipeAdaptors) {
        const adaptors = pipeAdaptors.reduce((acc, adaptor)=>{
            acc[adaptor.name] = adaptor.value;
            return acc;
        }, {});
        pipes.forEach((pipe)=>{
            const PipeClass = pipe.value;
            const name = pipe.name;
            const Adaptor = adaptors[name];
            this.renderPipes[name] = new PipeClass(this, Adaptor ? new Adaptor() : null);
        });
    }
    destroy(options = false) {
        this.runners.destroy.items.reverse();
        this.runners.destroy.emit(options);
        Object.values(this.runners).forEach((runner)=>{
            runner.destroy();
        });
        this._systemsHash = null;
        this.renderPipes = null;
    }
    /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */ generateTexture(options) {
        return this.textureGenerator.generateTexture(options);
    }
    /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    /**
   * Overrideable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */ _unsafeEvalCheck() {
        if (!(0, $92wAN.unsafeEvalSupported)()) throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
    }
};
/** The default options for the renderer. */ $809d6488275fc714$var$_AbstractRenderer.defaultOptions = {
    /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */ resolution: 1,
    /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */ failIfMajorPerformanceCaveat: false,
    /**
   * Should round pixels be forced when rendering?
   * @default false
   */ roundPixels: false
};
let $809d6488275fc714$export$58ab3ed211eed562 = $809d6488275fc714$var$_AbstractRenderer;

});
parcelRegister("92wAN", function(module, exports) {

$parcel$export(module.exports, "unsafeEvalSupported", () => $0c95344f1565c026$export$70c0711f29adc5cf);
"use strict";
let $0c95344f1565c026$var$unsafeEval;
function $0c95344f1565c026$export$70c0711f29adc5cf() {
    if (typeof $0c95344f1565c026$var$unsafeEval === "boolean") return $0c95344f1565c026$var$unsafeEval;
    try {
        const func = new Function("param1", "param2", "param3", "return param1[param2] === param3;");
        $0c95344f1565c026$var$unsafeEval = func({
            a: "b"
        }, "a", "b") === true;
    } catch (e) {
        $0c95344f1565c026$var$unsafeEval = false;
    }
    return $0c95344f1565c026$var$unsafeEval;
}

});

parcelRegister("7ItRq", function(module, exports) {

$parcel$export(module.exports, "CLEAR", () => $63bbdff1e5be0e1d$export$6c4d37c7f376a1de);
"use strict";
var $63bbdff1e5be0e1d$export$6c4d37c7f376a1de = /* @__PURE__ */ ((CLEAR2)=>{
    CLEAR2[CLEAR2["NONE"] = 0] = "NONE";
    CLEAR2[CLEAR2["COLOR"] = 16384] = "COLOR";
    CLEAR2[CLEAR2["STENCIL"] = 1024] = "STENCIL";
    CLEAR2[CLEAR2["DEPTH"] = 256] = "DEPTH";
    CLEAR2[CLEAR2["COLOR_DEPTH"] = 16640] = "COLOR_DEPTH";
    CLEAR2[CLEAR2["COLOR_STENCIL"] = 17408] = "COLOR_STENCIL";
    CLEAR2[CLEAR2["DEPTH_STENCIL"] = 1280] = "DEPTH_STENCIL";
    CLEAR2[CLEAR2["ALL"] = 17664] = "ALL";
    return CLEAR2;
})($63bbdff1e5be0e1d$export$6c4d37c7f376a1de || {});

});

parcelRegister("abOdb", function(module, exports) {

$parcel$export(module.exports, "SystemRunner", () => $dc812d5c49f81f11$export$ff5f2fe687fe3979);
"use strict";
class $dc812d5c49f81f11$export$ff5f2fe687fe3979 {
    /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */ constructor(name){
        this.items = [];
        this._name = name;
    }
    /* eslint-disable jsdoc/require-param, jsdoc/check-param-names */ /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */ /*  eslint-enable jsdoc/require-param, jsdoc/check-param-names */ emit(a0, a1, a2, a3, a4, a5, a6, a7) {
        const { name: name, items: items } = this;
        for(let i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        return this;
    }
    /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */ add(item) {
        if (item[this._name]) {
            this.remove(item);
            this.items.push(item);
        }
        return this;
    }
    /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */ remove(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) this.items.splice(index, 1);
        return this;
    }
    /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */ contains(item) {
        return this.items.indexOf(item) !== -1;
    }
    /** Remove all listeners from the Runner */ removeAll() {
        this.items.length = 0;
        return this;
    }
    /** Remove all references, don't use after this. */ destroy() {
        this.removeAll();
        this.items = null;
        this._name = null;
    }
    /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */ get empty() {
        return this.items.length === 0;
    }
    /**
   * The name of the runner.
   * @readonly
   */ get name() {
        return this._name;
    }
}

});


parcelRegister("h8UHn", function(module, exports) {

var $5xBLx = parcelRequire("5xBLx");
module.exports = Promise.all([
    $5xBLx("3ZLVG"),
    $5xBLx("jgEe0"),
    $5xBLx("01FTB")
]).then(()=>parcelRequire("bZhvE"));

});

parcelRegister("4ZUXm", function(module, exports) {

var $5xBLx = parcelRequire("5xBLx");
module.exports = Promise.all([
    $5xBLx("3ZLVG"),
    $5xBLx("jgEe0"),
    $5xBLx("4yKny")
]).then(()=>parcelRequire("jTsr0"));

});

parcelRegister("gMeQx", function(module, exports) {

$parcel$export(module.exports, "GraphicsContext", () => $9d7c87f122e5c95a$export$cde35afe8b5f985);

var $gpXaq = parcelRequire("gpXaq");

var $bEj7k = parcelRequire("bEj7k");

var $3kR0G = parcelRequire("3kR0G");

var $bwMhC = parcelRequire("bwMhC");

var $jollT = parcelRequire("jollT");

var $by5BM = parcelRequire("by5BM");

var $j0fPb = parcelRequire("j0fPb");

var $3vloD = parcelRequire("3vloD");

var $8ccTX = parcelRequire("8ccTX");

var $a3KnI = parcelRequire("a3KnI");

var $5uEQO = parcelRequire("5uEQO");
"use strict";
const $9d7c87f122e5c95a$var$tmpPoint = new (0, $bwMhC.Point)();
const $9d7c87f122e5c95a$var$tempMatrix = new (0, $3kR0G.Matrix)();
const $9d7c87f122e5c95a$var$_GraphicsContext = class _GraphicsContext extends (0, (/*@__PURE__*/$parcel$interopDefault($gpXaq))) {
    constructor(){
        super(...arguments);
        this.uid = (0, $by5BM.uid)("graphicsContext");
        this.dirty = true;
        this.batchMode = "auto";
        this.instructions = [];
        this._activePath = new (0, $8ccTX.GraphicsPath)();
        this._transform = new (0, $3kR0G.Matrix)();
        this._fillStyle = {
            ..._GraphicsContext.defaultFillStyle
        };
        this._strokeStyle = {
            ..._GraphicsContext.defaultStrokeStyle
        };
        this._stateStack = [];
        this._tick = 0;
        this._bounds = new (0, $3vloD.Bounds)();
        this._boundsDirty = true;
    }
    /**
   * Creates a new GraphicsContext object that is a clone of this instance, copying all properties,
   * including the current drawing state, transformations, styles, and instructions.
   * @returns A new GraphicsContext instance with the same properties and state as this one.
   */ clone() {
        const clone = new _GraphicsContext();
        clone.batchMode = this.batchMode;
        clone.instructions = this.instructions.slice();
        clone._activePath = this._activePath.clone();
        clone._transform = this._transform.clone();
        clone._fillStyle = {
            ...this._fillStyle
        };
        clone._strokeStyle = {
            ...this._strokeStyle
        };
        clone._stateStack = this._stateStack.slice();
        clone._bounds = this._bounds.clone();
        clone._boundsDirty = true;
        return clone;
    }
    /**
   * The current fill style of the graphics context. This can be a color, gradient, pattern, or a more complex style defined by a FillStyle object.
   */ get fillStyle() {
        return this._fillStyle;
    }
    set fillStyle(value) {
        this._fillStyle = (0, $5uEQO.convertFillInputToFillStyle)(value, _GraphicsContext.defaultFillStyle);
    }
    /**
   * The current stroke style of the graphics context. Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   */ get strokeStyle() {
        return this._strokeStyle;
    }
    set strokeStyle(value) {
        this._strokeStyle = (0, $5uEQO.convertFillInputToFillStyle)(value, _GraphicsContext.defaultStrokeStyle);
    }
    /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param style - The fill style to apply. This can be a simple color, a gradient or pattern object,
   *                or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setFillStyle(style) {
        this._fillStyle = (0, $5uEQO.convertFillInputToFillStyle)(style, _GraphicsContext.defaultFillStyle);
        return this;
    }
    /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param style - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   *                or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setStrokeStyle(style) {
        this._strokeStyle = (0, $5uEQO.convertFillInputToFillStyle)(style, _GraphicsContext.defaultStrokeStyle);
        return this;
    }
    texture(texture, tint, dx, dy, dw, dh) {
        this.instructions.push({
            action: "texture",
            data: {
                image: texture,
                dx: dx || 0,
                dy: dy || 0,
                dw: dw || texture.frame.width,
                dh: dh || texture.frame.height,
                transform: this._transform.clone(),
                alpha: this._fillStyle.alpha,
                style: tint ? (0, $bEj7k.Color).shared.setValue(tint).toNumber() : 16777215
            }
        });
        this.onUpdate();
        return this;
    }
    /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ beginPath() {
        this._activePath = new (0, $8ccTX.GraphicsPath)();
        return this;
    }
    fill(style, alpha) {
        let path;
        const lastInstruction = this.instructions[this.instructions.length - 1];
        if (this._tick === 0 && lastInstruction && lastInstruction.action === "stroke") path = lastInstruction.data.path;
        else path = this._activePath.clone();
        if (!path) return this;
        if (style != null) {
            if (alpha !== void 0 && typeof style === "number") {
                (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "GraphicsContext.fill(color, alpha) is deprecated, use GraphicsContext.fill({ color, alpha }) instead");
                style = {
                    color: style,
                    alpha: alpha
                };
            }
            this._fillStyle = (0, $5uEQO.convertFillInputToFillStyle)(style, _GraphicsContext.defaultFillStyle);
        }
        this.instructions.push({
            action: "fill",
            // TODO copy fill style!
            data: {
                style: this.fillStyle,
                path: path
            }
        });
        this.onUpdate();
        this._initNextPathLocation();
        this._tick = 0;
        return this;
    }
    _initNextPathLocation() {
        const { x: x, y: y } = this._activePath.getLastPoint((0, $bwMhC.Point).shared);
        this._activePath.clear();
        this._activePath.moveTo(x, y);
    }
    /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillStyleInputs parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param style - (Optional) The stroke style to apply. Can be defined as a simple color or a more complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ stroke(style) {
        let path;
        const lastInstruction = this.instructions[this.instructions.length - 1];
        if (this._tick === 0 && lastInstruction && lastInstruction.action === "fill") path = lastInstruction.data.path;
        else path = this._activePath.clone();
        if (!path) return this;
        if (style != null) this._strokeStyle = (0, $5uEQO.convertFillInputToFillStyle)(style, _GraphicsContext.defaultStrokeStyle);
        this.instructions.push({
            action: "stroke",
            // TODO copy fill style!
            data: {
                style: this.strokeStyle,
                path: path
            }
        });
        this.onUpdate();
        this._initNextPathLocation();
        this._tick = 0;
        return this;
    }
    /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   * @returns The instance of the current GraphicsContext for method chaining.
   */ cut() {
        for(let i = 0; i < 2; i++){
            const lastInstruction = this.instructions[this.instructions.length - 1 - i];
            const holePath = this._activePath.clone();
            if (lastInstruction) {
                if (lastInstruction.action === "stroke" || lastInstruction.action === "fill") {
                    if (lastInstruction.data.hole) lastInstruction.data.hole.addPath(holePath);
                    else {
                        lastInstruction.data.hole = holePath;
                        break;
                    }
                }
            }
        }
        this._initNextPathLocation();
        return this;
    }
    /**
   * Adds an arc to the current path, which is centered at (x, y) with the specified radius,
   * starting and ending angles, and direction.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The arc's radius.
   * @param startAngle - The starting angle, in radians.
   * @param endAngle - The ending angle, in radians.
   * @param counterclockwise - (Optional) Specifies whether the arc is drawn counterclockwise (true) or clockwise (false). Defaults to false.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ arc(x, y, radius, startAngle, endAngle, counterclockwise) {
        this._tick++;
        const t = this._transform;
        this._activePath.arc(t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    /**
   * Adds an arc to the current path with the given control points and radius, connected to the previous point
   * by a straight line if necessary.
   * @param x1 - The x-coordinate of the first control point.
   * @param y1 - The y-coordinate of the first control point.
   * @param x2 - The x-coordinate of the second control point.
   * @param y2 - The y-coordinate of the second control point.
   * @param radius - The arc's radius.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ arcTo(x1, y1, x2, y2, radius) {
        this._tick++;
        const t = this._transform;
        this._activePath.arcTo(t.a * x1 + t.c * y1 + t.tx, t.b * x1 + t.d * y1 + t.ty, t.a * x2 + t.c * y2 + t.tx, t.b * x2 + t.d * y2 + t.ty, radius);
        return this;
    }
    /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */ arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
        this._tick++;
        const t = this._transform;
        this._activePath.arcToSvg(rx, ry, xAxisRotation, // should we rotate this with transform??
        largeArcFlag, sweepFlag, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty);
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y, smoothness) {
        this._tick++;
        const t = this._transform;
        this._activePath.bezierCurveTo(t.a * cp1x + t.c * cp1y + t.tx, t.b * cp1x + t.d * cp1y + t.ty, t.a * cp2x + t.c * cp2y + t.tx, t.b * cp2x + t.d * cp2y + t.ty, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, smoothness);
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this._tick++;
        this._activePath?.closePath();
        return this;
    }
    /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @returns The instance of the current object for chaining.
   */ ellipse(x, y, radiusX, radiusY) {
        this._tick++;
        this._activePath.ellipse(x, y, radiusX, radiusY, this._transform.clone());
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius) {
        this._tick++;
        this._activePath.circle(x, y, radius, this._transform.clone());
        return this;
    }
    /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @returns The instance of the current object for chaining.
   */ path(path) {
        this._tick++;
        this._activePath.addPath(path, this._transform.clone());
        return this;
    }
    /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */ lineTo(x, y) {
        this._tick++;
        const t = this._transform;
        this._activePath.lineTo(t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty);
        return this;
    }
    /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */ moveTo(x, y) {
        this._tick++;
        const t = this._transform;
        const instructions = this._activePath.instructions;
        const transformedX = t.a * x + t.c * y + t.tx;
        const transformedY = t.b * x + t.d * y + t.ty;
        if (instructions.length === 1 && instructions[0].action === "moveTo") {
            instructions[0].data[0] = transformedX;
            instructions[0].data[1] = transformedY;
            return this;
        }
        this._activePath.moveTo(transformedX, transformedY);
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cpx - The x-coordinate of the control point.
   * @param cpy - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveTo(cpx, cpy, x, y, smoothness) {
        this._tick++;
        const t = this._transform;
        this._activePath.quadraticCurveTo(t.a * cpx + t.c * cpy + t.tx, t.b * cpx + t.d * cpy + t.ty, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, smoothness);
        return this;
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h) {
        this._tick++;
        this._activePath.rect(x, y, w, h, this._transform.clone());
        return this;
    }
    /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @returns The instance of the current object for chaining.
   */ roundRect(x, y, w, h, radius) {
        this._tick++;
        this._activePath.roundRect(x, y, w, h, radius, this._transform.clone());
        return this;
    }
    /**
   * Draws a polygon shape by specifying a sequence of points. This method allows for the creation of complex polygons,
   * which can be both open and closed. An optional transformation can be applied, enabling the polygon to be scaled,
   * rotated, or translated as needed.
   * @param points - An array of numbers, or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates, of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   */ poly(points, close) {
        this._tick++;
        this._activePath.poly(points, close, this._transform.clone());
        return this;
    }
    /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ regularPoly(x, y, radius, sides, rotation = 0, transform) {
        this._tick++;
        this._activePath.regularPoly(x, y, radius, sides, rotation, transform);
        return this;
    }
    /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @returns The instance of the current object for chaining.
   */ roundPoly(x, y, radius, sides, corner, rotation) {
        this._tick++;
        this._activePath.roundPoly(x, y, radius, sides, corner, rotation);
        return this;
    }
    /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */ roundShape(points, radius, useQuadratic, smoothness) {
        this._tick++;
        this._activePath.roundShape(points, radius, useQuadratic, smoothness);
        return this;
    }
    /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */ filletRect(x, y, width, height, fillet) {
        this._tick++;
        this._activePath.filletRect(x, y, width, height, fillet);
        return this;
    }
    /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */ chamferRect(x, y, width, height, chamfer, transform) {
        this._tick++;
        this._activePath.chamferRect(x, y, width, height, chamfer, transform);
        return this;
    }
    /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @returns The instance of the current object for chaining further drawing commands.
   */ star(x, y, points, radius, innerRadius = 0, rotation = 0) {
        this._tick++;
        this._activePath.star(x, y, points, radius, innerRadius, rotation, this._transform.clone());
        return this;
    }
    /**
   * Parses and renders an SVG string into the graphics context. This allows for complex shapes and paths
   * defined in SVG format to be drawn within the graphics context.
   * @param svg - The SVG string to be parsed and rendered.
   */ svg(svg) {
        this._tick++;
        (0, $a3KnI.SVGParser)(svg, this);
        return this;
    }
    /**
   * Restores the most recently saved graphics state by popping the top of the graphics state stack.
   * This includes transformations, fill styles, and stroke styles.
   */ restore() {
        const state = this._stateStack.pop();
        if (state) {
            this._transform = state.transform;
            this._fillStyle = state.fillStyle;
            this._strokeStyle = state.strokeStyle;
        }
        return this;
    }
    /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */ save() {
        this._stateStack.push({
            transform: this._transform.clone(),
            fillStyle: {
                ...this._fillStyle
            },
            strokeStyle: {
                ...this._strokeStyle
            }
        });
        return this;
    }
    /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */ getTransform() {
        return this._transform;
    }
    /**
   * Resets the current transformation matrix to the identity matrix, effectively removing any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ resetTransform() {
        this._transform.identity();
        return this;
    }
    /**
   * Applies a rotation transformation to the graphics context around the current origin.
   * @param angle - The angle of rotation in radians.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ rotate(angle) {
        this._transform.rotate(angle);
        return this;
    }
    /**
   * Applies a scaling transformation to the graphics context, scaling drawings by x horizontally and by y vertically.
   * @param x - The scale factor in the horizontal direction.
   * @param y - (Optional) The scale factor in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ scale(x, y = x) {
        this._transform.scale(x, y);
        return this;
    }
    setTransform(a, b, c, d, dx, dy) {
        if (a instanceof (0, $3kR0G.Matrix)) {
            this._transform.set(a.a, a.b, a.c, a.d, a.tx, a.ty);
            return this;
        }
        this._transform.set(a, b, c, d, dx, dy);
        return this;
    }
    transform(a, b, c, d, dx, dy) {
        if (a instanceof (0, $3kR0G.Matrix)) {
            this._transform.append(a);
            return this;
        }
        $9d7c87f122e5c95a$var$tempMatrix.set(a, b, c, d, dx, dy);
        this._transform.append($9d7c87f122e5c95a$var$tempMatrix);
        return this;
    }
    /**
   * Applies a translation transformation to the graphics context, moving the origin by the specified amounts.
   * @param x - The amount to translate in the horizontal direction.
   * @param y - (Optional) The amount to translate in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ translate(x, y = x) {
        this._transform.translate(x, y);
        return this;
    }
    /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ clear() {
        this.instructions.length = 0;
        this.resetTransform();
        this.onUpdate();
        return this;
    }
    onUpdate() {
        if (this.dirty) return;
        this.emit("update", this, 16);
        this.dirty = true;
        this._boundsDirty = true;
    }
    /** The bounds of the graphic shape. */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        const bounds = this._bounds;
        bounds.clear();
        for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            const action = instruction.action;
            if (action === "fill") {
                const data = instruction.data;
                bounds.addBounds(data.path.bounds);
            } else if (action === "texture") {
                const data = instruction.data;
                bounds.addFrame(data.dx, data.dy, data.dx + data.dw, data.dy + data.dh, data.transform);
            }
            if (action === "stroke") {
                const data = instruction.data;
                const padding = data.style.width / 2;
                const _bounds = data.path.bounds;
                bounds.addFrame(_bounds.minX - padding, _bounds.minY - padding, _bounds.maxX + padding, _bounds.maxY + padding);
            }
        }
        return bounds;
    }
    /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */ containsPoint(point) {
        if (!this.bounds.containsPoint(point.x, point.y)) return false;
        const instructions = this.instructions;
        let hasHit = false;
        for(let k = 0; k < instructions.length; k++){
            const instruction = instructions[k];
            const data = instruction.data;
            const path = data.path;
            if (!instruction.action || !path) continue;
            const style = data.style;
            const shapes = path.shapePath.shapePrimitives;
            for(let i = 0; i < shapes.length; i++){
                const shape = shapes[i].shape;
                if (!style || !shape) continue;
                const transform = shapes[i].transform;
                const transformedPoint = transform ? transform.applyInverse(point, $9d7c87f122e5c95a$var$tmpPoint) : point;
                if (instruction.action === "fill") hasHit = shape.contains(transformedPoint.x, transformedPoint.y);
                else hasHit = shape.strokeContains(transformedPoint.x, transformedPoint.y, style.width);
                const holes = data.hole;
                if (holes) {
                    const holeShapes = holes.shapePath?.shapePrimitives;
                    if (holeShapes) {
                        for(let j = 0; j < holeShapes.length; j++)if (holeShapes[j].shape.contains(transformedPoint.x, transformedPoint.y)) hasHit = false;
                    }
                }
                if (hasHit) return true;
            }
        }
        return hasHit;
    }
    /**
   * Destroys the GraphicsData object.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the fill/stroke style?
   * @param {boolean} [options.textureSource=false] - Should it destroy the texture source of the fill/stroke style?
   */ destroy(options = false) {
        this._stateStack.length = 0;
        this._transform = null;
        this.emit("destroy", this);
        this.removeAllListeners();
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            if (this._fillStyle.texture) this._fillStyle.texture.destroy(destroyTextureSource);
            if (this._strokeStyle.texture) this._strokeStyle.texture.destroy(destroyTextureSource);
        }
        this._fillStyle = null;
        this._strokeStyle = null;
        this.instructions = null;
        this._activePath = null;
        this._bounds = null;
        this._stateStack = null;
        this.customShader = null;
        this._transform = null;
    }
};
/** The default fill style to use when none is provided. */ $9d7c87f122e5c95a$var$_GraphicsContext.defaultFillStyle = {
    /** The color to use for the fill. */ color: 16777215,
    /** The alpha value to use for the fill. */ alpha: 1,
    /** The texture to use for the fill. */ texture: (0, $jollT.Texture).WHITE,
    /** The matrix to apply. */ matrix: null,
    /** The fill pattern to use. */ fill: null
};
/** The default stroke style to use when none is provided. */ $9d7c87f122e5c95a$var$_GraphicsContext.defaultStrokeStyle = {
    /** The width of the stroke. */ width: 1,
    /** The color to use for the stroke. */ color: 16777215,
    /** The alpha value to use for the stroke. */ alpha: 1,
    /** The alignment of the stroke. */ alignment: 0.5,
    /** The miter limit to use. */ miterLimit: 10,
    /** The line cap style to use. */ cap: "butt",
    /** The line join style to use. */ join: "miter",
    /** The texture to use for the fill. */ texture: (0, $jollT.Texture).WHITE,
    /** The matrix to apply. */ matrix: null,
    /** The fill pattern to use. */ fill: null
};
let $9d7c87f122e5c95a$export$cde35afe8b5f985 = $9d7c87f122e5c95a$var$_GraphicsContext;

});
parcelRegister("8ccTX", function(module, exports) {

$parcel$export(module.exports, "GraphicsPath", () => $78b9c6b5b96010b7$export$7e54506375634c19);

var $bwMhC = parcelRequire("bwMhC");

var $by5BM = parcelRequire("by5BM");

var $1q6Bk = parcelRequire("1q6Bk");

var $juBp6 = parcelRequire("juBp6");

var $gqKyR = parcelRequire("gqKyR");
"use strict";
class $78b9c6b5b96010b7$export$7e54506375634c19 {
    /**
   * Creates a `GraphicsPath` instance optionally from an SVG path string or an array of `PathInstruction`.
   * @param instructions - An SVG path string or an array of `PathInstruction` objects.
   */ constructor(instructions){
        this.instructions = [];
        this.uid = (0, $by5BM.uid)("graphicsPath");
        this._dirty = true;
        if (typeof instructions === "string") (0, $juBp6.SVGToGraphicsPath)(instructions, this);
        else this.instructions = instructions?.slice() ?? [];
    }
    /**
   * Provides access to the internal shape path, ensuring it is up-to-date with the current instructions.
   * @returns The `ShapePath` instance associated with this `GraphicsPath`.
   */ get shapePath() {
        if (!this._shapePath) this._shapePath = new (0, $gqKyR.ShapePath)(this);
        if (this._dirty) {
            this._dirty = false;
            this._shapePath.buildPath();
        }
        return this._shapePath;
    }
    /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @param transform - An optional transformation to apply to the added path.
   * @returns The instance of the current object for chaining.
   */ addPath(path, transform) {
        path = path.clone();
        this.instructions.push({
            action: "addPath",
            data: [
                path,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    arc(...args) {
        this.instructions.push({
            action: "arc",
            data: args
        });
        this._dirty = true;
        return this;
    }
    arcTo(...args) {
        this.instructions.push({
            action: "arcTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    arcToSvg(...args) {
        this.instructions.push({
            action: "arcToSvg",
            data: args
        });
        this._dirty = true;
        return this;
    }
    bezierCurveTo(...args) {
        this.instructions.push({
            action: "bezierCurveTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires two points: the second control point and the end point. The first control point is assumed to be
   * The starting point is the last point in the current path.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveToShort(cp2x, cp2y, x, y, smoothness) {
        const last = this.instructions[this.instructions.length - 1];
        const lastPoint = this.getLastPoint((0, $bwMhC.Point).shared);
        let cp1x = 0;
        let cp1y = 0;
        if (!last || last.action !== "bezierCurveTo") {
            cp1x = lastPoint.x;
            cp1y = lastPoint.y;
        } else {
            cp1x = last.data[2];
            cp1y = last.data[3];
            const currentX = lastPoint.x;
            const currentY = lastPoint.y;
            cp1x = currentX + (currentX - cp1x);
            cp1y = currentY + (currentY - cp1y);
        }
        this.instructions.push({
            action: "bezierCurveTo",
            data: [
                cp1x,
                cp1y,
                cp2x,
                cp2y,
                x,
                y,
                smoothness
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this.instructions.push({
            action: "closePath",
            data: []
        });
        this._dirty = true;
        return this;
    }
    ellipse(...args) {
        this.instructions.push({
            action: "ellipse",
            data: args
        });
        this._dirty = true;
        return this;
    }
    lineTo(...args) {
        this.instructions.push({
            action: "lineTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    moveTo(...args) {
        this.instructions.push({
            action: "moveTo",
            data: args
        });
        return this;
    }
    quadraticCurveTo(...args) {
        this.instructions.push({
            action: "quadraticCurveTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It uses the previous point as the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveToShort(x, y, smoothness) {
        const last = this.instructions[this.instructions.length - 1];
        const lastPoint = this.getLastPoint((0, $bwMhC.Point).shared);
        let cpx1 = 0;
        let cpy1 = 0;
        if (!last || last.action !== "quadraticCurveTo") {
            cpx1 = lastPoint.x;
            cpy1 = lastPoint.y;
        } else {
            cpx1 = last.data[0];
            cpy1 = last.data[1];
            const currentX = lastPoint.x;
            const currentY = lastPoint.y;
            cpx1 = currentX + (currentX - cpx1);
            cpy1 = currentY + (currentY - cpy1);
        }
        this.instructions.push({
            action: "quadraticCurveTo",
            data: [
                cpx1,
                cpy1,
                x,
                y,
                smoothness
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h, transform) {
        this.instructions.push({
            action: "rect",
            data: [
                x,
                y,
                w,
                h,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius, transform) {
        this.instructions.push({
            action: "circle",
            data: [
                x,
                y,
                radius,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    roundRect(...args) {
        this.instructions.push({
            action: "roundRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    poly(...args) {
        this.instructions.push({
            action: "poly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    regularPoly(...args) {
        this.instructions.push({
            action: "regularPoly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    roundPoly(...args) {
        this.instructions.push({
            action: "roundPoly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    roundShape(...args) {
        this.instructions.push({
            action: "roundShape",
            data: args
        });
        this._dirty = true;
        return this;
    }
    filletRect(...args) {
        this.instructions.push({
            action: "filletRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    chamferRect(...args) {
        this.instructions.push({
            action: "chamferRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @param transform - An optional `Matrix` object to apply a transformation to the star.
   * This can include rotations, scaling, and translations.
   * @returns The instance of the current object for chaining further drawing commands.
   */ // eslint-disable-next-line max-len
    star(x, y, points, radius, innerRadius, rotation, transform) {
        innerRadius = innerRadius || radius / 2;
        const startAngle = -1 * Math.PI / 2 + rotation;
        const len = points * 2;
        const delta = Math.PI * 2 / len;
        const polygon = [];
        for(let i = 0; i < len; i++){
            const r = i % 2 ? innerRadius : radius;
            const angle = i * delta + startAngle;
            polygon.push(x + r * Math.cos(angle), y + r * Math.sin(angle));
        }
        this.poly(polygon, true, transform);
        return this;
    }
    /**
   * Creates a copy of the current `GraphicsPath` instance. This method supports both shallow and deep cloning.
   * A shallow clone copies the reference of the instructions array, while a deep clone creates a new array and
   * copies each instruction individually, ensuring that modifications to the instructions of the cloned `GraphicsPath`
   * do not affect the original `GraphicsPath` and vice versa.
   * @param deep - A boolean flag indicating whether the clone should be deep.
   * @returns A new `GraphicsPath` instance that is a clone of the current instance.
   */ clone(deep = false) {
        const newGraphicsPath2D = new $78b9c6b5b96010b7$export$7e54506375634c19();
        if (!deep) newGraphicsPath2D.instructions = this.instructions.slice();
        else for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            newGraphicsPath2D.instructions.push({
                action: instruction.action,
                data: instruction.data.slice()
            });
        }
        return newGraphicsPath2D;
    }
    clear() {
        this.instructions.length = 0;
        this._dirty = true;
        return this;
    }
    /**
   * Applies a transformation matrix to all drawing instructions within the `GraphicsPath`.
   * This method enables the modification of the path's geometry according to the provided
   * transformation matrix, which can include translations, rotations, scaling, and skewing.
   *
   * Each drawing instruction in the path is updated to reflect the transformation,
   * ensuring the visual representation of the path is consistent with the applied matrix.
   *
   * Note: The transformation is applied directly to the coordinates and control points of the drawing instructions,
   * not to the path as a whole. This means the transformation's effects are baked into the individual instructions,
   * allowing for fine-grained control over the path's appearance.
   * @param matrix - A `Matrix` object representing the transformation to apply.
   * @returns The instance of the current object for chaining further operations.
   */ transform(matrix) {
        if (matrix.isIdentity()) return this;
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let x = 0;
        let y = 0;
        let cpx1 = 0;
        let cpy1 = 0;
        let cpx2 = 0;
        let cpy2 = 0;
        let rx = 0;
        let ry = 0;
        for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            const data = instruction.data;
            switch(instruction.action){
                case "moveTo":
                case "lineTo":
                    x = data[0];
                    y = data[1];
                    data[0] = a * x + c * y + tx;
                    data[1] = b * x + d * y + ty;
                    break;
                case "bezierCurveTo":
                    cpx1 = data[0];
                    cpy1 = data[1];
                    cpx2 = data[2];
                    cpy2 = data[3];
                    x = data[4];
                    y = data[5];
                    data[0] = a * cpx1 + c * cpy1 + tx;
                    data[1] = b * cpx1 + d * cpy1 + ty;
                    data[2] = a * cpx2 + c * cpy2 + tx;
                    data[3] = b * cpx2 + d * cpy2 + ty;
                    data[4] = a * x + c * y + tx;
                    data[5] = b * x + d * y + ty;
                    break;
                case "quadraticCurveTo":
                    cpx1 = data[0];
                    cpy1 = data[1];
                    x = data[2];
                    y = data[3];
                    data[0] = a * cpx1 + c * cpy1 + tx;
                    data[1] = b * cpx1 + d * cpy1 + ty;
                    data[2] = a * x + c * y + tx;
                    data[3] = b * x + d * y + ty;
                    break;
                case "arcToSvg":
                    x = data[5];
                    y = data[6];
                    rx = data[0];
                    ry = data[1];
                    data[0] = a * rx + c * ry;
                    data[1] = b * rx + d * ry;
                    data[5] = a * x + c * y + tx;
                    data[6] = b * x + d * y + ty;
                    break;
                case "circle":
                    data[4] = $78b9c6b5b96010b7$var$adjustTransform(data[3], matrix);
                    break;
                case "rect":
                    data[4] = $78b9c6b5b96010b7$var$adjustTransform(data[4], matrix);
                    break;
                case "ellipse":
                    data[8] = $78b9c6b5b96010b7$var$adjustTransform(data[8], matrix);
                    break;
                case "roundRect":
                    data[5] = $78b9c6b5b96010b7$var$adjustTransform(data[5], matrix);
                    break;
                case "addPath":
                    data[0].transform(matrix);
                    break;
                case "poly":
                    data[2] = $78b9c6b5b96010b7$var$adjustTransform(data[2], matrix);
                    break;
                default:
                    (0, $1q6Bk.warn)("unknown transform action", instruction.action);
                    break;
            }
        }
        this._dirty = true;
        return this;
    }
    get bounds() {
        return this.shapePath.bounds;
    }
    /**
   * Retrieves the last point from the current drawing instructions in the `GraphicsPath`.
   * This method is useful for operations that depend on the path's current endpoint,
   * such as connecting subsequent shapes or paths. It supports various drawing instructions,
   * ensuring the last point's position is accurately determined regardless of the path's complexity.
   *
   * If the last instruction is a `closePath`, the method iterates backward through the instructions
   *  until it finds an actionable instruction that defines a point (e.g., `moveTo`, `lineTo`,
   * `quadraticCurveTo`, etc.). For compound paths added via `addPath`, it recursively retrieves
   * the last point from the nested path.
   * @param out - A `Point` object where the last point's coordinates will be stored.
   * This object is modified directly to contain the result.
   * @returns The `Point` object containing the last point's coordinates.
   */ getLastPoint(out) {
        let index = this.instructions.length - 1;
        let lastInstruction = this.instructions[index];
        if (!lastInstruction) {
            out.x = 0;
            out.y = 0;
            return out;
        }
        while(lastInstruction.action === "closePath"){
            index--;
            if (index < 0) {
                out.x = 0;
                out.y = 0;
                return out;
            }
            lastInstruction = this.instructions[index];
        }
        switch(lastInstruction.action){
            case "moveTo":
            case "lineTo":
                out.x = lastInstruction.data[0];
                out.y = lastInstruction.data[1];
                break;
            case "quadraticCurveTo":
                out.x = lastInstruction.data[2];
                out.y = lastInstruction.data[3];
                break;
            case "bezierCurveTo":
                out.x = lastInstruction.data[4];
                out.y = lastInstruction.data[5];
                break;
            case "arc":
            case "arcToSvg":
                out.x = lastInstruction.data[5];
                out.y = lastInstruction.data[6];
                break;
            case "addPath":
                lastInstruction.data[0].getLastPoint(out);
                break;
        }
        return out;
    }
}
function $78b9c6b5b96010b7$var$adjustTransform(currentMatrix, transform) {
    if (currentMatrix) return currentMatrix.prepend(transform);
    return transform.clone();
}

});
parcelRegister("juBp6", function(module, exports) {

$parcel$export(module.exports, "SVGToGraphicsPath", () => $19f41e7ea0c0443c$export$14a4a8042d02aa8d);

var $eJJJX = parcelRequire("eJJJX");

var $1q6Bk = parcelRequire("1q6Bk");
"use strict";
function $19f41e7ea0c0443c$export$14a4a8042d02aa8d(svgPath, path) {
    const commands = (0, (/*@__PURE__*/$parcel$interopDefault($eJJJX)))(svgPath);
    const subpaths = [];
    let currentSubPath = null;
    let lastX = 0;
    let lastY = 0;
    for(let i = 0; i < commands.length; i++){
        const command = commands[i];
        const type = command[0];
        const data = command;
        switch(type){
            case "M":
                lastX = data[1];
                lastY = data[2];
                path.moveTo(lastX, lastY);
                break;
            case "m":
                lastX += data[1];
                lastY += data[2];
                path.moveTo(lastX, lastY);
                break;
            case "H":
                lastX = data[1];
                path.lineTo(lastX, lastY);
                break;
            case "h":
                lastX += data[1];
                path.lineTo(lastX, lastY);
                break;
            case "V":
                lastY = data[1];
                path.lineTo(lastX, lastY);
                break;
            case "v":
                lastY += data[1];
                path.lineTo(lastX, lastY);
                break;
            case "L":
                lastX = data[1];
                lastY = data[2];
                path.lineTo(lastX, lastY);
                break;
            case "l":
                lastX += data[1];
                lastY += data[2];
                path.lineTo(lastX, lastY);
                break;
            case "C":
                lastX = data[5];
                lastY = data[6];
                path.bezierCurveTo(data[1], data[2], data[3], data[4], lastX, lastY);
                break;
            case "c":
                path.bezierCurveTo(lastX + data[1], lastY + data[2], lastX + data[3], lastY + data[4], lastX + data[5], lastY + data[6]);
                lastX += data[5];
                lastY += data[6];
                break;
            case "S":
                lastX = data[3];
                lastY = data[4];
                path.bezierCurveToShort(data[1], data[2], lastX, lastY);
                break;
            case "s":
                path.bezierCurveToShort(lastX + data[1], lastY + data[2], lastX + data[3], lastY + data[4]);
                lastX += data[3];
                lastY += data[4];
                break;
            case "Q":
                lastX = data[3];
                lastY = data[4];
                path.quadraticCurveTo(data[1], data[2], lastX, lastY);
                break;
            case "q":
                path.quadraticCurveTo(lastX + data[1], lastY + data[2], lastX + data[3], lastY + data[4]);
                lastX += data[3];
                lastY += data[4];
                break;
            case "T":
                lastX = data[1];
                lastY = data[2];
                path.quadraticCurveToShort(lastX, lastY);
                break;
            case "t":
                lastX += data[1];
                lastY += data[2];
                path.quadraticCurveToShort(lastX, lastY);
                break;
            case "A":
                lastX = data[6];
                lastY = data[7];
                path.arcToSvg(data[1], data[2], data[3], data[4], data[5], lastX, lastY);
                break;
            case "a":
                lastX += data[6];
                lastY += data[7];
                path.arcToSvg(data[1], data[2], data[3], data[4], data[5], lastX, lastY);
                break;
            case "Z":
            case "z":
                path.closePath();
                if (subpaths.length > 0) {
                    currentSubPath = subpaths.pop();
                    if (currentSubPath) {
                        lastX = currentSubPath.startX;
                        lastY = currentSubPath.startY;
                    } else {
                        lastX = 0;
                        lastY = 0;
                    }
                }
                currentSubPath = null;
                break;
            default:
                (0, $1q6Bk.warn)(`Unknown SVG path command: ${type}`);
        }
        if (type !== "Z" && type !== "z") {
            if (currentSubPath === null) {
                currentSubPath = {
                    startX: lastX,
                    startY: lastY
                };
                subpaths.push(currentSubPath);
            }
        }
    }
    return path;
}

});
parcelRegister("eJJJX", function(module, exports) {
module.exports = $aba8bfb3df0db863$var$parse;
/**
 * expected argument lengths
 * @type {Object}
 */ var $aba8bfb3df0db863$var$length = {
    a: 7,
    c: 6,
    h: 1,
    l: 2,
    m: 2,
    q: 4,
    s: 4,
    t: 2,
    v: 1,
    z: 0
};
/**
 * segment pattern
 * @type {RegExp}
 */ var $aba8bfb3df0db863$var$segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
/**
 * parse an svg path data string. Generates an Array
 * of commands where each command is an Array of the
 * form `[command, arg1, arg2, ...]`
 *
 * @param {String} path
 * @return {Array}
 */ function $aba8bfb3df0db863$var$parse(path) {
    var data = [];
    path.replace($aba8bfb3df0db863$var$segment, function(_, command, args) {
        var type = command.toLowerCase();
        args = $aba8bfb3df0db863$var$parseValues(args);
        // overloaded moveTo
        if (type == "m" && args.length > 2) {
            data.push([
                command
            ].concat(args.splice(0, 2)));
            type = "l";
            command = command == "m" ? "l" : "L";
        }
        while(true){
            if (args.length == $aba8bfb3df0db863$var$length[type]) {
                args.unshift(command);
                return data.push(args);
            }
            if (args.length < $aba8bfb3df0db863$var$length[type]) throw new Error("malformed path data");
            data.push([
                command
            ].concat(args.splice(0, $aba8bfb3df0db863$var$length[type])));
        }
    });
    return data;
}
var $aba8bfb3df0db863$var$number = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
function $aba8bfb3df0db863$var$parseValues(args) {
    var numbers = args.match($aba8bfb3df0db863$var$number);
    return numbers ? numbers.map(Number) : [];
}

});


parcelRegister("gqKyR", function(module, exports) {

$parcel$export(module.exports, "ShapePath", () => $ed386e3bfa993cb6$export$148534a3c727230b);

var $duVYJ = parcelRequire("duVYJ");

var $aCytD = parcelRequire("aCytD");

var $1J187 = parcelRequire("1J187");

var $hFBUu = parcelRequire("hFBUu");

var $2Np5v = parcelRequire("2Np5v");

var $3vloD = parcelRequire("3vloD");

var $4fAWm = parcelRequire("4fAWm");

var $4plDg = parcelRequire("4plDg");

var $a2DH4 = parcelRequire("a2DH4");

var $4Kxwi = parcelRequire("4Kxwi");

var $RcJdn = parcelRequire("RcJdn");

var $8oBc0 = parcelRequire("8oBc0");
"use strict";
const $ed386e3bfa993cb6$var$tempRectangle = new (0, $hFBUu.Rectangle)();
class $ed386e3bfa993cb6$export$148534a3c727230b {
    constructor(graphicsPath2D){
        /** The list of shape primitives that make up the path. */ this.shapePrimitives = [];
        this._currentPoly = null;
        this._bounds = new (0, $3vloD.Bounds)();
        this._graphicsPath2D = graphicsPath2D;
    }
    /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */ moveTo(x, y) {
        this.startPoly(x, y);
        return this;
    }
    /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */ lineTo(x, y) {
        this._ensurePoly();
        const points = this._currentPoly.points;
        const fromX = points[points.length - 2];
        const fromY = points[points.length - 1];
        if (fromX !== x || fromY !== y) points.push(x, y);
        return this;
    }
    /**
   * Adds an arc to the path. The arc is centered at (x, y)
   *  position with radius `radius` starting at `startAngle` and ending at `endAngle`.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The radius of the arc.
   * @param startAngle - The starting angle of the arc, in radians.
   * @param endAngle - The ending angle of the arc, in radians.
   * @param counterclockwise - Specifies whether the arc should be drawn in the anticlockwise direction. False by default.
   * @returns The instance of the current object for chaining.
   */ arc(x, y, radius, startAngle, endAngle, counterclockwise) {
        this._ensurePoly(false);
        const points = this._currentPoly.points;
        (0, $a2DH4.buildArc)(points, x, y, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    /**
   * Adds an arc to the path with the arc tangent to the line joining two specified points.
   * The arc radius is specified by `radius`.
   * @param x1 - The x-coordinate of the first point.
   * @param y1 - The y-coordinate of the first point.
   * @param x2 - The x-coordinate of the second point.
   * @param y2 - The y-coordinate of the second point.
   * @param radius - The radius of the arc.
   * @returns The instance of the current object for chaining.
   */ arcTo(x1, y1, x2, y2, radius) {
        this._ensurePoly();
        const points = this._currentPoly.points;
        (0, $4Kxwi.buildArcTo)(points, x1, y1, x2, y2, radius);
        return this;
    }
    /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */ arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
        const points = this._currentPoly.points;
        (0, $RcJdn.buildArcToSvg)(points, this._currentPoly.lastX, this._currentPoly.lastY, x, y, rx, ry, xAxisRotation, largeArcFlag, sweepFlag);
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y, smoothness) {
        this._ensurePoly();
        const currentPoly = this._currentPoly;
        (0, $4fAWm.buildAdaptiveBezier)(this._currentPoly.points, currentPoly.lastX, currentPoly.lastY, cp1x, cp1y, cp2x, cp2y, x, y, smoothness);
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the control point.
   * @param cp1y - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothing - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveTo(cp1x, cp1y, x, y, smoothing) {
        this._ensurePoly();
        const currentPoly = this._currentPoly;
        (0, $4plDg.buildAdaptiveQuadratic)(this._currentPoly.points, currentPoly.lastX, currentPoly.lastY, cp1x, cp1y, x, y, smoothing);
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this.endPoly(true);
        return this;
    }
    /**
   * Adds another path to the current path. This method allows for the combination of multiple paths into one.
   * @param path - The `GraphicsPath` object representing the path to add.
   * @param transform - An optional `Matrix` object to apply a transformation to the path before adding it.
   * @returns The instance of the current object for chaining.
   */ addPath(path, transform) {
        this.endPoly();
        if (transform && !transform.isIdentity()) {
            path = path.clone(true);
            path.transform(transform);
        }
        for(let i = 0; i < path.instructions.length; i++){
            const instruction = path.instructions[i];
            this[instruction.action](...instruction.data);
        }
        return this;
    }
    /**
   * Finalizes the drawing of the current path. Optionally, it can close the path.
   * @param closePath - A boolean indicating whether to close the path after finishing. False by default.
   */ finish(closePath = false) {
        this.endPoly(closePath);
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h, transform) {
        this.drawShape(new (0, $hFBUu.Rectangle)(x, y, w, h), transform);
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius, transform) {
        this.drawShape(new (0, $duVYJ.Circle)(x, y, radius), transform);
        return this;
    }
    /**
   * Draws a polygon shape. This method allows for the creation of complex polygons by specifying a sequence of points.
   * @param points - An array of numbers, or or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ poly(points, close, transform) {
        const polygon = new (0, $1J187.Polygon)(points);
        polygon.closePath = close;
        this.drawShape(polygon, transform);
        return this;
    }
    /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ regularPoly(x, y, radius, sides, rotation = 0, transform) {
        sides = Math.max(sides | 0, 3);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const delta = Math.PI * 2 / sides;
        const polygon = [];
        for(let i = 0; i < sides; i++){
            const angle = i * delta + startAngle;
            polygon.push(x + radius * Math.cos(angle), y + radius * Math.sin(angle));
        }
        this.poly(polygon, true, transform);
        return this;
    }
    /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param smoothness - Optional parameter to adjust the smoothness of the rounding.
   * @returns The instance of the current object for chaining.
   */ roundPoly(x, y, radius, sides, corner, rotation = 0, smoothness) {
        sides = Math.max(sides | 0, 3);
        if (corner <= 0) return this.regularPoly(x, y, radius, sides, rotation);
        const sideLength = radius * Math.sin(Math.PI / sides) - 1e-3;
        corner = Math.min(corner, sideLength);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const delta = Math.PI * 2 / sides;
        const internalAngle = (sides - 2) * Math.PI / sides / 2;
        for(let i = 0; i < sides; i++){
            const angle = i * delta + startAngle;
            const x0 = x + radius * Math.cos(angle);
            const y0 = y + radius * Math.sin(angle);
            const a1 = angle + Math.PI + internalAngle;
            const a2 = angle - Math.PI - internalAngle;
            const x1 = x0 + corner * Math.cos(a1);
            const y1 = y0 + corner * Math.sin(a1);
            const x3 = x0 + corner * Math.cos(a2);
            const y3 = y0 + corner * Math.sin(a2);
            if (i === 0) this.moveTo(x1, y1);
            else this.lineTo(x1, y1);
            this.quadraticCurveTo(x0, y0, x3, y3, smoothness);
        }
        return this.closePath();
    }
    /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */ roundShape(points, radius, useQuadratic = false, smoothness) {
        if (points.length < 3) return this;
        if (useQuadratic) (0, $8oBc0.roundedShapeQuadraticCurve)(this, points, radius, smoothness);
        else (0, $8oBc0.roundedShapeArc)(this, points, radius);
        return this.closePath();
    }
    /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */ filletRect(x, y, width, height, fillet) {
        if (fillet === 0) return this.rect(x, y, width, height);
        const maxFillet = Math.min(width, height) / 2;
        const inset = Math.min(maxFillet, Math.max(-maxFillet, fillet));
        const right = x + width;
        const bottom = y + height;
        const dir = inset < 0 ? -inset : 0;
        const size = Math.abs(inset);
        return this.moveTo(x, y + size).arcTo(x + dir, y + dir, x + size, y, size).lineTo(right - size, y).arcTo(right - dir, y + dir, right, y + size, size).lineTo(right, bottom - size).arcTo(right - dir, bottom - dir, x + width - size, bottom, size).lineTo(x + size, bottom).arcTo(x + dir, bottom - dir, x, bottom - size, size).closePath();
    }
    /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */ chamferRect(x, y, width, height, chamfer, transform) {
        if (chamfer <= 0) return this.rect(x, y, width, height);
        const inset = Math.min(chamfer, Math.min(width, height) / 2);
        const right = x + width;
        const bottom = y + height;
        const points = [
            x + inset,
            y,
            right - inset,
            y,
            right,
            y + inset,
            right,
            bottom - inset,
            right - inset,
            bottom,
            x + inset,
            bottom,
            x,
            bottom - inset,
            x,
            y + inset
        ];
        for(let i = points.length - 1; i >= 2; i -= 2)if (points[i] === points[i - 2] && points[i - 1] === points[i - 3]) points.splice(i - 1, 2);
        return this.poly(points, true, transform);
    }
    /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @param transform - An optional `Matrix` object to apply a transformation to the ellipse. This can include rotations.
   * @returns The instance of the current object for chaining.
   */ ellipse(x, y, radiusX, radiusY, transform) {
        this.drawShape(new (0, $aCytD.Ellipse)(x, y, radiusX, radiusY), transform);
        return this;
    }
    /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ roundRect(x, y, w, h, radius, transform) {
        this.drawShape(new (0, $2Np5v.RoundedRectangle)(x, y, w, h, radius), transform);
        return this;
    }
    /**
   * Draws a given shape on the canvas.
   * This is a generic method that can draw any type of shape specified by the `ShapePrimitive` parameter.
   * An optional transformation matrix can be applied to the shape, allowing for complex transformations.
   * @param shape - The shape to draw, defined as a `ShapePrimitive` object.
   * @param matrix - An optional `Matrix` for transforming the shape. This can include rotations,
   * scaling, and translations.
   * @returns The instance of the current object for chaining.
   */ drawShape(shape, matrix) {
        this.endPoly();
        this.shapePrimitives.push({
            shape: shape,
            transform: matrix
        });
        return this;
    }
    /**
   * Starts a new polygon path from the specified starting point.
   * This method initializes a new polygon or ends the current one if it exists.
   * @param x - The x-coordinate of the starting point of the new polygon.
   * @param y - The y-coordinate of the starting point of the new polygon.
   * @returns The instance of the current object for chaining.
   */ startPoly(x, y) {
        let currentPoly = this._currentPoly;
        if (currentPoly) this.endPoly();
        currentPoly = new (0, $1J187.Polygon)();
        currentPoly.points.push(x, y);
        this._currentPoly = currentPoly;
        return this;
    }
    /**
   * Ends the current polygon path. If `closePath` is set to true,
   * the path is closed by connecting the last point to the first one.
   * This method finalizes the current polygon and prepares it for drawing or adding to the shape primitives.
   * @param closePath - A boolean indicating whether to close the polygon by connecting the last point
   *  back to the starting point. False by default.
   * @returns The instance of the current object for chaining.
   */ endPoly(closePath = false) {
        const shape = this._currentPoly;
        if (shape && shape.points.length > 2) {
            shape.closePath = closePath;
            this.shapePrimitives.push({
                shape: shape
            });
        }
        this._currentPoly = null;
        return this;
    }
    _ensurePoly(start = true) {
        if (this._currentPoly) return;
        this._currentPoly = new (0, $1J187.Polygon)();
        if (start) {
            const lastShape = this.shapePrimitives[this.shapePrimitives.length - 1];
            if (lastShape) {
                let lx = lastShape.shape.x;
                let ly = lastShape.shape.y;
                if (!lastShape.transform.isIdentity()) {
                    const t = lastShape.transform;
                    const tempX = lx;
                    lx = t.a * lx + t.c * ly + t.tx;
                    ly = t.b * tempX + t.d * ly + t.ty;
                }
                this._currentPoly.points.push(lx, ly);
            } else this._currentPoly.points.push(0, 0);
        }
    }
    /** Builds the path. */ buildPath() {
        const path = this._graphicsPath2D;
        this.shapePrimitives.length = 0;
        this._currentPoly = null;
        for(let i = 0; i < path.instructions.length; i++){
            const instruction = path.instructions[i];
            this[instruction.action](...instruction.data);
        }
        this.finish();
    }
    /** Gets the bounds of the path. */ get bounds() {
        const bounds = this._bounds;
        bounds.clear();
        const shapePrimitives = this.shapePrimitives;
        for(let i = 0; i < shapePrimitives.length; i++){
            const shapePrimitive = shapePrimitives[i];
            const boundsRect = shapePrimitive.shape.getBounds($ed386e3bfa993cb6$var$tempRectangle);
            if (shapePrimitive.transform) bounds.addRect(boundsRect, shapePrimitive.transform);
            else bounds.addRect(boundsRect);
        }
        return bounds;
    }
}

});
parcelRegister("duVYJ", function(module, exports) {

$parcel$export(module.exports, "Circle", () => $7ea76b2cc096b3d2$export$c89a927ffc67e6fa);

var $hFBUu = parcelRequire("hFBUu");
"use strict";
class $7ea76b2cc096b3d2$export$c89a927ffc67e6fa {
    /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */ constructor(x = 0, y = 0, radius = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @default 'circle'
     */ this.type = "circle";
        this.x = x;
        this.y = y;
        this.radius = radius;
    }
    /**
   * Creates a clone of this Circle instance
   * @returns A copy of the Circle
   */ clone() {
        return new $7ea76b2cc096b3d2$export$c89a927ffc67e6fa(this.x, this.y, this.radius);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   */ contains(x, y) {
        if (this.radius <= 0) return false;
        const r2 = this.radius * this.radius;
        let dx = this.x - x;
        let dy = this.y - y;
        dx *= dx;
        dy *= dy;
        return dx + dy <= r2;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle including the stroke.
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width - The width of the line to check
   * @returns Whether the x/y coordinates are within this Circle
   */ strokeContains(x, y, width) {
        if (this.radius === 0) return false;
        const dx = this.x - x;
        const dy = this.y - y;
        const r = this.radius;
        const w2 = width / 2;
        const distance = Math.sqrt(dx * dx + dy * dy);
        return distance < r + w2 && distance > r - w2;
    }
    /**
   * Returns the framing rectangle of the circle as a Rectangle object
   * @param out
   * @returns The framing rectangle
   */ getBounds(out) {
        out = out || new (0, $hFBUu.Rectangle)();
        out.x = this.x - this.radius;
        out.y = this.y - this.radius;
        out.width = this.radius * 2;
        out.height = this.radius * 2;
        return out;
    }
    /**
   * Copies another circle to this one.
   * @param circle - The circle to copy from.
   * @returns Returns itself.
   */ copyFrom(circle) {
        this.x = circle.x;
        this.y = circle.y;
        this.radius = circle.radius;
        return this;
    }
    /**
   * Copies this circle to another one.
   * @param circle - The circle to copy to.
   * @returns Returns given parameter.
   */ copyTo(circle) {
        circle.copyFrom(this);
        return circle;
    }
    toString() {
        return `[pixi.js/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
    }
}

});

parcelRegister("aCytD", function(module, exports) {

$parcel$export(module.exports, "Ellipse", () => $43793eaa16898c02$export$80b0269ab108fa11);

var $hFBUu = parcelRequire("hFBUu");
"use strict";
class $43793eaa16898c02$export$80b0269ab108fa11 {
    /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */ constructor(x = 0, y = 0, halfWidth = 0, halfHeight = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @default 'ellipse'
     */ this.type = "ellipse";
        this.x = x;
        this.y = y;
        this.halfWidth = halfWidth;
        this.halfHeight = halfHeight;
    }
    /**
   * Creates a clone of this Ellipse instance
   * @returns {Ellipse} A copy of the ellipse
   */ clone() {
        return new $43793eaa16898c02$export$80b0269ab108fa11(this.x, this.y, this.halfWidth, this.halfHeight);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   */ contains(x, y) {
        if (this.halfWidth <= 0 || this.halfHeight <= 0) return false;
        let normx = (x - this.x) / this.halfWidth;
        let normy = (y - this.y) / this.halfHeight;
        normx *= normx;
        normy *= normy;
        return normx + normy <= 1;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse including stroke
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width
   * @returns Whether the x/y coords are within this ellipse
   */ strokeContains(x, y, width) {
        const { halfWidth: halfWidth, halfHeight: halfHeight } = this;
        if (halfWidth <= 0 || halfHeight <= 0) return false;
        const halfStrokeWidth = width / 2;
        const innerA = halfWidth - halfStrokeWidth;
        const innerB = halfHeight - halfStrokeWidth;
        const outerA = halfWidth + halfStrokeWidth;
        const outerB = halfHeight + halfStrokeWidth;
        const normalizedX = x - this.x;
        const normalizedY = y - this.y;
        const innerEllipse = normalizedX * normalizedX / (innerA * innerA) + normalizedY * normalizedY / (innerB * innerB);
        const outerEllipse = normalizedX * normalizedX / (outerA * outerA) + normalizedY * normalizedY / (outerB * outerB);
        return innerEllipse > 1 && outerEllipse <= 1;
    }
    /**
   * Returns the framing rectangle of the ellipse as a Rectangle object
   * @returns The framing rectangle
   */ getBounds() {
        return new (0, $hFBUu.Rectangle)(this.x - this.halfWidth, this.y - this.halfHeight, this.halfWidth * 2, this.halfHeight * 2);
    }
    /**
   * Copies another ellipse to this one.
   * @param ellipse - The ellipse to copy from.
   * @returns Returns itself.
   */ copyFrom(ellipse) {
        this.x = ellipse.x;
        this.y = ellipse.y;
        this.halfWidth = ellipse.halfWidth;
        this.halfHeight = ellipse.halfHeight;
        return this;
    }
    /**
   * Copies this ellipse to another one.
   * @param ellipse - The ellipse to copy to.
   * @returns Returns given parameter.
   */ copyTo(ellipse) {
        ellipse.copyFrom(this);
        return ellipse;
    }
    toString() {
        return `[pixi.js/math:Ellipse x=${this.x} y=${this.y} halfWidth=${this.halfWidth} halfHeight=${this.halfHeight}]`;
    }
}

});

parcelRegister("1J187", function(module, exports) {

$parcel$export(module.exports, "Polygon", () => $583eae3bd87d51fc$export$7d31b617c820d435);

var $3DxI8 = parcelRequire("3DxI8");

var $hFBUu = parcelRequire("hFBUu");
"use strict";
class $583eae3bd87d51fc$export$7d31b617c820d435 {
    /**
   * @param points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */ constructor(...points){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @default 'polygon'
     */ this.type = "polygon";
        let flat = Array.isArray(points[0]) ? points[0] : points;
        if (typeof flat[0] !== "number") {
            const p = [];
            for(let i = 0, il = flat.length; i < il; i++)p.push(flat[i].x, flat[i].y);
            flat = p;
        }
        this.points = flat;
        this.closePath = true;
    }
    /**
   * Creates a clone of this polygon.
   * @returns - A copy of the polygon.
   */ clone() {
        const points = this.points.slice();
        const polygon = new $583eae3bd87d51fc$export$7d31b617c820d435(points);
        polygon.closePath = this.closePath;
        return polygon;
    }
    /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this polygon.
   */ contains(x, y) {
        let inside = false;
        const length = this.points.length / 2;
        for(let i = 0, j = length - 1; i < length; j = i++){
            const xi = this.points[i * 2];
            const yi = this.points[i * 2 + 1];
            const xj = this.points[j * 2];
            const yj = this.points[j * 2 + 1];
            const intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;
            if (intersect) inside = !inside;
        }
        return inside;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this polygon including the stroke.
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @returns Whether the x/y coordinates are within this polygon
   */ strokeContains(x, y, strokeWidth) {
        const halfStrokeWidth = strokeWidth / 2;
        const halfStrokeWidthSqrd = halfStrokeWidth * halfStrokeWidth;
        const { points: points } = this;
        const iterationLength = points.length - (this.closePath ? 0 : 2);
        for(let i = 0; i < iterationLength; i += 2){
            const x1 = points[i];
            const y1 = points[i + 1];
            const x2 = points[(i + 2) % points.length];
            const y2 = points[(i + 3) % points.length];
            const distanceSqrd = (0, $3DxI8.squaredDistanceToLineSegment)(x, y, x1, y1, x2, y2);
            if (distanceSqrd <= halfStrokeWidthSqrd) return true;
        }
        return false;
    }
    /**
   * Returns the framing rectangle of the polygon as a Rectangle object
   * @param out - optional rectangle to store the result
   * @returns The framing rectangle
   */ getBounds(out) {
        out = out || new (0, $hFBUu.Rectangle)();
        const points = this.points;
        let minX = Infinity;
        let maxX = -Infinity;
        let minY = Infinity;
        let maxY = -Infinity;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i];
            const y = points[i + 1];
            minX = x < minX ? x : minX;
            maxX = x > maxX ? x : maxX;
            minY = y < minY ? y : minY;
            maxY = y > maxY ? y : maxY;
        }
        out.x = minX;
        out.width = maxX - minX;
        out.y = minY;
        out.height = maxY - minY;
        return out;
    }
    /**
   * Copies another polygon to this one.
   * @param polygon - The polygon to copy from.
   * @returns Returns itself.
   */ copyFrom(polygon) {
        this.points = polygon.points.slice();
        this.closePath = polygon.closePath;
        return this;
    }
    /**
   * Copies this polygon to another one.
   * @param polygon - The polygon to copy to.
   * @returns Returns given parameter.
   */ copyTo(polygon) {
        polygon.copyFrom(this);
        return polygon;
    }
    toString() {
        return `[pixi.js/math:PolygoncloseStroke=${this.closePath}points=${this.points.reduce((pointsDesc, currentPoint)=>`${pointsDesc}, ${currentPoint}`, "")}]`;
    }
    /**
   * Get the last X coordinate of the polygon
   * @readonly
   */ get lastX() {
        return this.points[this.points.length - 2];
    }
    /**
   * Get the last Y coordinate of the polygon
   * @readonly
   */ get lastY() {
        return this.points[this.points.length - 1];
    }
    /**
   * Get the first X coordinate of the polygon
   * @readonly
   */ get x() {
        return this.points[this.points.length - 2];
    }
    /**
   * Get the first Y coordinate of the polygon
   * @readonly
   */ get y() {
        return this.points[this.points.length - 1];
    }
}

});
parcelRegister("3DxI8", function(module, exports) {

$parcel$export(module.exports, "squaredDistanceToLineSegment", () => $1adb4d86d9b23e41$export$db32ff20ff695a);
"use strict";
function $1adb4d86d9b23e41$export$db32ff20ff695a(x, y, x1, y1, x2, y2) {
    const a = x - x1;
    const b = y - y1;
    const c = x2 - x1;
    const d = y2 - y1;
    const dot = a * c + b * d;
    const lenSq = c * c + d * d;
    let param = -1;
    if (lenSq !== 0) param = dot / lenSq;
    let xx;
    let yy;
    if (param < 0) {
        xx = x1;
        yy = y1;
    } else if (param > 1) {
        xx = x2;
        yy = y2;
    } else {
        xx = x1 + param * c;
        yy = y1 + param * d;
    }
    const dx = x - xx;
    const dy = y - yy;
    return dx * dx + dy * dy;
}

});


parcelRegister("2Np5v", function(module, exports) {

$parcel$export(module.exports, "RoundedRectangle", () => $424624dd9bddd2bb$export$d55ab2e3dc5a4263);

var $hFBUu = parcelRequire("hFBUu");
"use strict";
const $424624dd9bddd2bb$var$isCornerWithinStroke = (pX, pY, cornerX, cornerY, radius, halfStrokeWidth)=>{
    const dx = pX - cornerX;
    const dy = pY - cornerY;
    const distance = Math.sqrt(dx * dx + dy * dy);
    return distance >= radius - halfStrokeWidth && distance <= radius + halfStrokeWidth;
};
class $424624dd9bddd2bb$export$d55ab2e3dc5a4263 {
    /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */ constructor(x = 0, y = 0, width = 0, height = 0, radius = 20){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @default 'roundedRectangle'
     */ this.type = "roundedRectangle";
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.radius = radius;
    }
    /**
   * Returns the framing rectangle of the rounded rectangle as a Rectangle object
   * @param out - optional rectangle to store the result
   * @returns The framing rectangle
   */ getBounds(out) {
        out = out || new (0, $hFBUu.Rectangle)();
        out.x = this.x;
        out.y = this.y;
        out.width = this.width;
        out.height = this.height;
        return out;
    }
    /**
   * Creates a clone of this Rounded Rectangle.
   * @returns - A copy of the rounded rectangle.
   */ clone() {
        return new $424624dd9bddd2bb$export$d55ab2e3dc5a4263(this.x, this.y, this.width, this.height, this.radius);
    }
    /**
   * Copies another rectangle to this one.
   * @param rectangle - The rectangle to copy from.
   * @returns Returns itself.
   */ copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    /**
   * Copies this rectangle to another one.
   * @param rectangle - The rectangle to copy to.
   * @returns Returns given parameter.
   */ copyTo(rectangle) {
        rectangle.copyFrom(this);
        return rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this Rounded Rectangle.
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x <= this.x + this.width) {
            if (y >= this.y && y <= this.y + this.height) {
                const radius = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
                if (y >= this.y + radius && y <= this.y + this.height - radius || x >= this.x + radius && x <= this.x + this.width - radius) return true;
                let dx = x - (this.x + radius);
                let dy = y - (this.y + radius);
                const radius2 = radius * radius;
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + this.width - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dy = y - (this.y + this.height - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + radius);
                if (dx * dx + dy * dy <= radius2) return true;
            }
        }
        return false;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @param pX - The X coordinate of the point to test
   * @param pY - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @returns Whether the x/y coordinates are within this rectangle
   */ strokeContains(pX, pY, strokeWidth) {
        const { x: x, y: y, width: width, height: height, radius: radius } = this;
        const halfStrokeWidth = strokeWidth / 2;
        const innerX = x + radius;
        const innerY = y + radius;
        const innerWidth = width - radius * 2;
        const innerHeight = height - radius * 2;
        const rightBound = x + width;
        const bottomBound = y + height;
        if ((pX >= x - halfStrokeWidth && pX <= x + halfStrokeWidth || pX >= rightBound - halfStrokeWidth && pX <= rightBound + halfStrokeWidth) && pY >= innerY && pY <= innerY + innerHeight) return true;
        if ((pY >= y - halfStrokeWidth && pY <= y + halfStrokeWidth || pY >= bottomBound - halfStrokeWidth && pY <= bottomBound + halfStrokeWidth) && pX >= innerX && pX <= innerX + innerWidth) return true;
        return(// Top-left
        pX < innerX && pY < innerY && $424624dd9bddd2bb$var$isCornerWithinStroke(pX, pY, innerX, innerY, radius, halfStrokeWidth) || pX > rightBound - radius && pY < innerY && $424624dd9bddd2bb$var$isCornerWithinStroke(pX, pY, rightBound - radius, innerY, radius, halfStrokeWidth) || pX > rightBound - radius && pY > bottomBound - radius && $424624dd9bddd2bb$var$isCornerWithinStroke(pX, pY, rightBound - radius, bottomBound - radius, radius, halfStrokeWidth) || pX < innerX && pY > bottomBound - radius && $424624dd9bddd2bb$var$isCornerWithinStroke(pX, pY, innerX, bottomBound - radius, radius, halfStrokeWidth));
    }
    toString() {
        return `[pixi.js/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
    }
}

});

parcelRegister("4fAWm", function(module, exports) {

$parcel$export(module.exports, "buildAdaptiveBezier", () => $fb986a0e984a81cc$export$7dab5eac414ecba2);

var $9ScHH = parcelRequire("9ScHH");
"use strict";
const $fb986a0e984a81cc$var$RECURSION_LIMIT = 8;
const $fb986a0e984a81cc$var$FLT_EPSILON = 11920929e-14;
const $fb986a0e984a81cc$var$PATH_DISTANCE_EPSILON = 1;
const $fb986a0e984a81cc$var$curveAngleToleranceEpsilon = 0.01;
const $fb986a0e984a81cc$var$mAngleTolerance = 0;
const $fb986a0e984a81cc$var$mCuspLimit = 0;
function $fb986a0e984a81cc$export$7dab5eac414ecba2(points, sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, smoothness) {
    const scale = 1;
    const smoothing = Math.min(0.99, // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? (0, $9ScHH.GraphicsContextSystem).defaultOptions.bezierSmoothness));
    let distanceTolerance = ($fb986a0e984a81cc$var$PATH_DISTANCE_EPSILON - smoothing) / scale;
    distanceTolerance *= distanceTolerance;
    $fb986a0e984a81cc$var$begin(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance);
    return points;
}
function $fb986a0e984a81cc$var$begin(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance) {
    $fb986a0e984a81cc$var$recursive(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance, 0);
    points.push(eX, eY);
}
function $fb986a0e984a81cc$var$recursive(x1, y1, x2, y2, x3, y3, x4, y4, points, distanceTolerance, level) {
    if (level > $fb986a0e984a81cc$var$RECURSION_LIMIT) return;
    const pi = Math.PI;
    const x12 = (x1 + x2) / 2;
    const y12 = (y1 + y2) / 2;
    const x23 = (x2 + x3) / 2;
    const y23 = (y2 + y3) / 2;
    const x34 = (x3 + x4) / 2;
    const y34 = (y3 + y4) / 2;
    const x123 = (x12 + x23) / 2;
    const y123 = (y12 + y23) / 2;
    const x234 = (x23 + x34) / 2;
    const y234 = (y23 + y34) / 2;
    const x1234 = (x123 + x234) / 2;
    const y1234 = (y123 + y234) / 2;
    if (level > 0) {
        let dx = x4 - x1;
        let dy = y4 - y1;
        const d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx);
        const d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx);
        let da1;
        let da2;
        if (d2 > $fb986a0e984a81cc$var$FLT_EPSILON && d3 > $fb986a0e984a81cc$var$FLT_EPSILON) {
            if ((d2 + d3) * (d2 + d3) <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($fb986a0e984a81cc$var$mAngleTolerance < $fb986a0e984a81cc$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                const a23 = Math.atan2(y3 - y2, x3 - x2);
                da1 = Math.abs(a23 - Math.atan2(y2 - y1, x2 - x1));
                da2 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - a23);
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da2 >= pi) da2 = 2 * pi - da2;
                if (da1 + da2 < $fb986a0e984a81cc$var$mAngleTolerance) {
                    points.push(x1234, y1234);
                    return;
                }
                if ($fb986a0e984a81cc$var$mCuspLimit !== 0) {
                    if (da1 > $fb986a0e984a81cc$var$mCuspLimit) {
                        points.push(x2, y2);
                        return;
                    }
                    if (da2 > $fb986a0e984a81cc$var$mCuspLimit) {
                        points.push(x3, y3);
                        return;
                    }
                }
            }
        } else if (d2 > $fb986a0e984a81cc$var$FLT_EPSILON) {
            if (d2 * d2 <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($fb986a0e984a81cc$var$mAngleTolerance < $fb986a0e984a81cc$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                da1 = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da1 < $fb986a0e984a81cc$var$mAngleTolerance) {
                    points.push(x2, y2);
                    points.push(x3, y3);
                    return;
                }
                if ($fb986a0e984a81cc$var$mCuspLimit !== 0) {
                    if (da1 > $fb986a0e984a81cc$var$mCuspLimit) {
                        points.push(x2, y2);
                        return;
                    }
                }
            }
        } else if (d3 > $fb986a0e984a81cc$var$FLT_EPSILON) {
            if (d3 * d3 <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($fb986a0e984a81cc$var$mAngleTolerance < $fb986a0e984a81cc$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                da1 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - Math.atan2(y3 - y2, x3 - x2));
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da1 < $fb986a0e984a81cc$var$mAngleTolerance) {
                    points.push(x2, y2);
                    points.push(x3, y3);
                    return;
                }
                if ($fb986a0e984a81cc$var$mCuspLimit !== 0) {
                    if (da1 > $fb986a0e984a81cc$var$mCuspLimit) {
                        points.push(x3, y3);
                        return;
                    }
                }
            }
        } else {
            dx = x1234 - (x1 + x4) / 2;
            dy = y1234 - (y1 + y4) / 2;
            if (dx * dx + dy * dy <= distanceTolerance) {
                points.push(x1234, y1234);
                return;
            }
        }
    }
    $fb986a0e984a81cc$var$recursive(x1, y1, x12, y12, x123, y123, x1234, y1234, points, distanceTolerance, level + 1);
    $fb986a0e984a81cc$var$recursive(x1234, y1234, x234, y234, x34, y34, x4, y4, points, distanceTolerance, level + 1);
}

});
parcelRegister("9ScHH", function(module, exports) {

$parcel$export(module.exports, "GraphicsContextSystem", () => $60a554686dde1561$export$f2f3ca33e4c65172);

var $aqljF = parcelRequire("aqljF");

var $ijSUj = parcelRequire("ijSUj");

var $9CSFV = parcelRequire("9CSFV");

var $8s2Nq = parcelRequire("8s2Nq");

var $5GFMM = parcelRequire("5GFMM");

var $8ZHaq = parcelRequire("8ZHaq");

var $9dWY3 = parcelRequire("9dWY3");
"use strict";
class $60a554686dde1561$export$e3e348c254036d55 {
    constructor(){
        this.batches = [];
        this.geometryData = {
            vertices: [],
            uvs: [],
            indices: []
        };
    }
}
class $60a554686dde1561$export$9b6a6c5b37fc8f49 {
    constructor(){
        this.geometry = new (0, $ijSUj.BatchGeometry)();
        this.instructions = new (0, $5GFMM.InstructionSet)();
    }
    init() {
        this.instructions.reset();
    }
}
const $60a554686dde1561$var$_GraphicsContextSystem = class _GraphicsContextSystem {
    constructor(){
        // the root context batches, used to either make a batch or geometry
        // all graphics use this as a base
        this._activeBatchers = [];
        this._gpuContextHash = {};
        // used for non-batchable graphics
        this._graphicsDataContextHash = /* @__PURE__ */ Object.create(null);
        this._needsContextNeedsRebuild = [];
    }
    /**
   * Runner init called, update the default options
   * @ignore
   */ init(options) {
        _GraphicsContextSystem.defaultOptions.bezierSmoothness = options?.bezierSmoothness ?? _GraphicsContextSystem.defaultOptions.bezierSmoothness;
    }
    prerender() {
        this._returnActiveBatchers();
    }
    getContextRenderData(context) {
        return this._graphicsDataContextHash[context.uid] || this._initContextRenderData(context);
    }
    // Context management functions
    updateGpuContext(context) {
        let gpuContext = this._gpuContextHash[context.uid] || this._initContext(context);
        if (context.dirty) {
            if (gpuContext) this._cleanGraphicsContextData(context);
            else gpuContext = this._initContext(context);
            (0, $9dWY3.buildContextBatches)(context, gpuContext);
            const batchMode = context.batchMode;
            if (context.customShader || batchMode === "no-batch") gpuContext.isBatchable = false;
            else if (batchMode === "auto") gpuContext.isBatchable = gpuContext.geometryData.vertices.length < 400;
            context.dirty = false;
        }
        return gpuContext;
    }
    getGpuContext(context) {
        return this._gpuContextHash[context.uid] || this._initContext(context);
    }
    _returnActiveBatchers() {
        for(let i = 0; i < this._activeBatchers.length; i++)(0, $8ZHaq.BigPool).return(this._activeBatchers[i]);
        this._activeBatchers.length = 0;
    }
    _initContextRenderData(context) {
        const graphicsData = (0, $8ZHaq.BigPool).get($60a554686dde1561$export$9b6a6c5b37fc8f49);
        const { batches: batches, geometryData: geometryData } = this._gpuContextHash[context.uid];
        const vertexSize = geometryData.vertices.length;
        const indexSize = geometryData.indices.length;
        for(let i = 0; i < batches.length; i++)batches[i].applyTransform = false;
        const batcher = (0, $8ZHaq.BigPool).get((0, $8s2Nq.Batcher));
        this._activeBatchers.push(batcher);
        batcher.ensureAttributeBuffer(vertexSize);
        batcher.ensureIndexBuffer(indexSize);
        batcher.begin();
        for(let i = 0; i < batches.length; i++){
            const batch = batches[i];
            batcher.add(batch);
        }
        batcher.finish(graphicsData.instructions);
        const geometry = graphicsData.geometry;
        geometry.indexBuffer.setDataWithSize(batcher.indexBuffer, batcher.indexSize, true);
        geometry.buffers[0].setDataWithSize(batcher.attributeBuffer.float32View, batcher.attributeSize, true);
        const drawBatches = batcher.batches;
        for(let i = 0; i < drawBatches.length; i++){
            const batch = drawBatches[i];
            batch.bindGroup = (0, $9CSFV.getTextureBatchBindGroup)(batch.textures.textures, batch.textures.count);
        }
        this._graphicsDataContextHash[context.uid] = graphicsData;
        return graphicsData;
    }
    _initContext(context) {
        const gpuContext = new $60a554686dde1561$export$e3e348c254036d55();
        this._gpuContextHash[context.uid] = gpuContext;
        context.on("update", this.onGraphicsContextUpdate, this);
        context.on("destroy", this.onGraphicsContextDestroy, this);
        return this._gpuContextHash[context.uid];
    }
    onGraphicsContextUpdate(context) {
        this._needsContextNeedsRebuild.push(context);
    }
    onGraphicsContextDestroy(context) {
        this._cleanGraphicsContextData(context);
        context.off("update", this.onGraphicsContextUpdate, this);
        context.off("destroy", this.onGraphicsContextDestroy, this);
        this._gpuContextHash[context.uid] = null;
    }
    _cleanGraphicsContextData(context) {
        const gpuContext = this._gpuContextHash[context.uid];
        if (!gpuContext.isBatchable) {
            if (this._graphicsDataContextHash[context.uid]) {
                (0, $8ZHaq.BigPool).return(this.getContextRenderData(context));
                this._graphicsDataContextHash[context.uid] = null;
            }
        }
        if (gpuContext.batches) gpuContext.batches.forEach((batch)=>{
            (0, $8ZHaq.BigPool).return(batch);
        });
    }
    destroy() {
        for (const context of this._needsContextNeedsRebuild)if (this._gpuContextHash[context.uid]) this.onGraphicsContextDestroy(context);
        this._needsContextNeedsRebuild.length = 0;
    }
};
/** @ignore */ $60a554686dde1561$var$_GraphicsContextSystem.extension = {
    type: [
        (0, $aqljF.ExtensionType).WebGLSystem,
        (0, $aqljF.ExtensionType).WebGPUSystem,
        (0, $aqljF.ExtensionType).CanvasSystem
    ],
    name: "graphicsContext"
};
/** The default options for the GraphicsContextSystem. */ $60a554686dde1561$var$_GraphicsContextSystem.defaultOptions = {
    /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */ bezierSmoothness: 0.5
};
let $60a554686dde1561$export$f2f3ca33e4c65172 = $60a554686dde1561$var$_GraphicsContextSystem;

});
parcelRegister("ijSUj", function(module, exports) {

$parcel$export(module.exports, "BatchGeometry", () => $179167cbe513a02f$export$449e8d355fd68e43);

var $lLNAC = parcelRequire("lLNAC");

var $duL0p = parcelRequire("duL0p");

var $376jC = parcelRequire("376jC");
"use strict";
const $179167cbe513a02f$var$placeHolderBufferData = new Float32Array(1);
const $179167cbe513a02f$var$placeHolderIndexData = new Uint32Array(1);
class $179167cbe513a02f$export$449e8d355fd68e43 extends (0, $376jC.Geometry) {
    constructor(){
        const vertexSize = 6;
        const attributeBuffer = new (0, $lLNAC.Buffer)({
            data: $179167cbe513a02f$var$placeHolderBufferData,
            label: "attribute-batch-buffer",
            usage: (0, $duL0p.BufferUsage).VERTEX | (0, $duL0p.BufferUsage).COPY_DST,
            shrinkToFit: false
        });
        const indexBuffer = new (0, $lLNAC.Buffer)({
            data: $179167cbe513a02f$var$placeHolderIndexData,
            label: "index-batch-buffer",
            usage: (0, $duL0p.BufferUsage).INDEX | (0, $duL0p.BufferUsage).COPY_DST,
            // | BufferUsage.STATIC,
            shrinkToFit: false
        });
        const stride = vertexSize * 4;
        super({
            attributes: {
                aPosition: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 0,
                    location: 1
                },
                aUV: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 8,
                    location: 3
                },
                aColor: {
                    buffer: attributeBuffer,
                    format: "unorm8x4",
                    stride: stride,
                    offset: 16,
                    location: 0
                },
                aTextureIdAndRound: {
                    buffer: attributeBuffer,
                    format: "uint16x2",
                    stride: stride,
                    offset: 20,
                    location: 2
                }
            },
            indexBuffer: indexBuffer
        });
    }
}

});
parcelRegister("lLNAC", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $737239b339ab9873$export$a143d493d941bafc);

var $gpXaq = parcelRequire("gpXaq");

var $by5BM = parcelRequire("by5BM");

var $duL0p = parcelRequire("duL0p");
"use strict";
class $737239b339ab9873$export$a143d493d941bafc extends (0, (/*@__PURE__*/$parcel$interopDefault($gpXaq))) {
    /**
   * Creates a new Buffer with the given options
   * @param options - the options for the buffer
   */ constructor(options){
        let { data: data, size: size } = options;
        const { usage: usage, label: label, shrinkToFit: shrinkToFit } = options;
        super();
        /**
     * emits when the underlying buffer has changed shape (i.e. resized)
     * letting the renderer know that it needs to discard the old buffer on the GPU and create a new one
     * @event change
     */ /**
     * emits when the underlying buffer data has been updated. letting the renderer know
     * that it needs to update the buffer on the GPU
     * @event update
     */ /**
     * emits when the buffer is destroyed. letting the renderer know that it needs to destroy the buffer on the GPU
     * @event destroy
     */ /**
     * a unique id for this uniform group used through the renderer
     * @internal
     * @ignore
     */ this.uid = (0, $by5BM.uid)("buffer");
        /**
     * a resource type, used to identify how to handle it when its in a bind group / shader resource
     * @internal
     * @ignore
     */ this._resourceType = "buffer";
        /**
     * the resource id used internally by the renderer to build bind group keys
     * @internal
     * @ignore
     */ this._resourceId = (0, $by5BM.uid)("resource");
        /**
     * used internally to know if a uniform group was used in the last render pass
     * @internal
     * @ignore
     */ this._touched = 0;
        /**
     * @internal
     * @ignore
     */ this._updateID = 1;
        /**
     * should the GPU buffer be shrunk when the data becomes smaller?
     * changing this will cause the buffer to be destroyed and a new one created on the GPU
     * this can be expensive, especially if the buffer is already big enough!
     * setting this to false will prevent the buffer from being shrunk. This will yield better performance
     * if you are constantly setting data that is changing size often.
     * @default true
     */ this.shrinkToFit = true;
        /**
     * Has the buffer been destroyed?
     * @readonly
     */ this.destroyed = false;
        if (data instanceof Array) data = new Float32Array(data);
        this._data = data;
        size = size ?? data?.byteLength;
        const mappedAtCreation = !!data;
        this.descriptor = {
            size: size,
            usage: usage,
            mappedAtCreation: mappedAtCreation,
            label: label
        };
        this.shrinkToFit = shrinkToFit ?? true;
    }
    /** the data in the buffer */ get data() {
        return this._data;
    }
    set data(value) {
        this.setDataWithSize(value, value.length, true);
    }
    /** whether the buffer is static or not */ get static() {
        return !!(this.descriptor.usage & (0, $duL0p.BufferUsage).STATIC);
    }
    set static(value) {
        if (value) this.descriptor.usage |= (0, $duL0p.BufferUsage).STATIC;
        else this.descriptor.usage &= ~(0, $duL0p.BufferUsage).STATIC;
    }
    /**
   * Sets the data in the buffer to the given value. This will immediately update the buffer on the GPU.
   * If you only want to update a subset of the buffer, you can pass in the size of the data.
   * @param value - the data to set
   * @param size - the size of the data in bytes
   * @param syncGPU - should the buffer be updated on the GPU immediately?
   */ setDataWithSize(value, size, syncGPU) {
        this._updateID++;
        this._updateSize = size * value.BYTES_PER_ELEMENT;
        if (this._data === value) {
            if (syncGPU) this.emit("update", this);
            return;
        }
        const oldData = this._data;
        this._data = value;
        if (oldData.length !== value.length) {
            if (!this.shrinkToFit && value.byteLength < oldData.byteLength) {
                if (syncGPU) this.emit("update", this);
            } else {
                this.descriptor.size = value.byteLength;
                this._resourceId = (0, $by5BM.uid)("resource");
                this.emit("change", this);
            }
            return;
        }
        if (syncGPU) this.emit("update", this);
    }
    /**
   * updates the buffer on the GPU to reflect the data in the buffer.
   * By default it will update the entire buffer. If you only want to update a subset of the buffer,
   * you can pass in the size of the buffer to update.
   * @param sizeInBytes - the new size of the buffer in bytes
   */ update(sizeInBytes) {
        this._updateSize = sizeInBytes ?? this._updateSize;
        this._updateID++;
        this.emit("update", this);
    }
    /** Destroys the buffer */ destroy() {
        this.destroyed = true;
        this.emit("destroy", this);
        this.emit("change", this);
        this._data = null;
        this.descriptor = null;
        this.removeAllListeners();
    }
}

});
parcelRegister("duL0p", function(module, exports) {

$parcel$export(module.exports, "BufferUsage", () => $cfe0b12878671dc2$export$f8deb2be8632fd10);
"use strict";
var $cfe0b12878671dc2$export$f8deb2be8632fd10 = /* @__PURE__ */ ((BufferUsage2)=>{
    BufferUsage2[BufferUsage2["MAP_READ"] = 1] = "MAP_READ";
    BufferUsage2[BufferUsage2["MAP_WRITE"] = 2] = "MAP_WRITE";
    BufferUsage2[BufferUsage2["COPY_SRC"] = 4] = "COPY_SRC";
    BufferUsage2[BufferUsage2["COPY_DST"] = 8] = "COPY_DST";
    BufferUsage2[BufferUsage2["INDEX"] = 16] = "INDEX";
    BufferUsage2[BufferUsage2["VERTEX"] = 32] = "VERTEX";
    BufferUsage2[BufferUsage2["UNIFORM"] = 64] = "UNIFORM";
    BufferUsage2[BufferUsage2["STORAGE"] = 128] = "STORAGE";
    BufferUsage2[BufferUsage2["INDIRECT"] = 256] = "INDIRECT";
    BufferUsage2[BufferUsage2["QUERY_RESOLVE"] = 512] = "QUERY_RESOLVE";
    BufferUsage2[BufferUsage2["STATIC"] = 1024] = "STATIC";
    return BufferUsage2;
})($cfe0b12878671dc2$export$f8deb2be8632fd10 || {});

});


parcelRegister("376jC", function(module, exports) {

$parcel$export(module.exports, "Geometry", () => $d0c4d932b3deca40$export$2db6c17465f94a2);

var $gpXaq = parcelRequire("gpXaq");

var $3vloD = parcelRequire("3vloD");

var $by5BM = parcelRequire("by5BM");

var $lLNAC = parcelRequire("lLNAC");

var $57PCt = parcelRequire("57PCt");

var $bv3IE = parcelRequire("bv3IE");
"use strict";
function $d0c4d932b3deca40$var$ensureIsAttribute(attribute) {
    if (attribute instanceof (0, $lLNAC.Buffer) || Array.isArray(attribute) || attribute.BYTES_PER_ELEMENT) attribute = {
        buffer: attribute
    };
    attribute.buffer = (0, $57PCt.ensureIsBuffer)(attribute.buffer, false);
    return attribute;
}
class $d0c4d932b3deca40$export$2db6c17465f94a2 extends (0, (/*@__PURE__*/$parcel$interopDefault($gpXaq))) {
    /**
   * Create a new instance of a geometry
   * @param options - The options for the geometry.
   */ constructor(options){
        const { attributes: attributes, indexBuffer: indexBuffer, topology: topology } = options;
        super();
        /** The unique id of the geometry. */ this.uid = (0, $by5BM.uid)("geometry");
        /**
     * the layout key will be generated by WebGPU all geometries that have the same structure
     * will have the same layout key. This is used to cache the pipeline layout
     * @internal
     * @ignore
     */ this._layoutKey = 0;
        /** the instance count of the geometry to draw */ this.instanceCount = 1;
        this._bounds = new (0, $3vloD.Bounds)();
        this._boundsDirty = true;
        this.attributes = attributes;
        this.buffers = [];
        this.instanceCount = options.instanceCount || 1;
        for(const i in attributes){
            const attribute = attributes[i] = $d0c4d932b3deca40$var$ensureIsAttribute(attributes[i]);
            const bufferIndex = this.buffers.indexOf(attribute.buffer);
            if (bufferIndex === -1) {
                this.buffers.push(attribute.buffer);
                attribute.buffer.on("update", this.onBufferUpdate, this);
                attribute.buffer.on("change", this.onBufferUpdate, this);
            }
        }
        if (indexBuffer) {
            this.indexBuffer = (0, $57PCt.ensureIsBuffer)(indexBuffer, true);
            this.buffers.push(this.indexBuffer);
        }
        this.topology = topology || "triangle-list";
    }
    onBufferUpdate() {
        this._boundsDirty = true;
        this.emit("update", this);
    }
    /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */ getAttribute(id) {
        return this.attributes[id];
    }
    /**
   * Returns the index buffer
   * @returns - The index buffer.
   */ getIndex() {
        return this.indexBuffer;
    }
    /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */ getBuffer(id) {
        return this.getAttribute(id).buffer;
    }
    /**
   * Used to figure out how many vertices there are in this geometry
   * @returns the number of vertices in the geometry
   */ getSize() {
        for(const i in this.attributes){
            const attribute = this.attributes[i];
            const buffer = attribute.buffer;
            return buffer.data.length / (attribute.stride / 4 || attribute.size);
        }
        return 0;
    }
    /** Returns the bounds of the geometry. */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        this._boundsDirty = false;
        return (0, $bv3IE.getGeometryBounds)(this, "aPosition", this._bounds);
    }
    /**
   * destroys the geometry.
   * @param destroyBuffers - destroy the buffers associated with this geometry
   */ destroy(destroyBuffers = false) {
        this.emit("destroy", this);
        this.removeAllListeners();
        if (destroyBuffers) this.buffers.forEach((buffer)=>buffer.destroy());
        this.attributes = null;
        this.buffers = null;
        this.indexBuffer = null;
        this._bounds = null;
    }
}

});
parcelRegister("57PCt", function(module, exports) {

$parcel$export(module.exports, "ensureIsBuffer", () => $6a9eeb3dc45fce36$export$e02adcb3cf335e03);

var $lLNAC = parcelRequire("lLNAC");

var $duL0p = parcelRequire("duL0p");
"use strict";
function $6a9eeb3dc45fce36$export$e02adcb3cf335e03(buffer, index) {
    if (!(buffer instanceof (0, $lLNAC.Buffer))) {
        let usage = index ? (0, $duL0p.BufferUsage).INDEX : (0, $duL0p.BufferUsage).VERTEX;
        if (buffer instanceof Array) {
            if (index) {
                buffer = new Uint32Array(buffer);
                usage = (0, $duL0p.BufferUsage).INDEX | (0, $duL0p.BufferUsage).COPY_DST;
            } else {
                buffer = new Float32Array(buffer);
                usage = (0, $duL0p.BufferUsage).VERTEX | (0, $duL0p.BufferUsage).COPY_DST;
            }
        }
        buffer = new (0, $lLNAC.Buffer)({
            data: buffer,
            label: index ? "index-mesh-buffer" : "vertex-mesh-buffer",
            usage: usage
        });
    }
    return buffer;
}

});

parcelRegister("bv3IE", function(module, exports) {

$parcel$export(module.exports, "getGeometryBounds", () => $4307f01314507680$export$ca8be28ec6402f29);
"use strict";
function $4307f01314507680$export$ca8be28ec6402f29(geometry, attributeId, bounds) {
    const attribute = geometry.getAttribute(attributeId);
    if (!attribute) {
        bounds.minX = 0;
        bounds.minY = 0;
        bounds.maxX = 0;
        bounds.maxY = 0;
        return bounds;
    }
    const data = attribute.buffer.data;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    const byteSize = data.BYTES_PER_ELEMENT;
    const offset = (attribute.offset || 0) / byteSize;
    const stride = (attribute.stride || 8) / byteSize;
    for(let i = offset; i < data.length; i += stride){
        const x = data[i];
        const y = data[i + 1];
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
    }
    bounds.minX = minX;
    bounds.minY = minY;
    bounds.maxX = maxX;
    bounds.maxY = maxY;
    return bounds;
}

});



parcelRegister("9CSFV", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $592667ad03caa38e$export$84c26df82650dc9b);

var $8Uizi = parcelRequire("8Uizi");

var $jollT = parcelRequire("jollT");

var $g7C2p = parcelRequire("g7C2p");
"use strict";
const $592667ad03caa38e$var$cachedGroups = {};
function $592667ad03caa38e$export$84c26df82650dc9b(textures, size) {
    let uid = 0;
    for(let i = 0; i < size; i++)uid = uid * 31 + textures[i].uid >>> 0;
    return $592667ad03caa38e$var$cachedGroups[uid] || $592667ad03caa38e$var$generateTextureBatchBindGroup(textures, uid);
}
function $592667ad03caa38e$var$generateTextureBatchBindGroup(textures, key) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < (0, $g7C2p.MAX_TEXTURES); i++){
        const texture = i < textures.length ? textures[i] : (0, $jollT.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $8Uizi.BindGroup)(bindGroupResources);
    $592667ad03caa38e$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});
parcelRegister("8Uizi", function(module, exports) {

$parcel$export(module.exports, "BindGroup", () => $ccb0846883e615e8$export$6f452ee382def63c);
"use strict";
class $ccb0846883e615e8$export$6f452ee382def63c {
    /**
   * Create a new instance eof the Bind Group.
   * @param resources - The resources that are bound together for use by a shader.
   */ constructor(resources){
        /** The resources that are bound together for use by a shader. */ this.resources = /* @__PURE__ */ Object.create(null);
        this._dirty = true;
        let index = 0;
        for(const i in resources){
            const resource = resources[i];
            this.setResource(resource, index++);
        }
        this._updateKey();
    }
    /**
   * Updates the key if its flagged as dirty. This is used internally to
   * match this bind group to a WebGPU BindGroup.
   * @internal
   * @ignore
   */ _updateKey() {
        if (!this._dirty) return;
        this._dirty = false;
        const keyParts = [];
        let index = 0;
        for(const i in this.resources)keyParts[index++] = this.resources[i]._resourceId;
        this._key = keyParts.join("|");
    }
    /**
   * Set a resource at a given index. this function will
   * ensure that listeners will be removed from the current resource
   * and added to the new resource.
   * @param resource - The resource to set.
   * @param index - The index to set the resource at.
   */ setResource(resource, index) {
        const currentResource = this.resources[index];
        if (resource === currentResource) return;
        if (currentResource) resource.off?.("change", this.onResourceChange, this);
        resource.on?.("change", this.onResourceChange, this);
        this.resources[index] = resource;
        this._dirty = true;
    }
    /**
   * Returns the resource at the current specified index.
   * @param index - The index of the resource to get.
   * @returns - The resource at the specified index.
   */ getResource(index) {
        return this.resources[index];
    }
    /**
   * Used internally to 'touch' each resource, to ensure that the GC
   * knows that all resources in this bind group are still being used.
   * @param tick - The current tick.
   * @internal
   * @ignore
   */ _touch(tick) {
        const resources = this.resources;
        for(const i in resources)resources[i]._touched = tick;
    }
    /** Destroys this bind group and removes all listeners. */ destroy() {
        const resources = this.resources;
        for(const i in resources){
            const resource = resources[i];
            resource.off?.("change", this.onResourceChange, this);
        }
        this.resources = null;
    }
    onResourceChange(resource) {
        this._dirty = true;
        if (resource.destroyed) {
            const resources = this.resources;
            for(const i in resources)if (resources[i] === resource) resources[i] = null;
        } else this._updateKey();
    }
}

});

parcelRegister("g7C2p", function(module, exports) {

$parcel$export(module.exports, "MAX_TEXTURES", () => $f5afa4f552476484$export$e09e7788b3f0275e);
"use strict";
const $f5afa4f552476484$export$e09e7788b3f0275e = 16;

});


parcelRegister("8s2Nq", function(module, exports) {

$parcel$export(module.exports, "Batcher", () => $a7ae5669479a5b28$export$704b12ddc1dacdd2);

var $by5BM = parcelRequire("by5BM");

var $4h51B = parcelRequire("4h51B");

var $6mKBq = parcelRequire("6mKBq");

var $jMmQ5 = parcelRequire("jMmQ5");

var $kO70o = parcelRequire("kO70o");

var $g7C2p = parcelRequire("g7C2p");
"use strict";
class $a7ae5669479a5b28$export$33b107562567fc47 {
    constructor(){
        this.renderPipeId = "batch";
        this.action = "startBatch";
        // TODO - eventually this could be useful for flagging batches as dirty and then only rebuilding those ones
        // public elementStart = 0;
        // public elementSize = 0;
        // for drawing..
        this.start = 0;
        this.size = 0;
        this.blendMode = "normal";
        this.canBundle = true;
    }
    destroy() {
        this.textures = null;
        this.gpuBindGroup = null;
        this.bindGroup = null;
        this.batcher = null;
    }
}
let $a7ae5669479a5b28$var$BATCH_TICK = 0;
const $a7ae5669479a5b28$var$_Batcher = class _Batcher {
    constructor(options = {}){
        this.uid = (0, $by5BM.uid)("batcher");
        this.dirty = true;
        this.batchIndex = 0;
        this.batches = [];
        // specifics.
        this._vertexSize = 6;
        this._elements = [];
        this._batchPool = [];
        this._batchPoolIndex = 0;
        this._textureBatchPool = [];
        this._textureBatchPoolIndex = 0;
        options = {
            ..._Batcher.defaultOptions,
            ...options
        };
        const { vertexSize: vertexSize, indexSize: indexSize } = options;
        this.attributeBuffer = new (0, $4h51B.ViewableBuffer)(vertexSize * this._vertexSize * 4);
        this.indexBuffer = new Uint16Array(indexSize);
    }
    begin() {
        this.batchIndex = 0;
        this.elementSize = 0;
        this.elementStart = 0;
        this.indexSize = 0;
        this.attributeSize = 0;
        this._batchPoolIndex = 0;
        this._textureBatchPoolIndex = 0;
        this._batchIndexStart = 0;
        this._batchIndexSize = 0;
        this.dirty = true;
    }
    add(batchableObject) {
        this._elements[this.elementSize++] = batchableObject;
        batchableObject.indexStart = this.indexSize;
        batchableObject.location = this.attributeSize;
        batchableObject.batcher = this;
        this.indexSize += batchableObject.indexSize;
        this.attributeSize += batchableObject.vertexSize * this._vertexSize;
    }
    checkAndUpdateTexture(batchableObject, texture) {
        const textureId = batchableObject.batch.textures.ids[texture._source.uid];
        if (!textureId && textureId !== 0) return false;
        batchableObject.textureId = textureId;
        batchableObject.texture = texture;
        return true;
    }
    updateElement(batchableObject) {
        this.dirty = true;
        batchableObject.packAttributes(this.attributeBuffer.float32View, this.attributeBuffer.uint32View, batchableObject.location, batchableObject.textureId);
    }
    /**
   * breaks the batcher. This happens when a batch gets too big,
   * or we need to switch to a different type of rendering (a filter for example)
   * @param instructionSet
   */ break(instructionSet) {
        const elements = this._elements;
        let textureBatch = this._textureBatchPool[this._textureBatchPoolIndex++] || new (0, $kO70o.BatchTextureArray)();
        textureBatch.clear();
        if (!elements[this.elementStart]) return;
        const firstElement = elements[this.elementStart];
        let blendMode = (0, $jMmQ5.getAdjustedBlendModeBlend)(firstElement.blendMode, firstElement.texture._source);
        if (this.attributeSize * 4 > this.attributeBuffer.size) this._resizeAttributeBuffer(this.attributeSize * 4);
        if (this.indexSize > this.indexBuffer.length) this._resizeIndexBuffer(this.indexSize);
        const f32 = this.attributeBuffer.float32View;
        const u32 = this.attributeBuffer.uint32View;
        const iBuffer = this.indexBuffer;
        let size = this._batchIndexSize;
        let start = this._batchIndexStart;
        let action = "startBatch";
        let batch = this._batchPool[this._batchPoolIndex++] || new $a7ae5669479a5b28$export$33b107562567fc47();
        for(let i = this.elementStart; i < this.elementSize; ++i){
            const element = elements[i];
            elements[i] = null;
            const texture = element.texture;
            const source = texture._source;
            const adjustedBlendMode = (0, $jMmQ5.getAdjustedBlendModeBlend)(element.blendMode, source);
            const blendModeChange = blendMode !== adjustedBlendMode;
            if (source._batchTick === $a7ae5669479a5b28$var$BATCH_TICK && !blendModeChange) {
                element.textureId = source._textureBindLocation;
                size += element.indexSize;
                element.packAttributes(f32, u32, element.location, element.textureId);
                element.packIndex(iBuffer, element.indexStart, element.location / this._vertexSize);
                element.batch = batch;
                continue;
            }
            source._batchTick = $a7ae5669479a5b28$var$BATCH_TICK;
            if (textureBatch.count >= (0, $g7C2p.MAX_TEXTURES) || blendModeChange) {
                this._finishBatch(batch, start, size - start, textureBatch, blendMode, instructionSet, action);
                action = "renderBatch";
                start = size;
                blendMode = adjustedBlendMode;
                textureBatch = this._textureBatchPool[this._textureBatchPoolIndex++] || new (0, $kO70o.BatchTextureArray)();
                textureBatch.clear();
                batch = this._batchPool[this._batchPoolIndex++] || new $a7ae5669479a5b28$export$33b107562567fc47();
                ++$a7ae5669479a5b28$var$BATCH_TICK;
            }
            element.textureId = source._textureBindLocation = textureBatch.count;
            textureBatch.ids[source.uid] = textureBatch.count;
            textureBatch.textures[textureBatch.count++] = source;
            element.batch = batch;
            size += element.indexSize;
            element.packAttributes(f32, u32, element.location, element.textureId);
            element.packIndex(iBuffer, element.indexStart, element.location / this._vertexSize);
        }
        if (textureBatch.count > 0) {
            this._finishBatch(batch, start, size - start, textureBatch, blendMode, instructionSet, action);
            start = size;
            ++$a7ae5669479a5b28$var$BATCH_TICK;
        }
        this.elementStart = this.elementSize;
        this._batchIndexStart = start;
        this._batchIndexSize = size;
    }
    _finishBatch(batch, indexStart, indexSize, textureBatch, blendMode, instructionSet, action) {
        batch.gpuBindGroup = null;
        batch.action = action;
        batch.batcher = this;
        batch.textures = textureBatch;
        batch.blendMode = blendMode;
        batch.start = indexStart;
        batch.size = indexSize;
        ++$a7ae5669479a5b28$var$BATCH_TICK;
        instructionSet.add(batch);
    }
    finish(instructionSet) {
        this.break(instructionSet);
    }
    /**
   * Resizes the attribute buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */ ensureAttributeBuffer(size) {
        if (size * 4 <= this.attributeBuffer.size) return;
        this._resizeAttributeBuffer(size * 4);
    }
    /**
   * Resizes the index buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */ ensureIndexBuffer(size) {
        if (size <= this.indexBuffer.length) return;
        this._resizeIndexBuffer(size);
    }
    _resizeAttributeBuffer(size) {
        const newSize = Math.max(size, this.attributeBuffer.size * 2);
        const newArrayBuffer = new (0, $4h51B.ViewableBuffer)(newSize);
        (0, $6mKBq.fastCopy)(this.attributeBuffer.rawBinaryData, newArrayBuffer.rawBinaryData);
        this.attributeBuffer = newArrayBuffer;
    }
    _resizeIndexBuffer(size) {
        const indexBuffer = this.indexBuffer;
        let newSize = Math.max(size, indexBuffer.length * 1.5);
        newSize += newSize % 2;
        const newIndexBuffer = newSize > 65535 ? new Uint32Array(newSize) : new Uint16Array(newSize);
        if (newIndexBuffer.BYTES_PER_ELEMENT !== indexBuffer.BYTES_PER_ELEMENT) for(let i = 0; i < indexBuffer.length; i++)newIndexBuffer[i] = indexBuffer[i];
        else (0, $6mKBq.fastCopy)(indexBuffer.buffer, newIndexBuffer.buffer);
        this.indexBuffer = newIndexBuffer;
    }
    destroy() {
        for(let i = 0; i < this.batches.length; i++)this.batches[i].destroy();
        this.batches = null;
        for(let i = 0; i < this._elements.length; i++)this._elements[i].batch = null;
        this._elements = null;
        this.indexBuffer = null;
        this.attributeBuffer.destroy();
        this.attributeBuffer = null;
    }
};
$a7ae5669479a5b28$var$_Batcher.defaultOptions = {
    vertexSize: 4,
    indexSize: 6
};
let $a7ae5669479a5b28$export$704b12ddc1dacdd2 = $a7ae5669479a5b28$var$_Batcher;

});
parcelRegister("4h51B", function(module, exports) {

$parcel$export(module.exports, "ViewableBuffer", () => $6a96ef2b79c966ef$export$4fdbf0662aa3047a);
"use strict";
class $6a96ef2b79c966ef$export$4fdbf0662aa3047a {
    constructor(sizeOrBuffer){
        if (typeof sizeOrBuffer === "number") this.rawBinaryData = new ArrayBuffer(sizeOrBuffer);
        else if (sizeOrBuffer instanceof Uint8Array) this.rawBinaryData = sizeOrBuffer.buffer;
        else this.rawBinaryData = sizeOrBuffer;
        this.uint32View = new Uint32Array(this.rawBinaryData);
        this.float32View = new Float32Array(this.rawBinaryData);
        this.size = this.rawBinaryData.byteLength;
    }
    /** View on the raw binary data as a `Int8Array`. */ get int8View() {
        if (!this._int8View) this._int8View = new Int8Array(this.rawBinaryData);
        return this._int8View;
    }
    /** View on the raw binary data as a `Uint8Array`. */ get uint8View() {
        if (!this._uint8View) this._uint8View = new Uint8Array(this.rawBinaryData);
        return this._uint8View;
    }
    /**  View on the raw binary data as a `Int16Array`. */ get int16View() {
        if (!this._int16View) this._int16View = new Int16Array(this.rawBinaryData);
        return this._int16View;
    }
    /** View on the raw binary data as a `Int32Array`. */ get int32View() {
        if (!this._int32View) this._int32View = new Int32Array(this.rawBinaryData);
        return this._int32View;
    }
    /** View on the raw binary data as a `Float64Array`. */ get float64View() {
        if (!this._float64Array) this._float64Array = new Float64Array(this.rawBinaryData);
        return this._float64Array;
    }
    /** View on the raw binary data as a `BigUint64Array`. */ get bigUint64View() {
        if (!this._bigUint64Array) this._bigUint64Array = new BigUint64Array(this.rawBinaryData);
        return this._bigUint64Array;
    }
    /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */ view(type) {
        return this[`${type}View`];
    }
    /** Destroys all buffer references. Do not use after calling this. */ destroy() {
        this.rawBinaryData = null;
        this._int8View = null;
        this._uint8View = null;
        this._int16View = null;
        this.uint16View = null;
        this._int32View = null;
        this.uint32View = null;
        this.float32View = null;
    }
    /**
   * Returns the size of the given type in bytes.
   * @param type - One of `int8`, `uint8`, `int16`,
   *   `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - size of the type in bytes
   */ static sizeOf(type) {
        switch(type){
            case "int8":
            case "uint8":
                return 1;
            case "int16":
            case "uint16":
                return 2;
            case "int32":
            case "uint32":
            case "float32":
                return 4;
            default:
                throw new Error(`${type} isn't a valid view type`);
        }
    }
}

});

parcelRegister("6mKBq", function(module, exports) {

$parcel$export(module.exports, "fastCopy", () => $b326302997d88b08$export$c691b0c42debe682);
"use strict";
function $b326302997d88b08$export$c691b0c42debe682(sourceBuffer, destinationBuffer) {
    const lengthDouble = sourceBuffer.byteLength / 8 | 0;
    const sourceFloat64View = new Float64Array(sourceBuffer, 0, lengthDouble);
    const destinationFloat64View = new Float64Array(destinationBuffer, 0, lengthDouble);
    destinationFloat64View.set(sourceFloat64View);
    const remainingBytes = sourceBuffer.byteLength - lengthDouble * 8;
    if (remainingBytes > 0) {
        const sourceUint8View = new Uint8Array(sourceBuffer, lengthDouble * 8, remainingBytes);
        const destinationUint8View = new Uint8Array(destinationBuffer, lengthDouble * 8, remainingBytes);
        destinationUint8View.set(sourceUint8View);
    }
}

});

parcelRegister("jMmQ5", function(module, exports) {

$parcel$export(module.exports, "getAdjustedBlendModeBlend", () => $05de39e184ab52ed$export$ab2fc5cf3fe899fe);

var $af8rS = parcelRequire("af8rS");
"use strict";
function $05de39e184ab52ed$export$ab2fc5cf3fe899fe(blendMode, textureSource) {
    if (textureSource.alphaMode === "no-premultiply-alpha") return (0, $af8rS.BLEND_TO_NPM)[blendMode] || blendMode;
    return blendMode;
}

});
parcelRegister("af8rS", function(module, exports) {

$parcel$export(module.exports, "BLEND_TO_NPM", () => $14e6ef2f0482a26c$export$8c0bd2ccaa4a8d5e);
$parcel$export(module.exports, "STENCIL_MODES", () => $14e6ef2f0482a26c$export$c250b85d73a91bdf);
"use strict";
const $14e6ef2f0482a26c$export$8c0bd2ccaa4a8d5e = {
    normal: "normal-npm",
    add: "add-npm",
    screen: "screen-npm"
};
var $14e6ef2f0482a26c$export$c250b85d73a91bdf = /* @__PURE__ */ ((STENCIL_MODES2)=>{
    STENCIL_MODES2[STENCIL_MODES2["DISABLED"] = 0] = "DISABLED";
    STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_ADD"] = 1] = "RENDERING_MASK_ADD";
    STENCIL_MODES2[STENCIL_MODES2["MASK_ACTIVE"] = 2] = "MASK_ACTIVE";
    STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_REMOVE"] = 3] = "RENDERING_MASK_REMOVE";
    STENCIL_MODES2[STENCIL_MODES2["NONE"] = 4] = "NONE";
    return STENCIL_MODES2;
})($14e6ef2f0482a26c$export$c250b85d73a91bdf || {});

});


parcelRegister("kO70o", function(module, exports) {

$parcel$export(module.exports, "BatchTextureArray", () => $626f656120b9f6a3$export$aa760e0febf1a758);
"use strict";
class $626f656120b9f6a3$export$aa760e0febf1a758 {
    constructor(){
        /** Respective locations for textures. */ this.ids = /* @__PURE__ */ Object.create(null);
        this.textures = [];
        this.count = 0;
    }
    /** Clear the textures and their locations. */ clear() {
        for(let i = 0; i < this.count; i++){
            const t = this.textures[i];
            this.textures[i] = null;
            this.ids[t.uid] = null;
        }
        this.count = 0;
    }
}

});


parcelRegister("9dWY3", function(module, exports) {

$parcel$export(module.exports, "buildContextBatches", () => $42430e1d0b12dd0b$export$e3c00f31a053d231);

var $hFBUu = parcelRequire("hFBUu");

var $9CP60 = parcelRequire("9CP60");

var $95vXQ = parcelRequire("95vXQ");

var $jollT = parcelRequire("jollT");

var $8ZHaq = parcelRequire("8ZHaq");

var $i5zXQ = parcelRequire("i5zXQ");

var $gBzwE = parcelRequire("gBzwE");

var $er2Z3 = parcelRequire("er2Z3");

var $7SnGQ = parcelRequire("7SnGQ");

var $gNR5d = parcelRequire("gNR5d");

var $23KZx = parcelRequire("23KZx");

var $3KVWv = parcelRequire("3KVWv");
"use strict";
const $42430e1d0b12dd0b$var$buildMap = {
    rectangle: (0, $gNR5d.buildRectangle),
    polygon: (0, $7SnGQ.buildPolygon),
    triangle: (0, $23KZx.buildTriangle),
    circle: (0, $gBzwE.buildCircle),
    ellipse: (0, $gBzwE.buildCircle),
    roundedRectangle: (0, $gBzwE.buildCircle)
};
const $42430e1d0b12dd0b$var$tempRect = new (0, $hFBUu.Rectangle)();
function $42430e1d0b12dd0b$export$e3c00f31a053d231(context, gpuContext) {
    const { geometryData: geometryData, batches: batches } = gpuContext;
    batches.length = 0;
    geometryData.indices.length = 0;
    geometryData.vertices.length = 0;
    geometryData.uvs.length = 0;
    for(let i = 0; i < context.instructions.length; i++){
        const instruction = context.instructions[i];
        if (instruction.action === "texture") $42430e1d0b12dd0b$var$addTextureToGeometryData(instruction.data, batches, geometryData);
        else if (instruction.action === "fill" || instruction.action === "stroke") {
            const isStroke = instruction.action === "stroke";
            const shapePath = instruction.data.path.shapePath;
            const style = instruction.data.style;
            const hole = instruction.data.hole;
            if (isStroke && hole) $42430e1d0b12dd0b$var$addShapePathToGeometryData(hole.shapePath, style, null, true, batches, geometryData);
            $42430e1d0b12dd0b$var$addShapePathToGeometryData(shapePath, style, hole, isStroke, batches, geometryData);
        }
    }
}
function $42430e1d0b12dd0b$var$addTextureToGeometryData(data, batches, geometryData) {
    const { vertices: vertices, uvs: uvs, indices: indices } = geometryData;
    const indexOffset = indices.length;
    const vertOffset = vertices.length / 2;
    const points = [];
    const build = $42430e1d0b12dd0b$var$buildMap.rectangle;
    const rect = $42430e1d0b12dd0b$var$tempRect;
    const texture = data.image;
    rect.x = data.dx;
    rect.y = data.dy;
    rect.width = data.dw;
    rect.height = data.dh;
    const matrix = data.transform;
    build.build(rect, points);
    if (matrix) (0, $95vXQ.transformVertices)(points, matrix);
    build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
    const textureUvs = texture.uvs;
    uvs.push(textureUvs.x0, textureUvs.y0, textureUvs.x1, textureUvs.y1, textureUvs.x3, textureUvs.y3, textureUvs.x2, textureUvs.y2);
    const graphicsBatch = (0, $8ZHaq.BigPool).get((0, $i5zXQ.BatchableGraphics));
    graphicsBatch.indexOffset = indexOffset;
    graphicsBatch.indexSize = indices.length - indexOffset;
    graphicsBatch.vertexOffset = vertOffset;
    graphicsBatch.vertexSize = vertices.length / 2 - vertOffset;
    graphicsBatch.color = data.style;
    graphicsBatch.alpha = data.alpha;
    graphicsBatch.texture = texture;
    graphicsBatch.geometryData = geometryData;
    batches.push(graphicsBatch);
}
function $42430e1d0b12dd0b$var$addShapePathToGeometryData(shapePath, style, hole, isStroke, batches, geometryData) {
    const { vertices: vertices, uvs: uvs, indices: indices } = geometryData;
    const lastIndex = shapePath.shapePrimitives.length - 1;
    shapePath.shapePrimitives.forEach(({ shape: shape, transform: matrix }, i)=>{
        const indexOffset = indices.length;
        const vertOffset = vertices.length / 2;
        const points = [];
        const build = $42430e1d0b12dd0b$var$buildMap[shape.type];
        build.build(shape, points);
        if (matrix) (0, $95vXQ.transformVertices)(points, matrix);
        if (!isStroke) {
            if (hole && lastIndex === i) {
                if (lastIndex !== 0) console.warn("[Pixi Graphics] only the last shape have be cut out");
                const holeIndices = [];
                const otherPoints = points.slice();
                const holeArrays = $42430e1d0b12dd0b$var$getHoleArrays(hole.shapePath);
                holeArrays.forEach((holePoints)=>{
                    holeIndices.push(otherPoints.length / 2);
                    otherPoints.push(...holePoints);
                });
                (0, $3KVWv.triangulateWithHoles)(otherPoints, holeIndices, vertices, 2, vertOffset, indices, indexOffset);
            } else build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
        } else {
            const close = shape.closePath ?? true;
            const lineStyle = style;
            (0, $er2Z3.buildLine)(points, lineStyle, false, close, vertices, 2, vertOffset, indices, indexOffset);
        }
        const uvsOffset = uvs.length / 2;
        const texture = style.texture;
        if (texture !== (0, $jollT.Texture).WHITE) {
            const textureMatrix = style.matrix;
            if (matrix) textureMatrix.append(matrix.clone().invert());
            (0, $9CP60.buildUvs)(vertices, 2, vertOffset, uvs, uvsOffset, 2, vertices.length / 2 - vertOffset, textureMatrix);
        } else (0, $9CP60.buildSimpleUvs)(uvs, uvsOffset, 2, vertices.length / 2 - vertOffset);
        const graphicsBatch = (0, $8ZHaq.BigPool).get((0, $i5zXQ.BatchableGraphics));
        graphicsBatch.indexOffset = indexOffset;
        graphicsBatch.indexSize = indices.length - indexOffset;
        graphicsBatch.vertexOffset = vertOffset;
        graphicsBatch.vertexSize = vertices.length / 2 - vertOffset;
        graphicsBatch.color = style.color;
        graphicsBatch.alpha = style.alpha;
        graphicsBatch.texture = texture;
        graphicsBatch.geometryData = geometryData;
        batches.push(graphicsBatch);
    });
}
function $42430e1d0b12dd0b$var$getHoleArrays(shape) {
    if (!shape) return [];
    const holePrimitives = shape.shapePrimitives;
    const holeArrays = [];
    for(let k = 0; k < holePrimitives.length; k++){
        const holePrimitive = holePrimitives[k].shape;
        const holePoints = [];
        const holeBuilder = $42430e1d0b12dd0b$var$buildMap[holePrimitive.type];
        holeBuilder.build(holePrimitive, holePoints);
        holeArrays.push(holePoints);
    }
    return holeArrays;
}

});
parcelRegister("9CP60", function(module, exports) {

$parcel$export(module.exports, "buildUvs", () => $aae5ec4578eb87d4$export$2027711a0ff70dc2);
$parcel$export(module.exports, "buildSimpleUvs", () => $aae5ec4578eb87d4$export$580e3d8462b9fe52);
"use strict";
function $aae5ec4578eb87d4$export$2027711a0ff70dc2(vertices, verticesStride, verticesOffset, uvs, uvsOffset, uvsStride, size, matrix = null) {
    let index = 0;
    verticesOffset *= verticesStride;
    uvsOffset *= uvsStride;
    const a = matrix.a;
    const b = matrix.b;
    const c = matrix.c;
    const d = matrix.d;
    const tx = matrix.tx;
    const ty = matrix.ty;
    while(index < size){
        const x = vertices[verticesOffset];
        const y = vertices[verticesOffset + 1];
        uvs[uvsOffset] = a * x + c * y + tx;
        uvs[uvsOffset + 1] = b * x + d * y + ty;
        uvsOffset += uvsStride;
        verticesOffset += verticesStride;
        index++;
    }
}
function $aae5ec4578eb87d4$export$580e3d8462b9fe52(uvs, uvsOffset, uvsStride, size) {
    let index = 0;
    uvsOffset *= uvsStride;
    while(index < size){
        uvs[uvsOffset] = 0;
        uvs[uvsOffset + 1] = 0;
        uvsOffset += uvsStride;
        index++;
    }
}

});

parcelRegister("95vXQ", function(module, exports) {

$parcel$export(module.exports, "transformVertices", () => $43e132f58bf3caa1$export$cbe36b8a8d6e3d3);
"use strict";
function $43e132f58bf3caa1$export$cbe36b8a8d6e3d3(vertices, m, offset, stride, size) {
    const a = m.a;
    const b = m.b;
    const c = m.c;
    const d = m.d;
    const tx = m.tx;
    const ty = m.ty;
    offset = offset || 0;
    stride = stride || 2;
    size = size || vertices.length / stride - offset;
    let index = offset * stride;
    for(let i = 0; i < size; i++){
        const x = vertices[index];
        const y = vertices[index + 1];
        vertices[index] = a * x + c * y + tx;
        vertices[index + 1] = b * x + d * y + ty;
        index += stride;
    }
}

});

parcelRegister("i5zXQ", function(module, exports) {

$parcel$export(module.exports, "BatchableGraphics", () => $c23487ce7d0e819a$export$91d2a08bbf21546b);

var $87h7J = parcelRequire("87h7J");
"use strict";
class $c23487ce7d0e819a$export$91d2a08bbf21546b {
    constructor(){
        this.batcher = null;
        this.batch = null;
        this.applyTransform = true;
        this.roundPixels = 0;
    }
    get blendMode() {
        if (this.applyTransform) return this.renderable.groupBlendMode;
        return "normal";
    }
    packIndex(indexBuffer, index, indicesOffset) {
        const indices = this.geometryData.indices;
        for(let i = 0; i < this.indexSize; i++)indexBuffer[index++] = indices[i + this.indexOffset] + indicesOffset - this.vertexOffset;
    }
    packAttributes(float32View, uint32View, index, textureId) {
        const geometry = this.geometryData;
        const graphics = this.renderable;
        const positions = geometry.vertices;
        const uvs = geometry.uvs;
        const offset = this.vertexOffset * 2;
        const vertSize = (this.vertexOffset + this.vertexSize) * 2;
        const rgb = this.color;
        const bgr = rgb >> 16 | rgb & 65280 | (rgb & 255) << 16;
        if (this.applyTransform) {
            const argb = (0, $87h7J.multiplyHexColors)(bgr, graphics.groupColor) + (this.alpha * graphics.groupAlpha * 255 << 24);
            const wt = graphics.groupTransform;
            const textureIdAndRound = textureId << 16 | this.roundPixels & 65535;
            const a = wt.a;
            const b = wt.b;
            const c = wt.c;
            const d = wt.d;
            const tx = wt.tx;
            const ty = wt.ty;
            for(let i = offset; i < vertSize; i += 2){
                const x = positions[i];
                const y = positions[i + 1];
                float32View[index] = a * x + c * y + tx;
                float32View[index + 1] = b * x + d * y + ty;
                float32View[index + 2] = uvs[i];
                float32View[index + 3] = uvs[i + 1];
                uint32View[index + 4] = argb;
                uint32View[index + 5] = textureIdAndRound;
                index += 6;
            }
        } else {
            const argb = bgr + (this.alpha * 255 << 24);
            for(let i = offset; i < vertSize; i += 2){
                float32View[index] = positions[i];
                float32View[index + 1] = positions[i + 1];
                float32View[index + 2] = uvs[i];
                float32View[index + 3] = uvs[i + 1];
                uint32View[index + 4] = argb;
                uint32View[index + 5] = textureId << 16;
                index += 6;
            }
        }
    }
    // TODO rename to vertexSize
    get vertSize() {
        return this.vertexSize;
    }
    copyTo(gpuBuffer) {
        gpuBuffer.indexOffset = this.indexOffset;
        gpuBuffer.indexSize = this.indexSize;
        gpuBuffer.vertexOffset = this.vertexOffset;
        gpuBuffer.vertexSize = this.vertexSize;
        gpuBuffer.color = this.color;
        gpuBuffer.alpha = this.alpha;
        gpuBuffer.texture = this.texture;
        gpuBuffer.geometryData = this.geometryData;
    }
    reset() {
        this.applyTransform = true;
    }
}

});
parcelRegister("87h7J", function(module, exports) {

$parcel$export(module.exports, "multiplyHexColors", () => $5a59da46d6c1c9b0$export$815d7ea0395de72c);
"use strict";
function $5a59da46d6c1c9b0$export$815d7ea0395de72c(color1, color2) {
    if (color1 === 16777215 || !color2) return color2;
    if (color2 === 16777215 || !color1) return color1;
    const r1 = color1 >> 16 & 255;
    const g1 = color1 >> 8 & 255;
    const b1 = color1 & 255;
    const r2 = color2 >> 16 & 255;
    const g2 = color2 >> 8 & 255;
    const b2 = color2 & 255;
    const r = r1 * r2 / 255;
    const g = g1 * g2 / 255;
    const b = b1 * b2 / 255;
    return (r << 16) + (g << 8) + b;
}

});


parcelRegister("gBzwE", function(module, exports) {

$parcel$export(module.exports, "buildCircle", () => $90d713ffe85ba3a6$export$a3541b2d8ecbfcf2);
"use strict";
const $90d713ffe85ba3a6$export$a3541b2d8ecbfcf2 = {
    build (shape, points) {
        let x;
        let y;
        let dx;
        let dy;
        let rx;
        let ry;
        if (shape.type === "circle") {
            const circle = shape;
            x = circle.x;
            y = circle.y;
            rx = ry = circle.radius;
            dx = dy = 0;
        } else if (shape.type === "ellipse") {
            const ellipse = shape;
            x = ellipse.x;
            y = ellipse.y;
            rx = ellipse.halfWidth;
            ry = ellipse.halfHeight;
            dx = dy = 0;
        } else {
            const roundedRect = shape;
            const halfWidth = roundedRect.width / 2;
            const halfHeight = roundedRect.height / 2;
            x = roundedRect.x + halfWidth;
            y = roundedRect.y + halfHeight;
            rx = ry = Math.max(0, Math.min(roundedRect.radius, Math.min(halfWidth, halfHeight)));
            dx = halfWidth - rx;
            dy = halfHeight - ry;
        }
        if (!(rx >= 0 && ry >= 0 && dx >= 0 && dy >= 0)) return points;
        const n = Math.ceil(2.3 * Math.sqrt(rx + ry));
        const m = n * 8 + (dx ? 4 : 0) + (dy ? 4 : 0);
        if (m === 0) return points;
        if (n === 0) {
            points[0] = points[6] = x + dx;
            points[1] = points[3] = y + dy;
            points[2] = points[4] = x - dx;
            points[5] = points[7] = y - dy;
            return points;
        }
        let j1 = 0;
        let j2 = n * 4 + (dx ? 2 : 0) + 2;
        let j3 = j2;
        let j4 = m;
        let x0 = dx + rx;
        let y0 = dy;
        let x1 = x + x0;
        let x2 = x - x0;
        let y1 = y + y0;
        points[j1++] = x1;
        points[j1++] = y1;
        points[--j2] = y1;
        points[--j2] = x2;
        if (dy) {
            const y22 = y - y0;
            points[j3++] = x2;
            points[j3++] = y22;
            points[--j4] = y22;
            points[--j4] = x1;
        }
        for(let i = 1; i < n; i++){
            const a = Math.PI / 2 * (i / n);
            const x02 = dx + Math.cos(a) * rx;
            const y02 = dy + Math.sin(a) * ry;
            const x12 = x + x02;
            const x22 = x - x02;
            const y12 = y + y02;
            const y22 = y - y02;
            points[j1++] = x12;
            points[j1++] = y12;
            points[--j2] = y12;
            points[--j2] = x22;
            points[j3++] = x22;
            points[j3++] = y22;
            points[--j4] = y22;
            points[--j4] = x12;
        }
        x0 = dx;
        y0 = dy + ry;
        x1 = x + x0;
        x2 = x - x0;
        y1 = y + y0;
        const y2 = y - y0;
        points[j1++] = x1;
        points[j1++] = y1;
        points[--j4] = y2;
        points[--j4] = x1;
        if (dx) {
            points[j1++] = x2;
            points[j1++] = y1;
            points[--j4] = y2;
            points[--j4] = x2;
        }
        return points;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        if (points.length === 0) return;
        let centerX = 0;
        let centerY = 0;
        for(let i = 0; i < points.length; i += 2){
            centerX += points[i];
            centerY += points[i + 1];
        }
        centerX /= points.length / 2;
        centerY /= points.length / 2;
        let count = verticesOffset;
        vertices[count * verticesStride] = centerX;
        vertices[count * verticesStride + 1] = centerY;
        const centerIndex = count++;
        for(let i = 0; i < points.length; i += 2){
            vertices[count * verticesStride] = points[i];
            vertices[count * verticesStride + 1] = points[i + 1];
            if (i > 0) {
                indices[indicesOffset++] = count;
                indices[indicesOffset++] = centerIndex;
                indices[indicesOffset++] = count - 1;
            }
            count++;
        }
        indices[indicesOffset++] = centerIndex + 1;
        indices[indicesOffset++] = centerIndex;
        indices[indicesOffset++] = count - 1;
    }
};

});

parcelRegister("er2Z3", function(module, exports) {

$parcel$export(module.exports, "buildLine", () => $93adb69e7c93bab1$export$45986ccf08e93b0b);

var $bwMhC = parcelRequire("bwMhC");

var $aThAx = parcelRequire("aThAx");

var $7TFU6 = parcelRequire("7TFU6");
"use strict";
function $93adb69e7c93bab1$var$square(x, y, nx, ny, innerWeight, outerWeight, clockwise, verts) {
    const ix = x - nx * innerWeight;
    const iy = y - ny * innerWeight;
    const ox = x + nx * outerWeight;
    const oy = y + ny * outerWeight;
    let exx;
    let eyy;
    if (clockwise) {
        exx = ny;
        eyy = -nx;
    } else {
        exx = -ny;
        eyy = nx;
    }
    const eix = ix + exx;
    const eiy = iy + eyy;
    const eox = ox + exx;
    const eoy = oy + eyy;
    verts.push(eix, eiy);
    verts.push(eox, eoy);
    return 2;
}
function $93adb69e7c93bab1$var$round(cx, cy, sx, sy, ex, ey, verts, clockwise) {
    const cx2p0x = sx - cx;
    const cy2p0y = sy - cy;
    let angle0 = Math.atan2(cx2p0x, cy2p0y);
    let angle1 = Math.atan2(ex - cx, ey - cy);
    if (clockwise && angle0 < angle1) angle0 += Math.PI * 2;
    else if (!clockwise && angle0 > angle1) angle1 += Math.PI * 2;
    let startAngle = angle0;
    const angleDiff = angle1 - angle0;
    const absAngleDiff = Math.abs(angleDiff);
    const radius = Math.sqrt(cx2p0x * cx2p0x + cy2p0y * cy2p0y);
    const segCount = (15 * absAngleDiff * Math.sqrt(radius) / Math.PI >> 0) + 1;
    const angleInc = angleDiff / segCount;
    startAngle += angleInc;
    if (clockwise) {
        verts.push(cx, cy);
        verts.push(sx, sy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx, cy);
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
        }
        verts.push(cx, cy);
        verts.push(ex, ey);
    } else {
        verts.push(sx, sy);
        verts.push(cx, cy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
            verts.push(cx, cy);
        }
        verts.push(ex, ey);
        verts.push(cx, cy);
    }
    return segCount * 2;
}
function $93adb69e7c93bab1$export$45986ccf08e93b0b(points, lineStyle, flipAlignment, closed, vertices, _verticesStride, _verticesOffset, indices, _indicesOffset) {
    const eps = (0, $aThAx.closePointEps);
    if (points.length === 0) return;
    const style = lineStyle;
    let alignment = style.alignment;
    if (lineStyle.alignment !== 0.5) {
        let orientation = (0, $7TFU6.getOrientationOfPoints)(points);
        if (flipAlignment) orientation *= -1;
        alignment = (alignment - 0.5) * orientation + 0.5;
    }
    const firstPoint = new (0, $bwMhC.Point)(points[0], points[1]);
    const lastPoint = new (0, $bwMhC.Point)(points[points.length - 2], points[points.length - 1]);
    const closedShape = closed;
    const closedPath = Math.abs(firstPoint.x - lastPoint.x) < eps && Math.abs(firstPoint.y - lastPoint.y) < eps;
    if (closedShape) {
        points = points.slice();
        if (closedPath) {
            points.pop();
            points.pop();
            lastPoint.set(points[points.length - 2], points[points.length - 1]);
        }
        const midPointX = (firstPoint.x + lastPoint.x) * 0.5;
        const midPointY = (lastPoint.y + firstPoint.y) * 0.5;
        points.unshift(midPointX, midPointY);
        points.push(midPointX, midPointY);
    }
    const verts = vertices;
    const length = points.length / 2;
    let indexCount = points.length;
    const indexStart = verts.length / 2;
    const width = style.width / 2;
    const widthSquared = width * width;
    const miterLimitSquared = style.miterLimit * style.miterLimit;
    let x0 = points[0];
    let y0 = points[1];
    let x1 = points[2];
    let y1 = points[3];
    let x2 = 0;
    let y2 = 0;
    let perpX = -(y0 - y1);
    let perpY = x0 - x1;
    let perp1x = 0;
    let perp1y = 0;
    let dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    const ratio = alignment;
    const innerWeight = (1 - ratio) * 2;
    const outerWeight = ratio * 2;
    if (!closedShape) {
        if (style.cap === "round") indexCount += $93adb69e7c93bab1$var$round(x0 - perpX * (innerWeight - outerWeight) * 0.5, y0 - perpY * (innerWeight - outerWeight) * 0.5, x0 - perpX * innerWeight, y0 - perpY * innerWeight, x0 + perpX * outerWeight, y0 + perpY * outerWeight, verts, true) + 2;
        else if (style.cap === "square") indexCount += $93adb69e7c93bab1$var$square(x0, y0, perpX, perpY, innerWeight, outerWeight, true, verts);
    }
    verts.push(x0 - perpX * innerWeight, y0 - perpY * innerWeight);
    verts.push(x0 + perpX * outerWeight, y0 + perpY * outerWeight);
    for(let i = 1; i < length - 1; ++i){
        x0 = points[(i - 1) * 2];
        y0 = points[(i - 1) * 2 + 1];
        x1 = points[i * 2];
        y1 = points[i * 2 + 1];
        x2 = points[(i + 1) * 2];
        y2 = points[(i + 1) * 2 + 1];
        perpX = -(y0 - y1);
        perpY = x0 - x1;
        dist = Math.sqrt(perpX * perpX + perpY * perpY);
        perpX /= dist;
        perpY /= dist;
        perpX *= width;
        perpY *= width;
        perp1x = -(y1 - y2);
        perp1y = x1 - x2;
        dist = Math.sqrt(perp1x * perp1x + perp1y * perp1y);
        perp1x /= dist;
        perp1y /= dist;
        perp1x *= width;
        perp1y *= width;
        const dx0 = x1 - x0;
        const dy0 = y0 - y1;
        const dx1 = x1 - x2;
        const dy1 = y2 - y1;
        const dot = dx0 * dx1 + dy0 * dy1;
        const cross = dy0 * dx1 - dy1 * dx0;
        const clockwise = cross < 0;
        if (Math.abs(cross) < 1e-3 * Math.abs(dot)) {
            verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
            verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
            if (dot >= 0) {
                if (style.join === "round") indexCount += $93adb69e7c93bab1$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                else indexCount += 2;
                verts.push(x1 - perp1x * outerWeight, y1 - perp1y * outerWeight);
                verts.push(x1 + perp1x * innerWeight, y1 + perp1y * innerWeight);
            }
            continue;
        }
        const c1 = (-perpX + x0) * (-perpY + y1) - (-perpX + x1) * (-perpY + y0);
        const c2 = (-perp1x + x2) * (-perp1y + y1) - (-perp1x + x1) * (-perp1y + y2);
        const px = (dx0 * c2 - dx1 * c1) / cross;
        const py = (dy1 * c1 - dy0 * c2) / cross;
        const pDist = (px - x1) * (px - x1) + (py - y1) * (py - y1);
        const imx = x1 + (px - x1) * innerWeight;
        const imy = y1 + (py - y1) * innerWeight;
        const omx = x1 - (px - x1) * outerWeight;
        const omy = y1 - (py - y1) * outerWeight;
        const smallerInsideSegmentSq = Math.min(dx0 * dx0 + dy0 * dy0, dx1 * dx1 + dy1 * dy1);
        const insideWeight = clockwise ? innerWeight : outerWeight;
        const smallerInsideDiagonalSq = smallerInsideSegmentSq + insideWeight * insideWeight * widthSquared;
        const insideMiterOk = pDist <= smallerInsideDiagonalSq;
        if (insideMiterOk) {
            if (style.join === "bevel" || pDist / widthSquared > miterLimitSquared) {
                if (clockwise) {
                    verts.push(imx, imy);
                    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
                    verts.push(omx, omy);
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
                indexCount += 2;
            } else if (style.join === "round") {
                if (clockwise) {
                    verts.push(imx, imy);
                    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
                    indexCount += $93adb69e7c93bab1$var$round(x1, y1, x1 + perpX * outerWeight, y1 + perpY * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 4;
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
                    verts.push(omx, omy);
                    indexCount += $93adb69e7c93bab1$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
            } else {
                verts.push(imx, imy);
                verts.push(omx, omy);
            }
        } else {
            verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
            verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
            if (style.join === "round") {
                if (clockwise) indexCount += $93adb69e7c93bab1$var$round(x1, y1, x1 + perpX * outerWeight, y1 + perpY * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 2;
                else indexCount += $93adb69e7c93bab1$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 2;
            } else if (style.join === "miter" && pDist / widthSquared <= miterLimitSquared) {
                if (clockwise) {
                    verts.push(omx, omy);
                    verts.push(omx, omy);
                } else {
                    verts.push(imx, imy);
                    verts.push(imx, imy);
                }
                indexCount += 2;
            }
            verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
            verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
            indexCount += 2;
        }
    }
    x0 = points[(length - 2) * 2];
    y0 = points[(length - 2) * 2 + 1];
    x1 = points[(length - 1) * 2];
    y1 = points[(length - 1) * 2 + 1];
    perpX = -(y0 - y1);
    perpY = x0 - x1;
    dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
    if (!closedShape) {
        if (style.cap === "round") indexCount += $93adb69e7c93bab1$var$round(x1 - perpX * (innerWeight - outerWeight) * 0.5, y1 - perpY * (innerWeight - outerWeight) * 0.5, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 + perpX * outerWeight, y1 + perpY * outerWeight, verts, false) + 2;
        else if (style.cap === "square") indexCount += $93adb69e7c93bab1$var$square(x1, y1, perpX, perpY, innerWeight, outerWeight, false, verts);
    }
    const eps2 = (0, $aThAx.curveEps) * (0, $aThAx.curveEps);
    for(let i = indexStart; i < indexCount + indexStart - 2; ++i){
        x0 = verts[i * 2];
        y0 = verts[i * 2 + 1];
        x1 = verts[(i + 1) * 2];
        y1 = verts[(i + 1) * 2 + 1];
        x2 = verts[(i + 2) * 2];
        y2 = verts[(i + 2) * 2 + 1];
        if (Math.abs(x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1)) < eps2) continue;
        indices.push(i, i + 1, i + 2);
    }
}

});
parcelRegister("aThAx", function(module, exports) {

$parcel$export(module.exports, "closePointEps", () => $71d58fbc707dc8de$export$7159a7c43f12984);
$parcel$export(module.exports, "curveEps", () => $71d58fbc707dc8de$export$51a946149243709);
"use strict";
const $71d58fbc707dc8de$export$7159a7c43f12984 = 1e-4;
const $71d58fbc707dc8de$export$51a946149243709 = 1e-4;

});

parcelRegister("7TFU6", function(module, exports) {

$parcel$export(module.exports, "getOrientationOfPoints", () => $7399c4784108d231$export$38856eae80d480e1);
"use strict";
function $7399c4784108d231$export$38856eae80d480e1(points) {
    const m = points.length;
    if (m < 6) return 1;
    let area = 0;
    for(let i = 0, x1 = points[m - 2], y1 = points[m - 1]; i < m; i += 2){
        const x2 = points[i];
        const y2 = points[i + 1];
        area += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    if (area < 0) return -1;
    return 1;
}

});


parcelRegister("7SnGQ", function(module, exports) {

$parcel$export(module.exports, "buildPolygon", () => $2a167e079acdbb45$export$4c2d12f7b210f357);

var $3KVWv = parcelRequire("3KVWv");
"use strict";
const $2a167e079acdbb45$var$emptyArray = [];
const $2a167e079acdbb45$export$4c2d12f7b210f357 = {
    build (shape, points) {
        for(let i = 0; i < shape.points.length; i++)points[i] = shape.points[i];
        return points;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        (0, $3KVWv.triangulateWithHoles)(points, $2a167e079acdbb45$var$emptyArray, vertices, verticesStride, verticesOffset, indices, indicesOffset);
    }
};

});
parcelRegister("3KVWv", function(module, exports) {

$parcel$export(module.exports, "triangulateWithHoles", () => $f242977be0d56518$export$5a241bf9c2c3d94b);

var $eH7tg = parcelRequire("eH7tg");
"use strict";
function $f242977be0d56518$export$5a241bf9c2c3d94b(points, holes, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
    const triangles = (0, (/*@__PURE__*/$parcel$interopDefault($eH7tg)))(points, holes, 2);
    if (!triangles) return;
    for(let i = 0; i < triangles.length; i += 3){
        indices[indicesOffset++] = triangles[i] + verticesOffset;
        indices[indicesOffset++] = triangles[i + 1] + verticesOffset;
        indices[indicesOffset++] = triangles[i + 2] + verticesOffset;
    }
    let index = verticesOffset * verticesStride;
    for(let i = 0; i < points.length; i += 2){
        vertices[index] = points[i];
        vertices[index + 1] = points[i + 1];
        index += verticesStride;
    }
}

});
parcelRegister("eH7tg", function(module, exports) {
"use strict";
module.exports = $ab2ae071cd7be4a4$var$earcut;
module.exports.default = $ab2ae071cd7be4a4$var$earcut;
function $ab2ae071cd7be4a4$var$earcut(data, holeIndices, dim) {
    dim = dim || 2;
    var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = $ab2ae071cd7be4a4$var$linkedList(data, 0, outerLen, dim, true), triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    var minX, minY, maxX, maxY, x, y, invSize;
    if (hasHoles) outerNode = $ab2ae071cd7be4a4$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];
        for(var i = dim; i < outerLen; i += dim){
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $ab2ae071cd7be4a4$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $ab2ae071cd7be4a4$var$linkedList(data, start, end, dim, clockwise) {
    var i, last;
    if (clockwise === $ab2ae071cd7be4a4$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $ab2ae071cd7be4a4$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $ab2ae071cd7be4a4$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $ab2ae071cd7be4a4$var$equals(last, last.next)) {
        $ab2ae071cd7be4a4$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $ab2ae071cd7be4a4$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    var p = start, again;
    do {
        again = false;
        if (!p.steiner && ($ab2ae071cd7be4a4$var$equals(p, p.next) || $ab2ae071cd7be4a4$var$area(p.prev, p, p.next) === 0)) {
            $ab2ae071cd7be4a4$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $ab2ae071cd7be4a4$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $ab2ae071cd7be4a4$var$indexCurve(ear, minX, minY, invSize);
    var stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $ab2ae071cd7be4a4$var$isEarHashed(ear, minX, minY, invSize) : $ab2ae071cd7be4a4$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $ab2ae071cd7be4a4$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $ab2ae071cd7be4a4$var$earcutLinked($ab2ae071cd7be4a4$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $ab2ae071cd7be4a4$var$cureLocalIntersections($ab2ae071cd7be4a4$var$filterPoints(ear), triangles, dim);
                $ab2ae071cd7be4a4$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $ab2ae071cd7be4a4$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $ab2ae071cd7be4a4$var$isEar(ear) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($ab2ae071cd7be4a4$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    var p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $ab2ae071cd7be4a4$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $ab2ae071cd7be4a4$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $ab2ae071cd7be4a4$var$isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($ab2ae071cd7be4a4$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    var minZ = $ab2ae071cd7be4a4$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $ab2ae071cd7be4a4$var$zOrder(x1, y1, minX, minY, invSize);
    var p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $ab2ae071cd7be4a4$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $ab2ae071cd7be4a4$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $ab2ae071cd7be4a4$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $ab2ae071cd7be4a4$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $ab2ae071cd7be4a4$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $ab2ae071cd7be4a4$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $ab2ae071cd7be4a4$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $ab2ae071cd7be4a4$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $ab2ae071cd7be4a4$var$cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev, b = p.next.next;
        if (!$ab2ae071cd7be4a4$var$equals(a, b) && $ab2ae071cd7be4a4$var$intersects(a, p, p.next, b) && $ab2ae071cd7be4a4$var$locallyInside(a, b) && $ab2ae071cd7be4a4$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $ab2ae071cd7be4a4$var$removeNode(p);
            $ab2ae071cd7be4a4$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $ab2ae071cd7be4a4$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $ab2ae071cd7be4a4$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $ab2ae071cd7be4a4$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = $ab2ae071cd7be4a4$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $ab2ae071cd7be4a4$var$filterPoints(a, a.next);
                c = $ab2ae071cd7be4a4$var$filterPoints(c, c.next);
                // run earcut on each half
                $ab2ae071cd7be4a4$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $ab2ae071cd7be4a4$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $ab2ae071cd7be4a4$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [], i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $ab2ae071cd7be4a4$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($ab2ae071cd7be4a4$var$getLeftmost(list));
    }
    queue.sort($ab2ae071cd7be4a4$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $ab2ae071cd7be4a4$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $ab2ae071cd7be4a4$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $ab2ae071cd7be4a4$var$eliminateHole(hole, outerNode) {
    var bridge = $ab2ae071cd7be4a4$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    var bridgeReverse = $ab2ae071cd7be4a4$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $ab2ae071cd7be4a4$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $ab2ae071cd7be4a4$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $ab2ae071cd7be4a4$var$findHoleBridge(hole, outerNode) {
    var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $ab2ae071cd7be4a4$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($ab2ae071cd7be4a4$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $ab2ae071cd7be4a4$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $ab2ae071cd7be4a4$var$sectorContainsSector(m, p) {
    return $ab2ae071cd7be4a4$var$area(m.prev, m, p.prev) < 0 && $ab2ae071cd7be4a4$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $ab2ae071cd7be4a4$var$indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === 0) p.z = $ab2ae071cd7be4a4$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $ab2ae071cd7be4a4$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $ab2ae071cd7be4a4$var$sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $ab2ae071cd7be4a4$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $ab2ae071cd7be4a4$var$getLeftmost(start) {
    var p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $ab2ae071cd7be4a4$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $ab2ae071cd7be4a4$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$ab2ae071cd7be4a4$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($ab2ae071cd7be4a4$var$locallyInside(a, b) && $ab2ae071cd7be4a4$var$locallyInside(b, a) && $ab2ae071cd7be4a4$var$middleInside(a, b) && // locally visible
    ($ab2ae071cd7be4a4$var$area(a.prev, a, b.prev) || $ab2ae071cd7be4a4$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $ab2ae071cd7be4a4$var$equals(a, b) && $ab2ae071cd7be4a4$var$area(a.prev, a, a.next) > 0 && $ab2ae071cd7be4a4$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $ab2ae071cd7be4a4$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $ab2ae071cd7be4a4$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $ab2ae071cd7be4a4$var$intersects(p1, q1, p2, q2) {
    var o1 = $ab2ae071cd7be4a4$var$sign($ab2ae071cd7be4a4$var$area(p1, q1, p2));
    var o2 = $ab2ae071cd7be4a4$var$sign($ab2ae071cd7be4a4$var$area(p1, q1, q2));
    var o3 = $ab2ae071cd7be4a4$var$sign($ab2ae071cd7be4a4$var$area(p2, q2, p1));
    var o4 = $ab2ae071cd7be4a4$var$sign($ab2ae071cd7be4a4$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $ab2ae071cd7be4a4$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $ab2ae071cd7be4a4$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $ab2ae071cd7be4a4$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $ab2ae071cd7be4a4$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $ab2ae071cd7be4a4$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $ab2ae071cd7be4a4$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $ab2ae071cd7be4a4$var$intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $ab2ae071cd7be4a4$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $ab2ae071cd7be4a4$var$locallyInside(a, b) {
    return $ab2ae071cd7be4a4$var$area(a.prev, a, a.next) < 0 ? $ab2ae071cd7be4a4$var$area(a, b, a.next) >= 0 && $ab2ae071cd7be4a4$var$area(a, a.prev, b) >= 0 : $ab2ae071cd7be4a4$var$area(a, b, a.prev) < 0 || $ab2ae071cd7be4a4$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $ab2ae071cd7be4a4$var$middleInside(a, b) {
    var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $ab2ae071cd7be4a4$var$splitPolygon(a, b) {
    var a2 = new $ab2ae071cd7be4a4$var$Node(a.i, a.x, a.y), b2 = new $ab2ae071cd7be4a4$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $ab2ae071cd7be4a4$var$insertNode(i, x, y, last) {
    var p = new $ab2ae071cd7be4a4$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $ab2ae071cd7be4a4$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $ab2ae071cd7be4a4$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
$ab2ae071cd7be4a4$var$earcut.deviation = function(data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    var polygonArea = Math.abs($ab2ae071cd7be4a4$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(var i = 0, len = holeIndices.length; i < len; i++){
        var start = holeIndices[i] * dim;
        var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($ab2ae071cd7be4a4$var$signedArea(data, start, end, dim));
    }
    var trianglesArea = 0;
    for(i = 0; i < triangles.length; i += 3){
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
};
function $ab2ae071cd7be4a4$var$signedArea(data, start, end, dim) {
    var sum = 0;
    for(var i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
$ab2ae071cd7be4a4$var$earcut.flatten = function(data) {
    var dim = data[0][0].length, result = {
        vertices: [],
        holes: [],
        dimensions: dim
    }, holeIndex = 0;
    for(var i = 0; i < data.length; i++){
        for(var j = 0; j < data[i].length; j++)for(var d = 0; d < dim; d++)result.vertices.push(data[i][j][d]);
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};

});



parcelRegister("gNR5d", function(module, exports) {

$parcel$export(module.exports, "buildRectangle", () => $739fd552f4cd99f6$export$cbe813d11f2192b2);
"use strict";
const $739fd552f4cd99f6$export$cbe813d11f2192b2 = {
    build (shape, points) {
        const rectData = shape;
        const x = rectData.x;
        const y = rectData.y;
        const width = rectData.width;
        const height = rectData.height;
        if (!(width >= 0 && height >= 0)) return points;
        points[0] = x;
        points[1] = y;
        points[2] = x + width;
        points[3] = y;
        points[4] = x + width;
        points[5] = y + height;
        points[6] = x;
        points[7] = y + height;
        return points;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        let count = 0;
        verticesOffset *= verticesStride;
        vertices[verticesOffset + count] = points[0];
        vertices[verticesOffset + count + 1] = points[1];
        count += verticesStride;
        vertices[verticesOffset + count] = points[2];
        vertices[verticesOffset + count + 1] = points[3];
        count += verticesStride;
        vertices[verticesOffset + count] = points[6];
        vertices[verticesOffset + count + 1] = points[7];
        count += verticesStride;
        vertices[verticesOffset + count] = points[4];
        vertices[verticesOffset + count + 1] = points[5];
        count += verticesStride;
        const verticesIndex = verticesOffset / verticesStride;
        indices[indicesOffset++] = verticesIndex;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 2;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 3;
        indices[indicesOffset++] = verticesIndex + 2;
    }
};

});

parcelRegister("23KZx", function(module, exports) {

$parcel$export(module.exports, "buildTriangle", () => $c9d806c232a5d50f$export$8eb75cb9f614d270);
"use strict";
const $c9d806c232a5d50f$export$8eb75cb9f614d270 = {
    build (shape, points) {
        points[0] = shape.x;
        points[1] = shape.y;
        points[2] = shape.x2;
        points[3] = shape.y2;
        points[4] = shape.x3;
        points[5] = shape.y3;
        return points;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        let count = 0;
        verticesOffset *= verticesStride;
        vertices[verticesOffset + count] = points[0];
        vertices[verticesOffset + count + 1] = points[1];
        count += verticesStride;
        vertices[verticesOffset + count] = points[2];
        vertices[verticesOffset + count + 1] = points[3];
        count += verticesStride;
        vertices[verticesOffset + count] = points[4];
        vertices[verticesOffset + count + 1] = points[5];
        const verticesIndex = verticesOffset / verticesStride;
        indices[indicesOffset++] = verticesIndex;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 2;
    }
};

});




parcelRegister("4plDg", function(module, exports) {

$parcel$export(module.exports, "buildAdaptiveQuadratic", () => $e370bd98707e3e46$export$d53ce9debfe7a6c2);

var $9ScHH = parcelRequire("9ScHH");
"use strict";
const $e370bd98707e3e46$var$RECURSION_LIMIT = 8;
const $e370bd98707e3e46$var$FLT_EPSILON = 11920929e-14;
const $e370bd98707e3e46$var$PATH_DISTANCE_EPSILON = 1;
const $e370bd98707e3e46$var$curveAngleToleranceEpsilon = 0.01;
const $e370bd98707e3e46$var$mAngleTolerance = 0;
function $e370bd98707e3e46$export$d53ce9debfe7a6c2(points, sX, sY, cp1x, cp1y, eX, eY, smoothness) {
    const scale = 1;
    const smoothing = Math.min(0.99, // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? (0, $9ScHH.GraphicsContextSystem).defaultOptions.bezierSmoothness));
    let distanceTolerance = ($e370bd98707e3e46$var$PATH_DISTANCE_EPSILON - smoothing) / scale;
    distanceTolerance *= distanceTolerance;
    $e370bd98707e3e46$var$begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance);
    return points;
}
function $e370bd98707e3e46$var$begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance) {
    $e370bd98707e3e46$var$recursive(points, sX, sY, cp1x, cp1y, eX, eY, distanceTolerance, 0);
    points.push(eX, eY);
}
function $e370bd98707e3e46$var$recursive(points, x1, y1, x2, y2, x3, y3, distanceTolerance, level) {
    if (level > $e370bd98707e3e46$var$RECURSION_LIMIT) return;
    const pi = Math.PI;
    const x12 = (x1 + x2) / 2;
    const y12 = (y1 + y2) / 2;
    const x23 = (x2 + x3) / 2;
    const y23 = (y2 + y3) / 2;
    const x123 = (x12 + x23) / 2;
    const y123 = (y12 + y23) / 2;
    let dx = x3 - x1;
    let dy = y3 - y1;
    const d = Math.abs((x2 - x3) * dy - (y2 - y3) * dx);
    if (d > $e370bd98707e3e46$var$FLT_EPSILON) {
        if (d * d <= distanceTolerance * (dx * dx + dy * dy)) {
            if ($e370bd98707e3e46$var$mAngleTolerance < $e370bd98707e3e46$var$curveAngleToleranceEpsilon) {
                points.push(x123, y123);
                return;
            }
            let da = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
            if (da >= pi) da = 2 * pi - da;
            if (da < $e370bd98707e3e46$var$mAngleTolerance) {
                points.push(x123, y123);
                return;
            }
        }
    } else {
        dx = x123 - (x1 + x3) / 2;
        dy = y123 - (y1 + y3) / 2;
        if (dx * dx + dy * dy <= distanceTolerance) {
            points.push(x123, y123);
            return;
        }
    }
    $e370bd98707e3e46$var$recursive(points, x1, y1, x12, y12, x123, y123, distanceTolerance, level + 1);
    $e370bd98707e3e46$var$recursive(points, x123, y123, x23, y23, x3, y3, distanceTolerance, level + 1);
}

});

parcelRegister("a2DH4", function(module, exports) {

$parcel$export(module.exports, "buildArc", () => $bb22a7051e9d152b$export$ed8eebdc6998f0f6);
"use strict";
function $bb22a7051e9d152b$export$ed8eebdc6998f0f6(points, x, y, radius, start, end, clockwise, steps) {
    let dist = Math.abs(start - end);
    if (!clockwise && start > end) dist = 2 * Math.PI - dist;
    else if (clockwise && end > start) dist = 2 * Math.PI - dist;
    steps = steps || Math.max(6, Math.floor(6 * Math.pow(radius, 1 / 3) * (dist / Math.PI)));
    steps = Math.max(steps, 3);
    let f = dist / steps;
    let t = start;
    f *= clockwise ? -1 : 1;
    for(let i = 0; i < steps + 1; i++){
        const cs = Math.cos(t);
        const sn = Math.sin(t);
        const nx = x + cs * radius;
        const ny = y + sn * radius;
        points.push(nx, ny);
        t += f;
    }
}

});

parcelRegister("4Kxwi", function(module, exports) {

$parcel$export(module.exports, "buildArcTo", () => $984b2d62d89d71aa$export$d46b7933b415e02f);

var $a2DH4 = parcelRequire("a2DH4");
"use strict";
function $984b2d62d89d71aa$export$d46b7933b415e02f(points, x1, y1, x2, y2, radius) {
    const fromX = points[points.length - 2];
    const fromY = points[points.length - 1];
    const a1 = fromY - y1;
    const b1 = fromX - x1;
    const a2 = y2 - y1;
    const b2 = x2 - x1;
    const mm = Math.abs(a1 * b2 - b1 * a2);
    if (mm < 1e-8 || radius === 0) {
        if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) points.push(x1, y1);
        return;
    }
    const dd = a1 * a1 + b1 * b1;
    const cc = a2 * a2 + b2 * b2;
    const tt = a1 * a2 + b1 * b2;
    const k1 = radius * Math.sqrt(dd) / mm;
    const k2 = radius * Math.sqrt(cc) / mm;
    const j1 = k1 * tt / dd;
    const j2 = k2 * tt / cc;
    const cx = k1 * b2 + k2 * b1;
    const cy = k1 * a2 + k2 * a1;
    const px = b1 * (k2 + j1);
    const py = a1 * (k2 + j1);
    const qx = b2 * (k1 + j2);
    const qy = a2 * (k1 + j2);
    const startAngle = Math.atan2(py - cy, px - cx);
    const endAngle = Math.atan2(qy - cy, qx - cx);
    (0, $a2DH4.buildArc)(points, cx + x1, cy + y1, radius, startAngle, endAngle, b1 * a2 > b2 * a1);
}

});

parcelRegister("RcJdn", function(module, exports) {

$parcel$export(module.exports, "buildArcToSvg", () => $f0e726c9295569ef$export$71ccaa6dca53075e);

var $4fAWm = parcelRequire("4fAWm");
"use strict";
const $f0e726c9295569ef$var$TAU = Math.PI * 2;
const $f0e726c9295569ef$var$out = {
    centerX: 0,
    centerY: 0,
    ang1: 0,
    ang2: 0
};
const $f0e726c9295569ef$var$mapToEllipse = ({ x: x, y: y }, rx, ry, cosPhi, sinPhi, centerX, centerY, out2)=>{
    x *= rx;
    y *= ry;
    const xp = cosPhi * x - sinPhi * y;
    const yp = sinPhi * x + cosPhi * y;
    out2.x = xp + centerX;
    out2.y = yp + centerY;
    return out2;
};
function $f0e726c9295569ef$var$approxUnitArc(ang1, ang2) {
    const a1 = ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);
    const a = ang2 === 1.5707963267948966 ? 0.551915024494 : a1;
    const x1 = Math.cos(ang1);
    const y1 = Math.sin(ang1);
    const x2 = Math.cos(ang1 + ang2);
    const y2 = Math.sin(ang1 + ang2);
    return [
        {
            x: x1 - y1 * a,
            y: y1 + x1 * a
        },
        {
            x: x2 + y2 * a,
            y: y2 - x2 * a
        },
        {
            x: x2,
            y: y2
        }
    ];
}
const $f0e726c9295569ef$var$vectorAngle = (ux, uy, vx, vy)=>{
    const sign = ux * vy - uy * vx < 0 ? -1 : 1;
    let dot = ux * vx + uy * vy;
    if (dot > 1) dot = 1;
    if (dot < -1) dot = -1;
    return sign * Math.acos(dot);
};
const $f0e726c9295569ef$var$getArcCenter = (px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, out2)=>{
    const rxSq = Math.pow(rx, 2);
    const rySq = Math.pow(ry, 2);
    const pxpSq = Math.pow(pxp, 2);
    const pypSq = Math.pow(pyp, 2);
    let radicant = rxSq * rySq - rxSq * pypSq - rySq * pxpSq;
    if (radicant < 0) radicant = 0;
    radicant /= rxSq * pypSq + rySq * pxpSq;
    radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
    const centerXp = radicant * rx / ry * pyp;
    const centerYp = radicant * -ry / rx * pxp;
    const centerX = cosPhi * centerXp - sinPhi * centerYp + (px + cx) / 2;
    const centerY = sinPhi * centerXp + cosPhi * centerYp + (py + cy) / 2;
    const vx1 = (pxp - centerXp) / rx;
    const vy1 = (pyp - centerYp) / ry;
    const vx2 = (-pxp - centerXp) / rx;
    const vy2 = (-pyp - centerYp) / ry;
    const ang1 = $f0e726c9295569ef$var$vectorAngle(1, 0, vx1, vy1);
    let ang2 = $f0e726c9295569ef$var$vectorAngle(vx1, vy1, vx2, vy2);
    if (sweepFlag === 0 && ang2 > 0) ang2 -= $f0e726c9295569ef$var$TAU;
    if (sweepFlag === 1 && ang2 < 0) ang2 += $f0e726c9295569ef$var$TAU;
    out2.centerX = centerX;
    out2.centerY = centerY;
    out2.ang1 = ang1;
    out2.ang2 = ang2;
};
function $f0e726c9295569ef$export$71ccaa6dca53075e(points, px, py, cx, cy, rx, ry, xAxisRotation = 0, largeArcFlag = 0, sweepFlag = 0) {
    if (rx === 0 || ry === 0) return;
    const sinPhi = Math.sin(xAxisRotation * $f0e726c9295569ef$var$TAU / 360);
    const cosPhi = Math.cos(xAxisRotation * $f0e726c9295569ef$var$TAU / 360);
    const pxp = cosPhi * (px - cx) / 2 + sinPhi * (py - cy) / 2;
    const pyp = -sinPhi * (px - cx) / 2 + cosPhi * (py - cy) / 2;
    if (pxp === 0 && pyp === 0) return;
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    const lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
    if (lambda > 1) {
        rx *= Math.sqrt(lambda);
        ry *= Math.sqrt(lambda);
    }
    $f0e726c9295569ef$var$getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, $f0e726c9295569ef$var$out);
    let { ang1: ang1, ang2: ang2 } = $f0e726c9295569ef$var$out;
    const { centerX: centerX, centerY: centerY } = $f0e726c9295569ef$var$out;
    let ratio = Math.abs(ang2) / ($f0e726c9295569ef$var$TAU / 4);
    if (Math.abs(1 - ratio) < 1e-7) ratio = 1;
    const segments = Math.max(Math.ceil(ratio), 1);
    ang2 /= segments;
    let lastX = points[points.length - 2];
    let lastY = points[points.length - 1];
    const outCurvePoint = {
        x: 0,
        y: 0
    };
    for(let i = 0; i < segments; i++){
        const curve = $f0e726c9295569ef$var$approxUnitArc(ang1, ang2);
        const { x: x1, y: y1 } = $f0e726c9295569ef$var$mapToEllipse(curve[0], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        const { x: x2, y: y2 } = $f0e726c9295569ef$var$mapToEllipse(curve[1], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        const { x: x, y: y } = $f0e726c9295569ef$var$mapToEllipse(curve[2], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        (0, $4fAWm.buildAdaptiveBezier)(points, lastX, lastY, x1, y1, x2, y2, x, y);
        lastX = x;
        lastY = y;
        ang1 += ang2;
    }
}

});

parcelRegister("8oBc0", function(module, exports) {

$parcel$export(module.exports, "roundedShapeArc", () => $903fec595d1b8a83$export$ae1f43bc280f09be);
$parcel$export(module.exports, "roundedShapeQuadraticCurve", () => $903fec595d1b8a83$export$cf503f371c53af9e);
"use strict";
function $903fec595d1b8a83$export$ae1f43bc280f09be(g, points, radius) {
    const vecFrom = (p, pp)=>{
        const x = pp.x - p.x;
        const y = pp.y - p.y;
        const len = Math.sqrt(x * x + y * y);
        const nx = x / len;
        const ny = y / len;
        return {
            len: len,
            nx: nx,
            ny: ny
        };
    };
    const sharpCorner = (i, p)=>{
        if (i === 0) g.moveTo(p.x, p.y);
        else g.lineTo(p.x, p.y);
    };
    let p1 = points[points.length - 1];
    for(let i = 0; i < points.length; i++){
        const p2 = points[i % points.length];
        const pRadius = p2.radius ?? radius;
        if (pRadius <= 0) {
            sharpCorner(i, p2);
            p1 = p2;
            continue;
        }
        const p3 = points[(i + 1) % points.length];
        const v1 = vecFrom(p2, p1);
        const v2 = vecFrom(p2, p3);
        if (v1.len < 1e-4 || v2.len < 1e-4) {
            sharpCorner(i, p2);
            p1 = p2;
            continue;
        }
        let angle = Math.asin(v1.nx * v2.ny - v1.ny * v2.nx);
        let radDirection = 1;
        let drawDirection = false;
        if (v1.nx * v2.nx - v1.ny * -v2.ny < 0) {
            if (angle < 0) angle = Math.PI + angle;
            else {
                angle = Math.PI - angle;
                radDirection = -1;
                drawDirection = true;
            }
        } else if (angle > 0) {
            radDirection = -1;
            drawDirection = true;
        }
        const halfAngle = angle / 2;
        let cRadius;
        let lenOut = Math.abs(Math.cos(halfAngle) * pRadius / Math.sin(halfAngle));
        if (lenOut > Math.min(v1.len / 2, v2.len / 2)) {
            lenOut = Math.min(v1.len / 2, v2.len / 2);
            cRadius = Math.abs(lenOut * Math.sin(halfAngle) / Math.cos(halfAngle));
        } else cRadius = pRadius;
        const cX = p2.x + v2.nx * lenOut + -v2.ny * cRadius * radDirection;
        const cY = p2.y + v2.ny * lenOut + v2.nx * cRadius * radDirection;
        const startAngle = Math.atan2(v1.ny, v1.nx) + Math.PI / 2 * radDirection;
        const endAngle = Math.atan2(v2.ny, v2.nx) - Math.PI / 2 * radDirection;
        if (i === 0) g.moveTo(cX + Math.cos(startAngle) * cRadius, cY + Math.sin(startAngle) * cRadius);
        g.arc(cX, cY, cRadius, startAngle, endAngle, drawDirection);
        p1 = p2;
    }
}
function $903fec595d1b8a83$export$cf503f371c53af9e(g, points, radius, smoothness) {
    const distance = (p1, p2)=>Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2);
    const pointLerp = (p1, p2, t)=>({
            x: p1.x + (p2.x - p1.x) * t,
            y: p1.y + (p2.y - p1.y) * t
        });
    const numPoints = points.length;
    for(let i = 0; i < numPoints; i++){
        const thisPoint = points[(i + 1) % numPoints];
        const pRadius = thisPoint.radius ?? radius;
        if (pRadius <= 0) {
            if (i === 0) g.moveTo(thisPoint.x, thisPoint.y);
            else g.lineTo(thisPoint.x, thisPoint.y);
            continue;
        }
        const lastPoint = points[i];
        const nextPoint = points[(i + 2) % numPoints];
        const lastEdgeLength = distance(lastPoint, thisPoint);
        let start;
        if (lastEdgeLength < 1e-4) start = thisPoint;
        else {
            const lastOffsetDistance = Math.min(lastEdgeLength / 2, pRadius);
            start = pointLerp(thisPoint, lastPoint, lastOffsetDistance / lastEdgeLength);
        }
        const nextEdgeLength = distance(nextPoint, thisPoint);
        let end;
        if (nextEdgeLength < 1e-4) end = thisPoint;
        else {
            const nextOffsetDistance = Math.min(nextEdgeLength / 2, pRadius);
            end = pointLerp(thisPoint, nextPoint, nextOffsetDistance / nextEdgeLength);
        }
        if (i === 0) g.moveTo(start.x, start.y);
        else g.lineTo(start.x, start.y);
        g.quadraticCurveTo(thisPoint.x, thisPoint.y, end.x, end.y, smoothness);
    }
}

});



parcelRegister("a3KnI", function(module, exports) {

$parcel$export(module.exports, "SVGParser", () => $a0e0bb749188f070$export$2cc2aaca18109aab);

var $bEj7k = parcelRequire("bEj7k");

var $8ccTX = parcelRequire("8ccTX");
"use strict";
function $a0e0bb749188f070$export$2cc2aaca18109aab(svg, graphicsContext) {
    if (typeof svg === "string") {
        const div = document.createElement("div");
        div.innerHTML = svg.trim();
        svg = div.querySelector("svg");
    }
    const session = {
        context: graphicsContext,
        path: new (0, $8ccTX.GraphicsPath)()
    };
    $a0e0bb749188f070$var$renderChildren(svg, session, null, null);
    return graphicsContext;
}
function $a0e0bb749188f070$var$renderChildren(svg, session, fillStyle, strokeStyle) {
    const children = svg.children;
    const { fillStyle: f1, strokeStyle: s1 } = $a0e0bb749188f070$var$parseStyle(svg);
    if (f1 && fillStyle) fillStyle = {
        ...fillStyle,
        ...f1
    };
    else if (f1) fillStyle = f1;
    if (s1 && strokeStyle) strokeStyle = {
        ...strokeStyle,
        ...s1
    };
    else if (s1) strokeStyle = s1;
    session.context.fillStyle = fillStyle;
    session.context.strokeStyle = strokeStyle;
    let x;
    let y;
    let x1;
    let y1;
    let x2;
    let y2;
    let cx;
    let cy;
    let r;
    let rx;
    let ry;
    let points;
    let pointsString;
    let d;
    let graphicsPath;
    let width;
    let height;
    switch(svg.nodeName.toLowerCase()){
        case "path":
            d = svg.getAttribute("d");
            graphicsPath = new (0, $8ccTX.GraphicsPath)(d);
            session.context.path(graphicsPath);
            if (fillStyle) session.context.fill();
            if (strokeStyle) session.context.stroke();
            break;
        case "circle":
            cx = $a0e0bb749188f070$var$parseFloatAttribute(svg, "cx", 0);
            cy = $a0e0bb749188f070$var$parseFloatAttribute(svg, "cy", 0);
            r = $a0e0bb749188f070$var$parseFloatAttribute(svg, "r", 0);
            session.context.ellipse(cx, cy, r, r);
            if (fillStyle) session.context.fill();
            if (strokeStyle) session.context.stroke();
            break;
        case "rect":
            x = $a0e0bb749188f070$var$parseFloatAttribute(svg, "x", 0);
            y = $a0e0bb749188f070$var$parseFloatAttribute(svg, "y", 0);
            width = $a0e0bb749188f070$var$parseFloatAttribute(svg, "width", 0);
            height = $a0e0bb749188f070$var$parseFloatAttribute(svg, "height", 0);
            rx = $a0e0bb749188f070$var$parseFloatAttribute(svg, "rx", 0);
            ry = $a0e0bb749188f070$var$parseFloatAttribute(svg, "ry", 0);
            if (rx || ry) session.context.roundRect(x, y, width, height, rx || ry);
            else session.context.rect(x, y, width, height);
            if (fillStyle) session.context.fill();
            if (strokeStyle) session.context.stroke();
            break;
        case "ellipse":
            cx = $a0e0bb749188f070$var$parseFloatAttribute(svg, "cx", 0);
            cy = $a0e0bb749188f070$var$parseFloatAttribute(svg, "cy", 0);
            rx = $a0e0bb749188f070$var$parseFloatAttribute(svg, "rx", 0);
            ry = $a0e0bb749188f070$var$parseFloatAttribute(svg, "ry", 0);
            session.context.beginPath();
            session.context.ellipse(cx, cy, rx, ry);
            if (fillStyle) session.context.fill();
            if (strokeStyle) session.context.stroke();
            break;
        case "line":
            x1 = $a0e0bb749188f070$var$parseFloatAttribute(svg, "x1", 0);
            y1 = $a0e0bb749188f070$var$parseFloatAttribute(svg, "y1", 0);
            x2 = $a0e0bb749188f070$var$parseFloatAttribute(svg, "x2", 0);
            y2 = $a0e0bb749188f070$var$parseFloatAttribute(svg, "y2", 0);
            session.context.beginPath();
            session.context.moveTo(x1, y1);
            session.context.lineTo(x2, y2);
            if (strokeStyle) session.context.stroke();
            break;
        case "polygon":
            pointsString = svg.getAttribute("points");
            points = pointsString.match(/\d+/g).map((n)=>parseInt(n, 10));
            session.context.poly(points, true);
            if (fillStyle) session.context.fill();
            if (strokeStyle) session.context.stroke();
            break;
        case "polyline":
            pointsString = svg.getAttribute("points");
            points = pointsString.match(/\d+/g).map((n)=>parseInt(n, 10));
            session.context.poly(points, false);
            if (strokeStyle) session.context.stroke();
            break;
        case "g":
        case "svg":
            break;
        default:
            console.info(`[SVG parser] <${svg.nodeName}> elements unsupported`);
            break;
    }
    for(let i = 0; i < children.length; i++)$a0e0bb749188f070$var$renderChildren(children[i], session, fillStyle, strokeStyle);
}
function $a0e0bb749188f070$var$parseFloatAttribute(svg, id, defaultValue) {
    const value = svg.getAttribute(id);
    return value ? Number(value) : defaultValue;
}
function $a0e0bb749188f070$var$parseStyle(svg) {
    const style = svg.getAttribute("style");
    const strokeStyle = {};
    const fillStyle = {};
    let useFill = false;
    let useStroke = false;
    if (style) {
        const styleParts = style.split(";");
        for(let i = 0; i < styleParts.length; i++){
            const stylePart = styleParts[i];
            const [key, value] = stylePart.split(":");
            switch(key){
                case "stroke":
                    if (value !== "none") {
                        strokeStyle.color = (0, $bEj7k.Color).shared.setValue(value).toNumber();
                        useStroke = true;
                    }
                    break;
                case "stroke-width":
                    strokeStyle.width = Number(value);
                    break;
                case "fill":
                    if (value !== "none") {
                        useFill = true;
                        fillStyle.color = (0, $bEj7k.Color).shared.setValue(value).toNumber();
                    }
                    break;
                case "fill-opacity":
                    fillStyle.alpha = Number(value);
                    break;
                case "stroke-opacity":
                    strokeStyle.alpha = Number(value);
                    break;
                case "opacity":
                    fillStyle.alpha = Number(value);
                    strokeStyle.alpha = Number(value);
                    break;
            }
        }
    } else {
        const stroke = svg.getAttribute("stroke");
        if (stroke && stroke !== "none") {
            useStroke = true;
            strokeStyle.color = (0, $bEj7k.Color).shared.setValue(stroke).toNumber();
            strokeStyle.width = $a0e0bb749188f070$var$parseFloatAttribute(svg, "stroke-width", 1);
        }
        const fill = svg.getAttribute("fill");
        if (fill && fill !== "none") {
            useFill = true;
            fillStyle.color = (0, $bEj7k.Color).shared.setValue(fill).toNumber();
        }
    }
    return {
        strokeStyle: useStroke ? strokeStyle : null,
        fillStyle: useFill ? fillStyle : null
    };
}

});

parcelRegister("5uEQO", function(module, exports) {

$parcel$export(module.exports, "convertFillInputToFillStyle", () => $aa7fdab448bd7d85$export$816bdeacb94f608f);

var $bEj7k = parcelRequire("bEj7k");

var $3kR0G = parcelRequire("3kR0G");

var $jollT = parcelRequire("jollT");

var $ex7ag = parcelRequire("ex7ag");

var $kHeR8 = parcelRequire("kHeR8");
"use strict";
function $aa7fdab448bd7d85$export$816bdeacb94f608f(value, defaultStyle) {
    if (value === void 0 || value === null) return null;
    let fillStyleToParse;
    let styleToMerge;
    if (value?.fill) {
        styleToMerge = value.fill;
        fillStyleToParse = {
            ...defaultStyle,
            ...value
        };
    } else {
        styleToMerge = value;
        fillStyleToParse = defaultStyle;
    }
    if ((0, $bEj7k.Color).isColorLike(styleToMerge)) {
        const temp = (0, $bEj7k.Color).shared.setValue(styleToMerge ?? 0);
        const opts = {
            ...fillStyleToParse,
            color: temp.toNumber(),
            alpha: temp.alpha === 1 ? fillStyleToParse.alpha : temp.alpha,
            texture: (0, $jollT.Texture).WHITE
        };
        return opts;
    } else if (styleToMerge instanceof (0, $kHeR8.FillPattern)) {
        const pattern = styleToMerge;
        return {
            ...fillStyleToParse,
            color: 16777215,
            texture: pattern.texture,
            matrix: pattern.transform,
            fill: fillStyleToParse.fill ?? null
        };
    } else if (styleToMerge instanceof (0, $ex7ag.FillGradient)) {
        const gradient = styleToMerge;
        gradient.buildLinearGradient();
        return {
            ...fillStyleToParse,
            color: 16777215,
            texture: gradient.texture,
            matrix: gradient.transform
        };
    }
    const style = {
        ...defaultStyle,
        ...value
    };
    if (style.texture) {
        if (style.texture !== (0, $jollT.Texture).WHITE) {
            const m = style.matrix?.invert() || new (0, $3kR0G.Matrix)();
            m.scale(1 / style.texture.frame.width, 1 / style.texture.frame.height);
            style.matrix = m;
        }
        const sourceStyle = style.texture.source.style;
        if (sourceStyle.addressMode === "clamp-to-edge") sourceStyle.addressMode = "repeat";
    }
    const color = (0, $bEj7k.Color).shared.setValue(style.color);
    style.alpha *= color.alpha;
    style.color = color.toNumber();
    style.matrix = style.matrix ? style.matrix.clone() : null;
    return style;
}

});
parcelRegister("ex7ag", function(module, exports) {

$parcel$export(module.exports, "FillGradient", () => $6e7d3bf44c0f18a2$export$722a6ea8c60ca86);

var $bEj7k = parcelRequire("bEj7k");

var $2NruG = parcelRequire("2NruG");

var $3kR0G = parcelRequire("3kR0G");

var $5yirD = parcelRequire("5yirD");

var $jollT = parcelRequire("jollT");

var $by5BM = parcelRequire("by5BM");
"use strict";
const $6e7d3bf44c0f18a2$var$_FillGradient = class _FillGradient {
    constructor(x0, y0, x1, y1){
        this.uid = (0, $by5BM.uid)("fillGradient");
        this.type = "linear";
        this.gradientStops = [];
        this.x0 = x0;
        this.y0 = y0;
        this.x1 = x1;
        this.y1 = y1;
    }
    addColorStop(offset, color) {
        this.gradientStops.push({
            offset: offset,
            color: (0, $bEj7k.Color).shared.setValue(color).toHex()
        });
        return this;
    }
    // TODO move to the system!
    buildLinearGradient() {
        const defaultSize = _FillGradient.defaultTextureSize;
        const { gradientStops: gradientStops } = this;
        const canvas = (0, $2NruG.DOMAdapter).get().createCanvas();
        canvas.width = defaultSize;
        canvas.height = defaultSize;
        const ctx = canvas.getContext("2d");
        const gradient = ctx.createLinearGradient(0, 0, _FillGradient.defaultTextureSize, 1);
        for(let i = 0; i < gradientStops.length; i++){
            const stop = gradientStops[i];
            gradient.addColorStop(stop.offset, stop.color);
        }
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, defaultSize, defaultSize);
        this.texture = new (0, $jollT.Texture)({
            source: new (0, $5yirD.ImageSource)({
                resource: canvas,
                addressModeU: "clamp-to-edge",
                addressModeV: "repeat"
            })
        });
        const { x0: x0, y0: y0, x1: x1, y1: y1 } = this;
        const m = new (0, $3kR0G.Matrix)();
        const dx = x1 - x0;
        const dy = y1 - y0;
        const dist = Math.sqrt(dx * dx + dy * dy);
        const angle = Math.atan2(dy, dx);
        m.translate(-x0, -y0);
        m.scale(1 / defaultSize, 1 / defaultSize);
        m.rotate(-angle);
        m.scale(256 / dist, 1);
        this.transform = m;
    }
};
$6e7d3bf44c0f18a2$var$_FillGradient.defaultTextureSize = 256;
let $6e7d3bf44c0f18a2$export$722a6ea8c60ca86 = $6e7d3bf44c0f18a2$var$_FillGradient;

});

parcelRegister("kHeR8", function(module, exports) {

$parcel$export(module.exports, "FillPattern", () => $dbff881747d61fc6$export$3d1378c7410cd8e);

var $3kR0G = parcelRequire("3kR0G");

var $by5BM = parcelRequire("by5BM");
"use strict";
const $dbff881747d61fc6$var$repetitionMap = {
    repeat: {
        addressModeU: "repeat",
        addressModeV: "repeat"
    },
    "repeat-x": {
        addressModeU: "repeat",
        addressModeV: "clamp-to-edge"
    },
    "repeat-y": {
        addressModeU: "clamp-to-edge",
        addressModeV: "repeat"
    },
    "no-repeat": {
        addressModeU: "clamp-to-edge",
        addressModeV: "clamp-to-edge"
    }
};
class $dbff881747d61fc6$export$3d1378c7410cd8e {
    constructor(texture, repetition){
        this.uid = (0, $by5BM.uid)("fillPattern");
        this.transform = new (0, $3kR0G.Matrix)();
        this.texture = texture;
        this.transform.scale(1 / texture.frame.width, 1 / texture.frame.height);
        if (repetition) {
            texture.source.style.addressModeU = $dbff881747d61fc6$var$repetitionMap[repetition].addressModeU;
            texture.source.style.addressModeV = $dbff881747d61fc6$var$repetitionMap[repetition].addressModeV;
        }
    }
    setTransform(transform) {
        const texture = this.texture;
        this.transform.copyFrom(transform);
        this.transform.invert();
        this.transform.scale(1 / texture.frame.width, 1 / texture.frame.height);
    }
}

});



parcelRegister("6BsCn", function(module, exports) {

$parcel$export(module.exports, "EventsTicker", () => $38e8364bfb951934$export$57a493ed609e53ea);

var $cuDRd = parcelRequire("cuDRd");

var $4CJdx = parcelRequire("4CJdx");
"use strict";
class $38e8364bfb951934$var$EventsTickerClass {
    constructor(){
        /** The frequency that fake events will be fired. */ this.interactionFrequency = 10;
        this._deltaTime = 0;
        this._didMove = false;
        this._tickerAdded = false;
        this._pauseUpdate = true;
    }
    /**
   * Initializes the event ticker.
   * @param events - The event system.
   */ init(events) {
        this.removeTickerListener();
        this.events = events;
        this.interactionFrequency = 10;
        this._deltaTime = 0;
        this._didMove = false;
        this._tickerAdded = false;
        this._pauseUpdate = true;
    }
    /** Whether to pause the update checks or not. */ get pauseUpdate() {
        return this._pauseUpdate;
    }
    set pauseUpdate(paused) {
        this._pauseUpdate = paused;
    }
    /** Adds the ticker listener. */ addTickerListener() {
        if (this._tickerAdded || !this.domElement) return;
        (0, $4CJdx.Ticker).system.add(this._tickerUpdate, this, (0, $cuDRd.UPDATE_PRIORITY).INTERACTION);
        this._tickerAdded = true;
    }
    /** Removes the ticker listener. */ removeTickerListener() {
        if (!this._tickerAdded) return;
        (0, $4CJdx.Ticker).system.remove(this._tickerUpdate, this);
        this._tickerAdded = false;
    }
    /** Sets flag to not fire extra events when the user has already moved there mouse */ pointerMoved() {
        this._didMove = true;
    }
    /** Updates the state of interactive objects. */ _update() {
        if (!this.domElement || this._pauseUpdate) return;
        if (this._didMove) {
            this._didMove = false;
            return;
        }
        const rootPointerEvent = this.events["_rootPointerEvent"];
        if (this.events.supportsTouchEvents && rootPointerEvent.pointerType === "touch") return;
        globalThis.document.dispatchEvent(new PointerEvent("pointermove", {
            clientX: rootPointerEvent.clientX,
            clientY: rootPointerEvent.clientY
        }));
    }
    /**
   * Updates the state of interactive objects if at least {@link interactionFrequency}
   * milliseconds have passed since the last invocation.
   *
   * Invoked by a throttled ticker update from {@link Ticker.system}.
   * @param ticker - The throttled ticker.
   */ _tickerUpdate(ticker) {
        this._deltaTime += ticker.deltaTime;
        if (this._deltaTime < this.interactionFrequency) return;
        this._deltaTime = 0;
        this._update();
    }
}
const $38e8364bfb951934$export$57a493ed609e53ea = new $38e8364bfb951934$var$EventsTickerClass();

});

parcelRegister("339HX", function(module, exports) {

$parcel$export(module.exports, "GlProgram", () => $5fd092d850d1c8fc$export$64881d9ea0a969d7);

var $gSnQ6 = parcelRequire("gSnQ6");

var $epkLW = parcelRequire("epkLW");

var $4Zwc1 = parcelRequire("4Zwc1");

var $j4tzt = parcelRequire("j4tzt");

var $9qLOd = parcelRequire("9qLOd");

var $fYkkS = parcelRequire("fYkkS");

var $cM4lH = parcelRequire("cM4lH");
"use strict";
const $5fd092d850d1c8fc$var$processes = {
    stripVersion: // strips any version headers..
    $cM4lH.stripVersion,
    ensurePrecision: // adds precision string if not already present
    $j4tzt.ensurePrecision,
    addProgramDefines: // add some defines if WebGL1 to make it more compatible with WebGL2 shaders
    $4Zwc1.addProgramDefines,
    setProgramName: // add the program name to the shader
    $fYkkS.setProgramName,
    insertVersion: // add the version string to the shader header
    $9qLOd.insertVersion
};
const $5fd092d850d1c8fc$var$programCache = /* @__PURE__ */ Object.create(null);
const $5fd092d850d1c8fc$var$_GlProgram = class _GlProgram {
    /**
   * Creates a shiny new GlProgram. Used by WebGL renderer.
   * @param options - The options for the program.
   */ constructor(options){
        options = {
            ..._GlProgram.defaultOptions,
            ...options
        };
        const isES300 = options.fragment.indexOf("#version 300 es") !== -1;
        const preprocessorOptions = {
            stripVersion: isES300,
            ensurePrecision: {
                requestedFragmentPrecision: options.preferredFragmentPrecision,
                requestedVertexPrecision: options.preferredVertexPrecision,
                maxSupportedVertexPrecision: "highp",
                maxSupportedFragmentPrecision: (0, $epkLW.getMaxFragmentPrecision)()
            },
            setProgramName: {
                name: options.name
            },
            addProgramDefines: isES300,
            insertVersion: isES300
        };
        let fragment = options.fragment;
        let vertex = options.vertex;
        Object.keys($5fd092d850d1c8fc$var$processes).forEach((processKey)=>{
            const processOptions = preprocessorOptions[processKey];
            fragment = $5fd092d850d1c8fc$var$processes[processKey](fragment, processOptions, true);
            vertex = $5fd092d850d1c8fc$var$processes[processKey](vertex, processOptions, false);
        });
        this.fragment = fragment;
        this.vertex = vertex;
        this._key = (0, $gSnQ6.createIdFromString)(`${this.vertex}:${this.fragment}`, "gl-program");
    }
    /** destroys the program */ destroy() {
        this.fragment = null;
        this.vertex = null;
        this._attributeData = null;
        this._uniformData = null;
        this._uniformBlockData = null;
        this.transformFeedbackVaryings = null;
    }
    /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */ static from(options) {
        const key = `${options.vertex}:${options.fragment}`;
        if (!$5fd092d850d1c8fc$var$programCache[key]) $5fd092d850d1c8fc$var$programCache[key] = new _GlProgram(options);
        return $5fd092d850d1c8fc$var$programCache[key];
    }
};
/** The default options used by the program. */ $5fd092d850d1c8fc$var$_GlProgram.defaultOptions = {
    preferredVertexPrecision: "highp",
    preferredFragmentPrecision: "mediump"
};
let $5fd092d850d1c8fc$export$64881d9ea0a969d7 = $5fd092d850d1c8fc$var$_GlProgram;

});
parcelRegister("gSnQ6", function(module, exports) {

$parcel$export(module.exports, "createIdFromString", () => $5934cb3499da9fc9$export$1e452c36dfe36a93);
"use strict";
const $5934cb3499da9fc9$var$idCounts = /* @__PURE__ */ Object.create(null);
const $5934cb3499da9fc9$var$idHash = /* @__PURE__ */ Object.create(null);
function $5934cb3499da9fc9$export$1e452c36dfe36a93(value, groupId) {
    let id = $5934cb3499da9fc9$var$idHash[value];
    if (id === void 0) {
        if ($5934cb3499da9fc9$var$idCounts[groupId] === void 0) $5934cb3499da9fc9$var$idCounts[groupId] = 1;
        $5934cb3499da9fc9$var$idHash[value] = id = $5934cb3499da9fc9$var$idCounts[groupId]++;
    }
    return id;
}

});

parcelRegister("epkLW", function(module, exports) {

$parcel$export(module.exports, "getMaxFragmentPrecision", () => $4078a88541e7de8e$export$428c38e64838140);

var $kqBFn = parcelRequire("kqBFn");
"use strict";
let $4078a88541e7de8e$var$maxFragmentPrecision;
function $4078a88541e7de8e$export$428c38e64838140() {
    if (!$4078a88541e7de8e$var$maxFragmentPrecision) {
        $4078a88541e7de8e$var$maxFragmentPrecision = "mediump";
        const gl = (0, $kqBFn.getTestContext)();
        if (gl) {
            if (gl.getShaderPrecisionFormat) {
                const shaderFragment = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
                $4078a88541e7de8e$var$maxFragmentPrecision = shaderFragment.precision ? "highp" : "mediump";
            }
        }
    }
    return $4078a88541e7de8e$var$maxFragmentPrecision;
}

});
parcelRegister("kqBFn", function(module, exports) {

$parcel$export(module.exports, "getTestContext", () => $8374dfae0271d8eb$export$f034b2d55f8df08b);

var $2NruG = parcelRequire("2NruG");
"use strict";
let $8374dfae0271d8eb$var$context;
function $8374dfae0271d8eb$export$f034b2d55f8df08b() {
    if (!$8374dfae0271d8eb$var$context || $8374dfae0271d8eb$var$context?.isContextLost()) {
        const canvas = (0, $2NruG.DOMAdapter).get().createCanvas();
        $8374dfae0271d8eb$var$context = canvas.getContext("webgl", {});
    }
    return $8374dfae0271d8eb$var$context;
}

});


parcelRegister("4Zwc1", function(module, exports) {

$parcel$export(module.exports, "addProgramDefines", () => $707dc5e0c69d6d76$export$fba00ea8bc676dd1);
"use strict";
function $707dc5e0c69d6d76$export$fba00ea8bc676dd1(src, isES300, isFragment) {
    if (isES300) return src;
    if (isFragment) {
        src = src.replace("out vec4 finalColor;", "");
        return `
        
        #ifdef GL_ES // This checks if it is WebGL1
        #define in varying
        #define finalColor gl_FragColor
        #define texture texture2D
        #endif
        ${src}
        `;
    }
    return `
        
        #ifdef GL_ES // This checks if it is WebGL1
        #define in attribute
        #define out varying
        #endif
        ${src}
        `;
}

});

parcelRegister("j4tzt", function(module, exports) {

$parcel$export(module.exports, "ensurePrecision", () => $d3ecb71ec5a61eae$export$899bdffb1b617f8b);
"use strict";
function $d3ecb71ec5a61eae$export$899bdffb1b617f8b(src, options, isFragment) {
    const maxSupportedPrecision = isFragment ? options.maxSupportedFragmentPrecision : options.maxSupportedVertexPrecision;
    if (src.substring(0, 9) !== "precision") {
        let precision = isFragment ? options.requestedFragmentPrecision : options.requestedVertexPrecision;
        if (precision === "highp" && maxSupportedPrecision !== "highp") precision = "mediump";
        return `precision ${precision} float;
${src}`;
    } else if (maxSupportedPrecision !== "highp" && src.substring(0, 15) === "precision highp") return src.replace("precision highp", "precision mediump");
    return src;
}

});

parcelRegister("9qLOd", function(module, exports) {

$parcel$export(module.exports, "insertVersion", () => $68b93ecb29867a12$export$df5409633d2e06a0);
"use strict";
function $68b93ecb29867a12$export$df5409633d2e06a0(src, isES300) {
    if (!isES300) return src;
    return `#version 300 es
${src}`;
}

});

parcelRegister("fYkkS", function(module, exports) {

$parcel$export(module.exports, "setProgramName", () => $66da26def2025896$export$fcd35f5a80d5e29b);
"use strict";
const $66da26def2025896$var$fragmentNameCache = {};
const $66da26def2025896$var$VertexNameCache = {};
function $66da26def2025896$export$fcd35f5a80d5e29b(src, { name: name = `pixi-program` }, isFragment = true) {
    name = name.replace(/\s+/g, "-");
    name += isFragment ? "-fragment" : "-vertex";
    const nameCache = isFragment ? $66da26def2025896$var$fragmentNameCache : $66da26def2025896$var$VertexNameCache;
    if (nameCache[name]) {
        nameCache[name]++;
        name += `-${nameCache[name]}`;
    } else nameCache[name] = 1;
    if (src.indexOf("#define SHADER_NAME") !== -1) return src;
    const shaderName = `#define SHADER_NAME ${name}`;
    return `${shaderName}
${src}`;
}

});

parcelRegister("cM4lH", function(module, exports) {

$parcel$export(module.exports, "stripVersion", () => $2b45a9e7e5a99acc$export$f71406e7a553e9e5);
"use strict";
function $2b45a9e7e5a99acc$export$f71406e7a553e9e5(src, isES300) {
    if (!isES300) return src;
    return src.replace("#version 300 es", "");
}

});


parcelRegister("9E2kA", function(module, exports) {

$parcel$export(module.exports, "GpuProgram", () => $f54e0b716160c122$export$b7a31a3cdd61870);

var $gSnQ6 = parcelRequire("gSnQ6");

var $hzS8y = parcelRequire("hzS8y");

var $djRXh = parcelRequire("djRXh");

var $32NBn = parcelRequire("32NBn");

var $3RoUR = parcelRequire("3RoUR");

var $dY9l9 = parcelRequire("dY9l9");
"use strict";
const $f54e0b716160c122$var$programCache = /* @__PURE__ */ Object.create(null);
class $f54e0b716160c122$export$b7a31a3cdd61870 {
    /**
   * Create a new GpuProgram
   * @param options - The options for the gpu program
   */ constructor(options){
        /**
     * @internal
     * @ignore
     */ this._layoutKey = 0;
        const { fragment: fragment, vertex: vertex, layout: layout, gpuLayout: gpuLayout, name: name } = options;
        this.name = name;
        this.fragment = fragment;
        this.vertex = vertex;
        if (fragment.source === vertex.source) {
            const structsAndGroups = (0, $djRXh.extractStructAndGroups)(fragment.source);
            this.structsAndGroups = structsAndGroups;
        } else {
            const vertexStructsAndGroups = (0, $djRXh.extractStructAndGroups)(vertex.source);
            const fragmentStructsAndGroups = (0, $djRXh.extractStructAndGroups)(fragment.source);
            this.structsAndGroups = (0, $dY9l9.removeStructAndGroupDuplicates)(vertexStructsAndGroups, fragmentStructsAndGroups);
        }
        this.layout = layout ?? (0, $3RoUR.generateLayoutHash)(this.structsAndGroups);
        this.gpuLayout = gpuLayout ?? (0, $32NBn.generateGpuLayoutGroups)(this.structsAndGroups);
        this.autoAssignGlobalUniforms = !!(this.layout[0]?.globalUniforms !== void 0);
        this.autoAssignLocalUniforms = !!(this.layout[1]?.localUniforms !== void 0);
        this._generateProgramKey();
    }
    // TODO maker this pure
    _generateProgramKey() {
        const { vertex: vertex, fragment: fragment } = this;
        const bigKey = vertex.source + fragment.source + vertex.entryPoint + fragment.entryPoint;
        this._layoutKey = (0, $gSnQ6.createIdFromString)(bigKey, "program");
    }
    get attributeData() {
        this._attributeData ?? (this._attributeData = (0, $hzS8y.extractAttributesFromGpuProgram)(this.vertex));
        return this._attributeData;
    }
    /** destroys the program */ destroy() {
        this.gpuLayout = null;
        this.layout = null;
        this.structsAndGroups = null;
        this.fragment = null;
        this.vertex = null;
    }
    /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */ static from(options) {
        const key = `${options.vertex.source}:${options.fragment.source}:${options.fragment.entryPoint}:${options.vertex.entryPoint}`;
        if (!$f54e0b716160c122$var$programCache[key]) $f54e0b716160c122$var$programCache[key] = new $f54e0b716160c122$export$b7a31a3cdd61870(options);
        return $f54e0b716160c122$var$programCache[key];
    }
}

});
parcelRegister("hzS8y", function(module, exports) {

$parcel$export(module.exports, "extractAttributesFromGpuProgram", () => $7da8fb3beddaa9af$export$b0efe5f01c53f69f);

var $25Lcl = parcelRequire("25Lcl");
"use strict";
const $7da8fb3beddaa9af$var$WGSL_TO_VERTEX_TYPES = {
    f32: "float32",
    "vec2<f32>": "float32x2",
    "vec3<f32>": "float32x3",
    "vec4<f32>": "float32x4",
    vec2f: "float32x2",
    vec3f: "float32x3",
    vec4f: "float32x4",
    i32: "sint32",
    "vec2<i32>": "sint32x2",
    "vec3<i32>": "sint32x3",
    "vec4<i32>": "sint32x4",
    u32: "uint32",
    "vec2<u32>": "uint32x2",
    "vec3<u32>": "uint32x3",
    "vec4<u32>": "uint32x4",
    bool: "uint32",
    "vec2<bool>": "uint32x2",
    "vec3<bool>": "uint32x3",
    "vec4<bool>": "uint32x4"
};
function $7da8fb3beddaa9af$export$b0efe5f01c53f69f({ source: source, entryPoint: entryPoint }) {
    const results = {};
    const mainVertStart = source.indexOf(`fn ${entryPoint}`);
    if (mainVertStart !== -1) {
        const arrowFunctionStart = source.indexOf("->", mainVertStart);
        if (arrowFunctionStart !== -1) {
            const functionArgsSubstring = source.substring(mainVertStart, arrowFunctionStart);
            const inputsRegex = /@location\((\d+)\)\s+([a-zA-Z0-9_]+)\s*:\s*([a-zA-Z0-9_<>]+)(?:,|\s|$)/g;
            let match;
            while((match = inputsRegex.exec(functionArgsSubstring)) !== null){
                const format = $7da8fb3beddaa9af$var$WGSL_TO_VERTEX_TYPES[match[3]] ?? "float32";
                results[match[2]] = {
                    location: parseInt(match[1], 10),
                    format: format,
                    stride: (0, $25Lcl.getAttributeInfoFromFormat)(format).stride,
                    offset: 0,
                    instance: false,
                    start: 0
                };
            }
        }
    }
    return results;
}

});
parcelRegister("25Lcl", function(module, exports) {

$parcel$export(module.exports, "getAttributeInfoFromFormat", () => $40ba239598f922c6$export$4da509c30cc6be33);
"use strict";
const $40ba239598f922c6$var$attributeFormatData = {
    uint8x2: {
        size: 2,
        stride: 2,
        normalised: false
    },
    uint8x4: {
        size: 4,
        stride: 4,
        normalised: false
    },
    sint8x2: {
        size: 2,
        stride: 2,
        normalised: false
    },
    sint8x4: {
        size: 4,
        stride: 4,
        normalised: false
    },
    unorm8x2: {
        size: 2,
        stride: 2,
        normalised: true
    },
    unorm8x4: {
        size: 4,
        stride: 4,
        normalised: true
    },
    snorm8x2: {
        size: 2,
        stride: 2,
        normalised: true
    },
    snorm8x4: {
        size: 4,
        stride: 4,
        normalised: true
    },
    uint16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    uint16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    sint16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    sint16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    unorm16x2: {
        size: 2,
        stride: 4,
        normalised: true
    },
    unorm16x4: {
        size: 4,
        stride: 8,
        normalised: true
    },
    snorm16x2: {
        size: 2,
        stride: 4,
        normalised: true
    },
    snorm16x4: {
        size: 4,
        stride: 8,
        normalised: true
    },
    float16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    float16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    float32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    float32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    float32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    float32x4: {
        size: 4,
        stride: 16,
        normalised: false
    },
    uint32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    uint32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    uint32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    uint32x4: {
        size: 4,
        stride: 16,
        normalised: false
    },
    sint32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    sint32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    sint32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    sint32x4: {
        size: 4,
        stride: 16,
        normalised: false
    }
};
function $40ba239598f922c6$export$4da509c30cc6be33(format) {
    return $40ba239598f922c6$var$attributeFormatData[format] ?? $40ba239598f922c6$var$attributeFormatData.float32;
}

});


parcelRegister("djRXh", function(module, exports) {

$parcel$export(module.exports, "extractStructAndGroups", () => $088dc443033984e9$export$368e99a200562975);
"use strict";
function $088dc443033984e9$export$368e99a200562975(wgsl) {
    const linePattern = /(^|[^/])@(group|binding)\(\d+\)[^;]+;/g;
    const groupPattern = /@group\((\d+)\)/;
    const bindingPattern = /@binding\((\d+)\)/;
    const namePattern = /var(<[^>]+>)? (\w+)/;
    const typePattern = /:\s*(\w+)/;
    const structPattern = /struct\s+(\w+)\s*{([^}]+)}/g;
    const structMemberPattern = /(\w+)\s*:\s*([\w\<\>]+)/g;
    const structName = /struct\s+(\w+)/;
    const groups = wgsl.match(linePattern)?.map((item)=>({
            group: parseInt(item.match(groupPattern)[1], 10),
            binding: parseInt(item.match(bindingPattern)[1], 10),
            name: item.match(namePattern)[2],
            isUniform: item.match(namePattern)[1] === "<uniform>",
            type: item.match(typePattern)[1]
        }));
    if (!groups) return {
        groups: [],
        structs: []
    };
    const structs = wgsl.match(structPattern)?.map((struct)=>{
        const name = struct.match(structName)[1];
        const members = struct.match(structMemberPattern).reduce((acc, member)=>{
            const [name2, type] = member.split(":");
            acc[name2.trim()] = type.trim();
            return acc;
        }, {});
        if (!members) return null;
        return {
            name: name,
            members: members
        };
    }).filter(({ name: name })=>groups.some((group)=>group.type === name)) ?? [];
    return {
        groups: groups,
        structs: structs
    };
}

});

parcelRegister("32NBn", function(module, exports) {

$parcel$export(module.exports, "generateGpuLayoutGroups", () => $2209ef978d281f8f$export$950011c0dc347495);

var $haIBv = parcelRequire("haIBv");
"use strict";
function $2209ef978d281f8f$export$950011c0dc347495({ groups: groups }) {
    const layout = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        if (!layout[group.group]) layout[group.group] = [];
        if (group.isUniform) layout[group.group].push({
            binding: group.binding,
            visibility: (0, $haIBv.ShaderStage).VERTEX | (0, $haIBv.ShaderStage).FRAGMENT,
            buffer: {
                type: "uniform"
            }
        });
        else if (group.type === "sampler") layout[group.group].push({
            binding: group.binding,
            visibility: (0, $haIBv.ShaderStage).FRAGMENT,
            sampler: {
                type: "filtering"
            }
        });
        else if (group.type === "texture_2d") layout[group.group].push({
            binding: group.binding,
            visibility: (0, $haIBv.ShaderStage).FRAGMENT,
            texture: {
                sampleType: "float",
                viewDimension: "2d",
                multisampled: false
            }
        });
    }
    return layout;
}

});
parcelRegister("haIBv", function(module, exports) {

$parcel$export(module.exports, "ShaderStage", () => $4ae4f078f174ee25$export$34a0cafc5a97ef31);
"use strict";
var $4ae4f078f174ee25$export$34a0cafc5a97ef31 = /* @__PURE__ */ ((ShaderStage2)=>{
    ShaderStage2[ShaderStage2["VERTEX"] = 1] = "VERTEX";
    ShaderStage2[ShaderStage2["FRAGMENT"] = 2] = "FRAGMENT";
    ShaderStage2[ShaderStage2["COMPUTE"] = 4] = "COMPUTE";
    return ShaderStage2;
})($4ae4f078f174ee25$export$34a0cafc5a97ef31 || {});

});


parcelRegister("3RoUR", function(module, exports) {

$parcel$export(module.exports, "generateLayoutHash", () => $cac9508435c5a958$export$6a0f9650f9d4f875);
"use strict";
function $cac9508435c5a958$export$6a0f9650f9d4f875({ groups: groups }) {
    const layout = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        if (!layout[group.group]) layout[group.group] = {};
        layout[group.group][group.name] = group.binding;
    }
    return layout;
}

});

parcelRegister("dY9l9", function(module, exports) {

$parcel$export(module.exports, "removeStructAndGroupDuplicates", () => $1bc9f3d6134cb6a8$export$5f344e20ddfaa2d6);
"use strict";
function $1bc9f3d6134cb6a8$export$5f344e20ddfaa2d6(vertexStructsAndGroups, fragmentStructsAndGroups) {
    const structNameSet = /* @__PURE__ */ new Set();
    const dupeGroupKeySet = /* @__PURE__ */ new Set();
    const structs = [
        ...vertexStructsAndGroups.structs,
        ...fragmentStructsAndGroups.structs
    ].filter((struct)=>{
        if (structNameSet.has(struct.name)) return false;
        structNameSet.add(struct.name);
        return true;
    });
    const groups = [
        ...vertexStructsAndGroups.groups,
        ...fragmentStructsAndGroups.groups
    ].filter((group)=>{
        const key = `${group.name}-${group.binding}`;
        if (dupeGroupKeySet.has(key)) return false;
        dupeGroupKeySet.add(key);
        return true;
    });
    return {
        structs: structs,
        groups: groups
    };
}

});


parcelRegister("9wDSg", function(module, exports) {

$parcel$export(module.exports, "UniformGroup", () => $6b516a461904f2a4$export$6601a7a2dcf79bf5);

var $by5BM = parcelRequire("by5BM");

var $gSnQ6 = parcelRequire("gSnQ6");

var $2QvNd = parcelRequire("2QvNd");
"use strict";
const $6b516a461904f2a4$var$_UniformGroup = class _UniformGroup {
    /**
   * Create a new Uniform group
   * @param uniformStructures - The structures of the uniform group
   * @param options - The optional parameters of this uniform group
   */ constructor(uniformStructures, options){
        /** used internally to know if a uniform group was used in the last render pass */ this._touched = 0;
        /** a unique id for this uniform group used through the renderer */ this.uid = (0, $by5BM.uid)("uniform");
        /** a resource type, used to identify how to handle it when its in a bind group / shader resource */ this._resourceType = "uniformGroup";
        /** the resource id used internally by the renderer to build bind group keys */ this._resourceId = (0, $by5BM.uid)("resource");
        /** used ito identify if this is a uniform group */ this.isUniformGroup = true;
        /**
     * used to flag if this Uniform groups data is different from what it has stored in its buffer / on the GPU
     * @internal
     * @ignore
     */ this._dirtyId = 0;
        // implementing the interface - UniformGroup are not destroyed
        this.destroyed = false;
        options = {
            ..._UniformGroup.defaultOptions,
            ...options
        };
        this.uniformStructures = uniformStructures;
        const uniforms = {};
        for(const i in uniformStructures){
            const uniformData = uniformStructures[i];
            uniformData.name = i;
            uniformData.size = uniformData.size ?? 1;
            uniformData.value ?? (uniformData.value = (0, $2QvNd.getDefaultUniformValue)(uniformData.type, uniformData.size));
            uniforms[i] = uniformData.value;
        }
        this.uniforms = uniforms;
        this._dirtyId = 1;
        this.ubo = options.ubo;
        this.isStatic = options.isStatic;
        this._signature = (0, $gSnQ6.createIdFromString)(Object.keys(uniforms).map((i)=>`${i}-${uniformStructures[i].type}`).join("-"), "uniform-group");
    }
    /** Call this if you want the uniform groups data to be uploaded to the GPU only useful if `isStatic` is true. */ update() {
        this._dirtyId++;
    }
};
/** The default options used by the uniform group. */ $6b516a461904f2a4$var$_UniformGroup.defaultOptions = {
    /** if true the UniformGroup is handled as an Uniform buffer object. */ ubo: false,
    /** if true, then you are responsible for when the data is uploaded to the GPU by calling `update()` */ isStatic: false
};
let $6b516a461904f2a4$export$6601a7a2dcf79bf5 = $6b516a461904f2a4$var$_UniformGroup;

});
parcelRegister("2QvNd", function(module, exports) {

$parcel$export(module.exports, "getDefaultUniformValue", () => $77f238ea88cf70af$export$7febdb6905805c3d);
"use strict";
function $77f238ea88cf70af$export$7febdb6905805c3d(type, size) {
    switch(type){
        case "f32":
            return 0;
        case "vec2<f32>":
            return new Float32Array(2 * size);
        case "vec3<f32>":
            return new Float32Array(3 * size);
        case "vec4<f32>":
            return new Float32Array(4 * size);
        case "mat2x2<f32>":
            return new Float32Array([
                1,
                0,
                0,
                1
            ]);
        case "mat3x3<f32>":
            return new Float32Array([
                1,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                1
            ]);
        case "mat4x4<f32>":
            return new Float32Array([
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ]);
    }
    return null;
}

});


parcelRegister("ld81y", function(module, exports) {

$parcel$export(module.exports, "Filter", () => $e2ea293ba60115e0$export$ec91da630f36d5ea);

var $339HX = parcelRequire("339HX");

var $9E2kA = parcelRequire("9E2kA");

var $3mUCq = parcelRequire("3mUCq");

var $d6jVO = parcelRequire("d6jVO");
"use strict";
const $e2ea293ba60115e0$var$_Filter = class _Filter extends (0, $3mUCq.Shader) {
    /**
   * @param options - The optional parameters of this filter.
   */ constructor(options){
        options = {
            ..._Filter.defaultOptions,
            ...options
        };
        super(options);
        /** If enabled is true the filter is applied, if false it will not. */ this.enabled = true;
        /**
     * The gpu state the filter requires to render.
     * @internal
     * @ignore
     */ this._state = (0, $d6jVO.State).for2d();
        this.padding = options.padding;
        if (typeof options.antialias === "boolean") this.antialias = options.antialias ? "on" : "off";
        else this.antialias = options.antialias;
        this.resolution = options.resolution;
        this.blendRequired = options.blendRequired;
        this.addResource("uTexture", 0, 1);
    }
    /**
   * Applies the filter
   * @param filterManager - The renderer to retrieve the filter from
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it
   */ apply(filterManager, input, output, clearMode) {
        filterManager.applyFilter(this, input, output, clearMode);
    }
    /**
   * Get the blend mode of the filter.
   * @default "normal"
   */ get blendMode() {
        return this._state.blendMode;
    }
    /** Sets the blend mode of the filter. */ set blendMode(value) {
        this._state.blendMode = value;
    }
    /**
   * A short hand function to create a filter based of a vertex and fragment shader src.
   * @param options
   * @returns A shiny new PixiJS filter!
   */ static from(options) {
        const { gpu: gpu, gl: gl, ...rest } = options;
        let gpuProgram;
        let glProgram;
        if (gpu) gpuProgram = (0, $9E2kA.GpuProgram).from(gpu);
        if (gl) glProgram = (0, $339HX.GlProgram).from(gl);
        return new _Filter({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            ...rest
        });
    }
};
/**
 * The default filter settings
 * @static
 */ $e2ea293ba60115e0$var$_Filter.defaultOptions = {
    blendMode: "normal",
    resolution: 1,
    padding: 0,
    antialias: "off",
    blendRequired: false
};
let $e2ea293ba60115e0$export$ec91da630f36d5ea = $e2ea293ba60115e0$var$_Filter;

});
parcelRegister("3mUCq", function(module, exports) {

$parcel$export(module.exports, "Shader", () => $ee3083dafab39dcc$export$462bb059fed9d9e5);

var $gpXaq = parcelRequire("gpXaq");

var $339HX = parcelRequire("339HX");

var $8Uizi = parcelRequire("8Uizi");

var $9E2kA = parcelRequire("9E2kA");

var $cepzV = parcelRequire("cepzV");

var $9wDSg = parcelRequire("9wDSg");
"use strict";
class $ee3083dafab39dcc$export$462bb059fed9d9e5 extends (0, (/*@__PURE__*/$parcel$interopDefault($gpXaq))) {
    constructor(options){
        super();
        /**
     * A record of the uniform groups and resources used by the shader.
     * This is used by WebGL renderer to sync uniform data.
     * @internal
     * @ignore
     */ this._uniformBindMap = /* @__PURE__ */ Object.create(null);
        this._ownedBindGroups = [];
        let { gpuProgram: gpuProgram, glProgram: glProgram, groups: groups, resources: resources, compatibleRenderers: compatibleRenderers, groupMap: groupMap } = options;
        this.gpuProgram = gpuProgram;
        this.glProgram = glProgram;
        if (compatibleRenderers === void 0) {
            compatibleRenderers = 0;
            if (gpuProgram) compatibleRenderers |= (0, $cepzV.RendererType).WEBGPU;
            if (glProgram) compatibleRenderers |= (0, $cepzV.RendererType).WEBGL;
        }
        this.compatibleRenderers = compatibleRenderers;
        const nameHash = {};
        if (!resources && !groups) resources = {};
        if (resources && groups) throw new Error("[Shader] Cannot have both resources and groups");
        else if (!gpuProgram && groups && !groupMap) throw new Error("[Shader] No group map or WebGPU shader provided - consider using resources instead.");
        else if (!gpuProgram && groups && groupMap) {
            for(const i in groupMap)for(const j in groupMap[i]){
                const uniformName = groupMap[i][j];
                nameHash[uniformName] = {
                    group: i,
                    binding: j,
                    name: uniformName
                };
            }
        } else if (gpuProgram && groups && !groupMap) {
            const groupData = gpuProgram.structsAndGroups.groups;
            groupMap = {};
            groupData.forEach((data)=>{
                groupMap[data.group] = groupMap[data.group] || {};
                groupMap[data.group][data.binding] = data.name;
                nameHash[data.name] = data;
            });
        } else if (resources) {
            if (!gpuProgram) {
                groupMap = {};
                groups = {
                    99: new (0, $8Uizi.BindGroup)()
                };
                this._ownedBindGroups.push(groups[99]);
                let bindTick = 0;
                for(const i in resources){
                    nameHash[i] = {
                        group: 99,
                        binding: bindTick,
                        name: i
                    };
                    groupMap[99] = groupMap[99] || {};
                    groupMap[99][bindTick] = i;
                    bindTick++;
                }
            } else {
                const groupData = gpuProgram.structsAndGroups.groups;
                groupMap = {};
                groupData.forEach((data)=>{
                    groupMap[data.group] = groupMap[data.group] || {};
                    groupMap[data.group][data.binding] = data.name;
                    nameHash[data.name] = data;
                });
            }
            groups = {};
            for(const i in resources){
                const name = i;
                let value = resources[i];
                if (!value.source && !value._resourceType) value = new (0, $9wDSg.UniformGroup)(value);
                const data = nameHash[name];
                if (data) {
                    if (!groups[data.group]) {
                        groups[data.group] = new (0, $8Uizi.BindGroup)();
                        this._ownedBindGroups.push(groups[data.group]);
                    }
                    groups[data.group].setResource(value, data.binding);
                }
            }
        }
        this.groups = groups;
        this._uniformBindMap = groupMap;
        this.resources = this._buildResourceAccessor(groups, nameHash);
    }
    /**
   * Sometimes a resource group will be provided later (for example global uniforms)
   * In such cases, this method can be used to let the shader know about the group.
   * @param name - the name of the resource group
   * @param groupIndex - the index of the group (should match the webGPU shader group location)
   * @param bindIndex - the index of the bind point (should match the webGPU shader bind point)
   */ addResource(name, groupIndex, bindIndex) {
        var _a, _b;
        (_a = this._uniformBindMap)[groupIndex] || (_a[groupIndex] = {});
        (_b = this._uniformBindMap[groupIndex])[bindIndex] || (_b[bindIndex] = name);
        if (!this.groups[groupIndex]) {
            this.groups[groupIndex] = new (0, $8Uizi.BindGroup)();
            this._ownedBindGroups.push(this.groups[groupIndex]);
        }
    }
    _buildResourceAccessor(groups, nameHash) {
        const uniformsOut = {};
        for(const i in nameHash){
            const data = nameHash[i];
            Object.defineProperty(uniformsOut, data.name, {
                get () {
                    return groups[data.group].getResource(data.binding);
                },
                set (value) {
                    groups[data.group].setResource(value, data.binding);
                }
            });
        }
        return uniformsOut;
    }
    /**
   * Use to destroy the shader when its not longer needed.
   * It will destroy the resources and remove listeners.
   * @param destroyPrograms - if the programs should be destroyed as well.
   * Make sure its not being used by other shaders!
   */ destroy(destroyPrograms = false) {
        this.emit("destroy", this);
        if (destroyPrograms) {
            this.gpuProgram?.destroy();
            this.glProgram?.destroy();
        }
        this.gpuProgram = null;
        this.glProgram = null;
        this.removeAllListeners();
        this._uniformBindMap = null;
        this._ownedBindGroups.forEach((bindGroup)=>{
            bindGroup.destroy();
        });
        this._ownedBindGroups = null;
        this.resources = null;
        this.groups = null;
    }
    static from(options) {
        const { gpu: gpu, gl: gl, ...rest } = options;
        let gpuProgram;
        let glProgram;
        if (gpu) gpuProgram = (0, $9E2kA.GpuProgram).from(gpu);
        if (gl) glProgram = (0, $339HX.GlProgram).from(gl);
        return new $ee3083dafab39dcc$export$462bb059fed9d9e5({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            ...rest
        });
    }
}

});
parcelRegister("cepzV", function(module, exports) {

$parcel$export(module.exports, "RendererType", () => $343620db9d9618e4$export$2ca8315eebe81c3d);
"use strict";
var $343620db9d9618e4$export$2ca8315eebe81c3d = /* @__PURE__ */ ((RendererType2)=>{
    RendererType2[RendererType2["WEBGL"] = 1] = "WEBGL";
    RendererType2[RendererType2["WEBGPU"] = 2] = "WEBGPU";
    RendererType2[RendererType2["BOTH"] = 3] = "BOTH";
    return RendererType2;
})($343620db9d9618e4$export$2ca8315eebe81c3d || {});

});


parcelRegister("d6jVO", function(module, exports) {

$parcel$export(module.exports, "State", () => $93af8dc04d8202b8$export$7254cc27399e90bd);
"use strict";
const $93af8dc04d8202b8$var$blendModeIds = {
    normal: 0,
    add: 1,
    multiply: 2,
    screen: 3,
    overlay: 4,
    erase: 5,
    "normal-npm": 6,
    "add-npm": 7,
    "screen-npm": 8
};
const $93af8dc04d8202b8$var$BLEND = 0;
const $93af8dc04d8202b8$var$OFFSET = 1;
const $93af8dc04d8202b8$var$CULLING = 2;
const $93af8dc04d8202b8$var$DEPTH_TEST = 3;
const $93af8dc04d8202b8$var$WINDING = 4;
const $93af8dc04d8202b8$var$DEPTH_MASK = 5;
const $93af8dc04d8202b8$var$_State = class _State {
    constructor(){
        this.data = 0;
        this.blendMode = "normal";
        this.polygonOffset = 0;
        this.blend = true;
        this.depthMask = true;
    }
    /**
   * Activates blending of the computed fragment color values.
   * @default true
   */ get blend() {
        return !!(this.data & 1 << $93af8dc04d8202b8$var$BLEND);
    }
    set blend(value) {
        if (!!(this.data & 1 << $93af8dc04d8202b8$var$BLEND) !== value) this.data ^= 1 << $93af8dc04d8202b8$var$BLEND;
    }
    /**
   * Activates adding an offset to depth values of polygon's fragments
   * @default false
   */ get offsets() {
        return !!(this.data & 1 << $93af8dc04d8202b8$var$OFFSET);
    }
    set offsets(value) {
        if (!!(this.data & 1 << $93af8dc04d8202b8$var$OFFSET) !== value) this.data ^= 1 << $93af8dc04d8202b8$var$OFFSET;
    }
    /** The culling settings for this state none - No culling back - Back face culling front - Front face culling */ set cullMode(value) {
        if (value === "none") {
            this.culling = false;
            return;
        }
        this.culling = true;
        this.clockwiseFrontFace = value === "front";
    }
    get cullMode() {
        if (!this.culling) return "none";
        return this.clockwiseFrontFace ? "front" : "back";
    }
    /**
   * Activates culling of polygons.
   * @default false
   */ get culling() {
        return !!(this.data & 1 << $93af8dc04d8202b8$var$CULLING);
    }
    set culling(value) {
        if (!!(this.data & 1 << $93af8dc04d8202b8$var$CULLING) !== value) this.data ^= 1 << $93af8dc04d8202b8$var$CULLING;
    }
    /**
   * Activates depth comparisons and updates to the depth buffer.
   * @default false
   */ get depthTest() {
        return !!(this.data & 1 << $93af8dc04d8202b8$var$DEPTH_TEST);
    }
    set depthTest(value) {
        if (!!(this.data & 1 << $93af8dc04d8202b8$var$DEPTH_TEST) !== value) this.data ^= 1 << $93af8dc04d8202b8$var$DEPTH_TEST;
    }
    /**
   * Enables or disables writing to the depth buffer.
   * @default true
   */ get depthMask() {
        return !!(this.data & 1 << $93af8dc04d8202b8$var$DEPTH_MASK);
    }
    set depthMask(value) {
        if (!!(this.data & 1 << $93af8dc04d8202b8$var$DEPTH_MASK) !== value) this.data ^= 1 << $93af8dc04d8202b8$var$DEPTH_MASK;
    }
    /**
   * Specifies whether or not front or back-facing polygons can be culled.
   * @default false
   */ get clockwiseFrontFace() {
        return !!(this.data & 1 << $93af8dc04d8202b8$var$WINDING);
    }
    set clockwiseFrontFace(value) {
        if (!!(this.data & 1 << $93af8dc04d8202b8$var$WINDING) !== value) this.data ^= 1 << $93af8dc04d8202b8$var$WINDING;
    }
    /**
   * The blend mode to be applied when this state is set. Apply a value of `normal` to reset the blend mode.
   * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
   * @default 'normal'
   */ get blendMode() {
        return this._blendMode;
    }
    set blendMode(value) {
        this.blend = value !== "none";
        this._blendMode = value;
        this._blendModeId = $93af8dc04d8202b8$var$blendModeIds[value] || 0;
    }
    /**
   * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
   * @default 0
   */ get polygonOffset() {
        return this._polygonOffset;
    }
    set polygonOffset(value) {
        this.offsets = !!value;
        this._polygonOffset = value;
    }
    toString() {
        return `[pixi.js/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
    }
    /**
   * A quickly getting an instance of a State that is configured for 2d rendering.
   * @returns a new State with values set for 2d rendering
   */ static for2d() {
        const state = new _State();
        state.depthTest = false;
        state.blend = true;
        return state;
    }
};
$93af8dc04d8202b8$var$_State.default2d = $93af8dc04d8202b8$var$_State.for2d();
let $93af8dc04d8202b8$export$7254cc27399e90bd = $93af8dc04d8202b8$var$_State;

});


parcelRegister("g5CeI", function(module, exports) {

$parcel$export(module.exports, "TexturePool", () => $c8788a264b7b4623$export$686d8ddcd5ee6cd2);

var $b2FIe = parcelRequire("b2FIe");

var $eIuJW = parcelRequire("eIuJW");

var $jollT = parcelRequire("jollT");
"use strict";
let $c8788a264b7b4623$var$count = 0;
class $c8788a264b7b4623$export$f5c6a2d8ed21d1d {
    /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {SCALE_MODE} [textureOptions.scaleMode] - See {@link SCALE_MODE} for possible values.
   */ constructor(textureOptions){
        this._poolKeyHash = /* @__PURE__ */ Object.create(null);
        this._texturePool = {};
        this.textureOptions = textureOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   * @param antialias
   */ createTexture(pixelWidth, pixelHeight, antialias) {
        const textureSource = new (0, $eIuJW.TextureSource)({
            ...this.textureOptions,
            width: pixelWidth,
            height: pixelHeight,
            resolution: 1,
            antialias: antialias,
            autoGarbageCollect: true
        });
        return new (0, $jollT.Texture)({
            source: textureSource,
            label: `texturePool_${$c8788a264b7b4623$var$count++}`
        });
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param frameWidth - The minimum width of the render texture.
   * @param frameHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @param antialias
   * @returns The new render texture.
   */ getOptimalTexture(frameWidth, frameHeight, resolution = 1, antialias) {
        let po2Width = Math.ceil(frameWidth * resolution - 1e-6);
        let po2Height = Math.ceil(frameHeight * resolution - 1e-6);
        po2Width = (0, $b2FIe.nextPow2)(po2Width);
        po2Height = (0, $b2FIe.nextPow2)(po2Height);
        const key = (po2Width << 17) + (po2Height << 1) + (antialias ? 1 : 0);
        if (!this._texturePool[key]) this._texturePool[key] = [];
        let texture = this._texturePool[key].pop();
        if (!texture) texture = this.createTexture(po2Width, po2Height, antialias);
        texture.source._resolution = resolution;
        texture.source.width = po2Width / resolution;
        texture.source.height = po2Height / resolution;
        texture.source.pixelWidth = po2Width;
        texture.source.pixelHeight = po2Height;
        texture.frame.x = 0;
        texture.frame.y = 0;
        texture.frame.width = frameWidth;
        texture.frame.height = frameHeight;
        texture.updateUvs();
        this._poolKeyHash[texture.uid] = key;
        return texture;
    }
    /**
   * Gets extra texture of the same size as input renderTexture
   * @param texture - The texture to check what size it is.
   * @param antialias - Whether to use antialias.
   * @returns A texture that is a power of two
   */ getSameSizeTexture(texture, antialias = false) {
        const source = texture.source;
        return this.getOptimalTexture(texture.width, texture.height, source._resolution, antialias);
    }
    /**
   * Place a render texture back into the pool.
   * @param renderTexture - The renderTexture to free
   */ returnTexture(renderTexture) {
        const key = this._poolKeyHash[renderTexture.uid];
        this._texturePool[key].push(renderTexture);
    }
    /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */ clear(destroyTextures) {
        destroyTextures = destroyTextures !== false;
        if (destroyTextures) for(const i in this._texturePool){
            const textures = this._texturePool[i];
            if (textures) for(let j = 0; j < textures.length; j++)textures[j].destroy(true);
        }
        this._texturePool = {};
    }
}
const $c8788a264b7b4623$export$686d8ddcd5ee6cd2 = new $c8788a264b7b4623$export$f5c6a2d8ed21d1d();

});

parcelRegister("8VCQS", function(module, exports) {

$parcel$export(module.exports, "Graphics", () => $cc80086735f83d94$export$29d3e417456abdad);

var $j0fPb = parcelRequire("j0fPb");

var $e0Ilp = parcelRequire("e0Ilp");

var $gMeQx = parcelRequire("gMeQx");
"use strict";
class $cc80086735f83d94$export$29d3e417456abdad extends (0, $e0Ilp.Container) {
    /**
   * @param options - Options for the Graphics.
   */ constructor(options){
        if (options instanceof (0, $gMeQx.GraphicsContext)) options = {
            context: options
        };
        const { context: context, roundPixels: roundPixels, ...rest } = options || {};
        super({
            label: "Graphics",
            ...rest
        });
        this.canBundle = true;
        this.renderPipeId = "graphics";
        this._roundPixels = 0;
        if (!context) this._context = this._ownedContext = new (0, $gMeQx.GraphicsContext)();
        else this._context = context;
        this._context.on("update", this.onViewUpdate, this);
        this.allowChildren = false;
        this.roundPixels = roundPixels ?? false;
    }
    set context(context) {
        if (context === this._context) return;
        this._context.off("update", this.onViewUpdate, this);
        this._context = context;
        this._context.on("update", this.onViewUpdate, this);
        this.onViewUpdate();
    }
    get context() {
        return this._context;
    }
    /**
   * The local bounds of the graphic.
   * @type {rendering.Bounds}
   */ get bounds() {
        return this._context.bounds;
    }
    /**
   * Adds the bounds of this object to the bounds object.
   * @param bounds - The output bounds object.
   */ addBounds(bounds) {
        bounds.addBounds(this._context.bounds);
    }
    /**
   * Checks if the object contains the given point.
   * @param point - The point to check
   */ containsPoint(point) {
        return this._context.containsPoint(point);
    }
    /**
   *  Whether or not to round the x/y position of the graphic.
   * @type {boolean}
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    set roundPixels(value) {
        this._roundPixels = value ? 1 : 0;
    }
    onViewUpdate() {
        this._didChangeId += 4096;
        this._didGraphicsUpdate = true;
        if (this.didViewUpdate) return;
        this.didViewUpdate = true;
        if (this.renderGroup) this.renderGroup.onChildViewUpdate(this);
    }
    /**
   * Destroys this graphics renderable and optionally its context.
   * @param options - Options parameter. A boolean will act as if all options
   *
   * If the context was created by this graphics and `destroy(false)` or `destroy()` is called
   * then the context will still be destroyed.
   *
   * If you want to explicitly not destroy this context that this graphics created,
   * then you should pass destroy({ context: false })
   *
   * If the context was passed in as an argument to the constructor then it will not be destroyed
   * @param {boolean} [options.texture=false] - Should destroy the texture of the graphics context
   * @param {boolean} [options.textureSource=false] - Should destroy the texture source of the graphics context
   * @param {boolean} [options.context=false] - Should destroy the context
   */ destroy(options) {
        if (this._ownedContext && !options) this._ownedContext.destroy(options);
        else if (options === true || options?.context === true) this._context.destroy(options);
        this._ownedContext = null;
        this._context = null;
        super.destroy(options);
    }
    _callContextMethod(method, args) {
        this.context[method](...args);
        return this;
    }
    // --------------------------------------- GraphicsContext methods ---------------------------------------
    /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param {FillStyleInputs} args - The fill style to apply. This can be a simple color, a gradient or
   * pattern object, or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setFillStyle(...args) {
        return this._callContextMethod("setFillStyle", args);
    }
    /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param {FillStyleInputs} args - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   * or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setStrokeStyle(...args) {
        return this._callContextMethod("setStrokeStyle", args);
    }
    fill(...args) {
        return this._callContextMethod("fill", args);
    }
    /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillStyleInputs parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param {FillStyleInputs} args - (Optional) The stroke style to apply. Can be defined as a simple color or a more
   * complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ stroke(...args) {
        return this._callContextMethod("stroke", args);
    }
    texture(...args) {
        return this._callContextMethod("texture", args);
    }
    /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ beginPath() {
        return this._callContextMethod("beginPath", []);
    }
    /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   */ cut() {
        return this._callContextMethod("cut", []);
    }
    arc(...args) {
        return this._callContextMethod("arc", args);
    }
    arcTo(...args) {
        return this._callContextMethod("arcTo", args);
    }
    arcToSvg(...args) {
        return this._callContextMethod("arcToSvg", args);
    }
    bezierCurveTo(...args) {
        return this._callContextMethod("bezierCurveTo", args);
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        return this._callContextMethod("closePath", []);
    }
    ellipse(...args) {
        return this._callContextMethod("ellipse", args);
    }
    circle(...args) {
        return this._callContextMethod("circle", args);
    }
    path(...args) {
        return this._callContextMethod("path", args);
    }
    lineTo(...args) {
        return this._callContextMethod("lineTo", args);
    }
    moveTo(...args) {
        return this._callContextMethod("moveTo", args);
    }
    quadraticCurveTo(...args) {
        return this._callContextMethod("quadraticCurveTo", args);
    }
    rect(...args) {
        return this._callContextMethod("rect", args);
    }
    roundRect(...args) {
        return this._callContextMethod("roundRect", args);
    }
    poly(...args) {
        return this._callContextMethod("poly", args);
    }
    regularPoly(...args) {
        return this._callContextMethod("regularPoly", args);
    }
    roundPoly(...args) {
        return this._callContextMethod("roundPoly", args);
    }
    roundShape(...args) {
        return this._callContextMethod("roundShape", args);
    }
    filletRect(...args) {
        return this._callContextMethod("filletRect", args);
    }
    chamferRect(...args) {
        return this._callContextMethod("chamferRect", args);
    }
    star(...args) {
        return this._callContextMethod("star", args);
    }
    svg(...args) {
        return this._callContextMethod("svg", args);
    }
    restore(...args) {
        return this._callContextMethod("restore", args);
    }
    /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */ save() {
        return this._callContextMethod("save", []);
    }
    /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */ getTransform() {
        return this.context.getTransform();
    }
    /**
   * Resets the current transformation matrix to the identity matrix, effectively removing
   * any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ resetTransform() {
        return this._callContextMethod("resetTransform", []);
    }
    rotateTransform(...args) {
        return this._callContextMethod("rotate", args);
    }
    scaleTransform(...args) {
        return this._callContextMethod("scale", args);
    }
    setTransform(...args) {
        return this._callContextMethod("setTransform", args);
    }
    transform(...args) {
        return this._callContextMethod("transform", args);
    }
    translateTransform(...args) {
        return this._callContextMethod("translate", args);
    }
    /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ clear() {
        return this._callContextMethod("clear", []);
    }
    /**
   * The fill style to use.
   * @type {ConvertedFillStyle}
   */ get fillStyle() {
        return this._context.fillStyle;
    }
    set fillStyle(value) {
        this._context.fillStyle = value;
    }
    /**
   * The stroke style to use.
   * @type {ConvertedStrokeStyle}
   */ get strokeStyle() {
        return this._context.strokeStyle;
    }
    set strokeStyle(value) {
        this._context.strokeStyle = value;
    }
    /**
   * Creates a new Graphics object.
   * Note that only the context of the object is cloned, not its transform (position,scale,etc)
   * @param deep - Whether to create a deep clone of the graphics object. If false, the context
   * will be shared between the two objects (default false). If true, the context will be
   * cloned (recommended if you need to modify the context in any way).
   * @returns - A clone of the graphics object
   */ clone(deep = false) {
        if (deep) return new $cc80086735f83d94$export$29d3e417456abdad(this._context.clone());
        this._ownedContext = null;
        const clone = new $cc80086735f83d94$export$29d3e417456abdad(this._context);
        return clone;
    }
    // -------- v7 deprecations ---------
    /**
   * @param width
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#setStrokeStyle} instead
   */ lineStyle(width, color, alpha) {
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "Graphics#lineStyle is no longer needed. Use Graphics#setStrokeStyle to set the stroke style.");
        const strokeStyle = {};
        width && (strokeStyle.width = width);
        color && (strokeStyle.color = color);
        alpha && (strokeStyle.alpha = alpha);
        this.context.strokeStyle = strokeStyle;
        return this;
    }
    /**
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */ beginFill(color, alpha) {
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "Graphics#beginFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
        const fillStyle = {};
        color && (fillStyle.color = color);
        alpha && (fillStyle.alpha = alpha);
        this.context.fillStyle = fillStyle;
        return this;
    }
    /**
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */ endFill() {
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "Graphics#endFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
        this.context.fill();
        const strokeStyle = this.context.strokeStyle;
        if (strokeStyle.width !== (0, $gMeQx.GraphicsContext).defaultStrokeStyle.width || strokeStyle.color !== (0, $gMeQx.GraphicsContext).defaultStrokeStyle.color || strokeStyle.alpha !== (0, $gMeQx.GraphicsContext).defaultStrokeStyle.alpha) this.context.stroke();
        return this;
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#circle} instead
   */ drawCircle(...args) {
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "Graphics#drawCircle has been renamed to Graphics#circle");
        return this._callContextMethod("circle", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#ellipse} instead
   */ drawEllipse(...args) {
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "Graphics#drawEllipse has been renamed to Graphics#ellipse");
        return this._callContextMethod("ellipse", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#poly} instead
   */ drawPolygon(...args) {
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "Graphics#drawPolygon has been renamed to Graphics#poly");
        return this._callContextMethod("poly", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#rect} instead
   */ drawRect(...args) {
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "Graphics#drawRect has been renamed to Graphics#rect");
        return this._callContextMethod("rect", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#roundRect} instead
   */ drawRoundedRect(...args) {
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "Graphics#drawRoundedRect has been renamed to Graphics#roundRect");
        return this._callContextMethod("roundRect", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#star} instead
   */ drawStar(...args) {
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "Graphics#drawStar has been renamed to Graphics#star");
        return this._callContextMethod("star", args);
    }
}

});

parcelRegister("gA7LB", function(module, exports) {

$parcel$export(module.exports, "CanvasTextMetrics", () => $7563fbebc5a7d505$export$b12f6bdc825d944f);

var $2NruG = parcelRequire("2NruG");

var $fHUjd = parcelRequire("fHUjd");
"use strict";
const $7563fbebc5a7d505$var$contextSettings = {
    // TextMetrics requires getImageData readback for measuring fonts.
    willReadFrequently: true
};
const $7563fbebc5a7d505$var$_CanvasTextMetrics = class _CanvasTextMetrics {
    /**
   * Checking that we can use modern canvas 2D API.
   *
   * Note: This is an unstable API, Chrome < 94 use `textLetterSpacing`, later versions use `letterSpacing`.
   * @see TextMetrics.experimentalLetterSpacing
   * @see https://developer.mozilla.org/en-US/docs/Web/API/ICanvasRenderingContext2D/letterSpacing
   * @see https://developer.chrome.com/origintrials/#/view_trial/3585991203293757441
   */ static get experimentalLetterSpacingSupported() {
        let result = _CanvasTextMetrics._experimentalLetterSpacingSupported;
        if (result !== void 0) {
            const proto = (0, $2NruG.DOMAdapter).get().getCanvasRenderingContext2D().prototype;
            result = _CanvasTextMetrics._experimentalLetterSpacingSupported = "letterSpacing" in proto || "textLetterSpacing" in proto;
        }
        return result;
    }
    /**
   * @param text - the text that was measured
   * @param style - the style that was measured
   * @param width - the measured width of the text
   * @param height - the measured height of the text
   * @param lines - an array of the lines of text broken by new lines and wrapping if specified in style
   * @param lineWidths - an array of the line widths for each line matched to `lines`
   * @param lineHeight - the measured line height for this style
   * @param maxLineWidth - the maximum line width for all measured lines
   * @param {FontMetrics} fontProperties - the font properties object from TextMetrics.measureFont
   */ constructor(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties){
        this.text = text;
        this.style = style;
        this.width = width;
        this.height = height;
        this.lines = lines;
        this.lineWidths = lineWidths;
        this.lineHeight = lineHeight;
        this.maxLineWidth = maxLineWidth;
        this.fontProperties = fontProperties;
    }
    /**
   * Measures the supplied string of text and returns a Rectangle.
   * @param text - The text to measure.
   * @param style - The text style to use for measuring
   * @param canvas - optional specification of the canvas to use for measuring.
   * @param wordWrap
   * @returns Measured width and height of the text.
   */ static measureText(text = " ", style, canvas = _CanvasTextMetrics._canvas, wordWrap = style.wordWrap) {
        const textKey = `${text}:${style.styleKey}`;
        if (_CanvasTextMetrics._measurementCache[textKey]) return _CanvasTextMetrics._measurementCache[textKey];
        const font = (0, $fHUjd.fontStringFromTextStyle)(style);
        const fontProperties = _CanvasTextMetrics.measureFont(font);
        if (fontProperties.fontSize === 0) {
            fontProperties.fontSize = style.fontSize;
            fontProperties.ascent = style.fontSize;
        }
        const context = _CanvasTextMetrics.__context;
        context.font = font;
        const outputText = wordWrap ? _CanvasTextMetrics._wordWrap(text, style, canvas) : text;
        const lines = outputText.split(/(?:\r\n|\r|\n)/);
        const lineWidths = new Array(lines.length);
        let maxLineWidth = 0;
        for(let i = 0; i < lines.length; i++){
            const lineWidth = _CanvasTextMetrics._measureText(lines[i], style.letterSpacing, context);
            lineWidths[i] = lineWidth;
            maxLineWidth = Math.max(maxLineWidth, lineWidth);
        }
        const strokeWidth = style._stroke?.width || 0;
        let width = maxLineWidth + strokeWidth;
        if (style.dropShadow) width += style.dropShadow.distance;
        const lineHeight = style.lineHeight || fontProperties.fontSize + strokeWidth;
        let height = Math.max(lineHeight, fontProperties.fontSize + strokeWidth * 2) + (lines.length - 1) * (lineHeight + style.leading);
        if (style.dropShadow) height += style.dropShadow.distance;
        const measurements = new _CanvasTextMetrics(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
        return measurements;
    }
    static _measureText(text, letterSpacing, context) {
        let useExperimentalLetterSpacing = false;
        if (_CanvasTextMetrics.experimentalLetterSpacingSupported) {
            if (_CanvasTextMetrics.experimentalLetterSpacing) {
                context.letterSpacing = `${letterSpacing}px`;
                context.textLetterSpacing = `${letterSpacing}px`;
                useExperimentalLetterSpacing = true;
            } else {
                context.letterSpacing = "0px";
                context.textLetterSpacing = "0px";
            }
        }
        let width = context.measureText(text).width;
        if (width > 0) {
            if (useExperimentalLetterSpacing) width -= letterSpacing;
            else width += (_CanvasTextMetrics.graphemeSegmenter(text).length - 1) * letterSpacing;
        }
        return width;
    }
    /**
   * Applies newlines to a string to have it optimally fit into the horizontal
   * bounds set by the Text object's wordWrapWidth property.
   * @param text - String to apply word wrapping to
   * @param style - the style to use when wrapping
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns New string with new lines applied where required
   */ static _wordWrap(text, style, canvas = _CanvasTextMetrics._canvas) {
        const context = canvas.getContext("2d", $7563fbebc5a7d505$var$contextSettings);
        let width = 0;
        let line = "";
        let lines = "";
        const cache = /* @__PURE__ */ Object.create(null);
        const { letterSpacing: letterSpacing, whiteSpace: whiteSpace } = style;
        const collapseSpaces = _CanvasTextMetrics._collapseSpaces(whiteSpace);
        const collapseNewlines = _CanvasTextMetrics._collapseNewlines(whiteSpace);
        let canPrependSpaces = !collapseSpaces;
        const wordWrapWidth = style.wordWrapWidth + letterSpacing;
        const tokens = _CanvasTextMetrics._tokenize(text);
        for(let i = 0; i < tokens.length; i++){
            let token = tokens[i];
            if (_CanvasTextMetrics._isNewline(token)) {
                if (!collapseNewlines) {
                    lines += _CanvasTextMetrics._addLine(line);
                    canPrependSpaces = !collapseSpaces;
                    line = "";
                    width = 0;
                    continue;
                }
                token = " ";
            }
            if (collapseSpaces) {
                const currIsBreakingSpace = _CanvasTextMetrics.isBreakingSpace(token);
                const lastIsBreakingSpace = _CanvasTextMetrics.isBreakingSpace(line[line.length - 1]);
                if (currIsBreakingSpace && lastIsBreakingSpace) continue;
            }
            const tokenWidth = _CanvasTextMetrics._getFromCache(token, letterSpacing, cache, context);
            if (tokenWidth > wordWrapWidth) {
                if (line !== "") {
                    lines += _CanvasTextMetrics._addLine(line);
                    line = "";
                    width = 0;
                }
                if (_CanvasTextMetrics.canBreakWords(token, style.breakWords)) {
                    const characters = _CanvasTextMetrics.wordWrapSplit(token);
                    for(let j = 0; j < characters.length; j++){
                        let char = characters[j];
                        let lastChar = char;
                        let k = 1;
                        while(characters[j + k]){
                            const nextChar = characters[j + k];
                            if (!_CanvasTextMetrics.canBreakChars(lastChar, nextChar, token, j, style.breakWords)) char += nextChar;
                            else break;
                            lastChar = nextChar;
                            k++;
                        }
                        j += k - 1;
                        const characterWidth = _CanvasTextMetrics._getFromCache(char, letterSpacing, cache, context);
                        if (characterWidth + width > wordWrapWidth) {
                            lines += _CanvasTextMetrics._addLine(line);
                            canPrependSpaces = false;
                            line = "";
                            width = 0;
                        }
                        line += char;
                        width += characterWidth;
                    }
                } else {
                    if (line.length > 0) {
                        lines += _CanvasTextMetrics._addLine(line);
                        line = "";
                        width = 0;
                    }
                    const isLastToken = i === tokens.length - 1;
                    lines += _CanvasTextMetrics._addLine(token, !isLastToken);
                    canPrependSpaces = false;
                    line = "";
                    width = 0;
                }
            } else {
                if (tokenWidth + width > wordWrapWidth) {
                    canPrependSpaces = false;
                    lines += _CanvasTextMetrics._addLine(line);
                    line = "";
                    width = 0;
                }
                if (line.length > 0 || !_CanvasTextMetrics.isBreakingSpace(token) || canPrependSpaces) {
                    line += token;
                    width += tokenWidth;
                }
            }
        }
        lines += _CanvasTextMetrics._addLine(line, false);
        return lines;
    }
    /**
   * Convienience function for logging each line added during the wordWrap method.
   * @param line    - The line of text to add
   * @param newLine - Add new line character to end
   * @returns A formatted line
   */ static _addLine(line, newLine = true) {
        line = _CanvasTextMetrics._trimRight(line);
        line = newLine ? `${line}
` : line;
        return line;
    }
    /**
   * Gets & sets the widths of calculated characters in a cache object
   * @param key            - The key
   * @param letterSpacing  - The letter spacing
   * @param cache          - The cache
   * @param context        - The canvas context
   * @returns The from cache.
   */ static _getFromCache(key, letterSpacing, cache, context) {
        let width = cache[key];
        if (typeof width !== "number") {
            width = _CanvasTextMetrics._measureText(key, letterSpacing, context) + letterSpacing;
            cache[key] = width;
        }
        return width;
    }
    /**
   * Determines whether we should collapse breaking spaces.
   * @param whiteSpace - The TextStyle property whiteSpace
   * @returns Should collapse
   */ static _collapseSpaces(whiteSpace) {
        return whiteSpace === "normal" || whiteSpace === "pre-line";
    }
    /**
   * Determines whether we should collapse newLine chars.
   * @param whiteSpace - The white space
   * @returns should collapse
   */ static _collapseNewlines(whiteSpace) {
        return whiteSpace === "normal";
    }
    /**
   * Trims breaking whitespaces from string.
   * @param text - The text
   * @returns Trimmed string
   */ static _trimRight(text) {
        if (typeof text !== "string") return "";
        for(let i = text.length - 1; i >= 0; i--){
            const char = text[i];
            if (!_CanvasTextMetrics.isBreakingSpace(char)) break;
            text = text.slice(0, -1);
        }
        return text;
    }
    /**
   * Determines if char is a newline.
   * @param char - The character
   * @returns True if newline, False otherwise.
   */ static _isNewline(char) {
        if (typeof char !== "string") return false;
        return _CanvasTextMetrics._newlines.includes(char.charCodeAt(0));
    }
    /**
   * Determines if char is a breaking whitespace.
   *
   * It allows one to determine whether char should be a breaking whitespace
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param char - The character
   * @param [_nextChar] - The next character
   * @returns True if whitespace, False otherwise.
   */ static isBreakingSpace(char, _nextChar) {
        if (typeof char !== "string") return false;
        return _CanvasTextMetrics._breakingSpaces.includes(char.charCodeAt(0));
    }
    /**
   * Splits a string into words, breaking-spaces and newLine characters
   * @param text - The text
   * @returns A tokenized array
   */ static _tokenize(text) {
        const tokens = [];
        let token = "";
        if (typeof text !== "string") return tokens;
        for(let i = 0; i < text.length; i++){
            const char = text[i];
            const nextChar = text[i + 1];
            if (_CanvasTextMetrics.isBreakingSpace(char, nextChar) || _CanvasTextMetrics._isNewline(char)) {
                if (token !== "") {
                    tokens.push(token);
                    token = "";
                }
                tokens.push(char);
                continue;
            }
            token += char;
        }
        if (token !== "") tokens.push(token);
        return tokens;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to customise which words should break
   * Examples are if the token is CJK or numbers.
   * It must return a boolean.
   * @param _token - The token
   * @param breakWords - The style attr break words
   * @returns Whether to break word or not
   */ static canBreakWords(_token, breakWords) {
        return breakWords;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to determine whether a pair of characters
   * should be broken by newlines
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param _char - The character
   * @param _nextChar - The next character
   * @param _token - The token/word the characters are from
   * @param _index - The index in the token of the char
   * @param _breakWords - The style attr break words
   * @returns whether to break word or not
   */ static canBreakChars(_char, _nextChar, _token, _index, _breakWords) {
        return true;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It is called when a token (usually a word) has to be split into separate pieces
   * in order to determine the point to break a word.
   * It must return an array of characters.
   * @param token - The token to split
   * @returns The characters of the token
   * @see CanvasTextMetrics.graphemeSegmenter
   */ static wordWrapSplit(token) {
        return _CanvasTextMetrics.graphemeSegmenter(token);
    }
    /**
   * Calculates the ascent, descent and fontSize of a given font-style
   * @param font - String representing the style of the font
   * @returns Font properties object
   */ static measureFont(font) {
        if (_CanvasTextMetrics._fonts[font]) return _CanvasTextMetrics._fonts[font];
        const context = _CanvasTextMetrics._context;
        context.font = font;
        const metrics = context.measureText(_CanvasTextMetrics.METRICS_STRING + _CanvasTextMetrics.BASELINE_SYMBOL);
        const properties = {
            ascent: metrics.actualBoundingBoxAscent,
            descent: metrics.actualBoundingBoxDescent,
            fontSize: metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent
        };
        _CanvasTextMetrics._fonts[font] = properties;
        return properties;
    }
    /**
   * Clear font metrics in metrics cache.
   * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
   */ static clearMetrics(font = "") {
        if (font) delete _CanvasTextMetrics._fonts[font];
        else _CanvasTextMetrics._fonts = {};
    }
    /**
   * Cached canvas element for measuring text
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _canvas() {
        if (!_CanvasTextMetrics.__canvas) {
            let canvas;
            try {
                const c = new OffscreenCanvas(0, 0);
                const context = c.getContext("2d", $7563fbebc5a7d505$var$contextSettings);
                if (context?.measureText) {
                    _CanvasTextMetrics.__canvas = c;
                    return c;
                }
                canvas = (0, $2NruG.DOMAdapter).get().createCanvas();
            } catch (ex) {
                canvas = (0, $2NruG.DOMAdapter).get().createCanvas();
            }
            canvas.width = canvas.height = 10;
            _CanvasTextMetrics.__canvas = canvas;
        }
        return _CanvasTextMetrics.__canvas;
    }
    /**
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _context() {
        if (!_CanvasTextMetrics.__context) _CanvasTextMetrics.__context = _CanvasTextMetrics._canvas.getContext("2d", $7563fbebc5a7d505$var$contextSettings);
        return _CanvasTextMetrics.__context;
    }
};
/**
 * String used for calculate font metrics.
 * These characters are all tall to help calculate the height required for text.
 */ $7563fbebc5a7d505$var$_CanvasTextMetrics.METRICS_STRING = "|\xc9q\xc5";
/** Baseline symbol for calculate font metrics. */ $7563fbebc5a7d505$var$_CanvasTextMetrics.BASELINE_SYMBOL = "M";
/** Baseline multiplier for calculate font metrics. */ $7563fbebc5a7d505$var$_CanvasTextMetrics.BASELINE_MULTIPLIER = 1.4;
/** Height multiplier for setting height of canvas to calculate font metrics. */ $7563fbebc5a7d505$var$_CanvasTextMetrics.HEIGHT_MULTIPLIER = 2;
/**
 * A Unicode "character", or "grapheme cluster", can be composed of multiple Unicode code points,
 * such as letters with diacritical marks (e.g. `'\u0065\u0301'`, letter e with acute)
 * or emojis with modifiers (e.g. `'\uD83E\uDDD1\u200D\uD83D\uDCBB'`, technologist).
 * The new `Intl.Segmenter` API in ES2022 can split the string into grapheme clusters correctly. If it is not available,
 * PixiJS will fallback to use the iterator of String, which can only spilt the string into code points.
 * If you want to get full functionality in environments that don't support `Intl.Segmenter` (such as Firefox),
 * you can use other libraries such as [grapheme-splitter]{@link https://www.npmjs.com/package/grapheme-splitter}
 * or [graphemer]{@link https://www.npmjs.com/package/graphemer} to create a polyfill. Since these libraries can be
 * relatively large in size to handle various Unicode grapheme clusters properly, PixiJS won't use them directly.
 */ $7563fbebc5a7d505$var$_CanvasTextMetrics.graphemeSegmenter = (()=>{
    if (typeof Intl?.Segmenter === "function") {
        const segmenter = new Intl.Segmenter();
        return (s)=>[
                ...segmenter.segment(s)
            ].map((x)=>x.segment);
    }
    return (s)=>[
            ...s
        ];
})();
/**
 * New rendering behavior for letter-spacing which uses Chrome's new native API. This will
 * lead to more accurate letter-spacing results because it does not try to manually draw
 * each character. However, this Chrome API is experimental and may not serve all cases yet.
 * @see TextMetrics.experimentalLetterSpacingSupported
 */ $7563fbebc5a7d505$var$_CanvasTextMetrics.experimentalLetterSpacing = false;
/** Cache of {@see TextMetrics.FontMetrics} objects. */ $7563fbebc5a7d505$var$_CanvasTextMetrics._fonts = {};
/** Cache of new line chars. */ $7563fbebc5a7d505$var$_CanvasTextMetrics._newlines = [
    10,
    // line feed
    13
];
/** Cache of breaking spaces. */ $7563fbebc5a7d505$var$_CanvasTextMetrics._breakingSpaces = [
    9,
    // character tabulation
    32,
    // space
    8192,
    // en quad
    8193,
    // em quad
    8194,
    // en space
    8195,
    // em space
    8196,
    // three-per-em space
    8197,
    // four-per-em space
    8198,
    // six-per-em space
    8200,
    // punctuation space
    8201,
    // thin space
    8202,
    // hair space
    8287,
    // medium mathematical space
    12288
];
$7563fbebc5a7d505$var$_CanvasTextMetrics._measurementCache = {};
let $7563fbebc5a7d505$export$b12f6bdc825d944f = $7563fbebc5a7d505$var$_CanvasTextMetrics;

});
parcelRegister("fHUjd", function(module, exports) {

$parcel$export(module.exports, "fontStringFromTextStyle", () => $3c52f22ba9e0ff39$export$b7b5edb82ac3fc66);
"use strict";
const $3c52f22ba9e0ff39$var$genericFontFamilies = [
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui"
];
function $3c52f22ba9e0ff39$export$b7b5edb82ac3fc66(style) {
    const fontSizeString = typeof style.fontSize === "number" ? `${style.fontSize}px` : style.fontSize;
    let fontFamilies = style.fontFamily;
    if (!Array.isArray(style.fontFamily)) fontFamilies = style.fontFamily.split(",");
    for(let i = fontFamilies.length - 1; i >= 0; i--){
        let fontFamily = fontFamilies[i].trim();
        if (!/([\"\'])[^\'\"]+\1/.test(fontFamily) && !$3c52f22ba9e0ff39$var$genericFontFamilies.includes(fontFamily)) fontFamily = `"${fontFamily}"`;
        fontFamilies[i] = fontFamily;
    }
    return `${style.fontStyle} ${style.fontVariant} ${style.fontWeight} ${fontSizeString} ${fontFamilies.join(",")}`;
}

});


parcelRegister("jZulE", function(module, exports) {

$parcel$export(module.exports, "TextStyle", () => $e4fd9cfa95519f91$export$1df879243bf2e42d);

var $gpXaq = parcelRequire("gpXaq");

var $bEj7k = parcelRequire("bEj7k");

var $j0fPb = parcelRequire("j0fPb");

var $ex7ag = parcelRequire("ex7ag");

var $gMeQx = parcelRequire("gMeQx");

var $5uEQO = parcelRequire("5uEQO");

var $kwtgT = parcelRequire("kwtgT");
"use strict";
const $e4fd9cfa95519f91$var$_TextStyle = class _TextStyle extends (0, (/*@__PURE__*/$parcel$interopDefault($gpXaq))) {
    constructor(style = {}){
        super();
        $e4fd9cfa95519f91$var$convertV7Tov8Style(style);
        const fullStyle = {
            ..._TextStyle.defaultTextStyle,
            ...style
        };
        for(const key in fullStyle){
            const thisKey = key;
            this[thisKey] = fullStyle[key];
        }
        this.update();
    }
    /**
   * Alignment for multiline text, does not affect single line text.
   * @member {'left'|'center'|'right'|'justify'}
   */ get align() {
        return this._align;
    }
    set align(value) {
        this._align = value;
        this.update();
    }
    /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */ get breakWords() {
        return this._breakWords;
    }
    set breakWords(value) {
        this._breakWords = value;
        this.update();
    }
    /** Set a drop shadow for the text. */ get dropShadow() {
        return this._dropShadow;
    }
    set dropShadow(value) {
        if (value !== null && typeof value === "object") this._dropShadow = {
            ..._TextStyle.defaultDropShadow,
            ...value
        };
        else this._dropShadow = value ? {
            ..._TextStyle.defaultDropShadow
        } : null;
        this.update();
    }
    /** The font family, can be a single font name, or a list of names where the first is the preferred font. */ get fontFamily() {
        return this._fontFamily;
    }
    set fontFamily(value) {
        this._fontFamily = value;
        this.update();
    }
    /** The font size (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em') */ get fontSize() {
        return this._fontSize;
    }
    set fontSize(value) {
        if (typeof value === "string") this._fontSize = parseInt(value, 10);
        else this._fontSize = value;
        this.update();
    }
    /**
   * The font style.
   * @member {'normal'|'italic'|'oblique'}
   */ get fontStyle() {
        return this._fontStyle;
    }
    set fontStyle(value) {
        this._fontStyle = value;
        this.update();
    }
    /**
   * The font variant.
   * @member {'normal'|'small-caps'}
   */ get fontVariant() {
        return this._fontVariant;
    }
    set fontVariant(value) {
        this._fontVariant = value;
        this.update();
    }
    /**
   * The font weight.
   * @member {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */ get fontWeight() {
        return this._fontWeight;
    }
    set fontWeight(value) {
        this._fontWeight = value;
        this.update();
    }
    /** The space between lines. */ get leading() {
        return this._leading;
    }
    set leading(value) {
        this._leading = value;
        this.update();
    }
    /** The amount of spacing between letters, default is 0. */ get letterSpacing() {
        return this._letterSpacing;
    }
    set letterSpacing(value) {
        this._letterSpacing = value;
        this.update();
    }
    /** The line height, a number that represents the vertical space that a letter uses. */ get lineHeight() {
        return this._lineHeight;
    }
    set lineHeight(value) {
        this._lineHeight = value;
        this.update();
    }
    /**
   * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
   * by adding padding to all sides of the text.
   */ get padding() {
        return this._padding;
    }
    set padding(value) {
        this._padding = value;
        this.update();
    }
    /** Trim transparent borders. This is an expensive operation so only use this if you have to! */ get trim() {
        return this._trim;
    }
    set trim(value) {
        this._trim = value;
        this.update();
    }
    /**
   * The baseline of the text that is rendered.
   * @member {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */ get textBaseline() {
        return this._textBaseline;
    }
    set textBaseline(value) {
        this._textBaseline = value;
        this.update();
    }
    /**
   * How newlines and spaces should be handled.
   * Default is 'pre' (preserve, preserve).
   *
   *  value       | New lines     |   Spaces
   *  ---         | ---           |   ---
   * 'normal'     | Collapse      |   Collapse
   * 'pre'        | Preserve      |   Preserve
   * 'pre-line'   | Preserve      |   Collapse
   * @member {'normal'|'pre'|'pre-line'}
   */ get whiteSpace() {
        return this._whiteSpace;
    }
    set whiteSpace(value) {
        this._whiteSpace = value;
        this.update();
    }
    /** Indicates if word wrap should be used. */ get wordWrap() {
        return this._wordWrap;
    }
    set wordWrap(value) {
        this._wordWrap = value;
        this.update();
    }
    /** The width at which text will wrap, it needs wordWrap to be set to true. */ get wordWrapWidth() {
        return this._wordWrapWidth;
    }
    set wordWrapWidth(value) {
        this._wordWrapWidth = value;
        this.update();
    }
    /** A fillstyle that will be used on the text e.g., 'red', '#00FF00'. */ get fill() {
        return this._originalFill;
    }
    set fill(value) {
        if (value === this._originalFill) return;
        this._originalFill = value;
        this._fill = (0, $5uEQO.convertFillInputToFillStyle)(value === 0 ? "black" : value, (0, $gMeQx.GraphicsContext).defaultFillStyle);
        this.update();
    }
    /** A fillstyle that will be used on the text stroke, e.g., 'blue', '#FCFF00'. */ get stroke() {
        return this._originalStroke;
    }
    set stroke(value) {
        if (value === this._originalStroke) return;
        this._originalStroke = value;
        this._stroke = (0, $5uEQO.convertFillInputToFillStyle)(value, (0, $gMeQx.GraphicsContext).defaultStrokeStyle);
        this.update();
    }
    _generateKey() {
        this._styleKey = (0, $kwtgT.generateTextStyleKey)(this);
        return this._styleKey;
    }
    update() {
        this._styleKey = null;
        this.emit("update", this);
    }
    /** Resets all properties to the default values */ reset() {
        const defaultStyle = _TextStyle.defaultTextStyle;
        for(const key in defaultStyle)this[key] = defaultStyle[key];
    }
    get styleKey() {
        return this._styleKey || this._generateKey();
    }
    /**
   * Creates a new TextStyle object with the same values as this one.
   * @returns New cloned TextStyle object
   */ clone() {
        return new _TextStyle({
            align: this.align,
            breakWords: this.breakWords,
            dropShadow: this.dropShadow,
            fill: this._fill,
            fontFamily: this.fontFamily,
            fontSize: this.fontSize,
            fontStyle: this.fontStyle,
            fontVariant: this.fontVariant,
            fontWeight: this.fontWeight,
            leading: this.leading,
            letterSpacing: this.letterSpacing,
            lineHeight: this.lineHeight,
            padding: this.padding,
            stroke: this._stroke,
            textBaseline: this.textBaseline,
            whiteSpace: this.whiteSpace,
            wordWrap: this.wordWrap,
            wordWrapWidth: this.wordWrapWidth
        });
    }
    /**
   * Destroys this text style.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the texture of the this style
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the this style
   */ destroy(options = false) {
        this.removeAllListeners();
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            if (this._fill?.texture) this._fill.texture.destroy(destroyTextureSource);
            if (this._originalFill?.texture) this._originalFill.texture.destroy(destroyTextureSource);
            if (this._stroke?.texture) this._stroke.texture.destroy(destroyTextureSource);
            if (this._originalStroke?.texture) this._originalStroke.texture.destroy(destroyTextureSource);
        }
        this._fill = null;
        this._stroke = null;
        this.dropShadow = null;
        this._originalStroke = null;
        this._originalFill = null;
    }
};
/** The default drop shadow settings */ $e4fd9cfa95519f91$var$_TextStyle.defaultDropShadow = {
    /** Set alpha for the drop shadow */ alpha: 1,
    /** Set a angle of the drop shadow */ angle: Math.PI / 6,
    /** Set a shadow blur radius */ blur: 0,
    /** A fill style to be used on the  e.g., 'red', '#00FF00' */ color: "black",
    /** Set a distance of the drop shadow */ distance: 5
};
/** The default text style settings */ $e4fd9cfa95519f91$var$_TextStyle.defaultTextStyle = {
    /**
   * See {@link TextStyle.align}
   * @type {'left'|'center'|'right'|'justify'}
   */ align: "left",
    /** See {@link TextStyle.breakWords} */ breakWords: false,
    /** See {@link TextStyle.dropShadow} */ dropShadow: null,
    /**
   * See {@link TextStyle.fill}
   * @type {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
   */ fill: "black",
    /**
   * See {@link TextStyle.fontFamily}
   * @type {string|string[]}
   */ fontFamily: "Arial",
    /**
   * See {@link TextStyle.fontSize}
   * @type {number|string}
   */ fontSize: 26,
    /**
   * See {@link TextStyle.fontStyle}
   * @type {'normal'|'italic'|'oblique'}
   */ fontStyle: "normal",
    /**
   * See {@link TextStyle.fontVariant}
   * @type {'normal'|'small-caps'}
   */ fontVariant: "normal",
    /**
   * See {@link TextStyle.fontWeight}
   * @type {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */ fontWeight: "normal",
    /** See {@link TextStyle.leading} */ leading: 0,
    /** See {@link TextStyle.letterSpacing} */ letterSpacing: 0,
    /** See {@link TextStyle.lineHeight} */ lineHeight: 0,
    /** See {@link TextStyle.padding} */ padding: 0,
    /**
   * See {@link TextStyle.stroke}
   * @type {string|number}
   */ stroke: null,
    /**
   * See {@link TextStyle.textBaseline}
   * @type {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */ textBaseline: "alphabetic",
    /** See {@link TextStyle.trim} */ trim: false,
    /**
   * See {@link TextStyle.whiteSpace}
   * @type {'normal'|'pre'|'pre-line'}
   */ whiteSpace: "pre",
    /** See {@link TextStyle.wordWrap} */ wordWrap: false,
    /** See {@link TextStyle.wordWrapWidth} */ wordWrapWidth: 100
};
let $e4fd9cfa95519f91$export$1df879243bf2e42d = $e4fd9cfa95519f91$var$_TextStyle;
function $e4fd9cfa95519f91$var$convertV7Tov8Style(style) {
    const oldStyle = style;
    if (typeof oldStyle.dropShadow === "boolean" && oldStyle.dropShadow) {
        const defaults = $e4fd9cfa95519f91$export$1df879243bf2e42d.defaultDropShadow;
        style.dropShadow = {
            alpha: oldStyle.dropShadowAlpha ?? defaults.alpha,
            angle: oldStyle.dropShadowAngle ?? defaults.angle,
            blur: oldStyle.dropShadowBlur ?? defaults.blur,
            color: oldStyle.dropShadowColor ?? defaults.color,
            distance: oldStyle.dropShadowDistance ?? defaults.distance
        };
    }
    if (oldStyle.strokeThickness !== void 0) {
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "strokeThickness is now a part of stroke");
        const color = oldStyle.stroke;
        style.stroke = {
            color: color,
            width: oldStyle.strokeThickness
        };
    }
    if (Array.isArray(oldStyle.fill)) {
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "gradient fill is now a fill pattern: `new FillGradient(...)`");
        const gradientFill = new (0, $ex7ag.FillGradient)(0, 0, 0, style.fontSize * 1.7);
        const fills = oldStyle.fill.map((color)=>(0, $bEj7k.Color).shared.setValue(color).toNumber());
        fills.forEach((number, index)=>{
            const ratio = oldStyle.fillGradientStops[index] ?? index / fills.length;
            gradientFill.addColorStop(ratio, number);
        });
        style.fill = {
            fill: gradientFill
        };
    }
}

});
parcelRegister("kwtgT", function(module, exports) {

$parcel$export(module.exports, "generateTextStyleKey", () => $be1b9db84b10b0fe$export$8a3681e2b47964bb);
"use strict";
const $be1b9db84b10b0fe$var$valuesToIterateForKeys = [
    "_fontFamily",
    "_fontStyle",
    "_fontSize",
    "_fontVariant",
    "_fontWeight",
    "_breakWords",
    "_align",
    "_leading",
    "_letterSpacing",
    "_lineHeight",
    "_textBaseline",
    "_whiteSpace",
    "_wordWrap",
    "_wordWrapWidth",
    "_padding",
    "_cssOverrides",
    "_trim"
];
function $be1b9db84b10b0fe$export$8a3681e2b47964bb(style) {
    const key = [];
    let index = 0;
    for(let i = 0; i < $be1b9db84b10b0fe$var$valuesToIterateForKeys.length; i++){
        const prop = $be1b9db84b10b0fe$var$valuesToIterateForKeys[i];
        key[index++] = style[prop];
    }
    index = $be1b9db84b10b0fe$var$addFillStyleKey(style._fill, key, index);
    index = $be1b9db84b10b0fe$var$addStokeStyleKey(style._stroke, key, index);
    return key.join("-");
}
function $be1b9db84b10b0fe$var$addFillStyleKey(fillStyle, key, index) {
    if (!fillStyle) return index;
    key[index++] = fillStyle.color;
    key[index++] = fillStyle.alpha;
    key[index++] = fillStyle.fill?.uid;
    return index;
}
function $be1b9db84b10b0fe$var$addStokeStyleKey(strokeStyle, key, index) {
    if (!strokeStyle) return index;
    index = $be1b9db84b10b0fe$var$addFillStyleKey(strokeStyle, key, index);
    key[index++] = strokeStyle.width;
    key[index++] = strokeStyle.alignment;
    key[index++] = strokeStyle.cap;
    key[index++] = strokeStyle.join;
    key[index++] = strokeStyle.miterLimit;
    return index;
}

});



var $aqljF = parcelRequire("aqljF");
"use strict";

const $ee5df6e6b889b376$export$a6aad6334ef58a1c = {
    extension: {
        type: (0, $aqljF.ExtensionType).Environment,
        name: "browser",
        priority: -1
    },
    test: ()=>true,
    load: async ()=>{
        await (parcelRequire("6kAkb"));
    }
};



var $aqljF = parcelRequire("aqljF");
"use strict";

const $9bed94e4c830c831$export$ee43dd1acddf6cf8 = {
    extension: {
        type: (0, $aqljF.ExtensionType).Environment,
        name: "webworker",
        priority: 0
    },
    test: ()=>typeof self !== "undefined" && self.WorkerGlobalScope !== void 0,
    load: async ()=>{
        await (parcelRequire("8QmW1"));
    }
};



var $aqljF = parcelRequire("aqljF");
parcelRequire("e7HG4");
parcelRequire("a6zwA");












































var $aqljF = parcelRequire("aqljF");

var $aqljF = parcelRequire("aqljF");
"use strict";
const $2524538025146fd3$var$environments = [];
(0, $aqljF.extensions).handleByNamedList((0, $aqljF.ExtensionType).Environment, $2524538025146fd3$var$environments);
async function $2524538025146fd3$export$72225172dd907279(manageImports) {
    if (!manageImports) return;
    for(let i = 0; i < $2524538025146fd3$var$environments.length; i++){
        const env = $2524538025146fd3$var$environments[i];
        if (env.value.test()) {
            await env.value.load();
            return;
        }
    }
}



var $2NruG = parcelRequire("2NruG");

var $lxavo = parcelRequire("lxavo");
"use strict";
let $bfed431c9d9ae390$var$_isWebGLSupported;
function $bfed431c9d9ae390$export$83dc396b76015322(failIfMajorPerformanceCaveat) {
    if ($bfed431c9d9ae390$var$_isWebGLSupported !== void 0) return $bfed431c9d9ae390$var$_isWebGLSupported;
    $bfed431c9d9ae390$var$_isWebGLSupported = (()=>{
        const contextOptions = {
            stencil: true,
            failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat ?? (0, $lxavo.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat
        };
        try {
            if (!(0, $2NruG.DOMAdapter).get().getWebGLRenderingContext()) return false;
            const canvas = (0, $2NruG.DOMAdapter).get().createCanvas();
            let gl = canvas.getContext("webgl", contextOptions);
            const success = !!gl?.getContextAttributes()?.stencil;
            if (gl) {
                const loseContext = gl.getExtension("WEBGL_lose_context");
                if (loseContext) loseContext.loseContext();
            }
            gl = null;
            return success;
        } catch (e) {
            return false;
        }
    })();
    return $bfed431c9d9ae390$var$_isWebGLSupported;
}



var $2NruG = parcelRequire("2NruG");
"use strict";
let $9f666d462c696d80$var$_isWebGPUSupported;
async function $9f666d462c696d80$export$216169f30082c873(options = {}) {
    if ($9f666d462c696d80$var$_isWebGPUSupported !== void 0) return $9f666d462c696d80$var$_isWebGPUSupported;
    $9f666d462c696d80$var$_isWebGPUSupported = await (async ()=>{
        const gpu = (0, $2NruG.DOMAdapter).get().getNavigator().gpu;
        if (!gpu) return false;
        try {
            const adapter = await navigator.gpu.requestAdapter(options);
            await adapter.requestDevice();
            return true;
        } catch (e) {
            return false;
        }
    })();
    return $9f666d462c696d80$var$_isWebGPUSupported;
}



var $lxavo = parcelRequire("lxavo");
"use strict";
const $afe885519f392edc$var$renderPriority = [
    "webgl",
    "webgpu",
    "canvas"
];


async function $afe885519f392edc$export$3583b92ab8150eb6(options) {
    let preferredOrder = [];
    if (options.preference) {
        preferredOrder.push(options.preference);
        $afe885519f392edc$var$renderPriority.forEach((item)=>{
            if (item !== options.preference) preferredOrder.push(item);
        });
    } else preferredOrder = $afe885519f392edc$var$renderPriority.slice();
    let RendererClass;
    await (0, $2524538025146fd3$export$72225172dd907279)(options.manageImports ?? true);
    let finalOptions = {};
    for(let i = 0; i < preferredOrder.length; i++){
        const rendererType = preferredOrder[i];
        if (rendererType === "webgpu" && await (0, $9f666d462c696d80$export$216169f30082c873)()) {
            const { WebGPURenderer: WebGPURenderer } = await (parcelRequire("h8UHn"));
            RendererClass = WebGPURenderer;
            finalOptions = {
                ...options,
                ...options.webgpu
            };
            break;
        } else if (rendererType === "webgl" && (0, $bfed431c9d9ae390$export$83dc396b76015322)(options.failIfMajorPerformanceCaveat ?? (0, $lxavo.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat)) {
            const { WebGLRenderer: WebGLRenderer } = await (parcelRequire("4ZUXm"));
            RendererClass = WebGLRenderer;
            finalOptions = {
                ...options,
                ...options.webgl
            };
            break;
        } else if (rendererType === "canvas") {
            finalOptions = {
                ...options
            };
            throw new Error("CanvasRenderer is not yet implemented");
        }
    }
    delete finalOptions.webgpu;
    delete finalOptions.webgl;
    if (!RendererClass) throw new Error("No available renderer for the current environment");
    const renderer = new RendererClass();
    await renderer.init(finalOptions);
    return renderer;
}



var $e0Ilp = parcelRequire("e0Ilp");

var $j0fPb = parcelRequire("j0fPb");
"use strict";
const $3b122057363041d2$var$_Application = class _Application {
    /** @ignore */ constructor(...args){
        /** The root display container that's rendered. */ this.stage = new (0, $e0Ilp.Container)();
        if (args[0] !== void 0) (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "Application constructor options are deprecated, please use Application.init() instead.");
    }
    /**
   * @param options - The optional application and renderer parameters.
   */ async init(options) {
        options = {
            ...options
        };
        this.renderer = await (0, $afe885519f392edc$export$3583b92ab8150eb6)(options);
        _Application._plugins.forEach((plugin)=>{
            plugin.init.call(this, options);
        });
    }
    /** Render the current stage. */ render() {
        this.renderer.render({
            container: this.stage
        });
    }
    /**
   * Reference to the renderer's canvas element.
   * @readonly
   * @member {HTMLCanvasElement}
   */ get canvas() {
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's canvas element.
   * @member {HTMLCanvasElement}
   * @deprecated since 8.0.0
   */ get view() {
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "Application.view is deprecated, please use Application.canvas instead.");
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's screen rectangle. Its safe to use as `filterArea` or `hitArea` for the whole screen.
   * @readonly
   */ get screen() {
        return this.renderer.screen;
    }
    /**
   * Destroys the application and all of its resources.
   * @param {object|boolean}[rendererDestroyOptions=false] - The options for destroying the renderer.
   * @param {boolean}[rendererDestroyOptions.removeView=false] - Removes the Canvas element from the DOM.
   * @param {object|boolean} [options=false] - The options for destroying the stage.
   * @param {boolean} [options.children=false] - If set to true, all the children will have their destroy method
   * called as well. `options` will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for children with textures e.g. Sprites.
   * If options.children is set to true,
   * it should destroy the texture of the child sprite.
   * @param {boolean} [options.textureSource=false] - Only used for children with textures e.g. Sprites.
   *  If options.children is set to true,
   * it should destroy the texture source of the child sprite.
   * @param {boolean} [options.context=false] - Only used for children with graphicsContexts e.g. Graphics.
   * If options.children is set to true,
   * it should destroy the context of the child graphics.
   */ destroy(rendererDestroyOptions = false, options = false) {
        const plugins = _Application._plugins.slice(0);
        plugins.reverse();
        plugins.forEach((plugin)=>{
            plugin.destroy.call(this);
        });
        this.stage.destroy(options);
        this.stage = null;
        this.renderer.destroy(rendererDestroyOptions);
        this.renderer = null;
    }
};
/**
 * Collection of installed plugins.
 * @alias _plugins
 */ $3b122057363041d2$var$_Application._plugins = [];
let $3b122057363041d2$export$16975c34e60e1e61 = $3b122057363041d2$var$_Application;
(0, $aqljF.extensions).handleByList((0, $aqljF.ExtensionType).Application, $3b122057363041d2$export$16975c34e60e1e61._plugins);





var $aqljF = parcelRequire("aqljF");

var $1q6Bk = parcelRequire("1q6Bk");
"use strict";
class $5cd28b403b84f142$export$1949379a83b843d5 {
    /**
   * @param loader
   * @param verbose - should the loader log to the console
   */ constructor(loader, verbose = false){
        this._loader = loader;
        this._assetList = [];
        this._isLoading = false;
        this._maxConcurrent = 1;
        this.verbose = verbose;
    }
    /**
   * Adds an array of assets to load.
   * @param assetUrls - assets to load
   */ add(assetUrls) {
        assetUrls.forEach((a)=>{
            this._assetList.push(a);
        });
        if (this.verbose) console.log("[BackgroundLoader] assets: ", this._assetList);
        if (this._isActive && !this._isLoading) this._next();
    }
    /**
   * Loads the next set of assets. Will try to load as many assets as it can at the same time.
   *
   * The max assets it will try to load at one time will be 4.
   */ async _next() {
        if (this._assetList.length && this._isActive) {
            this._isLoading = true;
            const toLoad = [];
            const toLoadAmount = Math.min(this._assetList.length, this._maxConcurrent);
            for(let i = 0; i < toLoadAmount; i++)toLoad.push(this._assetList.pop());
            await this._loader.load(toLoad);
            this._isLoading = false;
            this._next();
        }
    }
    /**
   * Activate/Deactivate the loading. If set to true then it will immediately continue to load the next asset.
   * @returns whether the class is active
   */ get active() {
        return this._isActive;
    }
    set active(value) {
        if (this._isActive === value) return;
        this._isActive = value;
        if (value && !this._isLoading) this._next();
    }
}



var $1qKFs = parcelRequire("1qKFs");

var $aqljF = parcelRequire("aqljF");

var $jollT = parcelRequire("jollT");
"use strict";
const $b1463a9683eb98cd$export$407b4625a915919d = {
    extension: (0, $aqljF.ExtensionType).CacheParser,
    test: (asset)=>Array.isArray(asset) && asset.every((t)=>t instanceof (0, $jollT.Texture)),
    getCacheableAssets: (keys, asset)=>{
        const out = {};
        keys.forEach((key)=>{
            asset.forEach((item, i)=>{
                out[key + (i === 0 ? "" : i + 1)] = item;
            });
        });
        return out;
    }
};



var $aqljF = parcelRequire("aqljF");
"use strict";
async function $4ba1729d60af6dea$export$7c459e568e7cea2c(imageData) {
    if ("Image" in globalThis) return new Promise((resolve)=>{
        const image = new Image();
        image.onload = ()=>{
            resolve(true);
        };
        image.onerror = ()=>{
            resolve(false);
        };
        image.src = imageData;
    });
    if ("createImageBitmap" in globalThis && "fetch" in globalThis) {
        try {
            const blob = await (await fetch(imageData)).blob();
            await createImageBitmap(blob);
        } catch (e) {
            return false;
        }
        return true;
    }
    return false;
}


"use strict";
const $729469a82d74b6d7$export$a60d2d4a3c570783 = {
    extension: {
        type: (0, $aqljF.ExtensionType).DetectionParser,
        priority: 1
    },
    test: async ()=>(0, $4ba1729d60af6dea$export$7c459e568e7cea2c)(// eslint-disable-next-line max-len
        "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A="),
    add: async (formats)=>[
            ...formats,
            "avif"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "avif")
};



var $aqljF = parcelRequire("aqljF");
"use strict";
const $35fa9d1f38b94970$var$imageFormats = [
    "png",
    "jpg",
    "jpeg"
];
const $35fa9d1f38b94970$export$b106d7c2de3b4d89 = {
    extension: {
        type: (0, $aqljF.ExtensionType).DetectionParser,
        priority: -1
    },
    test: ()=>Promise.resolve(true),
    add: async (formats)=>[
            ...formats,
            ...$35fa9d1f38b94970$var$imageFormats
        ],
    remove: async (formats)=>formats.filter((f)=>!$35fa9d1f38b94970$var$imageFormats.includes(f))
};



var $aqljF = parcelRequire("aqljF");
"use strict";
const $465d97873c7b2797$var$inWorker = "WorkerGlobalScope" in globalThis && globalThis instanceof globalThis.WorkerGlobalScope;
function $465d97873c7b2797$export$7a571c147b03abb1(mimeType) {
    if ($465d97873c7b2797$var$inWorker) return false;
    const video = document.createElement("video");
    return video.canPlayType(mimeType) !== "";
}


"use strict";
const $9e91d7343c879e67$export$7726d83fee274e25 = {
    extension: {
        type: (0, $aqljF.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $465d97873c7b2797$export$7a571c147b03abb1)("video/mp4"),
    add: async (formats)=>[
            ...formats,
            "mp4",
            "m4v"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "mp4" && f !== "m4v")
};



var $aqljF = parcelRequire("aqljF");

"use strict";
const $7a5d45498b3ec8cc$export$5a1da481121f806a = {
    extension: {
        type: (0, $aqljF.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $465d97873c7b2797$export$7a571c147b03abb1)("video/ogg"),
    add: async (formats)=>[
            ...formats,
            "ogv"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "ogv")
};



var $aqljF = parcelRequire("aqljF");

"use strict";
const $59ea8cd7ecc773db$export$a041d698a1896657 = {
    extension: {
        type: (0, $aqljF.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $465d97873c7b2797$export$7a571c147b03abb1)("video/webm"),
    add: async (formats)=>[
            ...formats,
            "webm"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webm")
};



var $aqljF = parcelRequire("aqljF");

"use strict";
const $ec57032a4727e7bb$export$d19529a9ed9823d4 = {
    extension: {
        type: (0, $aqljF.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $4ba1729d60af6dea$export$7c459e568e7cea2c)("data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA="),
    add: async (formats)=>[
            ...formats,
            "webp"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webp")
};



var $1q6Bk = parcelRequire("1q6Bk");

var $6sETp = parcelRequire("6sETp");

var $8o3Sc = parcelRequire("8o3Sc");

var $b9HvA = parcelRequire("b9HvA");
"use strict";
class $858870214708d158$export$3b0d6d7590275603 {
    constructor(){
        this._parsers = [];
        this._parsersValidated = false;
        /**
     * All loader parsers registered
     * @type {assets.LoaderParser[]}
     */ this.parsers = new Proxy(this._parsers, {
            set: (target, key, value)=>{
                this._parsersValidated = false;
                target[key] = value;
                return true;
            }
        });
        /** Cache loading promises that ae currently active */ this.promiseCache = {};
    }
    /** function used for testing */ reset() {
        this._parsersValidated = false;
        this.promiseCache = {};
    }
    /**
   * Used internally to generate a promise for the asset to be loaded.
   * @param url - The URL to be loaded
   * @param data - any custom additional information relevant to the asset being loaded
   * @returns - a promise that will resolve to an Asset for example a Texture of a JSON object
   */ _getLoadPromiseAndParser(url, data) {
        const result = {
            promise: null,
            parser: null
        };
        result.promise = (async ()=>{
            let asset = null;
            let parser = null;
            if (data.loadParser) {
                parser = this._parserHash[data.loadParser];
                if (!parser) (0, $1q6Bk.warn)(`[Assets] specified load parser "${data.loadParser}" not found while loading ${url}`);
            }
            if (!parser) {
                for(let i = 0; i < this.parsers.length; i++){
                    const parserX = this.parsers[i];
                    if (parserX.load && parserX.test?.(url, data, this)) {
                        parser = parserX;
                        break;
                    }
                }
                if (!parser) {
                    (0, $1q6Bk.warn)(`[Assets] ${url} could not be loaded as we don't know how to parse it, ensure the correct parser has been added`);
                    return null;
                }
            }
            asset = await parser.load(url, data, this);
            result.parser = parser;
            for(let i = 0; i < this.parsers.length; i++){
                const parser2 = this.parsers[i];
                if (parser2.parse) {
                    if (parser2.parse && await parser2.testParse?.(asset, data, this)) {
                        asset = await parser2.parse(asset, data, this) || asset;
                        result.parser = parser2;
                    }
                }
            }
            return asset;
        })();
        return result;
    }
    async load(assetsToLoadIn, onProgress) {
        if (!this._parsersValidated) this._validateParsers();
        let count = 0;
        const assets = {};
        const singleAsset = (0, $b9HvA.isSingleItem)(assetsToLoadIn);
        const assetsToLoad = (0, $8o3Sc.convertToList)(assetsToLoadIn, (item)=>({
                alias: [
                    item
                ],
                src: item
            }));
        const total = assetsToLoad.length;
        const promises = assetsToLoad.map(async (asset)=>{
            const url = (0, $6sETp.path).toAbsolute(asset.src);
            if (!assets[asset.src]) try {
                if (!this.promiseCache[url]) this.promiseCache[url] = this._getLoadPromiseAndParser(url, asset);
                assets[asset.src] = await this.promiseCache[url].promise;
                if (onProgress) onProgress(++count / total);
            } catch (e) {
                delete this.promiseCache[url];
                delete assets[asset.src];
                throw new Error(`[Loader.load] Failed to load ${url}.
${e}`);
            }
        });
        await Promise.all(promises);
        return singleAsset ? assets[assetsToLoad[0].src] : assets;
    }
    /**
   * Unloads one or more assets. Any unloaded assets will be destroyed, freeing up memory for your app.
   * The parser that created the asset, will be the one that unloads it.
   * @example
   * // Single asset:
   * const asset = await Loader.load('cool.png');
   *
   * await Loader.unload('cool.png');
   *
   * console.log(asset.destroyed); // true
   * @param assetsToUnloadIn - urls that you want to unload, or a single one!
   */ async unload(assetsToUnloadIn) {
        const assetsToUnload = (0, $8o3Sc.convertToList)(assetsToUnloadIn, (item)=>({
                alias: [
                    item
                ],
                src: item
            }));
        const promises = assetsToUnload.map(async (asset)=>{
            const url = (0, $6sETp.path).toAbsolute(asset.src);
            const loadPromise = this.promiseCache[url];
            if (loadPromise) {
                const loadedAsset = await loadPromise.promise;
                delete this.promiseCache[url];
                await loadPromise.parser?.unload?.(loadedAsset, asset, this);
            }
        });
        await Promise.all(promises);
    }
    /** validates our parsers, right now it only checks for name conflicts but we can add more here as required! */ _validateParsers() {
        this._parsersValidated = true;
        this._parserHash = this._parsers.filter((parser)=>parser.name).reduce((hash, parser)=>{
            if (!parser.name) (0, $1q6Bk.warn)(`[Assets] loadParser should have a name`);
            else if (hash[parser.name]) (0, $1q6Bk.warn)(`[Assets] loadParser name conflict "${parser.name}"`);
            return {
                ...hash,
                [parser.name]: parser
            };
        }, {});
    }
}



var $2NruG = parcelRequire("2NruG");

var $aqljF = parcelRequire("aqljF");
"use strict";
function $82e938273b896ff4$export$7ff8b059fb914323(url, mimes) {
    if (Array.isArray(mimes)) {
        for (const mime of mimes){
            if (url.startsWith(`data:${mime}`)) return true;
        }
        return false;
    }
    return url.startsWith(`data:${mimes}`);
}



var $6sETp = parcelRequire("6sETp");
"use strict";
function $3a97b39dc579b836$export$fd0180357b95b812(url, extension) {
    const tempURL = url.split("?")[0];
    const ext = (0, $6sETp.path).extname(tempURL).toLowerCase();
    if (Array.isArray(extension)) return extension.includes(ext);
    return ext === extension;
}



var $9uHEw = parcelRequire("9uHEw");
"use strict";
const $2a7a5de38413f9af$var$validJSONExtension = ".json";
const $2a7a5de38413f9af$var$validJSONMIME = "application/json";
const $2a7a5de38413f9af$export$e7c8553478f3aac7 = {
    extension: {
        type: (0, $aqljF.ExtensionType).LoadParser,
        priority: (0, $9uHEw.LoaderParserPriority).Low
    },
    name: "loadJson",
    test (url) {
        return (0, $82e938273b896ff4$export$7ff8b059fb914323)(url, $2a7a5de38413f9af$var$validJSONMIME) || (0, $3a97b39dc579b836$export$fd0180357b95b812)(url, $2a7a5de38413f9af$var$validJSONExtension);
    },
    async load (url) {
        const response = await (0, $2NruG.DOMAdapter).get().fetch(url);
        const json = await response.json();
        return json;
    }
};



var $2NruG = parcelRequire("2NruG");

var $aqljF = parcelRequire("aqljF");



var $9uHEw = parcelRequire("9uHEw");
"use strict";
const $c4f76552ca31f72e$var$validTXTExtension = ".txt";
const $c4f76552ca31f72e$var$validTXTMIME = "text/plain";
const $c4f76552ca31f72e$export$3835b7ee6dbebde8 = {
    name: "loadTxt",
    extension: {
        type: (0, $aqljF.ExtensionType).LoadParser,
        priority: (0, $9uHEw.LoaderParserPriority).Low
    },
    test (url) {
        return (0, $82e938273b896ff4$export$7ff8b059fb914323)(url, $c4f76552ca31f72e$var$validTXTMIME) || (0, $3a97b39dc579b836$export$fd0180357b95b812)(url, $c4f76552ca31f72e$var$validTXTExtension);
    },
    async load (url) {
        const response = await (0, $2NruG.DOMAdapter).get().fetch(url);
        const txt = await response.text();
        return txt;
    }
};



var $2NruG = parcelRequire("2NruG");

var $aqljF = parcelRequire("aqljF");

var $1q6Bk = parcelRequire("1q6Bk");

var $6sETp = parcelRequire("6sETp");

var $1qKFs = parcelRequire("1qKFs");



var $9uHEw = parcelRequire("9uHEw");
"use strict";
const $01ea2d0d4a3535e2$var$validWeights = [
    "normal",
    "bold",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900"
];
const $01ea2d0d4a3535e2$var$validFontExtensions = [
    ".ttf",
    ".otf",
    ".woff",
    ".woff2"
];
const $01ea2d0d4a3535e2$var$validFontMIMEs = [
    "font/ttf",
    "font/otf",
    "font/woff",
    "font/woff2"
];
const $01ea2d0d4a3535e2$var$CSS_IDENT_TOKEN_REGEX = /^(--|-?[A-Z_])[0-9A-Z_-]*$/i;
function $01ea2d0d4a3535e2$export$c461ca8f39d93d9b(url) {
    const ext = (0, $6sETp.path).extname(url);
    const name = (0, $6sETp.path).basename(url, ext);
    const nameWithSpaces = name.replace(/(-|_)/g, " ");
    const nameTokens = nameWithSpaces.toLowerCase().split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1));
    let valid = nameTokens.length > 0;
    for (const token of nameTokens)if (!token.match($01ea2d0d4a3535e2$var$CSS_IDENT_TOKEN_REGEX)) {
        valid = false;
        break;
    }
    let fontFamilyName = nameTokens.join(" ");
    if (!valid) fontFamilyName = `"${fontFamilyName.replace(/[\\"]/g, "\\$&")}"`;
    return fontFamilyName;
}
const $01ea2d0d4a3535e2$var$validURICharactersRegex = /^[0-9A-Za-z%:/?#\[\]@!\$&'()\*\+,;=\-._~]*$/;
function $01ea2d0d4a3535e2$var$encodeURIWhenNeeded(uri) {
    if ($01ea2d0d4a3535e2$var$validURICharactersRegex.test(uri)) return uri;
    return encodeURI(uri);
}
const $01ea2d0d4a3535e2$export$129ed93ad26b0298 = {
    extension: {
        type: (0, $aqljF.ExtensionType).LoadParser,
        priority: (0, $9uHEw.LoaderParserPriority).Low
    },
    name: "loadWebFont",
    test (url) {
        return (0, $82e938273b896ff4$export$7ff8b059fb914323)(url, $01ea2d0d4a3535e2$var$validFontMIMEs) || (0, $3a97b39dc579b836$export$fd0180357b95b812)(url, $01ea2d0d4a3535e2$var$validFontExtensions);
    },
    async load (url, options) {
        const fonts = (0, $2NruG.DOMAdapter).get().getFontFaceSet();
        if (fonts) {
            const fontFaces = [];
            const name = options.data?.family ?? $01ea2d0d4a3535e2$export$c461ca8f39d93d9b(url);
            const weights = options.data?.weights?.filter((weight)=>$01ea2d0d4a3535e2$var$validWeights.includes(weight)) ?? [
                "normal"
            ];
            const data = options.data ?? {};
            for(let i = 0; i < weights.length; i++){
                const weight = weights[i];
                const font = new FontFace(name, `url(${$01ea2d0d4a3535e2$var$encodeURIWhenNeeded(url)})`, {
                    ...data,
                    weight: weight
                });
                await font.load();
                fonts.add(font);
                fontFaces.push(font);
            }
            (0, $1qKFs.Cache).set(`${name}-and-url`, {
                url: url,
                fontFaces: fontFaces
            });
            return fontFaces.length === 1 ? fontFaces[0] : fontFaces;
        }
        (0, $1q6Bk.warn)("[loadWebFont] FontFace API is not supported. Skipping loading font");
        return null;
    },
    unload (font) {
        (Array.isArray(font) ? font : [
            font
        ]).forEach((t)=>{
            (0, $1qKFs.Cache).remove(t.family);
            (0, $2NruG.DOMAdapter).get().getFontFaceSet().delete(t);
        });
    }
};



var $2NruG = parcelRequire("2NruG");

var $aqljF = parcelRequire("aqljF");

var $5yirD = parcelRequire("5yirD");

var $gMeQx = parcelRequire("gMeQx");

var $6yskn = parcelRequire("6yskn");
"use strict";
function $44660c1a4952186b$export$8695ab2f322d2637(url, defaultValue = 1) {
    const resolution = (0, $6yskn.Resolver).RETINA_PREFIX?.exec(url);
    if (resolution) return parseFloat(resolution[1]);
    return defaultValue;
}





var $9uHEw = parcelRequire("9uHEw");

var $jollT = parcelRequire("jollT");

var $1q6Bk = parcelRequire("1q6Bk");

var $1qKFs = parcelRequire("1qKFs");
"use strict";
function $e19c5c9173423bb8$export$37b981a8c575f415(source, loader, url) {
    source.label = url;
    source._sourceOrigin = url;
    const texture = new (0, $jollT.Texture)({
        source: source,
        label: url
    });
    const unload = ()=>{
        delete loader.promiseCache[url];
        if ((0, $1qKFs.Cache).has(url)) (0, $1qKFs.Cache).remove(url);
    };
    texture.source.once("destroy", ()=>{
        if (loader.promiseCache[url]) {
            (0, $1q6Bk.warn)("[Assets] A TextureSource managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the TextureSource.");
            unload();
        }
    });
    texture.once("destroy", ()=>{
        if (!source.destroyed) {
            (0, $1q6Bk.warn)("[Assets] A Texture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the Texture.");
            unload();
        }
    });
    return texture;
}


"use strict";
const $e70fdc4b333909e4$var$validSVGExtension = ".svg";
const $e70fdc4b333909e4$var$validSVGMIME = "image/svg+xml";
const $e70fdc4b333909e4$export$b6a2e78b63791dfa = {
    extension: {
        type: (0, $aqljF.ExtensionType).LoadParser,
        priority: (0, $9uHEw.LoaderParserPriority).Low
    },
    name: "loadSVG",
    config: {
        crossOrigin: "anonymous",
        parseAsGraphicsContext: false
    },
    test (url) {
        return (0, $82e938273b896ff4$export$7ff8b059fb914323)(url, $e70fdc4b333909e4$var$validSVGMIME) || (0, $3a97b39dc579b836$export$fd0180357b95b812)(url, $e70fdc4b333909e4$var$validSVGExtension);
    },
    async load (url, asset, loader) {
        if (asset.data.parseAsGraphicsContext ?? this.config.parseAsGraphicsContext) return $e70fdc4b333909e4$var$loadAsGraphics(url);
        return $e70fdc4b333909e4$var$loadAsTexture(url, asset, loader, this.config.crossOrigin);
    },
    unload (asset) {
        asset.destroy(true);
    }
};
async function $e70fdc4b333909e4$var$loadAsTexture(url, asset, loader, crossOrigin) {
    const response = await (0, $2NruG.DOMAdapter).get().fetch(url);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const image = new Image();
    image.src = blobUrl;
    image.crossOrigin = crossOrigin;
    await image.decode();
    URL.revokeObjectURL(blobUrl);
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const resolution = asset.data?.resolution || (0, $44660c1a4952186b$export$8695ab2f322d2637)(url);
    const width = asset.data?.width ?? image.width;
    const height = asset.data?.height ?? image.height;
    canvas.width = width * resolution;
    canvas.height = height * resolution;
    context.drawImage(image, 0, 0, width * resolution, height * resolution);
    const { parseAsGraphicsContext: _p, ...rest } = asset.data;
    const base = new (0, $5yirD.ImageSource)({
        resource: canvas,
        alphaMode: "premultiply-alpha-on-upload",
        resolution: resolution,
        ...rest
    });
    return (0, $e19c5c9173423bb8$export$37b981a8c575f415)(base, loader, url);
}
async function $e70fdc4b333909e4$var$loadAsGraphics(url) {
    const response = await (0, $2NruG.DOMAdapter).get().fetch(url);
    const svgSource = await response.text();
    const context = new (0, $gMeQx.GraphicsContext)();
    context.svg(svgSource);
    return context;
}



var $2NruG = parcelRequire("2NruG");

var $aqljF = parcelRequire("aqljF");

var $5yirD = parcelRequire("5yirD");



const $8264f3c9c63016ae$var$WORKER_CODE = '(function () {\n    \'use strict\';\n\n    const WHITE_PNG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=";\n    async function checkImageBitmap() {\n      try {\n        if (typeof createImageBitmap !== "function")\n          return false;\n        const response = await fetch(WHITE_PNG);\n        const imageBlob = await response.blob();\n        const imageBitmap = await createImageBitmap(imageBlob);\n        return imageBitmap.width === 1 && imageBitmap.height === 1;\n      } catch (e) {\n        return false;\n      }\n    }\n    void checkImageBitmap().then((result) => {\n      self.postMessage(result);\n    });\n\n})();\n';
let $8264f3c9c63016ae$var$WORKER_URL = null;
class $8264f3c9c63016ae$export$2e2bcd8739ae039 {
    constructor(){
        if (!$8264f3c9c63016ae$var$WORKER_URL) $8264f3c9c63016ae$var$WORKER_URL = URL.createObjectURL(new Blob([
            $8264f3c9c63016ae$var$WORKER_CODE
        ], {
            type: "application/javascript"
        }));
        this.worker = new Worker($8264f3c9c63016ae$var$WORKER_URL);
    }
}
$8264f3c9c63016ae$export$2e2bcd8739ae039.revokeObjectURL = function revokeObjectURL() {
    if ($8264f3c9c63016ae$var$WORKER_URL) {
        URL.revokeObjectURL($8264f3c9c63016ae$var$WORKER_URL);
        $8264f3c9c63016ae$var$WORKER_URL = null;
    }
};


const $bca7ee3a281f8705$var$WORKER_CODE = "(function () {\n    'use strict';\n\n    async function loadImageBitmap(url) {\n      const response = await fetch(url);\n      if (!response.ok) {\n        throw new Error(`[WorkerManager.loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);\n      }\n      const imageBlob = await response.blob();\n      const imageBitmap = await createImageBitmap(imageBlob);\n      return imageBitmap;\n    }\n    self.onmessage = async (event) => {\n      try {\n        const imageBitmap = await loadImageBitmap(event.data.data[0]);\n        self.postMessage({\n          data: imageBitmap,\n          uuid: event.data.uuid,\n          id: event.data.id\n        }, [imageBitmap]);\n      } catch (e) {\n        self.postMessage({\n          error: e,\n          uuid: event.data.uuid,\n          id: event.data.id\n        });\n      }\n    };\n\n})();\n";
let $bca7ee3a281f8705$var$WORKER_URL = null;
class $bca7ee3a281f8705$export$2e2bcd8739ae039 {
    constructor(){
        if (!$bca7ee3a281f8705$var$WORKER_URL) $bca7ee3a281f8705$var$WORKER_URL = URL.createObjectURL(new Blob([
            $bca7ee3a281f8705$var$WORKER_CODE
        ], {
            type: "application/javascript"
        }));
        this.worker = new Worker($bca7ee3a281f8705$var$WORKER_URL);
    }
}
$bca7ee3a281f8705$export$2e2bcd8739ae039.revokeObjectURL = function revokeObjectURL() {
    if ($bca7ee3a281f8705$var$WORKER_URL) {
        URL.revokeObjectURL($bca7ee3a281f8705$var$WORKER_URL);
        $bca7ee3a281f8705$var$WORKER_URL = null;
    }
};


"use strict";
let $bd0808bb8d666cbe$var$UUID = 0;
let $bd0808bb8d666cbe$var$MAX_WORKERS;
class $bd0808bb8d666cbe$var$WorkerManagerClass {
    constructor(){
        this._initialized = false;
        this._createdWorkers = 0;
        this._workerPool = [];
        this._queue = [];
        this._resolveHash = {};
    }
    isImageBitmapSupported() {
        if (this._isImageBitmapSupported !== void 0) return this._isImageBitmapSupported;
        this._isImageBitmapSupported = new Promise((resolve)=>{
            const { worker: worker } = new (0, $8264f3c9c63016ae$export$2e2bcd8739ae039)();
            worker.addEventListener("message", (event)=>{
                worker.terminate();
                (0, $8264f3c9c63016ae$export$2e2bcd8739ae039).revokeObjectURL();
                resolve(event.data);
            });
        });
        return this._isImageBitmapSupported;
    }
    loadImageBitmap(src) {
        return this._run("loadImageBitmap", [
            src
        ]);
    }
    async _initWorkers() {
        if (this._initialized) return;
        this._initialized = true;
    }
    _getWorker() {
        if ($bd0808bb8d666cbe$var$MAX_WORKERS === void 0) $bd0808bb8d666cbe$var$MAX_WORKERS = navigator.hardwareConcurrency || 4;
        let worker = this._workerPool.pop();
        if (!worker && this._createdWorkers < $bd0808bb8d666cbe$var$MAX_WORKERS) {
            this._createdWorkers++;
            worker = new (0, $bca7ee3a281f8705$export$2e2bcd8739ae039)().worker;
            worker.addEventListener("message", (event)=>{
                this._complete(event.data);
                this._returnWorker(event.target);
                this._next();
            });
        }
        return worker;
    }
    _returnWorker(worker) {
        this._workerPool.push(worker);
    }
    _complete(data) {
        if (data.error !== void 0) this._resolveHash[data.uuid].reject(data.error);
        else this._resolveHash[data.uuid].resolve(data.data);
        this._resolveHash[data.uuid] = null;
    }
    async _run(id, args) {
        await this._initWorkers();
        const promise = new Promise((resolve, reject)=>{
            this._queue.push({
                id: id,
                arguments: args,
                resolve: resolve,
                reject: reject
            });
        });
        this._next();
        return promise;
    }
    _next() {
        if (!this._queue.length) return;
        const worker = this._getWorker();
        if (!worker) return;
        const toDo = this._queue.pop();
        const id = toDo.id;
        this._resolveHash[$bd0808bb8d666cbe$var$UUID] = {
            resolve: toDo.resolve,
            reject: toDo.reject
        };
        worker.postMessage({
            data: toDo.arguments,
            uuid: $bd0808bb8d666cbe$var$UUID++,
            id: id
        });
    }
}
const $bd0808bb8d666cbe$export$bcff6015853c67ce = new $bd0808bb8d666cbe$var$WorkerManagerClass();



var $9uHEw = parcelRequire("9uHEw");

"use strict";
const $481574dd5d7605df$var$validImageExtensions = [
    ".jpeg",
    ".jpg",
    ".png",
    ".webp",
    ".avif"
];
const $481574dd5d7605df$var$validImageMIMEs = [
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/avif"
];
async function $481574dd5d7605df$export$c614e6247302006d(url) {
    const response = await (0, $2NruG.DOMAdapter).get().fetch(url);
    if (!response.ok) throw new Error(`[loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);
    const imageBlob = await response.blob();
    const imageBitmap = await createImageBitmap(imageBlob);
    return imageBitmap;
}
const $481574dd5d7605df$export$897b113ee8307cd0 = {
    name: "loadTextures",
    extension: {
        type: (0, $aqljF.ExtensionType).LoadParser,
        priority: (0, $9uHEw.LoaderParserPriority).High
    },
    config: {
        preferWorkers: true,
        preferCreateImageBitmap: true,
        crossOrigin: "anonymous"
    },
    test (url) {
        return (0, $82e938273b896ff4$export$7ff8b059fb914323)(url, $481574dd5d7605df$var$validImageMIMEs) || (0, $3a97b39dc579b836$export$fd0180357b95b812)(url, $481574dd5d7605df$var$validImageExtensions);
    },
    async load (url, asset, loader) {
        let src = null;
        if (globalThis.createImageBitmap && this.config.preferCreateImageBitmap) {
            if (this.config.preferWorkers && await (0, $bd0808bb8d666cbe$export$bcff6015853c67ce).isImageBitmapSupported()) src = await (0, $bd0808bb8d666cbe$export$bcff6015853c67ce).loadImageBitmap(url);
            else src = await $481574dd5d7605df$export$c614e6247302006d(url);
        } else src = await new Promise((resolve)=>{
            src = new Image();
            src.crossOrigin = this.config.crossOrigin;
            src.src = url;
            if (src.complete) resolve(src);
            else src.onload = ()=>{
                resolve(src);
            };
        });
        const base = new (0, $5yirD.ImageSource)({
            resource: src,
            alphaMode: "premultiply-alpha-on-upload",
            resolution: asset.data?.resolution || (0, $44660c1a4952186b$export$8695ab2f322d2637)(url),
            ...asset.data
        });
        return (0, $e19c5c9173423bb8$export$37b981a8c575f415)(base, loader, url);
    },
    unload (texture) {
        texture.destroy(true);
    }
};



var $aqljF = parcelRequire("aqljF");

var $9yTSr = parcelRequire("9yTSr");

var $6SWkW = parcelRequire("6SWkW");




"use strict";
const $4394dcba514907d5$var$validVideoExtensions = [
    ".mp4",
    ".m4v",
    ".webm",
    ".ogg",
    ".ogv",
    ".h264",
    ".avi",
    ".mov"
];
const $4394dcba514907d5$var$validVideoMIMEs = $4394dcba514907d5$var$validVideoExtensions.map((ext)=>`video/${ext.substring(1)}`);
function $4394dcba514907d5$export$c47cb7c63271266e(element, url, crossorigin) {
    if (crossorigin === void 0 && !url.startsWith("data:")) element.crossOrigin = $4394dcba514907d5$export$292083da55c5b406(url);
    else if (crossorigin !== false) element.crossOrigin = typeof crossorigin === "string" ? crossorigin : "anonymous";
}
function $4394dcba514907d5$export$856bfbe81968ff62(element) {
    return new Promise((resolve, reject)=>{
        element.addEventListener("canplaythrough", loaded);
        element.addEventListener("error", error);
        element.load();
        function loaded() {
            cleanup();
            resolve();
        }
        function error(err) {
            cleanup();
            reject(err);
        }
        function cleanup() {
            element.removeEventListener("canplaythrough", loaded);
            element.removeEventListener("error", error);
        }
    });
}
function $4394dcba514907d5$export$292083da55c5b406(url, loc = globalThis.location) {
    if (url.startsWith("data:")) return "";
    loc = loc || globalThis.location;
    const parsedUrl = new URL(url, document.baseURI);
    if (parsedUrl.hostname !== loc.hostname || parsedUrl.port !== loc.port || parsedUrl.protocol !== loc.protocol) return "anonymous";
    return "";
}
const $4394dcba514907d5$export$68fa0976ba667d63 = {
    name: "loadVideo",
    extension: {
        type: (0, $aqljF.ExtensionType).LoadParser
    },
    config: null,
    test (url) {
        const isValidDataUrl = (0, $82e938273b896ff4$export$7ff8b059fb914323)(url, $4394dcba514907d5$var$validVideoMIMEs);
        const isValidExtension = (0, $3a97b39dc579b836$export$fd0180357b95b812)(url, $4394dcba514907d5$var$validVideoExtensions);
        return isValidDataUrl || isValidExtension;
    },
    async load (url, asset, loader) {
        const options = {
            ...(0, $9yTSr.VideoSource).defaultOptions,
            resolution: asset.data?.resolution || (0, $44660c1a4952186b$export$8695ab2f322d2637)(url),
            alphaMode: asset.data?.alphaMode || await (0, $6SWkW.detectVideoAlphaMode)(),
            ...asset.data
        };
        const videoElement = document.createElement("video");
        const attributeMap = {
            preload: options.autoLoad !== false ? "auto" : void 0,
            "webkit-playsinline": options.playsinline !== false ? "" : void 0,
            playsinline: options.playsinline !== false ? "" : void 0,
            muted: options.muted === true ? "" : void 0,
            loop: options.loop === true ? "" : void 0,
            autoplay: options.autoPlay !== false ? "" : void 0
        };
        Object.keys(attributeMap).forEach((key)=>{
            const value = attributeMap[key];
            if (value !== void 0) videoElement.setAttribute(key, value);
        });
        if (options.muted === true) videoElement.muted = true;
        $4394dcba514907d5$export$c47cb7c63271266e(videoElement, url, options.crossorigin);
        const sourceElement = document.createElement("source");
        let mime;
        if (url.startsWith("data:")) mime = url.slice(5, url.indexOf(";"));
        else if (!url.startsWith("blob:")) {
            const ext = url.split("?")[0].slice(url.lastIndexOf(".") + 1).toLowerCase();
            mime = (0, $9yTSr.VideoSource).MIME_TYPES[ext] || `video/${ext}`;
        }
        sourceElement.src = url;
        if (mime) sourceElement.type = mime;
        return new Promise((resolve)=>{
            const onCanPlay = async ()=>{
                const base = new (0, $9yTSr.VideoSource)({
                    ...options,
                    resource: videoElement
                });
                videoElement.removeEventListener("canplay", onCanPlay);
                if (asset.data.preload) await $4394dcba514907d5$export$856bfbe81968ff62(videoElement);
                resolve((0, $e19c5c9173423bb8$export$37b981a8c575f415)(base, loader, url));
            };
            videoElement.addEventListener("canplay", onCanPlay);
            videoElement.appendChild(sourceElement);
        });
    },
    unload (texture) {
        texture.destroy(true);
    }
};



var $aqljF = parcelRequire("aqljF");

var $6yskn = parcelRequire("6yskn");

var $aqljF = parcelRequire("aqljF");


var $6yskn = parcelRequire("6yskn");
"use strict";
const $9589914ca0c3b07b$export$cc356fa83de02bea = {
    extension: (0, $aqljF.ExtensionType).ResolveParser,
    test: (0, $481574dd5d7605df$export$897b113ee8307cd0).test,
    parse: (value)=>({
            resolution: parseFloat((0, $6yskn.Resolver).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
            format: value.split(".").pop(),
            src: value
        })
};


"use strict";
const $94190cea3125d913$export$2b5cca0b89cb089c = {
    extension: (0, $aqljF.ExtensionType).ResolveParser,
    test: (value)=>(0, $6yskn.Resolver).RETINA_PREFIX.test(value) && value.endsWith(".json"),
    parse: (0, $9589914ca0c3b07b$export$cc356fa83de02bea).parse
};




var $6yskn = parcelRequire("6yskn");

var $8o3Sc = parcelRequire("8o3Sc");

var $b9HvA = parcelRequire("b9HvA");
"use strict";
class $7eb272839e01564b$export$137d4dd907afac85 {
    constructor(){
        this._detections = [];
        this._initialized = false;
        this.resolver = new (0, $6yskn.Resolver)();
        this.loader = new (0, $858870214708d158$export$3b0d6d7590275603)();
        this.cache = (0, $1qKFs.Cache);
        this._backgroundLoader = new (0, $5cd28b403b84f142$export$1949379a83b843d5)(this.loader);
        this._backgroundLoader.active = true;
        this.reset();
    }
    /**
   * Best practice is to call this function before any loading commences
   * Initiating is the best time to add any customization to the way things are loaded.
   *
   * you do not need to call this for the Assets class to work, only if you want to set any initial properties
   * @param options - options to initialize the Assets manager with
   */ async init(options = {}) {
        if (this._initialized) {
            (0, $1q6Bk.warn)("[Assets]AssetManager already initialized, did you load before calling this Assets.init()?");
            return;
        }
        this._initialized = true;
        if (options.defaultSearchParams) this.resolver.setDefaultSearchParams(options.defaultSearchParams);
        if (options.basePath) this.resolver.basePath = options.basePath;
        if (options.bundleIdentifier) this.resolver.setBundleIdentifier(options.bundleIdentifier);
        if (options.manifest) {
            let manifest = options.manifest;
            if (typeof manifest === "string") manifest = await this.load(manifest);
            this.resolver.addManifest(manifest);
        }
        const resolutionPref = options.texturePreference?.resolution ?? 1;
        const resolution = typeof resolutionPref === "number" ? [
            resolutionPref
        ] : resolutionPref;
        const formats = await this._detectFormats({
            preferredFormats: options.texturePreference?.format,
            skipDetections: options.skipDetections,
            detections: this._detections
        });
        this.resolver.prefer({
            params: {
                format: formats,
                resolution: resolution
            }
        });
        if (options.preferences) this.setPreferences(options.preferences);
    }
    /**
   * Allows you to specify how to resolve any assets load requests.
   * There are a few ways to add things here as shown below:
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Simple
   * Assets.add({alias: 'bunnyBooBoo', src: 'bunny.png'});
   * const bunny = await Assets.load('bunnyBooBoo');
   *
   * // Multiple keys:
   * Assets.add({alias: ['burger', 'chicken'], src: 'bunny.png'});
   *
   * const bunny = await Assets.load('burger');
   * const bunny2 = await Assets.load('chicken');
   *
   * // passing options to to the object
   * Assets.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode: SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * // Multiple assets
   *
   * // The following all do the same thing:
   *
   * Assets.add({alias: 'bunnyBooBoo', src: 'bunny{png,webp}'});
   *
   * Assets.add({
   *     alias: 'bunnyBooBoo',
   *     src: [
   *         'bunny.png',
   *         'bunny.webp',
   *    ],
   * });
   *
   * const bunny = await Assets.load('bunnyBooBoo'); // Will try to load WebP if available
   * @param assets - the unresolved assets to add to the resolver
   */ add(assets) {
        this.resolver.add(assets);
    }
    async load(urls, onProgress) {
        if (!this._initialized) await this.init();
        const singleAsset = (0, $b9HvA.isSingleItem)(urls);
        const urlArray = (0, $8o3Sc.convertToList)(urls).map((url)=>{
            if (typeof url !== "string") {
                const aliases = this.resolver.getAlias(url);
                if (aliases.some((alias)=>!this.resolver.hasKey(alias))) this.add(url);
                return Array.isArray(aliases) ? aliases[0] : aliases;
            }
            if (!this.resolver.hasKey(url)) this.add({
                alias: url,
                src: url
            });
            return url;
        });
        const resolveResults = this.resolver.resolve(urlArray);
        const out = await this._mapLoadToResolve(resolveResults, onProgress);
        return singleAsset ? out[urlArray[0]] : out;
    }
    /**
   * This adds a bundle of assets in one go so that you can load them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * Assets.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const assets = await Assets.loadBundle('animals');
   * @param bundleId - the id of the bundle to add
   * @param assets - a record of the asset or assets that will be chosen from when loading via the specified key
   */ addBundle(bundleId, assets) {
        this.resolver.addBundle(bundleId, assets);
    }
    /**
   * Bundles are a way to load multiple assets at once.
   * If a manifest has been provided to the init function then you can load a bundle, or bundles.
   * you can also add bundles via `addBundle`
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * await Assets.init({ manifest });
   *
   * // Load a bundle...
   * loadScreenAssets = await Assets.loadBundle('load-screen');
   * // Load another bundle...
   * gameScreenAssets = await Assets.loadBundle('game-screen');
   * @param bundleIds - the bundle id or ids to load
   * @param onProgress - Optional function that is called when progress on asset loading is made.
   * The function is passed a single parameter, `progress`, which represents the percentage (0.0 - 1.0)
   * of the assets loaded. Do not use this function to detect when assets are complete and available,
   * instead use the Promise returned by this function.
   * @returns all the bundles assets or a hash of assets for each bundle specified
   */ async loadBundle(bundleIds, onProgress) {
        if (!this._initialized) await this.init();
        let singleAsset = false;
        if (typeof bundleIds === "string") {
            singleAsset = true;
            bundleIds = [
                bundleIds
            ];
        }
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        const out = {};
        const keys = Object.keys(resolveResults);
        let count = 0;
        let total = 0;
        const _onProgress = ()=>{
            onProgress?.(++count / total);
        };
        const promises = keys.map((bundleId)=>{
            const resolveResult = resolveResults[bundleId];
            total += Object.keys(resolveResult).length;
            return this._mapLoadToResolve(resolveResult, _onProgress).then((resolveResult2)=>{
                out[bundleId] = resolveResult2;
            });
        });
        await Promise.all(promises);
        return singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Initiate a background load of some assets. It will passively begin to load these assets in the background.
   * So when you actually come to loading them you will get a promise that resolves to the loaded assets immediately
   *
   * An example of this might be that you would background load game assets after your inital load.
   * then when you got to actually load your game screen assets when a player goes to the game - the loading
   * would already have stared or may even be complete, saving you having to show an interim load bar.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.backgroundLoad('bunny.png');
   *
   * // later on in your app...
   * await Assets.loadBundle('bunny.png'); // Will resolve quicker as loading may have completed!
   * @param urls - the url / urls you want to background load
   */ async backgroundLoad(urls) {
        if (!this._initialized) await this.init();
        if (typeof urls === "string") urls = [
            urls
        ];
        const resolveResults = this.resolver.resolve(urls);
        this._backgroundLoader.add(Object.values(resolveResults));
    }
    /**
   * Initiate a background of a bundle, works exactly like backgroundLoad but for bundles.
   * this can only be used if the loader has been initiated with a manifest
   * @example
   * import { Assets } from 'pixi.js';
   *
   * await Assets.init({
   *     manifest: {
   *         bundles: [
   *             {
   *                 name: 'load-screen',
   *                 assets: [...],
   *             },
   *             ...
   *         ],
   *     },
   * });
   *
   * Assets.backgroundLoadBundle('load-screen');
   *
   * // Later on in your app...
   * await Assets.loadBundle('load-screen'); // Will resolve quicker as loading may have completed!
   * @param bundleIds - the bundleId / bundleIds you want to background load
   */ async backgroundLoadBundle(bundleIds) {
        if (!this._initialized) await this.init();
        if (typeof bundleIds === "string") bundleIds = [
            bundleIds
        ];
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        Object.values(resolveResults).forEach((resolveResult)=>{
            this._backgroundLoader.add(Object.values(resolveResult));
        });
    }
    /**
   * Only intended for development purposes.
   * This will wipe the resolver and caches.
   * You will need to reinitialize the Asset
   */ reset() {
        this.resolver.reset();
        this.loader.reset();
        this.cache.reset();
        this._initialized = false;
    }
    get(keys) {
        if (typeof keys === "string") return (0, $1qKFs.Cache).get(keys);
        const assets = {};
        for(let i = 0; i < keys.length; i++)assets[i] = (0, $1qKFs.Cache).get(keys[i]);
        return assets;
    }
    /**
   * helper function to map resolved assets back to loaded assets
   * @param resolveResults - the resolve results from the resolver
   * @param onProgress - the progress callback
   */ async _mapLoadToResolve(resolveResults, onProgress) {
        const resolveArray = [
            ...new Set(Object.values(resolveResults))
        ];
        this._backgroundLoader.active = false;
        const loadedAssets = await this.loader.load(resolveArray, onProgress);
        this._backgroundLoader.active = true;
        const out = {};
        resolveArray.forEach((resolveResult)=>{
            const asset = loadedAssets[resolveResult.src];
            const keys = [
                resolveResult.src
            ];
            if (resolveResult.alias) keys.push(...resolveResult.alias);
            keys.forEach((key)=>{
                out[key] = asset;
            });
            (0, $1qKFs.Cache).set(keys, asset);
        });
        return out;
    }
    /**
   * Unload an asset or assets. As the Assets class is responsible for creating the assets via the `load` function
   * this will make sure to destroy any assets and release them from memory.
   * Once unloaded, you will need to load the asset again.
   *
   * Use this to help manage assets if you find that you have a large app and you want to free up memory.
   *
   * - it's up to you as the developer to make sure that textures are not actively being used when you unload them,
   * Pixi won't break but you will end up with missing assets. Not a good look for the user!
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Load a URL:
   * const myImageTexture = await Assets.load('http://some.url.com/image.png'); // => returns a texture
   *
   * await Assets.unload('http://some.url.com/image.png')
   *
   * // myImageTexture will be destroyed now.
   *
   * // Unload multiple assets:
   * const textures = await Assets.unload(['thumper', 'chicko']);
   * @param urls - the urls to unload
   */ async unload(urls) {
        if (!this._initialized) await this.init();
        const urlArray = (0, $8o3Sc.convertToList)(urls).map((url)=>typeof url !== "string" ? url.src : url);
        const resolveResults = this.resolver.resolve(urlArray);
        await this._unloadFromResolved(resolveResults);
    }
    /**
   * Bundles are a way to manage multiple assets at once.
   * this will unload all files in a bundle.
   *
   * once a bundle has been unloaded, you need to load it again to have access to the assets.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle({
   *     'thumper': 'http://some.url.com/thumper.png',
   * })
   *
   * const assets = await Assets.loadBundle('thumper');
   *
   * // Now to unload...
   *
   * await Assets.unloadBundle('thumper');
   *
   * // All assets in the assets object will now have been destroyed and purged from the cache
   * @param bundleIds - the bundle id or ids to unload
   */ async unloadBundle(bundleIds) {
        if (!this._initialized) await this.init();
        bundleIds = (0, $8o3Sc.convertToList)(bundleIds);
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        const promises = Object.keys(resolveResults).map((bundleId)=>this._unloadFromResolved(resolveResults[bundleId]));
        await Promise.all(promises);
    }
    async _unloadFromResolved(resolveResult) {
        const resolveArray = Object.values(resolveResult);
        resolveArray.forEach((resolveResult2)=>{
            (0, $1qKFs.Cache).remove(resolveResult2.src);
        });
        await this.loader.unload(resolveArray);
    }
    /**
   * Detects the supported formats for the browser, and returns an array of supported formats, respecting
   * the users preferred formats order.
   * @param options - the options to use when detecting formats
   * @param options.preferredFormats - the preferred formats to use
   * @param options.skipDetections - if we should skip the detections altogether
   * @param options.detections - the detections to use
   * @returns - the detected formats
   */ async _detectFormats(options) {
        let formats = [];
        if (options.preferredFormats) formats = Array.isArray(options.preferredFormats) ? options.preferredFormats : [
            options.preferredFormats
        ];
        for (const detection of options.detections){
            if (options.skipDetections || await detection.test()) formats = await detection.add(formats);
            else if (!options.skipDetections) formats = await detection.remove(formats);
        }
        formats = formats.filter((format, index)=>formats.indexOf(format) === index);
        return formats;
    }
    /** All the detection parsers currently added to the Assets class. */ get detections() {
        return this._detections;
    }
    /**
   * General setter for preferences. This is a helper function to set preferences on all parsers.
   * @param preferences - the preferences to set
   */ setPreferences(preferences) {
        this.loader.parsers.forEach((parser)=>{
            if (!parser.config) return;
            Object.keys(parser.config).filter((key)=>key in preferences).forEach((key)=>{
                parser.config[key] = preferences[key];
            });
        });
    }
}
const $7eb272839e01564b$export$c8eca95e306f7116 = new $7eb272839e01564b$export$137d4dd907afac85();
(0, $aqljF.extensions).handleByList((0, $aqljF.ExtensionType).LoadParser, $7eb272839e01564b$export$c8eca95e306f7116.loader.parsers).handleByList((0, $aqljF.ExtensionType).ResolveParser, $7eb272839e01564b$export$c8eca95e306f7116.resolver.parsers).handleByList((0, $aqljF.ExtensionType).CacheParser, $7eb272839e01564b$export$c8eca95e306f7116.cache.parsers).handleByList((0, $aqljF.ExtensionType).DetectionParser, $7eb272839e01564b$export$c8eca95e306f7116.detections);
(0, $aqljF.extensions).add((0, $b1463a9683eb98cd$export$407b4625a915919d), (0, $35fa9d1f38b94970$export$b106d7c2de3b4d89), (0, $729469a82d74b6d7$export$a60d2d4a3c570783), (0, $ec57032a4727e7bb$export$d19529a9ed9823d4), (0, $9e91d7343c879e67$export$7726d83fee274e25), (0, $7a5d45498b3ec8cc$export$5a1da481121f806a), (0, $59ea8cd7ecc773db$export$a041d698a1896657), (0, $2a7a5de38413f9af$export$e7c8553478f3aac7), (0, $c4f76552ca31f72e$export$3835b7ee6dbebde8), (0, $01ea2d0d4a3535e2$export$129ed93ad26b0298), (0, $e70fdc4b333909e4$export$b6a2e78b63791dfa), (0, $481574dd5d7605df$export$897b113ee8307cd0), (0, $4394dcba514907d5$export$68fa0976ba667d63), (0, $9589914ca0c3b07b$export$cc356fa83de02bea), (0, $94190cea3125d913$export$2b5cca0b89cb089c));
const $7eb272839e01564b$var$assetKeyMap = {
    loader: (0, $aqljF.ExtensionType).LoadParser,
    resolver: (0, $aqljF.ExtensionType).ResolveParser,
    cache: (0, $aqljF.ExtensionType).CacheParser,
    detection: (0, $aqljF.ExtensionType).DetectionParser
};
(0, $aqljF.extensions).handle((0, $aqljF.ExtensionType).Asset, (extension)=>{
    const ref = extension.ref;
    Object.entries($7eb272839e01564b$var$assetKeyMap).filter(([key])=>!!ref[key]).forEach(([key, type])=>(0, $aqljF.extensions).add(Object.assign(ref[key], // Allow the function to optionally define it's own
        // ExtensionMetadata, the use cases here is priority for LoaderParsers
        {
            extension: ref[key].extension ?? type
        })));
}, (extension)=>{
    const ref = extension.ref;
    Object.keys($7eb272839e01564b$var$assetKeyMap).filter((key)=>!!ref[key]).forEach((key)=>(0, $aqljF.extensions).remove(ref[key]));
});















var $9uHEw = parcelRequire("9uHEw");


















var $bEj7k = parcelRequire("bEj7k");



























var $2NruG = parcelRequire("2NruG");






var $6BsCn = parcelRequire("6BsCn");



























var $339HX = parcelRequire("339HX");

var $9E2kA = parcelRequire("9E2kA");

var $9wDSg = parcelRequire("9wDSg");

var $ld81y = parcelRequire("ld81y");
var $43b38a3b8faa6c75$export$2e2bcd8739ae039 = "in vec2 aPosition;\nout vec2 vTextureCoord;\n\nuniform vec4 uInputSize;\nuniform vec4 uOutputFrame;\nuniform vec4 uOutputTexture;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;\n    \n    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aPosition * (uOutputFrame.zw * uInputSize.zw);\n}\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n}\n";


var $494448da6b870c80$export$2e2bcd8739ae039 = "\nin vec2 vTextureCoord;\n\nout vec4 finalColor;\n\nuniform float uAlpha;\nuniform sampler2D uTexture;\n\nvoid main()\n{\n    finalColor =  texture(uTexture, vTextureCoord) * uAlpha;\n}\n";


var $17a6eedabc78f502$export$2e2bcd8739ae039 = "struct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\nstruct AlphaUniforms {\n  uAlpha:f32,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n@group(0) @binding(1) var uTexture: texture_2d<f32>;\n@group(0) @binding(2) var uSampler : sampler;\n\n@group(1) @binding(0) var<uniform> alphaUniforms : AlphaUniforms;\n\nstruct VSOutput {\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>\n  };\n\nfn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>\n{\n    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;\n\n    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nfn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);\n}\n\nfn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);  \n}\n\nfn getSize() -> vec2<f32>\n{\n  return gfu.uGlobalFrame.zw;\n}\n  \n@vertex\nfn mainVertex(\n  @location(0) aPosition : vec2<f32>, \n) -> VSOutput {\n  return VSOutput(\n   filterVertexPosition(aPosition),\n   filterTextureCoord(aPosition)\n  );\n}\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>,\n  @builtin(position) position: vec4<f32>\n) -> @location(0) vec4<f32> {\n \n    var sample = textureSample(uTexture, uSampler, uv);\n    \n    return sample * alphaUniforms.uAlpha;\n}";


"use strict";
const $3c87de1a7de6a738$var$_AlphaFilter = class _AlphaFilter extends (0, $ld81y.Filter) {
    constructor(options){
        options = {
            ..._AlphaFilter.defaultOptions,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: $17a6eedabc78f502$export$2e2bcd8739ae039,
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $17a6eedabc78f502$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $43b38a3b8faa6c75$export$2e2bcd8739ae039,
            fragment: $494448da6b870c80$export$2e2bcd8739ae039,
            name: "alpha-filter"
        });
        const { alpha: alpha, ...rest } = options;
        const alphaUniforms = new (0, $9wDSg.UniformGroup)({
            uAlpha: {
                value: alpha,
                type: "f32"
            }
        });
        super({
            ...rest,
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                alphaUniforms: alphaUniforms
            }
        });
    }
    /**
   * Coefficient for alpha multiplication
   * @default 1
   */ get alpha() {
        return this.resources.alphaUniforms.uniforms.uAlpha;
    }
    set alpha(value) {
        this.resources.alphaUniforms.uniforms.uAlpha = value;
    }
};
/** Default filter options */ $3c87de1a7de6a738$var$_AlphaFilter.defaultOptions = {
    /** Amount of alpha from 0 to 1, where 0 is transparent */ alpha: 1
};
let $3c87de1a7de6a738$export$adbaa0de008b0d7a = $3c87de1a7de6a738$var$_AlphaFilter;



var $g5CeI = parcelRequire("g5CeI");

var $cepzV = parcelRequire("cepzV");

var $j0fPb = parcelRequire("j0fPb");

var $ld81y = parcelRequire("ld81y");

var $g5CeI = parcelRequire("g5CeI");

var $cepzV = parcelRequire("cepzV");

var $ld81y = parcelRequire("ld81y");

var $339HX = parcelRequire("339HX");
"use strict";
const $5d5e2e8dc03bc22f$export$62963d757c50e400 = {
    5: [
        0.153388,
        0.221461,
        0.250301
    ],
    7: [
        0.071303,
        0.131514,
        0.189879,
        0.214607
    ],
    9: [
        0.028532,
        0.067234,
        0.124009,
        0.179044,
        0.20236
    ],
    11: [
        93e-4,
        0.028002,
        0.065984,
        0.121703,
        0.175713,
        0.198596
    ],
    13: [
        2406e-6,
        9255e-6,
        0.027867,
        0.065666,
        0.121117,
        0.174868,
        0.197641
    ],
    15: [
        489e-6,
        2403e-6,
        9246e-6,
        0.02784,
        0.065602,
        0.120999,
        0.174697,
        0.197448
    ]
};


"use strict";
const $3fef89511237cba5$var$fragTemplate = [
    "in vec2 vBlurTexCoords[%size%];",
    "uniform sampler2D uTexture;",
    "out vec4 finalColor;",
    "void main(void)",
    "{",
    "    finalColor = vec4(0.0);",
    "    %blur%",
    "}"
].join("\n");
function $3fef89511237cba5$export$1b0dcf101eb6a1c9(kernelSize) {
    const kernel = (0, $5d5e2e8dc03bc22f$export$62963d757c50e400)[kernelSize];
    const halfLength = kernel.length;
    let fragSource = $3fef89511237cba5$var$fragTemplate;
    let blurLoop = "";
    const template = "finalColor += texture(uTexture, vBlurTexCoords[%index%]) * %value%;";
    let value;
    for(let i = 0; i < kernelSize; i++){
        let blur = template.replace("%index%", i.toString());
        value = i;
        if (i >= halfLength) value = kernelSize - i - 1;
        blur = blur.replace("%value%", kernel[value].toString());
        blurLoop += blur;
        blurLoop += "\n";
    }
    fragSource = fragSource.replace("%blur%", blurLoop);
    fragSource = fragSource.replace("%size%", kernelSize.toString());
    return fragSource;
}


"use strict";
const $934e327a4eedb53a$var$vertTemplate = `
    in vec2 aPosition;

    uniform float uStrength;

    out vec2 vBlurTexCoords[%size%];

    uniform vec4 uInputSize;
    uniform vec4 uOutputFrame;
    uniform vec4 uOutputTexture;

    vec4 filterVertexPosition( void )
{
    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;
    
    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

    vec2 filterTextureCoord( void )
    {
        return aPosition * (uOutputFrame.zw * uInputSize.zw);
    }

    void main(void)
    {
        gl_Position = filterVertexPosition();

        float pixelStrength = uInputSize.%dimension% * uStrength;

        vec2 textureCoord = filterTextureCoord();
        %blur%
    }`;
function $934e327a4eedb53a$export$7a7fb9d9d09c33af(kernelSize, x) {
    const halfLength = Math.ceil(kernelSize / 2);
    let vertSource = $934e327a4eedb53a$var$vertTemplate;
    let blurLoop = "";
    let template;
    if (x) template = "vBlurTexCoords[%index%] =  textureCoord + vec2(%sampleIndex% * pixelStrength, 0.0);";
    else template = "vBlurTexCoords[%index%] =  textureCoord + vec2(0.0, %sampleIndex% * pixelStrength);";
    for(let i = 0; i < kernelSize; i++){
        let blur = template.replace("%index%", i.toString());
        blur = blur.replace("%sampleIndex%", `${i - (halfLength - 1)}.0`);
        blurLoop += blur;
        blurLoop += "\n";
    }
    vertSource = vertSource.replace("%blur%", blurLoop);
    vertSource = vertSource.replace("%size%", kernelSize.toString());
    vertSource = vertSource.replace("%dimension%", x ? "z" : "w");
    return vertSource;
}


"use strict";
function $bc7067bec27a87f4$export$fa4adee1a7bc708(horizontal, kernelSize) {
    const vertex = (0, $934e327a4eedb53a$export$7a7fb9d9d09c33af)(kernelSize, horizontal);
    const fragment = (0, $3fef89511237cba5$export$1b0dcf101eb6a1c9)(kernelSize);
    return (0, $339HX.GlProgram).from({
        vertex: vertex,
        fragment: fragment,
        name: `blur-${horizontal ? "horizontal" : "vertical"}-pass-filter`
    });
}



var $9E2kA = parcelRequire("9E2kA");

var $01bb0ea3ac5fd2b2$export$2e2bcd8739ae039 = "\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\nstruct BlurUniforms {\n  uStrength:f32,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n@group(0) @binding(1) var uTexture: texture_2d<f32>;\n@group(0) @binding(2) var uSampler : sampler;\n\n@group(1) @binding(0) var<uniform> blurUniforms : BlurUniforms;\n\n\nstruct VSOutput {\n    @builtin(position) position: vec4<f32>,\n    %blur-struct%\n  };\n\nfn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>\n{\n    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;\n\n    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nfn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);\n}\n\nfn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);  \n}\n\nfn getSize() -> vec2<f32>\n{\n  return gfu.uGlobalFrame.zw;\n}\n\n\n@vertex\nfn mainVertex(\n  @location(0) aPosition : vec2<f32>, \n) -> VSOutput {\n\n  let filteredCord = filterTextureCoord(aPosition);\n\n  let strength = gfu.uInputSize.w * blurUniforms.uStrength;\n\n  return VSOutput(\n   filterVertexPosition(aPosition),\n    %blur-vertex-out%\n  );\n}\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  %blur-fragment-in%\n) -> @location(0) vec4<f32> {\n\n    var   finalColor = vec4(0.0);\n\n    %blur-sampling%\n\n    return finalColor;\n}";


"use strict";
function $376a37952a91f473$export$96d9b45e64338908(horizontal, kernelSize) {
    const kernel = (0, $5d5e2e8dc03bc22f$export$62963d757c50e400)[kernelSize];
    const halfLength = kernel.length;
    const blurStructSource = [];
    const blurOutSource = [];
    const blurSamplingSource = [];
    for(let i = 0; i < kernelSize; i++){
        blurStructSource[i] = `@location(${i}) offset${i}: vec2<f32>,`;
        if (horizontal) blurOutSource[i] = `filteredCord + vec2(${i - halfLength + 1} * strength, 0.0),`;
        else blurOutSource[i] = `filteredCord + vec2(0.0, ${i - halfLength + 1} * strength),`;
        const kernelIndex = i < halfLength ? i : kernelSize - i - 1;
        const kernelValue = kernel[kernelIndex].toString();
        blurSamplingSource[i] = `finalColor += textureSample(uTexture, uSampler, offset${i}) * ${kernelValue};`;
    }
    const blurStruct = blurStructSource.join("\n");
    const blurOut = blurOutSource.join("\n");
    const blurSampling = blurSamplingSource.join("\n");
    const finalSource = (0, $01bb0ea3ac5fd2b2$export$2e2bcd8739ae039).replace("%blur-struct%", blurStruct).replace("%blur-vertex-out%", blurOut).replace("%blur-fragment-in%", blurStruct).replace("%blur-sampling%", blurSampling);
    return (0, $9E2kA.GpuProgram).from({
        vertex: {
            source: finalSource,
            entryPoint: "mainVertex"
        },
        fragment: {
            source: finalSource,
            entryPoint: "mainFragment"
        }
    });
}


"use strict";
const $f1dbcd66fba2886b$var$_BlurFilterPass = class _BlurFilterPass extends (0, $ld81y.Filter) {
    /**
   * @param options
   * @param options.horizontal - Do pass along the x-axis (`true`) or y-axis (`false`).
   * @param options.strength - The strength of the blur filter.
   * @param options.quality - The quality of the blur filter.
   * @param options.kernelSize - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
   */ constructor(options){
        options = {
            ..._BlurFilterPass.defaultOptions,
            ...options
        };
        const glProgram = (0, $bc7067bec27a87f4$export$fa4adee1a7bc708)(options.horizontal, options.kernelSize);
        const gpuProgram = (0, $376a37952a91f473$export$96d9b45e64338908)(options.horizontal, options.kernelSize);
        super({
            glProgram: glProgram,
            gpuProgram: gpuProgram,
            resources: {
                blurUniforms: {
                    uStrength: {
                        value: 0,
                        type: "f32"
                    }
                }
            },
            ...options
        });
        this.horizontal = options.horizontal;
        this._quality = 0;
        this.quality = options.quality;
        this.blur = options.strength;
        this._uniforms = this.resources.blurUniforms.uniforms;
    }
    /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - How to clear
   */ apply(filterManager, input, output, clearMode) {
        this._uniforms.uStrength = this.strength / this.passes;
        if (this.passes === 1) filterManager.applyFilter(this, input, output, clearMode);
        else {
            const tempTexture = (0, $g5CeI.TexturePool).getSameSizeTexture(input);
            let flip = input;
            let flop = tempTexture;
            this._state.blend = false;
            for(let i = 0; i < this.passes - 1; i++){
                filterManager.applyFilter(this, flip, flop, filterManager.renderer.type === (0, $cepzV.RendererType).WEBGPU);
                const temp = flop;
                flop = flip;
                flip = temp;
            }
            this._state.blend = true;
            filterManager.applyFilter(this, flip, output, clearMode);
            (0, $g5CeI.TexturePool).returnTexture(tempTexture);
        }
    }
    /**
   * Sets the strength of both the blur.
   * @default 16
   */ get blur() {
        return this.strength;
    }
    set blur(value) {
        this.padding = 1 + Math.abs(value) * 2;
        this.strength = value;
    }
    /**
   * Sets the quality of the blur by modifying the number of passes. More passes means higher
   * quality blurring but the lower the performance.
   * @default 4
   */ get quality() {
        return this._quality;
    }
    set quality(value) {
        this._quality = value;
        this.passes = value;
    }
};
/** Default blur filter pass options */ $f1dbcd66fba2886b$var$_BlurFilterPass.defaultOptions = {
    /** The strength of the blur filter. */ strength: 8,
    /** The quality of the blur filter. */ quality: 4,
    /** The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15. */ kernelSize: 5
};
let $f1dbcd66fba2886b$export$b100a8e8116621cf = $f1dbcd66fba2886b$var$_BlurFilterPass;


"use strict";
class $02d1c7a4f9d3e479$export$424348d09d827f49 extends (0, $ld81y.Filter) {
    constructor(...args){
        let options = args[0] ?? {};
        if (typeof options === "number") {
            (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), "BlurFilter constructor params are now options object. See params: { strength, quality, resolution, kernelSize }");
            options = {
                strength: options
            };
            if (args[1]) options.quality = args[1];
            if (args[2]) options.resolution = args[2];
            if (args[3]) options.kernelSize = args[3];
        }
        options = {
            ...(0, $f1dbcd66fba2886b$export$b100a8e8116621cf).defaultOptions,
            ...options
        };
        const { strength: strength, quality: quality, ...rest } = options;
        super({
            ...rest,
            compatibleRenderers: (0, $cepzV.RendererType).BOTH,
            resources: {}
        });
        this._repeatEdgePixels = false;
        this.blurXFilter = new (0, $f1dbcd66fba2886b$export$b100a8e8116621cf)({
            horizontal: false,
            ...options
        });
        this.blurYFilter = new (0, $f1dbcd66fba2886b$export$b100a8e8116621cf)({
            horizontal: true,
            ...options
        });
        this.quality = quality;
        this.blur = strength;
        this.repeatEdgePixels = false;
    }
    /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - How to clear
   */ apply(filterManager, input, output, clearMode) {
        const xStrength = Math.abs(this.blurXFilter.strength);
        const yStrength = Math.abs(this.blurYFilter.strength);
        if (xStrength && yStrength) {
            const tempTexture = (0, $g5CeI.TexturePool).getSameSizeTexture(input);
            this.blurXFilter.apply(filterManager, input, tempTexture, true);
            this.blurYFilter.apply(filterManager, tempTexture, output, clearMode);
            (0, $g5CeI.TexturePool).returnTexture(tempTexture);
        } else if (yStrength) this.blurYFilter.apply(filterManager, input, output, clearMode);
        else this.blurXFilter.apply(filterManager, input, output, clearMode);
    }
    updatePadding() {
        if (this._repeatEdgePixels) this.padding = 0;
        else this.padding = Math.max(Math.abs(this.blurXFilter.blur), Math.abs(this.blurYFilter.blur)) * 2;
    }
    /**
   * Sets the strength of both the blurX and blurY properties simultaneously
   * @default 2
   */ get blur() {
        return this.blurXFilter.blur;
    }
    set blur(value) {
        this.blurXFilter.blur = this.blurYFilter.blur = value;
        this.updatePadding();
    }
    /**
   * Sets the number of passes for blur. More passes means higher quality bluring.
   * @default 1
   */ get quality() {
        return this.blurXFilter.quality;
    }
    set quality(value) {
        this.blurXFilter.quality = this.blurYFilter.quality = value;
    }
    /**
   * Sets the strength of the blurX property
   * @default 2
   */ get blurX() {
        return this.blurXFilter.blur;
    }
    set blurX(value) {
        this.blurXFilter.blur = value;
        this.updatePadding();
    }
    /**
   * Sets the strength of the blurY property
   * @default 2
   */ get blurY() {
        return this.blurYFilter.blur;
    }
    set blurY(value) {
        this.blurYFilter.blur = value;
        this.updatePadding();
    }
    /**
   * Sets the blendmode of the filter
   * @default "normal"
   */ get blendMode() {
        return this.blurYFilter.blendMode;
    }
    set blendMode(value) {
        this.blurYFilter.blendMode = value;
    }
    /**
   * If set to true the edge of the target will be clamped
   * @default false
   */ get repeatEdgePixels() {
        return this._repeatEdgePixels;
    }
    set repeatEdgePixels(value) {
        this._repeatEdgePixels = value;
        this.updatePadding();
    }
}
/** Default blur filter options */ $02d1c7a4f9d3e479$export$424348d09d827f49.defaultOptions = {
    /** The strength of the blur filter. */ strength: 8,
    /** The quality of the blur filter. */ quality: 4,
    /** The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15. */ kernelSize: 5
};












var $ld81y = parcelRequire("ld81y");







var $l8FfC = parcelRequire("l8FfC");



var $lej7S = parcelRequire("lej7S");

var $bwMhC = parcelRequire("bwMhC");





var $hFBUu = parcelRequire("hFBUu");




























































var $339HX = parcelRequire("339HX");




























































var $9E2kA = parcelRequire("9E2kA");





























































var $keToW = parcelRequire("keToW");


var $5yirD = parcelRequire("5yirD");

var $eIuJW = parcelRequire("eIuJW");


var $jollT = parcelRequire("jollT");



var $g5CeI = parcelRequire("g5CeI");







var $3ATmb = parcelRequire("3ATmb");


















var $e0Ilp = parcelRequire("e0Ilp");




































var $8VCQS = parcelRequire("8VCQS");


























var $jollT = parcelRequire("jollT");

var $cuDRd = parcelRequire("cuDRd");

var $4CJdx = parcelRequire("4CJdx");

var $j5g5m = parcelRequire("j5g5m");
"use strict";
class $df1779dbe35539ec$export$dae599798687ad3c extends (0, $j5g5m.Sprite) {
    /**
   * @param textures - An array of {@link Texture} or frame
   *  objects that make up the animation.
   * @param {boolean} [autoUpdate=true] - Whether to use Ticker.shared to auto update animation time.
   */ constructor(textures, autoUpdate = true){
        super(textures[0] instanceof (0, $jollT.Texture) ? textures[0] : textures[0].texture);
        this._textures = null;
        this._durations = null;
        this._autoUpdate = autoUpdate;
        this._isConnectedToTicker = false;
        this.animationSpeed = 1;
        this.loop = true;
        this.updateAnchor = false;
        this.onComplete = null;
        this.onFrameChange = null;
        this.onLoop = null;
        this._currentTime = 0;
        this._playing = false;
        this._previousFrame = null;
        this.textures = textures;
    }
    /** Stops the AnimatedSprite. */ stop() {
        if (!this._playing) return;
        this._playing = false;
        if (this._autoUpdate && this._isConnectedToTicker) {
            (0, $4CJdx.Ticker).shared.remove(this.update, this);
            this._isConnectedToTicker = false;
        }
    }
    /** Plays the AnimatedSprite. */ play() {
        if (this._playing) return;
        this._playing = true;
        if (this._autoUpdate && !this._isConnectedToTicker) {
            (0, $4CJdx.Ticker).shared.add(this.update, this, (0, $cuDRd.UPDATE_PRIORITY).HIGH);
            this._isConnectedToTicker = true;
        }
    }
    /**
   * Stops the AnimatedSprite and goes to a specific frame.
   * @param frameNumber - Frame index to stop at.
   */ gotoAndStop(frameNumber) {
        this.stop();
        this.currentFrame = frameNumber;
    }
    /**
   * Goes to a specific frame and begins playing the AnimatedSprite.
   * @param frameNumber - Frame index to start at.
   */ gotoAndPlay(frameNumber) {
        this.currentFrame = frameNumber;
        this.play();
    }
    /**
   * Updates the object transform for rendering.
   * @param ticker - the ticker to use to update the object.
   */ update(ticker) {
        if (!this._playing) return;
        const deltaTime = ticker.deltaTime;
        const elapsed = this.animationSpeed * deltaTime;
        const previousFrame = this.currentFrame;
        if (this._durations !== null) {
            let lag = this._currentTime % 1 * this._durations[this.currentFrame];
            lag += elapsed / 60 * 1e3;
            while(lag < 0){
                this._currentTime--;
                lag += this._durations[this.currentFrame];
            }
            const sign = Math.sign(this.animationSpeed * deltaTime);
            this._currentTime = Math.floor(this._currentTime);
            while(lag >= this._durations[this.currentFrame]){
                lag -= this._durations[this.currentFrame] * sign;
                this._currentTime += sign;
            }
            this._currentTime += lag / this._durations[this.currentFrame];
        } else this._currentTime += elapsed;
        if (this._currentTime < 0 && !this.loop) {
            this.gotoAndStop(0);
            if (this.onComplete) this.onComplete();
        } else if (this._currentTime >= this._textures.length && !this.loop) {
            this.gotoAndStop(this._textures.length - 1);
            if (this.onComplete) this.onComplete();
        } else if (previousFrame !== this.currentFrame) {
            if (this.loop && this.onLoop) {
                if (this.animationSpeed > 0 && this.currentFrame < previousFrame || this.animationSpeed < 0 && this.currentFrame > previousFrame) this.onLoop();
            }
            this._updateTexture();
        }
    }
    /** Updates the displayed texture to match the current frame index. */ _updateTexture() {
        const currentFrame = this.currentFrame;
        if (this._previousFrame === currentFrame) return;
        this._previousFrame = currentFrame;
        this.texture = this._textures[currentFrame];
        if (this.updateAnchor) this.anchor.copyFrom(this.texture.defaultAnchor);
        if (this.onFrameChange) this.onFrameChange(this.currentFrame);
    }
    /** Stops the AnimatedSprite and destroys it. */ destroy() {
        this.stop();
        super.destroy();
        this.onComplete = null;
        this.onFrameChange = null;
        this.onLoop = null;
    }
    /**
   * A short hand way of creating an AnimatedSprite from an array of frame ids.
   * @param frames - The array of frames ids the AnimatedSprite will use as its texture frames.
   * @returns - The new animated sprite with the specified frames.
   */ static fromFrames(frames) {
        const textures = [];
        for(let i = 0; i < frames.length; ++i)textures.push((0, $jollT.Texture).from(frames[i]));
        return new $df1779dbe35539ec$export$dae599798687ad3c(textures);
    }
    /**
   * A short hand way of creating an AnimatedSprite from an array of image ids.
   * @param images - The array of image urls the AnimatedSprite will use as its texture frames.
   * @returns The new animate sprite with the specified images as frames.
   */ static fromImages(images) {
        const textures = [];
        for(let i = 0; i < images.length; ++i)textures.push((0, $jollT.Texture).from(images[i]));
        return new $df1779dbe35539ec$export$dae599798687ad3c(textures);
    }
    /**
   * The total number of frames in the AnimatedSprite. This is the same as number of textures
   * assigned to the AnimatedSprite.
   * @readonly
   * @default 0
   */ get totalFrames() {
        return this._textures.length;
    }
    /** The array of textures used for this AnimatedSprite. */ get textures() {
        return this._textures;
    }
    set textures(value) {
        if (value[0] instanceof (0, $jollT.Texture)) {
            this._textures = value;
            this._durations = null;
        } else {
            this._textures = [];
            this._durations = [];
            for(let i = 0; i < value.length; i++){
                this._textures.push(value[i].texture);
                this._durations.push(value[i].time);
            }
        }
        this._previousFrame = null;
        this.gotoAndStop(0);
        this._updateTexture();
    }
    /** The AnimatedSprite's current frame index. */ get currentFrame() {
        let currentFrame = Math.floor(this._currentTime) % this._textures.length;
        if (currentFrame < 0) currentFrame += this._textures.length;
        return currentFrame;
    }
    set currentFrame(value) {
        if (value < 0 || value > this.totalFrames - 1) throw new Error(`[AnimatedSprite]: Invalid frame index value ${value}, expected to be between 0 and totalFrames ${this.totalFrames}.`);
        const previousFrame = this.currentFrame;
        this._currentTime = value;
        if (previousFrame !== this.currentFrame) this._updateTexture();
    }
    /**
   * Indicates if the AnimatedSprite is currently playing.
   * @readonly
   */ get playing() {
        return this._playing;
    }
    /** Whether to use Ticker.shared to auto update animation time. */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        if (value !== this._autoUpdate) {
            this._autoUpdate = value;
            if (!this._autoUpdate && this._isConnectedToTicker) {
                (0, $4CJdx.Ticker).shared.remove(this.update, this);
                this._isConnectedToTicker = false;
            } else if (this._autoUpdate && !this._isConnectedToTicker && this._playing) {
                (0, $4CJdx.Ticker).shared.add(this.update, this);
                this._isConnectedToTicker = true;
            }
        }
    }
}















var $j5g5m = parcelRequire("j5g5m");





































var $lej7S = parcelRequire("lej7S");

var $j0fPb = parcelRequire("j0fPb");

var $3vloD = parcelRequire("3vloD");

var $e0Ilp = parcelRequire("e0Ilp");
"use strict";
class $e7ca80d35f04c488$export$daf74670712de91 extends (0, $e0Ilp.Container) {
    constructor(options, styleClass){
        const { text: text, resolution: resolution, style: style, anchor: anchor, width: width, height: height, roundPixels: roundPixels, ...rest } = options;
        super({
            ...rest
        });
        this.batched = true;
        /**
     * The resolution / device pixel ratio of the canvas.
     * @default 1
     */ this.resolution = null;
        this._didTextUpdate = true;
        this._roundPixels = 0;
        this._bounds = new (0, $3vloD.Bounds)();
        this._boundsDirty = true;
        this._styleClass = styleClass;
        this.text = text ?? "";
        this.style = style;
        this.resolution = resolution ?? null;
        this.allowChildren = false;
        this._anchor = new (0, $lej7S.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        this.roundPixels = roundPixels ?? false;
        if (width) this.width = width;
        if (height) this.height = height;
    }
    /**
   * The anchor sets the origin point of the text.
   * The default is `(0,0)`, this means the text's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the text's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the text's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * import { Text } from 'pixi.js';
   *
   * const text = new Text('hello world');
   * text.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   *  Whether or not to round the x/y position of the text.
   * @type {boolean}
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    set roundPixels(value) {
        this._roundPixels = value ? 1 : 0;
    }
    /** Set the copy for the text object. To split a line you can use '\n'. */ set text(value) {
        value = value.toString();
        if (this._text === value) return;
        this._text = value;
        this.onViewUpdate();
    }
    get text() {
        return this._text;
    }
    get style() {
        return this._style;
    }
    /**
   * Set the style of the text.
   *
   * Set up an event listener to listen for changes on the style object and mark the text as dirty.
   *
   * If setting the `style` can also be partial {@link AnyTextStyleOptions}.
   * @type {
   * text.TextStyle |
   * Partial<text.TextStyle> |
   * text.TextStyleOptions |
   * text.HTMLTextStyle |
   * Partial<text.HTMLTextStyle> |
   * text.HTMLTextStyleOptions
   * }
   */ set style(style) {
        style = style || {};
        this._style?.off("update", this.onViewUpdate, this);
        if (style instanceof this._styleClass) this._style = style;
        else this._style = new this._styleClass(style);
        this._style.on("update", this.onViewUpdate, this);
        this.onViewUpdate();
    }
    /**
   * The local bounds of the Text.
   * @type {rendering.Bounds}
   */ get bounds() {
        if (this._boundsDirty) {
            this._updateBounds();
            this._boundsDirty = false;
        }
        return this._bounds;
    }
    /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */ get width() {
        return Math.abs(this.scale.x) * this.bounds.width;
    }
    set width(value) {
        this._setWidth(value, this.bounds.width);
    }
    /** The height of the sprite, setting this will actually modify the scale to achieve the value set. */ get height() {
        return Math.abs(this.scale.y) * this.bounds.height;
    }
    set height(value) {
        this._setHeight(value, this.bounds.height);
    }
    /**
   * Retrieves the size of the Text as a [Size]{@link Size} object.
   * This is faster than get the width and height separately.
   * @param out - Optional object to store the size in.
   * @returns - The size of the Text.
   */ getSize(out) {
        if (!out) out = {};
        out.width = Math.abs(this.scale.x) * this.bounds.width;
        out.height = Math.abs(this.scale.y) * this.bounds.height;
        return out;
    }
    /**
   * Sets the size of the Text to the specified width and height.
   * This is faster than setting the width and height separately.
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */ setSize(value, height) {
        let convertedWidth;
        let convertedHeight;
        if (typeof value !== "object") {
            convertedWidth = value;
            convertedHeight = height ?? value;
        } else {
            convertedWidth = value.width;
            convertedHeight = value.height ?? value.width;
        }
        if (convertedWidth !== void 0) this._setWidth(convertedWidth, this.bounds.width);
        if (convertedHeight !== void 0) this._setHeight(convertedHeight, this.bounds.height);
    }
    /**
   * Adds the bounds of this text to the bounds object.
   * @param bounds - The output bounds object.
   */ addBounds(bounds) {
        const _bounds = this.bounds;
        bounds.addFrame(_bounds.minX, _bounds.minY, _bounds.maxX, _bounds.maxY);
    }
    /**
   * Checks if the text contains the given point.
   * @param point - The point to check
   */ containsPoint(point) {
        const width = this.bounds.maxX;
        const height = this.bounds.maxY;
        const x1 = -width * this.anchor.x;
        let y1 = 0;
        if (point.x >= x1 && point.x <= x1 + width) {
            y1 = -height * this.anchor.y;
            if (point.y >= y1 && point.y <= y1 + height) return true;
        }
        return false;
    }
    onViewUpdate() {
        this._didChangeId += 4096;
        this._boundsDirty = true;
        if (this.didViewUpdate) return;
        this.didViewUpdate = true;
        this._didTextUpdate = true;
        if (this.renderGroup) this.renderGroup.onChildViewUpdate(this);
    }
    _getKey() {
        return `${this.text}:${this._style.styleKey}`;
    }
    /**
   * Destroys this text renderable and optionally its style texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the texture of the text style
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the text style
   * @param {boolean} [options.style=false] - Should it destroy the style of the text
   */ destroy(options = false) {
        super.destroy(options);
        this.owner = null;
        this._bounds = null;
        this._anchor = null;
        if (typeof options === "boolean" ? options : options?.style) this._style.destroy(options);
        this._style = null;
        this._text = null;
    }
}
function $e7ca80d35f04c488$export$1f008a47b72e40d9(args, name) {
    let options = args[0] ?? {};
    if (typeof options === "string" || args[1]) {
        (0, $j0fPb.deprecation)((0, $j0fPb.v8_0_0), `use new ${name}({ text: "hi!", style }) instead`);
        options = {
            text: options,
            style: args[1]
        };
    }
    return options;
}



var $gA7LB = parcelRequire("gA7LB");

var $jZulE = parcelRequire("jZulE");
"use strict";
class $f7554d64cbb05d0f$export$5f1af8db9871e1d6 extends (0, $e7ca80d35f04c488$export$daf74670712de91) {
    constructor(...args){
        const options = (0, $e7ca80d35f04c488$export$1f008a47b72e40d9)(args, "Text");
        super(options, (0, $jZulE.TextStyle));
        this.renderPipeId = "text";
    }
    _updateBounds() {
        const bounds = this._bounds;
        const padding = this._style.padding;
        const anchor = this._anchor;
        const canvasMeasurement = (0, $gA7LB.CanvasTextMetrics).measureText(this._text, this._style);
        const { width: width, height: height } = canvasMeasurement;
        bounds.minX = -anchor._x * width - padding;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height - padding;
        bounds.maxY = bounds.minY + height;
    }
}







var $jxXUM = parcelRequire("jxXUM");



var $4CJdx = parcelRequire("4CJdx");










var $gpXaq = parcelRequire("gpXaq");





var $j0fPb = parcelRequire("j0fPb");







var $6sETp = parcelRequire("6sETp");




var $eH7tg = parcelRequire("eH7tg");
"use strict";
(0, $aqljF.extensions).add((0, $ee5df6e6b889b376$export$a6aad6334ef58a1c), (0, $9bed94e4c830c831$export$ee43dd1acddf6cf8));


var $jollT = parcelRequire("jollT");
var $jxXUM = parcelRequire("jxXUM");
/* Credit
    AntonNevsgodov <nevzgodov.anton@gmail.com>
*/ class $d47cae9fb86d08e6$var$$e8379818650e2442$export$93654d4f2d6cd524 {
    constructor(){
        this.encoder = new TextEncoder();
        this._pieces = [];
        this._parts = [];
    }
    append_buffer(data) {
        this.flush();
        this._parts.push(data);
    }
    append(data) {
        this._pieces.push(data);
    }
    flush() {
        if (this._pieces.length > 0) {
            const buf = new Uint8Array(this._pieces);
            this._parts.push(buf);
            this._pieces = [];
        }
    }
    toArrayBuffer() {
        const buffer = [];
        for (const part of this._parts)buffer.push(part);
        return $d47cae9fb86d08e6$var$$e8379818650e2442$var$concatArrayBuffers(buffer).buffer;
    }
}
function $d47cae9fb86d08e6$var$$e8379818650e2442$var$concatArrayBuffers(bufs) {
    let size = 0;
    for (const buf of bufs)size += buf.byteLength;
    const result = new Uint8Array(size);
    let offset = 0;
    for (const buf of bufs){
        const view = new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
        result.set(view, offset);
        offset += buf.byteLength;
    }
    return result;
}
function $d47cae9fb86d08e6$export$417857010dc9287f(data) {
    const unpacker = new $d47cae9fb86d08e6$var$$0cfd7828ad59115f$var$Unpacker(data);
    return unpacker.unpack();
}
function $d47cae9fb86d08e6$export$2a703dbb0cb35339(data) {
    const packer = new $d47cae9fb86d08e6$export$b9ec4b114aa40074();
    const res = packer.pack(data);
    if (res instanceof Promise) return res.then(()=>packer.getBuffer());
    return packer.getBuffer();
}
class $d47cae9fb86d08e6$var$$0cfd7828ad59115f$var$Unpacker {
    constructor(data){
        this.index = 0;
        this.dataBuffer = data;
        this.dataView = new Uint8Array(this.dataBuffer);
        this.length = this.dataBuffer.byteLength;
    }
    unpack() {
        const type = this.unpack_uint8();
        if (type < 0x80) return type;
        else if ((type ^ 0xe0) < 0x20) return (type ^ 0xe0) - 0x20;
        let size;
        if ((size = type ^ 0xa0) <= 0x0f) return this.unpack_raw(size);
        else if ((size = type ^ 0xb0) <= 0x0f) return this.unpack_string(size);
        else if ((size = type ^ 0x90) <= 0x0f) return this.unpack_array(size);
        else if ((size = type ^ 0x80) <= 0x0f) return this.unpack_map(size);
        switch(type){
            case 0xc0:
                return null;
            case 0xc1:
                return undefined;
            case 0xc2:
                return false;
            case 0xc3:
                return true;
            case 0xca:
                return this.unpack_float();
            case 0xcb:
                return this.unpack_double();
            case 0xcc:
                return this.unpack_uint8();
            case 0xcd:
                return this.unpack_uint16();
            case 0xce:
                return this.unpack_uint32();
            case 0xcf:
                return this.unpack_uint64();
            case 0xd0:
                return this.unpack_int8();
            case 0xd1:
                return this.unpack_int16();
            case 0xd2:
                return this.unpack_int32();
            case 0xd3:
                return this.unpack_int64();
            case 0xd4:
                return undefined;
            case 0xd5:
                return undefined;
            case 0xd6:
                return undefined;
            case 0xd7:
                return undefined;
            case 0xd8:
                size = this.unpack_uint16();
                return this.unpack_string(size);
            case 0xd9:
                size = this.unpack_uint32();
                return this.unpack_string(size);
            case 0xda:
                size = this.unpack_uint16();
                return this.unpack_raw(size);
            case 0xdb:
                size = this.unpack_uint32();
                return this.unpack_raw(size);
            case 0xdc:
                size = this.unpack_uint16();
                return this.unpack_array(size);
            case 0xdd:
                size = this.unpack_uint32();
                return this.unpack_array(size);
            case 0xde:
                size = this.unpack_uint16();
                return this.unpack_map(size);
            case 0xdf:
                size = this.unpack_uint32();
                return this.unpack_map(size);
        }
    }
    unpack_uint8() {
        const byte = this.dataView[this.index] & 0xff;
        this.index++;
        return byte;
    }
    unpack_uint16() {
        const bytes = this.read(2);
        const uint16 = (bytes[0] & 0xff) * 256 + (bytes[1] & 0xff);
        this.index += 2;
        return uint16;
    }
    unpack_uint32() {
        const bytes = this.read(4);
        const uint32 = ((bytes[0] * 256 + bytes[1]) * 256 + bytes[2]) * 256 + bytes[3];
        this.index += 4;
        return uint32;
    }
    unpack_uint64() {
        const bytes = this.read(8);
        const uint64 = ((((((bytes[0] * 256 + bytes[1]) * 256 + bytes[2]) * 256 + bytes[3]) * 256 + bytes[4]) * 256 + bytes[5]) * 256 + bytes[6]) * 256 + bytes[7];
        this.index += 8;
        return uint64;
    }
    unpack_int8() {
        const uint8 = this.unpack_uint8();
        return uint8 < 0x80 ? uint8 : uint8 - 256;
    }
    unpack_int16() {
        const uint16 = this.unpack_uint16();
        return uint16 < 0x8000 ? uint16 : uint16 - 65536;
    }
    unpack_int32() {
        const uint32 = this.unpack_uint32();
        return uint32 < 2 ** 31 ? uint32 : uint32 - 2 ** 32;
    }
    unpack_int64() {
        const uint64 = this.unpack_uint64();
        return uint64 < 2 ** 63 ? uint64 : uint64 - 2 ** 64;
    }
    unpack_raw(size) {
        if (this.length < this.index + size) throw new Error(`BinaryPackFailure: index is out of range ${this.index} ${size} ${this.length}`);
        const buf = this.dataBuffer.slice(this.index, this.index + size);
        this.index += size;
        return buf;
    }
    unpack_string(size) {
        const bytes = this.read(size);
        let i = 0;
        let str = "";
        let c;
        let code;
        while(i < size){
            c = bytes[i];
            // The length of a UTF-8 sequence is specified in the first byte:
            // 0xxxxxxx means length 1,
            // 110xxxxx means length 2,
            // 1110xxxx means length 3,
            // 11110xxx means length 4.
            // 10xxxxxx is for non-initial bytes.
            if (c < 0xa0) {
                // One-byte sequence: bits 0xxxxxxx
                code = c;
                i++;
            } else if ((c ^ 0xc0) < 0x20) {
                // Two-byte sequence: bits 110xxxxx 10xxxxxx
                code = (c & 0x1f) << 6 | bytes[i + 1] & 0x3f;
                i += 2;
            } else if ((c ^ 0xe0) < 0x10) {
                // Three-byte sequence: bits 1110xxxx 10xxxxxx 10xxxxxx
                code = (c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f;
                i += 3;
            } else {
                // Four-byte sequence: bits 11110xxx 10xxxxxx 10xxxxxx 10xxxxxx
                code = (c & 0x07) << 18 | (bytes[i + 1] & 0x3f) << 12 | (bytes[i + 2] & 0x3f) << 6 | bytes[i + 3] & 0x3f;
                i += 4;
            }
            str += String.fromCodePoint(code);
        }
        this.index += size;
        return str;
    }
    unpack_array(size) {
        const objects = new Array(size);
        for(let i = 0; i < size; i++)objects[i] = this.unpack();
        return objects;
    }
    unpack_map(size) {
        const map = {};
        for(let i = 0; i < size; i++){
            const key = this.unpack();
            map[key] = this.unpack();
        }
        return map;
    }
    unpack_float() {
        const uint32 = this.unpack_uint32();
        const sign = uint32 >> 31;
        const exp = (uint32 >> 23 & 0xff) - 127;
        const fraction = uint32 & 0x7fffff | 0x800000;
        return (sign === 0 ? 1 : -1) * fraction * 2 ** (exp - 23);
    }
    unpack_double() {
        const h32 = this.unpack_uint32();
        const l32 = this.unpack_uint32();
        const sign = h32 >> 31;
        const exp = (h32 >> 20 & 0x7ff) - 1023;
        const hfrac = h32 & 0xfffff | 0x100000;
        const frac = hfrac * 2 ** (exp - 20) + l32 * 2 ** (exp - 52);
        return (sign === 0 ? 1 : -1) * frac;
    }
    read(length) {
        const j = this.index;
        if (j + length <= this.length) return this.dataView.subarray(j, j + length);
        else throw new Error("BinaryPackFailure: read index out of range");
    }
}
class $d47cae9fb86d08e6$export$b9ec4b114aa40074 {
    getBuffer() {
        return this._bufferBuilder.toArrayBuffer();
    }
    pack(value) {
        if (typeof value === "string") this.pack_string(value);
        else if (typeof value === "number") {
            if (Math.floor(value) === value) this.pack_integer(value);
            else this.pack_double(value);
        } else if (typeof value === "boolean") {
            if (value === true) this._bufferBuilder.append(0xc3);
            else if (value === false) this._bufferBuilder.append(0xc2);
        } else if (value === undefined) this._bufferBuilder.append(0xc0);
        else if (typeof value === "object") {
            if (value === null) this._bufferBuilder.append(0xc0);
            else {
                const constructor = value.constructor;
                if (value instanceof Array) {
                    const res = this.pack_array(value);
                    if (res instanceof Promise) return res.then(()=>this._bufferBuilder.flush());
                } else if (value instanceof ArrayBuffer) this.pack_bin(new Uint8Array(value));
                else if ("BYTES_PER_ELEMENT" in value) {
                    const v = value;
                    this.pack_bin(new Uint8Array(v.buffer, v.byteOffset, v.byteLength));
                } else if (value instanceof Date) this.pack_string(value.toString());
                else if (value instanceof Blob) return value.arrayBuffer().then((buffer)=>{
                    this.pack_bin(new Uint8Array(buffer));
                    this._bufferBuilder.flush();
                });
                else if (constructor == Object || constructor.toString().startsWith("class")) {
                    const res = this.pack_object(value);
                    if (res instanceof Promise) return res.then(()=>this._bufferBuilder.flush());
                } else throw new Error(`Type "${constructor.toString()}" not yet supported`);
            }
        } else throw new Error(`Type "${typeof value}" not yet supported`);
        this._bufferBuilder.flush();
    }
    pack_bin(blob) {
        const length = blob.length;
        if (length <= 0x0f) this.pack_uint8(0xa0 + length);
        else if (length <= 0xffff) {
            this._bufferBuilder.append(0xda);
            this.pack_uint16(length);
        } else if (length <= 0xffffffff) {
            this._bufferBuilder.append(0xdb);
            this.pack_uint32(length);
        } else throw new Error("Invalid length");
        this._bufferBuilder.append_buffer(blob);
    }
    pack_string(str) {
        const encoded = this._textEncoder.encode(str);
        const length = encoded.length;
        if (length <= 0x0f) this.pack_uint8(0xb0 + length);
        else if (length <= 0xffff) {
            this._bufferBuilder.append(0xd8);
            this.pack_uint16(length);
        } else if (length <= 0xffffffff) {
            this._bufferBuilder.append(0xd9);
            this.pack_uint32(length);
        } else throw new Error("Invalid length");
        this._bufferBuilder.append_buffer(encoded);
    }
    pack_array(ary) {
        const length = ary.length;
        if (length <= 0x0f) this.pack_uint8(0x90 + length);
        else if (length <= 0xffff) {
            this._bufferBuilder.append(0xdc);
            this.pack_uint16(length);
        } else if (length <= 0xffffffff) {
            this._bufferBuilder.append(0xdd);
            this.pack_uint32(length);
        } else throw new Error("Invalid length");
        const packNext = (index)=>{
            if (index < length) {
                const res = this.pack(ary[index]);
                if (res instanceof Promise) return res.then(()=>packNext(index + 1));
                return packNext(index + 1);
            }
        };
        return packNext(0);
    }
    pack_integer(num) {
        if (num >= -32 && num <= 0x7f) this._bufferBuilder.append(num & 0xff);
        else if (num >= 0x00 && num <= 0xff) {
            this._bufferBuilder.append(0xcc);
            this.pack_uint8(num);
        } else if (num >= -128 && num <= 0x7f) {
            this._bufferBuilder.append(0xd0);
            this.pack_int8(num);
        } else if (num >= 0x0000 && num <= 0xffff) {
            this._bufferBuilder.append(0xcd);
            this.pack_uint16(num);
        } else if (num >= -32768 && num <= 0x7fff) {
            this._bufferBuilder.append(0xd1);
            this.pack_int16(num);
        } else if (num >= 0x00000000 && num <= 0xffffffff) {
            this._bufferBuilder.append(0xce);
            this.pack_uint32(num);
        } else if (num >= -2147483648 && num <= 0x7fffffff) {
            this._bufferBuilder.append(0xd2);
            this.pack_int32(num);
        } else if (num >= -9223372036854776000 && num <= 0x7fffffffffffffff) {
            this._bufferBuilder.append(0xd3);
            this.pack_int64(num);
        } else if (num >= 0x0000000000000000 && num <= 0xffffffffffffffff) {
            this._bufferBuilder.append(0xcf);
            this.pack_uint64(num);
        } else throw new Error("Invalid integer");
    }
    pack_double(num) {
        let sign = 0;
        if (num < 0) {
            sign = 1;
            num = -num;
        }
        const exp = Math.floor(Math.log(num) / Math.LN2);
        const frac0 = num / 2 ** exp - 1;
        const frac1 = Math.floor(frac0 * 2 ** 52);
        const b32 = 2 ** 32;
        const h32 = sign << 31 | exp + 1023 << 20 | frac1 / b32 & 0x0fffff;
        const l32 = frac1 % b32;
        this._bufferBuilder.append(0xcb);
        this.pack_int32(h32);
        this.pack_int32(l32);
    }
    pack_object(obj) {
        const keys = Object.keys(obj);
        const length = keys.length;
        if (length <= 0x0f) this.pack_uint8(0x80 + length);
        else if (length <= 0xffff) {
            this._bufferBuilder.append(0xde);
            this.pack_uint16(length);
        } else if (length <= 0xffffffff) {
            this._bufferBuilder.append(0xdf);
            this.pack_uint32(length);
        } else throw new Error("Invalid length");
        const packNext = (index)=>{
            if (index < keys.length) {
                const prop = keys[index];
                // eslint-disable-next-line no-prototype-builtins
                if (obj.hasOwnProperty(prop)) {
                    this.pack(prop);
                    const res = this.pack(obj[prop]);
                    if (res instanceof Promise) return res.then(()=>packNext(index + 1));
                }
                return packNext(index + 1);
            }
        };
        return packNext(0);
    }
    pack_uint8(num) {
        this._bufferBuilder.append(num);
    }
    pack_uint16(num) {
        this._bufferBuilder.append(num >> 8);
        this._bufferBuilder.append(num & 0xff);
    }
    pack_uint32(num) {
        const n = num & 0xffffffff;
        this._bufferBuilder.append((n & 0xff000000) >>> 24);
        this._bufferBuilder.append((n & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((n & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(n & 0x000000ff);
    }
    pack_uint64(num) {
        const high = num / 2 ** 32;
        const low = num % 2 ** 32;
        this._bufferBuilder.append((high & 0xff000000) >>> 24);
        this._bufferBuilder.append((high & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((high & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(high & 0x000000ff);
        this._bufferBuilder.append((low & 0xff000000) >>> 24);
        this._bufferBuilder.append((low & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((low & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(low & 0x000000ff);
    }
    pack_int8(num) {
        this._bufferBuilder.append(num & 0xff);
    }
    pack_int16(num) {
        this._bufferBuilder.append((num & 0xff00) >> 8);
        this._bufferBuilder.append(num & 0xff);
    }
    pack_int32(num) {
        this._bufferBuilder.append(num >>> 24 & 0xff);
        this._bufferBuilder.append((num & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((num & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(num & 0x000000ff);
    }
    pack_int64(num) {
        const high = Math.floor(num / 2 ** 32);
        const low = num % 2 ** 32;
        this._bufferBuilder.append((high & 0xff000000) >>> 24);
        this._bufferBuilder.append((high & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((high & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(high & 0x000000ff);
        this._bufferBuilder.append((low & 0xff000000) >>> 24);
        this._bufferBuilder.append((low & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((low & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(low & 0x000000ff);
    }
    constructor(){
        this._bufferBuilder = new $d47cae9fb86d08e6$var$$e8379818650e2442$export$93654d4f2d6cd524();
        this._textEncoder = new TextEncoder();
    }
}


/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
let $5b563905b3c142ef$var$logDisabled_ = true;
let $5b563905b3c142ef$var$deprecationWarnings_ = true;
function $5b563905b3c142ef$export$e3c02be309be1f23(uastring, expr, pos) {
    const match = uastring.match(expr);
    return match && match.length >= pos && parseInt(match[pos], 10);
}
function $5b563905b3c142ef$export$1f48841962b828b1(window1, eventNameToWrap, wrapper) {
    if (!window1.RTCPeerConnection) return;
    const proto = window1.RTCPeerConnection.prototype;
    const nativeAddEventListener = proto.addEventListener;
    proto.addEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap) return nativeAddEventListener.apply(this, arguments);
        const wrappedCallback = (e)=>{
            const modifiedEvent = wrapper(e);
            if (modifiedEvent) {
                if (cb.handleEvent) cb.handleEvent(modifiedEvent);
                else cb(modifiedEvent);
            }
        };
        this._eventMap = this._eventMap || {};
        if (!this._eventMap[eventNameToWrap]) this._eventMap[eventNameToWrap] = new Map();
        this._eventMap[eventNameToWrap].set(cb, wrappedCallback);
        return nativeAddEventListener.apply(this, [
            nativeEventName,
            wrappedCallback
        ]);
    };
    const nativeRemoveEventListener = proto.removeEventListener;
    proto.removeEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[eventNameToWrap]) return nativeRemoveEventListener.apply(this, arguments);
        if (!this._eventMap[eventNameToWrap].has(cb)) return nativeRemoveEventListener.apply(this, arguments);
        const unwrappedCb = this._eventMap[eventNameToWrap].get(cb);
        this._eventMap[eventNameToWrap].delete(cb);
        if (this._eventMap[eventNameToWrap].size === 0) delete this._eventMap[eventNameToWrap];
        if (Object.keys(this._eventMap).length === 0) delete this._eventMap;
        return nativeRemoveEventListener.apply(this, [
            nativeEventName,
            unwrappedCb
        ]);
    };
    Object.defineProperty(proto, "on" + eventNameToWrap, {
        get () {
            return this["_on" + eventNameToWrap];
        },
        set (cb) {
            if (this["_on" + eventNameToWrap]) {
                this.removeEventListener(eventNameToWrap, this["_on" + eventNameToWrap]);
                delete this["_on" + eventNameToWrap];
            }
            if (cb) this.addEventListener(eventNameToWrap, this["_on" + eventNameToWrap] = cb);
        },
        enumerable: true,
        configurable: true
    });
}
function $5b563905b3c142ef$export$afbfee8cc06fd3e4(bool) {
    if (typeof bool !== "boolean") return new Error("Argument type: " + typeof bool + ". Please use a boolean.");
    $5b563905b3c142ef$var$logDisabled_ = bool;
    return bool ? "adapter.js logging disabled" : "adapter.js logging enabled";
}
function $5b563905b3c142ef$export$51516be4b019e41e(bool) {
    if (typeof bool !== "boolean") return new Error("Argument type: " + typeof bool + ". Please use a boolean.");
    $5b563905b3c142ef$var$deprecationWarnings_ = !bool;
    return "adapter.js deprecation warnings " + (bool ? "disabled" : "enabled");
}
function $5b563905b3c142ef$export$bef1f36f5486a6a3() {
    if (typeof window === "object") {
        if ($5b563905b3c142ef$var$logDisabled_) return;
        if (typeof console !== "undefined" && typeof console.log === "function") console.log.apply(console, arguments);
    }
}
function $5b563905b3c142ef$export$cdd73fc4100a6ef4(oldMethod, newMethod) {
    if (!$5b563905b3c142ef$var$deprecationWarnings_) return;
    console.warn(oldMethod + " is deprecated, please use " + newMethod + " instead.");
}
function $5b563905b3c142ef$export$2d31490a0c05f094(window1) {
    // Returned result object.
    const result = {
        browser: null,
        version: null
    };
    // Fail early if it's not a browser
    if (typeof window1 === "undefined" || !window1.navigator || !window1.navigator.userAgent) {
        result.browser = "Not a browser.";
        return result;
    }
    const { navigator: navigator } = window1;
    if (navigator.mozGetUserMedia) {
        result.browser = "firefox";
        result.version = $5b563905b3c142ef$export$e3c02be309be1f23(navigator.userAgent, /Firefox\/(\d+)\./, 1);
    } else if (navigator.webkitGetUserMedia || window1.isSecureContext === false && window1.webkitRTCPeerConnection) {
        // Chrome, Chromium, Webview, Opera.
        // Version matches Chrome/WebRTC version.
        // Chrome 74 removed webkitGetUserMedia on http as well so we need the
        // more complicated fallback to webkitRTCPeerConnection.
        result.browser = "chrome";
        result.version = $5b563905b3c142ef$export$e3c02be309be1f23(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
    } else if (window1.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
        result.browser = "safari";
        result.version = $5b563905b3c142ef$export$e3c02be309be1f23(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1);
        result.supportsUnifiedPlan = window1.RTCRtpTransceiver && "currentDirection" in window1.RTCRtpTransceiver.prototype;
    } else {
        result.browser = "Not a supported browser.";
        return result;
    }
    return result;
}
/**
 * Checks if something is an object.
 *
 * @param {*} val The something you want to check.
 * @return true if val is an object, false otherwise.
 */ function $5b563905b3c142ef$var$isObject(val) {
    return Object.prototype.toString.call(val) === "[object Object]";
}
function $5b563905b3c142ef$export$15384eac40dc88c8(data) {
    if (!$5b563905b3c142ef$var$isObject(data)) return data;
    return Object.keys(data).reduce(function(accumulator, key) {
        const isObj = $5b563905b3c142ef$var$isObject(data[key]);
        const value = isObj ? $5b563905b3c142ef$export$15384eac40dc88c8(data[key]) : data[key];
        const isEmptyObject = isObj && !Object.keys(value).length;
        if (value === undefined || isEmptyObject) return accumulator;
        return Object.assign(accumulator, {
            [key]: value
        });
    }, {});
}
function $5b563905b3c142ef$export$571b373e75babb58(stats, base, resultSet) {
    if (!base || resultSet.has(base.id)) return;
    resultSet.set(base.id, base);
    Object.keys(base).forEach((name)=>{
        if (name.endsWith("Id")) $5b563905b3c142ef$export$571b373e75babb58(stats, stats.get(base[name]), resultSet);
        else if (name.endsWith("Ids")) base[name].forEach((id)=>{
            $5b563905b3c142ef$export$571b373e75babb58(stats, stats.get(id), resultSet);
        });
    });
}
function $5b563905b3c142ef$export$93439ffc3f787d51(result, track, outbound) {
    const streamStatsType = outbound ? "outbound-rtp" : "inbound-rtp";
    const filteredResult = new Map();
    if (track === null) return filteredResult;
    const trackStats = [];
    result.forEach((value)=>{
        if (value.type === "track" && value.trackIdentifier === track.id) trackStats.push(value);
    });
    trackStats.forEach((trackStat)=>{
        result.forEach((stats)=>{
            if (stats.type === streamStatsType && stats.trackId === trackStat.id) $5b563905b3c142ef$export$571b373e75babb58(result, stats, filteredResult);
        });
    });
    return filteredResult;
}


var $bc8e728c001d5ed6$exports = {};

$parcel$export($bc8e728c001d5ed6$exports, "shimMediaStream", () => $bc8e728c001d5ed6$export$33ee24e7a300bcd1);
$parcel$export($bc8e728c001d5ed6$exports, "shimOnTrack", () => $bc8e728c001d5ed6$export$f358708f68ab068);
$parcel$export($bc8e728c001d5ed6$exports, "shimGetSendersWithDtmf", () => $bc8e728c001d5ed6$export$a41a030a2842f5d6);
$parcel$export($bc8e728c001d5ed6$exports, "shimGetStats", () => $bc8e728c001d5ed6$export$90608323826f0b17);
$parcel$export($bc8e728c001d5ed6$exports, "shimSenderReceiverGetStats", () => $bc8e728c001d5ed6$export$f2f0f2338114eb4b);
$parcel$export($bc8e728c001d5ed6$exports, "shimAddTrackRemoveTrackWithNative", () => $bc8e728c001d5ed6$export$30e3cdd46f8d5100);
$parcel$export($bc8e728c001d5ed6$exports, "shimAddTrackRemoveTrack", () => $bc8e728c001d5ed6$export$9588259fcf4ebc91);
$parcel$export($bc8e728c001d5ed6$exports, "shimPeerConnection", () => $bc8e728c001d5ed6$export$852a08dda9a55ea7);
$parcel$export($bc8e728c001d5ed6$exports, "fixNegotiationNeeded", () => $bc8e728c001d5ed6$export$341293bbeaae37cb);
$parcel$export($bc8e728c001d5ed6$exports, "shimGetUserMedia", () => $2cbef99fbe83afe6$export$1ed4910f4d37dc5e);
$parcel$export($bc8e728c001d5ed6$exports, "shimGetDisplayMedia", () => $27b1de6aa169c2ce$export$97270b87351d9c04);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
"use strict";
const $2cbef99fbe83afe6$var$logging = $5b563905b3c142ef$export$bef1f36f5486a6a3;
function $2cbef99fbe83afe6$export$1ed4910f4d37dc5e(window, browserDetails) {
    const navigator = window && window.navigator;
    if (!navigator.mediaDevices) return;
    const constraintsToChrome_ = function(c) {
        if (typeof c !== "object" || c.mandatory || c.optional) return c;
        const cc = {};
        Object.keys(c).forEach((key)=>{
            if (key === "require" || key === "advanced" || key === "mediaSource") return;
            const r = typeof c[key] === "object" ? c[key] : {
                ideal: c[key]
            };
            if (r.exact !== undefined && typeof r.exact === "number") r.min = r.max = r.exact;
            const oldname_ = function(prefix, name) {
                if (prefix) return prefix + name.charAt(0).toUpperCase() + name.slice(1);
                return name === "deviceId" ? "sourceId" : name;
            };
            if (r.ideal !== undefined) {
                cc.optional = cc.optional || [];
                let oc = {};
                if (typeof r.ideal === "number") {
                    oc[oldname_("min", key)] = r.ideal;
                    cc.optional.push(oc);
                    oc = {};
                    oc[oldname_("max", key)] = r.ideal;
                    cc.optional.push(oc);
                } else {
                    oc[oldname_("", key)] = r.ideal;
                    cc.optional.push(oc);
                }
            }
            if (r.exact !== undefined && typeof r.exact !== "number") {
                cc.mandatory = cc.mandatory || {};
                cc.mandatory[oldname_("", key)] = r.exact;
            } else [
                "min",
                "max"
            ].forEach((mix)=>{
                if (r[mix] !== undefined) {
                    cc.mandatory = cc.mandatory || {};
                    cc.mandatory[oldname_(mix, key)] = r[mix];
                }
            });
        });
        if (c.advanced) cc.optional = (cc.optional || []).concat(c.advanced);
        return cc;
    };
    const shimConstraints_ = function(constraints, func) {
        if (browserDetails.version >= 61) return func(constraints);
        constraints = JSON.parse(JSON.stringify(constraints));
        if (constraints && typeof constraints.audio === "object") {
            const remap = function(obj, a, b) {
                if (a in obj && !(b in obj)) {
                    obj[b] = obj[a];
                    delete obj[a];
                }
            };
            constraints = JSON.parse(JSON.stringify(constraints));
            remap(constraints.audio, "autoGainControl", "googAutoGainControl");
            remap(constraints.audio, "noiseSuppression", "googNoiseSuppression");
            constraints.audio = constraintsToChrome_(constraints.audio);
        }
        if (constraints && typeof constraints.video === "object") {
            // Shim facingMode for mobile & surface pro.
            let face = constraints.video.facingMode;
            face = face && (typeof face === "object" ? face : {
                ideal: face
            });
            const getSupportedFacingModeLies = browserDetails.version < 66;
            if (face && (face.exact === "user" || face.exact === "environment" || face.ideal === "user" || face.ideal === "environment") && !(navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
                delete constraints.video.facingMode;
                let matches;
                if (face.exact === "environment" || face.ideal === "environment") matches = [
                    "back",
                    "rear"
                ];
                else if (face.exact === "user" || face.ideal === "user") matches = [
                    "front"
                ];
                if (matches) // Look for matches in label, or use last cam for back (typical).
                return navigator.mediaDevices.enumerateDevices().then((devices)=>{
                    devices = devices.filter((d)=>d.kind === "videoinput");
                    let dev = devices.find((d)=>matches.some((match)=>d.label.toLowerCase().includes(match)));
                    if (!dev && devices.length && matches.includes("back")) dev = devices[devices.length - 1]; // more likely the back cam
                    if (dev) constraints.video.deviceId = face.exact ? {
                        exact: dev.deviceId
                    } : {
                        ideal: dev.deviceId
                    };
                    constraints.video = constraintsToChrome_(constraints.video);
                    $2cbef99fbe83afe6$var$logging("chrome: " + JSON.stringify(constraints));
                    return func(constraints);
                });
            }
            constraints.video = constraintsToChrome_(constraints.video);
        }
        $2cbef99fbe83afe6$var$logging("chrome: " + JSON.stringify(constraints));
        return func(constraints);
    };
    const shimError_ = function(e) {
        if (browserDetails.version >= 64) return e;
        return {
            name: ({
                PermissionDeniedError: "NotAllowedError",
                PermissionDismissedError: "NotAllowedError",
                InvalidStateError: "NotAllowedError",
                DevicesNotFoundError: "NotFoundError",
                ConstraintNotSatisfiedError: "OverconstrainedError",
                TrackStartError: "NotReadableError",
                MediaDeviceFailedDueToShutdown: "NotAllowedError",
                MediaDeviceKillSwitchOn: "NotAllowedError",
                TabCaptureError: "AbortError",
                ScreenCaptureError: "AbortError",
                DeviceCaptureError: "AbortError"
            })[e.name] || e.name,
            message: e.message,
            constraint: e.constraint || e.constraintName,
            toString () {
                return this.name + (this.message && ": ") + this.message;
            }
        };
    };
    const getUserMedia_ = function(constraints, onSuccess, onError) {
        shimConstraints_(constraints, (c)=>{
            navigator.webkitGetUserMedia(c, onSuccess, (e)=>{
                if (onError) onError(shimError_(e));
            });
        });
    };
    navigator.getUserMedia = getUserMedia_.bind(navigator);
    // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
    // function which returns a Promise, it does not accept spec-style
    // constraints.
    if (navigator.mediaDevices.getUserMedia) {
        const origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function(cs) {
            return shimConstraints_(cs, (c)=>origGetUserMedia(c).then((stream)=>{
                    if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
                        stream.getTracks().forEach((track)=>{
                            track.stop();
                        });
                        throw new DOMException("", "NotFoundError");
                    }
                    return stream;
                }, (e)=>Promise.reject(shimError_(e))));
        };
    }
}


/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
function $27b1de6aa169c2ce$export$97270b87351d9c04(window, getSourceId) {
    if (window.navigator.mediaDevices && "getDisplayMedia" in window.navigator.mediaDevices) return;
    if (!window.navigator.mediaDevices) return;
    // getSourceId is a function that returns a promise resolving with
    // the sourceId of the screen/window/tab to be shared.
    if (typeof getSourceId !== "function") {
        console.error("shimGetDisplayMedia: getSourceId argument is not a function");
        return;
    }
    window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        return getSourceId(constraints).then((sourceId)=>{
            const widthSpecified = constraints.video && constraints.video.width;
            const heightSpecified = constraints.video && constraints.video.height;
            const frameRateSpecified = constraints.video && constraints.video.frameRate;
            constraints.video = {
                mandatory: {
                    chromeMediaSource: "desktop",
                    chromeMediaSourceId: sourceId,
                    maxFrameRate: frameRateSpecified || 3
                }
            };
            if (widthSpecified) constraints.video.mandatory.maxWidth = widthSpecified;
            if (heightSpecified) constraints.video.mandatory.maxHeight = heightSpecified;
            return window.navigator.mediaDevices.getUserMedia(constraints);
        });
    };
}


"use strict";
function $bc8e728c001d5ed6$export$33ee24e7a300bcd1(window) {
    window.MediaStream = window.MediaStream || window.webkitMediaStream;
}
function $bc8e728c001d5ed6$export$f358708f68ab068(window) {
    if (typeof window === "object" && window.RTCPeerConnection && !("ontrack" in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, "ontrack", {
            get () {
                return this._ontrack;
            },
            set (f) {
                if (this._ontrack) this.removeEventListener("track", this._ontrack);
                this.addEventListener("track", this._ontrack = f);
            },
            enumerable: true,
            configurable: true
        });
        const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            if (!this._ontrackpoly) {
                this._ontrackpoly = (e)=>{
                    // onaddstream does not fire when a track is added to an existing
                    // stream. But stream.onaddtrack is implemented so we use that.
                    e.stream.addEventListener("addtrack", (te)=>{
                        let receiver;
                        if (window.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === te.track.id);
                        else receiver = {
                            track: te.track
                        };
                        const event = new Event("track");
                        event.track = te.track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                    e.stream.getTracks().forEach((track)=>{
                        let receiver;
                        if (window.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === track.id);
                        else receiver = {
                            track: track
                        };
                        const event = new Event("track");
                        event.track = track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                };
                this.addEventListener("addstream", this._ontrackpoly);
            }
            return origSetRemoteDescription.apply(this, arguments);
        };
    } else // even if RTCRtpTransceiver is in window, it is only used and
    // emitted in unified-plan. Unfortunately this means we need
    // to unconditionally wrap the event.
    $5b563905b3c142ef$export$1f48841962b828b1(window, "track", (e)=>{
        if (!e.transceiver) Object.defineProperty(e, "transceiver", {
            value: {
                receiver: e.receiver
            }
        });
        return e;
    });
}
function $bc8e728c001d5ed6$export$a41a030a2842f5d6(window) {
    // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
    if (typeof window === "object" && window.RTCPeerConnection && !("getSenders" in window.RTCPeerConnection.prototype) && "createDTMFSender" in window.RTCPeerConnection.prototype) {
        const shimSenderWithDtmf = function(pc, track) {
            return {
                track: track,
                get dtmf () {
                    if (this._dtmf === undefined) {
                        if (track.kind === "audio") this._dtmf = pc.createDTMFSender(track);
                        else this._dtmf = null;
                    }
                    return this._dtmf;
                },
                _pc: pc
            };
        };
        // augment addTrack when getSenders is not available.
        if (!window.RTCPeerConnection.prototype.getSenders) {
            window.RTCPeerConnection.prototype.getSenders = function getSenders() {
                this._senders = this._senders || [];
                return this._senders.slice(); // return a copy of the internal state.
            };
            const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
            window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
                let sender = origAddTrack.apply(this, arguments);
                if (!sender) {
                    sender = shimSenderWithDtmf(this, track);
                    this._senders.push(sender);
                }
                return sender;
            };
            const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
            window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
                origRemoveTrack.apply(this, arguments);
                const idx = this._senders.indexOf(sender);
                if (idx !== -1) this._senders.splice(idx, 1);
            };
        }
        const origAddStream = window.RTCPeerConnection.prototype.addStream;
        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            this._senders = this._senders || [];
            origAddStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                this._senders.push(shimSenderWithDtmf(this, track));
            });
        };
        const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
        window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
            this._senders = this._senders || [];
            origRemoveStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                const sender = this._senders.find((s)=>s.track === track);
                if (sender) this._senders.splice(this._senders.indexOf(sender), 1);
            });
        };
    } else if (typeof window === "object" && window.RTCPeerConnection && "getSenders" in window.RTCPeerConnection.prototype && "createDTMFSender" in window.RTCPeerConnection.prototype && window.RTCRtpSender && !("dtmf" in window.RTCRtpSender.prototype)) {
        const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
        window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        Object.defineProperty(window.RTCRtpSender.prototype, "dtmf", {
            get () {
                if (this._dtmf === undefined) {
                    if (this.track.kind === "audio") this._dtmf = this._pc.createDTMFSender(this.track);
                    else this._dtmf = null;
                }
                return this._dtmf;
            }
        });
    }
}
function $bc8e728c001d5ed6$export$90608323826f0b17(window) {
    if (!window.RTCPeerConnection) return;
    const origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        // If selector is a function then we are in the old style stats so just
        // pass back the original getStats format to avoid breaking old users.
        if (arguments.length > 0 && typeof selector === "function") return origGetStats.apply(this, arguments);
        // When spec-style getStats is supported, return those when called with
        // either no arguments or the selector argument is null.
        if (origGetStats.length === 0 && (arguments.length === 0 || typeof selector !== "function")) return origGetStats.apply(this, []);
        const fixChromeStats_ = function(response) {
            const standardReport = {};
            const reports = response.result();
            reports.forEach((report)=>{
                const standardStats = {
                    id: report.id,
                    timestamp: report.timestamp,
                    type: {
                        localcandidate: "local-candidate",
                        remotecandidate: "remote-candidate"
                    }[report.type] || report.type
                };
                report.names().forEach((name)=>{
                    standardStats[name] = report.stat(name);
                });
                standardReport[standardStats.id] = standardStats;
            });
            return standardReport;
        };
        // shim getStats with maplike support
        const makeMapStats = function(stats) {
            return new Map(Object.keys(stats).map((key)=>[
                    key,
                    stats[key]
                ]));
        };
        if (arguments.length >= 2) {
            const successCallbackWrapper_ = function(response) {
                onSucc(makeMapStats(fixChromeStats_(response)));
            };
            return origGetStats.apply(this, [
                successCallbackWrapper_,
                selector
            ]);
        }
        // promise-support
        return new Promise((resolve, reject)=>{
            origGetStats.apply(this, [
                function(response) {
                    resolve(makeMapStats(fixChromeStats_(response)));
                },
                reject
            ]);
        }).then(onSucc, onErr);
    };
}
function $bc8e728c001d5ed6$export$f2f0f2338114eb4b(window) {
    if (!(typeof window === "object" && window.RTCPeerConnection && window.RTCRtpSender && window.RTCRtpReceiver)) return;
    // shim sender stats.
    if (!("getStats" in window.RTCRtpSender.prototype)) {
        const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
        if (origGetSenders) window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
        if (origAddTrack) window.RTCPeerConnection.prototype.addTrack = function addTrack() {
            const sender = origAddTrack.apply(this, arguments);
            sender._pc = this;
            return sender;
        };
        window.RTCRtpSender.prototype.getStats = function getStats() {
            const sender = this;
            return this._pc.getStats().then((result)=>/* Note: this will include stats of all senders that
         *   send a track with the same id as sender.track as
         *   it is not possible to identify the RTCRtpSender.
         */ $5b563905b3c142ef$export$93439ffc3f787d51(result, sender.track, true));
        };
    }
    // shim receiver stats.
    if (!("getStats" in window.RTCRtpReceiver.prototype)) {
        const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
        if (origGetReceivers) window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
            const receivers = origGetReceivers.apply(this, []);
            receivers.forEach((receiver)=>receiver._pc = this);
            return receivers;
        };
        $5b563905b3c142ef$export$1f48841962b828b1(window, "track", (e)=>{
            e.receiver._pc = e.srcElement;
            return e;
        });
        window.RTCRtpReceiver.prototype.getStats = function getStats() {
            const receiver = this;
            return this._pc.getStats().then((result)=>$5b563905b3c142ef$export$93439ffc3f787d51(result, receiver.track, false));
        };
    }
    if (!("getStats" in window.RTCRtpSender.prototype && "getStats" in window.RTCRtpReceiver.prototype)) return;
    // shim RTCPeerConnection.getStats(track).
    const origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        if (arguments.length > 0 && arguments[0] instanceof window.MediaStreamTrack) {
            const track = arguments[0];
            let sender;
            let receiver;
            let err;
            this.getSenders().forEach((s)=>{
                if (s.track === track) {
                    if (sender) err = true;
                    else sender = s;
                }
            });
            this.getReceivers().forEach((r)=>{
                if (r.track === track) {
                    if (receiver) err = true;
                    else receiver = r;
                }
                return r.track === track;
            });
            if (err || sender && receiver) return Promise.reject(new DOMException("There are more than one sender or receiver for the track.", "InvalidAccessError"));
            else if (sender) return sender.getStats();
            else if (receiver) return receiver.getStats();
            return Promise.reject(new DOMException("There is no sender or receiver for the track.", "InvalidAccessError"));
        }
        return origGetStats.apply(this, arguments);
    };
}
function $bc8e728c001d5ed6$export$30e3cdd46f8d5100(window) {
    // shim addTrack/removeTrack with native variants in order to make
    // the interactions with legacy getLocalStreams behave as in other browsers.
    // Keeps a mapping stream.id => [stream, rtpsenders...]
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        return Object.keys(this._shimmedLocalStreams).map((streamId)=>this._shimmedLocalStreams[streamId][0]);
    };
    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (!stream) return origAddTrack.apply(this, arguments);
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        const sender = origAddTrack.apply(this, arguments);
        if (!this._shimmedLocalStreams[stream.id]) this._shimmedLocalStreams[stream.id] = [
            stream,
            sender
        ];
        else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) this._shimmedLocalStreams[stream.id].push(sender);
        return sender;
    };
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        });
        const existingSenders = this.getSenders();
        origAddStream.apply(this, arguments);
        const newSenders = this.getSenders().filter((newSender)=>existingSenders.indexOf(newSender) === -1);
        this._shimmedLocalStreams[stream.id] = [
            stream
        ].concat(newSenders);
    };
    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        delete this._shimmedLocalStreams[stream.id];
        return origRemoveStream.apply(this, arguments);
    };
    const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
    window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        if (sender) Object.keys(this._shimmedLocalStreams).forEach((streamId)=>{
            const idx = this._shimmedLocalStreams[streamId].indexOf(sender);
            if (idx !== -1) this._shimmedLocalStreams[streamId].splice(idx, 1);
            if (this._shimmedLocalStreams[streamId].length === 1) delete this._shimmedLocalStreams[streamId];
        });
        return origRemoveTrack.apply(this, arguments);
    };
}
function $bc8e728c001d5ed6$export$9588259fcf4ebc91(window, browserDetails) {
    if (!window.RTCPeerConnection) return;
    // shim addTrack and removeTrack.
    if (window.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) return $bc8e728c001d5ed6$export$30e3cdd46f8d5100(window);
    // also shim pc.getLocalStreams when addTrack is shimmed
    // to return the original streams.
    const origGetLocalStreams = window.RTCPeerConnection.prototype.getLocalStreams;
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        const nativeStreams = origGetLocalStreams.apply(this);
        this._reverseStreams = this._reverseStreams || {};
        return nativeStreams.map((stream)=>this._reverseStreams[stream.id]);
    };
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        });
        // Add identity mapping for consistency with addTrack.
        // Unless this is being used with a stream from addTrack.
        if (!this._reverseStreams[stream.id]) {
            const newStream = new window.MediaStream(stream.getTracks());
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            stream = newStream;
        }
        origAddStream.apply(this, [
            stream
        ]);
    };
    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        origRemoveStream.apply(this, [
            this._streams[stream.id] || stream
        ]);
        delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
        delete this._streams[stream.id];
    };
    window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (this.signalingState === "closed") throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
        const streams = [].slice.call(arguments, 1);
        if (streams.length !== 1 || !streams[0].getTracks().find((t)=>t === track)) // this is not fully correct but all we can manage without
        // [[associated MediaStreams]] internal slot.
        throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.", "NotSupportedError");
        const alreadyExists = this.getSenders().find((s)=>s.track === track);
        if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        const oldStream = this._streams[stream.id];
        if (oldStream) {
            // this is using odd Chrome behaviour, use with caution:
            // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
            // Note: we rely on the high-level addTrack/dtmf shim to
            // create the sender with a dtmf sender.
            oldStream.addTrack(track);
            // Trigger ONN async.
            Promise.resolve().then(()=>{
                this.dispatchEvent(new Event("negotiationneeded"));
            });
        } else {
            const newStream = new window.MediaStream([
                track
            ]);
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            this.addStream(newStream);
        }
        return this.getSenders().find((s)=>s.track === track);
    };
    // replace the internal stream id with the external one and
    // vice versa.
    function replaceInternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(internalStream.id, "g"), externalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    function replaceExternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(externalStream.id, "g"), internalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    [
        "createOffer",
        "createAnswer"
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                const args = arguments;
                const isLegacyCall = arguments.length && typeof arguments[0] === "function";
                if (isLegacyCall) return nativeMethod.apply(this, [
                    (description)=>{
                        const desc = replaceInternalStreamId(this, description);
                        args[0].apply(null, [
                            desc
                        ]);
                    },
                    (err)=>{
                        if (args[1]) args[1].apply(null, err);
                    },
                    arguments[2]
                ]);
                return nativeMethod.apply(this, arguments).then((description)=>replaceInternalStreamId(this, description));
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const origSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
    window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        if (!arguments.length || !arguments[0].type) return origSetLocalDescription.apply(this, arguments);
        arguments[0] = replaceExternalStreamId(this, arguments[0]);
        return origSetLocalDescription.apply(this, arguments);
    };
    // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier
    const origLocalDescription = Object.getOwnPropertyDescriptor(window.RTCPeerConnection.prototype, "localDescription");
    Object.defineProperty(window.RTCPeerConnection.prototype, "localDescription", {
        get () {
            const description = origLocalDescription.get.apply(this);
            if (description.type === "") return description;
            return replaceInternalStreamId(this, description);
        }
    });
    window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        if (this.signalingState === "closed") throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
        // We can not yet check for sender instanceof RTCRtpSender
        // since we shim RTPSender. So we check if sender._pc is set.
        if (!sender._pc) throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", "TypeError");
        const isLocal = sender._pc === this;
        if (!isLocal) throw new DOMException("Sender was not created by this connection.", "InvalidAccessError");
        // Search for the native stream the senders track belongs to.
        this._streams = this._streams || {};
        let stream;
        Object.keys(this._streams).forEach((streamid)=>{
            const hasTrack = this._streams[streamid].getTracks().find((track)=>sender.track === track);
            if (hasTrack) stream = this._streams[streamid];
        });
        if (stream) {
            if (stream.getTracks().length === 1) // if this is the last track of the stream, remove the stream. This
            // takes care of any shimmed _senders.
            this.removeStream(this._reverseStreams[stream.id]);
            else // relying on the same odd chrome behaviour as above.
            stream.removeTrack(sender.track);
            this.dispatchEvent(new Event("negotiationneeded"));
        }
    };
}
function $bc8e728c001d5ed6$export$852a08dda9a55ea7(window, browserDetails) {
    if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) // very basic support for old versions.
    window.RTCPeerConnection = window.webkitRTCPeerConnection;
    if (!window.RTCPeerConnection) return;
    // shim implicit creation of RTCSessionDescription/RTCIceCandidate
    if (browserDetails.version < 53) [
        "setLocalDescription",
        "setRemoteDescription",
        "addIceCandidate"
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === "addIceCandidate" ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
}
function $bc8e728c001d5ed6$export$341293bbeaae37cb(window, browserDetails) {
    $5b563905b3c142ef$export$1f48841962b828b1(window, "negotiationneeded", (e)=>{
        const pc = e.target;
        if (browserDetails.version < 72 || pc.getConfiguration && pc.getConfiguration().sdpSemantics === "plan-b") {
            if (pc.signalingState !== "stable") return;
        }
        return e;
    });
}


var $18b983d360dbaced$exports = {};

$parcel$export($18b983d360dbaced$exports, "shimOnTrack", () => $18b983d360dbaced$export$f358708f68ab068);
$parcel$export($18b983d360dbaced$exports, "shimPeerConnection", () => $18b983d360dbaced$export$852a08dda9a55ea7);
$parcel$export($18b983d360dbaced$exports, "shimSenderGetStats", () => $18b983d360dbaced$export$f0525502095c04ef);
$parcel$export($18b983d360dbaced$exports, "shimReceiverGetStats", () => $18b983d360dbaced$export$83d69126527b1171);
$parcel$export($18b983d360dbaced$exports, "shimRemoveStream", () => $18b983d360dbaced$export$825e523ef749bd8c);
$parcel$export($18b983d360dbaced$exports, "shimRTCDataChannel", () => $18b983d360dbaced$export$ff9cb3bc8990e8f7);
$parcel$export($18b983d360dbaced$exports, "shimAddTransceiver", () => $18b983d360dbaced$export$70c77533b6e9908d);
$parcel$export($18b983d360dbaced$exports, "shimGetParameters", () => $18b983d360dbaced$export$66238223c298fbaa);
$parcel$export($18b983d360dbaced$exports, "shimCreateOffer", () => $18b983d360dbaced$export$51beccf0e777b843);
$parcel$export($18b983d360dbaced$exports, "shimCreateAnswer", () => $18b983d360dbaced$export$df0b46e7cef08150);
$parcel$export($18b983d360dbaced$exports, "shimGetUserMedia", () => $fb03f91c343d8c8f$export$1ed4910f4d37dc5e);
$parcel$export($18b983d360dbaced$exports, "shimGetDisplayMedia", () => $a0be8c28aef5e980$export$97270b87351d9c04);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
"use strict";
function $fb03f91c343d8c8f$export$1ed4910f4d37dc5e(window, browserDetails) {
    const navigator = window && window.navigator;
    const MediaStreamTrack = window && window.MediaStreamTrack;
    navigator.getUserMedia = function(constraints, onSuccess, onError) {
        // Replace Firefox 44+'s deprecation warning with unprefixed version.
        $5b563905b3c142ef$export$cdd73fc4100a6ef4("navigator.getUserMedia", "navigator.mediaDevices.getUserMedia");
        navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
    };
    if (!(browserDetails.version > 55 && "autoGainControl" in navigator.mediaDevices.getSupportedConstraints())) {
        const remap = function(obj, a, b) {
            if (a in obj && !(b in obj)) {
                obj[b] = obj[a];
                delete obj[a];
            }
        };
        const nativeGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function(c) {
            if (typeof c === "object" && typeof c.audio === "object") {
                c = JSON.parse(JSON.stringify(c));
                remap(c.audio, "autoGainControl", "mozAutoGainControl");
                remap(c.audio, "noiseSuppression", "mozNoiseSuppression");
            }
            return nativeGetUserMedia(c);
        };
        if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
            const nativeGetSettings = MediaStreamTrack.prototype.getSettings;
            MediaStreamTrack.prototype.getSettings = function() {
                const obj = nativeGetSettings.apply(this, arguments);
                remap(obj, "mozAutoGainControl", "autoGainControl");
                remap(obj, "mozNoiseSuppression", "noiseSuppression");
                return obj;
            };
        }
        if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
            const nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;
            MediaStreamTrack.prototype.applyConstraints = function(c) {
                if (this.kind === "audio" && typeof c === "object") {
                    c = JSON.parse(JSON.stringify(c));
                    remap(c, "autoGainControl", "mozAutoGainControl");
                    remap(c, "noiseSuppression", "mozNoiseSuppression");
                }
                return nativeApplyConstraints.apply(this, [
                    c
                ]);
            };
        }
    }
}


/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
function $a0be8c28aef5e980$export$97270b87351d9c04(window, preferredMediaSource) {
    if (window.navigator.mediaDevices && "getDisplayMedia" in window.navigator.mediaDevices) return;
    if (!window.navigator.mediaDevices) return;
    window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        if (!(constraints && constraints.video)) {
            const err = new DOMException("getDisplayMedia without video constraints is undefined");
            err.name = "NotFoundError";
            // from https://heycam.github.io/webidl/#idl-DOMException-error-names
            err.code = 8;
            return Promise.reject(err);
        }
        if (constraints.video === true) constraints.video = {
            mediaSource: preferredMediaSource
        };
        else constraints.video.mediaSource = preferredMediaSource;
        return window.navigator.mediaDevices.getUserMedia(constraints);
    };
}


"use strict";
function $18b983d360dbaced$export$f358708f68ab068(window) {
    if (typeof window === "object" && window.RTCTrackEvent && "receiver" in window.RTCTrackEvent.prototype && !("transceiver" in window.RTCTrackEvent.prototype)) Object.defineProperty(window.RTCTrackEvent.prototype, "transceiver", {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $18b983d360dbaced$export$852a08dda9a55ea7(window, browserDetails) {
    if (typeof window !== "object" || !(window.RTCPeerConnection || window.mozRTCPeerConnection)) return; // probably media.peerconnection.enabled=false in about:config
    if (!window.RTCPeerConnection && window.mozRTCPeerConnection) // very basic support for old versions.
    window.RTCPeerConnection = window.mozRTCPeerConnection;
    if (browserDetails.version < 53) // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    [
        "setLocalDescription",
        "setRemoteDescription",
        "addIceCandidate"
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === "addIceCandidate" ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const modernStatsTypes = {
        inboundrtp: "inbound-rtp",
        outboundrtp: "outbound-rtp",
        candidatepair: "candidate-pair",
        localcandidate: "local-candidate",
        remotecandidate: "remote-candidate"
    };
    const nativeGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        return nativeGetStats.apply(this, [
            selector || null
        ]).then((stats)=>{
            if (browserDetails.version < 53 && !onSucc) // Shim only promise getStats with spec-hyphens in type names
            // Leave callback version alone; misc old uses of forEach before Map
            try {
                stats.forEach((stat)=>{
                    stat.type = modernStatsTypes[stat.type] || stat.type;
                });
            } catch (e) {
                if (e.name !== "TypeError") throw e;
                // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
                stats.forEach((stat, i)=>{
                    stats.set(i, Object.assign({}, stat, {
                        type: modernStatsTypes[stat.type] || stat.type
                    }));
                });
            }
            return stats;
        }).then(onSucc, onErr);
    };
}
function $18b983d360dbaced$export$f0525502095c04ef(window) {
    if (!(typeof window === "object" && window.RTCPeerConnection && window.RTCRtpSender)) return;
    if (window.RTCRtpSender && "getStats" in window.RTCRtpSender.prototype) return;
    const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) window.RTCPeerConnection.prototype.getSenders = function getSenders() {
        const senders = origGetSenders.apply(this, []);
        senders.forEach((sender)=>sender._pc = this);
        return senders;
    };
    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) window.RTCPeerConnection.prototype.addTrack = function addTrack() {
        const sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
    };
    window.RTCRtpSender.prototype.getStats = function getStats() {
        return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
    };
}
function $18b983d360dbaced$export$83d69126527b1171(window) {
    if (!(typeof window === "object" && window.RTCPeerConnection && window.RTCRtpSender)) return;
    if (window.RTCRtpSender && "getStats" in window.RTCRtpReceiver.prototype) return;
    const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
        const receivers = origGetReceivers.apply(this, []);
        receivers.forEach((receiver)=>receiver._pc = this);
        return receivers;
    };
    $5b563905b3c142ef$export$1f48841962b828b1(window, "track", (e)=>{
        e.receiver._pc = e.srcElement;
        return e;
    });
    window.RTCRtpReceiver.prototype.getStats = function getStats() {
        return this._pc.getStats(this.track);
    };
}
function $18b983d360dbaced$export$825e523ef749bd8c(window) {
    if (!window.RTCPeerConnection || "removeStream" in window.RTCPeerConnection.prototype) return;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        $5b563905b3c142ef$export$cdd73fc4100a6ef4("removeStream", "removeTrack");
        this.getSenders().forEach((sender)=>{
            if (sender.track && stream.getTracks().includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $18b983d360dbaced$export$ff9cb3bc8990e8f7(window) {
    // rename DataChannel to RTCDataChannel (native fix in FF60):
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
    if (window.DataChannel && !window.RTCDataChannel) window.RTCDataChannel = window.DataChannel;
}
function $18b983d360dbaced$export$70c77533b6e9908d(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === "object" && window.RTCPeerConnection)) return;
    const origAddTransceiver = window.RTCPeerConnection.prototype.addTransceiver;
    if (origAddTransceiver) window.RTCPeerConnection.prototype.addTransceiver = function addTransceiver() {
        this.setParametersPromises = [];
        // WebIDL input coercion and validation
        let sendEncodings = arguments[1] && arguments[1].sendEncodings;
        if (sendEncodings === undefined) sendEncodings = [];
        sendEncodings = [
            ...sendEncodings
        ];
        const shouldPerformCheck = sendEncodings.length > 0;
        if (shouldPerformCheck) // If sendEncodings params are provided, validate grammar
        sendEncodings.forEach((encodingParam)=>{
            if ("rid" in encodingParam) {
                const ridRegex = /^[a-z0-9]{0,16}$/i;
                if (!ridRegex.test(encodingParam.rid)) throw new TypeError("Invalid RID value provided.");
            }
            if ("scaleResolutionDownBy" in encodingParam) {
                if (!(parseFloat(encodingParam.scaleResolutionDownBy) >= 1.0)) throw new RangeError("scale_resolution_down_by must be >= 1.0");
            }
            if ("maxFramerate" in encodingParam) {
                if (!(parseFloat(encodingParam.maxFramerate) >= 0)) throw new RangeError("max_framerate must be >= 0.0");
            }
        });
        const transceiver = origAddTransceiver.apply(this, arguments);
        if (shouldPerformCheck) {
            // Check if the init options were applied. If not we do this in an
            // asynchronous way and save the promise reference in a global object.
            // This is an ugly hack, but at the same time is way more robust than
            // checking the sender parameters before and after the createOffer
            // Also note that after the createoffer we are not 100% sure that
            // the params were asynchronously applied so we might miss the
            // opportunity to recreate offer.
            const { sender: sender } = transceiver;
            const params = sender.getParameters();
            if (!("encodings" in params) || // Avoid being fooled by patched getParameters() below.
            params.encodings.length === 1 && Object.keys(params.encodings[0]).length === 0) {
                params.encodings = sendEncodings;
                sender.sendEncodings = sendEncodings;
                this.setParametersPromises.push(sender.setParameters(params).then(()=>{
                    delete sender.sendEncodings;
                }).catch(()=>{
                    delete sender.sendEncodings;
                }));
            }
        }
        return transceiver;
    };
}
function $18b983d360dbaced$export$66238223c298fbaa(window) {
    if (!(typeof window === "object" && window.RTCRtpSender)) return;
    const origGetParameters = window.RTCRtpSender.prototype.getParameters;
    if (origGetParameters) window.RTCRtpSender.prototype.getParameters = function getParameters() {
        const params = origGetParameters.apply(this, arguments);
        if (!("encodings" in params)) params.encodings = [].concat(this.sendEncodings || [
            {}
        ]);
        return params;
    };
}
function $18b983d360dbaced$export$51beccf0e777b843(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === "object" && window.RTCPeerConnection)) return;
    const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function createOffer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateOffer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateOffer.apply(this, arguments);
    };
}
function $18b983d360dbaced$export$df0b46e7cef08150(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === "object" && window.RTCPeerConnection)) return;
    const origCreateAnswer = window.RTCPeerConnection.prototype.createAnswer;
    window.RTCPeerConnection.prototype.createAnswer = function createAnswer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateAnswer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateAnswer.apply(this, arguments);
    };
}


var $8df7b0829cc8430e$exports = {};

$parcel$export($8df7b0829cc8430e$exports, "shimLocalStreamsAPI", () => $8df7b0829cc8430e$export$8df41282f4fdcea2);
$parcel$export($8df7b0829cc8430e$exports, "shimRemoteStreamsAPI", () => $8df7b0829cc8430e$export$762aa4cbb4f2f857);
$parcel$export($8df7b0829cc8430e$exports, "shimCallbacksAPI", () => $8df7b0829cc8430e$export$da31df245debdd3);
$parcel$export($8df7b0829cc8430e$exports, "shimGetUserMedia", () => $8df7b0829cc8430e$export$1ed4910f4d37dc5e);
$parcel$export($8df7b0829cc8430e$exports, "shimConstraints", () => $8df7b0829cc8430e$export$494a01ac68ba81ac);
$parcel$export($8df7b0829cc8430e$exports, "shimRTCIceServerUrls", () => $8df7b0829cc8430e$export$671a8b47b41b6f41);
$parcel$export($8df7b0829cc8430e$exports, "shimTrackEventTransceiver", () => $8df7b0829cc8430e$export$85d53da088cb1b14);
$parcel$export($8df7b0829cc8430e$exports, "shimCreateOfferLegacy", () => $8df7b0829cc8430e$export$d444266503fdd2d4);
$parcel$export($8df7b0829cc8430e$exports, "shimAudioContext", () => $8df7b0829cc8430e$export$857cd739a7b795d2);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
"use strict";
function $8df7b0829cc8430e$export$8df41282f4fdcea2(window) {
    if (typeof window !== "object" || !window.RTCPeerConnection) return;
    if (!("getLocalStreams" in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        if (!this._localStreams) this._localStreams = [];
        return this._localStreams;
    };
    if (!("addStream" in window.RTCPeerConnection.prototype)) {
        const _addTrack = window.RTCPeerConnection.prototype.addTrack;
        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            if (!this._localStreams) this._localStreams = [];
            if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            // Try to emulate Chrome's behaviour of adding in audio-video order.
            // Safari orders by track id.
            stream.getAudioTracks().forEach((track)=>_addTrack.call(this, track, stream));
            stream.getVideoTracks().forEach((track)=>_addTrack.call(this, track, stream));
        };
        window.RTCPeerConnection.prototype.addTrack = function addTrack(track, ...streams) {
            if (streams) streams.forEach((stream)=>{
                if (!this._localStreams) this._localStreams = [
                    stream
                ];
                else if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            });
            return _addTrack.apply(this, arguments);
        };
    }
    if (!("removeStream" in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        if (!this._localStreams) this._localStreams = [];
        const index = this._localStreams.indexOf(stream);
        if (index === -1) return;
        this._localStreams.splice(index, 1);
        const tracks = stream.getTracks();
        this.getSenders().forEach((sender)=>{
            if (tracks.includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $8df7b0829cc8430e$export$762aa4cbb4f2f857(window) {
    if (typeof window !== "object" || !window.RTCPeerConnection) return;
    if (!("getRemoteStreams" in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
        return this._remoteStreams ? this._remoteStreams : [];
    };
    if (!("onaddstream" in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, "onaddstream", {
            get () {
                return this._onaddstream;
            },
            set (f) {
                if (this._onaddstream) {
                    this.removeEventListener("addstream", this._onaddstream);
                    this.removeEventListener("track", this._onaddstreampoly);
                }
                this.addEventListener("addstream", this._onaddstream = f);
                this.addEventListener("track", this._onaddstreampoly = (e)=>{
                    e.streams.forEach((stream)=>{
                        if (!this._remoteStreams) this._remoteStreams = [];
                        if (this._remoteStreams.includes(stream)) return;
                        this._remoteStreams.push(stream);
                        const event = new Event("addstream");
                        event.stream = stream;
                        this.dispatchEvent(event);
                    });
                });
            }
        });
        const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            const pc = this;
            if (!this._onaddstreampoly) this.addEventListener("track", this._onaddstreampoly = function(e) {
                e.streams.forEach((stream)=>{
                    if (!pc._remoteStreams) pc._remoteStreams = [];
                    if (pc._remoteStreams.indexOf(stream) >= 0) return;
                    pc._remoteStreams.push(stream);
                    const event = new Event("addstream");
                    event.stream = stream;
                    pc.dispatchEvent(event);
                });
            });
            return origSetRemoteDescription.apply(pc, arguments);
        };
    }
}
function $8df7b0829cc8430e$export$da31df245debdd3(window) {
    if (typeof window !== "object" || !window.RTCPeerConnection) return;
    const prototype = window.RTCPeerConnection.prototype;
    const origCreateOffer = prototype.createOffer;
    const origCreateAnswer = prototype.createAnswer;
    const setLocalDescription = prototype.setLocalDescription;
    const setRemoteDescription = prototype.setRemoteDescription;
    const addIceCandidate = prototype.addIceCandidate;
    prototype.createOffer = function createOffer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateOffer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateAnswer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    let withCallback = function(description, successCallback, failureCallback) {
        const promise = setLocalDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setLocalDescription = withCallback;
    withCallback = function(description, successCallback, failureCallback) {
        const promise = setRemoteDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setRemoteDescription = withCallback;
    withCallback = function(candidate, successCallback, failureCallback) {
        const promise = addIceCandidate.apply(this, [
            candidate
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.addIceCandidate = withCallback;
}
function $8df7b0829cc8430e$export$1ed4910f4d37dc5e(window) {
    const navigator = window && window.navigator;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // shim not needed in Safari 12.1
        const mediaDevices = navigator.mediaDevices;
        const _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);
        navigator.mediaDevices.getUserMedia = (constraints)=>{
            return _getUserMedia($8df7b0829cc8430e$export$494a01ac68ba81ac(constraints));
        };
    }
    if (!navigator.getUserMedia && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) navigator.getUserMedia = (function getUserMedia(constraints, cb, errcb) {
        navigator.mediaDevices.getUserMedia(constraints).then(cb, errcb);
    }).bind(navigator);
}
function $8df7b0829cc8430e$export$494a01ac68ba81ac(constraints) {
    if (constraints && constraints.video !== undefined) return Object.assign({}, constraints, {
        video: $5b563905b3c142ef$export$15384eac40dc88c8(constraints.video)
    });
    return constraints;
}
function $8df7b0829cc8430e$export$671a8b47b41b6f41(window) {
    if (!window.RTCPeerConnection) return;
    // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
    const OrigPeerConnection = window.RTCPeerConnection;
    window.RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
        if (pcConfig && pcConfig.iceServers) {
            const newIceServers = [];
            for(let i = 0; i < pcConfig.iceServers.length; i++){
                let server = pcConfig.iceServers[i];
                if (server.urls === undefined && server.url) {
                    $5b563905b3c142ef$export$cdd73fc4100a6ef4("RTCIceServer.url", "RTCIceServer.urls");
                    server = JSON.parse(JSON.stringify(server));
                    server.urls = server.url;
                    delete server.url;
                    newIceServers.push(server);
                } else newIceServers.push(pcConfig.iceServers[i]);
            }
            pcConfig.iceServers = newIceServers;
        }
        return new OrigPeerConnection(pcConfig, pcConstraints);
    };
    window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
    // wrap static methods. Currently just generateCertificate.
    if ("generateCertificate" in OrigPeerConnection) Object.defineProperty(window.RTCPeerConnection, "generateCertificate", {
        get () {
            return OrigPeerConnection.generateCertificate;
        }
    });
}
function $8df7b0829cc8430e$export$85d53da088cb1b14(window) {
    // Add event.transceiver member over deprecated event.receiver
    if (typeof window === "object" && window.RTCTrackEvent && "receiver" in window.RTCTrackEvent.prototype && !("transceiver" in window.RTCTrackEvent.prototype)) Object.defineProperty(window.RTCTrackEvent.prototype, "transceiver", {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $8df7b0829cc8430e$export$d444266503fdd2d4(window) {
    const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
        if (offerOptions) {
            if (typeof offerOptions.offerToReceiveAudio !== "undefined") // support bit values
            offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
            const audioTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === "audio");
            if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
                if (audioTransceiver.direction === "sendrecv") {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection("sendonly");
                    else audioTransceiver.direction = "sendonly";
                } else if (audioTransceiver.direction === "recvonly") {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection("inactive");
                    else audioTransceiver.direction = "inactive";
                }
            } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) this.addTransceiver("audio", {
                direction: "recvonly"
            });
            if (typeof offerOptions.offerToReceiveVideo !== "undefined") // support bit values
            offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
            const videoTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === "video");
            if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
                if (videoTransceiver.direction === "sendrecv") {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection("sendonly");
                    else videoTransceiver.direction = "sendonly";
                } else if (videoTransceiver.direction === "recvonly") {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection("inactive");
                    else videoTransceiver.direction = "inactive";
                }
            } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) this.addTransceiver("video", {
                direction: "recvonly"
            });
        }
        return origCreateOffer.apply(this, arguments);
    };
}
function $8df7b0829cc8430e$export$857cd739a7b795d2(window) {
    if (typeof window !== "object" || window.AudioContext) return;
    window.AudioContext = window.webkitAudioContext;
}


var $efb406df4b58fff0$exports = {};

$parcel$export($efb406df4b58fff0$exports, "shimRTCIceCandidate", () => $efb406df4b58fff0$export$cf133661e444ccfe);
$parcel$export($efb406df4b58fff0$exports, "shimRTCIceCandidateRelayProtocol", () => $efb406df4b58fff0$export$fdafb8d8280e29b5);
$parcel$export($efb406df4b58fff0$exports, "shimMaxMessageSize", () => $efb406df4b58fff0$export$a99147c78a56edc4);
$parcel$export($efb406df4b58fff0$exports, "shimSendThrowTypeError", () => $efb406df4b58fff0$export$d461c8d5c5db5da7);
$parcel$export($efb406df4b58fff0$exports, "shimConnectionState", () => $efb406df4b58fff0$export$63bb816cc75460);
$parcel$export($efb406df4b58fff0$exports, "removeExtmapAllowMixed", () => $efb406df4b58fff0$export$a57d114344295149);
$parcel$export($efb406df4b58fff0$exports, "shimAddIceCandidateNullOrEmpty", () => $efb406df4b58fff0$export$51d5e40b48c771c7);
$parcel$export($efb406df4b58fff0$exports, "shimParameterlessSetLocalDescription", () => $efb406df4b58fff0$export$7170d04e59f9d553);
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ var $46ed0eee2c35b4c4$exports = {};
/* eslint-env node */ "use strict";
// SDP helpers.
const $46ed0eee2c35b4c4$var$SDPUtils = {};
// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
$46ed0eee2c35b4c4$var$SDPUtils.generateIdentifier = function() {
    return Math.random().toString(36).substring(2, 12);
};
// The RTCP CNAME used by all peerconnections from the same JS.
$46ed0eee2c35b4c4$var$SDPUtils.localCName = $46ed0eee2c35b4c4$var$SDPUtils.generateIdentifier();
// Splits SDP into lines, dealing with both CRLF and LF.
$46ed0eee2c35b4c4$var$SDPUtils.splitLines = function(blob) {
    return blob.trim().split("\n").map((line)=>line.trim());
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
$46ed0eee2c35b4c4$var$SDPUtils.splitSections = function(blob) {
    const parts = blob.split("\nm=");
    return parts.map((part, index)=>(index > 0 ? "m=" + part : part).trim() + "\r\n");
};
// Returns the session description.
$46ed0eee2c35b4c4$var$SDPUtils.getDescription = function(blob) {
    const sections = $46ed0eee2c35b4c4$var$SDPUtils.splitSections(blob);
    return sections && sections[0];
};
// Returns the individual media sections.
$46ed0eee2c35b4c4$var$SDPUtils.getMediaSections = function(blob) {
    const sections = $46ed0eee2c35b4c4$var$SDPUtils.splitSections(blob);
    sections.shift();
    return sections;
};
// Returns lines that start with a certain prefix.
$46ed0eee2c35b4c4$var$SDPUtils.matchPrefix = function(blob, prefix) {
    return $46ed0eee2c35b4c4$var$SDPUtils.splitLines(blob).filter((line)=>line.indexOf(prefix) === 0);
};
// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
// Input can be prefixed with a=.
$46ed0eee2c35b4c4$var$SDPUtils.parseCandidate = function(line) {
    let parts;
    // Parse both variants.
    if (line.indexOf("a=candidate:") === 0) parts = line.substring(12).split(" ");
    else parts = line.substring(10).split(" ");
    const candidate = {
        foundation: parts[0],
        component: {
            1: "rtp",
            2: "rtcp"
        }[parts[1]] || parts[1],
        protocol: parts[2].toLowerCase(),
        priority: parseInt(parts[3], 10),
        ip: parts[4],
        address: parts[4],
        port: parseInt(parts[5], 10),
        // skip parts[6] == 'typ'
        type: parts[7]
    };
    for(let i = 8; i < parts.length; i += 2)switch(parts[i]){
        case "raddr":
            candidate.relatedAddress = parts[i + 1];
            break;
        case "rport":
            candidate.relatedPort = parseInt(parts[i + 1], 10);
            break;
        case "tcptype":
            candidate.tcpType = parts[i + 1];
            break;
        case "ufrag":
            candidate.ufrag = parts[i + 1]; // for backward compatibility.
            candidate.usernameFragment = parts[i + 1];
            break;
        default:
            if (candidate[parts[i]] === undefined) candidate[parts[i]] = parts[i + 1];
            break;
    }
    return candidate;
};
// Translates a candidate object into SDP candidate attribute.
// This does not include the a= prefix!
$46ed0eee2c35b4c4$var$SDPUtils.writeCandidate = function(candidate) {
    const sdp = [];
    sdp.push(candidate.foundation);
    const component = candidate.component;
    if (component === "rtp") sdp.push(1);
    else if (component === "rtcp") sdp.push(2);
    else sdp.push(component);
    sdp.push(candidate.protocol.toUpperCase());
    sdp.push(candidate.priority);
    sdp.push(candidate.address || candidate.ip);
    sdp.push(candidate.port);
    const type = candidate.type;
    sdp.push("typ");
    sdp.push(type);
    if (type !== "host" && candidate.relatedAddress && candidate.relatedPort) {
        sdp.push("raddr");
        sdp.push(candidate.relatedAddress);
        sdp.push("rport");
        sdp.push(candidate.relatedPort);
    }
    if (candidate.tcpType && candidate.protocol.toLowerCase() === "tcp") {
        sdp.push("tcptype");
        sdp.push(candidate.tcpType);
    }
    if (candidate.usernameFragment || candidate.ufrag) {
        sdp.push("ufrag");
        sdp.push(candidate.usernameFragment || candidate.ufrag);
    }
    return "candidate:" + sdp.join(" ");
};
// Parses an ice-options line, returns an array of option tags.
// Sample input:
// a=ice-options:foo bar
$46ed0eee2c35b4c4$var$SDPUtils.parseIceOptions = function(line) {
    return line.substring(14).split(" ");
};
// Parses a rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
$46ed0eee2c35b4c4$var$SDPUtils.parseRtpMap = function(line) {
    let parts = line.substring(9).split(" ");
    const parsed = {
        payloadType: parseInt(parts.shift(), 10)
    };
    parts = parts[0].split("/");
    parsed.name = parts[0];
    parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
    parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
    // legacy alias, got renamed back to channels in ORTC.
    parsed.numChannels = parsed.channels;
    return parsed;
};
// Generates a rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
$46ed0eee2c35b4c4$var$SDPUtils.writeRtpMap = function(codec) {
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    const channels = codec.channels || codec.numChannels || 1;
    return "a=rtpmap:" + pt + " " + codec.name + "/" + codec.clockRate + (channels !== 1 ? "/" + channels : "") + "\r\n";
};
// Parses a extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
$46ed0eee2c35b4c4$var$SDPUtils.parseExtmap = function(line) {
    const parts = line.substring(9).split(" ");
    return {
        id: parseInt(parts[0], 10),
        direction: parts[0].indexOf("/") > 0 ? parts[0].split("/")[1] : "sendrecv",
        uri: parts[1],
        attributes: parts.slice(2).join(" ")
    };
};
// Generates an extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
$46ed0eee2c35b4c4$var$SDPUtils.writeExtmap = function(headerExtension) {
    return "a=extmap:" + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== "sendrecv" ? "/" + headerExtension.direction : "") + " " + headerExtension.uri + (headerExtension.attributes ? " " + headerExtension.attributes : "") + "\r\n";
};
// Parses a fmtp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
$46ed0eee2c35b4c4$var$SDPUtils.parseFmtp = function(line) {
    const parsed = {};
    let kv;
    const parts = line.substring(line.indexOf(" ") + 1).split(";");
    for(let j = 0; j < parts.length; j++){
        kv = parts[j].trim().split("=");
        parsed[kv[0].trim()] = kv[1];
    }
    return parsed;
};
// Generates a fmtp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
$46ed0eee2c35b4c4$var$SDPUtils.writeFmtp = function(codec) {
    let line = "";
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.parameters && Object.keys(codec.parameters).length) {
        const params = [];
        Object.keys(codec.parameters).forEach((param)=>{
            if (codec.parameters[param] !== undefined) params.push(param + "=" + codec.parameters[param]);
            else params.push(param);
        });
        line += "a=fmtp:" + pt + " " + params.join(";") + "\r\n";
    }
    return line;
};
// Parses a rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
$46ed0eee2c35b4c4$var$SDPUtils.parseRtcpFb = function(line) {
    const parts = line.substring(line.indexOf(" ") + 1).split(" ");
    return {
        type: parts.shift(),
        parameter: parts.join(" ")
    };
};
// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
$46ed0eee2c35b4c4$var$SDPUtils.writeRtcpFb = function(codec) {
    let lines = "";
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.rtcpFeedback && codec.rtcpFeedback.length) // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach((fb)=>{
        lines += "a=rtcp-fb:" + pt + " " + fb.type + (fb.parameter && fb.parameter.length ? " " + fb.parameter : "") + "\r\n";
    });
    return lines;
};
// Parses a RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
$46ed0eee2c35b4c4$var$SDPUtils.parseSsrcMedia = function(line) {
    const sp = line.indexOf(" ");
    const parts = {
        ssrc: parseInt(line.substring(7, sp), 10)
    };
    const colon = line.indexOf(":", sp);
    if (colon > -1) {
        parts.attribute = line.substring(sp + 1, colon);
        parts.value = line.substring(colon + 1);
    } else parts.attribute = line.substring(sp + 1);
    return parts;
};
// Parse a ssrc-group line (see RFC 5576). Sample input:
// a=ssrc-group:semantics 12 34
$46ed0eee2c35b4c4$var$SDPUtils.parseSsrcGroup = function(line) {
    const parts = line.substring(13).split(" ");
    return {
        semantics: parts.shift(),
        ssrcs: parts.map((ssrc)=>parseInt(ssrc, 10))
    };
};
// Extracts the MID (RFC 5888) from a media section.
// Returns the MID or undefined if no mid line was found.
$46ed0eee2c35b4c4$var$SDPUtils.getMid = function(mediaSection) {
    const mid = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "a=mid:")[0];
    if (mid) return mid.substring(6);
};
// Parses a fingerprint line for DTLS-SRTP.
$46ed0eee2c35b4c4$var$SDPUtils.parseFingerprint = function(line) {
    const parts = line.substring(14).split(" ");
    return {
        algorithm: parts[0].toLowerCase(),
        value: parts[1].toUpperCase()
    };
};
// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
$46ed0eee2c35b4c4$var$SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
    const lines = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=fingerprint:");
    // Note: a=setup line is ignored since we use the 'auto' role in Edge.
    return {
        role: "auto",
        fingerprints: lines.map($46ed0eee2c35b4c4$var$SDPUtils.parseFingerprint)
    };
};
// Serializes DTLS parameters to SDP.
$46ed0eee2c35b4c4$var$SDPUtils.writeDtlsParameters = function(params, setupType) {
    let sdp = "a=setup:" + setupType + "\r\n";
    params.fingerprints.forEach((fp)=>{
        sdp += "a=fingerprint:" + fp.algorithm + " " + fp.value + "\r\n";
    });
    return sdp;
};
// Parses a=crypto lines into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
$46ed0eee2c35b4c4$var$SDPUtils.parseCryptoLine = function(line) {
    const parts = line.substring(9).split(" ");
    return {
        tag: parseInt(parts[0], 10),
        cryptoSuite: parts[1],
        keyParams: parts[2],
        sessionParams: parts.slice(3)
    };
};
$46ed0eee2c35b4c4$var$SDPUtils.writeCryptoLine = function(parameters) {
    return "a=crypto:" + parameters.tag + " " + parameters.cryptoSuite + " " + (typeof parameters.keyParams === "object" ? $46ed0eee2c35b4c4$var$SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? " " + parameters.sessionParams.join(" ") : "") + "\r\n";
};
// Parses the crypto key parameters into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
$46ed0eee2c35b4c4$var$SDPUtils.parseCryptoKeyParams = function(keyParams) {
    if (keyParams.indexOf("inline:") !== 0) return null;
    const parts = keyParams.substring(7).split("|");
    return {
        keyMethod: "inline",
        keySalt: parts[0],
        lifeTime: parts[1],
        mkiValue: parts[2] ? parts[2].split(":")[0] : undefined,
        mkiLength: parts[2] ? parts[2].split(":")[1] : undefined
    };
};
$46ed0eee2c35b4c4$var$SDPUtils.writeCryptoKeyParams = function(keyParams) {
    return keyParams.keyMethod + ":" + keyParams.keySalt + (keyParams.lifeTime ? "|" + keyParams.lifeTime : "") + (keyParams.mkiValue && keyParams.mkiLength ? "|" + keyParams.mkiValue + ":" + keyParams.mkiLength : "");
};
// Extracts all SDES parameters.
$46ed0eee2c35b4c4$var$SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
    const lines = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=crypto:");
    return lines.map($46ed0eee2c35b4c4$var$SDPUtils.parseCryptoLine);
};
// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
$46ed0eee2c35b4c4$var$SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
    const ufrag = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=ice-ufrag:")[0];
    const pwd = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=ice-pwd:")[0];
    if (!(ufrag && pwd)) return null;
    return {
        usernameFragment: ufrag.substring(12),
        password: pwd.substring(10)
    };
};
// Serializes ICE parameters to SDP.
$46ed0eee2c35b4c4$var$SDPUtils.writeIceParameters = function(params) {
    let sdp = "a=ice-ufrag:" + params.usernameFragment + "\r\n" + "a=ice-pwd:" + params.password + "\r\n";
    if (params.iceLite) sdp += "a=ice-lite\r\n";
    return sdp;
};
// Parses the SDP media section and returns RTCRtpParameters.
$46ed0eee2c35b4c4$var$SDPUtils.parseRtpParameters = function(mediaSection) {
    const description = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: [],
        rtcp: []
    };
    const lines = $46ed0eee2c35b4c4$var$SDPUtils.splitLines(mediaSection);
    const mline = lines[0].split(" ");
    description.profile = mline[2];
    for(let i = 3; i < mline.length; i++){
        const pt = mline[i];
        const rtpmapline = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "a=rtpmap:" + pt + " ")[0];
        if (rtpmapline) {
            const codec = $46ed0eee2c35b4c4$var$SDPUtils.parseRtpMap(rtpmapline);
            const fmtps = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "a=fmtp:" + pt + " ");
            // Only the first a=fmtp:<pt> is considered.
            codec.parameters = fmtps.length ? $46ed0eee2c35b4c4$var$SDPUtils.parseFmtp(fmtps[0]) : {};
            codec.rtcpFeedback = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-fb:" + pt + " ").map($46ed0eee2c35b4c4$var$SDPUtils.parseRtcpFb);
            description.codecs.push(codec);
            // parse FEC mechanisms from rtpmap lines.
            switch(codec.name.toUpperCase()){
                case "RED":
                case "ULPFEC":
                    description.fecMechanisms.push(codec.name.toUpperCase());
                    break;
                default:
                    break;
            }
        }
    }
    $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "a=extmap:").forEach((line)=>{
        description.headerExtensions.push($46ed0eee2c35b4c4$var$SDPUtils.parseExtmap(line));
    });
    const wildcardRtcpFb = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-fb:* ").map($46ed0eee2c35b4c4$var$SDPUtils.parseRtcpFb);
    description.codecs.forEach((codec)=>{
        wildcardRtcpFb.forEach((fb)=>{
            const duplicate = codec.rtcpFeedback.find((existingFeedback)=>{
                return existingFeedback.type === fb.type && existingFeedback.parameter === fb.parameter;
            });
            if (!duplicate) codec.rtcpFeedback.push(fb);
        });
    });
    // FIXME: parse rtcp.
    return description;
};
// Generates parts of the SDP media section describing the capabilities /
// parameters.
$46ed0eee2c35b4c4$var$SDPUtils.writeRtpDescription = function(kind, caps) {
    let sdp = "";
    // Build the mline.
    sdp += "m=" + kind + " ";
    sdp += caps.codecs.length > 0 ? "9" : "0"; // reject if no codecs.
    sdp += " " + (caps.profile || "UDP/TLS/RTP/SAVPF") + " ";
    sdp += caps.codecs.map((codec)=>{
        if (codec.preferredPayloadType !== undefined) return codec.preferredPayloadType;
        return codec.payloadType;
    }).join(" ") + "\r\n";
    sdp += "c=IN IP4 0.0.0.0\r\n";
    sdp += "a=rtcp:9 IN IP4 0.0.0.0\r\n";
    // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
    caps.codecs.forEach((codec)=>{
        sdp += $46ed0eee2c35b4c4$var$SDPUtils.writeRtpMap(codec);
        sdp += $46ed0eee2c35b4c4$var$SDPUtils.writeFmtp(codec);
        sdp += $46ed0eee2c35b4c4$var$SDPUtils.writeRtcpFb(codec);
    });
    let maxptime = 0;
    caps.codecs.forEach((codec)=>{
        if (codec.maxptime > maxptime) maxptime = codec.maxptime;
    });
    if (maxptime > 0) sdp += "a=maxptime:" + maxptime + "\r\n";
    if (caps.headerExtensions) caps.headerExtensions.forEach((extension)=>{
        sdp += $46ed0eee2c35b4c4$var$SDPUtils.writeExtmap(extension);
    });
    // FIXME: write fecMechanisms.
    return sdp;
};
// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
$46ed0eee2c35b4c4$var$SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
    const encodingParameters = [];
    const description = $46ed0eee2c35b4c4$var$SDPUtils.parseRtpParameters(mediaSection);
    const hasRed = description.fecMechanisms.indexOf("RED") !== -1;
    const hasUlpfec = description.fecMechanisms.indexOf("ULPFEC") !== -1;
    // filter a=ssrc:... cname:, ignore PlanB-msid
    const ssrcs = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map((line)=>$46ed0eee2c35b4c4$var$SDPUtils.parseSsrcMedia(line)).filter((parts)=>parts.attribute === "cname");
    const primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
    let secondarySsrc;
    const flows = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc-group:FID").map((line)=>{
        const parts = line.substring(17).split(" ");
        return parts.map((part)=>parseInt(part, 10));
    });
    if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) secondarySsrc = flows[0][1];
    description.codecs.forEach((codec)=>{
        if (codec.name.toUpperCase() === "RTX" && codec.parameters.apt) {
            let encParam = {
                ssrc: primarySsrc,
                codecPayloadType: parseInt(codec.parameters.apt, 10)
            };
            if (primarySsrc && secondarySsrc) encParam.rtx = {
                ssrc: secondarySsrc
            };
            encodingParameters.push(encParam);
            if (hasRed) {
                encParam = JSON.parse(JSON.stringify(encParam));
                encParam.fec = {
                    ssrc: primarySsrc,
                    mechanism: hasUlpfec ? "red+ulpfec" : "red"
                };
                encodingParameters.push(encParam);
            }
        }
    });
    if (encodingParameters.length === 0 && primarySsrc) encodingParameters.push({
        ssrc: primarySsrc
    });
    // we support both b=AS and b=TIAS but interpret AS as TIAS.
    let bandwidth = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "b=");
    if (bandwidth.length) {
        if (bandwidth[0].indexOf("b=TIAS:") === 0) bandwidth = parseInt(bandwidth[0].substring(7), 10);
        else if (bandwidth[0].indexOf("b=AS:") === 0) // use formula from JSEP to convert b=AS to TIAS value.
        bandwidth = parseInt(bandwidth[0].substring(5), 10) * 950 - 16000;
        else bandwidth = undefined;
        encodingParameters.forEach((params)=>{
            params.maxBitrate = bandwidth;
        });
    }
    return encodingParameters;
};
// parses http://draft.ortc.org/#rtcrtcpparameters*
$46ed0eee2c35b4c4$var$SDPUtils.parseRtcpParameters = function(mediaSection) {
    const rtcpParameters = {};
    // Gets the first SSRC. Note that with RTX there might be multiple
    // SSRCs.
    const remoteSsrc = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map((line)=>$46ed0eee2c35b4c4$var$SDPUtils.parseSsrcMedia(line)).filter((obj)=>obj.attribute === "cname")[0];
    if (remoteSsrc) {
        rtcpParameters.cname = remoteSsrc.value;
        rtcpParameters.ssrc = remoteSsrc.ssrc;
    }
    // Edge uses the compound attribute instead of reducedSize
    // compound is !reducedSize
    const rsize = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-rsize");
    rtcpParameters.reducedSize = rsize.length > 0;
    rtcpParameters.compound = rsize.length === 0;
    // parses the rtcp-mux attrіbute.
    // Note that Edge does not support unmuxed RTCP.
    const mux = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-mux");
    rtcpParameters.mux = mux.length > 0;
    return rtcpParameters;
};
$46ed0eee2c35b4c4$var$SDPUtils.writeRtcpParameters = function(rtcpParameters) {
    let sdp = "";
    if (rtcpParameters.reducedSize) sdp += "a=rtcp-rsize\r\n";
    if (rtcpParameters.mux) sdp += "a=rtcp-mux\r\n";
    if (rtcpParameters.ssrc !== undefined && rtcpParameters.cname) sdp += "a=ssrc:" + rtcpParameters.ssrc + " cname:" + rtcpParameters.cname + "\r\n";
    return sdp;
};
// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
$46ed0eee2c35b4c4$var$SDPUtils.parseMsid = function(mediaSection) {
    let parts;
    const spec = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "a=msid:");
    if (spec.length === 1) {
        parts = spec[0].substring(7).split(" ");
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
    const planB = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map((line)=>$46ed0eee2c35b4c4$var$SDPUtils.parseSsrcMedia(line)).filter((msidParts)=>msidParts.attribute === "msid");
    if (planB.length > 0) {
        parts = planB[0].value.split(" ");
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
};
// SCTP
// parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
// to draft-ietf-mmusic-sctp-sdp-05
$46ed0eee2c35b4c4$var$SDPUtils.parseSctpDescription = function(mediaSection) {
    const mline = $46ed0eee2c35b4c4$var$SDPUtils.parseMLine(mediaSection);
    const maxSizeLine = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "a=max-message-size:");
    let maxMessageSize;
    if (maxSizeLine.length > 0) maxMessageSize = parseInt(maxSizeLine[0].substring(19), 10);
    if (isNaN(maxMessageSize)) maxMessageSize = 65536;
    const sctpPort = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "a=sctp-port:");
    if (sctpPort.length > 0) return {
        port: parseInt(sctpPort[0].substring(12), 10),
        protocol: mline.fmt,
        maxMessageSize: maxMessageSize
    };
    const sctpMapLines = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "a=sctpmap:");
    if (sctpMapLines.length > 0) {
        const parts = sctpMapLines[0].substring(10).split(" ");
        return {
            port: parseInt(parts[0], 10),
            protocol: parts[1],
            maxMessageSize: maxMessageSize
        };
    }
};
// SCTP
// outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
// support by now receiving in this format, unless we originally parsed
// as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
// protocol of DTLS/SCTP -- without UDP/ or TCP/)
$46ed0eee2c35b4c4$var$SDPUtils.writeSctpDescription = function(media, sctp) {
    let output = [];
    if (media.protocol !== "DTLS/SCTP") output = [
        "m=" + media.kind + " 9 " + media.protocol + " " + sctp.protocol + "\r\n",
        "c=IN IP4 0.0.0.0\r\n",
        "a=sctp-port:" + sctp.port + "\r\n"
    ];
    else output = [
        "m=" + media.kind + " 9 " + media.protocol + " " + sctp.port + "\r\n",
        "c=IN IP4 0.0.0.0\r\n",
        "a=sctpmap:" + sctp.port + " " + sctp.protocol + " 65535\r\n"
    ];
    if (sctp.maxMessageSize !== undefined) output.push("a=max-message-size:" + sctp.maxMessageSize + "\r\n");
    return output.join("");
};
// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
$46ed0eee2c35b4c4$var$SDPUtils.generateSessionId = function() {
    return Math.random().toString().substr(2, 22);
};
// Write boiler plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
// sessUser is optional and defaults to 'thisisadapterortc'
$46ed0eee2c35b4c4$var$SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
    let sessionId;
    const version = sessVer !== undefined ? sessVer : 2;
    if (sessId) sessionId = sessId;
    else sessionId = $46ed0eee2c35b4c4$var$SDPUtils.generateSessionId();
    const user = sessUser || "thisisadapterortc";
    // FIXME: sess-id should be an NTP timestamp.
    return "v=0\r\no=" + user + " " + sessionId + " " + version + " IN IP4 127.0.0.1\r\n" + "s=-\r\n" + "t=0 0\r\n";
};
// Gets the direction from the mediaSection or the sessionpart.
$46ed0eee2c35b4c4$var$SDPUtils.getDirection = function(mediaSection, sessionpart) {
    // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
    const lines = $46ed0eee2c35b4c4$var$SDPUtils.splitLines(mediaSection);
    for(let i = 0; i < lines.length; i++)switch(lines[i]){
        case "a=sendrecv":
        case "a=sendonly":
        case "a=recvonly":
        case "a=inactive":
            return lines[i].substring(2);
        default:
    }
    if (sessionpart) return $46ed0eee2c35b4c4$var$SDPUtils.getDirection(sessionpart);
    return "sendrecv";
};
$46ed0eee2c35b4c4$var$SDPUtils.getKind = function(mediaSection) {
    const lines = $46ed0eee2c35b4c4$var$SDPUtils.splitLines(mediaSection);
    const mline = lines[0].split(" ");
    return mline[0].substring(2);
};
$46ed0eee2c35b4c4$var$SDPUtils.isRejected = function(mediaSection) {
    return mediaSection.split(" ", 2)[1] === "0";
};
$46ed0eee2c35b4c4$var$SDPUtils.parseMLine = function(mediaSection) {
    const lines = $46ed0eee2c35b4c4$var$SDPUtils.splitLines(mediaSection);
    const parts = lines[0].substring(2).split(" ");
    return {
        kind: parts[0],
        port: parseInt(parts[1], 10),
        protocol: parts[2],
        fmt: parts.slice(3).join(" ")
    };
};
$46ed0eee2c35b4c4$var$SDPUtils.parseOLine = function(mediaSection) {
    const line = $46ed0eee2c35b4c4$var$SDPUtils.matchPrefix(mediaSection, "o=")[0];
    const parts = line.substring(2).split(" ");
    return {
        username: parts[0],
        sessionId: parts[1],
        sessionVersion: parseInt(parts[2], 10),
        netType: parts[3],
        addressType: parts[4],
        address: parts[5]
    };
};
// a very naive interpretation of a valid SDP.
$46ed0eee2c35b4c4$var$SDPUtils.isValidSDP = function(blob) {
    if (typeof blob !== "string" || blob.length === 0) return false;
    const lines = $46ed0eee2c35b4c4$var$SDPUtils.splitLines(blob);
    for(let i = 0; i < lines.length; i++){
        if (lines[i].length < 2 || lines[i].charAt(1) !== "=") return false;
    // TODO: check the modifier a bit more.
    }
    return true;
};
$46ed0eee2c35b4c4$exports = $46ed0eee2c35b4c4$var$SDPUtils;



"use strict";
function $efb406df4b58fff0$export$cf133661e444ccfe(window) {
    // foundation is arbitrarily chosen as an indicator for full support for
    // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
    if (!window.RTCIceCandidate || window.RTCIceCandidate && "foundation" in window.RTCIceCandidate.prototype) return;
    const NativeRTCIceCandidate = window.RTCIceCandidate;
    window.RTCIceCandidate = function RTCIceCandidate(args) {
        // Remove the a= which shouldn't be part of the candidate string.
        if (typeof args === "object" && args.candidate && args.candidate.indexOf("a=") === 0) {
            args = JSON.parse(JSON.stringify(args));
            args.candidate = args.candidate.substring(2);
        }
        if (args.candidate && args.candidate.length) {
            // Augment the native candidate with the parsed fields.
            const nativeCandidate = new NativeRTCIceCandidate(args);
            const parsedCandidate = (0, (/*@__PURE__*/$parcel$interopDefault($46ed0eee2c35b4c4$exports))).parseCandidate(args.candidate);
            for(const key in parsedCandidate)if (!(key in nativeCandidate)) Object.defineProperty(nativeCandidate, key, {
                value: parsedCandidate[key]
            });
            // Override serializer to not serialize the extra attributes.
            nativeCandidate.toJSON = function toJSON() {
                return {
                    candidate: nativeCandidate.candidate,
                    sdpMid: nativeCandidate.sdpMid,
                    sdpMLineIndex: nativeCandidate.sdpMLineIndex,
                    usernameFragment: nativeCandidate.usernameFragment
                };
            };
            return nativeCandidate;
        }
        return new NativeRTCIceCandidate(args);
    };
    window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $5b563905b3c142ef$export$1f48841962b828b1(window, "icecandidate", (e)=>{
        if (e.candidate) Object.defineProperty(e, "candidate", {
            value: new window.RTCIceCandidate(e.candidate),
            writable: "false"
        });
        return e;
    });
}
function $efb406df4b58fff0$export$fdafb8d8280e29b5(window) {
    if (!window.RTCIceCandidate || window.RTCIceCandidate && "relayProtocol" in window.RTCIceCandidate.prototype) return;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $5b563905b3c142ef$export$1f48841962b828b1(window, "icecandidate", (e)=>{
        if (e.candidate) {
            const parsedCandidate = (0, (/*@__PURE__*/$parcel$interopDefault($46ed0eee2c35b4c4$exports))).parseCandidate(e.candidate.candidate);
            if (parsedCandidate.type === "relay") // This is a libwebrtc-specific mapping of local type preference
            // to relayProtocol.
            e.candidate.relayProtocol = ({
                0: "tls",
                1: "tcp",
                2: "udp"
            })[parsedCandidate.priority >> 24];
        }
        return e;
    });
}
function $efb406df4b58fff0$export$a99147c78a56edc4(window, browserDetails) {
    if (!window.RTCPeerConnection) return;
    if (!("sctp" in window.RTCPeerConnection.prototype)) Object.defineProperty(window.RTCPeerConnection.prototype, "sctp", {
        get () {
            return typeof this._sctp === "undefined" ? null : this._sctp;
        }
    });
    const sctpInDescription = function(description) {
        if (!description || !description.sdp) return false;
        const sections = (0, (/*@__PURE__*/$parcel$interopDefault($46ed0eee2c35b4c4$exports))).splitSections(description.sdp);
        sections.shift();
        return sections.some((mediaSection)=>{
            const mLine = (0, (/*@__PURE__*/$parcel$interopDefault($46ed0eee2c35b4c4$exports))).parseMLine(mediaSection);
            return mLine && mLine.kind === "application" && mLine.protocol.indexOf("SCTP") !== -1;
        });
    };
    const getRemoteFirefoxVersion = function(description) {
        // TODO: Is there a better solution for detecting Firefox?
        const match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
        if (match === null || match.length < 2) return -1;
        const version = parseInt(match[1], 10);
        // Test for NaN (yes, this is ugly)
        return version !== version ? -1 : version;
    };
    const getCanSendMaxMessageSize = function(remoteIsFirefox) {
        // Every implementation we know can send at least 64 KiB.
        // Note: Although Chrome is technically able to send up to 256 KiB, the
        //       data does not reach the other peer reliably.
        //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
        let canSendMaxMessageSize = 65536;
        if (browserDetails.browser === "firefox") {
            if (browserDetails.version < 57) {
                if (remoteIsFirefox === -1) // FF < 57 will send in 16 KiB chunks using the deprecated PPID
                // fragmentation.
                canSendMaxMessageSize = 16384;
                else // However, other FF (and RAWRTC) can reassemble PPID-fragmented
                // messages. Thus, supporting ~2 GiB when sending.
                canSendMaxMessageSize = 2147483637;
            } else if (browserDetails.version < 60) // Currently, all FF >= 57 will reset the remote maximum message size
            // to the default value when a data channel is created at a later
            // stage. :(
            // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
            canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
            else // FF >= 60 supports sending ~2 GiB
            canSendMaxMessageSize = 2147483637;
        }
        return canSendMaxMessageSize;
    };
    const getMaxMessageSize = function(description, remoteIsFirefox) {
        // Note: 65536 bytes is the default value from the SDP spec. Also,
        //       every implementation we know supports receiving 65536 bytes.
        let maxMessageSize = 65536;
        // FF 57 has a slightly incorrect default remote max message size, so
        // we need to adjust it here to avoid a failure when sending.
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
        if (browserDetails.browser === "firefox" && browserDetails.version === 57) maxMessageSize = 65535;
        const match = (0, (/*@__PURE__*/$parcel$interopDefault($46ed0eee2c35b4c4$exports))).matchPrefix(description.sdp, "a=max-message-size:");
        if (match.length > 0) maxMessageSize = parseInt(match[0].substring(19), 10);
        else if (browserDetails.browser === "firefox" && remoteIsFirefox !== -1) // If the maximum message size is not present in the remote SDP and
        // both local and remote are Firefox, the remote peer can receive
        // ~2 GiB.
        maxMessageSize = 2147483637;
        return maxMessageSize;
    };
    const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
        this._sctp = null;
        // Chrome decided to not expose .sctp in plan-b mode.
        // As usual, adapter.js has to do an 'ugly worakaround'
        // to cover up the mess.
        if (browserDetails.browser === "chrome" && browserDetails.version >= 76) {
            const { sdpSemantics: sdpSemantics } = this.getConfiguration();
            if (sdpSemantics === "plan-b") Object.defineProperty(this, "sctp", {
                get () {
                    return typeof this._sctp === "undefined" ? null : this._sctp;
                },
                enumerable: true,
                configurable: true
            });
        }
        if (sctpInDescription(arguments[0])) {
            // Check if the remote is FF.
            const isFirefox = getRemoteFirefoxVersion(arguments[0]);
            // Get the maximum message size the local peer is capable of sending
            const canSendMMS = getCanSendMaxMessageSize(isFirefox);
            // Get the maximum message size of the remote peer.
            const remoteMMS = getMaxMessageSize(arguments[0], isFirefox);
            // Determine final maximum message size
            let maxMessageSize;
            if (canSendMMS === 0 && remoteMMS === 0) maxMessageSize = Number.POSITIVE_INFINITY;
            else if (canSendMMS === 0 || remoteMMS === 0) maxMessageSize = Math.max(canSendMMS, remoteMMS);
            else maxMessageSize = Math.min(canSendMMS, remoteMMS);
            // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
            // attribute.
            const sctp = {};
            Object.defineProperty(sctp, "maxMessageSize", {
                get () {
                    return maxMessageSize;
                }
            });
            this._sctp = sctp;
        }
        return origSetRemoteDescription.apply(this, arguments);
    };
}
function $efb406df4b58fff0$export$d461c8d5c5db5da7(window) {
    if (!(window.RTCPeerConnection && "createDataChannel" in window.RTCPeerConnection.prototype)) return;
    // Note: Although Firefox >= 57 has a native implementation, the maximum
    //       message size can be reset for all data channels at a later stage.
    //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
    function wrapDcSend(dc, pc) {
        const origDataChannelSend = dc.send;
        dc.send = function send() {
            const data = arguments[0];
            const length = data.length || data.size || data.byteLength;
            if (dc.readyState === "open" && pc.sctp && length > pc.sctp.maxMessageSize) throw new TypeError("Message too large (can send a maximum of " + pc.sctp.maxMessageSize + " bytes)");
            return origDataChannelSend.apply(dc, arguments);
        };
    }
    const origCreateDataChannel = window.RTCPeerConnection.prototype.createDataChannel;
    window.RTCPeerConnection.prototype.createDataChannel = function createDataChannel() {
        const dataChannel = origCreateDataChannel.apply(this, arguments);
        wrapDcSend(dataChannel, this);
        return dataChannel;
    };
    $5b563905b3c142ef$export$1f48841962b828b1(window, "datachannel", (e)=>{
        wrapDcSend(e.channel, e.target);
        return e;
    });
}
function $efb406df4b58fff0$export$63bb816cc75460(window) {
    if (!window.RTCPeerConnection || "connectionState" in window.RTCPeerConnection.prototype) return;
    const proto = window.RTCPeerConnection.prototype;
    Object.defineProperty(proto, "connectionState", {
        get () {
            return ({
                completed: "connected",
                checking: "connecting"
            })[this.iceConnectionState] || this.iceConnectionState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(proto, "onconnectionstatechange", {
        get () {
            return this._onconnectionstatechange || null;
        },
        set (cb) {
            if (this._onconnectionstatechange) {
                this.removeEventListener("connectionstatechange", this._onconnectionstatechange);
                delete this._onconnectionstatechange;
            }
            if (cb) this.addEventListener("connectionstatechange", this._onconnectionstatechange = cb);
        },
        enumerable: true,
        configurable: true
    });
    [
        "setLocalDescription",
        "setRemoteDescription"
    ].forEach((method)=>{
        const origMethod = proto[method];
        proto[method] = function() {
            if (!this._connectionstatechangepoly) {
                this._connectionstatechangepoly = (e)=>{
                    const pc = e.target;
                    if (pc._lastConnectionState !== pc.connectionState) {
                        pc._lastConnectionState = pc.connectionState;
                        const newEvent = new Event("connectionstatechange", e);
                        pc.dispatchEvent(newEvent);
                    }
                    return e;
                };
                this.addEventListener("iceconnectionstatechange", this._connectionstatechangepoly);
            }
            return origMethod.apply(this, arguments);
        };
    });
}
function $efb406df4b58fff0$export$a57d114344295149(window, browserDetails) {
    /* remove a=extmap-allow-mixed for webrtc.org < M71 */ if (!window.RTCPeerConnection) return;
    if (browserDetails.browser === "chrome" && browserDetails.version >= 71) return;
    if (browserDetails.browser === "safari" && browserDetails.version >= 605) return;
    const nativeSRD = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription(desc) {
        if (desc && desc.sdp && desc.sdp.indexOf("\na=extmap-allow-mixed") !== -1) {
            const sdp = desc.sdp.split("\n").filter((line)=>{
                return line.trim() !== "a=extmap-allow-mixed";
            }).join("\n");
            // Safari enforces read-only-ness of RTCSessionDescription fields.
            if (window.RTCSessionDescription && desc instanceof window.RTCSessionDescription) arguments[0] = new window.RTCSessionDescription({
                type: desc.type,
                sdp: sdp
            });
            else desc.sdp = sdp;
        }
        return nativeSRD.apply(this, arguments);
    };
}
function $efb406df4b58fff0$export$51d5e40b48c771c7(window, browserDetails) {
    // Support for addIceCandidate(null or undefined)
    // as well as addIceCandidate({candidate: "", ...})
    // https://bugs.chromium.org/p/chromium/issues/detail?id=978582
    // Note: must be called before other polyfills which change the signature.
    if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) return;
    const nativeAddIceCandidate = window.RTCPeerConnection.prototype.addIceCandidate;
    if (!nativeAddIceCandidate || nativeAddIceCandidate.length === 0) return;
    window.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
        if (!arguments[0]) {
            if (arguments[1]) arguments[1].apply(null);
            return Promise.resolve();
        }
        // Firefox 68+ emits and processes {candidate: "", ...}, ignore
        // in older versions.
        // Native support for ignoring exists for Chrome M77+.
        // Safari ignores as well, exact version unknown but works in the same
        // version that also ignores addIceCandidate(null).
        if ((browserDetails.browser === "chrome" && browserDetails.version < 78 || browserDetails.browser === "firefox" && browserDetails.version < 68 || browserDetails.browser === "safari") && arguments[0] && arguments[0].candidate === "") return Promise.resolve();
        return nativeAddIceCandidate.apply(this, arguments);
    };
}
function $efb406df4b58fff0$export$7170d04e59f9d553(window, browserDetails) {
    if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) return;
    const nativeSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
    if (!nativeSetLocalDescription || nativeSetLocalDescription.length === 0) return;
    window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        let desc = arguments[0] || {};
        if (typeof desc !== "object" || desc.type && desc.sdp) return nativeSetLocalDescription.apply(this, arguments);
        // The remaining steps should technically happen when SLD comes off the
        // RTCPeerConnection's operations chain (not ahead of going on it), but
        // this is too difficult to shim. Instead, this shim only covers the
        // common case where the operations chain is empty. This is imperfect, but
        // should cover many cases. Rationale: Even if we can't reduce the glare
        // window to zero on imperfect implementations, there's value in tapping
        // into the perfect negotiation pattern that several browsers support.
        desc = {
            type: desc.type,
            sdp: desc.sdp
        };
        if (!desc.type) switch(this.signalingState){
            case "stable":
            case "have-local-offer":
            case "have-remote-pranswer":
                desc.type = "offer";
                break;
            default:
                desc.type = "answer";
                break;
        }
        if (desc.sdp || desc.type !== "offer" && desc.type !== "answer") return nativeSetLocalDescription.apply(this, [
            desc
        ]);
        const func = desc.type === "offer" ? this.createOffer : this.createAnswer;
        return func.apply(this).then((d)=>nativeSetLocalDescription.apply(this, [
                d
            ]));
    };
}



function $aec31092d03adf5b$export$e77bf46c04ac7d12({ window: window } = {}, options = {
    shimChrome: true,
    shimFirefox: true,
    shimSafari: true
}) {
    // Utils.
    const logging = $5b563905b3c142ef$export$bef1f36f5486a6a3;
    const browserDetails = $5b563905b3c142ef$export$2d31490a0c05f094(window);
    const adapter = {
        browserDetails: browserDetails,
        commonShim: $efb406df4b58fff0$exports,
        extractVersion: $5b563905b3c142ef$export$e3c02be309be1f23,
        disableLog: $5b563905b3c142ef$export$afbfee8cc06fd3e4,
        disableWarnings: $5b563905b3c142ef$export$51516be4b019e41e,
        sdp: // Expose sdp as a convenience. For production apps include directly.
        $46ed0eee2c35b4c4$exports
    };
    // Shim browser if found.
    switch(browserDetails.browser){
        case "chrome":
            if (!$bc8e728c001d5ed6$exports || !$bc8e728c001d5ed6$exports.shimPeerConnection || !options.shimChrome) {
                logging("Chrome shim is not included in this adapter release.");
                return adapter;
            }
            if (browserDetails.version === null) {
                logging("Chrome shim can not determine version, not shimming.");
                return adapter;
            }
            logging("adapter.js shimming chrome.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $bc8e728c001d5ed6$exports;
            // Must be called before shimPeerConnection.
            $efb406df4b58fff0$export$51d5e40b48c771c7(window, browserDetails);
            $efb406df4b58fff0$export$7170d04e59f9d553(window, browserDetails);
            $bc8e728c001d5ed6$exports.shimGetUserMedia(window, browserDetails);
            $bc8e728c001d5ed6$exports.shimMediaStream(window, browserDetails);
            $bc8e728c001d5ed6$exports.shimPeerConnection(window, browserDetails);
            $bc8e728c001d5ed6$exports.shimOnTrack(window, browserDetails);
            $bc8e728c001d5ed6$exports.shimAddTrackRemoveTrack(window, browserDetails);
            $bc8e728c001d5ed6$exports.shimGetSendersWithDtmf(window, browserDetails);
            $bc8e728c001d5ed6$exports.shimGetStats(window, browserDetails);
            $bc8e728c001d5ed6$exports.shimSenderReceiverGetStats(window, browserDetails);
            $bc8e728c001d5ed6$exports.fixNegotiationNeeded(window, browserDetails);
            $efb406df4b58fff0$export$cf133661e444ccfe(window, browserDetails);
            $efb406df4b58fff0$export$fdafb8d8280e29b5(window, browserDetails);
            $efb406df4b58fff0$export$63bb816cc75460(window, browserDetails);
            $efb406df4b58fff0$export$a99147c78a56edc4(window, browserDetails);
            $efb406df4b58fff0$export$d461c8d5c5db5da7(window, browserDetails);
            $efb406df4b58fff0$export$a57d114344295149(window, browserDetails);
            break;
        case "firefox":
            if (!$18b983d360dbaced$exports || !$18b983d360dbaced$exports.shimPeerConnection || !options.shimFirefox) {
                logging("Firefox shim is not included in this adapter release.");
                return adapter;
            }
            logging("adapter.js shimming firefox.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $18b983d360dbaced$exports;
            // Must be called before shimPeerConnection.
            $efb406df4b58fff0$export$51d5e40b48c771c7(window, browserDetails);
            $efb406df4b58fff0$export$7170d04e59f9d553(window, browserDetails);
            $18b983d360dbaced$exports.shimGetUserMedia(window, browserDetails);
            $18b983d360dbaced$exports.shimPeerConnection(window, browserDetails);
            $18b983d360dbaced$exports.shimOnTrack(window, browserDetails);
            $18b983d360dbaced$exports.shimRemoveStream(window, browserDetails);
            $18b983d360dbaced$exports.shimSenderGetStats(window, browserDetails);
            $18b983d360dbaced$exports.shimReceiverGetStats(window, browserDetails);
            $18b983d360dbaced$exports.shimRTCDataChannel(window, browserDetails);
            $18b983d360dbaced$exports.shimAddTransceiver(window, browserDetails);
            $18b983d360dbaced$exports.shimGetParameters(window, browserDetails);
            $18b983d360dbaced$exports.shimCreateOffer(window, browserDetails);
            $18b983d360dbaced$exports.shimCreateAnswer(window, browserDetails);
            $efb406df4b58fff0$export$cf133661e444ccfe(window, browserDetails);
            $efb406df4b58fff0$export$63bb816cc75460(window, browserDetails);
            $efb406df4b58fff0$export$a99147c78a56edc4(window, browserDetails);
            $efb406df4b58fff0$export$d461c8d5c5db5da7(window, browserDetails);
            break;
        case "safari":
            if (!$8df7b0829cc8430e$exports || !options.shimSafari) {
                logging("Safari shim is not included in this adapter release.");
                return adapter;
            }
            logging("adapter.js shimming safari.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $8df7b0829cc8430e$exports;
            // Must be called before shimCallbackAPI.
            $efb406df4b58fff0$export$51d5e40b48c771c7(window, browserDetails);
            $efb406df4b58fff0$export$7170d04e59f9d553(window, browserDetails);
            $8df7b0829cc8430e$exports.shimRTCIceServerUrls(window, browserDetails);
            $8df7b0829cc8430e$exports.shimCreateOfferLegacy(window, browserDetails);
            $8df7b0829cc8430e$exports.shimCallbacksAPI(window, browserDetails);
            $8df7b0829cc8430e$exports.shimLocalStreamsAPI(window, browserDetails);
            $8df7b0829cc8430e$exports.shimRemoteStreamsAPI(window, browserDetails);
            $8df7b0829cc8430e$exports.shimTrackEventTransceiver(window, browserDetails);
            $8df7b0829cc8430e$exports.shimGetUserMedia(window, browserDetails);
            $8df7b0829cc8430e$exports.shimAudioContext(window, browserDetails);
            $efb406df4b58fff0$export$cf133661e444ccfe(window, browserDetails);
            $efb406df4b58fff0$export$fdafb8d8280e29b5(window, browserDetails);
            $efb406df4b58fff0$export$a99147c78a56edc4(window, browserDetails);
            $efb406df4b58fff0$export$d461c8d5c5db5da7(window, browserDetails);
            $efb406df4b58fff0$export$a57d114344295149(window, browserDetails);
            break;
        default:
            logging("Unsupported browser!");
            break;
    }
    return adapter;
}


"use strict";
const $ed7d4482cebe850e$var$adapter = (0, $aec31092d03adf5b$export$e77bf46c04ac7d12)({
    window: typeof window === "undefined" ? undefined : window
});
var $ed7d4482cebe850e$export$2e2bcd8739ae039 = $ed7d4482cebe850e$var$adapter;


var $a2d2397a04cf9e13$exports = {};
"use strict";


var $4c3270599345206f$require$Buffer = $a2d2397a04cf9e13$exports.Buffer;
let $4c3270599345206f$var$decoder;
try {
    $4c3270599345206f$var$decoder = new TextDecoder();
} catch (error) {}
let $4c3270599345206f$var$src;
let $4c3270599345206f$var$srcEnd;
let $4c3270599345206f$var$position = 0;
let $4c3270599345206f$var$alreadySet;
const $4c3270599345206f$var$EMPTY_ARRAY = [];
const $4c3270599345206f$var$LEGACY_RECORD_INLINE_ID = 105;
const $4c3270599345206f$var$RECORD_DEFINITIONS_ID = 0xdffe;
const $4c3270599345206f$var$RECORD_INLINE_ID = 0xdfff // temporary first-come first-serve tag // proposed tag: 0x7265 // 're'
;
const $4c3270599345206f$var$BUNDLED_STRINGS_ID = 0xdff9;
const $4c3270599345206f$var$PACKED_TABLE_TAG_ID = 51;
const $4c3270599345206f$var$PACKED_REFERENCE_TAG_ID = 6;
const $4c3270599345206f$var$STOP_CODE = {};
let $4c3270599345206f$var$strings = $4c3270599345206f$var$EMPTY_ARRAY;
let $4c3270599345206f$var$stringPosition = 0;
let $4c3270599345206f$var$currentDecoder = {};
let $4c3270599345206f$var$currentStructures;
let $4c3270599345206f$var$srcString;
let $4c3270599345206f$var$srcStringStart = 0;
let $4c3270599345206f$var$srcStringEnd = 0;
let $4c3270599345206f$var$bundledStrings;
let $4c3270599345206f$var$referenceMap;
let $4c3270599345206f$var$currentExtensions = [];
let $4c3270599345206f$var$currentExtensionRanges = [];
let $4c3270599345206f$var$packedValues;
let $4c3270599345206f$var$dataView;
let $4c3270599345206f$var$restoreMapsAsObject;
let $4c3270599345206f$var$defaultOptions = {
    useRecords: false,
    mapsAsObjects: true
};
let $4c3270599345206f$var$sequentialMode = false;
let $4c3270599345206f$var$inlineObjectReadThreshold = 2;
var $4c3270599345206f$var$BlockedFunction // we use search and replace to change the next call to BlockedFunction to avoid CSP issues for
;
// no-eval build
try {
    new Function("");
} catch (error) {
    // if eval variants are not supported, do not create inline object readers ever
    $4c3270599345206f$var$inlineObjectReadThreshold = Infinity;
}
class $4c3270599345206f$export$f9de6ca0bc043724 {
    constructor(options){
        if (options) {
            if ((options.keyMap || options._keyMap) && !options.useRecords) {
                options.useRecords = false;
                options.mapsAsObjects = true;
            }
            if (options.useRecords === false && options.mapsAsObjects === undefined) options.mapsAsObjects = true;
            if (options.getStructures) options.getShared = options.getStructures;
            if (options.getShared && !options.structures) (options.structures = []).uninitialized = true // this is what we use to denote an uninitialized structures
            ;
            if (options.keyMap) {
                this.mapKey = new Map();
                for (let [k, v] of Object.entries(options.keyMap))this.mapKey.set(v, k);
            }
        }
        Object.assign(this, options);
    }
    /*
	decodeKey(key) {
		return this.keyMap
			? Object.keys(this.keyMap)[Object.values(this.keyMap).indexOf(key)] || key
			: key
	}
	*/ decodeKey(key) {
        return this.keyMap ? this.mapKey.get(key) || key : key;
    }
    encodeKey(key) {
        return this.keyMap && this.keyMap.hasOwnProperty(key) ? this.keyMap[key] : key;
    }
    encodeKeys(rec) {
        if (!this._keyMap) return rec;
        let map = new Map();
        for (let [k, v] of Object.entries(rec))map.set(this._keyMap.hasOwnProperty(k) ? this._keyMap[k] : k, v);
        return map;
    }
    decodeKeys(map) {
        if (!this._keyMap || map.constructor.name != "Map") return map;
        if (!this._mapKey) {
            this._mapKey = new Map();
            for (let [k, v] of Object.entries(this._keyMap))this._mapKey.set(v, k);
        }
        let res = {};
        //map.forEach((v,k) => res[Object.keys(this._keyMap)[Object.values(this._keyMap).indexOf(k)] || k] = v)
        map.forEach((v, k)=>res[$4c3270599345206f$var$safeKey(this._mapKey.has(k) ? this._mapKey.get(k) : k)] = v);
        return res;
    }
    mapDecode(source, end) {
        let res = this.decode(source);
        if (this._keyMap) //Experiemntal support for Optimised KeyMap  decoding 
        switch(res.constructor.name){
            case "Array":
                return res.map((r)=>this.decodeKeys(r));
        }
        return res;
    }
    decode(source, end) {
        if ($4c3270599345206f$var$src) // re-entrant execution, save the state and restore it after we do this decode
        return $4c3270599345206f$var$saveState(()=>{
            $4c3270599345206f$export$e6f020404d5b6c15();
            return this ? this.decode(source, end) : $4c3270599345206f$export$f9de6ca0bc043724.prototype.decode.call($4c3270599345206f$var$defaultOptions, source, end);
        });
        $4c3270599345206f$var$srcEnd = end > -1 ? end : source.length;
        $4c3270599345206f$var$position = 0;
        $4c3270599345206f$var$stringPosition = 0;
        $4c3270599345206f$var$srcStringEnd = 0;
        $4c3270599345206f$var$srcString = null;
        $4c3270599345206f$var$strings = $4c3270599345206f$var$EMPTY_ARRAY;
        $4c3270599345206f$var$bundledStrings = null;
        $4c3270599345206f$var$src = source;
        // this provides cached access to the data view for a buffer if it is getting reused, which is a recommend
        // technique for getting data from a database where it can be copied into an existing buffer instead of creating
        // new ones
        try {
            $4c3270599345206f$var$dataView = source.dataView || (source.dataView = new DataView(source.buffer, source.byteOffset, source.byteLength));
        } catch (error) {
            // if it doesn't have a buffer, maybe it is the wrong type of object
            $4c3270599345206f$var$src = null;
            if (source instanceof Uint8Array) throw error;
            throw new Error("Source must be a Uint8Array or Buffer but was a " + (source && typeof source == "object" ? source.constructor.name : typeof source));
        }
        if (this instanceof $4c3270599345206f$export$f9de6ca0bc043724) {
            $4c3270599345206f$var$currentDecoder = this;
            $4c3270599345206f$var$packedValues = this.sharedValues && (this.pack ? new Array(this.maxPrivatePackedValues || 16).concat(this.sharedValues) : this.sharedValues);
            if (this.structures) {
                $4c3270599345206f$var$currentStructures = this.structures;
                return $4c3270599345206f$export$8cb90b5f58dd32e2();
            } else if (!$4c3270599345206f$var$currentStructures || $4c3270599345206f$var$currentStructures.length > 0) $4c3270599345206f$var$currentStructures = [];
        } else {
            $4c3270599345206f$var$currentDecoder = $4c3270599345206f$var$defaultOptions;
            if (!$4c3270599345206f$var$currentStructures || $4c3270599345206f$var$currentStructures.length > 0) $4c3270599345206f$var$currentStructures = [];
            $4c3270599345206f$var$packedValues = null;
        }
        return $4c3270599345206f$export$8cb90b5f58dd32e2();
    }
    decodeMultiple(source, forEach) {
        let values, lastPosition = 0;
        try {
            let size = source.length;
            $4c3270599345206f$var$sequentialMode = true;
            let value = this ? this.decode(source, size) : $4c3270599345206f$var$defaultDecoder.decode(source, size);
            if (forEach) {
                if (forEach(value) === false) return;
                while($4c3270599345206f$var$position < size){
                    lastPosition = $4c3270599345206f$var$position;
                    if (forEach($4c3270599345206f$export$8cb90b5f58dd32e2()) === false) return;
                }
            } else {
                values = [
                    value
                ];
                while($4c3270599345206f$var$position < size){
                    lastPosition = $4c3270599345206f$var$position;
                    values.push($4c3270599345206f$export$8cb90b5f58dd32e2());
                }
                return values;
            }
        } catch (error) {
            error.lastPosition = lastPosition;
            error.values = values;
            throw error;
        } finally{
            $4c3270599345206f$var$sequentialMode = false;
            $4c3270599345206f$export$e6f020404d5b6c15();
        }
    }
}
function $4c3270599345206f$export$1690e12b840569b9() {
    return $4c3270599345206f$var$position;
}
function $4c3270599345206f$export$8cb90b5f58dd32e2() {
    try {
        let result = $4c3270599345206f$export$aafa59e2e03f2942();
        if ($4c3270599345206f$var$bundledStrings) {
            if ($4c3270599345206f$var$position >= $4c3270599345206f$var$bundledStrings.postBundlePosition) {
                let error = new Error("Unexpected bundle position");
                error.incomplete = true;
                throw error;
            }
            // bundled strings to skip past
            $4c3270599345206f$var$position = $4c3270599345206f$var$bundledStrings.postBundlePosition;
            $4c3270599345206f$var$bundledStrings = null;
        }
        if ($4c3270599345206f$var$position == $4c3270599345206f$var$srcEnd) {
            // finished reading this source, cleanup references
            $4c3270599345206f$var$currentStructures = null;
            $4c3270599345206f$var$src = null;
            if ($4c3270599345206f$var$referenceMap) $4c3270599345206f$var$referenceMap = null;
        } else if ($4c3270599345206f$var$position > $4c3270599345206f$var$srcEnd) {
            // over read
            let error = new Error("Unexpected end of CBOR data");
            error.incomplete = true;
            throw error;
        } else if (!$4c3270599345206f$var$sequentialMode) throw new Error("Data read, but end of buffer not reached");
        // else more to read, but we are reading sequentially, so don't clear source yet
        return result;
    } catch (error) {
        $4c3270599345206f$export$e6f020404d5b6c15();
        if (error instanceof RangeError || error.message.startsWith("Unexpected end of buffer")) error.incomplete = true;
        throw error;
    }
}
function $4c3270599345206f$export$aafa59e2e03f2942() {
    let token = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
    let majorType = token >> 5;
    token = token & 0x1f;
    if (token > 0x17) switch(token){
        case 0x18:
            token = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
            break;
        case 0x19:
            if (majorType == 7) return $4c3270599345206f$var$getFloat16();
            token = $4c3270599345206f$var$dataView.getUint16($4c3270599345206f$var$position);
            $4c3270599345206f$var$position += 2;
            break;
        case 0x1a:
            if (majorType == 7) {
                let value = $4c3270599345206f$var$dataView.getFloat32($4c3270599345206f$var$position);
                if ($4c3270599345206f$var$currentDecoder.useFloat32 > 2) {
                    // this does rounding of numbers that were encoded in 32-bit float to nearest significant decimal digit that could be preserved
                    let multiplier = $4c3270599345206f$export$c652a5bbb6be7a36[($4c3270599345206f$var$src[$4c3270599345206f$var$position] & 0x7f) << 1 | $4c3270599345206f$var$src[$4c3270599345206f$var$position + 1] >> 7];
                    $4c3270599345206f$var$position += 4;
                    return (multiplier * value + (value > 0 ? 0.5 : -0.5) >> 0) / multiplier;
                }
                $4c3270599345206f$var$position += 4;
                return value;
            }
            token = $4c3270599345206f$var$dataView.getUint32($4c3270599345206f$var$position);
            $4c3270599345206f$var$position += 4;
            break;
        case 0x1b:
            if (majorType == 7) {
                let value = $4c3270599345206f$var$dataView.getFloat64($4c3270599345206f$var$position);
                $4c3270599345206f$var$position += 8;
                return value;
            }
            if (majorType > 1) {
                if ($4c3270599345206f$var$dataView.getUint32($4c3270599345206f$var$position) > 0) throw new Error("JavaScript does not support arrays, maps, or strings with length over 4294967295");
                token = $4c3270599345206f$var$dataView.getUint32($4c3270599345206f$var$position + 4);
            } else if ($4c3270599345206f$var$currentDecoder.int64AsNumber) {
                token = $4c3270599345206f$var$dataView.getUint32($4c3270599345206f$var$position) * 0x100000000;
                token += $4c3270599345206f$var$dataView.getUint32($4c3270599345206f$var$position + 4);
            } else token = $4c3270599345206f$var$dataView.getBigUint64($4c3270599345206f$var$position);
            $4c3270599345206f$var$position += 8;
            break;
        case 0x1f:
            // indefinite length
            switch(majorType){
                case 2:
                case 3:
                    throw new Error("Indefinite length not supported for byte or text strings");
                case 4:
                    let array = [];
                    let value, i = 0;
                    while((value = $4c3270599345206f$export$aafa59e2e03f2942()) != $4c3270599345206f$var$STOP_CODE)array[i++] = value;
                    return majorType == 4 ? array : majorType == 3 ? array.join("") : $4c3270599345206f$require$Buffer.concat(array);
                case 5:
                    let key;
                    if ($4c3270599345206f$var$currentDecoder.mapsAsObjects) {
                        let object = {};
                        if ($4c3270599345206f$var$currentDecoder.keyMap) while((key = $4c3270599345206f$export$aafa59e2e03f2942()) != $4c3270599345206f$var$STOP_CODE)object[$4c3270599345206f$var$safeKey($4c3270599345206f$var$currentDecoder.decodeKey(key))] = $4c3270599345206f$export$aafa59e2e03f2942();
                        else while((key = $4c3270599345206f$export$aafa59e2e03f2942()) != $4c3270599345206f$var$STOP_CODE)object[$4c3270599345206f$var$safeKey(key)] = $4c3270599345206f$export$aafa59e2e03f2942();
                        return object;
                    } else {
                        if ($4c3270599345206f$var$restoreMapsAsObject) {
                            $4c3270599345206f$var$currentDecoder.mapsAsObjects = true;
                            $4c3270599345206f$var$restoreMapsAsObject = false;
                        }
                        let map = new Map();
                        if ($4c3270599345206f$var$currentDecoder.keyMap) while((key = $4c3270599345206f$export$aafa59e2e03f2942()) != $4c3270599345206f$var$STOP_CODE)map.set($4c3270599345206f$var$currentDecoder.decodeKey(key), $4c3270599345206f$export$aafa59e2e03f2942());
                        else while((key = $4c3270599345206f$export$aafa59e2e03f2942()) != $4c3270599345206f$var$STOP_CODE)map.set(key, $4c3270599345206f$export$aafa59e2e03f2942());
                        return map;
                    }
                case 7:
                    return $4c3270599345206f$var$STOP_CODE;
                default:
                    throw new Error("Invalid major type for indefinite length " + majorType);
            }
        default:
            throw new Error("Unknown token " + token);
    }
    switch(majorType){
        case 0:
            return token;
        case 1:
            return ~token;
        case 2:
            return $4c3270599345206f$var$readBin(token);
        case 3:
            if ($4c3270599345206f$var$srcStringEnd >= $4c3270599345206f$var$position) return $4c3270599345206f$var$srcString.slice($4c3270599345206f$var$position - $4c3270599345206f$var$srcStringStart, ($4c3270599345206f$var$position += token) - $4c3270599345206f$var$srcStringStart);
            if ($4c3270599345206f$var$srcStringEnd == 0 && $4c3270599345206f$var$srcEnd < 140 && token < 32) {
                // for small blocks, avoiding the overhead of the extract call is helpful
                let string = token < 16 ? $4c3270599345206f$var$shortStringInJS(token) : $4c3270599345206f$var$longStringInJS(token);
                if (string != null) return string;
            }
            return $4c3270599345206f$var$readFixedString(token);
        case 4:
            let array1 = new Array(token);
            //if (currentDecoder.keyMap) for (let i = 0; i < token; i++) array[i] = currentDecoder.decodeKey(read())	
            //else 
            for(let i = 0; i < token; i++)array1[i] = $4c3270599345206f$export$aafa59e2e03f2942();
            return array1;
        case 5:
            if ($4c3270599345206f$var$currentDecoder.mapsAsObjects) {
                let object = {};
                if ($4c3270599345206f$var$currentDecoder.keyMap) for(let i = 0; i < token; i++)object[$4c3270599345206f$var$safeKey($4c3270599345206f$var$currentDecoder.decodeKey($4c3270599345206f$export$aafa59e2e03f2942()))] = $4c3270599345206f$export$aafa59e2e03f2942();
                else for(let i = 0; i < token; i++)object[$4c3270599345206f$var$safeKey($4c3270599345206f$export$aafa59e2e03f2942())] = $4c3270599345206f$export$aafa59e2e03f2942();
                return object;
            } else {
                if ($4c3270599345206f$var$restoreMapsAsObject) {
                    $4c3270599345206f$var$currentDecoder.mapsAsObjects = true;
                    $4c3270599345206f$var$restoreMapsAsObject = false;
                }
                let map = new Map();
                if ($4c3270599345206f$var$currentDecoder.keyMap) for(let i = 0; i < token; i++)map.set($4c3270599345206f$var$currentDecoder.decodeKey($4c3270599345206f$export$aafa59e2e03f2942()), $4c3270599345206f$export$aafa59e2e03f2942());
                else for(let i = 0; i < token; i++)map.set($4c3270599345206f$export$aafa59e2e03f2942(), $4c3270599345206f$export$aafa59e2e03f2942());
                return map;
            }
        case 6:
            if (token >= $4c3270599345206f$var$BUNDLED_STRINGS_ID) {
                let structure = $4c3270599345206f$var$currentStructures[token & 0x1fff] // check record structures first
                ;
                // At some point we may provide an option for dynamic tag assignment with a range like token >= 8 && (token < 16 || (token > 0x80 && token < 0xc0) || (token > 0x130 && token < 0x4000))
                if (structure) {
                    if (!structure.read) structure.read = $4c3270599345206f$var$createStructureReader(structure);
                    return structure.read();
                }
                if (token < 0x10000) {
                    if (token == $4c3270599345206f$var$RECORD_INLINE_ID) {
                        // currentExtensions as densely stored array (v8 stores arrays densely under about 3000 elements)
                        let length = $4c3270599345206f$var$readJustLength();
                        let id = $4c3270599345206f$export$aafa59e2e03f2942();
                        let structure = $4c3270599345206f$export$aafa59e2e03f2942();
                        $4c3270599345206f$var$recordDefinition(id, structure);
                        let object = {};
                        if ($4c3270599345206f$var$currentDecoder.keyMap) for(let i = 2; i < length; i++){
                            let key = $4c3270599345206f$var$currentDecoder.decodeKey(structure[i - 2]);
                            object[$4c3270599345206f$var$safeKey(key)] = $4c3270599345206f$export$aafa59e2e03f2942();
                        }
                        else for(let i = 2; i < length; i++){
                            let key = structure[i - 2];
                            object[$4c3270599345206f$var$safeKey(key)] = $4c3270599345206f$export$aafa59e2e03f2942();
                        }
                        return object;
                    } else if (token == $4c3270599345206f$var$RECORD_DEFINITIONS_ID) {
                        let length = $4c3270599345206f$var$readJustLength();
                        let id = $4c3270599345206f$export$aafa59e2e03f2942();
                        for(let i = 2; i < length; i++)$4c3270599345206f$var$recordDefinition(id++, $4c3270599345206f$export$aafa59e2e03f2942());
                        return $4c3270599345206f$export$aafa59e2e03f2942();
                    } else if (token == $4c3270599345206f$var$BUNDLED_STRINGS_ID) return $4c3270599345206f$var$readBundleExt();
                    if ($4c3270599345206f$var$currentDecoder.getShared) {
                        $4c3270599345206f$var$loadShared();
                        structure = $4c3270599345206f$var$currentStructures[token & 0x1fff];
                        if (structure) {
                            if (!structure.read) structure.read = $4c3270599345206f$var$createStructureReader(structure);
                            return structure.read();
                        }
                    }
                }
            }
            let extension = $4c3270599345206f$var$currentExtensions[token];
            if (extension) {
                if (extension.handlesRead) return extension($4c3270599345206f$export$aafa59e2e03f2942);
                else return extension($4c3270599345206f$export$aafa59e2e03f2942());
            } else {
                let input = $4c3270599345206f$export$aafa59e2e03f2942();
                for(let i = 0; i < $4c3270599345206f$var$currentExtensionRanges.length; i++){
                    let value = $4c3270599345206f$var$currentExtensionRanges[i](token, input);
                    if (value !== undefined) return value;
                }
                return new $4c3270599345206f$export$3288d34c523a1192(input, token);
            }
        case 7:
            switch(token){
                case 0x14:
                    return false;
                case 0x15:
                    return true;
                case 0x16:
                    return null;
                case 0x17:
                    return; // undefined
                case 0x1f:
                default:
                    let packedValue = ($4c3270599345206f$var$packedValues || $4c3270599345206f$var$getPackedValues())[token];
                    if (packedValue !== undefined) return packedValue;
                    throw new Error("Unknown token " + token);
            }
        default:
            if (isNaN(token)) {
                let error = new Error("Unexpected end of CBOR data");
                error.incomplete = true;
                throw error;
            }
            throw new Error("Unknown CBOR token " + token);
    }
}
const $4c3270599345206f$var$validName = /^[a-zA-Z_$][a-zA-Z\d_$]*$/;
function $4c3270599345206f$var$createStructureReader(structure) {
    function readObject() {
        // get the array size from the header
        let length = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
        //let majorType = token >> 5
        length = length & 0x1f;
        if (length > 0x17) switch(length){
            case 0x18:
                length = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
                break;
            case 0x19:
                length = $4c3270599345206f$var$dataView.getUint16($4c3270599345206f$var$position);
                $4c3270599345206f$var$position += 2;
                break;
            case 0x1a:
                length = $4c3270599345206f$var$dataView.getUint32($4c3270599345206f$var$position);
                $4c3270599345206f$var$position += 4;
                break;
            default:
                throw new Error("Expected array header, but got " + $4c3270599345206f$var$src[$4c3270599345206f$var$position - 1]);
        }
        // This initial function is quick to instantiate, but runs slower. After several iterations pay the cost to build the faster function
        let compiledReader = this.compiledReader // first look to see if we have the fast compiled function
        ;
        while(compiledReader){
            // we have a fast compiled object literal reader
            if (compiledReader.propertyCount === length) return compiledReader($4c3270599345206f$export$aafa59e2e03f2942) // with the right length, so we use it
            ;
            compiledReader = compiledReader.next // see if there is another reader with the right length
            ;
        }
        if (this.slowReads++ >= $4c3270599345206f$var$inlineObjectReadThreshold) {
            let array = this.length == length ? this : this.slice(0, length);
            compiledReader = $4c3270599345206f$var$currentDecoder.keyMap ? new Function("r", "return {" + array.map((k)=>$4c3270599345206f$var$currentDecoder.decodeKey(k)).map((k)=>$4c3270599345206f$var$validName.test(k) ? $4c3270599345206f$var$safeKey(k) + ":r()" : "[" + JSON.stringify(k) + "]:r()").join(",") + "}") : new Function("r", "return {" + array.map((key)=>$4c3270599345206f$var$validName.test(key) ? $4c3270599345206f$var$safeKey(key) + ":r()" : "[" + JSON.stringify(key) + "]:r()").join(",") + "}");
            if (this.compiledReader) compiledReader.next = this.compiledReader // if there is an existing one, we store multiple readers as a linked list because it is usually pretty rare to have multiple readers (of different length) for the same structure
            ;
            compiledReader.propertyCount = length;
            this.compiledReader = compiledReader;
            return compiledReader($4c3270599345206f$export$aafa59e2e03f2942);
        }
        let object = {};
        if ($4c3270599345206f$var$currentDecoder.keyMap) for(let i = 0; i < length; i++)object[$4c3270599345206f$var$safeKey($4c3270599345206f$var$currentDecoder.decodeKey(this[i]))] = $4c3270599345206f$export$aafa59e2e03f2942();
        else for(let i = 0; i < length; i++)object[$4c3270599345206f$var$safeKey(this[i])] = $4c3270599345206f$export$aafa59e2e03f2942();
        return object;
    }
    structure.slowReads = 0;
    return readObject;
}
function $4c3270599345206f$var$safeKey(key) {
    return key === "__proto__" ? "__proto_" : key;
}
let $4c3270599345206f$var$readFixedString = $4c3270599345206f$var$readStringJS;
let $4c3270599345206f$var$readString8 = $4c3270599345206f$var$readStringJS;
let $4c3270599345206f$var$readString16 = $4c3270599345206f$var$readStringJS;
let $4c3270599345206f$var$readString32 = $4c3270599345206f$var$readStringJS;
let $4c3270599345206f$export$ae7c2166c4fa454a = false;
function $4c3270599345206f$export$b9cf06aee99126ca(extractStrings) {
    $4c3270599345206f$export$ae7c2166c4fa454a = true;
    $4c3270599345206f$var$readFixedString = readString(1);
    $4c3270599345206f$var$readString8 = readString(2);
    $4c3270599345206f$var$readString16 = readString(3);
    $4c3270599345206f$var$readString32 = readString(5);
    function readString(headerLength) {
        return function readString(length) {
            let string = $4c3270599345206f$var$strings[$4c3270599345206f$var$stringPosition++];
            if (string == null) {
                if ($4c3270599345206f$var$bundledStrings) return $4c3270599345206f$var$readStringJS(length);
                let extraction = extractStrings($4c3270599345206f$var$position, $4c3270599345206f$var$srcEnd, length, $4c3270599345206f$var$src);
                if (typeof extraction == "string") {
                    string = extraction;
                    $4c3270599345206f$var$strings = $4c3270599345206f$var$EMPTY_ARRAY;
                } else {
                    $4c3270599345206f$var$strings = extraction;
                    $4c3270599345206f$var$stringPosition = 1;
                    $4c3270599345206f$var$srcStringEnd = 1 // even if a utf-8 string was decoded, must indicate we are in the midst of extracted strings and can't skip strings
                    ;
                    string = $4c3270599345206f$var$strings[0];
                    if (string === undefined) throw new Error("Unexpected end of buffer");
                }
            }
            let srcStringLength = string.length;
            if (srcStringLength <= length) {
                $4c3270599345206f$var$position += length;
                return string;
            }
            $4c3270599345206f$var$srcString = string;
            $4c3270599345206f$var$srcStringStart = $4c3270599345206f$var$position;
            $4c3270599345206f$var$srcStringEnd = $4c3270599345206f$var$position + srcStringLength;
            $4c3270599345206f$var$position += length;
            return string.slice(0, length) // we know we just want the beginning
            ;
        };
    }
}
function $4c3270599345206f$var$readStringJS(length) {
    let result;
    if (length < 16) {
        if (result = $4c3270599345206f$var$shortStringInJS(length)) return result;
    }
    if (length > 64 && $4c3270599345206f$var$decoder) return $4c3270599345206f$var$decoder.decode($4c3270599345206f$var$src.subarray($4c3270599345206f$var$position, $4c3270599345206f$var$position += length));
    const end = $4c3270599345206f$var$position + length;
    const units = [];
    result = "";
    while($4c3270599345206f$var$position < end){
        const byte1 = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
        if ((byte1 & 0x80) === 0) // 1 byte
        units.push(byte1);
        else if ((byte1 & 0xe0) === 0xc0) {
            // 2 bytes
            const byte2 = $4c3270599345206f$var$src[$4c3270599345206f$var$position++] & 0x3f;
            units.push((byte1 & 0x1f) << 6 | byte2);
        } else if ((byte1 & 0xf0) === 0xe0) {
            // 3 bytes
            const byte2 = $4c3270599345206f$var$src[$4c3270599345206f$var$position++] & 0x3f;
            const byte3 = $4c3270599345206f$var$src[$4c3270599345206f$var$position++] & 0x3f;
            units.push((byte1 & 0x1f) << 12 | byte2 << 6 | byte3);
        } else if ((byte1 & 0xf8) === 0xf0) {
            // 4 bytes
            const byte2 = $4c3270599345206f$var$src[$4c3270599345206f$var$position++] & 0x3f;
            const byte3 = $4c3270599345206f$var$src[$4c3270599345206f$var$position++] & 0x3f;
            const byte4 = $4c3270599345206f$var$src[$4c3270599345206f$var$position++] & 0x3f;
            let unit = (byte1 & 0x07) << 0x12 | byte2 << 0x0c | byte3 << 0x06 | byte4;
            if (unit > 0xffff) {
                unit -= 0x10000;
                units.push(unit >>> 10 & 0x3ff | 0xd800);
                unit = 0xdc00 | unit & 0x3ff;
            }
            units.push(unit);
        } else units.push(byte1);
        if (units.length >= 0x1000) {
            result += $4c3270599345206f$var$fromCharCode.apply(String, units);
            units.length = 0;
        }
    }
    if (units.length > 0) result += $4c3270599345206f$var$fromCharCode.apply(String, units);
    return result;
}
let $4c3270599345206f$var$fromCharCode = String.fromCharCode;
function $4c3270599345206f$var$longStringInJS(length) {
    let start = $4c3270599345206f$var$position;
    let bytes = new Array(length);
    for(let i = 0; i < length; i++){
        const byte = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
        if ((byte & 0x80) > 0) {
            $4c3270599345206f$var$position = start;
            return;
        }
        bytes[i] = byte;
    }
    return $4c3270599345206f$var$fromCharCode.apply(String, bytes);
}
function $4c3270599345206f$var$shortStringInJS(length) {
    if (length < 4) {
        if (length < 2) {
            if (length === 0) return "";
            else {
                let a = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
                if ((a & 0x80) > 1) {
                    $4c3270599345206f$var$position -= 1;
                    return;
                }
                return $4c3270599345206f$var$fromCharCode(a);
            }
        } else {
            let a = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
            let b = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
            if ((a & 0x80) > 0 || (b & 0x80) > 0) {
                $4c3270599345206f$var$position -= 2;
                return;
            }
            if (length < 3) return $4c3270599345206f$var$fromCharCode(a, b);
            let c = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
            if ((c & 0x80) > 0) {
                $4c3270599345206f$var$position -= 3;
                return;
            }
            return $4c3270599345206f$var$fromCharCode(a, b, c);
        }
    } else {
        let a = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
        let b = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
        let c = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
        let d = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
        if ((a & 0x80) > 0 || (b & 0x80) > 0 || (c & 0x80) > 0 || (d & 0x80) > 0) {
            $4c3270599345206f$var$position -= 4;
            return;
        }
        if (length < 6) {
            if (length === 4) return $4c3270599345206f$var$fromCharCode(a, b, c, d);
            else {
                let e = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
                if ((e & 0x80) > 0) {
                    $4c3270599345206f$var$position -= 5;
                    return;
                }
                return $4c3270599345206f$var$fromCharCode(a, b, c, d, e);
            }
        } else if (length < 8) {
            let e = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
            let f = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
            if ((e & 0x80) > 0 || (f & 0x80) > 0) {
                $4c3270599345206f$var$position -= 6;
                return;
            }
            if (length < 7) return $4c3270599345206f$var$fromCharCode(a, b, c, d, e, f);
            let g = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
            if ((g & 0x80) > 0) {
                $4c3270599345206f$var$position -= 7;
                return;
            }
            return $4c3270599345206f$var$fromCharCode(a, b, c, d, e, f, g);
        } else {
            let e = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
            let f = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
            let g = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
            let h = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
            if ((e & 0x80) > 0 || (f & 0x80) > 0 || (g & 0x80) > 0 || (h & 0x80) > 0) {
                $4c3270599345206f$var$position -= 8;
                return;
            }
            if (length < 10) {
                if (length === 8) return $4c3270599345206f$var$fromCharCode(a, b, c, d, e, f, g, h);
                else {
                    let i = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
                    if ((i & 0x80) > 0) {
                        $4c3270599345206f$var$position -= 9;
                        return;
                    }
                    return $4c3270599345206f$var$fromCharCode(a, b, c, d, e, f, g, h, i);
                }
            } else if (length < 12) {
                let i = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
                let j = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
                if ((i & 0x80) > 0 || (j & 0x80) > 0) {
                    $4c3270599345206f$var$position -= 10;
                    return;
                }
                if (length < 11) return $4c3270599345206f$var$fromCharCode(a, b, c, d, e, f, g, h, i, j);
                let k = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
                if ((k & 0x80) > 0) {
                    $4c3270599345206f$var$position -= 11;
                    return;
                }
                return $4c3270599345206f$var$fromCharCode(a, b, c, d, e, f, g, h, i, j, k);
            } else {
                let i = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
                let j = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
                let k = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
                let l = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
                if ((i & 0x80) > 0 || (j & 0x80) > 0 || (k & 0x80) > 0 || (l & 0x80) > 0) {
                    $4c3270599345206f$var$position -= 12;
                    return;
                }
                if (length < 14) {
                    if (length === 12) return $4c3270599345206f$var$fromCharCode(a, b, c, d, e, f, g, h, i, j, k, l);
                    else {
                        let m = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
                        if ((m & 0x80) > 0) {
                            $4c3270599345206f$var$position -= 13;
                            return;
                        }
                        return $4c3270599345206f$var$fromCharCode(a, b, c, d, e, f, g, h, i, j, k, l, m);
                    }
                } else {
                    let m = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
                    let n = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
                    if ((m & 0x80) > 0 || (n & 0x80) > 0) {
                        $4c3270599345206f$var$position -= 14;
                        return;
                    }
                    if (length < 15) return $4c3270599345206f$var$fromCharCode(a, b, c, d, e, f, g, h, i, j, k, l, m, n);
                    let o = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
                    if ((o & 0x80) > 0) {
                        $4c3270599345206f$var$position -= 15;
                        return;
                    }
                    return $4c3270599345206f$var$fromCharCode(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o);
                }
            }
        }
    }
}
function $4c3270599345206f$var$readBin(length) {
    return $4c3270599345206f$var$currentDecoder.copyBuffers ? // specifically use the copying slice (not the node one)
    Uint8Array.prototype.slice.call($4c3270599345206f$var$src, $4c3270599345206f$var$position, $4c3270599345206f$var$position += length) : $4c3270599345206f$var$src.subarray($4c3270599345206f$var$position, $4c3270599345206f$var$position += length);
}
function $4c3270599345206f$var$readExt(length) {
    let type = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
    if ($4c3270599345206f$var$currentExtensions[type]) return $4c3270599345206f$var$currentExtensions[type]($4c3270599345206f$var$src.subarray($4c3270599345206f$var$position, $4c3270599345206f$var$position += length));
    else throw new Error("Unknown extension type " + type);
}
let $4c3270599345206f$var$f32Array = new Float32Array(1);
let $4c3270599345206f$var$u8Array = new Uint8Array($4c3270599345206f$var$f32Array.buffer, 0, 4);
function $4c3270599345206f$var$getFloat16() {
    let byte0 = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
    let byte1 = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
    let exponent = (byte0 & 0x7f) >> 2;
    if (exponent === 0x1f) {
        if (byte1 || byte0 & 3) return NaN;
        return byte0 & 0x80 ? -Infinity : Infinity;
    }
    if (exponent === 0) {
        // significand with 10 fractional bits and divided by 2^14
        let abs = ((byte0 & 3) << 8 | byte1) / 16777216;
        return byte0 & 0x80 ? -abs : abs;
    }
    $4c3270599345206f$var$u8Array[3] = byte0 & 0x80 | // sign bit
    (exponent >> 1) + 56 // 4 of 5 of the exponent bits, re-offset-ed
    ;
    $4c3270599345206f$var$u8Array[2] = (byte0 & 7) << 5 | // last exponent bit and first two mantissa bits
    byte1 >> 3 // next 5 bits of mantissa
    ;
    $4c3270599345206f$var$u8Array[1] = byte1 << 5; // last three bits of mantissa
    $4c3270599345206f$var$u8Array[0] = 0;
    return $4c3270599345206f$var$f32Array[0];
}
let $4c3270599345206f$var$keyCache = new Array(4096);
function $4c3270599345206f$var$readKey() {
    let length = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
    if (length >= 0x60 && length < 0x78) {
        // fixstr, potentially use key cache
        length = length - 0x60;
        if ($4c3270599345206f$var$srcStringEnd >= $4c3270599345206f$var$position) return $4c3270599345206f$var$srcString.slice($4c3270599345206f$var$position - $4c3270599345206f$var$srcStringStart, ($4c3270599345206f$var$position += length) - $4c3270599345206f$var$srcStringStart);
        else if (!($4c3270599345206f$var$srcStringEnd == 0 && $4c3270599345206f$var$srcEnd < 180)) return $4c3270599345206f$var$readFixedString(length);
    } else {
        $4c3270599345206f$var$position--;
        return $4c3270599345206f$export$aafa59e2e03f2942();
    }
    let key = (length << 5 ^ (length > 1 ? $4c3270599345206f$var$dataView.getUint16($4c3270599345206f$var$position) : length > 0 ? $4c3270599345206f$var$src[$4c3270599345206f$var$position] : 0)) & 0xfff;
    let entry = $4c3270599345206f$var$keyCache[key];
    let checkPosition = $4c3270599345206f$var$position;
    let end = $4c3270599345206f$var$position + length - 3;
    let chunk;
    let i = 0;
    if (entry && entry.bytes == length) {
        while(checkPosition < end){
            chunk = $4c3270599345206f$var$dataView.getUint32(checkPosition);
            if (chunk != entry[i++]) {
                checkPosition = 0x70000000;
                break;
            }
            checkPosition += 4;
        }
        end += 3;
        while(checkPosition < end){
            chunk = $4c3270599345206f$var$src[checkPosition++];
            if (chunk != entry[i++]) {
                checkPosition = 0x70000000;
                break;
            }
        }
        if (checkPosition === end) {
            $4c3270599345206f$var$position = checkPosition;
            return entry.string;
        }
        end -= 3;
        checkPosition = $4c3270599345206f$var$position;
    }
    entry = [];
    $4c3270599345206f$var$keyCache[key] = entry;
    entry.bytes = length;
    while(checkPosition < end){
        chunk = $4c3270599345206f$var$dataView.getUint32(checkPosition);
        entry.push(chunk);
        checkPosition += 4;
    }
    end += 3;
    while(checkPosition < end){
        chunk = $4c3270599345206f$var$src[checkPosition++];
        entry.push(chunk);
    }
    // for small blocks, avoiding the overhead of the extract call is helpful
    let string = length < 16 ? $4c3270599345206f$var$shortStringInJS(length) : $4c3270599345206f$var$longStringInJS(length);
    if (string != null) return entry.string = string;
    return entry.string = $4c3270599345206f$var$readFixedString(length);
}
class $4c3270599345206f$export$3288d34c523a1192 {
    constructor(value, tag){
        this.value = value;
        this.tag = tag;
    }
}
$4c3270599345206f$var$currentExtensions[0] = (dateString)=>{
    // string date extension
    return new Date(dateString);
};
$4c3270599345206f$var$currentExtensions[1] = (epochSec)=>{
    // numeric date extension
    return new Date(Math.round(epochSec * 1000));
};
$4c3270599345206f$var$currentExtensions[2] = (buffer)=>{
    // bigint extension
    let value = BigInt(0);
    for(let i = 0, l = buffer.byteLength; i < l; i++)value = BigInt(buffer[i]) + value << BigInt(8);
    return value;
};
$4c3270599345206f$var$currentExtensions[3] = (buffer)=>{
    // negative bigint extension
    return BigInt(-1) - $4c3270599345206f$var$currentExtensions[2](buffer);
};
$4c3270599345206f$var$currentExtensions[4] = (fraction)=>{
    // best to reparse to maintain accuracy
    return +(fraction[1] + "e" + fraction[0]);
};
$4c3270599345206f$var$currentExtensions[5] = (fraction)=>{
    // probably not sufficiently accurate
    return fraction[1] * Math.exp(fraction[0] * Math.log(2));
};
// the registration of the record definition extension
const $4c3270599345206f$var$recordDefinition = (id, structure)=>{
    id = id - 0xe000;
    let existingStructure = $4c3270599345206f$var$currentStructures[id];
    if (existingStructure && existingStructure.isShared) ($4c3270599345206f$var$currentStructures.restoreStructures || ($4c3270599345206f$var$currentStructures.restoreStructures = []))[id] = existingStructure;
    $4c3270599345206f$var$currentStructures[id] = structure;
    structure.read = $4c3270599345206f$var$createStructureReader(structure);
};
$4c3270599345206f$var$currentExtensions[$4c3270599345206f$var$LEGACY_RECORD_INLINE_ID] = (data)=>{
    let length = data.length;
    let structure = data[1];
    $4c3270599345206f$var$recordDefinition(data[0], structure);
    let object = {};
    for(let i = 2; i < length; i++){
        let key = structure[i - 2];
        object[$4c3270599345206f$var$safeKey(key)] = data[i];
    }
    return object;
};
$4c3270599345206f$var$currentExtensions[14] = (value)=>{
    if ($4c3270599345206f$var$bundledStrings) return $4c3270599345206f$var$bundledStrings[0].slice($4c3270599345206f$var$bundledStrings.position0, $4c3270599345206f$var$bundledStrings.position0 += value);
    return new $4c3270599345206f$export$3288d34c523a1192(value, 14);
};
$4c3270599345206f$var$currentExtensions[15] = (value)=>{
    if ($4c3270599345206f$var$bundledStrings) return $4c3270599345206f$var$bundledStrings[1].slice($4c3270599345206f$var$bundledStrings.position1, $4c3270599345206f$var$bundledStrings.position1 += value);
    return new $4c3270599345206f$export$3288d34c523a1192(value, 15);
};
let $4c3270599345206f$var$glbl = {
    Error: Error,
    RegExp: RegExp
};
$4c3270599345206f$var$currentExtensions[27] = (data)=>{
    return ($4c3270599345206f$var$glbl[data[0]] || Error)(data[1], data[2]);
};
const $4c3270599345206f$var$packedTable = (read)=>{
    if ($4c3270599345206f$var$src[$4c3270599345206f$var$position++] != 0x84) throw new Error("Packed values structure must be followed by a 4 element array");
    let newPackedValues = read() // packed values
    ;
    $4c3270599345206f$var$packedValues = $4c3270599345206f$var$packedValues ? newPackedValues.concat($4c3270599345206f$var$packedValues.slice(newPackedValues.length)) : newPackedValues;
    $4c3270599345206f$var$packedValues.prefixes = read();
    $4c3270599345206f$var$packedValues.suffixes = read();
    return read() // read the rump
    ;
};
$4c3270599345206f$var$packedTable.handlesRead = true;
$4c3270599345206f$var$currentExtensions[51] = $4c3270599345206f$var$packedTable;
$4c3270599345206f$var$currentExtensions[$4c3270599345206f$var$PACKED_REFERENCE_TAG_ID] = (data)=>{
    if (!$4c3270599345206f$var$packedValues) {
        if ($4c3270599345206f$var$currentDecoder.getShared) $4c3270599345206f$var$loadShared();
        else return new $4c3270599345206f$export$3288d34c523a1192(data, $4c3270599345206f$var$PACKED_REFERENCE_TAG_ID);
    }
    if (typeof data == "number") return $4c3270599345206f$var$packedValues[16 + (data >= 0 ? 2 * data : -2 * data - 1)];
    throw new Error("No support for non-integer packed references yet");
};
// The following code is an incomplete implementation of http://cbor.schmorp.de/stringref
// the real thing would need to implemennt more logic to populate the stringRefs table and
// maintain a stack of stringRef "namespaces".
//
// currentExtensions[25] = (id) => {
// 	return stringRefs[id]
// }
// currentExtensions[256] = (read) => {
// 	stringRefs = []
// 	try {
// 		return read()
// 	} finally {
// 		stringRefs = null
// 	}
// }
// currentExtensions[256].handlesRead = true
$4c3270599345206f$var$currentExtensions[28] = (read)=>{
    // shareable http://cbor.schmorp.de/value-sharing (for structured clones)
    if (!$4c3270599345206f$var$referenceMap) {
        $4c3270599345206f$var$referenceMap = new Map();
        $4c3270599345206f$var$referenceMap.id = 0;
    }
    let id = $4c3270599345206f$var$referenceMap.id++;
    let token = $4c3270599345206f$var$src[$4c3270599345206f$var$position];
    let target;
    // TODO: handle Maps, Sets, and other types that can cycle; this is complicated, because you potentially need to read
    // ahead past references to record structure definitions
    if (token >> 5 == 4) target = [];
    else target = {};
    let refEntry = {
        target: target
    } // a placeholder object
    ;
    $4c3270599345206f$var$referenceMap.set(id, refEntry);
    let targetProperties = read() // read the next value as the target object to id
    ;
    if (refEntry.used) return Object.assign(target, targetProperties);
    refEntry.target = targetProperties // the placeholder wasn't used, replace with the deserialized one
    ;
    return targetProperties // no cycle, can just use the returned read object
    ;
};
$4c3270599345206f$var$currentExtensions[28].handlesRead = true;
$4c3270599345206f$var$currentExtensions[29] = (id)=>{
    // sharedref http://cbor.schmorp.de/value-sharing (for structured clones)
    let refEntry = $4c3270599345206f$var$referenceMap.get(id);
    refEntry.used = true;
    return refEntry.target;
};
$4c3270599345206f$var$currentExtensions[258] = (array)=>new Set(array); // https://github.com/input-output-hk/cbor-sets-spec/blob/master/CBOR_SETS.md
($4c3270599345206f$var$currentExtensions[259] = (read)=>{
    // https://github.com/shanewholloway/js-cbor-codec/blob/master/docs/CBOR-259-spec
    // for decoding as a standard Map
    if ($4c3270599345206f$var$currentDecoder.mapsAsObjects) {
        $4c3270599345206f$var$currentDecoder.mapsAsObjects = false;
        $4c3270599345206f$var$restoreMapsAsObject = true;
    }
    return read();
}).handlesRead = true;
function $4c3270599345206f$var$combine(a, b) {
    if (typeof a === "string") return a + b;
    if (a instanceof Array) return a.concat(b);
    return Object.assign({}, a, b);
}
function $4c3270599345206f$var$getPackedValues() {
    if (!$4c3270599345206f$var$packedValues) {
        if ($4c3270599345206f$var$currentDecoder.getShared) $4c3270599345206f$var$loadShared();
        else throw new Error("No packed values available");
    }
    return $4c3270599345206f$var$packedValues;
}
const $4c3270599345206f$var$SHARED_DATA_TAG_ID = 0x53687264 // ascii 'Shrd'
;
$4c3270599345206f$var$currentExtensionRanges.push((tag, input)=>{
    if (tag >= 225 && tag <= 255) return $4c3270599345206f$var$combine($4c3270599345206f$var$getPackedValues().prefixes[tag - 224], input);
    if (tag >= 28704 && tag <= 32767) return $4c3270599345206f$var$combine($4c3270599345206f$var$getPackedValues().prefixes[tag - 28672], input);
    if (tag >= 1879052288 && tag <= 2147483647) return $4c3270599345206f$var$combine($4c3270599345206f$var$getPackedValues().prefixes[tag - 1879048192], input);
    if (tag >= 216 && tag <= 223) return $4c3270599345206f$var$combine(input, $4c3270599345206f$var$getPackedValues().suffixes[tag - 216]);
    if (tag >= 27647 && tag <= 28671) return $4c3270599345206f$var$combine(input, $4c3270599345206f$var$getPackedValues().suffixes[tag - 27639]);
    if (tag >= 1811940352 && tag <= 1879048191) return $4c3270599345206f$var$combine(input, $4c3270599345206f$var$getPackedValues().suffixes[tag - 1811939328]);
    if (tag == $4c3270599345206f$var$SHARED_DATA_TAG_ID) return {
        packedValues: $4c3270599345206f$var$packedValues,
        structures: $4c3270599345206f$var$currentStructures.slice(0),
        version: input
    };
    if (tag == 55799) return input;
});
const $4c3270599345206f$var$isLittleEndianMachine = new Uint8Array(new Uint16Array([
    1
]).buffer)[0] == 1;
const $4c3270599345206f$export$aae3eaec024a56b7 = [
    Uint8Array,
    Uint8ClampedArray,
    Uint16Array,
    Uint32Array,
    typeof BigUint64Array == "undefined" ? {
        name: "BigUint64Array"
    } : BigUint64Array,
    Int8Array,
    Int16Array,
    Int32Array,
    typeof BigInt64Array == "undefined" ? {
        name: "BigInt64Array"
    } : BigInt64Array,
    Float32Array,
    Float64Array
];
const $4c3270599345206f$var$typedArrayTags = [
    64,
    68,
    69,
    70,
    71,
    72,
    77,
    78,
    79,
    85,
    86
];
for(let i = 0; i < $4c3270599345206f$export$aae3eaec024a56b7.length; i++)$4c3270599345206f$var$registerTypedArray($4c3270599345206f$export$aae3eaec024a56b7[i], $4c3270599345206f$var$typedArrayTags[i]);
function $4c3270599345206f$var$registerTypedArray(TypedArray, tag) {
    let dvMethod = "get" + TypedArray.name.slice(0, -5);
    let bytesPerElement;
    if (typeof TypedArray === "function") bytesPerElement = TypedArray.BYTES_PER_ELEMENT;
    else TypedArray = null;
    for(let littleEndian = 0; littleEndian < 2; littleEndian++){
        if (!littleEndian && bytesPerElement == 1) continue;
        let sizeShift = bytesPerElement == 2 ? 1 : bytesPerElement == 4 ? 2 : 3;
        $4c3270599345206f$var$currentExtensions[littleEndian ? tag : tag - 4] = bytesPerElement == 1 || littleEndian == $4c3270599345206f$var$isLittleEndianMachine ? (buffer)=>{
            if (!TypedArray) throw new Error("Could not find typed array for code " + tag);
            // we have to always slice/copy here to get a new ArrayBuffer that is word/byte aligned
            return new TypedArray(Uint8Array.prototype.slice.call(buffer, 0).buffer);
        } : (buffer)=>{
            if (!TypedArray) throw new Error("Could not find typed array for code " + tag);
            let dv = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
            let elements = buffer.length >> sizeShift;
            let ta = new TypedArray(elements);
            let method = dv[dvMethod];
            for(let i = 0; i < elements; i++)ta[i] = method.call(dv, i << sizeShift, littleEndian);
            return ta;
        };
    }
}
function $4c3270599345206f$var$readBundleExt() {
    let length = $4c3270599345206f$var$readJustLength();
    let bundlePosition = $4c3270599345206f$var$position + $4c3270599345206f$export$aafa59e2e03f2942();
    for(let i = 2; i < length; i++){
        // skip past bundles that were already read
        let bundleLength = $4c3270599345206f$var$readJustLength() // this will increment position, so must add to position afterwards
        ;
        $4c3270599345206f$var$position += bundleLength;
    }
    let dataPosition = $4c3270599345206f$var$position;
    $4c3270599345206f$var$position = bundlePosition;
    $4c3270599345206f$var$bundledStrings = [
        $4c3270599345206f$var$readStringJS($4c3270599345206f$var$readJustLength()),
        $4c3270599345206f$var$readStringJS($4c3270599345206f$var$readJustLength())
    ];
    $4c3270599345206f$var$bundledStrings.position0 = 0;
    $4c3270599345206f$var$bundledStrings.position1 = 0;
    $4c3270599345206f$var$bundledStrings.postBundlePosition = $4c3270599345206f$var$position;
    $4c3270599345206f$var$position = dataPosition;
    return $4c3270599345206f$export$aafa59e2e03f2942();
}
function $4c3270599345206f$var$readJustLength() {
    let token = $4c3270599345206f$var$src[$4c3270599345206f$var$position++] & 0x1f;
    if (token > 0x17) switch(token){
        case 0x18:
            token = $4c3270599345206f$var$src[$4c3270599345206f$var$position++];
            break;
        case 0x19:
            token = $4c3270599345206f$var$dataView.getUint16($4c3270599345206f$var$position);
            $4c3270599345206f$var$position += 2;
            break;
        case 0x1a:
            token = $4c3270599345206f$var$dataView.getUint32($4c3270599345206f$var$position);
            $4c3270599345206f$var$position += 4;
            break;
    }
    return token;
}
function $4c3270599345206f$var$loadShared() {
    if ($4c3270599345206f$var$currentDecoder.getShared) {
        let sharedData = $4c3270599345206f$var$saveState(()=>{
            // save the state in case getShared modifies our buffer
            $4c3270599345206f$var$src = null;
            return $4c3270599345206f$var$currentDecoder.getShared();
        }) || {};
        let updatedStructures = sharedData.structures || [];
        $4c3270599345206f$var$currentDecoder.sharedVersion = sharedData.version;
        $4c3270599345206f$var$packedValues = $4c3270599345206f$var$currentDecoder.sharedValues = sharedData.packedValues;
        if ($4c3270599345206f$var$currentStructures === true) $4c3270599345206f$var$currentDecoder.structures = $4c3270599345206f$var$currentStructures = updatedStructures;
        else $4c3270599345206f$var$currentStructures.splice.apply($4c3270599345206f$var$currentStructures, [
            0,
            updatedStructures.length
        ].concat(updatedStructures));
    }
}
function $4c3270599345206f$var$saveState(callback) {
    let savedSrcEnd = $4c3270599345206f$var$srcEnd;
    let savedPosition = $4c3270599345206f$var$position;
    let savedStringPosition = $4c3270599345206f$var$stringPosition;
    let savedSrcStringStart = $4c3270599345206f$var$srcStringStart;
    let savedSrcStringEnd = $4c3270599345206f$var$srcStringEnd;
    let savedSrcString = $4c3270599345206f$var$srcString;
    let savedStrings = $4c3270599345206f$var$strings;
    let savedReferenceMap = $4c3270599345206f$var$referenceMap;
    let savedBundledStrings = $4c3270599345206f$var$bundledStrings;
    // TODO: We may need to revisit this if we do more external calls to user code (since it could be slow)
    let savedSrc = new Uint8Array($4c3270599345206f$var$src.slice(0, $4c3270599345206f$var$srcEnd)) // we copy the data in case it changes while external data is processed
    ;
    let savedStructures = $4c3270599345206f$var$currentStructures;
    let savedDecoder = $4c3270599345206f$var$currentDecoder;
    let savedSequentialMode = $4c3270599345206f$var$sequentialMode;
    let value = callback();
    $4c3270599345206f$var$srcEnd = savedSrcEnd;
    $4c3270599345206f$var$position = savedPosition;
    $4c3270599345206f$var$stringPosition = savedStringPosition;
    $4c3270599345206f$var$srcStringStart = savedSrcStringStart;
    $4c3270599345206f$var$srcStringEnd = savedSrcStringEnd;
    $4c3270599345206f$var$srcString = savedSrcString;
    $4c3270599345206f$var$strings = savedStrings;
    $4c3270599345206f$var$referenceMap = savedReferenceMap;
    $4c3270599345206f$var$bundledStrings = savedBundledStrings;
    $4c3270599345206f$var$src = savedSrc;
    $4c3270599345206f$var$sequentialMode = savedSequentialMode;
    $4c3270599345206f$var$currentStructures = savedStructures;
    $4c3270599345206f$var$currentDecoder = savedDecoder;
    $4c3270599345206f$var$dataView = new DataView($4c3270599345206f$var$src.buffer, $4c3270599345206f$var$src.byteOffset, $4c3270599345206f$var$src.byteLength);
    return value;
}
function $4c3270599345206f$export$e6f020404d5b6c15() {
    $4c3270599345206f$var$src = null;
    $4c3270599345206f$var$referenceMap = null;
    $4c3270599345206f$var$currentStructures = null;
}
function $4c3270599345206f$export$4e11b2f4fcd6c82d(extension) {
    $4c3270599345206f$var$currentExtensions[extension.tag] = extension.decode;
}
const $4c3270599345206f$export$c652a5bbb6be7a36 = new Array(147) // this is a table matching binary exponents to the multiplier to determine significant digit rounding
;
for(let i = 0; i < 256; i++)$4c3270599345206f$export$c652a5bbb6be7a36[i] = +("1e" + Math.floor(45.15 - i * 0.30103));
let $4c3270599345206f$var$defaultDecoder = new $4c3270599345206f$export$f9de6ca0bc043724({
    useRecords: false
});
const $4c3270599345206f$export$2f872c0f2117be69 = $4c3270599345206f$var$defaultDecoder.decode;
const $4c3270599345206f$export$ddfa300a3790ac32 = $4c3270599345206f$var$defaultDecoder.decodeMultiple;
const $4c3270599345206f$export$2239e49a3e351685 = {
    NEVER: 0,
    ALWAYS: 1,
    DECIMAL_ROUND: 3,
    DECIMAL_FIT: 4
};
function $4c3270599345206f$export$36da082398e4f139(float32Number) {
    $4c3270599345206f$var$f32Array[0] = float32Number;
    let multiplier = $4c3270599345206f$export$c652a5bbb6be7a36[($4c3270599345206f$var$u8Array[3] & 0x7f) << 1 | $4c3270599345206f$var$u8Array[2] >> 7];
    return (multiplier * float32Number + (float32Number > 0 ? 0.5 : -0.5) >> 0) / multiplier;
}


let $83cca8f38d19f682$var$textEncoder;
try {
    $83cca8f38d19f682$var$textEncoder = new TextEncoder();
} catch (error) {}
let $83cca8f38d19f682$var$extensions, $83cca8f38d19f682$var$extensionClasses;
const $83cca8f38d19f682$var$Buffer = typeof globalThis === "object" && globalThis.Buffer;
const $83cca8f38d19f682$var$hasNodeBuffer = typeof $83cca8f38d19f682$var$Buffer !== "undefined";
const $83cca8f38d19f682$var$ByteArrayAllocate = $83cca8f38d19f682$var$hasNodeBuffer ? $83cca8f38d19f682$var$Buffer.allocUnsafeSlow : Uint8Array;
const $83cca8f38d19f682$var$ByteArray = $83cca8f38d19f682$var$hasNodeBuffer ? $83cca8f38d19f682$var$Buffer : Uint8Array;
const $83cca8f38d19f682$var$MAX_STRUCTURES = 0x100;
const $83cca8f38d19f682$var$MAX_BUFFER_SIZE = $83cca8f38d19f682$var$hasNodeBuffer ? 0x100000000 : 0x7fd00000;
let $83cca8f38d19f682$var$serializationId = 1;
let $83cca8f38d19f682$var$throwOnIterable;
let $83cca8f38d19f682$var$target;
let $83cca8f38d19f682$var$targetView;
let $83cca8f38d19f682$var$position = 0;
let $83cca8f38d19f682$var$safeEnd;
let $83cca8f38d19f682$var$bundledStrings = null;
const $83cca8f38d19f682$var$MAX_BUNDLE_SIZE = 0xf000;
const $83cca8f38d19f682$var$hasNonLatin = /[\u0080-\uFFFF]/;
const $83cca8f38d19f682$var$RECORD_SYMBOL = Symbol("record-id");
class $83cca8f38d19f682$export$a50aceb0e02a00aa extends (0, $4c3270599345206f$export$f9de6ca0bc043724) {
    constructor(options){
        super(options);
        this.offset = 0;
        let typeBuffer;
        let start;
        let sharedStructures;
        let hasSharedUpdate;
        let structures;
        let referenceMap;
        options = options || {};
        let encodeUtf8 = $83cca8f38d19f682$var$ByteArray.prototype.utf8Write ? function(string, position, maxBytes) {
            return $83cca8f38d19f682$var$target.utf8Write(string, position, maxBytes);
        } : $83cca8f38d19f682$var$textEncoder && $83cca8f38d19f682$var$textEncoder.encodeInto ? function(string, position) {
            return $83cca8f38d19f682$var$textEncoder.encodeInto(string, $83cca8f38d19f682$var$target.subarray(position)).written;
        } : false;
        let encoder = this;
        let hasSharedStructures = options.structures || options.saveStructures;
        let maxSharedStructures = options.maxSharedStructures;
        if (maxSharedStructures == null) maxSharedStructures = hasSharedStructures ? 128 : 0;
        if (maxSharedStructures > 8190) throw new Error("Maximum maxSharedStructure is 8190");
        let isSequential = options.sequential;
        if (isSequential) maxSharedStructures = 0;
        if (!this.structures) this.structures = [];
        if (this.saveStructures) this.saveShared = this.saveStructures;
        let samplingPackedValues, packedObjectMap1, sharedValues = options.sharedValues;
        let sharedPackedObjectMap1;
        if (sharedValues) {
            sharedPackedObjectMap1 = Object.create(null);
            for(let i = 0, l = sharedValues.length; i < l; i++)sharedPackedObjectMap1[sharedValues[i]] = i;
        }
        let recordIdsToRemove = [];
        let transitionsCount = 0;
        let serializationsSinceTransitionRebuild = 0;
        this.mapEncode = function(value, encodeOptions) {
            // Experimental support for premapping keys using _keyMap instad of keyMap - not optiimised yet)
            if (this._keyMap && !this._mapped) //console.log('encoding ', value)
            switch(value.constructor.name){
                case "Array":
                    value = value.map((r)=>this.encodeKeys(r));
                    break;
            }
            return this.encode(value, encodeOptions);
        };
        this.encode = function(value, encodeOptions) {
            if (!$83cca8f38d19f682$var$target) {
                $83cca8f38d19f682$var$target = new $83cca8f38d19f682$var$ByteArrayAllocate(8192);
                $83cca8f38d19f682$var$targetView = new DataView($83cca8f38d19f682$var$target.buffer, 0, 8192);
                $83cca8f38d19f682$var$position = 0;
            }
            $83cca8f38d19f682$var$safeEnd = $83cca8f38d19f682$var$target.length - 10;
            if ($83cca8f38d19f682$var$safeEnd - $83cca8f38d19f682$var$position < 0x800) {
                // don't start too close to the end, 
                $83cca8f38d19f682$var$target = new $83cca8f38d19f682$var$ByteArrayAllocate($83cca8f38d19f682$var$target.length);
                $83cca8f38d19f682$var$targetView = new DataView($83cca8f38d19f682$var$target.buffer, 0, $83cca8f38d19f682$var$target.length);
                $83cca8f38d19f682$var$safeEnd = $83cca8f38d19f682$var$target.length - 10;
                $83cca8f38d19f682$var$position = 0;
            } else if (encodeOptions === $83cca8f38d19f682$export$d41ac1453288b342) $83cca8f38d19f682$var$position = $83cca8f38d19f682$var$position + 7 & 0x7ffffff8 // Word align to make any future copying of this buffer faster
            ;
            start = $83cca8f38d19f682$var$position;
            if (encoder.useSelfDescribedHeader) {
                $83cca8f38d19f682$var$targetView.setUint32($83cca8f38d19f682$var$position, 0xd9d9f700) // tag two byte, then self-descriptive tag
                ;
                $83cca8f38d19f682$var$position += 3;
            }
            referenceMap = encoder.structuredClone ? new Map() : null;
            if (encoder.bundleStrings && typeof value !== "string") {
                $83cca8f38d19f682$var$bundledStrings = [];
                $83cca8f38d19f682$var$bundledStrings.size = Infinity // force a new bundle start on first string
                ;
            } else $83cca8f38d19f682$var$bundledStrings = null;
            sharedStructures = encoder.structures;
            if (sharedStructures) {
                if (sharedStructures.uninitialized) {
                    let sharedData = encoder.getShared() || {};
                    encoder.structures = sharedStructures = sharedData.structures || [];
                    encoder.sharedVersion = sharedData.version;
                    let sharedValues = encoder.sharedValues = sharedData.packedValues;
                    if (sharedValues) {
                        sharedPackedObjectMap1 = {};
                        for(let i = 0, l = sharedValues.length; i < l; i++)sharedPackedObjectMap1[sharedValues[i]] = i;
                    }
                }
                let sharedStructuresLength = sharedStructures.length;
                if (sharedStructuresLength > maxSharedStructures && !isSequential) sharedStructuresLength = maxSharedStructures;
                if (!sharedStructures.transitions) {
                    // rebuild our structure transitions
                    sharedStructures.transitions = Object.create(null);
                    for(let i = 0; i < sharedStructuresLength; i++){
                        let keys = sharedStructures[i];
                        //console.log('shared struct keys:', keys)
                        if (!keys) continue;
                        let nextTransition, transition = sharedStructures.transitions;
                        for(let j = 0, l = keys.length; j < l; j++){
                            if (transition[$83cca8f38d19f682$var$RECORD_SYMBOL] === undefined) transition[$83cca8f38d19f682$var$RECORD_SYMBOL] = i;
                            let key = keys[j];
                            nextTransition = transition[key];
                            if (!nextTransition) nextTransition = transition[key] = Object.create(null);
                            transition = nextTransition;
                        }
                        transition[$83cca8f38d19f682$var$RECORD_SYMBOL] = i | 0x100000;
                    }
                }
                if (!isSequential) sharedStructures.nextId = sharedStructuresLength;
            }
            if (hasSharedUpdate) hasSharedUpdate = false;
            structures = sharedStructures || [];
            packedObjectMap1 = sharedPackedObjectMap1;
            if (options.pack) {
                let packedValues = new Map();
                packedValues.values = [];
                packedValues.encoder = encoder;
                packedValues.maxValues = options.maxPrivatePackedValues || (sharedPackedObjectMap1 ? 16 : Infinity);
                packedValues.objectMap = sharedPackedObjectMap1 || false;
                packedValues.samplingPackedValues = samplingPackedValues;
                $83cca8f38d19f682$var$findRepetitiveStrings(value, packedValues);
                if (packedValues.values.length > 0) {
                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xd8 // one-byte tag
                    ;
                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 51 // tag 51 for packed shared structures https://www.potaroo.net/ietf/ids/draft-ietf-cbor-packed-03.txt
                    ;
                    $83cca8f38d19f682$var$writeArrayHeader(4);
                    let valuesArray = packedValues.values;
                    encode(valuesArray);
                    $83cca8f38d19f682$var$writeArrayHeader(0) // prefixes
                    ;
                    $83cca8f38d19f682$var$writeArrayHeader(0) // suffixes
                    ;
                    packedObjectMap1 = Object.create(sharedPackedObjectMap1 || null);
                    for(let i = 0, l = valuesArray.length; i < l; i++)packedObjectMap1[valuesArray[i]] = i;
                }
            }
            $83cca8f38d19f682$var$throwOnIterable = encodeOptions & $83cca8f38d19f682$export$e724ae76933ea297;
            try {
                if ($83cca8f38d19f682$var$throwOnIterable) return;
                encode(value);
                if ($83cca8f38d19f682$var$bundledStrings) $83cca8f38d19f682$var$writeBundles(start, encode);
                encoder.offset = $83cca8f38d19f682$var$position // update the offset so next serialization doesn't write over our buffer, but can continue writing to same buffer sequentially
                ;
                if (referenceMap && referenceMap.idsToInsert) {
                    $83cca8f38d19f682$var$position += referenceMap.idsToInsert.length * 2;
                    if ($83cca8f38d19f682$var$position > $83cca8f38d19f682$var$safeEnd) makeRoom($83cca8f38d19f682$var$position);
                    encoder.offset = $83cca8f38d19f682$var$position;
                    let serialized = $83cca8f38d19f682$var$insertIds($83cca8f38d19f682$var$target.subarray(start, $83cca8f38d19f682$var$position), referenceMap.idsToInsert);
                    referenceMap = null;
                    return serialized;
                }
                if (encodeOptions & $83cca8f38d19f682$export$d41ac1453288b342) {
                    $83cca8f38d19f682$var$target.start = start;
                    $83cca8f38d19f682$var$target.end = $83cca8f38d19f682$var$position;
                    return $83cca8f38d19f682$var$target;
                }
                return $83cca8f38d19f682$var$target.subarray(start, $83cca8f38d19f682$var$position) // position can change if we call encode again in saveShared, so we get the buffer now
                ;
            } finally{
                if (sharedStructures) {
                    if (serializationsSinceTransitionRebuild < 10) serializationsSinceTransitionRebuild++;
                    if (sharedStructures.length > maxSharedStructures) sharedStructures.length = maxSharedStructures;
                    if (transitionsCount > 10000) {
                        // force a rebuild occasionally after a lot of transitions so it can get cleaned up
                        sharedStructures.transitions = null;
                        serializationsSinceTransitionRebuild = 0;
                        transitionsCount = 0;
                        if (recordIdsToRemove.length > 0) recordIdsToRemove = [];
                    } else if (recordIdsToRemove.length > 0 && !isSequential) {
                        for(let i = 0, l = recordIdsToRemove.length; i < l; i++)recordIdsToRemove[i][$83cca8f38d19f682$var$RECORD_SYMBOL] = undefined;
                        recordIdsToRemove = [];
                    //sharedStructures.nextId = maxSharedStructures
                    }
                }
                if (hasSharedUpdate && encoder.saveShared) {
                    if (encoder.structures.length > maxSharedStructures) encoder.structures = encoder.structures.slice(0, maxSharedStructures);
                    // we can't rely on start/end with REUSE_BUFFER_MODE since they will (probably) change when we save
                    let returnBuffer = $83cca8f38d19f682$var$target.subarray(start, $83cca8f38d19f682$var$position);
                    if (encoder.updateSharedData() === false) return encoder.encode(value) // re-encode if it fails
                    ;
                    return returnBuffer;
                }
                if (encodeOptions & $83cca8f38d19f682$export$5687accb6effa257) $83cca8f38d19f682$var$position = start;
            }
        };
        this.findCommonStringsToPack = ()=>{
            samplingPackedValues = new Map();
            if (!sharedPackedObjectMap1) sharedPackedObjectMap1 = Object.create(null);
            return (options)=>{
                let threshold = options && options.threshold || 4;
                let position = this.pack ? options.maxPrivatePackedValues || 16 : 0;
                if (!sharedValues) sharedValues = this.sharedValues = [];
                for (let [key, status] of samplingPackedValues)if (status.count > threshold) {
                    sharedPackedObjectMap1[key] = position++;
                    sharedValues.push(key);
                    hasSharedUpdate = true;
                }
                while(this.saveShared && this.updateSharedData() === false);
                samplingPackedValues = null;
            };
        };
        const encode = (value)=>{
            if ($83cca8f38d19f682$var$position > $83cca8f38d19f682$var$safeEnd) $83cca8f38d19f682$var$target = makeRoom($83cca8f38d19f682$var$position);
            var type = typeof value;
            var length;
            if (type === "string") {
                if (packedObjectMap1) {
                    let packedPosition = packedObjectMap1[value];
                    if (packedPosition >= 0) {
                        if (packedPosition < 16) $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = packedPosition + 0xe0 // simple values, defined in https://www.potaroo.net/ietf/ids/draft-ietf-cbor-packed-03.txt
                        ;
                        else {
                            $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xc6 // tag 6 defined in https://www.potaroo.net/ietf/ids/draft-ietf-cbor-packed-03.txt
                            ;
                            if (packedPosition & 1) encode(15 - packedPosition >> 1);
                            else encode(packedPosition - 16 >> 1);
                        }
                        return;
                    /*						} else if (packedStatus.serializationId != serializationId) {
							packedStatus.serializationId = serializationId
							packedStatus.count = 1
							if (options.sharedPack) {
								let sharedCount = packedStatus.sharedCount = (packedStatus.sharedCount || 0) + 1
								if (shareCount > (options.sharedPack.threshold || 5)) {
									let sharedPosition = packedStatus.position = packedStatus.nextSharedPosition
									hasSharedUpdate = true
									if (sharedPosition < 16)
										target[position++] = sharedPosition + 0xc0

								}
							}
						} // else any in-doc incrementation?*/ } else if (samplingPackedValues && !options.pack) {
                        let status = samplingPackedValues.get(value);
                        if (status) status.count++;
                        else samplingPackedValues.set(value, {
                            count: 1
                        });
                    }
                }
                let strLength = value.length;
                if ($83cca8f38d19f682$var$bundledStrings && strLength >= 4 && strLength < 0x400) {
                    if (($83cca8f38d19f682$var$bundledStrings.size += strLength) > $83cca8f38d19f682$var$MAX_BUNDLE_SIZE) {
                        let extStart;
                        let maxBytes = ($83cca8f38d19f682$var$bundledStrings[0] ? $83cca8f38d19f682$var$bundledStrings[0].length * 3 + $83cca8f38d19f682$var$bundledStrings[1].length : 0) + 10;
                        if ($83cca8f38d19f682$var$position + maxBytes > $83cca8f38d19f682$var$safeEnd) $83cca8f38d19f682$var$target = makeRoom($83cca8f38d19f682$var$position + maxBytes);
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xd9 // tag 16-bit
                        ;
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xdf // tag 0xdff9
                        ;
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xf9;
                        // TODO: If we only have one bundle with any string data, only write one string bundle
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = $83cca8f38d19f682$var$bundledStrings.position ? 0x84 : 0x82 // array of 4 or 2 elements depending on if we write bundles
                        ;
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x1a // 32-bit unsigned int
                        ;
                        extStart = $83cca8f38d19f682$var$position - start;
                        $83cca8f38d19f682$var$position += 4 // reserve for writing bundle reference
                        ;
                        if ($83cca8f38d19f682$var$bundledStrings.position) $83cca8f38d19f682$var$writeBundles(start, encode) // write the last bundles
                        ;
                        $83cca8f38d19f682$var$bundledStrings = [
                            "",
                            ""
                        ] // create new ones
                        ;
                        $83cca8f38d19f682$var$bundledStrings.size = 0;
                        $83cca8f38d19f682$var$bundledStrings.position = extStart;
                    }
                    let twoByte = $83cca8f38d19f682$var$hasNonLatin.test(value);
                    $83cca8f38d19f682$var$bundledStrings[twoByte ? 0 : 1] += value;
                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = twoByte ? 0xce : 0xcf;
                    encode(strLength);
                    return;
                }
                let headerSize;
                // first we estimate the header size, so we can write to the correct location
                if (strLength < 0x20) headerSize = 1;
                else if (strLength < 0x100) headerSize = 2;
                else if (strLength < 0x10000) headerSize = 3;
                else headerSize = 5;
                let maxBytes = strLength * 3;
                if ($83cca8f38d19f682$var$position + maxBytes > $83cca8f38d19f682$var$safeEnd) $83cca8f38d19f682$var$target = makeRoom($83cca8f38d19f682$var$position + maxBytes);
                if (strLength < 0x40 || !encodeUtf8) {
                    let i, c1, c2, strPosition = $83cca8f38d19f682$var$position + headerSize;
                    for(i = 0; i < strLength; i++){
                        c1 = value.charCodeAt(i);
                        if (c1 < 0x80) $83cca8f38d19f682$var$target[strPosition++] = c1;
                        else if (c1 < 0x800) {
                            $83cca8f38d19f682$var$target[strPosition++] = c1 >> 6 | 0xc0;
                            $83cca8f38d19f682$var$target[strPosition++] = c1 & 0x3f | 0x80;
                        } else if ((c1 & 0xfc00) === 0xd800 && ((c2 = value.charCodeAt(i + 1)) & 0xfc00) === 0xdc00) {
                            c1 = 0x10000 + ((c1 & 0x03ff) << 10) + (c2 & 0x03ff);
                            i++;
                            $83cca8f38d19f682$var$target[strPosition++] = c1 >> 18 | 0xf0;
                            $83cca8f38d19f682$var$target[strPosition++] = c1 >> 12 & 0x3f | 0x80;
                            $83cca8f38d19f682$var$target[strPosition++] = c1 >> 6 & 0x3f | 0x80;
                            $83cca8f38d19f682$var$target[strPosition++] = c1 & 0x3f | 0x80;
                        } else {
                            $83cca8f38d19f682$var$target[strPosition++] = c1 >> 12 | 0xe0;
                            $83cca8f38d19f682$var$target[strPosition++] = c1 >> 6 & 0x3f | 0x80;
                            $83cca8f38d19f682$var$target[strPosition++] = c1 & 0x3f | 0x80;
                        }
                    }
                    length = strPosition - $83cca8f38d19f682$var$position - headerSize;
                } else length = encodeUtf8(value, $83cca8f38d19f682$var$position + headerSize, maxBytes);
                if (length < 0x18) $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x60 | length;
                else if (length < 0x100) {
                    if (headerSize < 2) $83cca8f38d19f682$var$target.copyWithin($83cca8f38d19f682$var$position + 2, $83cca8f38d19f682$var$position + 1, $83cca8f38d19f682$var$position + 1 + length);
                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x78;
                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length;
                } else if (length < 0x10000) {
                    if (headerSize < 3) $83cca8f38d19f682$var$target.copyWithin($83cca8f38d19f682$var$position + 3, $83cca8f38d19f682$var$position + 2, $83cca8f38d19f682$var$position + 2 + length);
                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x79;
                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length >> 8;
                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length & 0xff;
                } else {
                    if (headerSize < 5) $83cca8f38d19f682$var$target.copyWithin($83cca8f38d19f682$var$position + 5, $83cca8f38d19f682$var$position + 3, $83cca8f38d19f682$var$position + 3 + length);
                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x7a;
                    $83cca8f38d19f682$var$targetView.setUint32($83cca8f38d19f682$var$position, length);
                    $83cca8f38d19f682$var$position += 4;
                }
                $83cca8f38d19f682$var$position += length;
            } else if (type === "number") {
                if (!this.alwaysUseFloat && value >>> 0 === value) {
                    // positive uint
                    if (value < 0x18) $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = value;
                    else if (value < 0x100) {
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x18;
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = value;
                    } else if (value < 0x10000) {
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x19;
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = value >> 8;
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = value & 0xff;
                    } else {
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x1a;
                        $83cca8f38d19f682$var$targetView.setUint32($83cca8f38d19f682$var$position, value);
                        $83cca8f38d19f682$var$position += 4;
                    }
                } else if (!this.alwaysUseFloat && value >> 0 === value) {
                    if (value >= -24) $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x1f - value;
                    else if (value >= -256) {
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x38;
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = ~value;
                    } else if (value >= -65536) {
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x39;
                        $83cca8f38d19f682$var$targetView.setUint16($83cca8f38d19f682$var$position, ~value);
                        $83cca8f38d19f682$var$position += 2;
                    } else {
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x3a;
                        $83cca8f38d19f682$var$targetView.setUint32($83cca8f38d19f682$var$position, ~value);
                        $83cca8f38d19f682$var$position += 4;
                    }
                } else {
                    let useFloat32;
                    if ((useFloat32 = this.useFloat32) > 0 && value < 0x100000000 && value >= -2147483648) {
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xfa;
                        $83cca8f38d19f682$var$targetView.setFloat32($83cca8f38d19f682$var$position, value);
                        let xShifted;
                        if (useFloat32 < 4 || (xShifted = value * (0, $4c3270599345206f$export$c652a5bbb6be7a36)[($83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position] & 0x7f) << 1 | $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position + 1] >> 7]) >> 0 === xShifted) {
                            $83cca8f38d19f682$var$position += 4;
                            return;
                        } else $83cca8f38d19f682$var$position-- // move back into position for writing a double
                        ;
                    }
                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xfb;
                    $83cca8f38d19f682$var$targetView.setFloat64($83cca8f38d19f682$var$position, value);
                    $83cca8f38d19f682$var$position += 8;
                }
            } else if (type === "object") {
                if (!value) $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xf6;
                else {
                    if (referenceMap) {
                        let referee = referenceMap.get(value);
                        if (referee) {
                            $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xd8;
                            $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 29 // http://cbor.schmorp.de/value-sharing
                            ;
                            $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x19 // 16-bit uint
                            ;
                            if (!referee.references) {
                                let idsToInsert = referenceMap.idsToInsert || (referenceMap.idsToInsert = []);
                                referee.references = [];
                                idsToInsert.push(referee);
                            }
                            referee.references.push($83cca8f38d19f682$var$position - start);
                            $83cca8f38d19f682$var$position += 2 // TODO: also support 32-bit
                            ;
                            return;
                        } else referenceMap.set(value, {
                            offset: $83cca8f38d19f682$var$position - start
                        });
                    }
                    let constructor = value.constructor;
                    if (constructor === Object) writeObject(value, true);
                    else if (constructor === Array) {
                        length = value.length;
                        if (length < 0x18) $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x80 | length;
                        else $83cca8f38d19f682$var$writeArrayHeader(length);
                        for(let i = 0; i < length; i++)encode(value[i]);
                    } else if (constructor === Map) {
                        if (this.mapsAsObjects ? this.useTag259ForMaps !== false : this.useTag259ForMaps) {
                            // use Tag 259 (https://github.com/shanewholloway/js-cbor-codec/blob/master/docs/CBOR-259-spec--explicit-maps.md) for maps if the user wants it that way
                            $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xd9;
                            $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 1;
                            $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 3;
                        }
                        length = value.size;
                        if (length < 0x18) $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xa0 | length;
                        else if (length < 0x100) {
                            $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xb8;
                            $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length;
                        } else if (length < 0x10000) {
                            $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xb9;
                            $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length >> 8;
                            $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length & 0xff;
                        } else {
                            $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xba;
                            $83cca8f38d19f682$var$targetView.setUint32($83cca8f38d19f682$var$position, length);
                            $83cca8f38d19f682$var$position += 4;
                        }
                        if (encoder.keyMap) for (let [key, entryValue] of value){
                            encode(encoder.encodeKey(key));
                            encode(entryValue);
                        }
                        else for (let [key, entryValue] of value){
                            encode(key);
                            encode(entryValue);
                        }
                    } else {
                        for(let i = 0, l = $83cca8f38d19f682$var$extensions.length; i < l; i++){
                            let extensionClass = $83cca8f38d19f682$var$extensionClasses[i];
                            if (value instanceof extensionClass) {
                                let extension = $83cca8f38d19f682$var$extensions[i];
                                let tag = extension.tag;
                                if (tag == undefined) tag = extension.getTag && extension.getTag.call(this, value);
                                if (tag < 0x18) $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xc0 | tag;
                                else if (tag < 0x100) {
                                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xd8;
                                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = tag;
                                } else if (tag < 0x10000) {
                                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xd9;
                                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = tag >> 8;
                                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = tag & 0xff;
                                } else if (tag > -1) {
                                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xda;
                                    $83cca8f38d19f682$var$targetView.setUint32($83cca8f38d19f682$var$position, tag);
                                    $83cca8f38d19f682$var$position += 4;
                                } // else undefined, don't write tag
                                extension.encode.call(this, value, encode, makeRoom);
                                return;
                            }
                        }
                        if (value[Symbol.iterator]) {
                            if ($83cca8f38d19f682$var$throwOnIterable) {
                                let error = new Error("Iterable should be serialized as iterator");
                                error.iteratorNotHandled = true;
                                throw error;
                            }
                            $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x9f // indefinite length array
                            ;
                            for (let entry of value)encode(entry);
                            $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xff // stop-code
                            ;
                            return;
                        }
                        if (value[Symbol.asyncIterator] || $83cca8f38d19f682$var$isBlob(value)) {
                            let error = new Error("Iterable/blob should be serialized as iterator");
                            error.iteratorNotHandled = true;
                            throw error;
                        }
                        if (this.useToJSON && value.toJSON) {
                            const json = value.toJSON();
                            // if for some reason value.toJSON returns itself it'll loop forever
                            if (json !== value) return encode(json);
                        }
                        // no extension found, write as object
                        writeObject(value, !value.hasOwnProperty) // if it doesn't have hasOwnProperty, don't do hasOwnProperty checks
                        ;
                    }
                }
            } else if (type === "boolean") $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = value ? 0xf5 : 0xf4;
            else if (type === "bigint") {
                if (value < BigInt(1) << BigInt(64) && value >= 0) {
                    // use an unsigned int as long as it fits
                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x1b;
                    $83cca8f38d19f682$var$targetView.setBigUint64($83cca8f38d19f682$var$position, value);
                } else if (value > -(BigInt(1) << BigInt(64)) && value < 0) {
                    // if we can fit an unsigned int, use that
                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x3b;
                    $83cca8f38d19f682$var$targetView.setBigUint64($83cca8f38d19f682$var$position, -value - BigInt(1));
                } else {
                    // overflow
                    if (this.largeBigIntToFloat) {
                        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xfb;
                        $83cca8f38d19f682$var$targetView.setFloat64($83cca8f38d19f682$var$position, Number(value));
                    } else throw new RangeError(value + " was too large to fit in CBOR 64-bit integer format, set largeBigIntToFloat to convert to float-64");
                }
                $83cca8f38d19f682$var$position += 8;
            } else if (type === "undefined") $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xf7;
            else throw new Error("Unknown type: " + type);
        };
        const writeObject = this.useRecords === false ? this.variableMapSize ? (object)=>{
            // this method is slightly slower, but generates "preferred serialization" (optimally small for smaller objects)
            let keys = Object.keys(object);
            let vals = Object.values(object);
            let length = keys.length;
            if (length < 0x18) $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xa0 | length;
            else if (length < 0x100) {
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xb8;
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length;
            } else if (length < 0x10000) {
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xb9;
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length >> 8;
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length & 0xff;
            } else {
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xba;
                $83cca8f38d19f682$var$targetView.setUint32($83cca8f38d19f682$var$position, length);
                $83cca8f38d19f682$var$position += 4;
            }
            let key;
            if (encoder.keyMap) for(let i = 0; i < length; i++){
                encode(encoder.encodeKey(keys[i]));
                encode(vals[i]);
            }
            else for(let i = 0; i < length; i++){
                encode(keys[i]);
                encode(vals[i]);
            }
        } : (object, safePrototype)=>{
            $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xb9 // always use map 16, so we can preallocate and set the length afterwards
            ;
            let objectOffset = $83cca8f38d19f682$var$position - start;
            $83cca8f38d19f682$var$position += 2;
            let size = 0;
            if (encoder.keyMap) {
                for(let key in object)if (safePrototype || object.hasOwnProperty(key)) {
                    encode(encoder.encodeKey(key));
                    encode(object[key]);
                    size++;
                }
            } else {
                for(let key in object)if (safePrototype || object.hasOwnProperty(key)) {
                    encode(key);
                    encode(object[key]);
                    size++;
                }
            }
            $83cca8f38d19f682$var$target[objectOffset++ + start] = size >> 8;
            $83cca8f38d19f682$var$target[objectOffset + start] = size & 0xff;
        } : (object, safePrototype)=>{
            let nextTransition, transition = structures.transitions || (structures.transitions = Object.create(null));
            let newTransitions = 0;
            let length = 0;
            let parentRecordId;
            let keys;
            if (this.keyMap) {
                keys = Object.keys(object).map((k)=>this.encodeKey(k));
                length = keys.length;
                for(let i = 0; i < length; i++){
                    let key = keys[i];
                    nextTransition = transition[key];
                    if (!nextTransition) {
                        nextTransition = transition[key] = Object.create(null);
                        newTransitions++;
                    }
                    transition = nextTransition;
                }
            } else {
                for(let key in object)if (safePrototype || object.hasOwnProperty(key)) {
                    nextTransition = transition[key];
                    if (!nextTransition) {
                        if (transition[$83cca8f38d19f682$var$RECORD_SYMBOL] & 0x100000) parentRecordId = transition[$83cca8f38d19f682$var$RECORD_SYMBOL] & 0xffff;
                        nextTransition = transition[key] = Object.create(null);
                        newTransitions++;
                    }
                    transition = nextTransition;
                    length++;
                }
            }
            let recordId = transition[$83cca8f38d19f682$var$RECORD_SYMBOL];
            if (recordId !== undefined) {
                recordId &= 0xffff;
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xd9;
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = recordId >> 8 | 0xe0;
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = recordId & 0xff;
            } else {
                if (!keys) keys = transition.__keys__ || (transition.__keys__ = Object.keys(object));
                if (parentRecordId === undefined) {
                    recordId = structures.nextId++;
                    if (!recordId) {
                        recordId = 0;
                        structures.nextId = 1;
                    }
                    if (recordId >= $83cca8f38d19f682$var$MAX_STRUCTURES) structures.nextId = (recordId = maxSharedStructures) + 1;
                } else recordId = parentRecordId;
                structures[recordId] = keys;
                if (recordId < maxSharedStructures) {
                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xd9;
                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = recordId >> 8 | 0xe0;
                    $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = recordId & 0xff;
                    transition = structures.transitions;
                    for(let i = 0; i < length; i++){
                        if (transition[$83cca8f38d19f682$var$RECORD_SYMBOL] === undefined || transition[$83cca8f38d19f682$var$RECORD_SYMBOL] & 0x100000) transition[$83cca8f38d19f682$var$RECORD_SYMBOL] = recordId;
                        transition = transition[keys[i]];
                    }
                    transition[$83cca8f38d19f682$var$RECORD_SYMBOL] = recordId | 0x100000 // indicates it is a extendable terminal
                    ;
                    hasSharedUpdate = true;
                } else {
                    transition[$83cca8f38d19f682$var$RECORD_SYMBOL] = recordId;
                    $83cca8f38d19f682$var$targetView.setUint32($83cca8f38d19f682$var$position, 0xd9dfff00) // tag two byte, then record definition id
                    ;
                    $83cca8f38d19f682$var$position += 3;
                    if (newTransitions) transitionsCount += serializationsSinceTransitionRebuild * newTransitions;
                    // record the removal of the id, we can maintain our shared structure
                    if (recordIdsToRemove.length >= $83cca8f38d19f682$var$MAX_STRUCTURES - maxSharedStructures) recordIdsToRemove.shift()[$83cca8f38d19f682$var$RECORD_SYMBOL] = undefined // we are cycling back through, and have to remove old ones
                    ;
                    recordIdsToRemove.push(transition);
                    $83cca8f38d19f682$var$writeArrayHeader(length + 2);
                    encode(0xe000 + recordId);
                    encode(keys);
                    if (safePrototype === null) return; // special exit for iterator
                    for(let key in object)if (safePrototype || object.hasOwnProperty(key)) encode(object[key]);
                    return;
                }
            }
            if (length < 0x18) $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x80 | length;
            else $83cca8f38d19f682$var$writeArrayHeader(length);
            if (safePrototype === null) return; // special exit for iterator
            for(let key in object)if (safePrototype || object.hasOwnProperty(key)) encode(object[key]);
        };
        const makeRoom = (end)=>{
            let newSize;
            if (end > 0x1000000) {
                // special handling for really large buffers
                if (end - start > $83cca8f38d19f682$var$MAX_BUFFER_SIZE) throw new Error("Encoded buffer would be larger than maximum buffer size");
                newSize = Math.min($83cca8f38d19f682$var$MAX_BUFFER_SIZE, Math.round(Math.max((end - start) * (end > 0x4000000 ? 1.25 : 2), 0x400000) / 0x1000) * 0x1000);
            } else newSize = (Math.max(end - start << 2, $83cca8f38d19f682$var$target.length - 1) >> 12) + 1 << 12;
            let newBuffer = new $83cca8f38d19f682$var$ByteArrayAllocate(newSize);
            $83cca8f38d19f682$var$targetView = new DataView(newBuffer.buffer, 0, newSize);
            if ($83cca8f38d19f682$var$target.copy) $83cca8f38d19f682$var$target.copy(newBuffer, 0, start, end);
            else newBuffer.set($83cca8f38d19f682$var$target.slice(start, end));
            $83cca8f38d19f682$var$position -= start;
            start = 0;
            $83cca8f38d19f682$var$safeEnd = newBuffer.length - 10;
            return $83cca8f38d19f682$var$target = newBuffer;
        };
        let chunkThreshold = 100;
        let continuedChunkThreshold = 1000;
        this.encodeAsIterable = function(value, options) {
            return startEncoding(value, options, encodeObjectAsIterable);
        };
        this.encodeAsAsyncIterable = function(value, options) {
            return startEncoding(value, options, encodeObjectAsAsyncIterable);
        };
        function* encodeObjectAsIterable(object, iterateProperties, finalIterable) {
            let constructor = object.constructor;
            if (constructor === Object) {
                let useRecords = encoder.useRecords !== false;
                if (useRecords) writeObject(object, null); // write the record identifier
                else $83cca8f38d19f682$var$writeEntityLength(Object.keys(object).length, 0xa0);
                for(let key in object){
                    let value = object[key];
                    if (!useRecords) encode(key);
                    if (value && typeof value === "object") {
                        if (iterateProperties[key]) yield* encodeObjectAsIterable(value, iterateProperties[key]);
                        else yield* tryEncode(value, iterateProperties, key);
                    } else encode(value);
                }
            } else if (constructor === Array) {
                let length = object.length;
                $83cca8f38d19f682$var$writeArrayHeader(length);
                for(let i = 0; i < length; i++){
                    let value = object[i];
                    if (value && (typeof value === "object" || $83cca8f38d19f682$var$position - start > chunkThreshold)) {
                        if (iterateProperties.element) yield* encodeObjectAsIterable(value, iterateProperties.element);
                        else yield* tryEncode(value, iterateProperties, "element");
                    } else encode(value);
                }
            } else if (object[Symbol.iterator]) {
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x9f; // start indefinite array
                for (let value of object)if (value && (typeof value === "object" || $83cca8f38d19f682$var$position - start > chunkThreshold)) {
                    if (iterateProperties.element) yield* encodeObjectAsIterable(value, iterateProperties.element);
                    else yield* tryEncode(value, iterateProperties, "element");
                } else encode(value);
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xff; // stop byte
            } else if ($83cca8f38d19f682$var$isBlob(object)) {
                $83cca8f38d19f682$var$writeEntityLength(object.size, 0x40); // encode as binary data
                yield $83cca8f38d19f682$var$target.subarray(start, $83cca8f38d19f682$var$position);
                yield object; // directly return blobs, they have to be encoded asynchronously
                restartEncoding();
            } else if (object[Symbol.asyncIterator]) {
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x9f; // start indefinite array
                yield $83cca8f38d19f682$var$target.subarray(start, $83cca8f38d19f682$var$position);
                yield object; // directly return async iterators, they have to be encoded asynchronously
                restartEncoding();
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xff; // stop byte
            } else encode(object);
            if (finalIterable && $83cca8f38d19f682$var$position > start) yield $83cca8f38d19f682$var$target.subarray(start, $83cca8f38d19f682$var$position);
            else if ($83cca8f38d19f682$var$position - start > chunkThreshold) {
                yield $83cca8f38d19f682$var$target.subarray(start, $83cca8f38d19f682$var$position);
                restartEncoding();
            }
        }
        function* tryEncode(value, iterateProperties, key) {
            let restart = $83cca8f38d19f682$var$position - start;
            try {
                encode(value);
                if ($83cca8f38d19f682$var$position - start > chunkThreshold) {
                    yield $83cca8f38d19f682$var$target.subarray(start, $83cca8f38d19f682$var$position);
                    restartEncoding();
                }
            } catch (error) {
                if (error.iteratorNotHandled) {
                    iterateProperties[key] = {};
                    $83cca8f38d19f682$var$position = start + restart; // restart our position so we don't have partial data from last encode
                    yield* encodeObjectAsIterable.call(this, value, iterateProperties[key]);
                } else throw error;
            }
        }
        function restartEncoding() {
            chunkThreshold = continuedChunkThreshold;
            encoder.encode(null, $83cca8f38d19f682$export$e724ae76933ea297); // restart encoding
        }
        function startEncoding(value, options, encodeIterable) {
            if (options && options.chunkThreshold) chunkThreshold = continuedChunkThreshold = options.chunkThreshold;
            else chunkThreshold = 100;
            if (value && typeof value === "object") {
                encoder.encode(null, $83cca8f38d19f682$export$e724ae76933ea297); // start encoding
                return encodeIterable(value, encoder.iterateProperties || (encoder.iterateProperties = {}), true);
            }
            return [
                encoder.encode(value)
            ];
        }
        async function* encodeObjectAsAsyncIterable(value, iterateProperties) {
            for (let encodedValue of encodeObjectAsIterable(value, iterateProperties, true)){
                let constructor = encodedValue.constructor;
                if (constructor === $83cca8f38d19f682$var$ByteArray || constructor === Uint8Array) yield encodedValue;
                else if ($83cca8f38d19f682$var$isBlob(encodedValue)) {
                    let reader = encodedValue.stream().getReader();
                    let next;
                    while(!(next = await reader.read()).done)yield next.value;
                } else if (encodedValue[Symbol.asyncIterator]) for await (let asyncValue of encodedValue){
                    restartEncoding();
                    if (asyncValue) yield* encodeObjectAsAsyncIterable(asyncValue, iterateProperties.async || (iterateProperties.async = {}));
                    else yield encoder.encode(asyncValue);
                }
                else yield encodedValue;
            }
        }
    }
    useBuffer(buffer) {
        // this means we are finished using our own buffer and we can write over it safely
        $83cca8f38d19f682$var$target = buffer;
        $83cca8f38d19f682$var$targetView = new DataView($83cca8f38d19f682$var$target.buffer, $83cca8f38d19f682$var$target.byteOffset, $83cca8f38d19f682$var$target.byteLength);
        $83cca8f38d19f682$var$position = 0;
    }
    clearSharedData() {
        if (this.structures) this.structures = [];
        if (this.sharedValues) this.sharedValues = undefined;
    }
    updateSharedData() {
        let lastVersion = this.sharedVersion || 0;
        this.sharedVersion = lastVersion + 1;
        let structuresCopy = this.structures.slice(0);
        let sharedData = new $83cca8f38d19f682$var$SharedData(structuresCopy, this.sharedValues, this.sharedVersion);
        let saveResults = this.saveShared(sharedData, (existingShared)=>(existingShared && existingShared.version || 0) == lastVersion);
        if (saveResults === false) {
            // get updated structures and try again if the update failed
            sharedData = this.getShared() || {};
            this.structures = sharedData.structures || [];
            this.sharedValues = sharedData.packedValues;
            this.sharedVersion = sharedData.version;
            this.structures.nextId = this.structures.length;
        } else // restore structures
        structuresCopy.forEach((structure, i)=>this.structures[i] = structure);
        // saveShared may fail to write and reload, or may have reloaded to check compatibility and overwrite saved data, either way load the correct shared data
        return saveResults;
    }
}
function $83cca8f38d19f682$var$writeEntityLength(length, majorValue) {
    if (length < 0x18) $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = majorValue | length;
    else if (length < 0x100) {
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = majorValue | 0x18;
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length;
    } else if (length < 0x10000) {
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = majorValue | 0x19;
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length >> 8;
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length & 0xff;
    } else {
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = majorValue | 0x1a;
        $83cca8f38d19f682$var$targetView.setUint32($83cca8f38d19f682$var$position, length);
        $83cca8f38d19f682$var$position += 4;
    }
}
class $83cca8f38d19f682$var$SharedData {
    constructor(structures, values, version){
        this.structures = structures;
        this.packedValues = values;
        this.version = version;
    }
}
function $83cca8f38d19f682$var$writeArrayHeader(length) {
    if (length < 0x18) $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x80 | length;
    else if (length < 0x100) {
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x98;
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length;
    } else if (length < 0x10000) {
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x99;
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length >> 8;
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length & 0xff;
    } else {
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x9a;
        $83cca8f38d19f682$var$targetView.setUint32($83cca8f38d19f682$var$position, length);
        $83cca8f38d19f682$var$position += 4;
    }
}
const $83cca8f38d19f682$var$BlobConstructor = typeof Blob === "undefined" ? function() {} : Blob;
function $83cca8f38d19f682$var$isBlob(object) {
    if (object instanceof $83cca8f38d19f682$var$BlobConstructor) return true;
    let tag = object[Symbol.toStringTag];
    return tag === "Blob" || tag === "File";
}
function $83cca8f38d19f682$var$findRepetitiveStrings(value, packedValues) {
    switch(typeof value){
        case "string":
            if (value.length > 3) {
                if (packedValues.objectMap[value] > -1 || packedValues.values.length >= packedValues.maxValues) return;
                let packedStatus = packedValues.get(value);
                if (packedStatus) {
                    if (++packedStatus.count == 2) packedValues.values.push(value);
                } else {
                    packedValues.set(value, {
                        count: 1
                    });
                    if (packedValues.samplingPackedValues) {
                        let status = packedValues.samplingPackedValues.get(value);
                        if (status) status.count++;
                        else packedValues.samplingPackedValues.set(value, {
                            count: 1
                        });
                    }
                }
            }
            break;
        case "object":
            if (value) {
                if (value instanceof Array) for(let i = 0, l = value.length; i < l; i++)$83cca8f38d19f682$var$findRepetitiveStrings(value[i], packedValues);
                else {
                    let includeKeys = !packedValues.encoder.useRecords;
                    for(var key in value)if (value.hasOwnProperty(key)) {
                        if (includeKeys) $83cca8f38d19f682$var$findRepetitiveStrings(key, packedValues);
                        $83cca8f38d19f682$var$findRepetitiveStrings(value[key], packedValues);
                    }
                }
            }
            break;
        case "function":
            console.log(value);
    }
}
const $83cca8f38d19f682$var$isLittleEndianMachine = new Uint8Array(new Uint16Array([
    1
]).buffer)[0] == 1;
$83cca8f38d19f682$var$extensionClasses = [
    Date,
    Set,
    Error,
    RegExp,
    (0, $4c3270599345206f$export$3288d34c523a1192),
    ArrayBuffer,
    Uint8Array,
    Uint8ClampedArray,
    Uint16Array,
    Uint32Array,
    typeof BigUint64Array == "undefined" ? function() {} : BigUint64Array,
    Int8Array,
    Int16Array,
    Int32Array,
    typeof BigInt64Array == "undefined" ? function() {} : BigInt64Array,
    Float32Array,
    Float64Array,
    $83cca8f38d19f682$var$SharedData
];
//Object.getPrototypeOf(Uint8Array.prototype).constructor /*TypedArray*/
$83cca8f38d19f682$var$extensions = [
    {
        tag: 1,
        encode (date, encode) {
            let seconds = date.getTime() / 1000;
            if ((this.useTimestamp32 || date.getMilliseconds() === 0) && seconds >= 0 && seconds < 0x100000000) {
                // Timestamp 32
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x1a;
                $83cca8f38d19f682$var$targetView.setUint32($83cca8f38d19f682$var$position, seconds);
                $83cca8f38d19f682$var$position += 4;
            } else {
                // Timestamp float64
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xfb;
                $83cca8f38d19f682$var$targetView.setFloat64($83cca8f38d19f682$var$position, seconds);
                $83cca8f38d19f682$var$position += 8;
            }
        }
    },
    {
        tag: 258,
        encode (set, encode) {
            let array = Array.from(set);
            encode(array);
        }
    },
    {
        tag: 27,
        encode (error, encode) {
            encode([
                error.name,
                error.message
            ]);
        }
    },
    {
        tag: 27,
        encode (regex, encode) {
            encode([
                "RegExp",
                regex.source,
                regex.flags
            ]);
        }
    },
    {
        getTag (tag) {
            return tag.tag;
        },
        encode (tag, encode) {
            encode(tag.value);
        }
    },
    {
        encode (arrayBuffer, encode, makeRoom) {
            $83cca8f38d19f682$var$writeBuffer(arrayBuffer, makeRoom);
        }
    },
    {
        getTag (typedArray) {
            if (typedArray.constructor === Uint8Array) {
                if (this.tagUint8Array || $83cca8f38d19f682$var$hasNodeBuffer && this.tagUint8Array !== false) return 64;
            } // else no tag
        },
        encode (typedArray, encode, makeRoom) {
            $83cca8f38d19f682$var$writeBuffer(typedArray, makeRoom);
        }
    },
    $83cca8f38d19f682$var$typedArrayEncoder(68, 1),
    $83cca8f38d19f682$var$typedArrayEncoder(69, 2),
    $83cca8f38d19f682$var$typedArrayEncoder(70, 4),
    $83cca8f38d19f682$var$typedArrayEncoder(71, 8),
    $83cca8f38d19f682$var$typedArrayEncoder(72, 1),
    $83cca8f38d19f682$var$typedArrayEncoder(77, 2),
    $83cca8f38d19f682$var$typedArrayEncoder(78, 4),
    $83cca8f38d19f682$var$typedArrayEncoder(79, 8),
    $83cca8f38d19f682$var$typedArrayEncoder(85, 4),
    $83cca8f38d19f682$var$typedArrayEncoder(86, 8),
    {
        encode (sharedData, encode) {
            let packedValues = sharedData.packedValues || [];
            let sharedStructures = sharedData.structures || [];
            if (packedValues.values.length > 0) {
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0xd8 // one-byte tag
                ;
                $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 51 // tag 51 for packed shared structures https://www.potaroo.net/ietf/ids/draft-ietf-cbor-packed-03.txt
                ;
                $83cca8f38d19f682$var$writeArrayHeader(4);
                let valuesArray = packedValues.values;
                encode(valuesArray);
                $83cca8f38d19f682$var$writeArrayHeader(0) // prefixes
                ;
                $83cca8f38d19f682$var$writeArrayHeader(0) // suffixes
                ;
                packedObjectMap = Object.create(sharedPackedObjectMap || null);
                for(let i = 0, l = valuesArray.length; i < l; i++)packedObjectMap[valuesArray[i]] = i;
            }
            if (sharedStructures) {
                $83cca8f38d19f682$var$targetView.setUint32($83cca8f38d19f682$var$position, 0xd9dffe00);
                $83cca8f38d19f682$var$position += 3;
                let definitions = sharedStructures.slice(0);
                definitions.unshift(0xe000);
                definitions.push(new (0, $4c3270599345206f$export$3288d34c523a1192)(sharedData.version, 0x53687264));
                encode(definitions);
            } else encode(new (0, $4c3270599345206f$export$3288d34c523a1192)(sharedData.version, 0x53687264));
        }
    }
];
function $83cca8f38d19f682$var$typedArrayEncoder(tag, size) {
    if (!$83cca8f38d19f682$var$isLittleEndianMachine && size > 1) tag -= 4 // the big endian equivalents are 4 less
    ;
    return {
        tag: tag,
        encode: function writeExtBuffer(typedArray, encode) {
            let length = typedArray.byteLength;
            let offset = typedArray.byteOffset || 0;
            let buffer = typedArray.buffer || typedArray;
            encode($83cca8f38d19f682$var$hasNodeBuffer ? $83cca8f38d19f682$var$Buffer.from(buffer, offset, length) : new Uint8Array(buffer, offset, length));
        }
    };
}
function $83cca8f38d19f682$var$writeBuffer(buffer, makeRoom) {
    let length = buffer.byteLength;
    if (length < 0x18) $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x40 + length;
    else if (length < 0x100) {
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x58;
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length;
    } else if (length < 0x10000) {
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x59;
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length >> 8;
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = length & 0xff;
    } else {
        $83cca8f38d19f682$var$target[$83cca8f38d19f682$var$position++] = 0x5a;
        $83cca8f38d19f682$var$targetView.setUint32($83cca8f38d19f682$var$position, length);
        $83cca8f38d19f682$var$position += 4;
    }
    if ($83cca8f38d19f682$var$position + length >= $83cca8f38d19f682$var$target.length) makeRoom($83cca8f38d19f682$var$position + length);
    // if it is already a typed array (has an ArrayBuffer), use that, but if it is an ArrayBuffer itself,
    // must wrap it to set it.
    $83cca8f38d19f682$var$target.set(buffer.buffer ? buffer : new Uint8Array(buffer), $83cca8f38d19f682$var$position);
    $83cca8f38d19f682$var$position += length;
}
function $83cca8f38d19f682$var$insertIds(serialized, idsToInsert) {
    // insert the ids that need to be referenced for structured clones
    let nextId;
    let distanceToMove = idsToInsert.length * 2;
    let lastEnd = serialized.length - distanceToMove;
    idsToInsert.sort((a, b)=>a.offset > b.offset ? 1 : -1);
    for(let id = 0; id < idsToInsert.length; id++){
        let referee = idsToInsert[id];
        referee.id = id;
        for (let position of referee.references){
            serialized[position++] = id >> 8;
            serialized[position] = id & 0xff;
        }
    }
    while(nextId = idsToInsert.pop()){
        let offset = nextId.offset;
        serialized.copyWithin(offset + distanceToMove, offset, lastEnd);
        distanceToMove -= 2;
        let position = offset + distanceToMove;
        serialized[position++] = 0xd8;
        serialized[position++] = 28 // http://cbor.schmorp.de/value-sharing
        ;
        lastEnd = offset;
    }
    return serialized;
}
function $83cca8f38d19f682$var$writeBundles(start, encode) {
    $83cca8f38d19f682$var$targetView.setUint32($83cca8f38d19f682$var$bundledStrings.position + start, $83cca8f38d19f682$var$position - $83cca8f38d19f682$var$bundledStrings.position - start + 1) // the offset to bundle
    ;
    let writeStrings = $83cca8f38d19f682$var$bundledStrings;
    $83cca8f38d19f682$var$bundledStrings = null;
    encode(writeStrings[0]);
    encode(writeStrings[1]);
}
function $83cca8f38d19f682$export$4e11b2f4fcd6c82d(extension) {
    if (extension.Class) {
        if (!extension.encode) throw new Error("Extension has no encode function");
        $83cca8f38d19f682$var$extensionClasses.unshift(extension.Class);
        $83cca8f38d19f682$var$extensions.unshift(extension);
    }
    (0, $4c3270599345206f$export$4e11b2f4fcd6c82d)(extension);
}
let $83cca8f38d19f682$var$defaultEncoder = new $83cca8f38d19f682$export$a50aceb0e02a00aa({
    useRecords: false
});
const $83cca8f38d19f682$export$c564cdbbe6da493 = $83cca8f38d19f682$var$defaultEncoder.encode;
const $83cca8f38d19f682$export$62a5d0ccbd8ba53e = $83cca8f38d19f682$var$defaultEncoder.encodeAsIterable;
const $83cca8f38d19f682$export$ba03bcdfc44f370a = $83cca8f38d19f682$var$defaultEncoder.encodeAsAsyncIterable;
const { NEVER: $83cca8f38d19f682$export$96c94437c95d7862, ALWAYS: $83cca8f38d19f682$export$9252627518dcde93, DECIMAL_ROUND: $83cca8f38d19f682$export$50de32e2440ab0bf, DECIMAL_FIT: $83cca8f38d19f682$export$fa7c7714126eb380 } = (0, $4c3270599345206f$export$2239e49a3e351685);
const $83cca8f38d19f682$export$d41ac1453288b342 = 512;
const $83cca8f38d19f682$export$5687accb6effa257 = 1024;
const $83cca8f38d19f682$export$e724ae76933ea297 = 2048;






var $6924ffcd99a844a5$require$Buffer = $a2d2397a04cf9e13$exports.Buffer;
function $6924ffcd99a844a5$export$82db1b517a03d6f4(objectIterator, options = {}) {
    if (!objectIterator || typeof objectIterator !== "object") throw new Error("first argument must be an Iterable, Async Iterable, or a Promise for an Async Iterable");
    else if (typeof objectIterator[Symbol.iterator] === "function") return $6924ffcd99a844a5$var$encodeIterSync(objectIterator, options);
    else if (typeof objectIterator.then === "function" || typeof objectIterator[Symbol.asyncIterator] === "function") return $6924ffcd99a844a5$var$encodeIterAsync(objectIterator, options);
    else throw new Error("first argument must be an Iterable, Async Iterable, Iterator, Async Iterator, or a Promise");
}
function* $6924ffcd99a844a5$var$encodeIterSync(objectIterator, options) {
    const encoder = new (0, $83cca8f38d19f682$export$a50aceb0e02a00aa)(options);
    for (const value of objectIterator)yield encoder.encode(value);
}
async function* $6924ffcd99a844a5$var$encodeIterAsync(objectIterator, options) {
    const encoder = new (0, $83cca8f38d19f682$export$a50aceb0e02a00aa)(options);
    for await (const value of objectIterator)yield encoder.encode(value);
}
function $6924ffcd99a844a5$export$5201756020406471(bufferIterator, options = {}) {
    if (!bufferIterator || typeof bufferIterator !== "object") throw new Error("first argument must be an Iterable, Async Iterable, Iterator, Async Iterator, or a promise");
    const decoder = new (0, $4c3270599345206f$export$f9de6ca0bc043724)(options);
    let incomplete;
    const parser = (chunk)=>{
        let yields;
        // if there's incomplete data from previous chunk, concatinate and try again
        if (incomplete) {
            chunk = $6924ffcd99a844a5$require$Buffer.concat([
                incomplete,
                chunk
            ]);
            incomplete = undefined;
        }
        try {
            yields = decoder.decodeMultiple(chunk);
        } catch (err) {
            if (err.incomplete) {
                incomplete = chunk.slice(err.lastPosition);
                yields = err.values;
            } else throw err;
        }
        return yields;
    };
    if (typeof bufferIterator[Symbol.iterator] === "function") return function* iter() {
        for (const value of bufferIterator)yield* parser(value);
    }();
    else if (typeof bufferIterator[Symbol.asyncIterator] === "function") return async function* iter() {
        for await (const value of bufferIterator)yield* parser(value);
    }();
}




// Integer Utility
var $dfb87e1808fe2a9d$export$3314b2c271c86d70 = 4294967295;
function $dfb87e1808fe2a9d$export$20f71c4c8b0f96c3(view, offset, value) {
    var high = value / 4294967296;
    var low = value; // high bits are truncated by DataView
    view.setUint32(offset, high);
    view.setUint32(offset + 4, low);
}
function $dfb87e1808fe2a9d$export$8532a5209571c04a(view, offset, value) {
    var high = Math.floor(value / 4294967296);
    var low = value; // high bits are truncated by DataView
    view.setUint32(offset, high);
    view.setUint32(offset + 4, low);
}
function $dfb87e1808fe2a9d$export$69825c7adcc820c6(view, offset) {
    var high = view.getInt32(offset);
    var low = view.getUint32(offset + 4);
    return high * 4294967296 + low;
}
function $dfb87e1808fe2a9d$export$59a2dbf579ff9568(view, offset) {
    var high = view.getUint32(offset);
    var low = view.getUint32(offset + 4);
    return high * 4294967296 + low;
}


var $371a3837fd81d701$exports = {};
// shim for using process in browser
var $371a3837fd81d701$var$process = $371a3837fd81d701$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = "browser";
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ""; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$371a3837fd81d701$var$process.cwd = function() {
    return "/";
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};


var $b22d208b31a8382d$var$_a, $b22d208b31a8382d$var$_b, $b22d208b31a8382d$var$_c;
var $b22d208b31a8382d$var$TEXT_ENCODING_AVAILABLE = (typeof $371a3837fd81d701$exports === "undefined" || (($b22d208b31a8382d$var$_a = $371a3837fd81d701$exports === null || $371a3837fd81d701$exports === void 0 ? void 0 : $371a3837fd81d701$exports.env) === null || $b22d208b31a8382d$var$_a === void 0 ? void 0 : $b22d208b31a8382d$var$_a["TEXT_ENCODING"]) !== "never") && typeof TextEncoder !== "undefined" && typeof TextDecoder !== "undefined";
function $b22d208b31a8382d$export$b61de95301265227(str) {
    var strLength = str.length;
    var byteLength = 0;
    var pos = 0;
    while(pos < strLength){
        var value = str.charCodeAt(pos++);
        if ((value & 0xffffff80) === 0) {
            // 1-byte
            byteLength++;
            continue;
        } else if ((value & 0xfffff800) === 0) // 2-bytes
        byteLength += 2;
        else {
            // handle surrogate pair
            if (value >= 0xd800 && value <= 0xdbff) // high surrogate
            {
                if (pos < strLength) {
                    var extra = str.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
            }
            if ((value & 0xffff0000) === 0) // 3-byte
            byteLength += 3;
            else // 4-byte
            byteLength += 4;
        }
    }
    return byteLength;
}
function $b22d208b31a8382d$export$1042e4338f1ef853(str, output, outputOffset) {
    var strLength = str.length;
    var offset = outputOffset;
    var pos = 0;
    while(pos < strLength){
        var value = str.charCodeAt(pos++);
        if ((value & 0xffffff80) === 0) {
            // 1-byte
            output[offset++] = value;
            continue;
        } else if ((value & 0xfffff800) === 0) // 2-bytes
        output[offset++] = value >> 6 & 0x1f | 0xc0;
        else {
            // handle surrogate pair
            if (value >= 0xd800 && value <= 0xdbff) // high surrogate
            {
                if (pos < strLength) {
                    var extra = str.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
            }
            if ((value & 0xffff0000) === 0) {
                // 3-byte
                output[offset++] = value >> 12 & 0x0f | 0xe0;
                output[offset++] = value >> 6 & 0x3f | 0x80;
            } else {
                // 4-byte
                output[offset++] = value >> 18 & 0x07 | 0xf0;
                output[offset++] = value >> 12 & 0x3f | 0x80;
                output[offset++] = value >> 6 & 0x3f | 0x80;
            }
        }
        output[offset++] = value & 0x3f | 0x80;
    }
}
var $b22d208b31a8382d$var$sharedTextEncoder = $b22d208b31a8382d$var$TEXT_ENCODING_AVAILABLE ? new TextEncoder() : undefined;
var $b22d208b31a8382d$export$ed34c0622b397238 = !$b22d208b31a8382d$var$TEXT_ENCODING_AVAILABLE ? (0, $dfb87e1808fe2a9d$export$3314b2c271c86d70) : typeof $371a3837fd81d701$exports !== "undefined" && (($b22d208b31a8382d$var$_b = $371a3837fd81d701$exports === null || $371a3837fd81d701$exports === void 0 ? void 0 : $371a3837fd81d701$exports.env) === null || $b22d208b31a8382d$var$_b === void 0 ? void 0 : $b22d208b31a8382d$var$_b["TEXT_ENCODING"]) !== "force" ? 200 : 0;
function $b22d208b31a8382d$var$utf8EncodeTEencode(str, output, outputOffset) {
    output.set($b22d208b31a8382d$var$sharedTextEncoder.encode(str), outputOffset);
}
function $b22d208b31a8382d$var$utf8EncodeTEencodeInto(str, output, outputOffset) {
    $b22d208b31a8382d$var$sharedTextEncoder.encodeInto(str, output.subarray(outputOffset));
}
var $b22d208b31a8382d$export$34cfdc82d430524 = ($b22d208b31a8382d$var$sharedTextEncoder === null || $b22d208b31a8382d$var$sharedTextEncoder === void 0 ? void 0 : $b22d208b31a8382d$var$sharedTextEncoder.encodeInto) ? $b22d208b31a8382d$var$utf8EncodeTEencodeInto : $b22d208b31a8382d$var$utf8EncodeTEencode;
var $b22d208b31a8382d$var$CHUNK_SIZE = 4096;
function $b22d208b31a8382d$export$551117984c2adf4f(bytes, inputOffset, byteLength) {
    var offset = inputOffset;
    var end = offset + byteLength;
    var units = [];
    var result = "";
    while(offset < end){
        var byte1 = bytes[offset++];
        if ((byte1 & 0x80) === 0) // 1 byte
        units.push(byte1);
        else if ((byte1 & 0xe0) === 0xc0) {
            // 2 bytes
            var byte2 = bytes[offset++] & 0x3f;
            units.push((byte1 & 0x1f) << 6 | byte2);
        } else if ((byte1 & 0xf0) === 0xe0) {
            // 3 bytes
            var byte2 = bytes[offset++] & 0x3f;
            var byte3 = bytes[offset++] & 0x3f;
            units.push((byte1 & 0x1f) << 12 | byte2 << 6 | byte3);
        } else if ((byte1 & 0xf8) === 0xf0) {
            // 4 bytes
            var byte2 = bytes[offset++] & 0x3f;
            var byte3 = bytes[offset++] & 0x3f;
            var byte4 = bytes[offset++] & 0x3f;
            var unit = (byte1 & 0x07) << 0x12 | byte2 << 0x0c | byte3 << 0x06 | byte4;
            if (unit > 0xffff) {
                unit -= 0x10000;
                units.push(unit >>> 10 & 0x3ff | 0xd800);
                unit = 0xdc00 | unit & 0x3ff;
            }
            units.push(unit);
        } else units.push(byte1);
        if (units.length >= $b22d208b31a8382d$var$CHUNK_SIZE) {
            result += String.fromCharCode.apply(String, units);
            units.length = 0;
        }
    }
    if (units.length > 0) result += String.fromCharCode.apply(String, units);
    return result;
}
var $b22d208b31a8382d$var$sharedTextDecoder = $b22d208b31a8382d$var$TEXT_ENCODING_AVAILABLE ? new TextDecoder() : null;
var $b22d208b31a8382d$export$d866281c5a66d1ef = !$b22d208b31a8382d$var$TEXT_ENCODING_AVAILABLE ? (0, $dfb87e1808fe2a9d$export$3314b2c271c86d70) : typeof $371a3837fd81d701$exports !== "undefined" && (($b22d208b31a8382d$var$_c = $371a3837fd81d701$exports === null || $371a3837fd81d701$exports === void 0 ? void 0 : $371a3837fd81d701$exports.env) === null || $b22d208b31a8382d$var$_c === void 0 ? void 0 : $b22d208b31a8382d$var$_c["TEXT_DECODER"]) !== "force" ? 200 : 0;
function $b22d208b31a8382d$export$6ed79e41309992dc(bytes, inputOffset, byteLength) {
    var stringBytes = bytes.subarray(inputOffset, inputOffset + byteLength);
    return $b22d208b31a8382d$var$sharedTextDecoder.decode(stringBytes);
}


// ExtensionCodec to handle MessagePack extensions
/**
 * ExtData is used to handle Extension Types that are not registered to ExtensionCodec.
 */ var $fb2ad73dd45eaa99$export$bcbeb236456bc779 = /** @class */ function() {
    function ExtData(type, data) {
        this.type = type;
        this.data = data;
    }
    return ExtData;
}();


// https://github.com/msgpack/msgpack/blob/master/spec.md#timestamp-extension-type
var $1c14d367b301d5e6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1c14d367b301d5e6$export$ef3eed12d06c0285 = /** @class */ function(_super) {
    $1c14d367b301d5e6$var$__extends(DecodeError, _super);
    function DecodeError(message) {
        var _this = _super.call(this, message) || this;
        // fix the prototype chain in a cross-platform way
        var proto = Object.create(DecodeError.prototype);
        Object.setPrototypeOf(_this, proto);
        Object.defineProperty(_this, "name", {
            configurable: true,
            enumerable: false,
            value: DecodeError.name
        });
        return _this;
    }
    return DecodeError;
}(Error);



var $86bdf3d407a5cfae$export$f18369fc203f4e13 = -1;
var $86bdf3d407a5cfae$var$TIMESTAMP32_MAX_SEC = 4294967295; // 32-bit unsigned int
var $86bdf3d407a5cfae$var$TIMESTAMP64_MAX_SEC = 17179869183; // 34-bit unsigned int
function $86bdf3d407a5cfae$export$2fd05b828dd81159(_a) {
    var sec = _a.sec, nsec = _a.nsec;
    if (sec >= 0 && nsec >= 0 && sec <= $86bdf3d407a5cfae$var$TIMESTAMP64_MAX_SEC) {
        // Here sec >= 0 && nsec >= 0
        if (nsec === 0 && sec <= $86bdf3d407a5cfae$var$TIMESTAMP32_MAX_SEC) {
            // timestamp 32 = { sec32 (unsigned) }
            var rv = new Uint8Array(4);
            var view = new DataView(rv.buffer);
            view.setUint32(0, sec);
            return rv;
        } else {
            // timestamp 64 = { nsec30 (unsigned), sec34 (unsigned) }
            var secHigh = sec / 0x100000000;
            var secLow = sec & 0xffffffff;
            var rv = new Uint8Array(8);
            var view = new DataView(rv.buffer);
            // nsec30 | secHigh2
            view.setUint32(0, nsec << 2 | secHigh & 0x3);
            // secLow32
            view.setUint32(4, secLow);
            return rv;
        }
    } else {
        // timestamp 96 = { nsec32 (unsigned), sec64 (signed) }
        var rv = new Uint8Array(12);
        var view = new DataView(rv.buffer);
        view.setUint32(0, nsec);
        (0, $dfb87e1808fe2a9d$export$8532a5209571c04a)(view, 4, sec);
        return rv;
    }
}
function $86bdf3d407a5cfae$export$221d97b3b00b03c2(date) {
    var msec = date.getTime();
    var sec = Math.floor(msec / 1e3);
    var nsec = (msec - sec * 1e3) * 1e6;
    // Normalizes { sec, nsec } to ensure nsec is unsigned.
    var nsecInSec = Math.floor(nsec / 1e9);
    return {
        sec: sec + nsecInSec,
        nsec: nsec - nsecInSec * 1e9
    };
}
function $86bdf3d407a5cfae$export$32420f352fe0fc83(object) {
    if (object instanceof Date) {
        var timeSpec = $86bdf3d407a5cfae$export$221d97b3b00b03c2(object);
        return $86bdf3d407a5cfae$export$2fd05b828dd81159(timeSpec);
    } else return null;
}
function $86bdf3d407a5cfae$export$abfc8800a5159711(data) {
    var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
    // data may be 32, 64, or 96 bits
    switch(data.byteLength){
        case 4:
            // timestamp 32 = { sec32 }
            var sec = view.getUint32(0);
            var nsec = 0;
            return {
                sec: sec,
                nsec: nsec
            };
        case 8:
            // timestamp 64 = { nsec30, sec34 }
            var nsec30AndSecHigh2 = view.getUint32(0);
            var secLow32 = view.getUint32(4);
            var sec = (nsec30AndSecHigh2 & 0x3) * 0x100000000 + secLow32;
            var nsec = nsec30AndSecHigh2 >>> 2;
            return {
                sec: sec,
                nsec: nsec
            };
        case 12:
            // timestamp 96 = { nsec32 (unsigned), sec64 (signed) }
            var sec = (0, $dfb87e1808fe2a9d$export$69825c7adcc820c6)(view, 4);
            var nsec = view.getUint32(0);
            return {
                sec: sec,
                nsec: nsec
            };
        default:
            throw new (0, $1c14d367b301d5e6$export$ef3eed12d06c0285)("Unrecognized data size for timestamp (expected 4, 8, or 12): ".concat(data.length));
    }
}
function $86bdf3d407a5cfae$export$80b8ff9315e4298f(data) {
    var timeSpec = $86bdf3d407a5cfae$export$abfc8800a5159711(data);
    return new Date(timeSpec.sec * 1e3 + timeSpec.nsec / 1e6);
}
var $86bdf3d407a5cfae$export$8654479533463da1 = {
    type: $86bdf3d407a5cfae$export$f18369fc203f4e13,
    encode: $86bdf3d407a5cfae$export$32420f352fe0fc83,
    decode: $86bdf3d407a5cfae$export$80b8ff9315e4298f
};


var $a351f48fb4e8cf30$export$12677a794dbd89d7 = /** @class */ function() {
    function ExtensionCodec() {
        // built-in extensions
        this.builtInEncoders = [];
        this.builtInDecoders = [];
        // custom extensions
        this.encoders = [];
        this.decoders = [];
        this.register((0, $86bdf3d407a5cfae$export$8654479533463da1));
    }
    ExtensionCodec.prototype.register = function(_a) {
        var type = _a.type, encode = _a.encode, decode = _a.decode;
        if (type >= 0) {
            // custom extensions
            this.encoders[type] = encode;
            this.decoders[type] = decode;
        } else {
            // built-in extensions
            var index = 1 + type;
            this.builtInEncoders[index] = encode;
            this.builtInDecoders[index] = decode;
        }
    };
    ExtensionCodec.prototype.tryToEncode = function(object, context) {
        // built-in extensions
        for(var i = 0; i < this.builtInEncoders.length; i++){
            var encodeExt = this.builtInEncoders[i];
            if (encodeExt != null) {
                var data = encodeExt(object, context);
                if (data != null) {
                    var type = -1 - i;
                    return new (0, $fb2ad73dd45eaa99$export$bcbeb236456bc779)(type, data);
                }
            }
        }
        // custom extensions
        for(var i = 0; i < this.encoders.length; i++){
            var encodeExt = this.encoders[i];
            if (encodeExt != null) {
                var data = encodeExt(object, context);
                if (data != null) {
                    var type = i;
                    return new (0, $fb2ad73dd45eaa99$export$bcbeb236456bc779)(type, data);
                }
            }
        }
        if (object instanceof (0, $fb2ad73dd45eaa99$export$bcbeb236456bc779)) // to keep ExtData as is
        return object;
        return null;
    };
    ExtensionCodec.prototype.decode = function(data, type, context) {
        var decodeExt = type < 0 ? this.builtInDecoders[-1 - type] : this.decoders[type];
        if (decodeExt) return decodeExt(data, type, context);
        else // decode() does not fail, returns ExtData instead.
        return new (0, $fb2ad73dd45eaa99$export$bcbeb236456bc779)(type, data);
    };
    ExtensionCodec.defaultCodec = new ExtensionCodec();
    return ExtensionCodec;
}();



function $d3f66129ab233ea6$export$f8d669c2a17882f2(buffer) {
    if (buffer instanceof Uint8Array) return buffer;
    else if (ArrayBuffer.isView(buffer)) return new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    else if (buffer instanceof ArrayBuffer) return new Uint8Array(buffer);
    else // ArrayLike<number>
    return Uint8Array.from(buffer);
}
function $d3f66129ab233ea6$export$7277868462c1ba02(buffer) {
    if (buffer instanceof ArrayBuffer) return new DataView(buffer);
    var bufferView = $d3f66129ab233ea6$export$f8d669c2a17882f2(buffer);
    return new DataView(bufferView.buffer, bufferView.byteOffset, bufferView.byteLength);
}


var $fbca2e5b74897fc2$export$2c6de1218fe0e46d = 100;
var $fbca2e5b74897fc2$export$29659805a45f979c = 2048;
var $fbca2e5b74897fc2$export$a50aceb0e02a00aa = /** @class */ function() {
    function Encoder(extensionCodec, context, maxDepth, initialBufferSize, sortKeys, forceFloat32, ignoreUndefined, forceIntegerToFloat) {
        if (extensionCodec === void 0) extensionCodec = (0, $a351f48fb4e8cf30$export$12677a794dbd89d7).defaultCodec;
        if (context === void 0) context = undefined;
        if (maxDepth === void 0) maxDepth = $fbca2e5b74897fc2$export$2c6de1218fe0e46d;
        if (initialBufferSize === void 0) initialBufferSize = $fbca2e5b74897fc2$export$29659805a45f979c;
        if (sortKeys === void 0) sortKeys = false;
        if (forceFloat32 === void 0) forceFloat32 = false;
        if (ignoreUndefined === void 0) ignoreUndefined = false;
        if (forceIntegerToFloat === void 0) forceIntegerToFloat = false;
        this.extensionCodec = extensionCodec;
        this.context = context;
        this.maxDepth = maxDepth;
        this.initialBufferSize = initialBufferSize;
        this.sortKeys = sortKeys;
        this.forceFloat32 = forceFloat32;
        this.ignoreUndefined = ignoreUndefined;
        this.forceIntegerToFloat = forceIntegerToFloat;
        this.pos = 0;
        this.view = new DataView(new ArrayBuffer(this.initialBufferSize));
        this.bytes = new Uint8Array(this.view.buffer);
    }
    Encoder.prototype.reinitializeState = function() {
        this.pos = 0;
    };
    /**
     * This is almost equivalent to {@link Encoder#encode}, but it returns an reference of the encoder's internal buffer and thus much faster than {@link Encoder#encode}.
     *
     * @returns Encodes the object and returns a shared reference the encoder's internal buffer.
     */ Encoder.prototype.encodeSharedRef = function(object) {
        this.reinitializeState();
        this.doEncode(object, 1);
        return this.bytes.subarray(0, this.pos);
    };
    /**
     * @returns Encodes the object and returns a copy of the encoder's internal buffer.
     */ Encoder.prototype.encode = function(object) {
        this.reinitializeState();
        this.doEncode(object, 1);
        return this.bytes.slice(0, this.pos);
    };
    Encoder.prototype.doEncode = function(object, depth) {
        if (depth > this.maxDepth) throw new Error("Too deep objects in depth ".concat(depth));
        if (object == null) this.encodeNil();
        else if (typeof object === "boolean") this.encodeBoolean(object);
        else if (typeof object === "number") this.encodeNumber(object);
        else if (typeof object === "string") this.encodeString(object);
        else this.encodeObject(object, depth);
    };
    Encoder.prototype.ensureBufferSizeToWrite = function(sizeToWrite) {
        var requiredSize = this.pos + sizeToWrite;
        if (this.view.byteLength < requiredSize) this.resizeBuffer(requiredSize * 2);
    };
    Encoder.prototype.resizeBuffer = function(newSize) {
        var newBuffer = new ArrayBuffer(newSize);
        var newBytes = new Uint8Array(newBuffer);
        var newView = new DataView(newBuffer);
        newBytes.set(this.bytes);
        this.view = newView;
        this.bytes = newBytes;
    };
    Encoder.prototype.encodeNil = function() {
        this.writeU8(0xc0);
    };
    Encoder.prototype.encodeBoolean = function(object) {
        if (object === false) this.writeU8(0xc2);
        else this.writeU8(0xc3);
    };
    Encoder.prototype.encodeNumber = function(object) {
        if (Number.isSafeInteger(object) && !this.forceIntegerToFloat) {
            if (object >= 0) {
                if (object < 0x80) // positive fixint
                this.writeU8(object);
                else if (object < 0x100) {
                    // uint 8
                    this.writeU8(0xcc);
                    this.writeU8(object);
                } else if (object < 0x10000) {
                    // uint 16
                    this.writeU8(0xcd);
                    this.writeU16(object);
                } else if (object < 0x100000000) {
                    // uint 32
                    this.writeU8(0xce);
                    this.writeU32(object);
                } else {
                    // uint 64
                    this.writeU8(0xcf);
                    this.writeU64(object);
                }
            } else {
                if (object >= -32) // negative fixint
                this.writeU8(0xe0 | object + 0x20);
                else if (object >= -128) {
                    // int 8
                    this.writeU8(0xd0);
                    this.writeI8(object);
                } else if (object >= -32768) {
                    // int 16
                    this.writeU8(0xd1);
                    this.writeI16(object);
                } else if (object >= -2147483648) {
                    // int 32
                    this.writeU8(0xd2);
                    this.writeI32(object);
                } else {
                    // int 64
                    this.writeU8(0xd3);
                    this.writeI64(object);
                }
            }
        } else // non-integer numbers
        if (this.forceFloat32) {
            // float 32
            this.writeU8(0xca);
            this.writeF32(object);
        } else {
            // float 64
            this.writeU8(0xcb);
            this.writeF64(object);
        }
    };
    Encoder.prototype.writeStringHeader = function(byteLength) {
        if (byteLength < 32) // fixstr
        this.writeU8(0xa0 + byteLength);
        else if (byteLength < 0x100) {
            // str 8
            this.writeU8(0xd9);
            this.writeU8(byteLength);
        } else if (byteLength < 0x10000) {
            // str 16
            this.writeU8(0xda);
            this.writeU16(byteLength);
        } else if (byteLength < 0x100000000) {
            // str 32
            this.writeU8(0xdb);
            this.writeU32(byteLength);
        } else throw new Error("Too long string: ".concat(byteLength, " bytes in UTF-8"));
    };
    Encoder.prototype.encodeString = function(object) {
        var maxHeaderSize = 5;
        var strLength = object.length;
        if (strLength > (0, $b22d208b31a8382d$export$ed34c0622b397238)) {
            var byteLength = (0, $b22d208b31a8382d$export$b61de95301265227)(object);
            this.ensureBufferSizeToWrite(maxHeaderSize + byteLength);
            this.writeStringHeader(byteLength);
            (0, $b22d208b31a8382d$export$34cfdc82d430524)(object, this.bytes, this.pos);
            this.pos += byteLength;
        } else {
            var byteLength = (0, $b22d208b31a8382d$export$b61de95301265227)(object);
            this.ensureBufferSizeToWrite(maxHeaderSize + byteLength);
            this.writeStringHeader(byteLength);
            (0, $b22d208b31a8382d$export$1042e4338f1ef853)(object, this.bytes, this.pos);
            this.pos += byteLength;
        }
    };
    Encoder.prototype.encodeObject = function(object, depth) {
        // try to encode objects with custom codec first of non-primitives
        var ext = this.extensionCodec.tryToEncode(object, this.context);
        if (ext != null) this.encodeExtension(ext);
        else if (Array.isArray(object)) this.encodeArray(object, depth);
        else if (ArrayBuffer.isView(object)) this.encodeBinary(object);
        else if (typeof object === "object") this.encodeMap(object, depth);
        else // symbol, function and other special object come here unless extensionCodec handles them.
        throw new Error("Unrecognized object: ".concat(Object.prototype.toString.apply(object)));
    };
    Encoder.prototype.encodeBinary = function(object) {
        var size = object.byteLength;
        if (size < 0x100) {
            // bin 8
            this.writeU8(0xc4);
            this.writeU8(size);
        } else if (size < 0x10000) {
            // bin 16
            this.writeU8(0xc5);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // bin 32
            this.writeU8(0xc6);
            this.writeU32(size);
        } else throw new Error("Too large binary: ".concat(size));
        var bytes = (0, $d3f66129ab233ea6$export$f8d669c2a17882f2)(object);
        this.writeU8a(bytes);
    };
    Encoder.prototype.encodeArray = function(object, depth) {
        var size = object.length;
        if (size < 16) // fixarray
        this.writeU8(0x90 + size);
        else if (size < 0x10000) {
            // array 16
            this.writeU8(0xdc);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // array 32
            this.writeU8(0xdd);
            this.writeU32(size);
        } else throw new Error("Too large array: ".concat(size));
        for(var _i = 0, object_1 = object; _i < object_1.length; _i++){
            var item = object_1[_i];
            this.doEncode(item, depth + 1);
        }
    };
    Encoder.prototype.countWithoutUndefined = function(object, keys) {
        var count = 0;
        for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
            var key = keys_1[_i];
            if (object[key] !== undefined) count++;
        }
        return count;
    };
    Encoder.prototype.encodeMap = function(object, depth) {
        var keys = Object.keys(object);
        if (this.sortKeys) keys.sort();
        var size = this.ignoreUndefined ? this.countWithoutUndefined(object, keys) : keys.length;
        if (size < 16) // fixmap
        this.writeU8(0x80 + size);
        else if (size < 0x10000) {
            // map 16
            this.writeU8(0xde);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // map 32
            this.writeU8(0xdf);
            this.writeU32(size);
        } else throw new Error("Too large map object: ".concat(size));
        for(var _i = 0, keys_2 = keys; _i < keys_2.length; _i++){
            var key = keys_2[_i];
            var value = object[key];
            if (!(this.ignoreUndefined && value === undefined)) {
                this.encodeString(key);
                this.doEncode(value, depth + 1);
            }
        }
    };
    Encoder.prototype.encodeExtension = function(ext) {
        var size = ext.data.length;
        if (size === 1) // fixext 1
        this.writeU8(0xd4);
        else if (size === 2) // fixext 2
        this.writeU8(0xd5);
        else if (size === 4) // fixext 4
        this.writeU8(0xd6);
        else if (size === 8) // fixext 8
        this.writeU8(0xd7);
        else if (size === 16) // fixext 16
        this.writeU8(0xd8);
        else if (size < 0x100) {
            // ext 8
            this.writeU8(0xc7);
            this.writeU8(size);
        } else if (size < 0x10000) {
            // ext 16
            this.writeU8(0xc8);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // ext 32
            this.writeU8(0xc9);
            this.writeU32(size);
        } else throw new Error("Too large extension object: ".concat(size));
        this.writeI8(ext.type);
        this.writeU8a(ext.data);
    };
    Encoder.prototype.writeU8 = function(value) {
        this.ensureBufferSizeToWrite(1);
        this.view.setUint8(this.pos, value);
        this.pos++;
    };
    Encoder.prototype.writeU8a = function(values) {
        var size = values.length;
        this.ensureBufferSizeToWrite(size);
        this.bytes.set(values, this.pos);
        this.pos += size;
    };
    Encoder.prototype.writeI8 = function(value) {
        this.ensureBufferSizeToWrite(1);
        this.view.setInt8(this.pos, value);
        this.pos++;
    };
    Encoder.prototype.writeU16 = function(value) {
        this.ensureBufferSizeToWrite(2);
        this.view.setUint16(this.pos, value);
        this.pos += 2;
    };
    Encoder.prototype.writeI16 = function(value) {
        this.ensureBufferSizeToWrite(2);
        this.view.setInt16(this.pos, value);
        this.pos += 2;
    };
    Encoder.prototype.writeU32 = function(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setUint32(this.pos, value);
        this.pos += 4;
    };
    Encoder.prototype.writeI32 = function(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setInt32(this.pos, value);
        this.pos += 4;
    };
    Encoder.prototype.writeF32 = function(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setFloat32(this.pos, value);
        this.pos += 4;
    };
    Encoder.prototype.writeF64 = function(value) {
        this.ensureBufferSizeToWrite(8);
        this.view.setFloat64(this.pos, value);
        this.pos += 8;
    };
    Encoder.prototype.writeU64 = function(value) {
        this.ensureBufferSizeToWrite(8);
        (0, $dfb87e1808fe2a9d$export$20f71c4c8b0f96c3)(this.view, this.pos, value);
        this.pos += 8;
    };
    Encoder.prototype.writeI64 = function(value) {
        this.ensureBufferSizeToWrite(8);
        (0, $dfb87e1808fe2a9d$export$8532a5209571c04a)(this.view, this.pos, value);
        this.pos += 8;
    };
    return Encoder;
}();

function $23a418a154e33a3f$export$78406e843f5312da(byte) {
    return "".concat(byte < 0 ? "-" : "", "0x").concat(Math.abs(byte).toString(16).padStart(2, "0"));
}







var $299a6cb5f2b5256a$var$DEFAULT_MAX_KEY_LENGTH = 16;
var $299a6cb5f2b5256a$var$DEFAULT_MAX_LENGTH_PER_KEY = 16;
var $299a6cb5f2b5256a$export$529b830450faf29c = /** @class */ function() {
    function CachedKeyDecoder(maxKeyLength, maxLengthPerKey) {
        if (maxKeyLength === void 0) maxKeyLength = $299a6cb5f2b5256a$var$DEFAULT_MAX_KEY_LENGTH;
        if (maxLengthPerKey === void 0) maxLengthPerKey = $299a6cb5f2b5256a$var$DEFAULT_MAX_LENGTH_PER_KEY;
        this.maxKeyLength = maxKeyLength;
        this.maxLengthPerKey = maxLengthPerKey;
        this.hit = 0;
        this.miss = 0;
        // avoid `new Array(N)`, which makes a sparse array,
        // because a sparse array is typically slower than a non-sparse array.
        this.caches = [];
        for(var i = 0; i < this.maxKeyLength; i++)this.caches.push([]);
    }
    CachedKeyDecoder.prototype.canBeCached = function(byteLength) {
        return byteLength > 0 && byteLength <= this.maxKeyLength;
    };
    CachedKeyDecoder.prototype.find = function(bytes, inputOffset, byteLength) {
        var records = this.caches[byteLength - 1];
        FIND_CHUNK: for(var _i = 0, records_1 = records; _i < records_1.length; _i++){
            var record = records_1[_i];
            var recordBytes = record.bytes;
            for(var j = 0; j < byteLength; j++){
                if (recordBytes[j] !== bytes[inputOffset + j]) continue FIND_CHUNK;
            }
            return record.str;
        }
        return null;
    };
    CachedKeyDecoder.prototype.store = function(bytes, value) {
        var records = this.caches[bytes.length - 1];
        var record = {
            bytes: bytes,
            str: value
        };
        if (records.length >= this.maxLengthPerKey) // `records` are full!
        // Set `record` to an arbitrary position.
        records[Math.random() * records.length | 0] = record;
        else records.push(record);
    };
    CachedKeyDecoder.prototype.decode = function(bytes, inputOffset, byteLength) {
        var cachedValue = this.find(bytes, inputOffset, byteLength);
        if (cachedValue != null) {
            this.hit++;
            return cachedValue;
        }
        this.miss++;
        var str = (0, $b22d208b31a8382d$export$551117984c2adf4f)(bytes, inputOffset, byteLength);
        // Ensure to copy a slice of bytes because the byte may be NodeJS Buffer and Buffer#slice() returns a reference to its internal ArrayBuffer.
        var slicedCopyOfBytes = Uint8Array.prototype.slice.call(bytes, inputOffset, inputOffset + byteLength);
        this.store(slicedCopyOfBytes, str);
        return str;
    };
    return CachedKeyDecoder;
}();



var $3ed27e40785d3726$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3ed27e40785d3726$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $3ed27e40785d3726$var$__asyncValues = undefined && undefined.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $3ed27e40785d3726$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $3ed27e40785d3726$var$__await ? (this.v = v, this) : new $3ed27e40785d3726$var$__await(v);
};
var $3ed27e40785d3726$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3ed27e40785d3726$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $3ed27e40785d3726$var$isValidMapKeyType = function(key) {
    var keyType = typeof key;
    return keyType === "string" || keyType === "number";
};
var $3ed27e40785d3726$var$HEAD_BYTE_REQUIRED = -1;
var $3ed27e40785d3726$var$EMPTY_VIEW = new DataView(new ArrayBuffer(0));
var $3ed27e40785d3726$var$EMPTY_BYTES = new Uint8Array($3ed27e40785d3726$var$EMPTY_VIEW.buffer);
var $3ed27e40785d3726$export$449c37eaf7093493 = function() {
    try {
        // IE11: The spec says it should throw RangeError,
        // IE11: but in IE11 it throws TypeError.
        $3ed27e40785d3726$var$EMPTY_VIEW.getInt8(0);
    } catch (e) {
        return e.constructor;
    }
    throw new Error("never reached");
}();
var $3ed27e40785d3726$var$MORE_DATA = new $3ed27e40785d3726$export$449c37eaf7093493("Insufficient data");
var $3ed27e40785d3726$var$sharedCachedKeyDecoder = new (0, $299a6cb5f2b5256a$export$529b830450faf29c)();
var $3ed27e40785d3726$export$f9de6ca0bc043724 = /** @class */ function() {
    function Decoder(extensionCodec, context, maxStrLength, maxBinLength, maxArrayLength, maxMapLength, maxExtLength, keyDecoder) {
        if (extensionCodec === void 0) extensionCodec = (0, $a351f48fb4e8cf30$export$12677a794dbd89d7).defaultCodec;
        if (context === void 0) context = undefined;
        if (maxStrLength === void 0) maxStrLength = (0, $dfb87e1808fe2a9d$export$3314b2c271c86d70);
        if (maxBinLength === void 0) maxBinLength = (0, $dfb87e1808fe2a9d$export$3314b2c271c86d70);
        if (maxArrayLength === void 0) maxArrayLength = (0, $dfb87e1808fe2a9d$export$3314b2c271c86d70);
        if (maxMapLength === void 0) maxMapLength = (0, $dfb87e1808fe2a9d$export$3314b2c271c86d70);
        if (maxExtLength === void 0) maxExtLength = (0, $dfb87e1808fe2a9d$export$3314b2c271c86d70);
        if (keyDecoder === void 0) keyDecoder = $3ed27e40785d3726$var$sharedCachedKeyDecoder;
        this.extensionCodec = extensionCodec;
        this.context = context;
        this.maxStrLength = maxStrLength;
        this.maxBinLength = maxBinLength;
        this.maxArrayLength = maxArrayLength;
        this.maxMapLength = maxMapLength;
        this.maxExtLength = maxExtLength;
        this.keyDecoder = keyDecoder;
        this.totalPos = 0;
        this.pos = 0;
        this.view = $3ed27e40785d3726$var$EMPTY_VIEW;
        this.bytes = $3ed27e40785d3726$var$EMPTY_BYTES;
        this.headByte = $3ed27e40785d3726$var$HEAD_BYTE_REQUIRED;
        this.stack = [];
    }
    Decoder.prototype.reinitializeState = function() {
        this.totalPos = 0;
        this.headByte = $3ed27e40785d3726$var$HEAD_BYTE_REQUIRED;
        this.stack.length = 0;
    // view, bytes, and pos will be re-initialized in setBuffer()
    };
    Decoder.prototype.setBuffer = function(buffer) {
        this.bytes = (0, $d3f66129ab233ea6$export$f8d669c2a17882f2)(buffer);
        this.view = (0, $d3f66129ab233ea6$export$7277868462c1ba02)(this.bytes);
        this.pos = 0;
    };
    Decoder.prototype.appendBuffer = function(buffer) {
        if (this.headByte === $3ed27e40785d3726$var$HEAD_BYTE_REQUIRED && !this.hasRemaining(1)) this.setBuffer(buffer);
        else {
            var remainingData = this.bytes.subarray(this.pos);
            var newData = (0, $d3f66129ab233ea6$export$f8d669c2a17882f2)(buffer);
            // concat remainingData + newData
            var newBuffer = new Uint8Array(remainingData.length + newData.length);
            newBuffer.set(remainingData);
            newBuffer.set(newData, remainingData.length);
            this.setBuffer(newBuffer);
        }
    };
    Decoder.prototype.hasRemaining = function(size) {
        return this.view.byteLength - this.pos >= size;
    };
    Decoder.prototype.createExtraByteError = function(posToShow) {
        var _a = this, view = _a.view, pos = _a.pos;
        return new RangeError("Extra ".concat(view.byteLength - pos, " of ").concat(view.byteLength, " byte(s) found at buffer[").concat(posToShow, "]"));
    };
    /**
     * @throws {@link DecodeError}
     * @throws {@link RangeError}
     */ Decoder.prototype.decode = function(buffer) {
        this.reinitializeState();
        this.setBuffer(buffer);
        var object = this.doDecodeSync();
        if (this.hasRemaining(1)) throw this.createExtraByteError(this.pos);
        return object;
    };
    Decoder.prototype.decodeMulti = function(buffer) {
        return $3ed27e40785d3726$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    this.reinitializeState();
                    this.setBuffer(buffer);
                    _a.label = 1;
                case 1:
                    if (!this.hasRemaining(1)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        this.doDecodeSync()
                    ];
                case 2:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    Decoder.prototype.decodeAsync = function(stream) {
        var stream_1, stream_1_1;
        var e_1, _a;
        return $3ed27e40785d3726$var$__awaiter(this, void 0, void 0, function() {
            var decoded, object, buffer, e_1_1, _b, headByte, pos, totalPos;
            return $3ed27e40785d3726$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        decoded = false;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            6,
                            7,
                            12
                        ]);
                        stream_1 = $3ed27e40785d3726$var$__asyncValues(stream);
                        _c.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            stream_1.next()
                        ];
                    case 3:
                        if (!(stream_1_1 = _c.sent(), !stream_1_1.done)) return [
                            3 /*break*/ ,
                            5
                        ];
                        buffer = stream_1_1.value;
                        if (decoded) throw this.createExtraByteError(this.totalPos);
                        this.appendBuffer(buffer);
                        try {
                            object = this.doDecodeSync();
                            decoded = true;
                        } catch (e) {
                            if (!(e instanceof $3ed27e40785d3726$export$449c37eaf7093493)) throw e; // rethrow
                        // fallthrough
                        }
                        this.totalPos += this.pos;
                        _c.label = 4;
                    case 4:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 6:
                        e_1_1 = _c.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 7:
                        _c.trys.push([
                            7,
                            ,
                            10,
                            11
                        ]);
                        if (!(stream_1_1 && !stream_1_1.done && (_a = stream_1.return))) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(stream_1)
                        ];
                    case 8:
                        _c.sent();
                        _c.label = 9;
                    case 9:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        if (e_1) throw e_1.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 11:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 12:
                        if (decoded) {
                            if (this.hasRemaining(1)) throw this.createExtraByteError(this.totalPos);
                            return [
                                2 /*return*/ ,
                                object
                            ];
                        }
                        _b = this, headByte = _b.headByte, pos = _b.pos, totalPos = _b.totalPos;
                        throw new RangeError("Insufficient data in parsing ".concat((0, $23a418a154e33a3f$export$78406e843f5312da)(headByte), " at ").concat(totalPos, " (").concat(pos, " in the current buffer)"));
                }
            });
        });
    };
    Decoder.prototype.decodeArrayStream = function(stream) {
        return this.decodeMultiAsync(stream, true);
    };
    Decoder.prototype.decodeStream = function(stream) {
        return this.decodeMultiAsync(stream, false);
    };
    Decoder.prototype.decodeMultiAsync = function(stream, isArray) {
        return $3ed27e40785d3726$var$__asyncGenerator(this, arguments, function decodeMultiAsync_1() {
            var isArrayHeaderRequired, arrayItemsLeft, stream_2, stream_2_1, buffer, e_2, e_3_1;
            var e_3, _a;
            return $3ed27e40785d3726$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        isArrayHeaderRequired = isArray;
                        arrayItemsLeft = -1;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            13,
                            14,
                            19
                        ]);
                        stream_2 = $3ed27e40785d3726$var$__asyncValues(stream);
                        _b.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            $3ed27e40785d3726$var$__await(stream_2.next())
                        ];
                    case 3:
                        if (!(stream_2_1 = _b.sent(), !stream_2_1.done)) return [
                            3 /*break*/ ,
                            12
                        ];
                        buffer = stream_2_1.value;
                        if (isArray && arrayItemsLeft === 0) throw this.createExtraByteError(this.totalPos);
                        this.appendBuffer(buffer);
                        if (isArrayHeaderRequired) {
                            arrayItemsLeft = this.readArraySize();
                            isArrayHeaderRequired = false;
                            this.complete();
                        }
                        _b.label = 4;
                    case 4:
                        _b.trys.push([
                            4,
                            9,
                            ,
                            10
                        ]);
                        _b.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            $3ed27e40785d3726$var$__await(this.doDecodeSync())
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 7:
                        _b.sent();
                        if (--arrayItemsLeft === 0) return [
                            3 /*break*/ ,
                            8
                        ];
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        e_2 = _b.sent();
                        if (!(e_2 instanceof $3ed27e40785d3726$export$449c37eaf7093493)) throw e_2; // rethrow
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 10:
                        this.totalPos += this.pos;
                        _b.label = 11;
                    case 11:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 12:
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 13:
                        e_3_1 = _b.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 14:
                        _b.trys.push([
                            14,
                            ,
                            17,
                            18
                        ]);
                        if (!(stream_2_1 && !stream_2_1.done && (_a = stream_2.return))) return [
                            3 /*break*/ ,
                            16
                        ];
                        return [
                            4 /*yield*/ ,
                            $3ed27e40785d3726$var$__await(_a.call(stream_2))
                        ];
                    case 15:
                        _b.sent();
                        _b.label = 16;
                    case 16:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 17:
                        if (e_3) throw e_3.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 18:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 19:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Decoder.prototype.doDecodeSync = function() {
        DECODE: while(true){
            var headByte = this.readHeadByte();
            var object = void 0;
            if (headByte >= 0xe0) // negative fixint (111x xxxx) 0xe0 - 0xff
            object = headByte - 0x100;
            else if (headByte < 0xc0) {
                if (headByte < 0x80) // positive fixint (0xxx xxxx) 0x00 - 0x7f
                object = headByte;
                else if (headByte < 0x90) {
                    // fixmap (1000 xxxx) 0x80 - 0x8f
                    var size = headByte - 0x80;
                    if (size !== 0) {
                        this.pushMapState(size);
                        this.complete();
                        continue DECODE;
                    } else object = {};
                } else if (headByte < 0xa0) {
                    // fixarray (1001 xxxx) 0x90 - 0x9f
                    var size = headByte - 0x90;
                    if (size !== 0) {
                        this.pushArrayState(size);
                        this.complete();
                        continue DECODE;
                    } else object = [];
                } else {
                    // fixstr (101x xxxx) 0xa0 - 0xbf
                    var byteLength = headByte - 0xa0;
                    object = this.decodeUtf8String(byteLength, 0);
                }
            } else if (headByte === 0xc0) // nil
            object = null;
            else if (headByte === 0xc2) // false
            object = false;
            else if (headByte === 0xc3) // true
            object = true;
            else if (headByte === 0xca) // float 32
            object = this.readF32();
            else if (headByte === 0xcb) // float 64
            object = this.readF64();
            else if (headByte === 0xcc) // uint 8
            object = this.readU8();
            else if (headByte === 0xcd) // uint 16
            object = this.readU16();
            else if (headByte === 0xce) // uint 32
            object = this.readU32();
            else if (headByte === 0xcf) // uint 64
            object = this.readU64();
            else if (headByte === 0xd0) // int 8
            object = this.readI8();
            else if (headByte === 0xd1) // int 16
            object = this.readI16();
            else if (headByte === 0xd2) // int 32
            object = this.readI32();
            else if (headByte === 0xd3) // int 64
            object = this.readI64();
            else if (headByte === 0xd9) {
                // str 8
                var byteLength = this.lookU8();
                object = this.decodeUtf8String(byteLength, 1);
            } else if (headByte === 0xda) {
                // str 16
                var byteLength = this.lookU16();
                object = this.decodeUtf8String(byteLength, 2);
            } else if (headByte === 0xdb) {
                // str 32
                var byteLength = this.lookU32();
                object = this.decodeUtf8String(byteLength, 4);
            } else if (headByte === 0xdc) {
                // array 16
                var size = this.readU16();
                if (size !== 0) {
                    this.pushArrayState(size);
                    this.complete();
                    continue DECODE;
                } else object = [];
            } else if (headByte === 0xdd) {
                // array 32
                var size = this.readU32();
                if (size !== 0) {
                    this.pushArrayState(size);
                    this.complete();
                    continue DECODE;
                } else object = [];
            } else if (headByte === 0xde) {
                // map 16
                var size = this.readU16();
                if (size !== 0) {
                    this.pushMapState(size);
                    this.complete();
                    continue DECODE;
                } else object = {};
            } else if (headByte === 0xdf) {
                // map 32
                var size = this.readU32();
                if (size !== 0) {
                    this.pushMapState(size);
                    this.complete();
                    continue DECODE;
                } else object = {};
            } else if (headByte === 0xc4) {
                // bin 8
                var size = this.lookU8();
                object = this.decodeBinary(size, 1);
            } else if (headByte === 0xc5) {
                // bin 16
                var size = this.lookU16();
                object = this.decodeBinary(size, 2);
            } else if (headByte === 0xc6) {
                // bin 32
                var size = this.lookU32();
                object = this.decodeBinary(size, 4);
            } else if (headByte === 0xd4) // fixext 1
            object = this.decodeExtension(1, 0);
            else if (headByte === 0xd5) // fixext 2
            object = this.decodeExtension(2, 0);
            else if (headByte === 0xd6) // fixext 4
            object = this.decodeExtension(4, 0);
            else if (headByte === 0xd7) // fixext 8
            object = this.decodeExtension(8, 0);
            else if (headByte === 0xd8) // fixext 16
            object = this.decodeExtension(16, 0);
            else if (headByte === 0xc7) {
                // ext 8
                var size = this.lookU8();
                object = this.decodeExtension(size, 1);
            } else if (headByte === 0xc8) {
                // ext 16
                var size = this.lookU16();
                object = this.decodeExtension(size, 2);
            } else if (headByte === 0xc9) {
                // ext 32
                var size = this.lookU32();
                object = this.decodeExtension(size, 4);
            } else throw new (0, $1c14d367b301d5e6$export$ef3eed12d06c0285)("Unrecognized type byte: ".concat((0, $23a418a154e33a3f$export$78406e843f5312da)(headByte)));
            this.complete();
            var stack = this.stack;
            while(stack.length > 0){
                // arrays and maps
                var state = stack[stack.length - 1];
                if (state.type === 0 /* State.ARRAY */ ) {
                    state.array[state.position] = object;
                    state.position++;
                    if (state.position === state.size) {
                        stack.pop();
                        object = state.array;
                    } else continue DECODE;
                } else if (state.type === 1 /* State.MAP_KEY */ ) {
                    if (!$3ed27e40785d3726$var$isValidMapKeyType(object)) throw new (0, $1c14d367b301d5e6$export$ef3eed12d06c0285)("The type of key must be string or number but " + typeof object);
                    if (object === "__proto__") throw new (0, $1c14d367b301d5e6$export$ef3eed12d06c0285)("The key __proto__ is not allowed");
                    state.key = object;
                    state.type = 2 /* State.MAP_VALUE */ ;
                    continue DECODE;
                } else {
                    // it must be `state.type === State.MAP_VALUE` here
                    state.map[state.key] = object;
                    state.readCount++;
                    if (state.readCount === state.size) {
                        stack.pop();
                        object = state.map;
                    } else {
                        state.key = null;
                        state.type = 1 /* State.MAP_KEY */ ;
                        continue DECODE;
                    }
                }
            }
            return object;
        }
    };
    Decoder.prototype.readHeadByte = function() {
        if (this.headByte === $3ed27e40785d3726$var$HEAD_BYTE_REQUIRED) this.headByte = this.readU8();
        return this.headByte;
    };
    Decoder.prototype.complete = function() {
        this.headByte = $3ed27e40785d3726$var$HEAD_BYTE_REQUIRED;
    };
    Decoder.prototype.readArraySize = function() {
        var headByte = this.readHeadByte();
        switch(headByte){
            case 0xdc:
                return this.readU16();
            case 0xdd:
                return this.readU32();
            default:
                if (headByte < 0xa0) return headByte - 0x90;
                else throw new (0, $1c14d367b301d5e6$export$ef3eed12d06c0285)("Unrecognized array type byte: ".concat((0, $23a418a154e33a3f$export$78406e843f5312da)(headByte)));
        }
    };
    Decoder.prototype.pushMapState = function(size) {
        if (size > this.maxMapLength) throw new (0, $1c14d367b301d5e6$export$ef3eed12d06c0285)("Max length exceeded: map length (".concat(size, ") > maxMapLengthLength (").concat(this.maxMapLength, ")"));
        this.stack.push({
            type: 1 /* State.MAP_KEY */ ,
            size: size,
            key: null,
            readCount: 0,
            map: {}
        });
    };
    Decoder.prototype.pushArrayState = function(size) {
        if (size > this.maxArrayLength) throw new (0, $1c14d367b301d5e6$export$ef3eed12d06c0285)("Max length exceeded: array length (".concat(size, ") > maxArrayLength (").concat(this.maxArrayLength, ")"));
        this.stack.push({
            type: 0 /* State.ARRAY */ ,
            size: size,
            array: new Array(size),
            position: 0
        });
    };
    Decoder.prototype.decodeUtf8String = function(byteLength, headerOffset) {
        var _a;
        if (byteLength > this.maxStrLength) throw new (0, $1c14d367b301d5e6$export$ef3eed12d06c0285)("Max length exceeded: UTF-8 byte length (".concat(byteLength, ") > maxStrLength (").concat(this.maxStrLength, ")"));
        if (this.bytes.byteLength < this.pos + headerOffset + byteLength) throw $3ed27e40785d3726$var$MORE_DATA;
        var offset = this.pos + headerOffset;
        var object;
        if (this.stateIsMapKey() && ((_a = this.keyDecoder) === null || _a === void 0 ? void 0 : _a.canBeCached(byteLength))) object = this.keyDecoder.decode(this.bytes, offset, byteLength);
        else if (byteLength > (0, $b22d208b31a8382d$export$d866281c5a66d1ef)) object = (0, $b22d208b31a8382d$export$6ed79e41309992dc)(this.bytes, offset, byteLength);
        else object = (0, $b22d208b31a8382d$export$551117984c2adf4f)(this.bytes, offset, byteLength);
        this.pos += headerOffset + byteLength;
        return object;
    };
    Decoder.prototype.stateIsMapKey = function() {
        if (this.stack.length > 0) {
            var state = this.stack[this.stack.length - 1];
            return state.type === 1 /* State.MAP_KEY */ ;
        }
        return false;
    };
    Decoder.prototype.decodeBinary = function(byteLength, headOffset) {
        if (byteLength > this.maxBinLength) throw new (0, $1c14d367b301d5e6$export$ef3eed12d06c0285)("Max length exceeded: bin length (".concat(byteLength, ") > maxBinLength (").concat(this.maxBinLength, ")"));
        if (!this.hasRemaining(byteLength + headOffset)) throw $3ed27e40785d3726$var$MORE_DATA;
        var offset = this.pos + headOffset;
        var object = this.bytes.subarray(offset, offset + byteLength);
        this.pos += headOffset + byteLength;
        return object;
    };
    Decoder.prototype.decodeExtension = function(size, headOffset) {
        if (size > this.maxExtLength) throw new (0, $1c14d367b301d5e6$export$ef3eed12d06c0285)("Max length exceeded: ext length (".concat(size, ") > maxExtLength (").concat(this.maxExtLength, ")"));
        var extType = this.view.getInt8(this.pos + headOffset);
        var data = this.decodeBinary(size, headOffset + 1 /* extType */ );
        return this.extensionCodec.decode(data, extType, this.context);
    };
    Decoder.prototype.lookU8 = function() {
        return this.view.getUint8(this.pos);
    };
    Decoder.prototype.lookU16 = function() {
        return this.view.getUint16(this.pos);
    };
    Decoder.prototype.lookU32 = function() {
        return this.view.getUint32(this.pos);
    };
    Decoder.prototype.readU8 = function() {
        var value = this.view.getUint8(this.pos);
        this.pos++;
        return value;
    };
    Decoder.prototype.readI8 = function() {
        var value = this.view.getInt8(this.pos);
        this.pos++;
        return value;
    };
    Decoder.prototype.readU16 = function() {
        var value = this.view.getUint16(this.pos);
        this.pos += 2;
        return value;
    };
    Decoder.prototype.readI16 = function() {
        var value = this.view.getInt16(this.pos);
        this.pos += 2;
        return value;
    };
    Decoder.prototype.readU32 = function() {
        var value = this.view.getUint32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readI32 = function() {
        var value = this.view.getInt32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readU64 = function() {
        var value = (0, $dfb87e1808fe2a9d$export$59a2dbf579ff9568)(this.view, this.pos);
        this.pos += 8;
        return value;
    };
    Decoder.prototype.readI64 = function() {
        var value = (0, $dfb87e1808fe2a9d$export$69825c7adcc820c6)(this.view, this.pos);
        this.pos += 8;
        return value;
    };
    Decoder.prototype.readF32 = function() {
        var value = this.view.getFloat32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readF64 = function() {
        var value = this.view.getFloat64(this.pos);
        this.pos += 8;
        return value;
    };
    return Decoder;
}();


// utility for whatwg streams
var $010a5dccaa7b92a5$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $010a5dccaa7b92a5$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $010a5dccaa7b92a5$var$__await ? (this.v = v, this) : new $010a5dccaa7b92a5$var$__await(v);
};
var $010a5dccaa7b92a5$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $010a5dccaa7b92a5$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $010a5dccaa7b92a5$export$edb10ab8dd75a915(object) {
    return object[Symbol.asyncIterator] != null;
}
function $010a5dccaa7b92a5$var$assertNonNull(value) {
    if (value == null) throw new Error("Assertion Failure: value must not be null nor undefined");
}
function $010a5dccaa7b92a5$export$f62cf0e66867a58e(stream) {
    return $010a5dccaa7b92a5$var$__asyncGenerator(this, arguments, function asyncIterableFromStream_1() {
        var reader, _a, done, value;
        return $010a5dccaa7b92a5$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = stream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4 /*yield*/ ,
                        $010a5dccaa7b92a5$var$__await(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (!done) return [
                        3 /*break*/ ,
                        5
                    ];
                    return [
                        4 /*yield*/ ,
                        $010a5dccaa7b92a5$var$__await(void 0)
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        _b.sent()
                    ];
                case 5:
                    $010a5dccaa7b92a5$var$assertNonNull(value);
                    return [
                        4 /*yield*/ ,
                        $010a5dccaa7b92a5$var$__await(value)
                    ];
                case 6:
                    return [
                        4 /*yield*/ ,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 8:
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 10:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $010a5dccaa7b92a5$export$bf99ef56e8bd104(streamLike) {
    if ($010a5dccaa7b92a5$export$edb10ab8dd75a915(streamLike)) return streamLike;
    else return $010a5dccaa7b92a5$export$f62cf0e66867a58e(streamLike);
}



var $2bd2af5ea7e51d27$export$ca6ec972f712a9eb = {};
function $2bd2af5ea7e51d27$export$2f872c0f2117be69(buffer, options) {
    if (options === void 0) options = $2bd2af5ea7e51d27$export$ca6ec972f712a9eb;
    var decoder = new (0, $3ed27e40785d3726$export$f9de6ca0bc043724)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
    return decoder.decode(buffer);
}
function $2bd2af5ea7e51d27$export$43cc91859d9fdc54(buffer, options) {
    if (options === void 0) options = $2bd2af5ea7e51d27$export$ca6ec972f712a9eb;
    var decoder = new (0, $3ed27e40785d3726$export$f9de6ca0bc043724)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
    return decoder.decodeMulti(buffer);
}


var $803b493dc42be9fd$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $803b493dc42be9fd$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $803b493dc42be9fd$export$e4c183687a6ff9b(streamLike, options) {
    if (options === void 0) options = (0, $2bd2af5ea7e51d27$export$ca6ec972f712a9eb);
    return $803b493dc42be9fd$var$__awaiter(this, void 0, void 0, function() {
        var stream, decoder;
        return $803b493dc42be9fd$var$__generator(this, function(_a) {
            stream = (0, $010a5dccaa7b92a5$export$bf99ef56e8bd104)(streamLike);
            decoder = new (0, $3ed27e40785d3726$export$f9de6ca0bc043724)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
            return [
                2 /*return*/ ,
                decoder.decodeAsync(stream)
            ];
        });
    });
}
function $803b493dc42be9fd$export$b1b94ac44d9853a4(streamLike, options) {
    if (options === void 0) options = (0, $2bd2af5ea7e51d27$export$ca6ec972f712a9eb);
    var stream = (0, $010a5dccaa7b92a5$export$bf99ef56e8bd104)(streamLike);
    var decoder = new (0, $3ed27e40785d3726$export$f9de6ca0bc043724)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
    return decoder.decodeArrayStream(stream);
}
function $803b493dc42be9fd$export$bf87d8a088c760fb(streamLike, options) {
    if (options === void 0) options = (0, $2bd2af5ea7e51d27$export$ca6ec972f712a9eb);
    var stream = (0, $010a5dccaa7b92a5$export$bf99ef56e8bd104)(streamLike);
    var decoder = new (0, $3ed27e40785d3726$export$f9de6ca0bc043724)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
    return decoder.decodeStream(stream);
}
function $803b493dc42be9fd$export$7fb0f205e4fd0bbe(streamLike, options) {
    if (options === void 0) options = (0, $2bd2af5ea7e51d27$export$ca6ec972f712a9eb);
    return $803b493dc42be9fd$export$bf87d8a088c760fb(streamLike, options);
}


function $59c7ca8d46bbf378$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
class $59c7ca8d46bbf378$var$$fcbcc7538a6776d5$export$f1c5f4c9cb95390b {
    constructor(){
        this.chunkedMTU = 16300 // The original 60000 bytes setting does not work when sending data from Firefox to Chrome, which is "cut off" after 16384 bytes and delivered individually.
        ;
        // Binary stuff
        this._dataCount = 1;
        this.chunk = (blob)=>{
            const chunks = [];
            const size = blob.byteLength;
            const total = Math.ceil(size / this.chunkedMTU);
            let index = 0;
            let start = 0;
            while(start < size){
                const end = Math.min(size, start + this.chunkedMTU);
                const b = blob.slice(start, end);
                const chunk = {
                    __peerData: this._dataCount,
                    n: index,
                    data: b,
                    total: total
                };
                chunks.push(chunk);
                start = end;
                index++;
            }
            this._dataCount++;
            return chunks;
        };
    }
}
function $59c7ca8d46bbf378$var$$fcbcc7538a6776d5$export$52c89ebcdc4f53f2(bufs) {
    let size = 0;
    for (const buf of bufs)size += buf.byteLength;
    const result = new Uint8Array(size);
    let offset = 0;
    for (const buf of bufs){
        result.set(buf, offset);
        offset += buf.byteLength;
    }
    return result;
}
const $59c7ca8d46bbf378$var$$fb63e766cfafaab9$var$webRTCAdapter = (0, $ed7d4482cebe850e$export$2e2bcd8739ae039).default || (0, $ed7d4482cebe850e$export$2e2bcd8739ae039);
const $59c7ca8d46bbf378$var$$fb63e766cfafaab9$export$25be9502477c137d = new class {
    isWebRTCSupported() {
        return typeof RTCPeerConnection !== "undefined";
    }
    isBrowserSupported() {
        const browser = this.getBrowser();
        const version = this.getVersion();
        const validBrowser = this.supportedBrowsers.includes(browser);
        if (!validBrowser) return false;
        if (browser === "chrome") return version >= this.minChromeVersion;
        if (browser === "firefox") return version >= this.minFirefoxVersion;
        if (browser === "safari") return !this.isIOS && version >= this.minSafariVersion;
        return false;
    }
    getBrowser() {
        return $59c7ca8d46bbf378$var$$fb63e766cfafaab9$var$webRTCAdapter.browserDetails.browser;
    }
    getVersion() {
        return $59c7ca8d46bbf378$var$$fb63e766cfafaab9$var$webRTCAdapter.browserDetails.version || 0;
    }
    isUnifiedPlanSupported() {
        const browser = this.getBrowser();
        const version = $59c7ca8d46bbf378$var$$fb63e766cfafaab9$var$webRTCAdapter.browserDetails.version || 0;
        if (browser === "chrome" && version < this.minChromeVersion) return false;
        if (browser === "firefox" && version >= this.minFirefoxVersion) return true;
        if (!window.RTCRtpTransceiver || !("currentDirection" in RTCRtpTransceiver.prototype)) return false;
        let tempPc;
        let supported = false;
        try {
            tempPc = new RTCPeerConnection();
            tempPc.addTransceiver("audio");
            supported = true;
        } catch (e) {} finally{
            if (tempPc) tempPc.close();
        }
        return supported;
    }
    toString() {
        return `Supports:
    browser:${this.getBrowser()}
    version:${this.getVersion()}
    isIOS:${this.isIOS}
    isWebRTCSupported:${this.isWebRTCSupported()}
    isBrowserSupported:${this.isBrowserSupported()}
    isUnifiedPlanSupported:${this.isUnifiedPlanSupported()}`;
    }
    constructor(){
        this.isIOS = [
            "iPad",
            "iPhone",
            "iPod"
        ].includes(navigator.platform);
        this.supportedBrowsers = [
            "firefox",
            "chrome",
            "safari"
        ];
        this.minFirefoxVersion = 59;
        this.minChromeVersion = 72;
        this.minSafariVersion = 605;
    }
}();
const $59c7ca8d46bbf378$var$$9a84a32bf0bf36bb$export$f35f128fd59ea256 = (id)=>{
    // Allow empty ids
    return !id || /^[A-Za-z0-9]+(?:[ _-][A-Za-z0-9]+)*$/.test(id);
};
const $59c7ca8d46bbf378$var$$0e5fd1585784c252$export$4e61f672936bec77 = ()=>Math.random().toString(36).slice(2);
const $59c7ca8d46bbf378$var$$4f4134156c446392$var$DEFAULT_CONFIG = {
    iceServers: [
        {
            urls: "stun:stun.l.google.com:19302"
        },
        {
            urls: [
                "turn:eu-0.turn.peerjs.com:3478",
                "turn:us-0.turn.peerjs.com:3478"
            ],
            username: "peerjs",
            credential: "peerjsp"
        }
    ],
    sdpSemantics: "unified-plan"
};
class $59c7ca8d46bbf378$var$$4f4134156c446392$export$f8f26dd395d7e1bd extends $59c7ca8d46bbf378$var$$fcbcc7538a6776d5$export$f1c5f4c9cb95390b {
    noop() {}
    blobToArrayBuffer(blob, cb) {
        const fr = new FileReader();
        fr.onload = function(evt) {
            if (evt.target) cb(evt.target.result);
        };
        fr.readAsArrayBuffer(blob);
        return fr;
    }
    binaryStringToArrayBuffer(binary) {
        const byteArray = new Uint8Array(binary.length);
        for(let i = 0; i < binary.length; i++)byteArray[i] = binary.charCodeAt(i) & 0xff;
        return byteArray.buffer;
    }
    isSecure() {
        return location.protocol === "https:";
    }
    constructor(...args){
        super(...args);
        this.CLOUD_HOST = "0.peerjs.com";
        this.CLOUD_PORT = 443;
        // Browsers that need chunking:
        this.chunkedBrowsers = {
            Chrome: 1,
            chrome: 1
        };
        // Returns browser-agnostic default config
        this.defaultConfig = $59c7ca8d46bbf378$var$$4f4134156c446392$var$DEFAULT_CONFIG;
        this.browser = $59c7ca8d46bbf378$var$$fb63e766cfafaab9$export$25be9502477c137d.getBrowser();
        this.browserVersion = $59c7ca8d46bbf378$var$$fb63e766cfafaab9$export$25be9502477c137d.getVersion();
        this.pack = (0, $d47cae9fb86d08e6$export$2a703dbb0cb35339);
        this.unpack = (0, $d47cae9fb86d08e6$export$417857010dc9287f);
        /**
	 * A hash of WebRTC features mapped to booleans that correspond to whether the feature is supported by the current browser.
	 *
	 * :::caution
	 * Only the properties documented here are guaranteed to be present on `util.supports`
	 * :::
	 */ this.supports = function() {
            const supported = {
                browser: $59c7ca8d46bbf378$var$$fb63e766cfafaab9$export$25be9502477c137d.isBrowserSupported(),
                webRTC: $59c7ca8d46bbf378$var$$fb63e766cfafaab9$export$25be9502477c137d.isWebRTCSupported(),
                audioVideo: false,
                data: false,
                binaryBlob: false,
                reliable: false
            };
            if (!supported.webRTC) return supported;
            let pc;
            try {
                pc = new RTCPeerConnection($59c7ca8d46bbf378$var$$4f4134156c446392$var$DEFAULT_CONFIG);
                supported.audioVideo = true;
                let dc;
                try {
                    dc = pc.createDataChannel("_PEERJSTEST", {
                        ordered: true
                    });
                    supported.data = true;
                    supported.reliable = !!dc.ordered;
                    // Binary test
                    try {
                        dc.binaryType = "blob";
                        supported.binaryBlob = !$59c7ca8d46bbf378$var$$fb63e766cfafaab9$export$25be9502477c137d.isIOS;
                    } catch (e) {}
                } catch (e) {} finally{
                    if (dc) dc.close();
                }
            } catch (e) {} finally{
                if (pc) pc.close();
            }
            return supported;
        }();
        // Ensure alphanumeric ids
        this.validateId = $59c7ca8d46bbf378$var$$9a84a32bf0bf36bb$export$f35f128fd59ea256;
        this.randomToken = $59c7ca8d46bbf378$var$$0e5fd1585784c252$export$4e61f672936bec77;
    }
}
const $59c7ca8d46bbf378$export$7debb50ef11d5e0b = new $59c7ca8d46bbf378$var$$4f4134156c446392$export$f8f26dd395d7e1bd();
const $59c7ca8d46bbf378$var$$257947e92926277a$var$LOG_PREFIX = "PeerJS: ";
var $59c7ca8d46bbf378$var$$257947e92926277a$export$243e62d78d3b544d;
(function(LogLevel) {
    /**
	 * Prints no logs.
	 */ LogLevel[LogLevel["Disabled"] = 0] = "Disabled";
    /**
	 * Prints only errors.
	 */ LogLevel[LogLevel["Errors"] = 1] = "Errors";
    /**
	 * Prints errors and warnings.
	 */ LogLevel[LogLevel["Warnings"] = 2] = "Warnings";
    /**
	 * Prints all logs.
	 */ LogLevel[LogLevel["All"] = 3] = "All";
})($59c7ca8d46bbf378$var$$257947e92926277a$export$243e62d78d3b544d || ($59c7ca8d46bbf378$var$$257947e92926277a$export$243e62d78d3b544d = {}));
class $59c7ca8d46bbf378$var$$257947e92926277a$var$Logger {
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(logLevel) {
        this._logLevel = logLevel;
    }
    log(...args) {
        if (this._logLevel >= 3) this._print(3, ...args);
    }
    warn(...args) {
        if (this._logLevel >= 2) this._print(2, ...args);
    }
    error(...args) {
        if (this._logLevel >= 1) this._print(1, ...args);
    }
    setLogFunction(fn) {
        this._print = fn;
    }
    _print(logLevel, ...rest) {
        const copy = [
            $59c7ca8d46bbf378$var$$257947e92926277a$var$LOG_PREFIX,
            ...rest
        ];
        for(const i in copy)if (copy[i] instanceof Error) copy[i] = "(" + copy[i].name + ") " + copy[i].message;
        if (logLevel >= 3) console.log(...copy);
        else if (logLevel >= 2) console.warn("WARNING", ...copy);
        else if (logLevel >= 1) console.error("ERROR", ...copy);
    }
    constructor(){
        this._logLevel = 0;
    }
}
var $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039 = new $59c7ca8d46bbf378$var$$257947e92926277a$var$Logger();
var $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$exports = {};
"use strict";
var $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$has = Object.prototype.hasOwnProperty, $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$Events().__proto__) $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EE(fn, context || emitter, once), evt = $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$prefix ? $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter() {
    this._events = new $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$has.call(events, name)) names.push($59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$prefix ? $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$prefix ? $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$prefix ? $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$prefix ? $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$prefix ? $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$prefix + event : event;
        if (this._events[evt]) $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$clearEvent(this, evt);
    } else {
        this._events = new $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.off = $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.removeListener;
$59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.addListener = $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter.prefixed = $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter.EventEmitter = $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter;
$59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$exports = $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$var$EventEmitter;
var $59c7ca8d46bbf378$var$$78455e22dea96b8c$exports = {};
$59c7ca8d46bbf378$var$$parcel$export($59c7ca8d46bbf378$var$$78455e22dea96b8c$exports, "ConnectionType", ()=>$59c7ca8d46bbf378$export$3157d57b4135e3bc);
$59c7ca8d46bbf378$var$$parcel$export($59c7ca8d46bbf378$var$$78455e22dea96b8c$exports, "PeerErrorType", ()=>$59c7ca8d46bbf378$export$9547aaa2e39030ff);
$59c7ca8d46bbf378$var$$parcel$export($59c7ca8d46bbf378$var$$78455e22dea96b8c$exports, "BaseConnectionErrorType", ()=>$59c7ca8d46bbf378$export$7974935686149686);
$59c7ca8d46bbf378$var$$parcel$export($59c7ca8d46bbf378$var$$78455e22dea96b8c$exports, "DataConnectionErrorType", ()=>$59c7ca8d46bbf378$export$49ae800c114df41d);
$59c7ca8d46bbf378$var$$parcel$export($59c7ca8d46bbf378$var$$78455e22dea96b8c$exports, "SerializationType", ()=>$59c7ca8d46bbf378$export$89f507cf986a947);
$59c7ca8d46bbf378$var$$parcel$export($59c7ca8d46bbf378$var$$78455e22dea96b8c$exports, "SocketEventType", ()=>$59c7ca8d46bbf378$export$3b5c4a4b6354f023);
$59c7ca8d46bbf378$var$$parcel$export($59c7ca8d46bbf378$var$$78455e22dea96b8c$exports, "ServerMessageType", ()=>$59c7ca8d46bbf378$export$adb4a1754da6f10d);
var $59c7ca8d46bbf378$export$3157d57b4135e3bc;
(function(ConnectionType) {
    ConnectionType["Data"] = "data";
    ConnectionType["Media"] = "media";
})($59c7ca8d46bbf378$export$3157d57b4135e3bc || ($59c7ca8d46bbf378$export$3157d57b4135e3bc = {}));
var $59c7ca8d46bbf378$export$9547aaa2e39030ff;
(function(PeerErrorType) {
    /**
	 * The client's browser does not support some or all WebRTC features that you are trying to use.
	 */ PeerErrorType["BrowserIncompatible"] = "browser-incompatible";
    /**
	 * You've already disconnected this peer from the server and can no longer make any new connections on it.
	 */ PeerErrorType["Disconnected"] = "disconnected";
    /**
	 * The ID passed into the Peer constructor contains illegal characters.
	 */ PeerErrorType["InvalidID"] = "invalid-id";
    /**
	 * The API key passed into the Peer constructor contains illegal characters or is not in the system (cloud server only).
	 */ PeerErrorType["InvalidKey"] = "invalid-key";
    /**
	 * Lost or cannot establish a connection to the signalling server.
	 */ PeerErrorType["Network"] = "network";
    /**
	 * The peer you're trying to connect to does not exist.
	 */ PeerErrorType["PeerUnavailable"] = "peer-unavailable";
    /**
	 * PeerJS is being used securely, but the cloud server does not support SSL. Use a custom PeerServer.
	 */ PeerErrorType["SslUnavailable"] = "ssl-unavailable";
    /**
	 * Unable to reach the server.
	 */ PeerErrorType["ServerError"] = "server-error";
    /**
	 * An error from the underlying socket.
	 */ PeerErrorType["SocketError"] = "socket-error";
    /**
	 * The underlying socket closed unexpectedly.
	 */ PeerErrorType["SocketClosed"] = "socket-closed";
    /**
	 * The ID passed into the Peer constructor is already taken.
	 *
	 * :::caution
	 * This error is not fatal if your peer has open peer-to-peer connections.
	 * This can happen if you attempt to {@apilink Peer.reconnect} a peer that has been disconnected from the server,
	 * but its old ID has now been taken.
	 * :::
	 */ PeerErrorType["UnavailableID"] = "unavailable-id";
    /**
	 * Native WebRTC errors.
	 */ PeerErrorType["WebRTC"] = "webrtc";
})($59c7ca8d46bbf378$export$9547aaa2e39030ff || ($59c7ca8d46bbf378$export$9547aaa2e39030ff = {}));
var $59c7ca8d46bbf378$export$7974935686149686;
(function(BaseConnectionErrorType) {
    BaseConnectionErrorType["NegotiationFailed"] = "negotiation-failed";
    BaseConnectionErrorType["ConnectionClosed"] = "connection-closed";
})($59c7ca8d46bbf378$export$7974935686149686 || ($59c7ca8d46bbf378$export$7974935686149686 = {}));
var $59c7ca8d46bbf378$export$49ae800c114df41d;
(function(DataConnectionErrorType) {
    DataConnectionErrorType["NotOpenYet"] = "not-open-yet";
    DataConnectionErrorType["MessageToBig"] = "message-too-big";
})($59c7ca8d46bbf378$export$49ae800c114df41d || ($59c7ca8d46bbf378$export$49ae800c114df41d = {}));
var $59c7ca8d46bbf378$export$89f507cf986a947;
(function(SerializationType) {
    SerializationType["Binary"] = "binary";
    SerializationType["BinaryUTF8"] = "binary-utf8";
    SerializationType["JSON"] = "json";
    SerializationType["None"] = "raw";
})($59c7ca8d46bbf378$export$89f507cf986a947 || ($59c7ca8d46bbf378$export$89f507cf986a947 = {}));
var $59c7ca8d46bbf378$export$3b5c4a4b6354f023;
(function(SocketEventType) {
    SocketEventType["Message"] = "message";
    SocketEventType["Disconnected"] = "disconnected";
    SocketEventType["Error"] = "error";
    SocketEventType["Close"] = "close";
})($59c7ca8d46bbf378$export$3b5c4a4b6354f023 || ($59c7ca8d46bbf378$export$3b5c4a4b6354f023 = {}));
var $59c7ca8d46bbf378$export$adb4a1754da6f10d;
(function(ServerMessageType) {
    ServerMessageType["Heartbeat"] = "HEARTBEAT";
    ServerMessageType["Candidate"] = "CANDIDATE";
    ServerMessageType["Offer"] = "OFFER";
    ServerMessageType["Answer"] = "ANSWER";
    ServerMessageType["Open"] = "OPEN";
    ServerMessageType["Error"] = "ERROR";
    ServerMessageType["IdTaken"] = "ID-TAKEN";
    ServerMessageType["InvalidKey"] = "INVALID-KEY";
    ServerMessageType["Leave"] = "LEAVE";
    ServerMessageType["Expire"] = "EXPIRE";
})($59c7ca8d46bbf378$export$adb4a1754da6f10d || ($59c7ca8d46bbf378$export$adb4a1754da6f10d = {}));
var $59c7ca8d46bbf378$var$$f5f881ec4575f1fc$exports = {};
$59c7ca8d46bbf378$var$$f5f881ec4575f1fc$exports = JSON.parse('{"name":"peerjs","version":"1.5.2","keywords":["peerjs","webrtc","p2p","rtc"],"description":"PeerJS client","homepage":"https://peerjs.com","bugs":{"url":"https://github.com/peers/peerjs/issues"},"repository":{"type":"git","url":"https://github.com/peers/peerjs"},"license":"MIT","contributors":["Michelle Bu <michelle@michellebu.com>","afrokick <devbyru@gmail.com>","ericz <really.ez@gmail.com>","Jairo <kidandcat@gmail.com>","Jonas Gloning <34194370+jonasgloning@users.noreply.github.com>","Jairo Caro-Accino Viciana <jairo@galax.be>","Carlos Caballero <carlos.caballero.gonzalez@gmail.com>","hc <hheennrryy@gmail.com>","Muhammad Asif <capripio@gmail.com>","PrashoonB <prashoonbhattacharjee@gmail.com>","Harsh Bardhan Mishra <47351025+HarshCasper@users.noreply.github.com>","akotynski <aleksanderkotbury@gmail.com>","lmb <i@lmb.io>","Jairooo <jairocaro@msn.com>","Moritz St\xfcckler <moritz.stueckler@gmail.com>","Simon <crydotsnakegithub@gmail.com>","Denis Lukov <denismassters@gmail.com>","Philipp Hancke <fippo@andyet.net>","Hans Oksendahl <hansoksendahl@gmail.com>","Jess <jessachandler@gmail.com>","khankuan <khankuan@gmail.com>","DUODVK <kurmanov.work@gmail.com>","XiZhao <kwang1imsa@gmail.com>","Matthias Lohr <matthias@lohr.me>","=frank tree <=frnktrb@googlemail.com>","Andre Eckardt <aeckardt@outlook.com>","Chris Cowan <agentme49@gmail.com>","Alex Chuev <alex@chuev.com>","alxnull <alxnull@e.mail.de>","Yemel Jardi <angel.jardi@gmail.com>","Ben Parnell <benjaminparnell.94@gmail.com>","Benny Lichtner <bennlich@gmail.com>","fresheneesz <bitetrudpublic@gmail.com>","bob.barstead@exaptive.com <bob.barstead@exaptive.com>","chandika <chandika@gmail.com>","emersion <contact@emersion.fr>","Christopher Van <cvan@users.noreply.github.com>","eddieherm <edhermoso@gmail.com>","Eduardo Pinho <enet4mikeenet@gmail.com>","Evandro Zanatta <ezanatta@tray.net.br>","Gardner Bickford <gardner@users.noreply.github.com>","Gian Luca <gianluca.cecchi@cynny.com>","PatrickJS <github@gdi2290.com>","jonnyf <github@jonathanfoss.co.uk>","Hizkia Felix <hizkifw@gmail.com>","Hristo Oskov <hristo.oskov@gmail.com>","Isaac Madwed <i.madwed@gmail.com>","Ilya Konanykhin <ilya.konanykhin@gmail.com>","jasonbarry <jasbarry@me.com>","Jonathan Burke <jonathan.burke.1311@googlemail.com>","Josh Hamit <josh.hamit@gmail.com>","Jordan Austin <jrax86@gmail.com>","Joel Wetzell <jwetzell@yahoo.com>","xizhao <kevin.wang@cloudera.com>","Alberto Torres <kungfoobar@gmail.com>","Jonathan Mayol <mayoljonathan@gmail.com>","Jefferson Felix <me@jsfelix.dev>","Rolf Erik Lekang <me@rolflekang.com>","Kevin Mai-Husan Chia <mhchia@users.noreply.github.com>","Pepijn de Vos <pepijndevos@gmail.com>","JooYoung <qkdlql@naver.com>","Tobias Speicher <rootcommander@gmail.com>","Steve Blaurock <sblaurock@gmail.com>","Kyrylo Shegeda <shegeda@ualberta.ca>","Diwank Singh Tomer <singh@diwank.name>","So\u0308ren Balko <Soeren.Balko@gmail.com>","Arpit Solanki <solankiarpit1997@gmail.com>","Yuki Ito <yuki@gnnk.net>","Artur Zayats <zag2art@gmail.com>"],"funding":{"type":"opencollective","url":"https://opencollective.com/peer"},"collective":{"type":"opencollective","url":"https://opencollective.com/peer"},"files":["dist/*"],"sideEffects":["lib/global.ts","lib/supports.ts"],"main":"dist/bundler.cjs","module":"dist/bundler.mjs","browser-minified":"dist/peerjs.min.js","browser-unminified":"dist/peerjs.js","browser-minified-cbor":"dist/serializer.cbor.mjs","browser-minified-msgpack":"dist/serializer.msgpack.mjs","types":"dist/types.d.ts","engines":{"node":">= 14"},"targets":{"types":{"source":"lib/exports.ts"},"main":{"source":"lib/exports.ts","sourceMap":{"inlineSources":true}},"module":{"source":"lib/exports.ts","includeNodeModules":["eventemitter3"],"sourceMap":{"inlineSources":true}},"browser-minified":{"context":"browser","outputFormat":"global","optimize":true,"engines":{"browsers":"chrome >= 83, edge >= 83, firefox >= 80, safari >= 15"},"source":"lib/global.ts"},"browser-unminified":{"context":"browser","outputFormat":"global","optimize":false,"engines":{"browsers":"chrome >= 83, edge >= 83, firefox >= 80, safari >= 15"},"source":"lib/global.ts"},"browser-minified-cbor":{"context":"browser","outputFormat":"esmodule","isLibrary":true,"optimize":true,"engines":{"browsers":"chrome >= 83, edge >= 83, firefox >= 102, safari >= 15"},"source":"lib/dataconnection/StreamConnection/Cbor.ts"},"browser-minified-msgpack":{"context":"browser","outputFormat":"esmodule","isLibrary":true,"optimize":true,"engines":{"browsers":"chrome >= 83, edge >= 83, firefox >= 102, safari >= 15"},"source":"lib/dataconnection/StreamConnection/MsgPack.ts"}},"scripts":{"contributors":"git-authors-cli --print=false && prettier --write package.json && git add package.json package-lock.json && git commit -m \\"chore(contributors): update and sort contributors list\\"","check":"tsc --noEmit && tsc -p e2e/tsconfig.json --noEmit","watch":"parcel watch","build":"rm -rf dist && parcel build","prepublishOnly":"npm run build","test":"jest","test:watch":"jest --watch","coverage":"jest --coverage --collectCoverageFrom=\\"./lib/**\\"","format":"prettier --write .","format:check":"prettier --check .","semantic-release":"semantic-release","e2e":"wdio run e2e/wdio.local.conf.ts","e2e:bstack":"wdio run e2e/wdio.bstack.conf.ts"},"devDependencies":{"@parcel/config-default":"^2.9.3","@parcel/packager-ts":"^2.9.3","@parcel/transformer-typescript-tsc":"^2.9.3","@parcel/transformer-typescript-types":"^2.9.3","@semantic-release/changelog":"^6.0.1","@semantic-release/git":"^10.0.1","@swc/core":"^1.3.27","@swc/jest":"^0.2.24","@types/jasmine":"^4.3.4","@wdio/browserstack-service":"^8.11.2","@wdio/cli":"^8.11.2","@wdio/globals":"^8.11.2","@wdio/jasmine-framework":"^8.11.2","@wdio/local-runner":"^8.11.2","@wdio/spec-reporter":"^8.11.2","@wdio/types":"^8.10.4","http-server":"^14.1.1","jest":"^29.3.1","jest-environment-jsdom":"^29.3.1","mock-socket":"^9.0.0","parcel":"^2.9.3","prettier":"^3.0.0","semantic-release":"^21.0.0","ts-node":"^10.9.1","typescript":"^5.0.0","wdio-geckodriver-service":"^5.0.1"},"dependencies":{"@msgpack/msgpack":"^2.8.0","cbor-x":"1.5.4","eventemitter3":"^4.0.7","peerjs-js-binarypack":"^2.1.0","webrtc-adapter":"^8.0.0"},"alias":{"process":false,"buffer":false}}');
class $59c7ca8d46bbf378$var$$8f5bfa60836d261d$export$4798917dbf149b79 extends $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$exports.EventEmitter {
    constructor(secure, host, port, path, key, pingInterval = 5000){
        super();
        this.pingInterval = pingInterval;
        this._disconnected = true;
        this._messagesQueue = [];
        const wsProtocol = secure ? "wss://" : "ws://";
        this._baseUrl = wsProtocol + host + ":" + port + path + "peerjs?key=" + key;
    }
    start(id, token) {
        this._id = id;
        const wsUrl = `${this._baseUrl}&id=${id}&token=${token}`;
        if (!!this._socket || !this._disconnected) return;
        this._socket = new WebSocket(wsUrl + "&version=" + $59c7ca8d46bbf378$var$$f5f881ec4575f1fc$exports.version);
        this._disconnected = false;
        this._socket.onmessage = (event)=>{
            let data;
            try {
                data = JSON.parse(event.data);
                $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Server message received:", data);
            } catch (e) {
                $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Invalid server message", event.data);
                return;
            }
            this.emit($59c7ca8d46bbf378$export$3b5c4a4b6354f023.Message, data);
        };
        this._socket.onclose = (event)=>{
            if (this._disconnected) return;
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Socket closed.", event);
            this._cleanup();
            this._disconnected = true;
            this.emit($59c7ca8d46bbf378$export$3b5c4a4b6354f023.Disconnected);
        };
        // Take care of the queue of connections if necessary and make sure Peer knows
        // socket is open.
        this._socket.onopen = ()=>{
            if (this._disconnected) return;
            this._sendQueuedMessages();
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Socket open");
            this._scheduleHeartbeat();
        };
    }
    _scheduleHeartbeat() {
        this._wsPingTimer = setTimeout(()=>{
            this._sendHeartbeat();
        }, this.pingInterval);
    }
    _sendHeartbeat() {
        if (!this._wsOpen()) {
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Cannot send heartbeat, because socket closed`);
            return;
        }
        const message = JSON.stringify({
            type: $59c7ca8d46bbf378$export$adb4a1754da6f10d.Heartbeat
        });
        this._socket.send(message);
        this._scheduleHeartbeat();
    }
    /** Is the websocket currently open? */ _wsOpen() {
        return !!this._socket && this._socket.readyState === 1;
    }
    /** Send queued messages. */ _sendQueuedMessages() {
        //Create copy of queue and clear it,
        //because send method push the message back to queue if smth will go wrong
        const copiedQueue = [
            ...this._messagesQueue
        ];
        this._messagesQueue = [];
        for (const message of copiedQueue)this.send(message);
    }
    /** Exposed send for DC & Peer. */ send(data) {
        if (this._disconnected) return;
        // If we didn't get an ID yet, we can't yet send anything so we should queue
        // up these messages.
        if (!this._id) {
            this._messagesQueue.push(data);
            return;
        }
        if (!data.type) {
            this.emit($59c7ca8d46bbf378$export$3b5c4a4b6354f023.Error, "Invalid message");
            return;
        }
        if (!this._wsOpen()) return;
        const message = JSON.stringify(data);
        this._socket.send(message);
    }
    close() {
        if (this._disconnected) return;
        this._cleanup();
        this._disconnected = true;
    }
    _cleanup() {
        if (this._socket) {
            this._socket.onopen = this._socket.onmessage = this._socket.onclose = null;
            this._socket.close();
            this._socket = undefined;
        }
        clearTimeout(this._wsPingTimer);
    }
}
class $59c7ca8d46bbf378$var$$b82fb8fc0514bfc1$export$89e6bb5ad64bf4a {
    constructor(connection){
        this.connection = connection;
    }
    /** Returns a PeerConnection object set up correctly (for data, media). */ startConnection(options) {
        const peerConnection = this._startPeerConnection();
        // Set the connection's PC.
        this.connection.peerConnection = peerConnection;
        if (this.connection.type === $59c7ca8d46bbf378$export$3157d57b4135e3bc.Media && options._stream) this._addTracksToConnection(options._stream, peerConnection);
        // What do we need to do now?
        if (options.originator) {
            const dataConnection = this.connection;
            const config = {
                ordered: !!options.reliable
            };
            const dataChannel = peerConnection.createDataChannel(dataConnection.label, config);
            dataConnection._initializeDataChannel(dataChannel);
            this._makeOffer();
        } else this.handleSDP("OFFER", options.sdp);
    }
    /** Start a PC. */ _startPeerConnection() {
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Creating RTCPeerConnection.");
        const peerConnection = new RTCPeerConnection(this.connection.provider.options.config);
        this._setupListeners(peerConnection);
        return peerConnection;
    }
    /** Set up various WebRTC listeners. */ _setupListeners(peerConnection) {
        const peerId = this.connection.peer;
        const connectionId = this.connection.connectionId;
        const connectionType = this.connection.type;
        const provider = this.connection.provider;
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Listening for ICE candidates.");
        peerConnection.onicecandidate = (evt)=>{
            if (!evt.candidate || !evt.candidate.candidate) return;
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Received ICE candidates for ${peerId}:`, evt.candidate);
            provider.socket.send({
                type: $59c7ca8d46bbf378$export$adb4a1754da6f10d.Candidate,
                payload: {
                    candidate: evt.candidate,
                    type: connectionType,
                    connectionId: connectionId
                },
                dst: peerId
            });
        };
        peerConnection.oniceconnectionstatechange = ()=>{
            switch(peerConnection.iceConnectionState){
                case "failed":
                    $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("iceConnectionState is failed, closing connections to " + peerId);
                    this.connection.emitError($59c7ca8d46bbf378$export$7974935686149686.NegotiationFailed, "Negotiation of connection to " + peerId + " failed.");
                    this.connection.close();
                    break;
                case "closed":
                    $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("iceConnectionState is closed, closing connections to " + peerId);
                    this.connection.emitError($59c7ca8d46bbf378$export$7974935686149686.ConnectionClosed, "Connection to " + peerId + " closed.");
                    this.connection.close();
                    break;
                case "disconnected":
                    $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("iceConnectionState changed to disconnected on the connection with " + peerId);
                    break;
                case "completed":
                    peerConnection.onicecandidate = ()=>{};
                    break;
            }
            this.connection.emit("iceStateChanged", peerConnection.iceConnectionState);
        };
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Listening for data channel");
        // Fired between offer and answer, so options should already be saved
        // in the options hash.
        peerConnection.ondatachannel = (evt)=>{
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Received data channel");
            const dataChannel = evt.channel;
            const connection = provider.getConnection(peerId, connectionId);
            connection._initializeDataChannel(dataChannel);
        };
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Listening for remote stream");
        peerConnection.ontrack = (evt)=>{
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Received remote stream");
            const stream = evt.streams[0];
            const connection = provider.getConnection(peerId, connectionId);
            if (connection.type === $59c7ca8d46bbf378$export$3157d57b4135e3bc.Media) {
                const mediaConnection = connection;
                this._addStreamToMediaConnection(stream, mediaConnection);
            }
        };
    }
    cleanup() {
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Cleaning up PeerConnection to " + this.connection.peer);
        const peerConnection = this.connection.peerConnection;
        if (!peerConnection) return;
        this.connection.peerConnection = null;
        //unsubscribe from all PeerConnection's events
        peerConnection.onicecandidate = peerConnection.oniceconnectionstatechange = peerConnection.ondatachannel = peerConnection.ontrack = ()=>{};
        const peerConnectionNotClosed = peerConnection.signalingState !== "closed";
        let dataChannelNotClosed = false;
        const dataChannel = this.connection.dataChannel;
        if (dataChannel) dataChannelNotClosed = !!dataChannel.readyState && dataChannel.readyState !== "closed";
        if (peerConnectionNotClosed || dataChannelNotClosed) peerConnection.close();
    }
    async _makeOffer() {
        const peerConnection = this.connection.peerConnection;
        const provider = this.connection.provider;
        try {
            const offer = await peerConnection.createOffer(this.connection.options.constraints);
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Created offer.");
            if (this.connection.options.sdpTransform && typeof this.connection.options.sdpTransform === "function") offer.sdp = this.connection.options.sdpTransform(offer.sdp) || offer.sdp;
            try {
                await peerConnection.setLocalDescription(offer);
                $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Set localDescription:", offer, `for:${this.connection.peer}`);
                let payload = {
                    sdp: offer,
                    type: this.connection.type,
                    connectionId: this.connection.connectionId,
                    metadata: this.connection.metadata
                };
                if (this.connection.type === $59c7ca8d46bbf378$export$3157d57b4135e3bc.Data) {
                    const dataConnection = this.connection;
                    payload = {
                        ...payload,
                        label: dataConnection.label,
                        reliable: dataConnection.reliable,
                        serialization: dataConnection.serialization
                    };
                }
                provider.socket.send({
                    type: $59c7ca8d46bbf378$export$adb4a1754da6f10d.Offer,
                    payload: payload,
                    dst: this.connection.peer
                });
            } catch (err) {
                // TODO: investigate why _makeOffer is being called from the answer
                if (err != "OperationError: Failed to set local offer sdp: Called in wrong state: kHaveRemoteOffer") {
                    provider.emitError($59c7ca8d46bbf378$export$9547aaa2e39030ff.WebRTC, err);
                    $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to setLocalDescription, ", err);
                }
            }
        } catch (err_1) {
            provider.emitError($59c7ca8d46bbf378$export$9547aaa2e39030ff.WebRTC, err_1);
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to createOffer, ", err_1);
        }
    }
    async _makeAnswer() {
        const peerConnection = this.connection.peerConnection;
        const provider = this.connection.provider;
        try {
            const answer = await peerConnection.createAnswer();
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Created answer.");
            if (this.connection.options.sdpTransform && typeof this.connection.options.sdpTransform === "function") answer.sdp = this.connection.options.sdpTransform(answer.sdp) || answer.sdp;
            try {
                await peerConnection.setLocalDescription(answer);
                $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Set localDescription:`, answer, `for:${this.connection.peer}`);
                provider.socket.send({
                    type: $59c7ca8d46bbf378$export$adb4a1754da6f10d.Answer,
                    payload: {
                        sdp: answer,
                        type: this.connection.type,
                        connectionId: this.connection.connectionId
                    },
                    dst: this.connection.peer
                });
            } catch (err) {
                provider.emitError($59c7ca8d46bbf378$export$9547aaa2e39030ff.WebRTC, err);
                $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to setLocalDescription, ", err);
            }
        } catch (err_1) {
            provider.emitError($59c7ca8d46bbf378$export$9547aaa2e39030ff.WebRTC, err_1);
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to create answer, ", err_1);
        }
    }
    /** Handle an SDP. */ async handleSDP(type, sdp) {
        sdp = new RTCSessionDescription(sdp);
        const peerConnection = this.connection.peerConnection;
        const provider = this.connection.provider;
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Setting remote description", sdp);
        const self = this;
        try {
            await peerConnection.setRemoteDescription(sdp);
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Set remoteDescription:${type} for:${this.connection.peer}`);
            if (type === "OFFER") await self._makeAnswer();
        } catch (err) {
            provider.emitError($59c7ca8d46bbf378$export$9547aaa2e39030ff.WebRTC, err);
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to setRemoteDescription, ", err);
        }
    }
    /** Handle a candidate. */ async handleCandidate(ice) {
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`handleCandidate:`, ice);
        try {
            await this.connection.peerConnection.addIceCandidate(ice);
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Added ICE candidate for:${this.connection.peer}`);
        } catch (err) {
            this.connection.provider.emitError($59c7ca8d46bbf378$export$9547aaa2e39030ff.WebRTC, err);
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to handleCandidate, ", err);
        }
    }
    _addTracksToConnection(stream, peerConnection) {
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`add tracks from stream ${stream.id} to peer connection`);
        if (!peerConnection.addTrack) return $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.error(`Your browser does't support RTCPeerConnection#addTrack. Ignored.`);
        stream.getTracks().forEach((track)=>{
            peerConnection.addTrack(track, stream);
        });
    }
    _addStreamToMediaConnection(stream, mediaConnection) {
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`add stream ${stream.id} to media connection ${mediaConnection.connectionId}`);
        mediaConnection.addStream(stream);
    }
}
class $59c7ca8d46bbf378$var$$23779d1881157a18$export$6a678e589c8a4542 extends $59c7ca8d46bbf378$var$$c4dcfd1d1ea86647$exports.EventEmitter {
    /**
	 * Emits a typed error message.
	 *
	 * @internal
	 */ emitError(type, err) {
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.error("Error:", err);
        // @ts-ignore
        this.emit("error", new $59c7ca8d46bbf378$export$98871882f492de82(`${type}`, err));
    }
}
class $59c7ca8d46bbf378$export$98871882f492de82 extends Error {
    /**
	 * @internal
	 */ constructor(type, err){
        if (typeof err === "string") super(err);
        else {
            super();
            Object.assign(this, err);
        }
        this.type = type;
    }
}
class $59c7ca8d46bbf378$var$$5045192fc6d387ba$export$23a2a68283c24d80 extends $59c7ca8d46bbf378$var$$23779d1881157a18$export$6a678e589c8a4542 {
    /**
	 * Whether the media connection is active (e.g. your call has been answered).
	 * You can check this if you want to set a maximum wait time for a one-sided call.
	 */ get open() {
        return this._open;
    }
    constructor(/**
		 * The ID of the peer on the other end of this connection.
		 */ peer, provider, options){
        super();
        this.peer = peer;
        this.provider = provider;
        this.options = options;
        this._open = false;
        this.metadata = options.metadata;
    }
}
class $59c7ca8d46bbf378$var$$5c1d08c7c57da9a3$export$4a84e95a2324ac29 extends $59c7ca8d46bbf378$var$$5045192fc6d387ba$export$23a2a68283c24d80 {
    static #_ = this.ID_PREFIX = "mc_";
    /**
	 * For media connections, this is always 'media'.
	 */ get type() {
        return $59c7ca8d46bbf378$export$3157d57b4135e3bc.Media;
    }
    get localStream() {
        return this._localStream;
    }
    get remoteStream() {
        return this._remoteStream;
    }
    constructor(peerId, provider, options){
        super(peerId, provider, options);
        this._localStream = this.options._stream;
        this.connectionId = this.options.connectionId || $59c7ca8d46bbf378$var$$5c1d08c7c57da9a3$export$4a84e95a2324ac29.ID_PREFIX + $59c7ca8d46bbf378$export$7debb50ef11d5e0b.randomToken();
        this._negotiator = new $59c7ca8d46bbf378$var$$b82fb8fc0514bfc1$export$89e6bb5ad64bf4a(this);
        if (this._localStream) this._negotiator.startConnection({
            _stream: this._localStream,
            originator: true
        });
    }
    /** Called by the Negotiator when the DataChannel is ready. */ _initializeDataChannel(dc) {
        this.dataChannel = dc;
        this.dataChannel.onopen = ()=>{
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} dc connection success`);
            this.emit("willCloseOnRemote");
        };
        this.dataChannel.onclose = ()=>{
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} dc closed for:`, this.peer);
            this.close();
        };
    }
    addStream(remoteStream) {
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log("Receiving stream", remoteStream);
        this._remoteStream = remoteStream;
        super.emit("stream", remoteStream); // Should we call this `open`?
    }
    /**
	 * @internal
	 */ handleMessage(message) {
        const type = message.type;
        const payload = message.payload;
        switch(message.type){
            case $59c7ca8d46bbf378$export$adb4a1754da6f10d.Answer:
                // Forward to negotiator
                this._negotiator.handleSDP(type, payload.sdp);
                this._open = true;
                break;
            case $59c7ca8d46bbf378$export$adb4a1754da6f10d.Candidate:
                this._negotiator.handleCandidate(payload.candidate);
                break;
            default:
                $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.warn(`Unrecognized message type:${type} from peer:${this.peer}`);
                break;
        }
    }
    /**
     * When receiving a {@apilink PeerEvents | `call`} event on a peer, you can call
     * `answer` on the media connection provided by the callback to accept the call
     * and optionally send your own media stream.

     *
     * @param stream A WebRTC media stream.
     * @param options
     * @returns
     */ answer(stream, options = {}) {
        if (this._localStream) {
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.warn("Local stream already exists on this MediaConnection. Are you answering a call twice?");
            return;
        }
        this._localStream = stream;
        if (options && options.sdpTransform) this.options.sdpTransform = options.sdpTransform;
        this._negotiator.startConnection({
            ...this.options._payload,
            _stream: stream
        });
        // Retrieve lost messages stored because PeerConnection not set up.
        const messages = this.provider._getMessages(this.connectionId);
        for (const message of messages)this.handleMessage(message);
        this._open = true;
    }
    /**
	 * Exposed functionality for users.
	 */ /**
	 * Closes the media connection.
	 */ close() {
        if (this._negotiator) {
            this._negotiator.cleanup();
            this._negotiator = null;
        }
        this._localStream = null;
        this._remoteStream = null;
        if (this.provider) {
            this.provider._removeConnection(this);
            this.provider = null;
        }
        if (this.options && this.options._stream) this.options._stream = null;
        if (!this.open) return;
        this._open = false;
        super.emit("close");
    }
}
class $59c7ca8d46bbf378$var$$abf266641927cd89$export$2c4e825dc9120f87 {
    constructor(_options){
        this._options = _options;
    }
    _buildRequest(method) {
        const protocol = this._options.secure ? "https" : "http";
        const { host: host, port: port, path: path, key: key } = this._options;
        const url = new URL(`${protocol}://${host}:${port}${path}${key}/${method}`);
        // TODO: Why timestamp, why random?
        url.searchParams.set("ts", `${Date.now()}${Math.random()}`);
        url.searchParams.set("version", $59c7ca8d46bbf378$var$$f5f881ec4575f1fc$exports.version);
        return fetch(url.href, {
            referrerPolicy: this._options.referrerPolicy
        });
    }
    /** Get a unique ID from the server via XHR and initialize with it. */ async retrieveId() {
        try {
            const response = await this._buildRequest("id");
            if (response.status !== 200) throw new Error(`Error. Status:${response.status}`);
            return response.text();
        } catch (error) {
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.error("Error retrieving ID", error);
            let pathError = "";
            if (this._options.path === "/" && this._options.host !== $59c7ca8d46bbf378$export$7debb50ef11d5e0b.CLOUD_HOST) pathError = " If you passed in a `path` to your self-hosted PeerServer, you'll also need to pass in that same path when creating a new Peer.";
            throw new Error("Could not get an ID from the server." + pathError);
        }
    }
    /** @deprecated */ async listAllPeers() {
        try {
            const response = await this._buildRequest("peers");
            if (response.status !== 200) {
                if (response.status === 401) {
                    let helpfulError = "";
                    if (this._options.host === $59c7ca8d46bbf378$export$7debb50ef11d5e0b.CLOUD_HOST) helpfulError = "It looks like you're using the cloud server. You can email team@peerjs.com to enable peer listing for your API key.";
                    else helpfulError = "You need to enable `allow_discovery` on your self-hosted PeerServer to use this feature.";
                    throw new Error("It doesn't look like you have permission to list peers IDs. " + helpfulError);
                }
                throw new Error(`Error. Status:${response.status}`);
            }
            return response.json();
        } catch (error) {
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.error("Error retrieving list peers", error);
            throw new Error("Could not get list peers from the server." + error);
        }
    }
}
class $59c7ca8d46bbf378$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9 extends $59c7ca8d46bbf378$var$$5045192fc6d387ba$export$23a2a68283c24d80 {
    static #_ = this.ID_PREFIX = "dc_";
    static #_1 = this.MAX_BUFFERED_AMOUNT = 8388608;
    get type() {
        return $59c7ca8d46bbf378$export$3157d57b4135e3bc.Data;
    }
    constructor(peerId, provider, options){
        super(peerId, provider, options);
        this.connectionId = this.options.connectionId || $59c7ca8d46bbf378$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9.ID_PREFIX + $59c7ca8d46bbf378$var$$0e5fd1585784c252$export$4e61f672936bec77();
        this.label = this.options.label || this.connectionId;
        this.reliable = !!this.options.reliable;
        this._negotiator = new $59c7ca8d46bbf378$var$$b82fb8fc0514bfc1$export$89e6bb5ad64bf4a(this);
        this._negotiator.startConnection(this.options._payload || {
            originator: true,
            reliable: this.reliable
        });
    }
    /** Called by the Negotiator when the DataChannel is ready. */ _initializeDataChannel(dc) {
        this.dataChannel = dc;
        this.dataChannel.onopen = ()=>{
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} dc connection success`);
            this._open = true;
            this.emit("open");
        };
        this.dataChannel.onmessage = (e)=>{
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} dc onmessage:`, e.data);
        // this._handleDataMessage(e);
        };
        this.dataChannel.onclose = ()=>{
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} dc closed for:`, this.peer);
            this.close();
        };
    }
    /**
	 * Exposed functionality for users.
	 */ /** Allows user to close connection. */ close(options) {
        if (options?.flush) {
            this.send({
                __peerData: {
                    type: "close"
                }
            });
            return;
        }
        if (this._negotiator) {
            this._negotiator.cleanup();
            this._negotiator = null;
        }
        if (this.provider) {
            this.provider._removeConnection(this);
            this.provider = null;
        }
        if (this.dataChannel) {
            this.dataChannel.onopen = null;
            this.dataChannel.onmessage = null;
            this.dataChannel.onclose = null;
            this.dataChannel = null;
        }
        if (!this.open) return;
        this._open = false;
        super.emit("close");
    }
    /** Allows user to send data. */ send(data, chunked = false) {
        if (!this.open) {
            this.emitError($59c7ca8d46bbf378$export$49ae800c114df41d.NotOpenYet, "Connection is not open. You should listen for the `open` event before sending messages.");
            return;
        }
        return this._send(data, chunked);
    }
    async handleMessage(message) {
        const payload = message.payload;
        switch(message.type){
            case $59c7ca8d46bbf378$export$adb4a1754da6f10d.Answer:
                await this._negotiator.handleSDP(message.type, payload.sdp);
                break;
            case $59c7ca8d46bbf378$export$adb4a1754da6f10d.Candidate:
                await this._negotiator.handleCandidate(payload.candidate);
                break;
            default:
                $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.warn("Unrecognized message type:", message.type, "from peer:", this.peer);
                break;
        }
    }
}
class $59c7ca8d46bbf378$export$ff7c9d4c11d94e8b extends $59c7ca8d46bbf378$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9 {
    get bufferSize() {
        return this._bufferSize;
    }
    _initializeDataChannel(dc) {
        super._initializeDataChannel(dc);
        this.dataChannel.binaryType = "arraybuffer";
        this.dataChannel.addEventListener("message", (e)=>this._handleDataMessage(e));
    }
    _bufferedSend(msg) {
        if (this._buffering || !this._trySend(msg)) {
            this._buffer.push(msg);
            this._bufferSize = this._buffer.length;
        }
    }
    // Returns true if the send succeeds.
    _trySend(msg) {
        if (!this.open) return false;
        if (this.dataChannel.bufferedAmount > $59c7ca8d46bbf378$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9.MAX_BUFFERED_AMOUNT) {
            this._buffering = true;
            setTimeout(()=>{
                this._buffering = false;
                this._tryBuffer();
            }, 50);
            return false;
        }
        try {
            this.dataChannel.send(msg);
        } catch (e) {
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.error(`DC#:${this.connectionId} Error when sending:`, e);
            this._buffering = true;
            this.close();
            return false;
        }
        return true;
    }
    // Try to send the first message in the buffer.
    _tryBuffer() {
        if (!this.open) return;
        if (this._buffer.length === 0) return;
        const msg = this._buffer[0];
        if (this._trySend(msg)) {
            this._buffer.shift();
            this._bufferSize = this._buffer.length;
            this._tryBuffer();
        }
    }
    close(options) {
        if (options?.flush) {
            this.send({
                __peerData: {
                    type: "close"
                }
            });
            return;
        }
        this._buffer = [];
        this._bufferSize = 0;
        super.close();
    }
    constructor(...args){
        super(...args);
        this._buffer = [];
        this._bufferSize = 0;
        this._buffering = false;
    }
}
class $59c7ca8d46bbf378$var$$9fcfddb3ae148f88$export$f0a5a64d5bb37108 extends $59c7ca8d46bbf378$export$ff7c9d4c11d94e8b {
    close(options) {
        super.close(options);
        this._chunkedData = {};
    }
    constructor(peerId, provider, options){
        super(peerId, provider, options);
        this.chunker = new $59c7ca8d46bbf378$var$$fcbcc7538a6776d5$export$f1c5f4c9cb95390b();
        this.serialization = $59c7ca8d46bbf378$export$89f507cf986a947.Binary;
        this._chunkedData = {};
    }
    // Handles a DataChannel message.
    _handleDataMessage({ data: data }) {
        const deserializedData = (0, $d47cae9fb86d08e6$export$417857010dc9287f)(data);
        // PeerJS specific message
        const peerData = deserializedData["__peerData"];
        if (peerData) {
            if (peerData.type === "close") {
                this.close();
                return;
            }
            // Chunked data -- piece things back together.
            // @ts-ignore
            this._handleChunk(deserializedData);
            return;
        }
        this.emit("data", deserializedData);
    }
    _handleChunk(data) {
        const id = data.__peerData;
        const chunkInfo = this._chunkedData[id] || {
            data: [],
            count: 0,
            total: data.total
        };
        chunkInfo.data[data.n] = new Uint8Array(data.data);
        chunkInfo.count++;
        this._chunkedData[id] = chunkInfo;
        if (chunkInfo.total === chunkInfo.count) {
            // Clean up before making the recursive call to `_handleDataMessage`.
            delete this._chunkedData[id];
            // We've received all the chunks--time to construct the complete data.
            // const data = new Blob(chunkInfo.data);
            const data = $59c7ca8d46bbf378$var$$fcbcc7538a6776d5$export$52c89ebcdc4f53f2(chunkInfo.data);
            this._handleDataMessage({
                data: data
            });
        }
    }
    _send(data, chunked) {
        const blob = (0, $d47cae9fb86d08e6$export$2a703dbb0cb35339)(data);
        if (blob instanceof Promise) return this._send_blob(blob);
        if (!chunked && blob.byteLength > this.chunker.chunkedMTU) {
            this._sendChunks(blob);
            return;
        }
        this._bufferedSend(blob);
    }
    async _send_blob(blobPromise) {
        const blob = await blobPromise;
        if (blob.byteLength > this.chunker.chunkedMTU) {
            this._sendChunks(blob);
            return;
        }
        this._bufferedSend(blob);
    }
    _sendChunks(blob) {
        const blobs = this.chunker.chunk(blob);
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} Try to send ${blobs.length} chunks...`);
        for (const blob of blobs)this.send(blob, true);
    }
}
class $59c7ca8d46bbf378$var$$bbaee3f15f714663$export$6f88fe47d32c9c94 extends $59c7ca8d46bbf378$export$ff7c9d4c11d94e8b {
    _handleDataMessage({ data: data }) {
        super.emit("data", data);
    }
    _send(data, _chunked) {
        this._bufferedSend(data);
    }
    constructor(...args){
        super(...args);
        this.serialization = $59c7ca8d46bbf378$export$89f507cf986a947.None;
    }
}
class $59c7ca8d46bbf378$var$$817f931e3f9096cf$export$48880ac635f47186 extends $59c7ca8d46bbf378$export$ff7c9d4c11d94e8b {
    // Handles a DataChannel message.
    _handleDataMessage({ data: data }) {
        const deserializedData = this.parse(this.decoder.decode(data));
        // PeerJS specific message
        const peerData = deserializedData["__peerData"];
        if (peerData && peerData.type === "close") {
            this.close();
            return;
        }
        this.emit("data", deserializedData);
    }
    _send(data, _chunked) {
        const encodedData = this.encoder.encode(this.stringify(data));
        if (encodedData.byteLength >= $59c7ca8d46bbf378$export$7debb50ef11d5e0b.chunkedMTU) {
            this.emitError($59c7ca8d46bbf378$export$49ae800c114df41d.MessageToBig, "Message too big for JSON channel");
            return;
        }
        this._bufferedSend(encodedData);
    }
    constructor(...args){
        super(...args);
        this.serialization = $59c7ca8d46bbf378$export$89f507cf986a947.JSON;
        this.encoder = new TextEncoder();
        this.decoder = new TextDecoder();
        this.stringify = JSON.stringify;
        this.parse = JSON.parse;
    }
}
class $59c7ca8d46bbf378$var$$416260bce337df90$var$PeerOptions {
}
class $59c7ca8d46bbf378$export$ecd1fc136c422448 extends $59c7ca8d46bbf378$var$$23779d1881157a18$export$6a678e589c8a4542 {
    static #_ = this.DEFAULT_KEY = "peerjs";
    /**
	 * The brokering ID of this peer
	 *
	 * If no ID was specified in {@apilink Peer | the constructor},
	 * this will be `undefined` until the {@apilink PeerEvents | `open`} event is emitted.
	 */ get id() {
        return this._id;
    }
    get options() {
        return this._options;
    }
    get open() {
        return this._open;
    }
    /**
	 * @internal
	 */ get socket() {
        return this._socket;
    }
    /**
	 * A hash of all connections associated with this peer, keyed by the remote peer's ID.
	 * @deprecated
	 * Return type will change from Object to Map<string,[]>
	 */ get connections() {
        const plainConnections = Object.create(null);
        for (const [k, v] of this._connections)plainConnections[k] = v;
        return plainConnections;
    }
    /**
	 * true if this peer and all of its connections can no longer be used.
	 */ get destroyed() {
        return this._destroyed;
    }
    /**
	 * false if there is an active connection to the PeerServer.
	 */ get disconnected() {
        return this._disconnected;
    }
    constructor(id, options){
        super();
        this._serializers = {
            raw: $59c7ca8d46bbf378$var$$bbaee3f15f714663$export$6f88fe47d32c9c94,
            json: $59c7ca8d46bbf378$var$$817f931e3f9096cf$export$48880ac635f47186,
            binary: $59c7ca8d46bbf378$var$$9fcfddb3ae148f88$export$f0a5a64d5bb37108,
            "binary-utf8": $59c7ca8d46bbf378$var$$9fcfddb3ae148f88$export$f0a5a64d5bb37108,
            default: $59c7ca8d46bbf378$var$$9fcfddb3ae148f88$export$f0a5a64d5bb37108
        };
        this._id = null;
        this._lastServerId = null;
        // States.
        this._destroyed = false // Connections have been killed
        ;
        this._disconnected = false // Connection to PeerServer killed but P2P connections still active
        ;
        this._open = false // Sockets and such are not yet open.
        ;
        this._connections = new Map() // All connections for this peer.
        ;
        this._lostMessages = new Map() // src => [list of messages]
        ;
        let userId;
        // Deal with overloading
        if (id && id.constructor == Object) options = id;
        else if (id) userId = id.toString();
        // Configurize options
        options = {
            debug: 0,
            host: $59c7ca8d46bbf378$export$7debb50ef11d5e0b.CLOUD_HOST,
            port: $59c7ca8d46bbf378$export$7debb50ef11d5e0b.CLOUD_PORT,
            path: "/",
            key: $59c7ca8d46bbf378$export$ecd1fc136c422448.DEFAULT_KEY,
            token: $59c7ca8d46bbf378$export$7debb50ef11d5e0b.randomToken(),
            config: $59c7ca8d46bbf378$export$7debb50ef11d5e0b.defaultConfig,
            referrerPolicy: "strict-origin-when-cross-origin",
            serializers: {},
            ...options
        };
        this._options = options;
        this._serializers = {
            ...this._serializers,
            ...this.options.serializers
        };
        // Detect relative URL host.
        if (this._options.host === "/") this._options.host = window.location.hostname;
        // Set path correctly.
        if (this._options.path) {
            if (this._options.path[0] !== "/") this._options.path = "/" + this._options.path;
            if (this._options.path[this._options.path.length - 1] !== "/") this._options.path += "/";
        }
        // Set whether we use SSL to same as current host
        if (this._options.secure === undefined && this._options.host !== $59c7ca8d46bbf378$export$7debb50ef11d5e0b.CLOUD_HOST) this._options.secure = $59c7ca8d46bbf378$export$7debb50ef11d5e0b.isSecure();
        else if (this._options.host == $59c7ca8d46bbf378$export$7debb50ef11d5e0b.CLOUD_HOST) this._options.secure = true;
        // Set a custom log function if present
        if (this._options.logFunction) $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.setLogFunction(this._options.logFunction);
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.logLevel = this._options.debug || 0;
        this._api = new $59c7ca8d46bbf378$var$$abf266641927cd89$export$2c4e825dc9120f87(options);
        this._socket = this._createServerConnection();
        // Sanity checks
        // Ensure WebRTC supported
        if (!$59c7ca8d46bbf378$export$7debb50ef11d5e0b.supports.audioVideo && !$59c7ca8d46bbf378$export$7debb50ef11d5e0b.supports.data) {
            this._delayedAbort($59c7ca8d46bbf378$export$9547aaa2e39030ff.BrowserIncompatible, "The current browser does not support WebRTC");
            return;
        }
        // Ensure alphanumeric id
        if (!!userId && !$59c7ca8d46bbf378$export$7debb50ef11d5e0b.validateId(userId)) {
            this._delayedAbort($59c7ca8d46bbf378$export$9547aaa2e39030ff.InvalidID, `ID "${userId}" is invalid`);
            return;
        }
        if (userId) this._initialize(userId);
        else this._api.retrieveId().then((id)=>this._initialize(id)).catch((error)=>this._abort($59c7ca8d46bbf378$export$9547aaa2e39030ff.ServerError, error));
    }
    _createServerConnection() {
        const socket = new $59c7ca8d46bbf378$var$$8f5bfa60836d261d$export$4798917dbf149b79(this._options.secure, this._options.host, this._options.port, this._options.path, this._options.key, this._options.pingInterval);
        socket.on($59c7ca8d46bbf378$export$3b5c4a4b6354f023.Message, (data)=>{
            this._handleMessage(data);
        });
        socket.on($59c7ca8d46bbf378$export$3b5c4a4b6354f023.Error, (error)=>{
            this._abort($59c7ca8d46bbf378$export$9547aaa2e39030ff.SocketError, error);
        });
        socket.on($59c7ca8d46bbf378$export$3b5c4a4b6354f023.Disconnected, ()=>{
            if (this.disconnected) return;
            this.emitError($59c7ca8d46bbf378$export$9547aaa2e39030ff.Network, "Lost connection to server.");
            this.disconnect();
        });
        socket.on($59c7ca8d46bbf378$export$3b5c4a4b6354f023.Close, ()=>{
            if (this.disconnected) return;
            this._abort($59c7ca8d46bbf378$export$9547aaa2e39030ff.SocketClosed, "Underlying socket is already closed.");
        });
        return socket;
    }
    /** Initialize a connection with the server. */ _initialize(id) {
        this._id = id;
        this.socket.start(id, this._options.token);
    }
    /** Handles messages from the server. */ _handleMessage(message) {
        const type = message.type;
        const payload = message.payload;
        const peerId = message.src;
        switch(type){
            case $59c7ca8d46bbf378$export$adb4a1754da6f10d.Open:
                this._lastServerId = this.id;
                this._open = true;
                this.emit("open", this.id);
                break;
            case $59c7ca8d46bbf378$export$adb4a1754da6f10d.Error:
                this._abort($59c7ca8d46bbf378$export$9547aaa2e39030ff.ServerError, payload.msg);
                break;
            case $59c7ca8d46bbf378$export$adb4a1754da6f10d.IdTaken:
                this._abort($59c7ca8d46bbf378$export$9547aaa2e39030ff.UnavailableID, `ID "${this.id}" is taken`);
                break;
            case $59c7ca8d46bbf378$export$adb4a1754da6f10d.InvalidKey:
                this._abort($59c7ca8d46bbf378$export$9547aaa2e39030ff.InvalidKey, `API KEY "${this._options.key}" is invalid`);
                break;
            case $59c7ca8d46bbf378$export$adb4a1754da6f10d.Leave:
                $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Received leave message from ${peerId}`);
                this._cleanupPeer(peerId);
                this._connections.delete(peerId);
                break;
            case $59c7ca8d46bbf378$export$adb4a1754da6f10d.Expire:
                this.emitError($59c7ca8d46bbf378$export$9547aaa2e39030ff.PeerUnavailable, `Could not connect to peer ${peerId}`);
                break;
            case $59c7ca8d46bbf378$export$adb4a1754da6f10d.Offer:
                {
                    // we should consider switching this to CALL/CONNECT, but this is the least breaking option.
                    const connectionId = payload.connectionId;
                    let connection = this.getConnection(peerId, connectionId);
                    if (connection) {
                        connection.close();
                        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.warn(`Offer received for existing Connection ID:${connectionId}`);
                    }
                    // Create a new connection.
                    if (payload.type === $59c7ca8d46bbf378$export$3157d57b4135e3bc.Media) {
                        const mediaConnection = new $59c7ca8d46bbf378$var$$5c1d08c7c57da9a3$export$4a84e95a2324ac29(peerId, this, {
                            connectionId: connectionId,
                            _payload: payload,
                            metadata: payload.metadata
                        });
                        connection = mediaConnection;
                        this._addConnection(peerId, connection);
                        this.emit("call", mediaConnection);
                    } else if (payload.type === $59c7ca8d46bbf378$export$3157d57b4135e3bc.Data) {
                        const dataConnection = new this._serializers[payload.serialization](peerId, this, {
                            connectionId: connectionId,
                            _payload: payload,
                            metadata: payload.metadata,
                            label: payload.label,
                            serialization: payload.serialization,
                            reliable: payload.reliable
                        });
                        connection = dataConnection;
                        this._addConnection(peerId, connection);
                        this.emit("connection", dataConnection);
                    } else {
                        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.warn(`Received malformed connection type:${payload.type}`);
                        return;
                    }
                    // Find messages.
                    const messages = this._getMessages(connectionId);
                    for (const message of messages)connection.handleMessage(message);
                    break;
                }
            default:
                {
                    if (!payload) {
                        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.warn(`You received a malformed message from ${peerId} of type ${type}`);
                        return;
                    }
                    const connectionId = payload.connectionId;
                    const connection = this.getConnection(peerId, connectionId);
                    if (connection && connection.peerConnection) connection.handleMessage(message);
                    else if (connectionId) this._storeMessage(connectionId, message);
                    else $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.warn("You received an unrecognized message:", message);
                    break;
                }
        }
    }
    /** Stores messages without a set up connection, to be claimed later. */ _storeMessage(connectionId, message) {
        if (!this._lostMessages.has(connectionId)) this._lostMessages.set(connectionId, []);
        this._lostMessages.get(connectionId).push(message);
    }
    /**
	 * Retrieve messages from lost message store
	 * @internal
	 */ //TODO Change it to private
    _getMessages(connectionId) {
        const messages = this._lostMessages.get(connectionId);
        if (messages) {
            this._lostMessages.delete(connectionId);
            return messages;
        }
        return [];
    }
    /**
	 * Connects to the remote peer specified by id and returns a data connection.
	 * @param peer The brokering ID of the remote peer (their {@apilink Peer.id}).
	 * @param options for specifying details about Peer Connection
	 */ connect(peer, options = {}) {
        options = {
            serialization: "default",
            ...options
        };
        if (this.disconnected) {
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.warn("You cannot connect to a new Peer because you called .disconnect() on this Peer and ended your connection with the server. You can create a new Peer to reconnect, or call reconnect on this peer if you believe its ID to still be available.");
            this.emitError($59c7ca8d46bbf378$export$9547aaa2e39030ff.Disconnected, "Cannot connect to new Peer after disconnecting from server.");
            return;
        }
        const dataConnection = new this._serializers[options.serialization](peer, this, options);
        this._addConnection(peer, dataConnection);
        return dataConnection;
    }
    /**
	 * Calls the remote peer specified by id and returns a media connection.
	 * @param peer The brokering ID of the remote peer (their peer.id).
	 * @param stream The caller's media stream
	 * @param options Metadata associated with the connection, passed in by whoever initiated the connection.
	 */ call(peer, stream, options = {}) {
        if (this.disconnected) {
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.warn("You cannot connect to a new Peer because you called .disconnect() on this Peer and ended your connection with the server. You can create a new Peer to reconnect.");
            this.emitError($59c7ca8d46bbf378$export$9547aaa2e39030ff.Disconnected, "Cannot connect to new Peer after disconnecting from server.");
            return;
        }
        if (!stream) {
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.error("To call a peer, you must provide a stream from your browser's `getUserMedia`.");
            return;
        }
        const mediaConnection = new $59c7ca8d46bbf378$var$$5c1d08c7c57da9a3$export$4a84e95a2324ac29(peer, this, {
            ...options,
            _stream: stream
        });
        this._addConnection(peer, mediaConnection);
        return mediaConnection;
    }
    /** Add a data/media connection to this peer. */ _addConnection(peerId, connection) {
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`add connection ${connection.type}:${connection.connectionId} to peerId:${peerId}`);
        if (!this._connections.has(peerId)) this._connections.set(peerId, []);
        this._connections.get(peerId).push(connection);
    }
    //TODO should be private
    _removeConnection(connection) {
        const connections = this._connections.get(connection.peer);
        if (connections) {
            const index = connections.indexOf(connection);
            if (index !== -1) connections.splice(index, 1);
        }
        //remove from lost messages
        this._lostMessages.delete(connection.connectionId);
    }
    /** Retrieve a data/media connection for this peer. */ getConnection(peerId, connectionId) {
        const connections = this._connections.get(peerId);
        if (!connections) return null;
        for (const connection of connections){
            if (connection.connectionId === connectionId) return connection;
        }
        return null;
    }
    _delayedAbort(type, message) {
        setTimeout(()=>{
            this._abort(type, message);
        }, 0);
    }
    /**
	 * Emits an error message and destroys the Peer.
	 * The Peer is not destroyed if it's in a disconnected state, in which case
	 * it retains its disconnected state and its existing connections.
	 */ _abort(type, message) {
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.error("Aborting!");
        this.emitError(type, message);
        if (!this._lastServerId) this.destroy();
        else this.disconnect();
    }
    /**
	 * Destroys the Peer: closes all active connections as well as the connection
	 * to the server.
	 *
	 * :::caution
	 * This cannot be undone; the respective peer object will no longer be able
	 * to create or receive any connections, its ID will be forfeited on the server,
	 * and all of its data and media connections will be closed.
	 * :::
	 */ destroy() {
        if (this.destroyed) return;
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Destroy peer with ID:${this.id}`);
        this.disconnect();
        this._cleanup();
        this._destroyed = true;
        this.emit("close");
    }
    /** Disconnects every connection on this peer. */ _cleanup() {
        for (const peerId of this._connections.keys()){
            this._cleanupPeer(peerId);
            this._connections.delete(peerId);
        }
        this.socket.removeAllListeners();
    }
    /** Closes all connections to this peer. */ _cleanupPeer(peerId) {
        const connections = this._connections.get(peerId);
        if (!connections) return;
        for (const connection of connections)connection.close();
    }
    /**
	 * Disconnects the Peer's connection to the PeerServer. Does not close any
	 *  active connections.
	 * Warning: The peer can no longer create or accept connections after being
	 *  disconnected. It also cannot reconnect to the server.
	 */ disconnect() {
        if (this.disconnected) return;
        const currentId = this.id;
        $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Disconnect peer with ID:${currentId}`);
        this._disconnected = true;
        this._open = false;
        this.socket.close();
        this._lastServerId = currentId;
        this._id = null;
        this.emit("disconnected", currentId);
    }
    /** Attempts to reconnect with the same ID.
	 *
	 * Only {@apilink Peer.disconnect | disconnected peers} can be reconnected.
	 * Destroyed peers cannot be reconnected.
	 * If the connection fails (as an example, if the peer's old ID is now taken),
	 * the peer's existing connections will not close, but any associated errors events will fire.
	 */ reconnect() {
        if (this.disconnected && !this.destroyed) {
            $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Attempting reconnection to server with ID ${this._lastServerId}`);
            this._disconnected = false;
            this._initialize(this._lastServerId);
        } else if (this.destroyed) throw new Error("This peer cannot reconnect to the server. It has already been destroyed.");
        else if (!this.disconnected && !this.open) $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.error("In a hurry? We're still trying to make the initial connection!");
        else throw new Error(`Peer ${this.id} cannot reconnect because it is not disconnected from the server!`);
    }
    /**
	 * Get a list of available peer IDs. If you're running your own server, you'll
	 * want to set allow_discovery: true in the PeerServer options. If you're using
	 * the cloud server, email team@peerjs.com to get the functionality enabled for
	 * your key.
	 */ listAllPeers(cb = (_)=>{}) {
        this._api.listAllPeers().then((peers)=>cb(peers)).catch((error)=>this._abort($59c7ca8d46bbf378$export$9547aaa2e39030ff.ServerError, error));
    }
}
class $59c7ca8d46bbf378$export$72aa44612e2200cd extends $59c7ca8d46bbf378$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9 {
    constructor(peerId, provider, options){
        super(peerId, provider, {
            ...options,
            reliable: true
        });
        this._CHUNK_SIZE = 32768;
        this._splitStream = new TransformStream({
            transform: (chunk, controller)=>{
                for(let split = 0; split < chunk.length; split += this._CHUNK_SIZE)controller.enqueue(chunk.subarray(split, split + this._CHUNK_SIZE));
            }
        });
        this._rawSendStream = new WritableStream({
            write: async (chunk, controller)=>{
                const openEvent = new Promise((resolve)=>this.dataChannel.addEventListener("bufferedamountlow", resolve, {
                        once: true
                    }));
                // if we can send the chunk now, send it
                // if not, we wait until at least half of the sending buffer is free again
                await (this.dataChannel.bufferedAmount <= $59c7ca8d46bbf378$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9.MAX_BUFFERED_AMOUNT - chunk.byteLength || openEvent);
                // TODO: what can go wrong here?
                try {
                    this.dataChannel.send(chunk);
                } catch (e) {
                    $59c7ca8d46bbf378$var$$257947e92926277a$export$2e2bcd8739ae039.error(`DC#:${this.connectionId} Error when sending:`, e);
                    controller.error(e);
                    this.close();
                }
            }
        });
        this.writer = this._splitStream.writable.getWriter();
        this._rawReadStream = new ReadableStream({
            start: (controller)=>{
                this.once("open", ()=>{
                    this.dataChannel.addEventListener("message", (e)=>{
                        controller.enqueue(e.data);
                    });
                });
            }
        });
        this._splitStream.readable.pipeTo(this._rawSendStream);
    }
    _initializeDataChannel(dc) {
        super._initializeDataChannel(dc);
        this.dataChannel.binaryType = "arraybuffer";
        this.dataChannel.bufferedAmountLowThreshold = $59c7ca8d46bbf378$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9.MAX_BUFFERED_AMOUNT / 2;
    }
}
const $59c7ca8d46bbf378$var$$dcf98445f54823f4$var$NullValue = Symbol.for(null);
function $59c7ca8d46bbf378$var$$dcf98445f54823f4$var$concatUint8Array(buffer1, buffer2) {
    const tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
    tmp.set(buffer1, 0);
    tmp.set(buffer2, buffer1.byteLength);
    return new Uint8Array(tmp.buffer);
}
const $59c7ca8d46bbf378$var$$dcf98445f54823f4$var$iterateOver = async function*(stream) {
    const reader = stream.getReader();
    try {
        while(true){
            const { done: done, value: value } = await reader.read();
            if (done) return;
            yield value;
        }
    } finally{
        reader.releaseLock();
    }
};
class $59c7ca8d46bbf378$export$7e9583c3c8a0a2cc extends $59c7ca8d46bbf378$export$72aa44612e2200cd {
    constructor(peerId, provider, options){
        super(peerId, provider, {
            ...options,
            reliable: true
        });
        this.serialization = "Cbor";
        this._encoder = new (0, $83cca8f38d19f682$export$a50aceb0e02a00aa)();
        this._decoder = new (0, $4c3270599345206f$export$f9de6ca0bc043724)();
        this._decoderStream = new TransformStream({
            transform: (abchunk, controller)=>{
                let chunk = new Uint8Array(abchunk);
                if (this._inc) {
                    chunk = $59c7ca8d46bbf378$var$$dcf98445f54823f4$var$concatUint8Array(this._inc, chunk);
                    this._inc = null;
                }
                let values;
                try {
                    values = this._decoder.decodeMultiple(chunk);
                } catch (error) {
                    if (error.incomplete) {
                        this._inc = chunk.subarray(error.lastPosition);
                        values = error.values;
                    } else throw error;
                } finally{
                    for (let value of values || []){
                        if (value === null) value = $59c7ca8d46bbf378$var$$dcf98445f54823f4$var$NullValue;
                        controller.enqueue(value);
                    }
                }
            }
        });
        this._rawReadStream.pipeTo(this._decoderStream.writable);
        (async ()=>{
            for await (const msg of $59c7ca8d46bbf378$var$$dcf98445f54823f4$var$iterateOver(this._decoderStream.readable)){
                if (msg.__peerData?.type === "close") {
                    this.close();
                    return;
                }
                this.emit("data", msg);
            }
        })();
    }
    _send(data) {
        return this.writer.write(this._encoder.encode(data));
    }
}
class $59c7ca8d46bbf378$export$f6a74c7ffa2903e6 extends $59c7ca8d46bbf378$export$ecd1fc136c422448 {
    constructor(...args){
        super(...args);
        this._serializers = {
            Cbor: $59c7ca8d46bbf378$export$7e9583c3c8a0a2cc,
            default: $59c7ca8d46bbf378$export$7e9583c3c8a0a2cc
        };
    }
}
class $59c7ca8d46bbf378$export$80f5de1a66c4d624 extends $59c7ca8d46bbf378$export$72aa44612e2200cd {
    constructor(peerId, provider, options){
        super(peerId, provider, options);
        this.serialization = "MsgPack";
        this._encoder = new (0, $fbca2e5b74897fc2$export$a50aceb0e02a00aa)();
        (async ()=>{
            for await (const msg of (0, $803b493dc42be9fd$export$bf87d8a088c760fb)(this._rawReadStream)){
                // @ts-ignore
                if (msg.__peerData?.type === "close") {
                    this.close();
                    return;
                }
                this.emit("data", msg);
            }
        })();
    }
    _send(data) {
        return this.writer.write(this._encoder.encode(data));
    }
}
class $59c7ca8d46bbf378$export$d72c7bf8eef50853 extends $59c7ca8d46bbf378$export$ecd1fc136c422448 {
    constructor(...args){
        super(...args);
        this._serializers = {
            MsgPack: $59c7ca8d46bbf378$export$80f5de1a66c4d624,
            default: $59c7ca8d46bbf378$export$80f5de1a66c4d624
        };
    }
}
var $59c7ca8d46bbf378$export$2e2bcd8739ae039 = $59c7ca8d46bbf378$export$ecd1fc136c422448;


class $455fa7c8daf8d6b7$export$c53a55e8a0b56c58 {
    constructor(userId){
        this.userId = userId;
        this.members = [];
        this.unloadListener = ()=>this.destroy();
        this.listeners = [];
        this.peer = new (0, $59c7ca8d46bbf378$export$ecd1fc136c422448)(userId, {
            host: "takeseats.ru",
            port: 9000,
            path: "/takeseats",
            secure: false,
            config: {
                iceServers: [
                    {
                        url: "stun:stun.l.google.com:19302"
                    }
                ]
            }
        });
        this.peer.on("error", (err)=>{
            console.error(`${err.name}: ${err.message} [${err.type}]`);
        });
        this.peer.on("connection", (member)=>this.addDataConnectionEventHandlers(member, true));
        window.addEventListener("unload", this.unloadListener);
    }
    emit(address, data) {
        this.listeners.forEach((listener)=>listener(address, data));
    }
    addDataConnectionEventHandlers(dc, incoming = false) {
        dc.on("open", ()=>{
            this.members.push(dc);
            dc.send({
                type: "members-list",
                message: this.members.map((m)=>m.peer).filter((p)=>p !== dc.peer)
            });
            console.log("sending members", this.members);
            dc.on("iceStateChanged", (state)=>{
                if (state === "disconnected") {
                    if (incoming) {
                        const backConnection = this.peer.connect(dc.peer);
                        this.addDataConnectionEventHandlers(backConnection);
                    }
                    dc.close();
                }
            });
            this.emit(dc.peer, {
                type: "announce",
                message: dc.peer
            });
        });
        dc.on("close", ()=>{
            this.members = this.members.filter((m)=>m !== dc);
            this.emit(dc.peer, {
                type: "player-disconnected",
                message: null
            });
        });
        dc.on("data", (data)=>{
            if (data.type === "members-list") {
                console.log("received members", data.message);
                data.message.forEach((peer)=>{
                    if (!this.members.some((m)=>m.peer === peer)) {
                        const dc = this.peer.connect(peer);
                        this.addDataConnectionEventHandlers(dc);
                    }
                });
                return;
            }
            this.emit(dc.peer, data);
        });
        dc.on("error", ()=>{
            console.log("error");
        });
    }
    connectToMember(userId) {
        this.peer.once("open", ()=>{
            const dc = this.peer.connect(userId);
            this.addDataConnectionEventHandlers(dc);
        });
    }
    destroy() {
        this.peer.destroy();
        window.removeEventListener("unload", this.unloadListener);
    }
    address() {
        return this.userId;
    }
    on(event, listener) {
        this.listeners.push(listener);
    }
    send(arg, chunked) {
        this.listeners.forEach((l)=>l(this.userId, arg));
        this.members.forEach((m)=>m.send(arg, chunked));
    }
    sendTo(to, arg, chunked) {
        const peer = this.members.find((m)=>m.peer === to);
        if (peer) peer.send(arg, chunked);
    }
}


class $5aa23f633f590d4c$export$9b781de7bf37bf48 {
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
    rotate(angleRadians) {
        const newX = Math.cos(angleRadians) * this.x - Math.sin(angleRadians) * this.y;
        const newY = Math.sin(angleRadians) * this.x + Math.cos(angleRadians) * this.y;
        this.x = newX;
        this.y = newY;
        return this;
    }
    get length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    get normalized() {
        const len = this.length;
        return new $5aa23f633f590d4c$export$9b781de7bf37bf48(this.x / len, this.y / len);
    }
    static distance(a, b) {
        return new $5aa23f633f590d4c$export$9b781de7bf37bf48(b.x - a.x, b.y - a.y).length;
    }
    copy() {
        return new $5aa23f633f590d4c$export$9b781de7bf37bf48(this.x, this.y);
    }
}


var $45fe05e25c77474d$export$9e9c3b4596bcb2e8;
(function(KeyState) {
    KeyState[KeyState["OFF"] = 0] = "OFF";
    KeyState[KeyState["HELD"] = 1] = "HELD";
    KeyState[KeyState["PRESSED"] = 2] = "PRESSED";
})($45fe05e25c77474d$export$9e9c3b4596bcb2e8 || ($45fe05e25c77474d$export$9e9c3b4596bcb2e8 = {}));
class $45fe05e25c77474d$export$2e2bcd8739ae039 {
    static get instance() {
        if ($45fe05e25c77474d$export$2e2bcd8739ae039._instance) return $45fe05e25c77474d$export$2e2bcd8739ae039._instance;
        throw new Error("Controls is not created!");
    }
    keyDown(event) {
        $45fe05e25c77474d$export$2e2bcd8739ae039.instance.keyboard.set(event.key.toLowerCase(), 1);
        event.preventDefault();
    }
    keyUp(event) {
        $45fe05e25c77474d$export$2e2bcd8739ae039.instance.keyboard.set(event.key.toLowerCase(), 2);
        event.preventDefault();
        requestAnimationFrame(()=>$45fe05e25c77474d$export$2e2bcd8739ae039.instance.keyboard.set(event.key.toLowerCase(), 0));
    }
    mouseMove(event) {
        const oldPos = $45fe05e25c77474d$export$2e2bcd8739ae039.instance.mouse.position;
        const mouseMove = $45fe05e25c77474d$export$2e2bcd8739ae039.instance.mouse.movement;
        $45fe05e25c77474d$export$2e2bcd8739ae039.instance.mouse.movement = new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)((event.offsetX - oldPos.x + mouseMove.x) / 2, (event.offsetY - oldPos.y + mouseMove.y) / 2);
        $45fe05e25c77474d$export$2e2bcd8739ae039.instance.mouse.position = new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)(event.offsetX, event.offsetY);
    }
    mouseDown(event) {
        if (event.button === 0) $45fe05e25c77474d$export$2e2bcd8739ae039.instance.mouse.pressed = true;
    }
    mouseUp(event) {
        if (event.button === 0) $45fe05e25c77474d$export$2e2bcd8739ae039.instance.mouse.pressed = false;
    }
    constructor(parent){
        this.keyboard = new Map();
        this.mouse = {
            position: new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)(0, 0),
            movement: new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)(),
            pressed: false
        };
        parent.addEventListener("keydown", this.keyDown);
        parent.addEventListener("keyup", this.keyUp);
        parent.addEventListener("mousemove", this.mouseMove);
        parent.addEventListener("mousedown", this.mouseDown);
        parent.addEventListener("mouseup", this.mouseUp);
        $45fe05e25c77474d$export$2e2bcd8739ae039._instance = this;
    }
}



var $jxXUM = parcelRequire("jxXUM");
var $j5g5m = parcelRequire("j5g5m");
var $jollT = parcelRequire("jollT");
var $8VCQS = parcelRequire("8VCQS");
var $6BsCn = parcelRequire("6BsCn");

var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");
var $ec78c175a89a0f54$export$2e2bcd8739ae039 = "in vec2 aPosition;\nout vec2 vTextureCoord;\n\nuniform vec4 uInputSize;\nuniform vec4 uOutputFrame;\nuniform vec4 uOutputTexture;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;\n    \n    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aPosition * (uOutputFrame.zw * uInputSize.zw);\n}\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n}\n";


var $69d09aa8ffdf58e2$export$2e2bcd8739ae039 = "struct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\nstruct VSOutput {\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>\n  };\n\nfn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>\n{\n    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;\n\n    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nfn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);\n}\n\nfn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);  \n}\n\nfn getSize() -> vec2<f32>\n{\n  return gfu.uGlobalFrame.zw;\n}\n  \n@vertex\nfn mainVertex(\n  @location(0) aPosition : vec2<f32>, \n) -> VSOutput {\n  return VSOutput(\n   filterVertexPosition(aPosition),\n   filterTextureCoord(aPosition)\n  );\n}";


var $4cee5c5819be807b$export$2e2bcd8739ae039 = "in vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform float uGamma;\nuniform float uContrast;\nuniform float uSaturation;\nuniform float uBrightness;\nuniform vec4 uColor;\n\nvoid main()\n{\n    vec4 c = texture(uTexture, vTextureCoord);\n\n    if (c.a > 0.0) {\n        c.rgb /= c.a;\n\n        vec3 rgb = pow(c.rgb, vec3(1. / uGamma));\n        rgb = mix(vec3(.5), mix(vec3(dot(vec3(.2125, .7154, .0721), rgb)), rgb, uSaturation), uContrast);\n        rgb.r *= uColor.r;\n        rgb.g *= uColor.g;\n        rgb.b *= uColor.b;\n        c.rgb = rgb * uBrightness;\n\n        c.rgb *= c.a;\n    }\n\n    finalColor = c * uColor.a;\n}\n";


var $4872bfe9e2d02483$export$2e2bcd8739ae039 = "struct AdjustmentUniforms {\n  uGamma: f32,\n  uContrast: f32,\n  uSaturation: f32,\n  uBrightness: f32,\n  uColor: vec4<f32>,\n};\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> adjustmentUniforms : AdjustmentUniforms;\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>,\n  @builtin(position) position: vec4<f32>\n) -> @location(0) vec4<f32> {\n  var sample = textureSample(uTexture, uSampler, uv);\n  let color = adjustmentUniforms.uColor;\n\n  if (sample.a > 0.0) \n  {\n    sample = vec4<f32>(sample.rgb / sample.a, sample.a);\n    var rgb: vec3<f32> = pow(sample.rgb, vec3<f32>(1. / adjustmentUniforms.uGamma));\n    rgb = mix(vec3<f32>(.5), mix(vec3<f32>(dot(vec3<f32>(.2125, .7154, .0721), rgb)), rgb, adjustmentUniforms.uSaturation), adjustmentUniforms.uContrast);\n    rgb.r *= color.r;\n    rgb.g *= color.g;\n    rgb.b *= color.b;\n    sample = vec4<f32>(rgb.rgb * adjustmentUniforms.uBrightness, sample.a);\n    sample = vec4<f32>(sample.rgb * sample.a, sample.a);\n  }\n\n  return sample * color.a;\n}";


var $c9158f5c3661f142$var$__defProp = Object.defineProperty;
var $c9158f5c3661f142$var$__defNormalProp = (obj, key, value)=>key in obj ? $c9158f5c3661f142$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c9158f5c3661f142$var$__publicField = (obj, key, value)=>{
    $c9158f5c3661f142$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $c9158f5c3661f142$var$_AdjustmentFilter = class _AdjustmentFilter extends (0, $ld81y.Filter) {
    /**
   * @param options - The options of the adjustment filter.
   */ constructor(options){
        options = {
            ..._AdjustmentFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $4872bfe9e2d02483$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $4cee5c5819be807b$export$2e2bcd8739ae039,
            name: "adjustment-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                adjustmentUniforms: {
                    uGamma: {
                        value: options.gamma,
                        type: "f32"
                    },
                    uContrast: {
                        value: options.contrast,
                        type: "f32"
                    },
                    uSaturation: {
                        value: options.saturation,
                        type: "f32"
                    },
                    uBrightness: {
                        value: options.brightness,
                        type: "f32"
                    },
                    uColor: {
                        value: [
                            options.red,
                            options.green,
                            options.blue,
                            options.alpha
                        ],
                        type: "vec4<f32>"
                    }
                }
            }
        });
        $c9158f5c3661f142$var$__publicField(this, "uniforms");
        this.uniforms = this.resources.adjustmentUniforms.uniforms;
    }
    /**
   * Amount of luminance
   * @default 1
   */ get gamma() {
        return this.uniforms.uGamma;
    }
    set gamma(value) {
        this.uniforms.uGamma = value;
    }
    /**
   * Amount of contrast
   * @default 1
   */ get contrast() {
        return this.uniforms.uContrast;
    }
    set contrast(value) {
        this.uniforms.uContrast = value;
    }
    /**
   * Amount of color saturation
   * @default 1
   */ get saturation() {
        return this.uniforms.uSaturation;
    }
    set saturation(value) {
        this.uniforms.uSaturation = value;
    }
    /**
   * The overall brightness
   * @default 1
   */ get brightness() {
        return this.uniforms.uBrightness;
    }
    set brightness(value) {
        this.uniforms.uBrightness = value;
    }
    /**
   * The multiplied red channel
   * @default 1
   */ get red() {
        return this.uniforms.uColor[0];
    }
    set red(value) {
        this.uniforms.uColor[0] = value;
    }
    /**
   * The multiplied blue channel
   * @default 1
   */ get green() {
        return this.uniforms.uColor[1];
    }
    set green(value) {
        this.uniforms.uColor[1] = value;
    }
    /**
   * The multiplied green channel
   * @default 1
   */ get blue() {
        return this.uniforms.uColor[2];
    }
    set blue(value) {
        this.uniforms.uColor[2] = value;
    }
    /**
   * The overall alpha channel
   * @default 1
   */ get alpha() {
        return this.uniforms.uColor[3];
    }
    set alpha(value) {
        this.uniforms.uColor[3] = value;
    }
};
/** Default values for options. */ $c9158f5c3661f142$var$__publicField($c9158f5c3661f142$var$_AdjustmentFilter, "DEFAULT_OPTIONS", {
    gamma: 1,
    contrast: 1,
    saturation: 1,
    brightness: 1,
    red: 1,
    green: 1,
    blue: 1,
    alpha: 1
});
let $c9158f5c3661f142$export$9ac29bfc5603b2cd = $c9158f5c3661f142$var$_AdjustmentFilter;



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $jollT = parcelRequire("jollT");
var $g5CeI = parcelRequire("g5CeI");
var $ld81y = parcelRequire("ld81y");



var $j0fPb = parcelRequire("j0fPb");
var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $g5CeI = parcelRequire("g5CeI");
var $ld81y = parcelRequire("ld81y");


var $64402c8c2fd2847b$export$2e2bcd8739ae039 = "\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec2 uOffset;\n\nvoid main(void)\n{\n    vec4 color = vec4(0.0);\n\n    // Sample top left pixel\n    color += texture(uTexture, vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y + uOffset.y));\n\n    // Sample top right pixel\n    color += texture(uTexture, vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y + uOffset.y));\n\n    // Sample bottom right pixel\n    color += texture(uTexture, vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y - uOffset.y));\n\n    // Sample bottom left pixel\n    color += texture(uTexture, vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y - uOffset.y));\n\n    // Average\n    color *= 0.25;\n\n    finalColor = color;\n}";


var $eddaeaf4ed3d7afc$export$2e2bcd8739ae039 = "struct KawaseBlurUniforms {\n  uOffset:vec2<f32>,\n};\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> kawaseBlurUniforms : KawaseBlurUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let uOffset = kawaseBlurUniforms.uOffset;\n  var color: vec4<f32> = vec4<f32>(0.0);\n\n  // Sample top left pixel\n  color += textureSample(uTexture, uSampler, vec2<f32>(uv.x - uOffset.x, uv.y + uOffset.y));\n  // Sample top right pixel\n  color += textureSample(uTexture, uSampler, vec2<f32>(uv.x + uOffset.x, uv.y + uOffset.y));\n  // Sample bottom right pixel\n  color += textureSample(uTexture, uSampler, vec2<f32>(uv.x + uOffset.x, uv.y - uOffset.y));\n  // Sample bottom left pixel\n  color += textureSample(uTexture, uSampler, vec2<f32>(uv.x - uOffset.x, uv.y - uOffset.y));\n  // Average\n  color *= 0.25;\n\n  return color;\n}";


var $bfab8d33e578cae6$export$2e2bcd8739ae039 = "\nprecision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec2 uOffset;\n\nuniform vec4 uInputClamp;\n\nvoid main(void)\n{\n    vec4 color = vec4(0.0);\n\n    // Sample top left pixel\n    color += texture(uTexture, clamp(vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y + uOffset.y), uInputClamp.xy, uInputClamp.zw));\n\n    // Sample top right pixel\n    color += texture(uTexture, clamp(vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y + uOffset.y), uInputClamp.xy, uInputClamp.zw));\n\n    // Sample bottom right pixel\n    color += texture(uTexture, clamp(vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y - uOffset.y), uInputClamp.xy, uInputClamp.zw));\n\n    // Sample bottom left pixel\n    color += texture(uTexture, clamp(vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y - uOffset.y), uInputClamp.xy, uInputClamp.zw));\n\n    // Average\n    color *= 0.25;\n\n    finalColor = color;\n}\n";


var $7acb7b7095424c21$export$2e2bcd8739ae039 = "struct KawaseBlurUniforms {\n  uOffset:vec2<f32>,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> kawaseBlurUniforms : KawaseBlurUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let uOffset = kawaseBlurUniforms.uOffset;\n  var color: vec4<f32> = vec4(0.0);\n\n  // Sample top left pixel\n  color += textureSample(uTexture, uSampler, clamp(vec2<f32>(uv.x - uOffset.x, uv.y + uOffset.y), gfu.uInputClamp.xy, gfu.uInputClamp.zw));\n  // Sample top right pixel\n  color += textureSample(uTexture, uSampler, clamp(vec2<f32>(uv.x + uOffset.x, uv.y + uOffset.y), gfu.uInputClamp.xy, gfu.uInputClamp.zw));\n  // Sample bottom right pixel\n  color += textureSample(uTexture, uSampler, clamp(vec2<f32>(uv.x + uOffset.x, uv.y - uOffset.y), gfu.uInputClamp.xy, gfu.uInputClamp.zw));\n  // Sample bottom left pixel\n  color += textureSample(uTexture, uSampler, clamp(vec2<f32>(uv.x - uOffset.x, uv.y - uOffset.y), gfu.uInputClamp.xy, gfu.uInputClamp.zw));\n  // Average\n  color *= 0.25;\n    \n  return color;\n}";


var $2433219b84d26ac4$var$__defProp = Object.defineProperty;
var $2433219b84d26ac4$var$__defNormalProp = (obj, key, value)=>key in obj ? $2433219b84d26ac4$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2433219b84d26ac4$var$__publicField = (obj, key, value)=>{
    $2433219b84d26ac4$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $2433219b84d26ac4$var$_KawaseBlurFilter = class _KawaseBlurFilter extends (0, $ld81y.Filter) {
    /** @ignore */ constructor(...args){
        let options = args[0] ?? {};
        if (typeof options === "number" || Array.isArray(options)) {
            (0, $j0fPb.deprecation)("6.0.0", "KawaseBlurFilter constructor params are now options object. See params: { strength, quality, clamp, pixelSize }");
            options = {
                strength: options
            };
            if (args[1] !== void 0) options.quality = args[1];
            if (args[2] !== void 0) options.clamp = args[2];
        }
        options = {
            ..._KawaseBlurFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: options?.clamp ? (0, $7acb7b7095424c21$export$2e2bcd8739ae039) : (0, $eddaeaf4ed3d7afc$export$2e2bcd8739ae039),
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: options?.clamp ? (0, $bfab8d33e578cae6$export$2e2bcd8739ae039) : (0, $64402c8c2fd2847b$export$2e2bcd8739ae039),
            name: "kawase-blur-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                kawaseBlurUniforms: {
                    uOffset: {
                        value: new Float32Array(2),
                        type: "vec2<f32>"
                    }
                }
            }
        });
        $2433219b84d26ac4$var$__publicField(this, "uniforms");
        $2433219b84d26ac4$var$__publicField(this, "_pixelSize", {
            x: 0,
            y: 0
        });
        $2433219b84d26ac4$var$__publicField(this, "_clamp");
        $2433219b84d26ac4$var$__publicField(this, "_kernels", []);
        $2433219b84d26ac4$var$__publicField(this, "_blur");
        $2433219b84d26ac4$var$__publicField(this, "_quality");
        this.uniforms = this.resources.kawaseBlurUniforms.uniforms;
        this.pixelSize = options.pixelSize ?? {
            x: 1,
            y: 1
        };
        if (Array.isArray(options.strength)) this.kernels = options.strength;
        else if (typeof options.strength === "number") {
            this._blur = options.strength;
            this.quality = options.quality ?? 3;
        }
        this._clamp = !!options.clamp;
    }
    /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */ apply(filterManager, input, output, clearMode) {
        const uvX = this.pixelSizeX / input.source.width;
        const uvY = this.pixelSizeY / input.source.height;
        let offset;
        if (this._quality === 1 || this._blur === 0) {
            offset = this._kernels[0] + 0.5;
            this.uniforms.uOffset[0] = offset * uvX;
            this.uniforms.uOffset[1] = offset * uvY;
            filterManager.applyFilter(this, input, output, clearMode);
        } else {
            const renderTarget = (0, $g5CeI.TexturePool).getSameSizeTexture(input);
            let source2 = input;
            let target = renderTarget;
            let tmp;
            const last = this._quality - 1;
            for(let i = 0; i < last; i++){
                offset = this._kernels[i] + 0.5;
                this.uniforms.uOffset[0] = offset * uvX;
                this.uniforms.uOffset[1] = offset * uvY;
                filterManager.applyFilter(this, source2, target, true);
                tmp = source2;
                source2 = target;
                target = tmp;
            }
            offset = this._kernels[last] + 0.5;
            this.uniforms.uOffset[0] = offset * uvX;
            this.uniforms.uOffset[1] = offset * uvY;
            filterManager.applyFilter(this, source2, output, clearMode);
            (0, $g5CeI.TexturePool).returnTexture(renderTarget);
        }
    }
    /**
    * The amount of blur, value greater than `0`.
    * @default 4
    */ get strength() {
        return this._blur;
    }
    set strength(value) {
        this._blur = value;
        this._generateKernels();
    }
    /**
    * The quality of the filter, integer greater than `1`.
    * @default 3
    */ get quality() {
        return this._quality;
    }
    set quality(value) {
        this._quality = Math.max(1, Math.round(value));
        this._generateKernels();
    }
    /**
    * The kernel size of the blur filter, for advanced usage
    * @default [0]
    */ get kernels() {
        return this._kernels;
    }
    set kernels(value) {
        if (Array.isArray(value) && value.length > 0) {
            this._kernels = value;
            this._quality = value.length;
            this._blur = Math.max(...value);
        } else {
            this._kernels = [
                0
            ];
            this._quality = 1;
        }
    }
    /**
    * The size of the pixels. Large size is blurrier. For advanced usage.
    * @default {x:1,y:1}
    */ get pixelSize() {
        return this._pixelSize;
    }
    set pixelSize(value) {
        if (typeof value === "number") {
            this.pixelSizeX = this.pixelSizeY = value;
            return;
        }
        if (Array.isArray(value)) {
            this.pixelSizeX = value[0];
            this.pixelSizeY = value[1];
            return;
        }
        this._pixelSize = value;
    }
    /**
    * The size of the pixels on the `x` axis. Large size is blurrier. For advanced usage.
    * @default 1
    */ get pixelSizeX() {
        return this.pixelSize.x;
    }
    set pixelSizeX(value) {
        this.pixelSize.x = value;
    }
    /**
    * The size of the pixels on the `y` axis. Large size is blurrier. For advanced usage.
    * @default 1
    */ get pixelSizeY() {
        return this.pixelSize.y;
    }
    set pixelSizeY(value) {
        this.pixelSize.y = value;
    }
    /**
    * Get the if the filter is clamped
    * @default false
    */ get clamp() {
        return this._clamp;
    }
    /** Update padding based on kernel data */ _updatePadding() {
        this.padding = Math.ceil(this._kernels.reduce((acc, v)=>acc + v + 0.5, 0));
    }
    /** Auto generate kernels by blur & quality */ _generateKernels() {
        const blur = this._blur;
        const quality = this._quality;
        const kernels = [
            blur
        ];
        if (blur > 0) {
            let k = blur;
            const step = blur / quality;
            for(let i = 1; i < quality; i++){
                k -= step;
                kernels.push(k);
            }
        }
        this._kernels = kernels;
        this._updatePadding();
    }
};
/** Default values for options. */ $2433219b84d26ac4$var$__publicField($2433219b84d26ac4$var$_KawaseBlurFilter, "DEFAULT_OPTIONS", {
    strength: 4,
    quality: 3,
    clamp: false,
    pixelSize: {
        x: 1,
        y: 1
    }
});
let $2433219b84d26ac4$export$31164edf0fb20199 = $2433219b84d26ac4$var$_KawaseBlurFilter;


var $5f8ee2ac59fa17ff$export$2e2bcd8739ae039 = "in vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform sampler2D uMapTexture;\nuniform float uBloomScale;\nuniform float uBrightness;\n\nvoid main() {\n    vec4 color = texture(uTexture, vTextureCoord);\n    color.rgb *= uBrightness;\n    vec4 bloomColor = vec4(texture(uMapTexture, vTextureCoord).rgb, 0.0);\n    bloomColor.rgb *= uBloomScale;\n    finalColor = color + bloomColor;\n}\n";


var $eb217847e34eec43$export$2e2bcd8739ae039 = "struct AdvancedBloomUniforms {\n  uBloomScale: f32,\n  uBrightness: f32,\n};\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> advancedBloomUniforms : AdvancedBloomUniforms;\n@group(1) @binding(1) var uMapTexture: texture_2d<f32>;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  var color = textureSample(uTexture, uSampler, uv);\n  color = vec4<f32>(color.rgb * advancedBloomUniforms.uBrightness, color.a);\n\n  var bloomColor = vec4<f32>(textureSample(uMapTexture, uSampler, uv).rgb, 0.0);\n  bloomColor = vec4<f32>(bloomColor.rgb * advancedBloomUniforms.uBloomScale, bloomColor.a);\n  \n  return color + bloomColor;\n}\n";



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $bfb9db68071eff37$export$2e2bcd8739ae039 = "\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform float uThreshold;\n\nvoid main() {\n    vec4 color = texture(uTexture, vTextureCoord);\n\n    // A simple & fast algorithm for getting brightness.\n    // It's inaccuracy , but good enought for this feature.\n    float _max = max(max(color.r, color.g), color.b);\n    float _min = min(min(color.r, color.g), color.b);\n    float brightness = (_max + _min) * 0.5;\n\n    if(brightness > uThreshold) {\n        finalColor = color;\n    } else {\n        finalColor = vec4(0.0, 0.0, 0.0, 0.0);\n    }\n}\n";


var $e6e052a8581ed3f1$export$2e2bcd8739ae039 = "struct ExtractBrightnessUniforms {\n  uThreshold: f32,\n};\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> extractBrightnessUniforms : ExtractBrightnessUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let color: vec4<f32> = textureSample(uTexture, uSampler, uv);\n\n  // A simple & fast algorithm for getting brightness.\n  // It's inaccurate, but good enough for this feature.\n  let max: f32 = max(max(color.r, color.g), color.b);\n  let min: f32 = min(min(color.r, color.g), color.b);\n  let brightness: f32 = (max + min) * 0.5;\n\n  return select(vec4<f32>(0.), color, brightness > extractBrightnessUniforms.uThreshold);\n}\n";


var $a25e83c6bc1d0936$var$__defProp = Object.defineProperty;
var $a25e83c6bc1d0936$var$__defNormalProp = (obj, key, value)=>key in obj ? $a25e83c6bc1d0936$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a25e83c6bc1d0936$var$__publicField = (obj, key, value)=>{
    $a25e83c6bc1d0936$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $a25e83c6bc1d0936$var$_ExtractBrightnessFilter = class _ExtractBrightnessFilter extends (0, $ld81y.Filter) {
    constructor(options){
        options = {
            ..._ExtractBrightnessFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $e6e052a8581ed3f1$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $bfb9db68071eff37$export$2e2bcd8739ae039,
            name: "extract-brightness-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                extractBrightnessUniforms: {
                    uThreshold: {
                        value: options.threshold,
                        type: "f32"
                    }
                }
            }
        });
        $a25e83c6bc1d0936$var$__publicField(this, "uniforms");
        this.uniforms = this.resources.extractBrightnessUniforms.uniforms;
    }
    /**
   * Defines how bright a color needs to be extracted.
   * @default 0.5
   */ get threshold() {
        return this.uniforms.uThreshold;
    }
    set threshold(value) {
        this.uniforms.uThreshold = value;
    }
};
/** Default values for options. */ $a25e83c6bc1d0936$var$__publicField($a25e83c6bc1d0936$var$_ExtractBrightnessFilter, "DEFAULT_OPTIONS", {
    threshold: 0.5
});
let $a25e83c6bc1d0936$export$3184aba1f05c290d = $a25e83c6bc1d0936$var$_ExtractBrightnessFilter;


var $7d58a4b9e5faa45a$var$__defProp = Object.defineProperty;
var $7d58a4b9e5faa45a$var$__defNormalProp = (obj, key, value)=>key in obj ? $7d58a4b9e5faa45a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7d58a4b9e5faa45a$var$__publicField = (obj, key, value)=>{
    $7d58a4b9e5faa45a$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $7d58a4b9e5faa45a$var$_AdvancedBloomFilter = class _AdvancedBloomFilter extends (0, $ld81y.Filter) {
    /**
   * @param options - Options for the AdvancedBloomFilter constructor.
   */ constructor(options){
        options = {
            ..._AdvancedBloomFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $eb217847e34eec43$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $5f8ee2ac59fa17ff$export$2e2bcd8739ae039,
            name: "advanced-bloom-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                advancedBloomUniforms: {
                    uBloomScale: {
                        value: options.bloomScale,
                        type: "f32"
                    },
                    uBrightness: {
                        value: options.brightness,
                        type: "f32"
                    }
                },
                uMapTexture: (0, $jollT.Texture).WHITE
            }
        });
        $7d58a4b9e5faa45a$var$__publicField(this, "uniforms");
        /** To adjust the strength of the bloom. Higher values is more intense brightness. */ $7d58a4b9e5faa45a$var$__publicField(this, "bloomScale", 1);
        /** The brightness, lower value is more subtle brightness, higher value is blown-out. */ $7d58a4b9e5faa45a$var$__publicField(this, "brightness", 1);
        $7d58a4b9e5faa45a$var$__publicField(this, "_extractFilter");
        $7d58a4b9e5faa45a$var$__publicField(this, "_blurFilter");
        this.uniforms = this.resources.advancedBloomUniforms.uniforms;
        this._extractFilter = new (0, $a25e83c6bc1d0936$export$3184aba1f05c290d)({
            threshold: options.threshold
        });
        this._blurFilter = new (0, $2433219b84d26ac4$export$31164edf0fb20199)({
            strength: options.kernels ?? options.blur,
            quality: options.kernels ? void 0 : options.quality
        });
        Object.assign(this, options);
    }
    /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */ apply(filterManager, input, output, clearMode) {
        const brightTarget = (0, $g5CeI.TexturePool).getSameSizeTexture(input);
        this._extractFilter.apply(filterManager, input, brightTarget, true);
        const bloomTarget = (0, $g5CeI.TexturePool).getSameSizeTexture(input);
        this._blurFilter.apply(filterManager, brightTarget, bloomTarget, true);
        this.uniforms.uBloomScale = this.bloomScale;
        this.uniforms.uBrightness = this.brightness;
        this.resources.uMapTexture = bloomTarget.source;
        filterManager.applyFilter(this, input, output, clearMode);
        (0, $g5CeI.TexturePool).returnTexture(bloomTarget);
        (0, $g5CeI.TexturePool).returnTexture(brightTarget);
    }
    /**
   * Defines how bright a color needs to be extracted.
   * @default 0.5
   */ get threshold() {
        return this._extractFilter.threshold;
    }
    set threshold(value) {
        this._extractFilter.threshold = value;
    }
    /** The kernels of the Blur Filter */ get kernels() {
        return this._blurFilter.kernels;
    }
    set kernels(value) {
        this._blurFilter.kernels = value;
    }
    /**
   * The strength of the Blur properties simultaneously
   * @default 2
   */ get blur() {
        return this._blurFilter.strength;
    }
    set blur(value) {
        this._blurFilter.strength = value;
    }
    /**
   * The quality of the Blur Filter
   * @default 4
   */ get quality() {
        return this._blurFilter.quality;
    }
    set quality(value) {
        this._blurFilter.quality = value;
    }
    /**
   * The pixel size of the Kawase Blur filter
   * @default {x:1,y:1}
   */ get pixelSize() {
        return this._blurFilter.pixelSize;
    }
    set pixelSize(value) {
        if (typeof value === "number") value = {
            x: value,
            y: value
        };
        if (Array.isArray(value)) value = {
            x: value[0],
            y: value[1]
        };
        this._blurFilter.pixelSize = value;
    }
    /**
   * The horizontal pixelSize of the Kawase Blur filter
   * @default 1
   */ get pixelSizeX() {
        return this._blurFilter.pixelSizeX;
    }
    set pixelSizeX(value) {
        this._blurFilter.pixelSizeX = value;
    }
    /**
   * The vertical pixel size of the Kawase Blur filter
   * @default 1
   */ get pixelSizeY() {
        return this._blurFilter.pixelSizeY;
    }
    set pixelSizeY(value) {
        this._blurFilter.pixelSizeY = value;
    }
};
/** Default values for options. */ $7d58a4b9e5faa45a$var$__publicField($7d58a4b9e5faa45a$var$_AdvancedBloomFilter, "DEFAULT_OPTIONS", {
    threshold: 0.5,
    bloomScale: 1,
    brightness: 1,
    blur: 8,
    quality: 4,
    pixelSize: {
        x: 1,
        y: 1
    }
});
let $7d58a4b9e5faa45a$export$b970daeca74b07ea = $7d58a4b9e5faa45a$var$_AdvancedBloomFilter;



var $j0fPb = parcelRequire("j0fPb");
var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $bEj7k = parcelRequire("bEj7k");
var $ld81y = parcelRequire("ld81y");


var $d4ef7386ef080d4c$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform float uSize;\nuniform vec3 uColor;\nuniform float uReplaceColor;\n\nuniform vec4 uInputSize;\n\nvec2 mapCoord( vec2 coord )\n{\n    coord *= uInputSize.xy;\n    coord += uInputSize.zw;\n\n    return coord;\n}\n\nvec2 unmapCoord( vec2 coord )\n{\n    coord -= uInputSize.zw;\n    coord /= uInputSize.xy;\n\n    return coord;\n}\n\nvec2 pixelate(vec2 coord, vec2 size)\n{\n    return floor(coord / size) * size;\n}\n\nvec2 getMod(vec2 coord, vec2 size)\n{\n    return mod(coord, size) / size;\n}\n\nfloat character(float n, vec2 p)\n{\n    p = floor(p*vec2(4.0, 4.0) + 2.5);\n\n    if (clamp(p.x, 0.0, 4.0) == p.x)\n    {\n        if (clamp(p.y, 0.0, 4.0) == p.y)\n        {\n            if (int(mod(n/exp2(p.x + 5.0*p.y), 2.0)) == 1) return 1.0;\n        }\n    }\n    return 0.0;\n}\n\nvoid main()\n{\n    vec2 coord = mapCoord(vTextureCoord);\n\n    // get the grid position\n    vec2 pixCoord = pixelate(coord, vec2(uSize));\n    pixCoord = unmapCoord(pixCoord);\n\n    // sample the color at grid position\n    vec4 color = texture(uTexture, pixCoord);\n\n    // brightness of the color as it's perceived by the human eye\n    float gray = 0.3 * color.r + 0.59 * color.g + 0.11 * color.b;\n\n    // determine the character to use\n    float n =  65536.0;             // .\n    if (gray > 0.2) n = 65600.0;    // :\n    if (gray > 0.3) n = 332772.0;   // *\n    if (gray > 0.4) n = 15255086.0; // o\n    if (gray > 0.5) n = 23385164.0; // &\n    if (gray > 0.6) n = 15252014.0; // 8\n    if (gray > 0.7) n = 13199452.0; // @\n    if (gray > 0.8) n = 11512810.0; // #\n\n    // get the mod..\n    vec2 modd = getMod(coord, vec2(uSize));\n\n    finalColor = (uReplaceColor > 0.5 ? vec4(uColor, 1.) : color) * character( n, vec2(-1.0) + modd * 2.0);\n}\n";


var $54295da58c81e080$export$2e2bcd8739ae039 = "struct AsciiUniforms {\n    uSize: f32,\n    uColor: vec3<f32>,\n    uReplaceColor: f32,\n};\n\nstruct GlobalFilterUniforms {\n    uInputSize:vec4<f32>,\n    uInputPixel:vec4<f32>,\n    uInputClamp:vec4<f32>,\n    uOutputFrame:vec4<f32>,\n    uGlobalFrame:vec4<f32>,\n    uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> asciiUniforms : AsciiUniforms;\n\n@fragment\nfn mainFragment(\n    @location(0) uv: vec2<f32>,\n    @builtin(position) position: vec4<f32>\n) -> @location(0) vec4<f32> {\n    let pixelSize: f32 = asciiUniforms.uSize;\n    let coord: vec2<f32> = mapCoord(uv);\n\n    // get the rounded color..\n    var pixCoord: vec2<f32> = pixelate(coord, vec2<f32>(pixelSize));\n    pixCoord = unmapCoord(pixCoord);\n\n    var color = textureSample(uTexture, uSampler, pixCoord);\n\n    // determine the character to use\n    let gray: f32 = 0.3 * color.r + 0.59 * color.g + 0.11 * color.b;\n    \n    var n: f32 = 65536.0; // .\n    if (gray > 0.2) {\n        n = 65600.0;    // :\n    }\n    if (gray > 0.3) {\n        n = 332772.0;   // *\n    }\n    if (gray > 0.4) {\n        n = 15255086.0; // o\n    }\n    if (gray > 0.5) {\n        n = 23385164.0; // &\n    }\n    if (gray > 0.6) {\n        n = 15252014.0; // 8\n    }\n    if (gray > 0.7) {\n        n = 13199452.0; // @\n    }\n    if (gray > 0.8) {\n        n = 11512810.0; // #\n    }\n\n    // get the mod..\n    let modd: vec2<f32> = getMod(coord, vec2<f32>(pixelSize));\n    return select(color, vec4<f32>(asciiUniforms.uColor, 1.), asciiUniforms.uReplaceColor > 0.5) * character(n, vec2<f32>(-1.0) + modd * 2.0);\n}\n\nfn pixelate(coord: vec2<f32>, size: vec2<f32>) -> vec2<f32>\n{\n    return floor( coord / size ) * size;\n}\n\nfn getMod(coord: vec2<f32>, size: vec2<f32>) -> vec2<f32>\n{\n    return moduloVec2( coord , size) / size;\n}\n\nfn character(n: f32, p: vec2<f32>) -> f32\n{\n    var q: vec2<f32> = floor(p*vec2<f32>(4.0, 4.0) + 2.5);\n\n    if (clamp(q.x, 0.0, 4.0) == q.x)\n    {\n        if (clamp(q.y, 0.0, 4.0) == q.y)\n        {\n        if (i32(modulo(n/exp2(q.x + 5.0*q.y), 2.0)) == 1)\n        {\n            return 1.0;\n        }\n        }\n    }\n\n    return 0.0;\n}\n\nfn modulo(x: f32, y: f32) -> f32\n{\n  return x - y * floor(x/y);\n}\n\nfn moduloVec2(x: vec2<f32>, y: vec2<f32>) -> vec2<f32>\n{\n  return x - y * floor(x/y);\n}\n\nfn mapCoord(coord: vec2<f32> ) -> vec2<f32>\n{\n    var mappedCoord: vec2<f32> = coord;\n    mappedCoord *= gfu.uInputSize.xy;\n    mappedCoord += gfu.uOutputFrame.xy;\n    return mappedCoord;\n}\n\nfn unmapCoord(coord: vec2<f32> ) -> vec2<f32>\n{\n    var mappedCoord: vec2<f32> = coord;\n    mappedCoord -= gfu.uOutputFrame.xy;\n    mappedCoord /= gfu.uInputSize.xy;\n    return mappedCoord;\n}";


var $3e12b478453d02f2$var$__defProp = Object.defineProperty;
var $3e12b478453d02f2$var$__defNormalProp = (obj, key, value)=>key in obj ? $3e12b478453d02f2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3e12b478453d02f2$var$__publicField = (obj, key, value)=>{
    $3e12b478453d02f2$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $3e12b478453d02f2$var$_AsciiFilter = class _AsciiFilter extends (0, $ld81y.Filter) {
    /** @ignore */ constructor(...args){
        let options = args[0] ?? {};
        if (typeof options === "number") {
            (0, $j0fPb.deprecation)("6.0.0", "AsciiFilter constructor params are now options object. See params: { size, color, replaceColor }");
            options = {
                size: options
            };
        }
        const replaceColor = options?.color && options.replaceColor !== false;
        options = {
            ..._AsciiFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $54295da58c81e080$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $d4ef7386ef080d4c$export$2e2bcd8739ae039,
            name: "ascii-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                asciiUniforms: {
                    uSize: {
                        value: options.size,
                        type: "f32"
                    },
                    uColor: {
                        value: new Float32Array(3),
                        type: "vec3<f32>"
                    },
                    uReplaceColor: {
                        value: Number(replaceColor),
                        type: "f32"
                    }
                }
            }
        });
        $3e12b478453d02f2$var$__publicField(this, "uniforms");
        $3e12b478453d02f2$var$__publicField(this, "_color");
        this.uniforms = this.resources.asciiUniforms.uniforms;
        this._color = new (0, $bEj7k.Color)();
        this.color = options.color ?? 16777215;
    }
    /**
   * The pixel size used by the filter.
   * @default 8
   */ get size() {
        return this.uniforms.uSize;
    }
    set size(value) {
        this.uniforms.uSize = value;
    }
    /**
   * The resulting color of the ascii characters, as a 3 component RGB or numerical hex
   * @example [1.0, 1.0, 1.0] = 0xffffff
   * @default 0xffffff
   */ get color() {
        return this._color.value;
    }
    set color(value) {
        this._color.setValue(value);
        const [r, g, b] = this._color.toArray();
        this.uniforms.uColor[0] = r;
        this.uniforms.uColor[1] = g;
        this.uniforms.uColor[2] = b;
    }
    /**
   * Determine whether or not to replace the source colors with the provided.
   */ get replaceColor() {
        return this.uniforms.uReplaceColor > 0.5;
    }
    set replaceColor(value) {
        this.uniforms.uReplaceColor = value ? 1 : 0;
    }
};
/** Default values for options. */ $3e12b478453d02f2$var$__publicField($3e12b478453d02f2$var$_AsciiFilter, "DEFAULT_OPTIONS", {
    size: 8,
    color: 16777215,
    replaceColor: false
});
let $3e12b478453d02f2$export$15bcb18d890d25c4 = $3e12b478453d02f2$var$_AsciiFilter;



var $ld81y = parcelRequire("ld81y");
var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $jollT = parcelRequire("jollT");
var $g5CeI = parcelRequire("g5CeI");


var $fbe1aa5347a4d6a9$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform sampler2D uBackground;\n\nvoid main(void){\n    vec4 front = texture(uTexture, vTextureCoord);\n    vec4 back = texture(uBackground, vTextureCoord);\n\n    if (front.a == 0.0) {\n        discard;\n    }\n    \n    vec3 color = mix(back.rgb, front.rgb / front.a, front.a);\n\n    finalColor = vec4(color, 1.0);\n}";


var $057aae74bab96174$export$2e2bcd8739ae039 = "@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var uBackground: texture_2d<f32>; \n\n@fragment\nfn mainFragment(\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n    var front: vec4<f32> = textureSample(uTexture, uSampler, uv);\n    var back: vec4<f32> = textureSample(uBackground, uSampler, uv);\n    \n    if (front.a == 0.0) {\n        discard;\n    }\n\n    var color: vec3<f32> = mix(back.rgb, front.rgb / front.a, front.a);\n\n    return vec4<f32>(color, 1.0);\n}";


var $f6c3019c81e143cc$var$__defProp = Object.defineProperty;
var $f6c3019c81e143cc$var$__defNormalProp = (obj, key, value)=>key in obj ? $f6c3019c81e143cc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f6c3019c81e143cc$var$__publicField = (obj, key, value)=>{
    $f6c3019c81e143cc$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
class $f6c3019c81e143cc$export$be3580ae316f80c2 extends (0, $02d1c7a4f9d3e479$export$424348d09d827f49) {
    /**
   * @param options - The options of the blur filter.
   */ constructor(options){
        super(options);
        $f6c3019c81e143cc$var$__publicField(this, "_blendPass");
        this.blendRequired = true;
        this.padding = 0;
        this._blendPass = new (0, $ld81y.Filter)({
            gpuProgram: (0, $9E2kA.GpuProgram).from({
                vertex: {
                    source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                    entryPoint: "mainVertex"
                },
                fragment: {
                    source: (0, $057aae74bab96174$export$2e2bcd8739ae039),
                    entryPoint: "mainFragment"
                }
            }),
            glProgram: (0, $339HX.GlProgram).from({
                vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
                fragment: $fbe1aa5347a4d6a9$export$2e2bcd8739ae039,
                name: "drop-shadow-filter"
            }),
            resources: {
                uBackground: (0, $jollT.Texture).EMPTY
            }
        });
    }
    /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */ apply(filterManager, input, output, clearMode) {
        const backTexture = filterManager._activeFilterData.backTexture;
        const blurredBackground = (0, $g5CeI.TexturePool).getSameSizeTexture(input);
        super.apply(filterManager, backTexture, blurredBackground, true);
        this._blendPass.resources.uBackground = blurredBackground.source;
        this._blendPass.apply(filterManager, input, output, clearMode);
        (0, $g5CeI.TexturePool).returnTexture(blurredBackground);
    }
    updatePadding() {
        this.padding = 0;
    }
}



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $bEj7k = parcelRequire("bEj7k");
var $l8FfC = parcelRequire("l8FfC");
var $ld81y = parcelRequire("ld81y");


var $d47a3ab9b1a6264c$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec2 uTransform;\nuniform vec3 uLightColor;\nuniform float uLightAlpha;\nuniform vec3 uShadowColor;\nuniform float uShadowAlpha;\n\nuniform vec4 uInputSize;\n\nvoid main(void) {\n    vec2 transform = vec2(1.0 / uInputSize) * vec2(uTransform.x, uTransform.y);\n    vec4 color = texture(uTexture, vTextureCoord);\n    float light = texture(uTexture, vTextureCoord - transform).a;\n    float shadow = texture(uTexture, vTextureCoord + transform).a;\n\n    color.rgb = mix(color.rgb, uLightColor, clamp((color.a - light) * uLightAlpha, 0.0, 1.0));\n    color.rgb = mix(color.rgb, uShadowColor, clamp((color.a - shadow) * uShadowAlpha, 0.0, 1.0));\n    finalColor = vec4(color.rgb * color.a, color.a);\n}\n";


var $e6d4e8ac9f1ba414$export$2e2bcd8739ae039 = "struct BevelUniforms {\n  uLightColor: vec3<f32>,\n  uLightAlpha: f32,\n  uShadowColor: vec3<f32>,\n  uShadowAlpha: f32,\n  uTransform: vec2<f32>,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> bevelUniforms : BevelUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let transform = vec2<f32>(1.0 / gfu.uInputSize.xy) * vec2<f32>(bevelUniforms.uTransform.x, bevelUniforms.uTransform.y);\n  var color: vec4<f32> = textureSample(uTexture, uSampler, uv);\n  let lightSample: f32 = textureSample(uTexture, uSampler, uv - transform).a;\n  let shadowSample: f32 = textureSample(uTexture, uSampler, uv + transform).a;\n\n  let light = vec4<f32>(bevelUniforms.uLightColor, bevelUniforms.uLightAlpha);\n  let shadow = vec4<f32>(bevelUniforms.uShadowColor, bevelUniforms.uShadowAlpha);\n\n  color = vec4<f32>(mix(color.rgb, light.rgb, clamp((color.a - lightSample) * light.a, 0.0, 1.0)), color.a);\n  color = vec4<f32>(mix(color.rgb, shadow.rgb, clamp((color.a - shadowSample) * shadow.a, 0.0, 1.0)), color.a);\n  \n  return vec4<f32>(color.rgb * color.a, color.a);\n}";


var $4bb0654f3fe82b02$var$__defProp = Object.defineProperty;
var $4bb0654f3fe82b02$var$__defNormalProp = (obj, key, value)=>key in obj ? $4bb0654f3fe82b02$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4bb0654f3fe82b02$var$__publicField = (obj, key, value)=>{
    $4bb0654f3fe82b02$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $4bb0654f3fe82b02$var$_BevelFilter = class _BevelFilter extends (0, $ld81y.Filter) {
    /**
   * @param options - Options for the BevelFilter constructor.
   */ constructor(options){
        options = {
            ..._BevelFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $e6d4e8ac9f1ba414$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $d47a3ab9b1a6264c$export$2e2bcd8739ae039,
            name: "bevel-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                bevelUniforms: {
                    uLightColor: {
                        value: new Float32Array(3),
                        type: "vec3<f32>"
                    },
                    uLightAlpha: {
                        value: options.lightAlpha,
                        type: "f32"
                    },
                    uShadowColor: {
                        value: new Float32Array(3),
                        type: "vec3<f32>"
                    },
                    uShadowAlpha: {
                        value: options.shadowAlpha,
                        type: "f32"
                    },
                    uTransform: {
                        value: new Float32Array(2),
                        type: "vec2<f32>"
                    }
                }
            },
            // Workaround: https://github.com/pixijs/filters/issues/230
            // applies correctly only if there is at least a single-pixel padding with alpha=0 around an image
            // To solve this problem, a padding of 1 put on the filter should suffice
            padding: 1
        });
        $4bb0654f3fe82b02$var$__publicField(this, "uniforms");
        $4bb0654f3fe82b02$var$__publicField(this, "_thickness");
        $4bb0654f3fe82b02$var$__publicField(this, "_rotation");
        $4bb0654f3fe82b02$var$__publicField(this, "_lightColor");
        $4bb0654f3fe82b02$var$__publicField(this, "_shadowColor");
        this.uniforms = this.resources.bevelUniforms.uniforms;
        this._lightColor = new (0, $bEj7k.Color)();
        this._shadowColor = new (0, $bEj7k.Color)();
        this.lightColor = options.lightColor ?? 16777215;
        this.shadowColor = options.shadowColor ?? 0;
        Object.assign(this, options);
    }
    /**
   * The angle of the light in degrees
   * @default 45
   */ get rotation() {
        return this._rotation / (0, $l8FfC.DEG_TO_RAD);
    }
    set rotation(value) {
        this._rotation = value * (0, $l8FfC.DEG_TO_RAD);
        this._updateTransform();
    }
    /**
   * The thickness of the bevel
   * @default 2
   */ get thickness() {
        return this._thickness;
    }
    set thickness(value) {
        this._thickness = value;
        this._updateTransform();
    }
    /**
   * The color value of the left & top bevel.
   * @example [1.0, 1.0, 1.0] = 0xffffff
   * @default 0xffffff
   */ get lightColor() {
        return this._lightColor.value;
    }
    set lightColor(value) {
        this._lightColor.setValue(value);
        const [r, g, b] = this._lightColor.toArray();
        this.uniforms.uLightColor[0] = r;
        this.uniforms.uLightColor[1] = g;
        this.uniforms.uLightColor[2] = b;
    }
    /**
   * The alpha value of the left & top bevel.
   * @default 0.7
   */ get lightAlpha() {
        return this.uniforms.uLightAlpha;
    }
    set lightAlpha(value) {
        this.uniforms.uLightAlpha = value;
    }
    /**
   * The color value of the right & bottom bevel.
   * @default 0xffffff
   */ get shadowColor() {
        return this._shadowColor.value;
    }
    set shadowColor(value) {
        this._shadowColor.setValue(value);
        const [r, g, b] = this._shadowColor.toArray();
        this.uniforms.uShadowColor[0] = r;
        this.uniforms.uShadowColor[1] = g;
        this.uniforms.uShadowColor[2] = b;
    }
    /**
   * The alpha value of the right & bottom bevel.
   * @default 0.7
   */ get shadowAlpha() {
        return this.uniforms.uShadowAlpha;
    }
    set shadowAlpha(value) {
        this.uniforms.uShadowAlpha = value;
    }
    /**
   * Update the transform matrix of offset angle.
   * @private
   */ _updateTransform() {
        this.uniforms.uTransform[0] = this.thickness * Math.cos(this._rotation);
        this.uniforms.uTransform[1] = this.thickness * Math.sin(this._rotation);
    }
};
/** Default values for options. */ $4bb0654f3fe82b02$var$__publicField($4bb0654f3fe82b02$var$_BevelFilter, "DEFAULT_OPTIONS", {
    rotation: 45,
    thickness: 2,
    lightColor: 16777215,
    lightAlpha: 0.7,
    shadowColor: 0,
    shadowAlpha: 0.7
});
let $4bb0654f3fe82b02$export$b3fbca19e4458c27 = $4bb0654f3fe82b02$var$_BevelFilter;



var $j0fPb = parcelRequire("j0fPb");
var $g5CeI = parcelRequire("g5CeI");
var $472bed08b3afe5ae$var$__defProp = Object.defineProperty;
var $472bed08b3afe5ae$var$__defNormalProp = (obj, key, value)=>key in obj ? $472bed08b3afe5ae$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $472bed08b3afe5ae$var$__publicField = (obj, key, value)=>{
    $472bed08b3afe5ae$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $472bed08b3afe5ae$var$_BloomFilter = class _BloomFilter extends (0, $3c87de1a7de6a738$export$adbaa0de008b0d7a) {
    /** @ignore */ constructor(...args){
        let options = args[0] ?? {};
        if (typeof options === "number" || Array.isArray(options) || "x" in options && "y" in options) {
            (0, $j0fPb.deprecation)("6.0.0", "BloomFilter constructor params are now options object. See params: { strength, quality, resolution, kernelSize }");
            let strength = options;
            if (Array.isArray(strength)) strength = {
                x: strength[0],
                y: strength[1]
            };
            options = {
                strength: strength
            };
            if (args[1] !== void 0) options.quality = args[1];
            if (args[2] !== void 0) options.resolution = args[2];
            if (args[3] !== void 0) options.kernelSize = args[3];
        }
        options = {
            ..._BloomFilter.DEFAULT_OPTIONS,
            ...options
        };
        super();
        $472bed08b3afe5ae$var$__publicField(this, "_blurXFilter");
        $472bed08b3afe5ae$var$__publicField(this, "_blurYFilter");
        $472bed08b3afe5ae$var$__publicField(this, "_strength");
        this._strength = {
            x: 2,
            y: 2
        };
        if (options.strength) {
            if (typeof options.strength === "number") {
                this._strength.x = options.strength;
                this._strength.y = options.strength;
            } else {
                this._strength.x = options.strength.x;
                this._strength.y = options.strength.y;
            }
        }
        this._blurXFilter = new (0, $f1dbcd66fba2886b$export$b100a8e8116621cf)({
            ...options,
            horizontal: true,
            strength: this.strengthX
        });
        this._blurYFilter = new (0, $f1dbcd66fba2886b$export$b100a8e8116621cf)({
            ...options,
            horizontal: false,
            strength: this.strengthY
        });
        this._blurYFilter.blendMode = "screen";
        Object.assign(this, options);
    }
    /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */ apply(filterManager, input, output, clear) {
        const renderTarget = (0, $g5CeI.TexturePool).getSameSizeTexture(input);
        filterManager.applyFilter(this, input, output, clear);
        this._blurXFilter.apply(filterManager, input, renderTarget, true);
        this._blurYFilter.apply(filterManager, renderTarget, output, false);
        (0, $g5CeI.TexturePool).returnTexture(renderTarget);
    }
    /**
   * Sets the strength of both the blurX and blurY properties simultaneously
   * @default 2
   */ get strength() {
        return this._strength;
    }
    set strength(value) {
        this._strength = typeof value === "number" ? {
            x: value,
            y: value
        } : value;
        this._updateStrength();
    }
    /**
   * Sets the strength of the blur on the `x` axis
   * @default 2
   */ get strengthX() {
        return this.strength.x;
    }
    set strengthX(value) {
        this.strength.x = value;
        this._updateStrength();
    }
    /**
   * Sets the strength of the blur on the `y` axis
   * @default 2
   */ get strengthY() {
        return this.strength.y;
    }
    set strengthY(value) {
        this.strength.y = value;
        this._updateStrength();
    }
    _updateStrength() {
        this._blurXFilter.blur = this.strengthX;
        this._blurYFilter.blur = this.strengthY;
    }
    /**
   * @deprecated since 6.0.0
   *
   * The strength of both the blurX and blurY properties simultaneously
   * @default 2
   * @see BloomFilter#strength
   */ get blur() {
        (0, $j0fPb.deprecation)("6.0.0", "BloomFilter.blur is deprecated, please use BloomFilter.strength instead");
        return this.strengthX;
    }
    set blur(value) {
        (0, $j0fPb.deprecation)("6.0.0", "BloomFilter.blur is deprecated, please use BloomFilter.strength instead");
        this.strength = value;
    }
    /**
   * @deprecated since 6.0.0
   *
   * The strength of the blurX property
   * @default 2
   * @see BloomFilter#strengthX
   */ get blurX() {
        (0, $j0fPb.deprecation)("6.0.0", "BloomFilter.blurX is deprecated, please use BloomFilter.strengthX instead");
        return this.strengthX;
    }
    set blurX(value) {
        (0, $j0fPb.deprecation)("6.0.0", "BloomFilter.blurX is deprecated, please use BloomFilter.strengthX instead");
        this.strengthX = value;
    }
    /**
   * @deprecated since 6.0.0
   *
   * The strength of the blurY property
   * @default 2
   * @see BloomFilter#strengthY
   */ get blurY() {
        (0, $j0fPb.deprecation)("6.0.0", "BloomFilter.blurY is deprecated, please use BloomFilter.strengthY instead");
        return this.strengthY;
    }
    set blurY(value) {
        (0, $j0fPb.deprecation)("6.0.0", "BloomFilter.blurY is deprecated, please use BloomFilter.strengthY instead");
        this.strengthY = value;
    }
};
/** Default values for options. */ $472bed08b3afe5ae$var$__publicField($472bed08b3afe5ae$var$_BloomFilter, "DEFAULT_OPTIONS", {
    strength: {
        x: 2,
        y: 2
    },
    quality: 4,
    resolution: 1,
    kernelSize: 5
});
let $472bed08b3afe5ae$export$fbc160adde9cf656 = $472bed08b3afe5ae$var$_BloomFilter;



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $407e1d3a71f5d00d$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec2 uDimensions;\nuniform vec2 uCenter;\nuniform float uRadius;\nuniform float uStrength;\n\nuniform vec4 uInputSize;\nuniform vec4 uInputClamp;\n\nvoid main()\n{\n    vec2 coord = vTextureCoord * uInputSize.xy;\n    coord -= uCenter * uDimensions.xy;\n    float distance = length(coord);\n\n    if (distance < uRadius) {\n        float percent = distance / uRadius;\n        if (uStrength > 0.0) {\n            coord *= mix(1.0, smoothstep(0.0, uRadius / distance, percent), uStrength * 0.75);\n        } else {\n            coord *= mix(1.0, pow(percent, 1.0 + uStrength * 0.75) * uRadius / distance, 1.0 - percent);\n        }\n    }\n\n    coord += uCenter * uDimensions.xy;\n    coord /= uInputSize.xy;\n    vec2 clampedCoord = clamp(coord, uInputClamp.xy, uInputClamp.zw);\n    vec4 color = texture(uTexture, clampedCoord);\n\n    if (coord != clampedCoord) {\n        color *= max(0.0, 1.0 - length(coord - clampedCoord));\n    }\n\n    finalColor = color;\n}\n";


var $2450d7632e05b57d$export$2e2bcd8739ae039 = "struct BulgePinchUniforms {\n  uDimensions: vec2<f32>,\n  uCenter: vec2<f32>,\n  uRadius: f32,\n  uStrength: f32,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> bulgePinchUniforms : BulgePinchUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let dimensions: vec2<f32> = bulgePinchUniforms.uDimensions;\n  let center: vec2<f32> = bulgePinchUniforms.uCenter;\n  let radius: f32 = bulgePinchUniforms.uRadius;\n  let strength: f32 = bulgePinchUniforms.uStrength;\n  var coord: vec2<f32> = (uv * gfu.uInputSize.xy) - center * dimensions.xy;\n\n  let distance: f32 = length(coord);\n\n  if (distance < radius) {\n      let percent: f32 = distance / radius;\n      if (strength > 0.0) {\n          coord *= mix(1.0, smoothstep(0.0, radius / distance, percent), strength * 0.75);\n      } else {\n          coord *= mix(1.0, pow(percent, 1.0 + strength * 0.75) * radius / distance, 1.0 - percent);\n      }\n  }\n    coord += (center * dimensions.xy);\n    coord /= gfu.uInputSize.xy;\n\n    let clampedCoord: vec2<f32> = clamp(coord, gfu.uInputClamp.xy, gfu.uInputClamp.zw);\n    var color: vec4<f32> = textureSample(uTexture, uSampler, clampedCoord);\n    if (coord.x != clampedCoord.x && coord.y != clampedCoord.y) {\n        color *= max(0.0, 1.0 - length(coord - clampedCoord));\n    }\n\n    return color;\n}\n\nfn compareVec2(x: vec2<f32>, y: vec2<f32>) -> bool\n{\n  if (x.x == y.x && x.y == y.y)\n  {\n    return true;\n  }\n\n  return false;\n}";


var $8ff54faf83c0f5dd$var$__defProp = Object.defineProperty;
var $8ff54faf83c0f5dd$var$__defNormalProp = (obj, key, value)=>key in obj ? $8ff54faf83c0f5dd$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8ff54faf83c0f5dd$var$__publicField = (obj, key, value)=>{
    $8ff54faf83c0f5dd$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $8ff54faf83c0f5dd$var$_BulgePinchFilter = class _BulgePinchFilter extends (0, $ld81y.Filter) {
    /**
   * @param options - Options for the BulgePinchFilter constructor.
   */ constructor(options){
        options = {
            ..._BulgePinchFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $2450d7632e05b57d$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $407e1d3a71f5d00d$export$2e2bcd8739ae039,
            name: "bulge-pinch-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                bulgePinchUniforms: {
                    uDimensions: {
                        value: [
                            0,
                            0
                        ],
                        type: "vec2<f32>"
                    },
                    uCenter: {
                        value: options.center,
                        type: "vec2<f32>"
                    },
                    uRadius: {
                        value: options.radius,
                        type: "f32"
                    },
                    uStrength: {
                        value: options.strength,
                        type: "f32"
                    }
                }
            }
        });
        $8ff54faf83c0f5dd$var$__publicField(this, "uniforms");
        this.uniforms = this.resources.bulgePinchUniforms.uniforms;
        Object.assign(this, options);
    }
    /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */ apply(filterManager, input, output, clearMode) {
        this.uniforms.uDimensions[0] = input.frame.width;
        this.uniforms.uDimensions[1] = input.frame.height;
        filterManager.applyFilter(this, input, output, clearMode);
    }
    /**
   * Sets the center of the effect in normalized screen coords.
   * { x: 0, y: 0 } means top-left and { x: 1, y: 1 } mean bottom-right
   * @default {x:0.5,y:0.5}
   */ get center() {
        return this.uniforms.uCenter;
    }
    set center(value) {
        if (typeof value === "number") value = {
            x: value,
            y: value
        };
        if (Array.isArray(value)) value = {
            x: value[0],
            y: value[1]
        };
        this.uniforms.uCenter = value;
    }
    /**
   * Sets the center of the effect in normalized screen coords on the `x` axis
   * @default 0
   */ get centerX() {
        return this.uniforms.uCenter.x;
    }
    set centerX(value) {
        this.uniforms.uCenter.x = value;
    }
    /**
   * Sets the center of the effect in normalized screen coords on the `y` axis
   * @default 0
   */ get centerY() {
        return this.uniforms.uCenter.y;
    }
    set centerY(value) {
        this.uniforms.uCenter.y = value;
    }
    /**
   * The radius of the circle of effect
   * @default 100
   */ get radius() {
        return this.uniforms.uRadius;
    }
    set radius(value) {
        this.uniforms.uRadius = value;
    }
    /**
   * A value between -1 and 1 (-1 is strong pinch, 0 is no effect, 1 is strong bulge)
   * @default 1
   */ get strength() {
        return this.uniforms.uStrength;
    }
    set strength(value) {
        this.uniforms.uStrength = value;
    }
};
/** Default values for options. */ $8ff54faf83c0f5dd$var$__publicField($8ff54faf83c0f5dd$var$_BulgePinchFilter, "DEFAULT_OPTIONS", {
    center: {
        x: 0.5,
        y: 0.5
    },
    radius: 100,
    strength: 1
});
let $8ff54faf83c0f5dd$export$3db008ed2b7e8808 = $8ff54faf83c0f5dd$var$_BulgePinchFilter;



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $bEj7k = parcelRequire("bEj7k");
var $ld81y = parcelRequire("ld81y");
var $d0cdc919e283289e$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nin vec2 vFilterCoord;\nout vec4 finalColor;\n\nconst int TYPE_LINEAR = 0;\nconst int TYPE_RADIAL = 1;\nconst int TYPE_CONIC = 2;\nconst int MAX_STOPS = 32;\n\nuniform sampler2D uTexture;\nuniform vec4 uOptions;\nuniform vec2 uCounts;\nuniform vec3 uColors[MAX_STOPS];\nuniform vec4 uStops[MAX_STOPS];\n\nconst float PI = 3.1415926538;\nconst float PI_2 = PI*2.;\n\nstruct ColorStop {\n    float offset;\n    vec3 color;\n    float alpha;\n};\n\nmat2 rotate2d(float angle){\n    return mat2(cos(angle), -sin(angle),\n    sin(angle), cos(angle));\n}\n\nfloat projectLinearPosition(vec2 pos, float angle){\n    vec2 center = vec2(0.5);\n    vec2 result = pos - center;\n    result = rotate2d(angle) * result;\n    result = result + center;\n    return clamp(result.x, 0., 1.);\n}\n\nfloat projectRadialPosition(vec2 pos) {\n    float r = distance(pos, vec2(0.5));\n    return clamp(2.*r, 0., 1.);\n}\n\nfloat projectAnglePosition(vec2 pos, float angle) {\n    vec2 center = pos - vec2(0.5);\n    float polarAngle=atan(-center.y, center.x);\n    return mod(polarAngle + angle, PI_2) / PI_2;\n}\n\nfloat projectPosition(vec2 pos, int type, float angle) {\n    if (type == TYPE_LINEAR) {\n        return projectLinearPosition(pos, angle);\n    } else if (type == TYPE_RADIAL) {\n        return projectRadialPosition(pos);\n    } else if (type == TYPE_CONIC) {\n        return projectAnglePosition(pos, angle);\n    }\n\n    return pos.y;\n}\n\nvoid main(void) {\n    int uType = int(uOptions[0]);\n    float uAngle = uOptions[1];\n    float uAlpha = uOptions[2];\n    float uReplace = uOptions[3];\n\n    int uNumStops = int(uCounts[0]);\n    float uMaxColors = uCounts[1];\n\n    // current/original color\n    vec4 currentColor = texture(uTexture, vTextureCoord);\n\n    // skip calculations if gradient alpha is 0\n    if (0.0 == uAlpha) {\n        finalColor = currentColor;\n        return;\n    }\n\n    // project position\n    float y = projectPosition(vFilterCoord, int(uType), radians(uAngle));\n\n    // check gradient bounds\n    float offsetMin = uStops[0][0];\n    float offsetMax = 0.0;\n\n    int numStops = int(uNumStops);\n\n    for (int i = 0; i < MAX_STOPS; i++) {\n        if (i == numStops-1){ // last index\n            offsetMax = uStops[i][0];\n        }\n    }\n\n    if (y  < offsetMin || y > offsetMax) {\n        finalColor = currentColor;\n        return;\n    }\n\n    // limit colors\n    if (uMaxColors > 0.) {\n        float stepSize = 1./uMaxColors;\n        float stepNumber = float(floor(y/stepSize));\n        y = stepSize * (stepNumber + 0.5);// offset by 0.5 to use color from middle of segment\n    }\n\n    // find color stops\n    ColorStop from;\n    ColorStop to;\n\n    for (int i = 0; i < MAX_STOPS; i++) {\n        if (y >= uStops[i][0]) {\n            from = ColorStop(uStops[i][0], uColors[i], uStops[i][1]);\n            to = ColorStop(uStops[i+1][0], uColors[i+1], uStops[i+1][1]);\n        }\n\n        if (i == numStops-1){ // last index\n            break;\n        }\n    }\n\n    // mix colors from stops\n    vec4 colorFrom = vec4(from.color * from.alpha, from.alpha);\n    vec4 colorTo = vec4(to.color * to.alpha, to.alpha);\n\n    float segmentHeight = to.offset - from.offset;\n    float relativePos = y - from.offset;// position from 0 to [segmentHeight]\n    float relativePercent = relativePos / segmentHeight;// position in percent between [from.offset] and [to.offset].\n\n    float gradientAlpha = uAlpha * currentColor.a;\n    vec4 gradientColor = mix(colorFrom, colorTo, relativePercent) * gradientAlpha;\n\n    if (uReplace < 0.5) {\n        // mix resulting color with current color\n        finalColor = gradientColor + currentColor*(1.-gradientColor.a);\n    } else {\n        // replace with gradient color\n        finalColor = gradientColor;\n    }\n}\n";


var $82fe1f32b4975de0$export$2e2bcd8739ae039 = "in vec2 aPosition;\nout vec2 vTextureCoord;\nout vec2 vFilterCoord;\n\nuniform vec4 uInputSize;\nuniform vec4 uOutputFrame;\nuniform vec4 uOutputTexture;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;\n    \n    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aPosition * (uOutputFrame.zw * uInputSize.zw);\n}\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n    vFilterCoord = vTextureCoord * uInputSize.xy / uOutputFrame.zw;\n}\n";


var $b49ba8df25276103$export$2e2bcd8739ae039 = "struct BaseUniforms {\n  uOptions: vec4<f32>,\n  uCounts: vec2<f32>,\n};\n\nstruct StopsUniforms {\n  uColors: array<vec3<f32>, MAX_STOPS>,\n  uStops: array<vec4<f32>, MAX_STOPS>,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> baseUniforms : BaseUniforms;\n@group(1) @binding(1) var<uniform> stopsUniforms : StopsUniforms;\n\nstruct VSOutput {\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>,\n  @location(1) coord : vec2<f32>\n};\n\nfn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>\n{\n    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;\n\n    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nfn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);\n}\n\nfn filterCoord( vTextureCoord:vec2<f32> ) -> vec2<f32>\n{\n    return vTextureCoord * gfu.uInputSize.xy / gfu.uOutputFrame.zw;\n}\n\nfn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);  \n}\n\nfn getSize() -> vec2<f32>\n{\n  return gfu.uGlobalFrame.zw;\n}\n  \n@vertex\nfn mainVertex(\n  @location(0) aPosition : vec2<f32>, \n) -> VSOutput {\n  let vTextureCoord: vec2<f32> = filterTextureCoord(aPosition);\n  return VSOutput(\n   filterVertexPosition(aPosition),\n   vTextureCoord,\n   filterCoord(vTextureCoord),\n  );\n}\n\nstruct ColorStop {\n  offset: f32,\n  color: vec3<f32>,\n  alpha: f32,\n};\n\nfn rotate2d(angle: f32) -> mat2x2<f32>{\n  return mat2x2(cos(angle), -sin(angle),\n  sin(angle), cos(angle));\n}\n\nfn projectLinearPosition(pos: vec2<f32>, angle: f32) -> f32 {\n  var center: vec2<f32> = vec2<f32>(0.5);\n  var result: vec2<f32> = pos - center;\n  result = rotate2d(angle) * result;\n  result = result + center;\n  return clamp(result.x, 0.0, 1.0);\n}\n\nfn projectRadialPosition(pos: vec2<f32>) -> f32 {\n  var r: f32 = distance(pos, vec2<f32>(0.5));\n  return clamp(2.0 * r, 0.0, 1.0);\n}\n\nfn projectAnglePosition(pos: vec2<f32>, angle: f32) -> f32 {\n  var center: vec2<f32> = pos - vec2<f32>(0.5, 0.5);\n  var polarAngle: f32 = atan2(-center.y, center.x);\n  return ((polarAngle + angle) % PI_2) / PI_2;\n}\n\nfn projectPosition(pos: vec2<f32>, gradientType: i32, angle: f32) -> f32 {\n  if (gradientType == TYPE_LINEAR) {\n      return projectLinearPosition(pos, angle);\n  } else if (gradientType == TYPE_RADIAL) {\n      return projectRadialPosition(pos);\n  } else if (gradientType == TYPE_CONIC) {\n      return projectAnglePosition(pos, angle);\n  }\n\n  return pos.y;\n}\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>,\n  @location(1) coord : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let uType: i32 = i32(baseUniforms.uOptions[0]);\n  let uAngle: f32 = baseUniforms.uOptions[1];\n  let uAlpha: f32 = baseUniforms.uOptions[2];\n  let uReplace: f32 = baseUniforms.uOptions[3];\n\n  let uNumStops: i32 = i32(baseUniforms.uCounts[0]);\n  let uMaxColors: f32 = baseUniforms.uCounts[1];\n\n  // current/original color\n  var currentColor: vec4<f32> = textureSample(uTexture, uSampler, uv);\n\n  // skip calculations if gradient alpha is 0\n  if (uAlpha == 0.0) { return currentColor; }\n\n  // project position\n  var y: f32 = projectPosition(coord, uType, radians(uAngle));\n\n  // check gradient bounds\n  var offsetMin: f32 = stopsUniforms.uStops[0][0];\n  var offsetMax: f32 = 0.0;\n\n  let numStops: i32 = uNumStops;\n\n  for (var i: i32 = 0; i < MAX_STOPS; i = i + 1) {\n      if (i == numStops - 1) { // last index\n          offsetMax = stopsUniforms.uStops[i][0];\n      }\n  }\n\n  if (y  < offsetMin || y > offsetMax) { return currentColor; }\n\n  // limit colors\n  if (uMaxColors > 0.0) {\n      var stepSize: f32 = 1.0 / uMaxColors;\n      var stepNumber: f32 = floor(y / stepSize);\n      y = stepSize * (stepNumber + 0.5); // offset by 0.5 to use color from middle of segment\n  }\n\n  // find color stops\n  var stopFrom: ColorStop;\n  var stopTo: ColorStop;\n\n  for (var i: i32 = 0; i < MAX_STOPS; i = i + 1) {\n      if (y >= stopsUniforms.uStops[i][0]) {\n          stopFrom = ColorStop(stopsUniforms.uStops[i][0], stopsUniforms.uColors[i], stopsUniforms.uStops[i][1]);\n          stopTo = ColorStop(stopsUniforms.uStops[i + 1][0], stopsUniforms.uColors[i + 1], stopsUniforms.uStops[i + 1][1]);\n      }\n\n      if (i == numStops - 1) { // last index\n          break;\n      }\n  }\n\n  // mix colors from stops\n  var colorFrom: vec4<f32> = vec4<f32>(stopFrom.color * stopFrom.alpha, stopFrom.alpha);\n  var colorTo: vec4<f32> = vec4<f32>(stopTo.color * stopTo.alpha, stopTo.alpha);\n\n  var segmentHeight: f32 = stopTo.offset - stopFrom.offset;\n  var relativePos: f32 = y - stopFrom.offset; // position from 0 to [segmentHeight]\n  var relativePercent: f32 = relativePos / segmentHeight; // position in percent between [from.offset] and [to.offset].\n\n  var gradientAlpha: f32 = uAlpha * currentColor.a;\n  var gradientColor: vec4<f32> = mix(colorFrom, colorTo, relativePercent) * gradientAlpha;\n\n  if (uReplace < 0.5) {\n      // mix resulting color with current color\n      return gradientColor + currentColor * (1.0 - gradientColor.a);\n  } else {\n      // replace with gradient color\n      return gradientColor;\n  }\n}\n\nconst PI: f32 = 3.14159265358979323846264;\nconst PI_2: f32 = PI * 2.0;\n\nconst TYPE_LINEAR: i32 = 0;\nconst TYPE_RADIAL: i32 = 1;\nconst TYPE_CONIC: i32 = 2;\nconst MAX_STOPS: i32 = 32;";


// Copyright (c) 2014 Rafael Caricio. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.
var $7bab4dec15e56ebf$var$GradientParser = $7bab4dec15e56ebf$var$GradientParser || {};
$7bab4dec15e56ebf$var$GradientParser.stringify = function() {
    var visitor = {
        "visit_linear-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_repeating-linear-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_radial-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_repeating-radial-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_gradient": function(node) {
            var orientation = visitor.visit(node.orientation);
            if (orientation) orientation += ", ";
            return node.type + "(" + orientation + visitor.visit(node.colorStops) + ")";
        },
        "visit_shape": function(node) {
            var result = node.value, at = visitor.visit(node.at), style = visitor.visit(node.style);
            if (style) result += " " + style;
            if (at) result += " at " + at;
            return result;
        },
        "visit_default-radial": function(node) {
            var result = "", at = visitor.visit(node.at);
            if (at) result += at;
            return result;
        },
        "visit_extent-keyword": function(node) {
            var result = node.value, at = visitor.visit(node.at);
            if (at) result += " at " + at;
            return result;
        },
        "visit_position-keyword": function(node) {
            return node.value;
        },
        "visit_position": function(node) {
            return visitor.visit(node.value.x) + " " + visitor.visit(node.value.y);
        },
        "visit_%": function(node) {
            return node.value + "%";
        },
        "visit_em": function(node) {
            return node.value + "em";
        },
        "visit_px": function(node) {
            return node.value + "px";
        },
        "visit_literal": function(node) {
            return visitor.visit_color(node.value, node);
        },
        "visit_hex": function(node) {
            return visitor.visit_color("#" + node.value, node);
        },
        "visit_rgb": function(node) {
            return visitor.visit_color("rgb(" + node.value.join(", ") + ")", node);
        },
        "visit_rgba": function(node) {
            return visitor.visit_color("rgba(" + node.value.join(", ") + ")", node);
        },
        "visit_color": function(resultColor, node) {
            var result = resultColor, length = visitor.visit(node.length);
            if (length) result += " " + length;
            return result;
        },
        "visit_angular": function(node) {
            return node.value + "deg";
        },
        "visit_directional": function(node) {
            return "to " + node.value;
        },
        "visit_array": function(elements) {
            var result = "", size = elements.length;
            elements.forEach(function(element, i) {
                result += visitor.visit(element);
                if (i < size - 1) result += ", ";
            });
            return result;
        },
        "visit": function(element) {
            if (!element) return "";
            var result = "";
            if (element instanceof Array) return visitor.visit_array(element, result);
            else if (element.type) {
                var nodeVisitor = visitor["visit_" + element.type];
                if (nodeVisitor) return nodeVisitor(element);
                else throw Error("Missing visitor visit_" + element.type);
            } else throw Error("Invalid node.");
        }
    };
    return function(root) {
        return visitor.visit(root);
    };
}();
// Copyright (c) 2014 Rafael Caricio. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.
var $7bab4dec15e56ebf$var$GradientParser = $7bab4dec15e56ebf$var$GradientParser || {};
$7bab4dec15e56ebf$var$GradientParser.parse = function() {
    var tokens = {
        linearGradient: /^(\-(webkit|o|ms|moz)\-)?(linear\-gradient)/i,
        repeatingLinearGradient: /^(\-(webkit|o|ms|moz)\-)?(repeating\-linear\-gradient)/i,
        radialGradient: /^(\-(webkit|o|ms|moz)\-)?(radial\-gradient)/i,
        repeatingRadialGradient: /^(\-(webkit|o|ms|moz)\-)?(repeating\-radial\-gradient)/i,
        sideOrCorner: /^to (left (top|bottom)|right (top|bottom)|left|right|top|bottom)/i,
        extentKeywords: /^(closest\-side|closest\-corner|farthest\-side|farthest\-corner|contain|cover)/,
        positionKeywords: /^(left|center|right|top|bottom)/i,
        pixelValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))px/,
        percentageValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))\%/,
        emValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))em/,
        angleValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))deg/,
        startCall: /^\(/,
        endCall: /^\)/,
        comma: /^,/,
        hexColor: /^\#([0-9a-fA-F]+)/,
        literalColor: /^([a-zA-Z]+)/,
        rgbColor: /^rgb/i,
        rgbaColor: /^rgba/i,
        number: /^(([0-9]*\.[0-9]+)|([0-9]+\.?))/
    };
    var input = "";
    function error(msg) {
        var err = new Error(input + ": " + msg);
        err.source = input;
        throw err;
    }
    function getAST() {
        var ast = matchListDefinitions();
        if (input.length > 0) error("Invalid input not EOF");
        return ast;
    }
    function matchListDefinitions() {
        return matchListing(matchDefinition);
    }
    function matchDefinition() {
        return matchGradient("linear-gradient", tokens.linearGradient, matchLinearOrientation) || matchGradient("repeating-linear-gradient", tokens.repeatingLinearGradient, matchLinearOrientation) || matchGradient("radial-gradient", tokens.radialGradient, matchListRadialOrientations) || matchGradient("repeating-radial-gradient", tokens.repeatingRadialGradient, matchListRadialOrientations);
    }
    function matchGradient(gradientType, pattern, orientationMatcher) {
        return matchCall(pattern, function(captures) {
            var orientation = orientationMatcher();
            if (orientation) {
                if (!scan(tokens.comma)) error("Missing comma before color stops");
            }
            return {
                type: gradientType,
                orientation: orientation,
                colorStops: matchListing(matchColorStop)
            };
        });
    }
    function matchCall(pattern, callback) {
        var captures = scan(pattern);
        if (captures) {
            if (!scan(tokens.startCall)) error("Missing (");
            var result = callback(captures);
            if (!scan(tokens.endCall)) error("Missing )");
            return result;
        }
    }
    function matchLinearOrientation() {
        return matchSideOrCorner() || matchAngle();
    }
    function matchSideOrCorner() {
        return match("directional", tokens.sideOrCorner, 1);
    }
    function matchAngle() {
        return match("angular", tokens.angleValue, 1);
    }
    function matchListRadialOrientations() {
        var radialOrientations, radialOrientation = matchRadialOrientation(), lookaheadCache;
        if (radialOrientation) {
            radialOrientations = [];
            radialOrientations.push(radialOrientation);
            lookaheadCache = input;
            if (scan(tokens.comma)) {
                radialOrientation = matchRadialOrientation();
                if (radialOrientation) radialOrientations.push(radialOrientation);
                else input = lookaheadCache;
            }
        }
        return radialOrientations;
    }
    function matchRadialOrientation() {
        var radialType = matchCircle() || matchEllipse();
        if (radialType) radialType.at = matchAtPosition();
        else {
            var extent = matchExtentKeyword();
            if (extent) {
                radialType = extent;
                var positionAt = matchAtPosition();
                if (positionAt) radialType.at = positionAt;
            } else {
                var defaultPosition = matchPositioning();
                if (defaultPosition) radialType = {
                    type: "default-radial",
                    at: defaultPosition
                };
            }
        }
        return radialType;
    }
    function matchCircle() {
        var circle = match("shape", /^(circle)/i, 0);
        if (circle) circle.style = matchLength() || matchExtentKeyword();
        return circle;
    }
    function matchEllipse() {
        var ellipse = match("shape", /^(ellipse)/i, 0);
        if (ellipse) ellipse.style = matchDistance() || matchExtentKeyword();
        return ellipse;
    }
    function matchExtentKeyword() {
        return match("extent-keyword", tokens.extentKeywords, 1);
    }
    function matchAtPosition() {
        if (match("position", /^at/, 0)) {
            var positioning = matchPositioning();
            if (!positioning) error("Missing positioning value");
            return positioning;
        }
    }
    function matchPositioning() {
        var location = matchCoordinates();
        if (location.x || location.y) return {
            type: "position",
            value: location
        };
    }
    function matchCoordinates() {
        return {
            x: matchDistance(),
            y: matchDistance()
        };
    }
    function matchListing(matcher) {
        var captures = matcher(), result = [];
        if (captures) {
            result.push(captures);
            while(scan(tokens.comma)){
                captures = matcher();
                if (captures) result.push(captures);
                else error("One extra comma");
            }
        }
        return result;
    }
    function matchColorStop() {
        var color = matchColor();
        if (!color) error("Expected color definition");
        color.length = matchDistance();
        return color;
    }
    function matchColor() {
        return matchHexColor() || matchRGBAColor() || matchRGBColor() || matchLiteralColor();
    }
    function matchLiteralColor() {
        return match("literal", tokens.literalColor, 0);
    }
    function matchHexColor() {
        return match("hex", tokens.hexColor, 1);
    }
    function matchRGBColor() {
        return matchCall(tokens.rgbColor, function() {
            return {
                type: "rgb",
                value: matchListing(matchNumber)
            };
        });
    }
    function matchRGBAColor() {
        return matchCall(tokens.rgbaColor, function() {
            return {
                type: "rgba",
                value: matchListing(matchNumber)
            };
        });
    }
    function matchNumber() {
        return scan(tokens.number)[1];
    }
    function matchDistance() {
        return match("%", tokens.percentageValue, 1) || matchPositionKeyword() || matchLength();
    }
    function matchPositionKeyword() {
        return match("position-keyword", tokens.positionKeywords, 1);
    }
    function matchLength() {
        return match("px", tokens.pixelValue, 1) || match("em", tokens.emValue, 1);
    }
    function match(type, pattern, captureIndex) {
        var captures = scan(pattern);
        if (captures) return {
            type: type,
            value: captures[captureIndex]
        };
    }
    function scan(regexp) {
        var captures, blankCaptures;
        blankCaptures = /^[\n\r\t\s]+/.exec(input);
        if (blankCaptures) consume(blankCaptures[0].length);
        captures = regexp.exec(input);
        if (captures) consume(captures[0].length);
        return captures;
    }
    function consume(size) {
        input = input.substr(size);
    }
    return function(code) {
        input = code.toString();
        return getAST();
    };
}();
var $7bab4dec15e56ebf$export$98e6a39c04603d36 = $7bab4dec15e56ebf$var$GradientParser.parse;
$7bab4dec15e56ebf$var$GradientParser.stringify;



var $bEj7k = parcelRequire("bEj7k");
function $c8ca14978b59862a$export$563845e8776dd2a1(cssGradient) {
    const cssGradientNodes = (0, $7bab4dec15e56ebf$export$98e6a39c04603d36)($c8ca14978b59862a$export$d58c8edb910f9d7a(cssGradient));
    if (cssGradientNodes.length === 0) throw new Error("Invalid CSS gradient.");
    else if (cssGradientNodes.length !== 1) throw new Error("Unsupported CSS gradient (multiple gradients is not supported).");
    const cssGradientNode = cssGradientNodes[0];
    const type = $c8ca14978b59862a$export$c5b75842cdcdd36e(cssGradientNode.type);
    const stops = $c8ca14978b59862a$export$7e958be60ce23d29(cssGradientNode.colorStops);
    const angle = $c8ca14978b59862a$export$7c7530c3a66c65e6(cssGradientNode.orientation);
    return {
        type: type,
        stops: stops,
        angle: angle
    };
}
function $c8ca14978b59862a$export$c5b75842cdcdd36e(type) {
    const supportedTypes = {
        "linear-gradient": 0,
        "radial-gradient": 1
    };
    if (!(type in supportedTypes)) throw new Error(`Unsupported gradient type "${type}"`);
    return supportedTypes[type];
}
function $c8ca14978b59862a$export$7e958be60ce23d29(stops) {
    const offsets = $c8ca14978b59862a$export$2ae3a005160a31a6(stops);
    const result = [];
    const color = new (0, $bEj7k.Color)();
    for(let i = 0; i < stops.length; i++){
        const colorString = $c8ca14978b59862a$export$488c23733c9d6ba6(stops[i]);
        const rgbaColor = color.setValue(colorString).toArray();
        result.push({
            offset: offsets[i],
            color: rgbaColor.slice(0, 3),
            alpha: rgbaColor[3]
        });
    }
    return result;
}
function $c8ca14978b59862a$export$488c23733c9d6ba6(stop) {
    switch(stop.type){
        case "hex":
            return `#${stop.value}`;
        case "literal":
            return stop.value;
        default:
            return `${stop.type}(${stop.value.join(",")})`;
    }
}
function $c8ca14978b59862a$export$2ae3a005160a31a6(stops) {
    const offsets = [];
    const dynamicOffset = -1;
    for(let i = 0; i < stops.length; i++){
        const cssStop = stops[i];
        let stopOffset = dynamicOffset;
        if (cssStop.type === "literal") {
            if (cssStop.length && "type" in cssStop.length && cssStop.length.type === "%" && "value" in cssStop.length) stopOffset = parseFloat(cssStop.length.value) / 100;
        }
        offsets.push(stopOffset);
    }
    const findNextFixedStop = (fromIndex)=>{
        for(let k = fromIndex; k < offsets.length; k++){
            if (offsets[k] !== dynamicOffset) return {
                indexDelta: k - fromIndex,
                offset: offsets[k]
            };
        }
        return {
            indexDelta: offsets.length - 1 - fromIndex,
            offset: 1
        };
    };
    let prevFixedOffset = 0;
    for(let i = 0; i < offsets.length; i++){
        const offset = offsets[i];
        if (offset !== dynamicOffset) prevFixedOffset = offset;
        else if (i === 0) offsets[i] = 0;
        else if (i + 1 === offsets.length) offsets[i] = 1;
        else {
            const nextFixed = findNextFixedStop(i);
            const offsetDelta = nextFixed.offset - prevFixedOffset;
            const stepSize = offsetDelta / (1 + nextFixed.indexDelta);
            for(let s = 0; s <= nextFixed.indexDelta; s++)offsets[i + s] = prevFixedOffset + (s + 1) * stepSize;
            i += nextFixed.indexDelta;
            prevFixedOffset = offsets[i];
        }
    }
    return offsets.map($c8ca14978b59862a$var$fixFloatRounding);
}
function $c8ca14978b59862a$var$fixFloatRounding(value) {
    const maxLength = 6;
    if (value.toString().length > maxLength) return parseFloat(value.toString().substring(0, maxLength));
    return value;
}
function $c8ca14978b59862a$export$7c7530c3a66c65e6(orientation) {
    if (typeof orientation === "undefined") return 0;
    if ("type" in orientation && "value" in orientation) switch(orientation.type){
        case "angular":
            return parseFloat(orientation.value);
        case "directional":
            return $c8ca14978b59862a$export$279ee792baf424dc(orientation.value);
    }
    return 0;
}
function $c8ca14978b59862a$export$279ee792baf424dc(value) {
    const supportedValues = {
        left: 270,
        top: 0,
        bottom: 180,
        right: 90,
        "left top": 315,
        "top left": 315,
        "left bottom": 225,
        "bottom left": 225,
        "right top": 45,
        "top right": 45,
        "right bottom": 135,
        "bottom right": 135
    };
    if (!(value in supportedValues)) throw new Error(`Unsupported directional value "${value}"`);
    return supportedValues[value];
}
function $c8ca14978b59862a$export$d58c8edb910f9d7a(value) {
    let value_ = value.replace(/\s{2,}/gu, " ");
    value_ = value_.replace(/;/g, "");
    value_ = value_.replace(/ ,/g, ",");
    value_ = value_.replace(/\( /g, "(");
    value_ = value_.replace(/ \)/g, ")");
    return value_.trim();
}
 //# sourceMappingURL=CssGradientParser.mjs.map


var $8f4698a3a5ea1fd6$var$__defProp = Object.defineProperty;
var $8f4698a3a5ea1fd6$var$__defNormalProp = (obj, key, value)=>key in obj ? $8f4698a3a5ea1fd6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8f4698a3a5ea1fd6$var$__publicField = (obj, key, value)=>{
    $8f4698a3a5ea1fd6$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $8f4698a3a5ea1fd6$var$ANGLE_OFFSET = 90;
function $8f4698a3a5ea1fd6$var$sortColorStops(stops) {
    return [
        ...stops
    ].sort((a, b)=>a.offset - b.offset);
}
const $8f4698a3a5ea1fd6$var$_ColorGradientFilter = class _ColorGradientFilter extends (0, $ld81y.Filter) {
    /**
   * @param options - Options for the ColorGradientFilter constructor.
   */ constructor(options){
        if (options && "css" in options) options = {
            ...(0, $c8ca14978b59862a$export$563845e8776dd2a1)(options.css || ""),
            alpha: options.alpha ?? _ColorGradientFilter.defaults.alpha,
            maxColors: options.maxColors ?? _ColorGradientFilter.defaults.maxColors
        };
        else options = {
            ..._ColorGradientFilter.defaults,
            ...options
        };
        if (!options.stops || options.stops.length < 2) throw new Error("ColorGradientFilter requires at least 2 color stops.");
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: $b49ba8df25276103$export$2e2bcd8739ae039,
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $b49ba8df25276103$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $82fe1f32b4975de0$export$2e2bcd8739ae039,
            fragment: $d0cdc919e283289e$export$2e2bcd8739ae039,
            name: "color-gradient-filter"
        });
        const maxStops = 32;
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                baseUniforms: {
                    uOptions: {
                        value: [
                            // Gradient Type
                            options.type,
                            // Gradient Angle
                            options.angle ?? $8f4698a3a5ea1fd6$var$ANGLE_OFFSET,
                            // Master Alpha
                            options.alpha,
                            // Replace Base Color
                            options.replace ? 1 : 0
                        ],
                        type: "vec4<f32>"
                    },
                    uCounts: {
                        value: [
                            // Number of Stops
                            options.stops.length,
                            // Max Gradient Colors
                            options.maxColors
                        ],
                        type: "vec2<f32>"
                    }
                },
                stopsUniforms: {
                    uColors: {
                        value: new Float32Array(maxStops * 3),
                        type: "vec3<f32>",
                        size: maxStops
                    },
                    // We only need vec2, but we need to pad to eliminate the WGSL warning, TODO: @Mat ?
                    uStops: {
                        value: new Float32Array(maxStops * 4),
                        type: "vec4<f32>",
                        size: maxStops
                    }
                }
            }
        });
        $8f4698a3a5ea1fd6$var$__publicField(this, "baseUniforms");
        $8f4698a3a5ea1fd6$var$__publicField(this, "stopsUniforms");
        $8f4698a3a5ea1fd6$var$__publicField(this, "_stops", []);
        this.baseUniforms = this.resources.baseUniforms.uniforms;
        this.stopsUniforms = this.resources.stopsUniforms.uniforms;
        Object.assign(this, options);
    }
    get stops() {
        return this._stops;
    }
    set stops(stops) {
        const sortedStops = $8f4698a3a5ea1fd6$var$sortColorStops(stops);
        const color = new (0, $bEj7k.Color)();
        let r;
        let g;
        let b;
        for(let i = 0; i < sortedStops.length; i++){
            color.setValue(sortedStops[i].color);
            const indexStart = i * 3;
            [r, g, b] = color.toArray();
            this.stopsUniforms.uColors[indexStart] = r;
            this.stopsUniforms.uColors[indexStart + 1] = g;
            this.stopsUniforms.uColors[indexStart + 2] = b;
            this.stopsUniforms.uStops[i * 4] = sortedStops[i].offset;
            this.stopsUniforms.uStops[i * 4 + 1] = sortedStops[i].alpha;
        }
        this.baseUniforms.uCounts[0] = sortedStops.length;
        this._stops = sortedStops;
    }
    /**
  * The type of gradient
  * @default ColorGradientFilter.LINEAR
  */ get type() {
        return this.baseUniforms.uOptions[0];
    }
    set type(value) {
        this.baseUniforms.uOptions[0] = value;
    }
    /**
  * The angle of the gradient in degrees
  * @default 90
  */ get angle() {
        return this.baseUniforms.uOptions[1] + $8f4698a3a5ea1fd6$var$ANGLE_OFFSET;
    }
    set angle(value) {
        this.baseUniforms.uOptions[1] = value - $8f4698a3a5ea1fd6$var$ANGLE_OFFSET;
    }
    /**
  * The alpha value of the gradient (0-1)
  * @default 1
  */ get alpha() {
        return this.baseUniforms.uOptions[2];
    }
    set alpha(value) {
        this.baseUniforms.uOptions[2] = value;
    }
    /**
  * The maximum number of colors to render (0 = no limit)
  * @default 0
  */ get maxColors() {
        return this.baseUniforms.uCounts[1];
    }
    set maxColors(value) {
        this.baseUniforms.uCounts[1] = value;
    }
    /**
   * If true, the gradient will replace the existing color, otherwise it
   * will be multiplied with it
   * @default false
   */ get replace() {
        return this.baseUniforms.uOptions[3] > 0.5;
    }
    set replace(value) {
        this.baseUniforms.uOptions[3] = value ? 1 : 0;
    }
};
/** Gradient types */ $8f4698a3a5ea1fd6$var$__publicField($8f4698a3a5ea1fd6$var$_ColorGradientFilter, "LINEAR", 0);
$8f4698a3a5ea1fd6$var$__publicField($8f4698a3a5ea1fd6$var$_ColorGradientFilter, "RADIAL", 1);
$8f4698a3a5ea1fd6$var$__publicField($8f4698a3a5ea1fd6$var$_ColorGradientFilter, "CONIC", 2);
/** Default constructor options */ $8f4698a3a5ea1fd6$var$__publicField($8f4698a3a5ea1fd6$var$_ColorGradientFilter, "defaults", {
    type: $8f4698a3a5ea1fd6$var$_ColorGradientFilter.LINEAR,
    stops: [
        {
            offset: 0,
            color: 16711680,
            alpha: 1
        },
        {
            offset: 1,
            color: 255,
            alpha: 1
        }
    ],
    alpha: 1,
    angle: 90,
    maxColors: 0,
    replace: false
});
let $8f4698a3a5ea1fd6$export$e893609768979f4b = $8f4698a3a5ea1fd6$var$_ColorGradientFilter;




var $jollT = parcelRequire("jollT");
var $eIuJW = parcelRequire("eIuJW");
var $j0fPb = parcelRequire("j0fPb");
var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $44493aeeeebb9d60$export$2e2bcd8739ae039 = "in vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform sampler2D uMapTexture;\nuniform float uMix;\nuniform float uSize;\nuniform float uSliceSize;\nuniform float uSlicePixelSize;\nuniform float uSliceInnerSize;\n\nvoid main() {\n    vec4 color = texture(uTexture, vTextureCoord.xy);\n    vec4 adjusted;\n\n    if (color.a > 0.0) {\n        color.rgb /= color.a;\n        float innerWidth = uSize - 1.0;\n        float zSlice0 = min(floor(color.b * innerWidth), innerWidth);\n        float zSlice1 = min(zSlice0 + 1.0, innerWidth);\n        float xOffset = uSlicePixelSize * 0.5 + color.r * uSliceInnerSize;\n        float s0 = xOffset + (zSlice0 * uSliceSize);\n        float s1 = xOffset + (zSlice1 * uSliceSize);\n        float yOffset = uSliceSize * 0.5 + color.g * (1.0 - uSliceSize);\n        vec4 slice0Color = texture(uMapTexture, vec2(s0,yOffset));\n        vec4 slice1Color = texture(uMapTexture, vec2(s1,yOffset));\n        float zOffset = fract(color.b * innerWidth);\n        adjusted = mix(slice0Color, slice1Color, zOffset);\n\n        color.rgb *= color.a;\n    }\n\n    finalColor = vec4(mix(color, adjusted, uMix).rgb, color.a);\n\n}";


var $49a40a129bb25118$export$2e2bcd8739ae039 = "struct ColorMapUniforms {\n  uMix: f32,\n  uSize: f32,\n  uSliceSize: f32,\n  uSlicePixelSize: f32,\n  uSliceInnerSize: f32,\n};\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> colorMapUniforms : ColorMapUniforms;\n@group(1) @binding(1) var uMapTexture: texture_2d<f32>;\n@group(1) @binding(2) var uMapSampler: sampler;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  var color:vec4<f32> = textureSample(uTexture, uSampler, uv);\n\n  var adjusted: vec4<f32>;\n\n  var altColor: vec4<f32> = vec4<f32>(color.rgb / color.a, color.a);\n  let innerWidth: f32 = colorMapUniforms.uSize - 1.0;\n  let zSlice0: f32 = min(floor(color.b * innerWidth), innerWidth);\n  let zSlice1: f32 = min(zSlice0 + 1.0, innerWidth);\n  let xOffset: f32 = colorMapUniforms.uSlicePixelSize * 0.5 + color.r * colorMapUniforms.uSliceInnerSize;\n  let s0: f32 = xOffset + (zSlice0 * colorMapUniforms.uSliceSize);\n  let s1: f32 = xOffset + (zSlice1 * colorMapUniforms.uSliceSize);\n  let yOffset: f32 = colorMapUniforms.uSliceSize * 0.5 + color.g * (1.0 - colorMapUniforms.uSliceSize);\n  let slice0Color: vec4<f32> = textureSample(uMapTexture, uMapSampler, vec2(s0,yOffset));\n  let slice1Color: vec4<f32> = textureSample(uMapTexture, uMapSampler, vec2(s1,yOffset));\n  let zOffset: f32 = fract(color.b * innerWidth);\n  adjusted = mix(slice0Color, slice1Color, zOffset);\n  altColor = vec4<f32>(color.rgb * color.a, color.a);\n\n  let realColor: vec4<f32> = select(color, altColor, color.a > 0.0);\n\n  return vec4<f32>(mix(realColor, adjusted, colorMapUniforms.uMix).rgb, realColor.a);\n}";


var $026e88d3c4676276$var$__defProp = Object.defineProperty;
var $026e88d3c4676276$var$__defNormalProp = (obj, key, value)=>key in obj ? $026e88d3c4676276$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $026e88d3c4676276$var$__publicField = (obj, key, value)=>{
    $026e88d3c4676276$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $026e88d3c4676276$var$_ColorMapFilter = class _ColorMapFilter extends (0, $ld81y.Filter) {
    /** @ignore */ constructor(...args){
        let options = args[0] ?? {};
        if (options instanceof (0, $jollT.Texture) || options instanceof (0, $eIuJW.TextureSource)) {
            (0, $j0fPb.deprecation)("6.0.0", "ColorMapFilter constructor params are now options object. See params: { colorMap, nearest, mix }");
            options = {
                colorMap: options
            };
            if (args[1] !== void 0) options.nearest = args[1];
            if (args[2] !== void 0) options.mix = args[2];
        }
        options = {
            ..._ColorMapFilter.DEFAULT_OPTIONS,
            ...options
        };
        if (!options.colorMap) throw Error("No color map texture source was provided to ColorMapFilter");
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $49a40a129bb25118$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $44493aeeeebb9d60$export$2e2bcd8739ae039,
            name: "color-map-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                colorMapUniforms: {
                    uMix: {
                        value: options.mix,
                        type: "f32"
                    },
                    uSize: {
                        value: 0,
                        type: "f32"
                    },
                    uSliceSize: {
                        value: 0,
                        type: "f32"
                    },
                    uSlicePixelSize: {
                        value: 0,
                        type: "f32"
                    },
                    uSliceInnerSize: {
                        value: 0,
                        type: "f32"
                    }
                },
                uMapTexture: options.colorMap.source,
                uMapSampler: options.colorMap.source.style
            }
        });
        $026e88d3c4676276$var$__publicField(this, "uniforms");
        $026e88d3c4676276$var$__publicField(this, "_size", 0);
        $026e88d3c4676276$var$__publicField(this, "_sliceSize", 0);
        $026e88d3c4676276$var$__publicField(this, "_slicePixelSize", 0);
        $026e88d3c4676276$var$__publicField(this, "_sliceInnerSize", 0);
        $026e88d3c4676276$var$__publicField(this, "_nearest", false);
        $026e88d3c4676276$var$__publicField(this, "_scaleMode", "linear");
        $026e88d3c4676276$var$__publicField(this, "_colorMap");
        this.uniforms = this.resources.colorMapUniforms.uniforms;
        Object.assign(this, options);
    }
    /** The mix from 0 to 1, where 0 is the original image and 1 is the color mapped image. */ get mix() {
        return this.uniforms.uMix;
    }
    set mix(value) {
        this.uniforms.uMix = value;
    }
    /**
   * The size of one color slice.
   * @readonly
   */ get colorSize() {
        return this._size;
    }
    /** The colorMap texture. */ get colorMap() {
        return this._colorMap;
    }
    set colorMap(value) {
        if (!value || value === this.colorMap) return;
        const source2 = value instanceof (0, $jollT.Texture) ? value.source : value;
        source2.style.scaleMode = this._scaleMode;
        source2.autoGenerateMipmaps = false;
        this._size = source2.height;
        this._sliceSize = 1 / this._size;
        this._slicePixelSize = this._sliceSize / this._size;
        this._sliceInnerSize = this._slicePixelSize * (this._size - 1);
        this.uniforms.uSize = this._size;
        this.uniforms.uSliceSize = this._sliceSize;
        this.uniforms.uSlicePixelSize = this._slicePixelSize;
        this.uniforms.uSliceInnerSize = this._sliceInnerSize;
        this.resources.uMapTexture = source2;
        this._colorMap = value;
    }
    /** Whether use NEAREST for colorMap texture. */ get nearest() {
        return this._nearest;
    }
    set nearest(nearest) {
        this._nearest = nearest;
        this._scaleMode = nearest ? "nearest" : "linear";
        const texture = this._colorMap;
        if (texture && texture.source) {
            texture.source.scaleMode = this._scaleMode;
            texture.source.autoGenerateMipmaps = false;
            texture.source.style.update();
            texture.source.update();
        }
    }
    /**
   * If the colorMap is based on canvas,
   * and the content of canvas has changed, then call `updateColorMap` for update texture.
   */ updateColorMap() {
        const texture = this._colorMap;
        if (texture?.source) {
            texture.source.update();
            this.colorMap = texture;
        }
    }
    /**
   * Destroys this filter
   * @default false
   */ destroy() {
        this._colorMap?.destroy();
        super.destroy();
    }
};
/** Default values for options. */ $026e88d3c4676276$var$__publicField($026e88d3c4676276$var$_ColorMapFilter, "DEFAULT_OPTIONS", {
    colorMap: (0, $jollT.Texture).WHITE,
    nearest: false,
    mix: 1
});
let $026e88d3c4676276$export$676635c5c496e2b5 = $026e88d3c4676276$var$_ColorMapFilter;



var $j0fPb = parcelRequire("j0fPb");
var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $bEj7k = parcelRequire("bEj7k");
var $ld81y = parcelRequire("ld81y");


var $0cccb1814d6def93$export$2e2bcd8739ae039 = "in vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec3 uColor;\nuniform float uAlpha;\n\nvoid main(void) {\n    vec4 c = texture(uTexture, vTextureCoord);\n    finalColor = vec4(mix(c.rgb, uColor.rgb, c.a * uAlpha), c.a);\n}\n";


var $62f910d5f16891e4$export$2e2bcd8739ae039 = "struct ColorOverlayUniforms {\n    uColor: vec3<f32>,\n    uAlpha: f32,\n};\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> colorOverlayUniforms : ColorOverlayUniforms;\n\n@fragment\nfn mainFragment(\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n    let c = textureSample(uTexture, uSampler, uv);\n    return vec4<f32>(mix(c.rgb, colorOverlayUniforms.uColor.rgb, c.a * colorOverlayUniforms.uAlpha), c.a);\n}\n";


var $5e46bd2d65d18794$var$__defProp = Object.defineProperty;
var $5e46bd2d65d18794$var$__defNormalProp = (obj, key, value)=>key in obj ? $5e46bd2d65d18794$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5e46bd2d65d18794$var$__publicField = (obj, key, value)=>{
    $5e46bd2d65d18794$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $5e46bd2d65d18794$var$_ColorOverlayFilter = class _ColorOverlayFilter extends (0, $ld81y.Filter) {
    /** @ignore */ constructor(...args){
        let options = args[0] ?? {};
        if (typeof options === "number" || Array.isArray(options) || options instanceof Float32Array) {
            (0, $j0fPb.deprecation)("6.0.0", "ColorOverlayFilter constructor params are now options object. See params: { color, alpha }");
            options = {
                color: options
            };
            if (args[1] !== void 0) options.alpha = args[1];
        }
        options = {
            ..._ColorOverlayFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $62f910d5f16891e4$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $0cccb1814d6def93$export$2e2bcd8739ae039,
            name: "color-overlay-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                colorOverlayUniforms: {
                    uColor: {
                        value: new Float32Array(3),
                        type: "vec3<f32>"
                    },
                    uAlpha: {
                        value: options.alpha,
                        type: "f32"
                    }
                }
            }
        });
        $5e46bd2d65d18794$var$__publicField(this, "uniforms");
        $5e46bd2d65d18794$var$__publicField(this, "_color");
        this.uniforms = this.resources.colorOverlayUniforms.uniforms;
        this._color = new (0, $bEj7k.Color)();
        this.color = options.color ?? 0;
    }
    /**
   * The over color source
   * @member {number|Array<number>|Float32Array}
   * @default 0x000000
   */ get color() {
        return this._color.value;
    }
    set color(value) {
        this._color.setValue(value);
        const [r, g, b] = this._color.toArray();
        this.uniforms.uColor[0] = r;
        this.uniforms.uColor[1] = g;
        this.uniforms.uColor[2] = b;
    }
    /**
   * The alpha value of the color
   * @default 1
   */ get alpha() {
        return this.uniforms.uAlpha;
    }
    set alpha(value) {
        this.uniforms.uAlpha = value;
    }
};
/** Default shockwave filter options */ $5e46bd2d65d18794$var$__publicField($5e46bd2d65d18794$var$_ColorOverlayFilter, "DEFAULT_OPTIONS", {
    /** The color of the overlay */ color: 0,
    /** The alpha of the overlay */ alpha: 1
});
let $5e46bd2d65d18794$export$d8402030d196095b = $5e46bd2d65d18794$var$_ColorOverlayFilter;



var $j0fPb = parcelRequire("j0fPb");
var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $bEj7k = parcelRequire("bEj7k");
var $ld81y = parcelRequire("ld81y");


var $5e8cfc1fead3ff1b$export$2e2bcd8739ae039 = "in vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec3 uOriginalColor;\nuniform vec3 uTargetColor;\nuniform float uTolerance;\n\nvoid main(void) {\n    vec4 c = texture(uTexture, vTextureCoord);\n    vec3 colorDiff = uOriginalColor - (c.rgb / max(c.a, 0.0000000001));\n    float colorDistance = length(colorDiff);\n    float doReplace = step(colorDistance, uTolerance);\n    finalColor = vec4(mix(c.rgb, (uTargetColor + colorDiff) * c.a, doReplace), c.a);\n}\n";


var $deee16fd095494fc$export$2e2bcd8739ae039 = "struct ColorReplaceUniforms {\n  uOriginalColor: vec3<f32>,\n  uTargetColor: vec3<f32>,\n  uTolerance: f32,\n};\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> colorReplaceUniforms : ColorReplaceUniforms;\n\n@fragment\nfn mainFragment(\n   @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let sample: vec4<f32> = textureSample(uTexture, uSampler, uv);\n\n  let colorDiff: vec3<f32> = colorReplaceUniforms.uOriginalColor - (sample.rgb / max(sample.a, 0.0000000001));\n  let colorDistance: f32 = length(colorDiff);\n  let doReplace: f32 = step(colorDistance, colorReplaceUniforms.uTolerance);\n\n  return vec4<f32>(mix(sample.rgb, (colorReplaceUniforms.uTargetColor + colorDiff) * sample.a, doReplace), sample.a);\n}";


var $ceec17f84d3fb441$var$__defProp = Object.defineProperty;
var $ceec17f84d3fb441$var$__defNormalProp = (obj, key, value)=>key in obj ? $ceec17f84d3fb441$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ceec17f84d3fb441$var$__publicField = (obj, key, value)=>{
    $ceec17f84d3fb441$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $ceec17f84d3fb441$var$_ColorReplaceFilter = class _ColorReplaceFilter extends (0, $ld81y.Filter) {
    /** @ignore */ constructor(...args){
        let options = args[0] ?? {};
        if (typeof options === "number" || Array.isArray(options) || options instanceof Float32Array) {
            (0, $j0fPb.deprecation)("6.0.0", "ColorReplaceFilter constructor params are now options object. See params: { originalColor, targetColor, tolerance }");
            options = {
                originalColor: options
            };
            if (args[1] !== void 0) options.targetColor = args[1];
            if (args[2] !== void 0) options.tolerance = args[2];
        }
        options = {
            ..._ColorReplaceFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $deee16fd095494fc$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $5e8cfc1fead3ff1b$export$2e2bcd8739ae039,
            name: "color-replace-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                colorReplaceUniforms: {
                    uOriginalColor: {
                        value: new Float32Array(3),
                        type: "vec3<f32>"
                    },
                    uTargetColor: {
                        value: new Float32Array(3),
                        type: "vec3<f32>"
                    },
                    uTolerance: {
                        value: options.tolerance,
                        type: "f32"
                    }
                }
            }
        });
        $ceec17f84d3fb441$var$__publicField(this, "uniforms");
        $ceec17f84d3fb441$var$__publicField(this, "_originalColor");
        $ceec17f84d3fb441$var$__publicField(this, "_targetColor");
        this.uniforms = this.resources.colorReplaceUniforms.uniforms;
        this._originalColor = new (0, $bEj7k.Color)();
        this._targetColor = new (0, $bEj7k.Color)();
        this.originalColor = options.originalColor ?? 16711680;
        this.targetColor = options.targetColor ?? 0;
        Object.assign(this, options);
    }
    /**
   * The color that will be changed.
   * @example [1.0, 1.0, 1.0] = 0xffffff
   * @default 0xff0000
   */ get originalColor() {
        return this._originalColor.value;
    }
    set originalColor(value) {
        this._originalColor.setValue(value);
        const [r, g, b] = this._originalColor.toArray();
        this.uniforms.uOriginalColor[0] = r;
        this.uniforms.uOriginalColor[1] = g;
        this.uniforms.uOriginalColor[2] = b;
    }
    /**
    * The resulting color.
    * @example [1.0, 1.0, 1.0] = 0xffffff
    * @default 0x000000
    */ get targetColor() {
        return this._targetColor.value;
    }
    set targetColor(value) {
        this._targetColor.setValue(value);
        const [r, g, b] = this._targetColor.toArray();
        this.uniforms.uTargetColor[0] = r;
        this.uniforms.uTargetColor[1] = g;
        this.uniforms.uTargetColor[2] = b;
    }
    /**
    * Tolerance/sensitivity of the floating-point comparison between colors (lower = more exact, higher = more inclusive)
    * @default 0.4
    */ get tolerance() {
        return this.uniforms.uTolerance;
    }
    set tolerance(value) {
        this.uniforms.uTolerance = value;
    }
    /**
   * @deprecated since 6.0.0
   *
   * The resulting color, as a 3 component RGB e.g. [1.0, 0.5, 1.0]
   * @member {number|Array<number>|Float32Array}
   * @default 0x000000
   * @see ColorReplaceFilter#targetColor
   */ set newColor(value) {
        (0, $j0fPb.deprecation)("6.0.0", "ColorReplaceFilter.newColor is deprecated, please use ColorReplaceFilter.targetColor instead");
        this.targetColor = value;
    }
    get newColor() {
        (0, $j0fPb.deprecation)("6.0.0", "ColorReplaceFilter.newColor is deprecated, please use ColorReplaceFilter.targetColor instead");
        return this.targetColor;
    }
    /**
   * @deprecated since 6.0.0
   *
   * Tolerance/sensitivity of the floating-point comparison between colors (lower = more exact, higher = more inclusive)
   * @default 0.4
   * @see ColorReplaceFilter#tolerance
   */ set epsilon(value) {
        (0, $j0fPb.deprecation)("6.0.0", "ColorReplaceFilter.epsilon is deprecated, please use ColorReplaceFilter.tolerance instead");
        this.tolerance = value;
    }
    get epsilon() {
        (0, $j0fPb.deprecation)("6.0.0", "ColorReplaceFilter.epsilon is deprecated, please use ColorReplaceFilter.tolerance instead");
        return this.tolerance;
    }
};
/** Default values for options. */ $ceec17f84d3fb441$var$__publicField($ceec17f84d3fb441$var$_ColorReplaceFilter, "DEFAULT_OPTIONS", {
    originalColor: 16711680,
    targetColor: 0,
    tolerance: 0.4
});
let $ceec17f84d3fb441$export$25638752278038b9 = $ceec17f84d3fb441$var$_ColorReplaceFilter;



var $j0fPb = parcelRequire("j0fPb");
var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $39a9caf57f855665$export$2e2bcd8739ae039 = "in vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec2 uTexelSize;\nuniform mat3 uMatrix;\n\nvoid main(void)\n{\n    vec4 c11 = texture(uTexture, vTextureCoord - uTexelSize); // top left\n    vec4 c12 = texture(uTexture, vec2(vTextureCoord.x, vTextureCoord.y - uTexelSize.y)); // top center\n    vec4 c13 = texture(uTexture, vec2(vTextureCoord.x + uTexelSize.x, vTextureCoord.y - uTexelSize.y)); // top right\n\n    vec4 c21 = texture(uTexture, vec2(vTextureCoord.x - uTexelSize.x, vTextureCoord.y)); // mid left\n    vec4 c22 = texture(uTexture, vTextureCoord); // mid center\n    vec4 c23 = texture(uTexture, vec2(vTextureCoord.x + uTexelSize.x, vTextureCoord.y)); // mid right\n\n    vec4 c31 = texture(uTexture, vec2(vTextureCoord.x - uTexelSize.x, vTextureCoord.y + uTexelSize.y)); // bottom left\n    vec4 c32 = texture(uTexture, vec2(vTextureCoord.x, vTextureCoord.y + uTexelSize.y)); // bottom center\n    vec4 c33 = texture(uTexture, vTextureCoord + uTexelSize); // bottom right\n\n    finalColor =\n        c11 * uMatrix[0][0] + c12 * uMatrix[0][1] + c13 * uMatrix[0][2] +\n        c21 * uMatrix[1][0] + c22 * uMatrix[1][1] + c23 * uMatrix[1][2] +\n        c31 * uMatrix[2][0] + c32 * uMatrix[2][1] + c33 * uMatrix[2][2];\n\n    finalColor.a = c22.a;\n}";


var $61fda2caaade84b0$export$2e2bcd8739ae039 = "struct ConvolutionUniforms {\n    uMatrix: mat3x3<f32>,\n    uTexelSize: vec2<f32>,\n};\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> convolutionUniforms : ConvolutionUniforms;\n\n@fragment\nfn mainFragment(\n    @location(0) uv: vec2<f32>,\n    @builtin(position) position: vec4<f32>\n) -> @location(0) vec4<f32> {\n    let texelSize = convolutionUniforms.uTexelSize;\n    let matrix = convolutionUniforms.uMatrix;\n\n    let c11: vec4<f32> = textureSample(uTexture, uSampler, uv - texelSize); // top left\n    let c12: vec4<f32> = textureSample(uTexture, uSampler, vec2<f32>(uv.x, uv.y - texelSize.y)); // top center\n    let c13: vec4<f32> = textureSample(uTexture, uSampler, vec2<f32>(uv.x + texelSize.x, uv.y - texelSize.y)); // top right\n\n    let c21: vec4<f32> = textureSample(uTexture, uSampler, vec2<f32>(uv.x - texelSize.x, uv.y)); // mid left\n    let c22: vec4<f32> = textureSample(uTexture, uSampler, uv); // mid center\n    let c23: vec4<f32> = textureSample(uTexture, uSampler, vec2<f32>(uv.x + texelSize.x, uv.y)); // mid right\n\n    let c31: vec4<f32> = textureSample(uTexture, uSampler, vec2<f32>(uv.x - texelSize.x, uv.y + texelSize.y)); // bottom left\n    let c32: vec4<f32> = textureSample(uTexture, uSampler, vec2<f32>(uv.x, uv.y + texelSize.y)); // bottom center\n    let c33: vec4<f32> = textureSample(uTexture, uSampler, uv + texelSize); // bottom right\n\n    var finalColor: vec4<f32> = vec4<f32>(\n        c11 * matrix[0][0] + c12 * matrix[0][1] + c13 * matrix[0][2] +\n        c21 * matrix[1][0] + c22 * matrix[1][1] + c23 * matrix[1][2] +\n        c31 * matrix[2][0] + c32 * matrix[2][1] + c33 * matrix[2][2]\n    );\n\n    finalColor.a = c22.a;\n\n    return finalColor;\n}";


var $99c2cabcd1f98d2b$var$__defProp = Object.defineProperty;
var $99c2cabcd1f98d2b$var$__defNormalProp = (obj, key, value)=>key in obj ? $99c2cabcd1f98d2b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $99c2cabcd1f98d2b$var$__publicField = (obj, key, value)=>{
    $99c2cabcd1f98d2b$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $99c2cabcd1f98d2b$var$_ConvolutionFilter = class _ConvolutionFilter extends (0, $ld81y.Filter) {
    /** @ignore */ constructor(...args){
        let options = args[0] ?? {};
        if (Array.isArray(options)) {
            (0, $j0fPb.deprecation)("6.0.0", "ConvolutionFilter constructor params are now options object. See params: { matrix, width, height }");
            options = {
                matrix: options
            };
            if (args[1] !== void 0) options.width = args[1];
            if (args[2] !== void 0) options.height = args[2];
        }
        options = {
            ..._ConvolutionFilter.DEFAULT_OPTIONS,
            ...options
        };
        const width = options.width ?? 200;
        const height = options.height ?? 200;
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $61fda2caaade84b0$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $39a9caf57f855665$export$2e2bcd8739ae039,
            name: "convolution-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                convolutionUniforms: {
                    uMatrix: {
                        value: options.matrix,
                        type: "mat3x3<f32>"
                    },
                    uTexelSize: {
                        value: {
                            x: 1 / width,
                            y: 1 / height
                        },
                        type: "vec2<f32>"
                    }
                }
            }
        });
        $99c2cabcd1f98d2b$var$__publicField(this, "uniforms");
        this.uniforms = this.resources.convolutionUniforms.uniforms;
        this.width = width;
        this.height = height;
    }
    /**
   * An array of values used for matrix transformation, specified as a 9 point Array
   * @example
   * const matrix = new Float32Array(9); // 9 elements of value 0
   * const matrix = [0,0.5,0,0.5,1,0.5,0,0.5,0];
   * @default [0,0,0,0,0,0,0,0,0]
   */ get matrix() {
        return this.uniforms.uMatrix;
    }
    set matrix(matrix) {
        matrix.forEach((v, i)=>{
            this.uniforms.uMatrix[i] = v;
        });
    }
    /**
   * Width of the object you are transforming
   * @default 200
   */ get width() {
        return 1 / this.uniforms.uTexelSize.x;
    }
    set width(value) {
        this.uniforms.uTexelSize.x = 1 / value;
    }
    /**
   * Height of the object you are transforming
   * @default 200
   */ get height() {
        return 1 / this.uniforms.uTexelSize.y;
    }
    set height(value) {
        this.uniforms.uTexelSize.y = 1 / value;
    }
};
/** Default values for options. */ $99c2cabcd1f98d2b$var$__publicField($99c2cabcd1f98d2b$var$_ConvolutionFilter, "DEFAULT_OPTIONS", {
    matrix: new Float32Array(9),
    width: 200,
    height: 200
});
let $99c2cabcd1f98d2b$export$e566fb96646592af = $99c2cabcd1f98d2b$var$_ConvolutionFilter;



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $c4eaa677b5952eed$export$2e2bcd8739ae039 = "in vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\n\nvoid main(void)\n{\n    float lum = length(texture(uTexture, vTextureCoord.xy).rgb);\n\n    finalColor = vec4(1.0, 1.0, 1.0, 1.0);\n\n    if (lum < 1.00)\n    {\n        if (mod(gl_FragCoord.x + gl_FragCoord.y, 10.0) == 0.0)\n        {\n            finalColor = vec4(0.0, 0.0, 0.0, 1.0);\n        }\n    }\n\n    if (lum < 0.75)\n    {\n        if (mod(gl_FragCoord.x - gl_FragCoord.y, 10.0) == 0.0)\n        {\n            finalColor = vec4(0.0, 0.0, 0.0, 1.0);\n        }\n    }\n\n    if (lum < 0.50)\n    {\n        if (mod(gl_FragCoord.x + gl_FragCoord.y - 5.0, 10.0) == 0.0)\n        {\n            finalColor = vec4(0.0, 0.0, 0.0, 1.0);\n        }\n    }\n\n    if (lum < 0.3)\n    {\n        if (mod(gl_FragCoord.x - gl_FragCoord.y - 5.0, 10.0) == 0.0)\n        {\n            finalColor = vec4(0.0, 0.0, 0.0, 1.0);\n        }\n    }\n}\n";


var $e05bab4f305d341e$export$2e2bcd8739ae039 = "@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n\n@fragment\nfn mainFragment(\n    @location(0) uv: vec2<f32>,\n    @builtin(position) position: vec4<f32>\n) -> @location(0) vec4<f32> {\n    let lum: f32 = length(textureSample(uTexture, uSampler, uv).rgb);\n\n    if (lum < 1.00)\n    {\n        if (modulo(position.x + position.y, 10.0) == 0.0)\n        {\n            return vec4<f32>(0.0, 0.0, 0.0, 1.0);\n        }\n    }\n\n    if (lum < 0.75)\n    {\n        if (modulo(position.x - position.y, 10.0) == 0.0)\n        {\n            return vec4<f32>(0.0, 0.0, 0.0, 1.0);\n        }\n    }\n\n    if (lum < 0.50)\n    {\n        if (modulo(position.x + position.y - 5.0, 10.0) == 0.0)\n        {\n            return vec4<f32>(0.0, 0.0, 0.0, 1.0);\n        }\n    }\n\n    if (lum < 0.3)\n    {\n        if (modulo(position.x - position.y - 5.0, 10.0) == 0.0)\n        {\n            return vec4<f32>(0.0, 0.0, 0.0, 1.0);\n        }\n    }\n\n    return vec4<f32>(1.0);\n}\n\nfn modulo(x: f32, y: f32) -> f32\n{\n  return x - y * floor(x/y);\n}";


class $e3656e1330c5edc0$export$243c62fa1f37514d extends (0, $ld81y.Filter) {
    constructor(){
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $e05bab4f305d341e$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $c4eaa677b5952eed$export$2e2bcd8739ae039,
            name: "cross-hatch-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {}
        });
    }
}



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $44e3dbeecf0ebf2a$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec4 uLine;\nuniform vec2 uNoise;\nuniform vec3 uVignette;\nuniform float uSeed;\nuniform float uTime;\nuniform vec2 uDimensions;\n\nuniform vec4 uInputSize;\n\nconst float SQRT_2 = 1.414213;\n\nfloat rand(vec2 co) {\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nfloat vignette(vec3 co, vec2 coord)\n{\n    float outter = SQRT_2 - uVignette[0] * SQRT_2;\n    vec2 dir = vec2(0.5) - coord;\n    dir.y *= uDimensions.y / uDimensions.x;\n    float darker = clamp((outter - length(dir) * SQRT_2) / ( 0.00001 + uVignette[2] * SQRT_2), 0.0, 1.0);\n    return darker + (1.0 - darker) * (1.0 - uVignette[1]);\n}\n\nfloat noise(vec2 coord)\n{\n    vec2 pixelCoord = coord * uInputSize.xy;\n    pixelCoord.x = floor(pixelCoord.x / uNoise[1]);\n    pixelCoord.y = floor(pixelCoord.y / uNoise[1]);\n    return (rand(pixelCoord * uNoise[1] * uSeed) - 0.5) * uNoise[0];\n}\n\nvec3 interlaceLines(vec3 co, vec2 coord)\n{\n    vec3 color = co;\n\n    float curvature = uLine[0];\n    float lineWidth = uLine[1];\n    float lineContrast = uLine[2];\n    float verticalLine = uLine[3];\n\n    vec2 dir = vec2(coord * uInputSize.xy / uDimensions - 0.5);\n\n    float _c = curvature > 0. ? curvature : 1.;\n    float k = curvature > 0. ? (length(dir * dir) * 0.25 * _c * _c + 0.935 * _c) : 1.;\n    vec2 uv = dir * k;\n    float v = verticalLine > 0.5 ? uv.x * uDimensions.x : uv.y * uDimensions.y;\n    v *= min(1.0, 2.0 / lineWidth ) / _c;\n    float j = 1. + cos(v * 1.2 - uTime) * 0.5 * lineContrast;\n    color *= j;\n\n    float segment = verticalLine > 0.5 ? mod((dir.x + .5) * uDimensions.x, 4.) : mod((dir.y + .5) * uDimensions.y, 4.);\n    color *= 0.99 + ceil(segment) * 0.015;\n\n    return color;\n}\n\nvoid main(void)\n{\n    finalColor = texture(uTexture, vTextureCoord);\n    vec2 coord = vTextureCoord * uInputSize.xy / uDimensions;\n\n    if (uNoise[0] > 0.0 && uNoise[1] > 0.0)\n    {\n        float n = noise(vTextureCoord);\n        finalColor += vec4(n, n, n, finalColor.a);\n    }\n\n    if (uVignette[0] > 0.)\n    {\n        float v = vignette(finalColor.rgb, coord);\n        finalColor *= vec4(v, v, v, finalColor.a);\n    }\n\n    if (uLine[1] > 0.0)\n    {\n        finalColor = vec4(interlaceLines(finalColor.rgb, vTextureCoord), finalColor.a);  \n    }\n}\n";


var $4f607eec9b3fef69$export$2e2bcd8739ae039 = "struct CRTUniforms {\n    uLine: vec4<f32>,\n    uNoise: vec2<f32>,\n    uVignette: vec3<f32>,\n    uSeed: f32,\n    uTime: f32,\n    uDimensions: vec2<f32>,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> crtUniforms : CRTUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n    \n  var color: vec4<f32> = textureSample(uTexture, uSampler, uv);\n  let coord: vec2<f32> = uv * gfu.uInputSize.xy / crtUniforms.uDimensions;\n\n  let uNoise = crtUniforms.uNoise;\n\n  if (uNoise[0] > 0.0 && uNoise[1] > 0.0)\n  {\n    color += vec4<f32>(vec3<f32>(noise(uv)), color.a);\n  }\n\n  if (crtUniforms.uVignette[0] > 0.)\n  {\n    color *= vec4<f32>(vec3<f32>(vignette(color.rgb, coord)), color.a);\n  }\n\n  if (crtUniforms.uLine[1] > 0.0)\n  {\n    color = vec4<f32>(vec3<f32>(interlaceLines(color.rgb, uv)), color.a);  \n  }\n\n  return color;\n}\n\nconst SQRT_2: f32 = 1.414213;\n\nfn modulo(x: f32, y: f32) -> f32\n{\n  return x - y * floor(x/y);\n}\n\nfn rand(co: vec2<f32>) -> f32\n{\n  return fract(sin(dot(co, vec2<f32>(12.9898, 78.233))) * 43758.5453);\n}\n\nfn vignette(co: vec3<f32>, coord: vec2<f32>) -> f32\n{\n  let uVignette = crtUniforms.uVignette;\n  let uDimensions = crtUniforms.uDimensions;\n  \n  let outter: f32 = SQRT_2 - uVignette[0] * SQRT_2;\n  var dir: vec2<f32> = vec2<f32>(0.5) - coord;\n  dir.y *= uDimensions.y / uDimensions.x;\n  let darker: f32 = clamp((outter - length(dir) * SQRT_2) / ( 0.00001 + uVignette[2] * SQRT_2), 0.0, 1.0);\n  return darker + (1.0 - darker) * (1.0 - uVignette[1]);\n}\n\nfn noise(coord: vec2<f32>) -> f32\n{\n  let uNoise = crtUniforms.uNoise;\n  let uSeed = crtUniforms.uSeed;\n\n  var pixelCoord: vec2<f32> = coord * gfu.uInputSize.xy;\n  pixelCoord.x = floor(pixelCoord.x / uNoise[1]);\n  pixelCoord.y = floor(pixelCoord.y / uNoise[1]);\n  return (rand(pixelCoord * uNoise[1] * uSeed) - 0.5) * uNoise[0];\n}\n\nfn interlaceLines(co: vec3<f32>, coord: vec2<f32>) -> vec3<f32>\n{\n  var color = co;\n\n  let uDimensions = crtUniforms.uDimensions;\n\n  let curvature: f32 = crtUniforms.uLine[0];\n  let lineWidth: f32 = crtUniforms.uLine[1];\n  let lineContrast: f32 = crtUniforms.uLine[2];\n  let verticalLine: f32 = crtUniforms.uLine[3];\n\n  let dir: vec2<f32> = vec2<f32>(coord * gfu.uInputSize.xy / uDimensions - 0.5);\n\n  let _c: f32 = select(1., curvature, curvature > 0.);\n  let k: f32 = select(1., (length(dir * dir) * 0.25 * _c * _c + 0.935 * _c), curvature > 0.);\n  let uv: vec2<f32> = dir * k;\n  let v: f32 = select(uv.y * uDimensions.y, uv.x * uDimensions.x, verticalLine > 0.5) * min(1.0, 2.0 / lineWidth ) / _c;\n  let j: f32 = 1. + cos(v * 1.2 - crtUniforms.uTime) * 0.5 * lineContrast;\n  color *= j;\n\n  let segment: f32 = select(modulo((dir.y + .5) * uDimensions.y, 4.), modulo((dir.x + .5) * uDimensions.x, 4.), verticalLine > 0.5);\n  color *= 0.99 + ceil(segment) * 0.015;\n\n  return color;\n}";


var $27cf5565d7902c62$var$__defProp = Object.defineProperty;
var $27cf5565d7902c62$var$__defNormalProp = (obj, key, value)=>key in obj ? $27cf5565d7902c62$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $27cf5565d7902c62$var$__publicField = (obj, key, value)=>{
    $27cf5565d7902c62$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $27cf5565d7902c62$var$_CRTFilter = class _CRTFilter extends (0, $ld81y.Filter) {
    /**
   * @param options - Options for the CRTFilter constructor.
   */ constructor(options){
        options = {
            ..._CRTFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $4f607eec9b3fef69$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $44e3dbeecf0ebf2a$export$2e2bcd8739ae039,
            name: "crt-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                crtUniforms: {
                    uLine: {
                        value: new Float32Array(4),
                        type: "vec4<f32>"
                    },
                    uNoise: {
                        value: new Float32Array(2),
                        type: "vec2<f32>"
                    },
                    uVignette: {
                        value: new Float32Array(3),
                        type: "vec3<f32>"
                    },
                    uSeed: {
                        value: options.seed,
                        type: "f32"
                    },
                    uTime: {
                        value: options.time,
                        type: "f32"
                    },
                    uDimensions: {
                        value: new Float32Array(2),
                        type: "vec2<f32>"
                    }
                }
            }
        });
        $27cf5565d7902c62$var$__publicField(this, "uniforms");
        /**
     * A seed value to apply to the random noise generation
     * @default 0
     */ $27cf5565d7902c62$var$__publicField(this, "seed");
        /**
     * Opacity/intensity of the noise effect between `0` and `1`
     * @default 0.3
     */ $27cf5565d7902c62$var$__publicField(this, "time");
        this.uniforms = this.resources.crtUniforms.uniforms;
        Object.assign(this, options);
    }
    /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */ apply(filterManager, input, output, clearMode) {
        this.uniforms.uDimensions[0] = input.frame.width;
        this.uniforms.uDimensions[1] = input.frame.height;
        this.uniforms.uSeed = this.seed;
        this.uniforms.uTime = this.time;
        filterManager.applyFilter(this, input, output, clearMode);
    }
    /**
   * Bend of interlaced lines, higher value means more bend
   * @default 1
   */ get curvature() {
        return this.uniforms.uLine[0];
    }
    set curvature(value) {
        this.uniforms.uLine[0] = value;
    }
    /**
   * Width of interlaced lines
   * @default 1
   */ get lineWidth() {
        return this.uniforms.uLine[1];
    }
    set lineWidth(value) {
        this.uniforms.uLine[1] = value;
    }
    /**
   * Contrast of interlaced lines
   * @default 0.25
   */ get lineContrast() {
        return this.uniforms.uLine[2];
    }
    set lineContrast(value) {
        this.uniforms.uLine[2] = value;
    }
    /**
   * The orientation of the line:
   *
   * `true` create vertical lines, `false` creates horizontal lines
   * @default false
   */ get verticalLine() {
        return this.uniforms.uLine[3] > 0.5;
    }
    set verticalLine(value) {
        this.uniforms.uLine[3] = value ? 1 : 0;
    }
    /**
   * Opacity/intensity of the noise effect between `0` and `1`
   * @default 0.3
   */ get noise() {
        return this.uniforms.uNoise[0];
    }
    set noise(value) {
        this.uniforms.uNoise[0] = value;
    }
    /**
   * The size of the noise particles
   * @default 0
   */ get noiseSize() {
        return this.uniforms.uNoise[1];
    }
    set noiseSize(value) {
        this.uniforms.uNoise[1] = value;
    }
    /**
   * The radius of the vignette effect, smaller values produces a smaller vignette
   * @default 0.3
   */ get vignetting() {
        return this.uniforms.uVignette[0];
    }
    set vignetting(value) {
        this.uniforms.uVignette[0] = value;
    }
    /**
   * Amount of opacity of vignette
   * @default 1
   */ get vignettingAlpha() {
        return this.uniforms.uVignette[1];
    }
    set vignettingAlpha(value) {
        this.uniforms.uVignette[1] = value;
    }
    /**
   * Blur intensity of the vignette
   * @default 0.3
   */ get vignettingBlur() {
        return this.uniforms.uVignette[2];
    }
    set vignettingBlur(value) {
        this.uniforms.uVignette[2] = value;
    }
};
/** Default values for options. */ $27cf5565d7902c62$var$__publicField($27cf5565d7902c62$var$_CRTFilter, "DEFAULT_OPTIONS", {
    curvature: 1,
    lineWidth: 1,
    lineContrast: 0.25,
    verticalLine: false,
    noise: 0,
    noiseSize: 1,
    vignetting: 0.3,
    vignettingAlpha: 1,
    vignettingBlur: 0.3,
    time: 0,
    seed: 0
});
let $27cf5565d7902c62$export$ae91753653e6e05 = $27cf5565d7902c62$var$_CRTFilter;





var $j0fPb = parcelRequire("j0fPb");
var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $91107dd064d5ef98$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform float uAngle;\nuniform float uScale;\nuniform bool uGrayScale;\n\nuniform vec4 uInputSize;\n\nfloat pattern()\n{\n    float s = sin(uAngle), c = cos(uAngle);\n    vec2 tex = vTextureCoord * uInputSize.xy;\n    vec2 point = vec2(\n        c * tex.x - s * tex.y,\n        s * tex.x + c * tex.y\n    ) * uScale;\n    return (sin(point.x) * sin(point.y)) * 4.0;\n    }\n\n    void main()\n    {\n    vec4 color = texture(uTexture, vTextureCoord);\n    vec3 colorRGB = vec3(color);\n\n    if (uGrayScale)\n    {\n        colorRGB = vec3(color.r + color.g + color.b) / 3.0;\n    }\n\n    finalColor = vec4(colorRGB * 10.0 - 5.0 + pattern(), color.a);\n}\n";


var $0a34dbf46c18e09a$export$2e2bcd8739ae039 = "struct DotUniforms {\n  uScale:f32,\n  uAngle:f32,\n  uGrayScale:f32,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> dotUniforms : DotUniforms;\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>,\n  @builtin(position) position: vec4<f32>\n) -> @location(0) vec4<f32> {\n  let color: vec4<f32> = textureSample(uTexture, uSampler, uv);\n  let gray: vec3<f32> = vec3<f32>(dot(color.rgb, vec3<f32>(0.299, 0.587, 0.114)));\n  // dotUniforms.uGrayScale == 1 doesn't ever pass so it is converted to a float and compared to 0.5 instead \n  let finalColor: vec3<f32> = select(color.rgb, gray, f32(dotUniforms.uGrayScale) >= 0.5);\n\n  return vec4<f32>(finalColor * 10.0 - 5.0 + pattern(uv), color.a);\n}\n\nfn pattern(uv: vec2<f32>) -> f32\n{\n  let s: f32 = sin(dotUniforms.uAngle);\n  let c: f32 = cos(dotUniforms.uAngle);\n  \n  let tex: vec2<f32> = uv * gfu.uInputSize.xy;\n  \n  let p: vec2<f32> = vec2<f32>(\n      c * tex.x - s * tex.y,\n      s * tex.x + c * tex.y\n  ) * dotUniforms.uScale;\n\n  return (sin(p.x) * sin(p.y)) * 4.0;\n}";


var $050fc8824778f723$var$__defProp = Object.defineProperty;
var $050fc8824778f723$var$__defNormalProp = (obj, key, value)=>key in obj ? $050fc8824778f723$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $050fc8824778f723$var$__publicField = (obj, key, value)=>{
    $050fc8824778f723$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $050fc8824778f723$var$_DotFilter = class _DotFilter extends (0, $ld81y.Filter) {
    /** @ignore */ constructor(...args){
        let options = args[0] ?? {};
        if (typeof options === "number") {
            (0, $j0fPb.deprecation)("6.0.0", "DotFilter constructor params are now options object. See params: { scale, angle, grayscale }");
            options = {
                scale: options
            };
            if (args[1] !== void 0) options.angle = args[1];
            if (args[2] !== void 0) options.grayscale = args[2];
        }
        options = {
            ..._DotFilter.DEFAULT_OPTIONS,
            ...options
        };
        const dotUniforms = {
            uScale: {
                value: options.scale,
                type: "f32"
            },
            uAngle: {
                value: options.angle,
                type: "f32"
            },
            uGrayScale: {
                value: options.grayscale ? 1 : 0,
                type: "f32"
            }
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $0a34dbf46c18e09a$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $91107dd064d5ef98$export$2e2bcd8739ae039,
            name: "dot-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                dotUniforms: dotUniforms
            }
        });
    }
    /**
   * The scale of the effect.
   * @default 1
   */ get scale() {
        return this.resources.dotUniforms.uniforms.uScale;
    }
    set scale(value) {
        this.resources.dotUniforms.uniforms.uScale = value;
    }
    /**
  * The radius of the effect.
  * @default 5
  */ get angle() {
        return this.resources.dotUniforms.uniforms.uAngle;
    }
    set angle(value) {
        this.resources.dotUniforms.uniforms.uAngle = value;
    }
    /**
  * Whether to rendering it in gray scale.
  * @default true
  */ get grayscale() {
        return this.resources.dotUniforms.uniforms.uGrayScale === 1;
    }
    set grayscale(value) {
        this.resources.dotUniforms.uniforms.uGrayScale = value ? 1 : 0;
    }
};
/** Default values for options. */ $050fc8824778f723$var$__publicField($050fc8824778f723$var$_DotFilter, "DEFAULT_OPTIONS", {
    scale: 1,
    angle: 5,
    grayscale: true
});
let $050fc8824778f723$export$7cf7dcd1ca793e20 = $050fc8824778f723$var$_DotFilter;



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $bEj7k = parcelRequire("bEj7k");
var $ld81y = parcelRequire("ld81y");
var $g5CeI = parcelRequire("g5CeI");



var $289254418de3b713$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform float uAlpha;\nuniform vec3 uColor;\nuniform vec2 uOffset;\n\nuniform vec4 uInputSize;\n\nvoid main(void){\n    vec4 sample = texture(uTexture, vTextureCoord - uOffset * uInputSize.zw);\n\n    // Premultiply alpha\n    sample.rgb = uColor.rgb * sample.a;\n\n    // alpha user alpha\n    sample *= uAlpha;\n\n    finalColor = sample;\n}";


var $66929afb9c8b22bb$export$2e2bcd8739ae039 = "struct DropShadowUniforms {\n  uAlpha: f32,\n  uColor: vec3<f32>,\n  uOffset: vec2<f32>,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> dropShadowUniforms : DropShadowUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  var color: vec4<f32> = textureSample(uTexture, uSampler, uv - dropShadowUniforms.uOffset * gfu.uInputSize.zw);\n\n  // Premultiply alpha\n  color = vec4<f32>(vec3<f32>(dropShadowUniforms.uColor.rgb * color.a), color.a);\n  // alpha user alpha\n  color *= dropShadowUniforms.uAlpha;\n\n  return color;\n}";


var $e234fabd83f60df8$var$__defProp = Object.defineProperty;
var $e234fabd83f60df8$var$__defNormalProp = (obj, key, value)=>key in obj ? $e234fabd83f60df8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e234fabd83f60df8$var$__publicField = (obj, key, value)=>{
    $e234fabd83f60df8$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $e234fabd83f60df8$var$_DropShadowFilter = class _DropShadowFilter extends (0, $ld81y.Filter) {
    /**
   * @param options - Options for the DropShadowFilter constructor.
   */ constructor(options){
        options = {
            ..._DropShadowFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $66929afb9c8b22bb$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $289254418de3b713$export$2e2bcd8739ae039,
            name: "drop-shadow-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                dropShadowUniforms: {
                    uAlpha: {
                        value: options.alpha,
                        type: "f32"
                    },
                    uColor: {
                        value: new Float32Array(3),
                        type: "vec3<f32>"
                    },
                    uOffset: {
                        value: options.offset,
                        type: "vec2<f32>"
                    }
                }
            },
            resolution: options.resolution
        });
        $e234fabd83f60df8$var$__publicField(this, "uniforms");
        /**
     * Hide the contents, only show the shadow.
     * @default false
     */ $e234fabd83f60df8$var$__publicField(this, "shadowOnly", false);
        $e234fabd83f60df8$var$__publicField(this, "_color");
        $e234fabd83f60df8$var$__publicField(this, "_blurFilter");
        $e234fabd83f60df8$var$__publicField(this, "_basePass");
        this.uniforms = this.resources.dropShadowUniforms.uniforms;
        this._color = new (0, $bEj7k.Color)();
        this.color = options.color ?? 0;
        this._blurFilter = new (0, $2433219b84d26ac4$export$31164edf0fb20199)({
            strength: options.kernels ?? options.blur,
            quality: options.kernels ? void 0 : options.quality
        });
        this._basePass = new (0, $ld81y.Filter)({
            gpuProgram: (0, $9E2kA.GpuProgram).from({
                vertex: {
                    source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                    entryPoint: "mainVertex"
                },
                fragment: {
                    source: `
                    @group(0) @binding(1) var uTexture: texture_2d<f32>; 
                    @group(0) @binding(2) var uSampler: sampler;
                    @fragment
                    fn mainFragment(
                        @builtin(position) position: vec4<f32>,
                        @location(0) uv : vec2<f32>
                    ) -> @location(0) vec4<f32> {
                        return textureSample(uTexture, uSampler, uv);
                    }
                    `,
                    entryPoint: "mainFragment"
                }
            }),
            glProgram: (0, $339HX.GlProgram).from({
                vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
                fragment: `
                in vec2 vTextureCoord;
                out vec4 finalColor;
                uniform sampler2D uTexture;

                void main(void){
                    finalColor = texture(uTexture, vTextureCoord);
                }
                `,
                name: "drop-shadow-filter"
            }),
            resources: {}
        });
        Object.assign(this, options);
    }
    /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */ apply(filterManager, input, output, clearMode) {
        const renderTarget = (0, $g5CeI.TexturePool).getSameSizeTexture(input);
        filterManager.applyFilter(this, input, renderTarget, true);
        this._blurFilter.apply(filterManager, renderTarget, output, clearMode);
        if (!this.shadowOnly) filterManager.applyFilter(this._basePass, input, output, false);
        (0, $g5CeI.TexturePool).returnTexture(renderTarget);
    }
    /**
   * Set the offset position of the drop-shadow relative to the original image.
   * @default [4,4]
   */ get offset() {
        return this.uniforms.uOffset;
    }
    set offset(value) {
        this.uniforms.uOffset = value;
        this._updatePadding();
    }
    /**
   * Set the offset position of the drop-shadow relative to the original image on the `x` axis
   * @default 4
   */ get offsetX() {
        return this.offset.x;
    }
    set offsetX(value) {
        this.offset.x = value;
        this._updatePadding();
    }
    /**
   * Set the offset position of the drop-shadow relative to the original image on the `y` axis
   * @default 4
   */ get offsetY() {
        return this.offset.y;
    }
    set offsetY(value) {
        this.offset.y = value;
        this._updatePadding();
    }
    /**
   * The color value of shadow.
   * @example [0.0, 0.0, 0.0] = 0x000000
   * @default 0x000000
   */ get color() {
        return this._color.value;
    }
    set color(value) {
        this._color.setValue(value);
        const [r, g, b] = this._color.toArray();
        this.uniforms.uColor[0] = r;
        this.uniforms.uColor[1] = g;
        this.uniforms.uColor[2] = b;
    }
    /**
   * Coefficient for alpha multiplication
   * @default 1
   */ get alpha() {
        return this.uniforms.uAlpha;
    }
    set alpha(value) {
        this.uniforms.uAlpha = value;
    }
    /**
   * The strength of the shadow's blur.
   * @default 2
   */ get blur() {
        return this._blurFilter.strength;
    }
    set blur(value) {
        this._blurFilter.strength = value;
        this._updatePadding();
    }
    /**
   * Sets the quality of the Blur Filter
   * @default 4
   */ get quality() {
        return this._blurFilter.quality;
    }
    set quality(value) {
        this._blurFilter.quality = value;
        this._updatePadding();
    }
    /** Sets the kernels of the Blur Filter */ get kernels() {
        return this._blurFilter.kernels;
    }
    set kernels(value) {
        this._blurFilter.kernels = value;
    }
    /**
   * Sets the pixelSize of the Kawase Blur filter
   * @default [1,1]
   */ get pixelSize() {
        return this._blurFilter.pixelSize;
    }
    set pixelSize(value) {
        if (typeof value === "number") value = {
            x: value,
            y: value
        };
        if (Array.isArray(value)) value = {
            x: value[0],
            y: value[1]
        };
        this._blurFilter.pixelSize = value;
    }
    /**
   * Sets the pixelSize of the Kawase Blur filter on the `x` axis
   * @default 1
   */ get pixelSizeX() {
        return this._blurFilter.pixelSizeX;
    }
    set pixelSizeX(value) {
        this._blurFilter.pixelSizeX = value;
    }
    /**
   * Sets the pixelSize of the Kawase Blur filter on the `y` axis
   * @default 1
   */ get pixelSizeY() {
        return this._blurFilter.pixelSizeY;
    }
    set pixelSizeY(value) {
        this._blurFilter.pixelSizeY = value;
    }
    /**
   * Recalculate the proper padding amount.
   * @private
   */ _updatePadding() {
        const offsetPadding = Math.max(Math.abs(this.offsetX), Math.abs(this.offsetY));
        this.padding = offsetPadding + this.blur * 2 + this.quality * 4;
    }
};
/** Default values for options. */ $e234fabd83f60df8$var$__publicField($e234fabd83f60df8$var$_DropShadowFilter, "DEFAULT_OPTIONS", {
    offset: {
        x: 4,
        y: 4
    },
    color: 0,
    alpha: 0.5,
    shadowOnly: false,
    kernels: void 0,
    blur: 2,
    quality: 3,
    pixelSize: {
        x: 1,
        y: 1
    },
    resolution: 1
});
let $e234fabd83f60df8$export$57214e398098d4e3 = $e234fabd83f60df8$var$_DropShadowFilter;



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $10707233ded151c4$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform float uStrength;\n\nuniform vec4 uInputSize;\n\nvoid main(void)\n{\n	vec2 onePixel = vec2(1.0 / uInputSize);\n\n	vec4 color;\n\n	color.rgb = vec3(0.5);\n\n	color -= texture(uTexture, vTextureCoord - onePixel) * uStrength;\n	color += texture(uTexture, vTextureCoord + onePixel) * uStrength;\n\n	color.rgb = vec3((color.r + color.g + color.b) / 3.0);\n\n	float alpha = texture(uTexture, vTextureCoord).a;\n\n	finalColor = vec4(color.rgb * alpha, alpha);\n}\n";


var $8516af6e9d5b1e8d$export$2e2bcd8739ae039 = "struct EmbossUniforms {\n  uStrength:f32,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> embossUniforms : EmbossUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let onePixel: vec2<f32> = vec2<f32>(1.0 / gfu.uInputSize.xy);\n	var color: vec3<f32> = vec3<f32>(0.5);\n\n	color -= (textureSample(uTexture, uSampler, uv - onePixel) * embossUniforms.uStrength).rgb;\n	color += (textureSample(uTexture, uSampler, uv + onePixel) * embossUniforms.uStrength).rgb;\n\n	color = vec3<f32>((color.r + color.g + color.b) / 3.0);\n\n	let blendColor: vec4<f32> = textureSample(uTexture, uSampler, uv);\n\n	return vec4<f32>(color.rgb * blendColor.a, blendColor.a);\n}";


var $852b217efc974fd6$var$__defProp = Object.defineProperty;
var $852b217efc974fd6$var$__defNormalProp = (obj, key, value)=>key in obj ? $852b217efc974fd6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $852b217efc974fd6$var$__publicField = (obj, key, value)=>{
    $852b217efc974fd6$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
class $852b217efc974fd6$export$564b6ccbc3bf408d extends (0, $ld81y.Filter) {
    /**
   * @param {number} [strength=5] - Strength of the emboss.
   */ constructor(strength = 5){
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $8516af6e9d5b1e8d$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $10707233ded151c4$export$2e2bcd8739ae039,
            name: "emboss-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                embossUniforms: {
                    uStrength: {
                        value: strength,
                        type: "f32"
                    }
                }
            }
        });
        $852b217efc974fd6$var$__publicField(this, "uniforms");
        this.uniforms = this.resources.embossUniforms.uniforms;
    }
    /**
   * Strength of the emboss
   * @default 5
   */ get strength() {
        return this.uniforms.uStrength;
    }
    set strength(value) {
        this.uniforms.uStrength = value;
    }
}



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $jollT = parcelRequire("jollT");
var $5yirD = parcelRequire("5yirD");
var $l8FfC = parcelRequire("l8FfC");
var $ld81y = parcelRequire("ld81y");


var $93cb624265c94e08$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform sampler2D uDisplacementMap;\nuniform float uSeed;\nuniform vec2 uDimensions;\nuniform float uAspect;\nuniform float uFillMode;\nuniform float uOffset;\nuniform float uDirection;\nuniform vec2 uRed;\nuniform vec2 uGreen;\nuniform vec2 uBlue;\n\nuniform vec4 uInputSize;\nuniform vec4 uInputClamp;\n\nconst int TRANSPARENT = 0;\nconst int ORIGINAL = 1;\nconst int LOOP = 2;\nconst int CLAMP = 3;\nconst int MIRROR = 4;\n\nvoid main(void)\n{\n    vec2 coord = (vTextureCoord * uInputSize.xy) / uDimensions;\n\n    if (coord.x > 1.0 || coord.y > 1.0) {\n        return;\n    }\n\n    float sinDir = sin(uDirection);\n    float cosDir = cos(uDirection);\n\n    float cx = coord.x - 0.5;\n    float cy = (coord.y - 0.5) * uAspect;\n    float ny = (-sinDir * cx + cosDir * cy) / uAspect + 0.5;\n\n    // displacementMap: repeat\n    // ny = ny > 1.0 ? ny - 1.0 : (ny < 0.0 ? 1.0 + ny : ny);\n\n    // displacementMap: mirror\n    ny = ny > 1.0 ? 2.0 - ny : (ny < 0.0 ? -ny : ny);\n\n    vec4 dc = texture(uDisplacementMap, vec2(0.5, ny));\n\n    float displacement = (dc.r - dc.g) * (uOffset / uInputSize.x);\n\n    coord = vTextureCoord + vec2(cosDir * displacement, sinDir * displacement * uAspect);\n\n    int fillMode = int(uFillMode);\n\n    if (fillMode == CLAMP) {\n        coord = clamp(coord, uInputClamp.xy, uInputClamp.zw);\n    } else {\n        if( coord.x > uInputClamp.z ) {\n            if (fillMode == TRANSPARENT) {\n                discard;\n            } else if (fillMode == LOOP) {\n                coord.x -= uInputClamp.z;\n            } else if (fillMode == MIRROR) {\n                coord.x = uInputClamp.z * 2.0 - coord.x;\n            }\n        } else if( coord.x < uInputClamp.x ) {\n            if (fillMode == TRANSPARENT) {\n                discard;\n            } else if (fillMode == LOOP) {\n                coord.x += uInputClamp.z;\n            } else if (fillMode == MIRROR) {\n                coord.x *= -uInputClamp.z;\n            }\n        }\n\n        if( coord.y > uInputClamp.w ) {\n            if (fillMode == TRANSPARENT) {\n                discard;\n            } else if (fillMode == LOOP) {\n                coord.y -= uInputClamp.w;\n            } else if (fillMode == MIRROR) {\n                coord.y = uInputClamp.w * 2.0 - coord.y;\n            }\n        } else if( coord.y < uInputClamp.y ) {\n            if (fillMode == TRANSPARENT) {\n                discard;\n            } else if (fillMode == LOOP) {\n                coord.y += uInputClamp.w;\n            } else if (fillMode == MIRROR) {\n                coord.y *= -uInputClamp.w;\n            }\n        }\n    }\n\n    finalColor.r = texture(uTexture, coord + uRed * (1.0 - uSeed * 0.4) / uInputSize.xy).r;\n    finalColor.g = texture(uTexture, coord + uGreen * (1.0 - uSeed * 0.3) / uInputSize.xy).g;\n    finalColor.b = texture(uTexture, coord + uBlue * (1.0 - uSeed * 0.2) / uInputSize.xy).b;\n    finalColor.a = texture(uTexture, coord).a;\n}\n";


var $7c54322183c7e8df$export$2e2bcd8739ae039 = "struct GlitchUniforms {\n  uSeed: f32,\n  uDimensions: vec2<f32>,\n  uAspect: f32,\n  uFillMode: f32,\n  uOffset: f32,\n  uDirection: f32,\n  uRed: vec2<f32>,\n  uGreen: vec2<f32>,\n  uBlue: vec2<f32>,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> glitchUniforms : GlitchUniforms;\n@group(1) @binding(1) var uDisplacementMap: texture_2d<f32>; \n@group(1) @binding(2) var uDisplacementSampler: sampler; \n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let uSeed: f32 = glitchUniforms.uSeed;\n  let uDimensions: vec2<f32> = glitchUniforms.uDimensions;\n  let uAspect: f32 = glitchUniforms.uAspect;\n  let uOffset: f32 = glitchUniforms.uOffset;\n  let uDirection: f32 = glitchUniforms.uDirection;\n  let uRed: vec2<f32> = glitchUniforms.uRed;\n  let uGreen: vec2<f32> = glitchUniforms.uGreen;\n  let uBlue: vec2<f32> = glitchUniforms.uBlue;\n\n  let uInputSize: vec4<f32> = gfu.uInputSize;\n  let uInputClamp: vec4<f32> = gfu.uInputClamp;\n\n  var discarded: bool = false;\n  var coord: vec2<f32> = (uv * uInputSize.xy) / uDimensions;\n\n    if (coord.x > 1.0 || coord.y > 1.0) {\n      discarded = true;\n    }\n\n    let sinDir: f32 = sin(uDirection);\n    let cosDir: f32 = cos(uDirection);\n\n    let cx: f32 = coord.x - 0.5;\n    let cy: f32 = (coord.y - 0.5) * uAspect;\n    var ny: f32 = (-sinDir * cx + cosDir * cy) / uAspect + 0.5;\n\n    ny = select(select(ny, -ny, ny < 0.0), 2.0 - ny, ny > 1.0);\n\n    let dc: vec4<f32> = textureSample(uDisplacementMap, uDisplacementSampler, vec2<f32>(0.5, ny));\n\n    let displacement: f32 = (dc.r - dc.g) * (uOffset / uInputSize.x);\n\n    coord = uv + vec2<f32>(cosDir * displacement, sinDir * displacement * uAspect);\n\n    let fillMode: i32 = i32(glitchUniforms.uFillMode);\n\n    if (fillMode == CLAMP) {\n      coord = clamp(coord, uInputClamp.xy, uInputClamp.zw);\n    } else {\n      if (coord.x > uInputClamp.z) {\n        if (fillMode == TRANSPARENT) {\n          discarded = true;\n        } else if (fillMode == LOOP) {\n          coord.x = coord.x - uInputClamp.z;\n        } else if (fillMode == MIRROR) {\n          coord.x = uInputClamp.z * 2.0 - coord.x;\n        }\n      } else if (coord.x < uInputClamp.x) {\n        if (fillMode == TRANSPARENT) {\n          discarded = true;\n        } else if (fillMode == LOOP) {\n          coord.x = coord.x + uInputClamp.z;\n        } else if (fillMode == MIRROR) {\n          coord.x = coord.x * -uInputClamp.z;\n        }\n      }\n\n      if (coord.y > uInputClamp.w) {\n        if (fillMode == TRANSPARENT) {\n          discarded = true;\n        } else if (fillMode == LOOP) {\n          coord.y = coord.y - uInputClamp.w;\n        } else if (fillMode == MIRROR) {\n          coord.y = uInputClamp.w * 2.0 - coord.y;\n        }\n      } else if (coord.y < uInputClamp.y) {\n        if (fillMode == TRANSPARENT) {\n          discarded = true;\n        } else if (fillMode == LOOP) {\n          coord.y = coord.y + uInputClamp.w;\n        } else if (fillMode == MIRROR) {\n          coord.y = coord.y * -uInputClamp.w;\n        }\n      }\n    }\n\n    let seedR: f32 = 1.0 - uSeed * 0.4;\n    let seedG: f32 = 1.0 - uSeed * 0.3;\n    let seedB: f32 = 1.0 - uSeed * 0.2;\n\n    let offsetR: vec2<f32> = vec2(uRed.x * seedR / uInputSize.x, uRed.y * seedR / uInputSize.y);\n    let offsetG: vec2<f32> = vec2(uGreen.x * seedG / uInputSize.x, uGreen.y * seedG / uInputSize.y);\n    let offsetB: vec2<f32> = vec2(uBlue.x * seedB / uInputSize.x, uBlue.y * seedB / uInputSize.y);\n\n    let r = textureSample(uTexture, uSampler, coord + offsetR).r;\n    let g = textureSample(uTexture, uSampler, coord + offsetG).g;\n    let b = textureSample(uTexture, uSampler, coord + offsetB).b;\n    let a = textureSample(uTexture, uSampler, coord).a;\n\n    return select(vec4<f32>(r, g, b, a), vec4<f32>(0.0,0.0,0.0,0.0), discarded);\n}\n\nconst TRANSPARENT: i32 = 0;\nconst ORIGINAL: i32 = 1;\nconst LOOP: i32 = 2;\nconst CLAMP: i32 = 3;\nconst MIRROR: i32 = 4;";


var $fd220b2e775d2042$var$__defProp = Object.defineProperty;
var $fd220b2e775d2042$var$__defNormalProp = (obj, key, value)=>key in obj ? $fd220b2e775d2042$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $fd220b2e775d2042$var$__publicField = (obj, key, value)=>{
    $fd220b2e775d2042$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $fd220b2e775d2042$var$_GlitchFilter = class _GlitchFilter extends (0, $ld81y.Filter) {
    /**
   * @param options - Options for the GlitchFilter constructor.
   */ constructor(options){
        options = {
            ..._GlitchFilter.defaults,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $7c54322183c7e8df$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $93cb624265c94e08$export$2e2bcd8739ae039,
            name: "glitch-filter"
        });
        const canvas = document.createElement("canvas");
        canvas.width = 4;
        canvas.height = options.sampleSize ?? 512;
        const texture = new (0, $jollT.Texture)({
            source: new (0, $5yirD.ImageSource)({
                resource: canvas
            })
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                glitchUniforms: {
                    uSeed: {
                        value: options?.seed ?? 0,
                        type: "f32"
                    },
                    uDimensions: {
                        value: new Float32Array(2),
                        type: "vec2<f32>"
                    },
                    uAspect: {
                        value: 1,
                        type: "f32"
                    },
                    uFillMode: {
                        value: options?.fillMode ?? 0,
                        type: "f32"
                    },
                    uOffset: {
                        value: options?.offset ?? 100,
                        type: "f32"
                    },
                    uDirection: {
                        value: options?.direction ?? 0,
                        type: "f32"
                    },
                    uRed: {
                        value: options.red,
                        type: "vec2<f32>"
                    },
                    uGreen: {
                        value: options.green,
                        type: "vec2<f32>"
                    },
                    uBlue: {
                        value: options.blue,
                        type: "vec2<f32>"
                    }
                },
                uDisplacementMap: texture.source,
                uDisplacementSampler: texture.source.style
            }
        });
        $fd220b2e775d2042$var$__publicField(this, "uniforms");
        /**
     * `true` will divide the bands roughly based on equal amounts
     * where as setting to `false` will vary the band sizes dramatically (more random looking).
     */ $fd220b2e775d2042$var$__publicField(this, "average", false);
        /** Minimum size of slices as a portion of the `sampleSize` */ $fd220b2e775d2042$var$__publicField(this, "minSize", 8);
        /** Height of the displacement map canvas. */ $fd220b2e775d2042$var$__publicField(this, "sampleSize", 512);
        /** Internally generated canvas. */ $fd220b2e775d2042$var$__publicField(this, "_canvas");
        /**
     * The displacement map is used to generate the bands.
     * If using your own texture, `slices` will be ignored.
     *
     * @member {Texture}
     * @readonly
     */ $fd220b2e775d2042$var$__publicField(this, "texture");
        /** Internal number of slices */ $fd220b2e775d2042$var$__publicField(this, "_slices", 0);
        $fd220b2e775d2042$var$__publicField(this, "_sizes", new Float32Array(1));
        $fd220b2e775d2042$var$__publicField(this, "_offsets", new Float32Array(1));
        this.uniforms = this.resources.glitchUniforms.uniforms;
        this._canvas = canvas;
        this.texture = texture;
        Object.assign(this, options);
    }
    /**
   * Override existing apply method in Filter
   * @private
   */ apply(filterManager, input, output, clearMode) {
        const { width: width, height: height } = input.frame;
        this.uniforms.uDimensions[0] = width;
        this.uniforms.uDimensions[1] = height;
        this.uniforms.uAspect = height / width;
        filterManager.applyFilter(this, input, output, clearMode);
    }
    /**
   * Randomize the slices size (heights).
   *
   * @private
   */ _randomizeSizes() {
        const arr = this._sizes;
        const last = this._slices - 1;
        const size = this.sampleSize;
        const min = Math.min(this.minSize / size, 0.9 / this._slices);
        if (this.average) {
            const count = this._slices;
            let rest = 1;
            for(let i = 0; i < last; i++){
                const averageWidth = rest / (count - i);
                const w = Math.max(averageWidth * (1 - Math.random() * 0.6), min);
                arr[i] = w;
                rest -= w;
            }
            arr[last] = rest;
        } else {
            let rest = 1;
            const ratio = Math.sqrt(1 / this._slices);
            for(let i = 0; i < last; i++){
                const w = Math.max(ratio * rest * Math.random(), min);
                arr[i] = w;
                rest -= w;
            }
            arr[last] = rest;
        }
        this.shuffle();
    }
    /**
   * Shuffle the sizes of the slices, advanced usage.
   */ shuffle() {
        const arr = this._sizes;
        const last = this._slices - 1;
        for(let i = last; i > 0; i--){
            const rand = Math.random() * i >> 0;
            const temp = arr[i];
            arr[i] = arr[rand];
            arr[rand] = temp;
        }
    }
    /**
   * Randomize the values for offset from -1 to 1
   *
   * @private
   */ _randomizeOffsets() {
        for(let i = 0; i < this._slices; i++)this._offsets[i] = Math.random() * (Math.random() < 0.5 ? -1 : 1);
    }
    /**
   * Regenerating random size, offsets for slices.
   */ refresh() {
        this._randomizeSizes();
        this._randomizeOffsets();
        this.redraw();
    }
    /**
   * Redraw displacement bitmap texture, advanced usage.
   */ redraw() {
        const size = this.sampleSize;
        const texture = this.texture;
        const ctx = this._canvas.getContext("2d");
        ctx.clearRect(0, 0, 8, size);
        let offset;
        let y = 0;
        for(let i = 0; i < this._slices; i++){
            offset = Math.floor(this._offsets[i] * 256);
            const height = this._sizes[i] * size;
            const red = offset > 0 ? offset : 0;
            const green = offset < 0 ? -offset : 0;
            ctx.fillStyle = `rgba(${red}, ${green}, 0, 1)`;
            ctx.fillRect(0, y >> 0, size, height + 1 >> 0);
            y += height;
        }
        texture.source.update();
    }
    /**
   * Manually custom slices size (height) of displacement bitmap
   *
   * @member {number[]|Float32Array}
   */ set sizes(sizes) {
        const len = Math.min(this._slices, sizes.length);
        for(let i = 0; i < len; i++)this._sizes[i] = sizes[i];
    }
    get sizes() {
        return this._sizes;
    }
    /**
   * Manually set custom slices offset of displacement bitmap, this is
   * a collection of values from -1 to 1. To change the max offset value
   * set `offset`.
   *
   * @member {number[]|Float32Array}
   */ set offsets(offsets) {
        const len = Math.min(this._slices, offsets.length);
        for(let i = 0; i < len; i++)this._offsets[i] = offsets[i];
    }
    get offsets() {
        return this._offsets;
    }
    /**
   * The count of slices.
   * @default 5
   */ get slices() {
        return this._slices;
    }
    set slices(value) {
        if (this._slices === value) return;
        this._slices = value;
        this._sizes = new Float32Array(value);
        this._offsets = new Float32Array(value);
        this.refresh();
    }
    /**
   * The maximum offset amount of slices.
   * @default 100
   */ get offset() {
        return this.uniforms.uOffset;
    }
    set offset(value) {
        this.uniforms.uOffset = value;
    }
    /**
   * A seed value for randomizing glitch effect.
   * @default 0
   */ get seed() {
        return this.uniforms.uSeed;
    }
    set seed(value) {
        this.uniforms.uSeed = value;
    }
    /**
   * The fill mode of the space after the offset.
   * @default FILL_MODES.TRANSPARENT
   */ get fillMode() {
        return this.uniforms.uFillMode;
    }
    set fillMode(value) {
        this.uniforms.uFillMode = value;
    }
    /**
   * The angle in degree of the offset of slices.
   * @default 0
   */ get direction() {
        return this.uniforms.uDirection / (0, $l8FfC.DEG_TO_RAD);
    }
    set direction(value) {
        this.uniforms.uDirection = value * (0, $l8FfC.DEG_TO_RAD);
    }
    /**
   * Red channel offset.
   * @default {x:0,y:0}
   */ get red() {
        return this.uniforms.uRed;
    }
    set red(value) {
        if (Array.isArray(value)) value = {
            x: value[0],
            y: value[1]
        };
        this.uniforms.uRed = value;
    }
    /**
   * Green channel offset.
   * @default {x:0,y:0}
   */ get green() {
        return this.uniforms.uGreen;
    }
    set green(value) {
        if (Array.isArray(value)) value = {
            x: value[0],
            y: value[1]
        };
        this.uniforms.uGreen = value;
    }
    /**
   * Blue offset.
   * @default {x:0,y:0}
   */ get blue() {
        return this.uniforms.uBlue;
    }
    set blue(value) {
        if (Array.isArray(value)) value = {
            x: value[0],
            y: value[1]
        };
        this.uniforms.uBlue = value;
    }
    /**
   * Removes all references
   */ destroy() {
        this.texture?.destroy(true);
        this.texture = this._canvas = this.red = this.green = this.blue = this._sizes = this._offsets = null;
    }
};
/** Default constructor options. */ $fd220b2e775d2042$var$__publicField($fd220b2e775d2042$var$_GlitchFilter, "defaults", {
    slices: 5,
    offset: 100,
    direction: 0,
    fillMode: 0,
    average: false,
    seed: 0,
    red: {
        x: 0,
        y: 0
    },
    green: {
        x: 0,
        y: 0
    },
    blue: {
        x: 0,
        y: 0
    },
    minSize: 8,
    sampleSize: 512
});
let $fd220b2e775d2042$export$75cd31e528fd02b8 = $fd220b2e775d2042$var$_GlitchFilter;



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $bEj7k = parcelRequire("bEj7k");
var $ld81y = parcelRequire("ld81y");


var $d7a33e1541d28d4b$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec2 uStrength;\nuniform vec3 uColor;\nuniform float uKnockout;\nuniform float uAlpha;\n\nuniform vec4 uInputSize;\nuniform vec4 uInputClamp;\n\nconst float PI = 3.14159265358979323846264;\n\n// Hard-assignment of DIST and ANGLE_STEP_SIZE instead of using uDistance and uQuality to allow them to be use on GLSL loop conditions\nconst float DIST = __DIST__;\nconst float ANGLE_STEP_SIZE = min(__ANGLE_STEP_SIZE__, PI * 2.);\nconst float ANGLE_STEP_NUM = ceil(PI * 2. / ANGLE_STEP_SIZE);\nconst float MAX_TOTAL_ALPHA = ANGLE_STEP_NUM * DIST * (DIST + 1.) / 2.;\n\nvoid main(void) {\n    vec2 px = vec2(1.) / uInputSize.xy;\n\n    float totalAlpha = 0.;\n\n    vec2 direction;\n    vec2 displaced;\n    vec4 curColor;\n\n    for (float angle = 0.; angle < PI * 2.; angle += ANGLE_STEP_SIZE) {\n      direction = vec2(cos(angle), sin(angle)) * px;\n\n      for (float curDistance = 0.; curDistance < DIST; curDistance++) {\n          displaced = clamp(vTextureCoord + direction * (curDistance + 1.), uInputClamp.xy, uInputClamp.zw);\n          curColor = texture(uTexture, displaced);\n          totalAlpha += (DIST - curDistance) * curColor.a;\n      }\n    }\n    \n    curColor = texture(uTexture, vTextureCoord);\n\n    vec4 glowColor = vec4(uColor, uAlpha);\n    bool knockout = uKnockout > .5;\n    float innerStrength = uStrength[0];\n    float outerStrength = uStrength[1];\n\n    float alphaRatio = totalAlpha / MAX_TOTAL_ALPHA;\n    float innerGlowAlpha = (1. - alphaRatio) * innerStrength * curColor.a * uAlpha;\n    float innerGlowStrength = min(1., innerGlowAlpha);\n    \n    vec4 innerColor = mix(curColor, glowColor, innerGlowStrength);\n    float outerGlowAlpha = alphaRatio * outerStrength * (1. - curColor.a) * uAlpha;\n    float outerGlowStrength = min(1. - innerColor.a, outerGlowAlpha);\n    vec4 outerGlowColor = outerGlowStrength * glowColor.rgba;\n\n    if (knockout) {\n      float resultAlpha = outerGlowAlpha + innerGlowAlpha;\n      finalColor = vec4(glowColor.rgb * resultAlpha, resultAlpha);\n    }\n    else {\n      finalColor = innerColor + outerGlowColor;\n    }\n}\n";


var $b6183e58162ba497$export$2e2bcd8739ae039 = "struct GlowUniforms {\n  uDistance: f32,\n  uStrength: vec2<f32>,\n  uColor: vec3<f32>,\n  uAlpha: f32,\n  uQuality: f32,\n  uKnockout: f32,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> glowUniforms : GlowUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let quality = glowUniforms.uQuality;\n  let distance = glowUniforms.uDistance;\n\n  let dist: f32 = glowUniforms.uDistance;\n  let angleStepSize: f32 = min(1. / quality / distance, PI * 2.0);\n  let angleStepNum: f32 = ceil(PI * 2.0 / angleStepSize);\n\n  let px: vec2<f32> = vec2<f32>(1.0 / gfu.uInputSize.xy);\n\n  var totalAlpha: f32 = 0.0;\n\n  var direction: vec2<f32>;\n  var displaced: vec2<f32>;\n  var curColor: vec4<f32>;\n\n  for (var angle = 0.0; angle < PI * 2.0; angle += angleStepSize) {\n    direction = vec2<f32>(cos(angle), sin(angle)) * px;\n    for (var curDistance = 0.0; curDistance < dist; curDistance+=1) {\n      displaced = vec2<f32>(clamp(uv + direction * (curDistance + 1.0), gfu.uInputClamp.xy, gfu.uInputClamp.zw));\n      curColor = textureSample(uTexture, uSampler, displaced);\n      totalAlpha += (dist - curDistance) * curColor.a;\n    }\n  }\n    \n  curColor = textureSample(uTexture, uSampler, uv);\n\n  let glowColorRGB = glowUniforms.uColor;\n  let glowAlpha = glowUniforms.uAlpha;\n  let glowColor = vec4<f32>(glowColorRGB, glowAlpha);\n  let knockout: bool = glowUniforms.uKnockout > 0.5;\n  let innerStrength = glowUniforms.uStrength[0];\n  let outerStrength = glowUniforms.uStrength[1];\n\n  let alphaRatio: f32 = (totalAlpha / (angleStepNum * dist * (dist + 1.0) / 2.0));\n  let innerGlowAlpha: f32 = (1.0 - alphaRatio) * innerStrength * curColor.a * glowAlpha;\n  let innerGlowStrength: f32 = min(1.0, innerGlowAlpha);\n  \n  let innerColor: vec4<f32> = mix(curColor, glowColor, innerGlowStrength);\n  let outerGlowAlpha: f32 = alphaRatio * outerStrength * (1. - curColor.a) * glowAlpha;\n  let outerGlowStrength: f32 = min(1.0 - innerColor.a, outerGlowAlpha);\n  let outerGlowColor: vec4<f32> = outerGlowStrength * glowColor.rgba;\n  \n  if (knockout) {\n    let resultAlpha: f32 = outerGlowAlpha + innerGlowAlpha;\n    return vec4<f32>(glowColor.rgb * resultAlpha, resultAlpha);\n  }\n  else {\n    return innerColor + outerGlowColor;\n  }\n}\n\nconst PI: f32 = 3.14159265358979323846264;";


var $56ce4e1f15249c3e$var$__defProp = Object.defineProperty;
var $56ce4e1f15249c3e$var$__defNormalProp = (obj, key, value)=>key in obj ? $56ce4e1f15249c3e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $56ce4e1f15249c3e$var$__publicField = (obj, key, value)=>{
    $56ce4e1f15249c3e$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $56ce4e1f15249c3e$var$_GlowFilter = class _GlowFilter extends (0, $ld81y.Filter) {
    /**
   * @param options - Options for the GlowFilter constructor.
   */ constructor(options){
        options = {
            ..._GlowFilter.DEFAULT_OPTIONS,
            ...options
        };
        const distance = options.distance ?? 10;
        const quality = options.quality ?? 0.1;
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $b6183e58162ba497$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: (0, $d7a33e1541d28d4b$export$2e2bcd8739ae039).replace(/__ANGLE_STEP_SIZE__/gi, `${(1 / quality / distance).toFixed(7)}`).replace(/__DIST__/gi, `${distance.toFixed(0)}.0`),
            name: "glow-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                glowUniforms: {
                    uDistance: {
                        value: distance,
                        type: "f32"
                    },
                    uStrength: {
                        value: [
                            options.innerStrength,
                            options.outerStrength
                        ],
                        type: "vec2<f32>"
                    },
                    uColor: {
                        value: new Float32Array(3),
                        type: "vec3<f32>"
                    },
                    uAlpha: {
                        value: options.alpha,
                        type: "f32"
                    },
                    uQuality: {
                        value: quality,
                        type: "f32"
                    },
                    uKnockout: {
                        value: options?.knockout ?? false ? 1 : 0,
                        type: "f32"
                    }
                }
            },
            padding: distance
        });
        $56ce4e1f15249c3e$var$__publicField(this, "uniforms");
        $56ce4e1f15249c3e$var$__publicField(this, "_color");
        this.uniforms = this.resources.glowUniforms.uniforms;
        this._color = new (0, $bEj7k.Color)();
        this.color = options.color ?? 16777215;
    }
    /**
   * Only draw the glow, not the texture itself
   * @default false
   */ get distance() {
        return this.uniforms.uDistance;
    }
    set distance(value) {
        this.uniforms.uDistance = this.padding = value;
    }
    /**
  * The strength of the glow inward from the edge of the sprite.
  * @default 0
  */ get innerStrength() {
        return this.uniforms.uStrength[0];
    }
    set innerStrength(value) {
        this.uniforms.uStrength[0] = value;
    }
    /**
  * The strength of the glow outward from the edge of the sprite.
  * @default 4
  */ get outerStrength() {
        return this.uniforms.uStrength[1];
    }
    set outerStrength(value) {
        this.uniforms.uStrength[1] = value;
    }
    /**
  * The color of the glow.
  * @default 0xFFFFFF
  */ get color() {
        return this._color.value;
    }
    set color(value) {
        this._color.setValue(value);
        const [r, g, b] = this._color.toArray();
        this.uniforms.uColor[0] = r;
        this.uniforms.uColor[1] = g;
        this.uniforms.uColor[2] = b;
    }
    /**
  * The alpha of the glow
  * @default 1
  */ get alpha() {
        return this.uniforms.uAlpha;
    }
    set alpha(value) {
        this.uniforms.uAlpha = value;
    }
    /**
  * A number between 0 and 1 that describes the quality of the glow. The higher the number the less performant
  * @default 0.1
  */ get quality() {
        return this.uniforms.uQuality;
    }
    set quality(value) {
        this.uniforms.uQuality = value;
    }
    /**
  * Only draw the glow, not the texture itself
  * @default false
  */ get knockout() {
        return this.uniforms.uKnockout === 1;
    }
    set knockout(value) {
        this.uniforms.uKnockout = value ? 1 : 0;
    }
};
/** Default values for options. */ $56ce4e1f15249c3e$var$__publicField($56ce4e1f15249c3e$var$_GlowFilter, "DEFAULT_OPTIONS", {
    distance: 10,
    outerStrength: 4,
    innerStrength: 0,
    color: 16777215,
    alpha: 1,
    quality: 0.1,
    knockout: false
});
let $56ce4e1f15249c3e$export$faabf7f2d3f0943e = $56ce4e1f15249c3e$var$_GlowFilter;



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $l8FfC = parcelRequire("l8FfC");
var $ld81y = parcelRequire("ld81y");


var $6304995d30f7ba7c$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec2 uDimensions;\nuniform float uParallel;\nuniform vec2 uLight;\nuniform float uAspect;\nuniform float uTime;\nuniform vec3 uRay;\n\nuniform vec4 uInputSize;\n\n${PERLIN}\n\nvoid main(void) {\n    vec2 uDimensions = uDimensions;\n    bool uParallel = uParallel > 0.5;\n    vec2 uLight = uLight;\n    float uAspect = uAspect;\n\n    vec2 coord = vTextureCoord * uInputSize.xy / uDimensions;\n\n    float d;\n\n    if (uParallel) {\n        float _cos = uLight.x;\n        float _sin = uLight.y;\n        d = (_cos * coord.x) + (_sin * coord.y * uAspect);\n    } else {\n        float dx = coord.x - uLight.x / uDimensions.x;\n        float dy = (coord.y - uLight.y / uDimensions.y) * uAspect;\n        float dis = sqrt(dx * dx + dy * dy) + 0.00001;\n        d = dy / dis;\n    }\n\n    float uTime = uTime;\n    vec3 uRay = uRay;\n\n    float gain = uRay[0];\n    float lacunarity = uRay[1];\n    float alpha = uRay[2];\n\n    vec3 dir = vec3(d, d, 0.0);\n    float noise = turb(dir + vec3(uTime, 0.0, 62.1 + uTime) * 0.05, vec3(480.0, 320.0, 480.0), lacunarity, gain);\n    noise = mix(noise, 0.0, 0.3);\n    //fade vertically.\n    vec4 mist = vec4(vec3(noise), 1.0) * (1.0 - coord.y);\n    mist.a = 1.0;\n    // apply user alpha\n    mist *= alpha;\n\n    finalColor = texture(uTexture, vTextureCoord) + mist;\n}\n";


var $8973463d588368b3$export$2e2bcd8739ae039 = "struct GodrayUniforms {\n  uLight: vec2<f32>,\n  uParallel: f32,\n  uAspect: f32,\n  uTime: f32,\n  uRay: vec3<f32>,\n  uDimensions: vec2<f32>,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> godrayUniforms : GodrayUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let uDimensions: vec2<f32> = godrayUniforms.uDimensions;\n  let uParallel: bool = godrayUniforms.uParallel > 0.5;\n  let uLight: vec2<f32> = godrayUniforms.uLight;\n  let uAspect: f32 = godrayUniforms.uAspect;\n\n  let coord: vec2<f32> = uv * gfu.uInputSize.xy / uDimensions;\n\n  var d: f32;\n\n  if (uParallel) {\n    let _cos: f32 = uLight.x;\n    let _sin: f32 = uLight.y;\n    d = (_cos * coord.x) + (_sin * coord.y * uAspect);\n  } else {\n    let dx: f32 = coord.x - uLight.x / uDimensions.x;\n    let dy: f32 = (coord.y - uLight.y / uDimensions.y) * uAspect;\n    let dis: f32 = sqrt(dx * dx + dy * dy) + 0.00001;\n    d = dy / dis;\n  }\n\n  let uTime: f32 = godrayUniforms.uTime;\n  let uRay: vec3<f32> = godrayUniforms.uRay;\n  \n  let gain = uRay[0];\n  let lacunarity = uRay[1];\n  let alpha = uRay[2];\n\n  let dir: vec3<f32> = vec3<f32>(d, d, 0.0);\n  var noise: f32 = turb(dir + vec3<f32>(uTime, 0.0, 62.1 + uTime) * 0.05, vec3<f32>(480.0, 320.0, 480.0), lacunarity, gain);\n  noise = mix(noise, 0.0, 0.3);\n  //fade vertically.\n  var mist: vec4<f32> = vec4<f32>(vec3<f32>(noise), 1.0) * (1.0 - coord.y);\n  mist.a = 1.0;\n  // apply user alpha\n  mist *= alpha;\n  return textureSample(uTexture, uSampler, uv) + mist;\n}\n\n${PERLIN}";


var $cbdc145f00f29045$export$2e2bcd8739ae039 = "vec3 mod289(vec3 x)\n{\n    return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\nvec4 mod289(vec4 x)\n{\n    return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\nvec4 permute(vec4 x)\n{\n    return mod289(((x * 34.0) + 1.0) * x);\n}\nvec4 taylorInvSqrt(vec4 r)\n{\n    return 1.79284291400159 - 0.85373472095314 * r;\n}\nvec3 fade(vec3 t)\n{\n    return t * t * t * (t * (t * 6.0 - 15.0) + 10.0);\n}\n// Classic Perlin noise, periodic variant\nfloat pnoise(vec3 P, vec3 rep)\n{\n    vec3 Pi0 = mod(floor(P), rep); // Integer part, modulo period\n    vec3 Pi1 = mod(Pi0 + vec3(1.0), rep); // Integer part + 1, mod period\n    Pi0 = mod289(Pi0);\n    Pi1 = mod289(Pi1);\n    vec3 Pf0 = fract(P); // Fractional part for interpolation\n    vec3 Pf1 = Pf0 - vec3(1.0); // Fractional part - 1.0\n    vec4 ix = vec4(Pi0.x, Pi1.x, Pi0.x, Pi1.x);\n    vec4 iy = vec4(Pi0.yy, Pi1.yy);\n    vec4 iz0 = Pi0.zzzz;\n    vec4 iz1 = Pi1.zzzz;\n    vec4 ixy = permute(permute(ix) + iy);\n    vec4 ixy0 = permute(ixy + iz0);\n    vec4 ixy1 = permute(ixy + iz1);\n    vec4 gx0 = ixy0 * (1.0 / 7.0);\n    vec4 gy0 = fract(floor(gx0) * (1.0 / 7.0)) - 0.5;\n    gx0 = fract(gx0);\n    vec4 gz0 = vec4(0.5) - abs(gx0) - abs(gy0);\n    vec4 sz0 = step(gz0, vec4(0.0));\n    gx0 -= sz0 * (step(0.0, gx0) - 0.5);\n    gy0 -= sz0 * (step(0.0, gy0) - 0.5);\n    vec4 gx1 = ixy1 * (1.0 / 7.0);\n    vec4 gy1 = fract(floor(gx1) * (1.0 / 7.0)) - 0.5;\n    gx1 = fract(gx1);\n    vec4 gz1 = vec4(0.5) - abs(gx1) - abs(gy1);\n    vec4 sz1 = step(gz1, vec4(0.0));\n    gx1 -= sz1 * (step(0.0, gx1) - 0.5);\n    gy1 -= sz1 * (step(0.0, gy1) - 0.5);\n    vec3 g000 = vec3(gx0.x, gy0.x, gz0.x);\n    vec3 g100 = vec3(gx0.y, gy0.y, gz0.y);\n    vec3 g010 = vec3(gx0.z, gy0.z, gz0.z);\n    vec3 g110 = vec3(gx0.w, gy0.w, gz0.w);\n    vec3 g001 = vec3(gx1.x, gy1.x, gz1.x);\n    vec3 g101 = vec3(gx1.y, gy1.y, gz1.y);\n    vec3 g011 = vec3(gx1.z, gy1.z, gz1.z);\n    vec3 g111 = vec3(gx1.w, gy1.w, gz1.w);\n    vec4 norm0 = taylorInvSqrt(vec4(dot(g000, g000), dot(g010, g010), dot(g100, g100), dot(g110, g110)));\n    g000 *= norm0.x;\n    g010 *= norm0.y;\n    g100 *= norm0.z;\n    g110 *= norm0.w;\n    vec4 norm1 = taylorInvSqrt(vec4(dot(g001, g001), dot(g011, g011), dot(g101, g101), dot(g111, g111)));\n    g001 *= norm1.x;\n    g011 *= norm1.y;\n    g101 *= norm1.z;\n    g111 *= norm1.w;\n    float n000 = dot(g000, Pf0);\n    float n100 = dot(g100, vec3(Pf1.x, Pf0.yz));\n    float n010 = dot(g010, vec3(Pf0.x, Pf1.y, Pf0.z));\n    float n110 = dot(g110, vec3(Pf1.xy, Pf0.z));\n    float n001 = dot(g001, vec3(Pf0.xy, Pf1.z));\n    float n101 = dot(g101, vec3(Pf1.x, Pf0.y, Pf1.z));\n    float n011 = dot(g011, vec3(Pf0.x, Pf1.yz));\n    float n111 = dot(g111, Pf1);\n    vec3 fade_xyz = fade(Pf0);\n    vec4 n_z = mix(vec4(n000, n100, n010, n110), vec4(n001, n101, n011, n111), fade_xyz.z);\n    vec2 n_yz = mix(n_z.xy, n_z.zw, fade_xyz.y);\n    float n_xyz = mix(n_yz.x, n_yz.y, fade_xyz.x);\n    return 2.2 * n_xyz;\n}\nfloat turb(vec3 P, vec3 rep, float lacunarity, float gain)\n{\n    float sum = 0.0;\n    float sc = 1.0;\n    float totalgain = 1.0;\n    for (float i = 0.0; i < 6.0; i++)\n    {\n        sum += totalgain * pnoise(P * sc, rep);\n        sc *= lacunarity;\n        totalgain *= gain;\n    }\n    return abs(sum);\n}\n";


var $b8d6b8814e225920$export$2e2bcd8739ae039 = "// Taken from https://gist.github.com/munrocket/236ed5ba7e409b8bdf1ff6eca5dcdc39\n\nfn moduloVec3(x: vec3<f32>, y: vec3<f32>) -> vec3<f32>\n{\n  return x - y * floor(x/y);\n}\nfn mod289Vec3(x: vec3<f32>) -> vec3<f32>\n{\n    return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\nfn mod289Vec4(x: vec4<f32>) -> vec4<f32>\n{\n    return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\nfn permute4(x: vec4<f32>) -> vec4<f32>\n{\n    return mod289Vec4(((x * 34.0) + 1.0) * x);\n}\nfn taylorInvSqrt(r: vec4<f32>) -> vec4<f32>\n{\n    return 1.79284291400159 - 0.85373472095314 * r;\n}\nfn fade3(t: vec3<f32>) -> vec3<f32>\n{\n    return t * t * t * (t * (t * 6.0 - 15.0) + 10.0);\n}\nfn fade2(t: vec2<f32>) -> vec2<f32> { return t * t * t * (t * (t * 6. - 15.) + 10.); }\n\nfn perlinNoise2(P: vec2<f32>) -> f32 {\n  var Pi: vec4<f32> = floor(P.xyxy) + vec4<f32>(0., 0., 1., 1.);\n  let Pf = fract(P.xyxy) - vec4<f32>(0., 0., 1., 1.);\n  Pi = Pi % vec4<f32>(289.); // To avoid truncation effects in permutation\n  let ix = Pi.xzxz;\n  let iy = Pi.yyww;\n  let fx = Pf.xzxz;\n  let fy = Pf.yyww;\n  let i = permute4(permute4(ix) + iy);\n  var gx: vec4<f32> = 2. * fract(i * 0.0243902439) - 1.; // 1/41 = 0.024...\n  let gy = abs(gx) - 0.5;\n  let tx = floor(gx + 0.5);\n  gx = gx - tx;\n  var g00: vec2<f32> = vec2<f32>(gx.x, gy.x);\n  var g10: vec2<f32> = vec2<f32>(gx.y, gy.y);\n  var g01: vec2<f32> = vec2<f32>(gx.z, gy.z);\n  var g11: vec2<f32> = vec2<f32>(gx.w, gy.w);\n  let norm = 1.79284291400159 - 0.85373472095314 *\n      vec4<f32>(dot(g00, g00), dot(g01, g01), dot(g10, g10), dot(g11, g11));\n  g00 = g00 * norm.x;\n  g01 = g01 * norm.y;\n  g10 = g10 * norm.z;\n  g11 = g11 * norm.w;\n  let n00 = dot(g00, vec2<f32>(fx.x, fy.x));\n  let n10 = dot(g10, vec2<f32>(fx.y, fy.y));\n  let n01 = dot(g01, vec2<f32>(fx.z, fy.z));\n  let n11 = dot(g11, vec2<f32>(fx.w, fy.w));\n  let fade_xy = fade2(Pf.xy);\n  let n_x = mix(vec2<f32>(n00, n01), vec2<f32>(n10, n11), vec2<f32>(fade_xy.x));\n  let n_xy = mix(n_x.x, n_x.y, fade_xy.y);\n  return 2.3 * n_xy;\n}\n\n// Classic Perlin noise, periodic variant\nfn perlinNoise3(P: vec3<f32>, rep: vec3<f32>) -> f32\n{\n    var Pi0: vec3<f32> = moduloVec3(floor(P), rep); // Integer part, modulo period\n    var Pi1: vec3<f32> = moduloVec3(Pi0 + vec3<f32>(1.0), rep); // Integer part + 1, mod period\n    Pi0 = mod289Vec3(Pi0);\n    Pi1 = mod289Vec3(Pi1);\n    let Pf0: vec3<f32> = fract(P); // Fractional part for interpolation\n    let Pf1: vec3<f32> = Pf0 - vec3<f32>(1.0); // Fractional part - 1.0\n    let ix: vec4<f32> = vec4<f32>(Pi0.x, Pi1.x, Pi0.x, Pi1.x);\n    let iy: vec4<f32> = vec4<f32>(Pi0.yy, Pi1.yy);\n    let iz0: vec4<f32> = Pi0.zzzz;\n    let iz1: vec4<f32> = Pi1.zzzz;\n    let ixy: vec4<f32> = permute4(permute4(ix) + iy);\n    let ixy0: vec4<f32> = permute4(ixy + iz0);\n    let ixy1: vec4<f32> = permute4(ixy + iz1);\n    var gx0: vec4<f32> = ixy0 * (1.0 / 7.0);\n    var gy0: vec4<f32> = fract(floor(gx0) * (1.0 / 7.0)) - 0.5;\n    gx0 = fract(gx0);\n    let gz0: vec4<f32> = vec4<f32>(0.5) - abs(gx0) - abs(gy0);\n    let sz0: vec4<f32> = step(gz0, vec4<f32>(0.0));\n    gx0 -= sz0 * (step(vec4<f32>(0.0), gx0) - 0.5);\n    gy0 -= sz0 * (step(vec4<f32>(0.0), gy0) - 0.5);\n    var gx1: vec4<f32> = ixy1 * (1.0 / 7.0);\n    var gy1: vec4<f32> = fract(floor(gx1) * (1.0 / 7.0)) - 0.5;\n    gx1 = fract(gx1);\n    let gz1: vec4<f32> = vec4<f32>(0.5) - abs(gx1) - abs(gy1);\n    let sz1: vec4<f32> = step(gz1, vec4<f32>(0.0));\n    gx1 -= sz1 * (step(vec4<f32>(0.0), gx1) - 0.5);\n    gy1 -= sz1 * (step(vec4<f32>(0.0), gy1) - 0.5);\n    var g000: vec3<f32> = vec3<f32>(gx0.x, gy0.x, gz0.x);\n    var g100: vec3<f32> = vec3<f32>(gx0.y, gy0.y, gz0.y);\n    var g010: vec3<f32> = vec3<f32>(gx0.z, gy0.z, gz0.z);\n    var g110: vec3<f32> = vec3<f32>(gx0.w, gy0.w, gz0.w);\n    var g001: vec3<f32> = vec3<f32>(gx1.x, gy1.x, gz1.x);\n    var g101: vec3<f32> = vec3<f32>(gx1.y, gy1.y, gz1.y);\n    var g011: vec3<f32> = vec3<f32>(gx1.z, gy1.z, gz1.z);\n    var g111: vec3<f32> = vec3<f32>(gx1.w, gy1.w, gz1.w);\n    let norm0: vec4<f32> = taylorInvSqrt(vec4<f32>(dot(g000, g000), dot(g010, g010), dot(g100, g100), dot(g110, g110)));\n    g000 *= norm0.x;\n    g010 *= norm0.y;\n    g100 *= norm0.z;\n    g110 *= norm0.w;\n    let norm1: vec4<f32> = taylorInvSqrt(vec4<f32>(dot(g001, g001), dot(g011, g011), dot(g101, g101), dot(g111, g111)));\n    g001 *= norm1.x;\n    g011 *= norm1.y;\n    g101 *= norm1.z;\n    g111 *= norm1.w;\n    let n000: f32 = dot(g000, Pf0);\n    let n100: f32 = dot(g100, vec3<f32>(Pf1.x, Pf0.yz));\n    let n010: f32 = dot(g010, vec3<f32>(Pf0.x, Pf1.y, Pf0.z));\n    let n110: f32 = dot(g110, vec3<f32>(Pf1.xy, Pf0.z));\n    let n001: f32 = dot(g001, vec3<f32>(Pf0.xy, Pf1.z));\n    let n101: f32 = dot(g101, vec3<f32>(Pf1.x, Pf0.y, Pf1.z));\n    let n011: f32 = dot(g011, vec3<f32>(Pf0.x, Pf1.yz));\n    let n111: f32 = dot(g111, Pf1);\n    let fade_xyz: vec3<f32> = fade3(Pf0);\n    let n_z: vec4<f32> = mix(vec4<f32>(n000, n100, n010, n110), vec4<f32>(n001, n101, n011, n111), fade_xyz.z);\n    let n_yz: vec2<f32> = mix(n_z.xy, n_z.zw, fade_xyz.y);\n    let n_xyz: f32 = mix(n_yz.x, n_yz.y, fade_xyz.x);\n    return 2.2 * n_xyz;\n}\nfn turb(P: vec3<f32>, rep: vec3<f32>, lacunarity: f32, gain: f32) -> f32\n{\n    var sum: f32 = 0.0;\n    var sc: f32 = 1.0;\n    var totalgain: f32 = 1.0;\n    for (var i = 0.0; i < 6.0; i += 1)\n    {\n        sum += totalgain * perlinNoise3(P * sc, rep);\n        sc *= lacunarity;\n        totalgain *= gain;\n    }\n    return abs(sum);\n}";


var $5c2adae217f01dae$var$__defProp = Object.defineProperty;
var $5c2adae217f01dae$var$__defNormalProp = (obj, key, value)=>key in obj ? $5c2adae217f01dae$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5c2adae217f01dae$var$__publicField = (obj, key, value)=>{
    $5c2adae217f01dae$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $5c2adae217f01dae$var$_GodrayFilter = class _GodrayFilter extends (0, $ld81y.Filter) {
    /**
   * @param options - Options for the GodrayFilter constructor.
   */ constructor(options){
        options = {
            ..._GodrayFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: (0, $8973463d588368b3$export$2e2bcd8739ae039).replace("${PERLIN}", (0, $b8d6b8814e225920$export$2e2bcd8739ae039)),
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: (0, $6304995d30f7ba7c$export$2e2bcd8739ae039).replace("${PERLIN}", (0, $cbdc145f00f29045$export$2e2bcd8739ae039)),
            name: "god-ray-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                godrayUniforms: {
                    uLight: {
                        value: new Float32Array(2),
                        type: "vec2<f32>"
                    },
                    uParallel: {
                        value: 0,
                        type: "f32"
                    },
                    uAspect: {
                        value: 0,
                        type: "f32"
                    },
                    uTime: {
                        value: options.time,
                        type: "f32"
                    },
                    uRay: {
                        value: new Float32Array(3),
                        type: "vec3<f32>"
                    },
                    uDimensions: {
                        value: new Float32Array(2),
                        type: "vec2<f32>"
                    }
                }
            }
        });
        $5c2adae217f01dae$var$__publicField(this, "uniforms");
        /**
     * The current time position
     * @default 0
     */ $5c2adae217f01dae$var$__publicField(this, "time", 0);
        $5c2adae217f01dae$var$__publicField(this, "_angleLight", [
            0,
            0
        ]);
        $5c2adae217f01dae$var$__publicField(this, "_angle", 0);
        $5c2adae217f01dae$var$__publicField(this, "_center");
        this.uniforms = this.resources.godrayUniforms.uniforms;
        Object.assign(this, options);
    }
    /**
   * Override existing apply method in Filter
   * @override
   * @ignore
   */ apply(filterManager, input, output, clearMode) {
        const width = input.frame.width;
        const height = input.frame.height;
        this.uniforms.uLight[0] = this.parallel ? this._angleLight[0] : this._center.x;
        this.uniforms.uLight[1] = this.parallel ? this._angleLight[1] : this._center.y;
        this.uniforms.uDimensions[0] = width;
        this.uniforms.uDimensions[1] = height;
        this.uniforms.uAspect = height / width;
        this.uniforms.uTime = this.time;
        filterManager.applyFilter(this, input, output, clearMode);
    }
    /**
   * The angle/light-source of the rays in degrees. For instance,
   * a value of 0 is vertical rays, values of 90 or -90 produce horizontal rays
   * @default 30
   */ get angle() {
        return this._angle;
    }
    set angle(value) {
        this._angle = value;
        const radians = value * (0, $l8FfC.DEG_TO_RAD);
        this._angleLight[0] = Math.cos(radians);
        this._angleLight[1] = Math.sin(radians);
    }
    /**
   * `true` if light rays are parallel (uses angle), `false` to use the focal `center` point
   * @default true
   */ get parallel() {
        return this.uniforms.uParallel > 0.5;
    }
    set parallel(value) {
        this.uniforms.uParallel = value ? 1 : 0;
    }
    /**
   * Focal point for non-parallel rays, to use this `parallel` must be set to `false`.
   * @default {x:0,y:0}
   */ get center() {
        return this._center;
    }
    set center(value) {
        if (Array.isArray(value)) value = {
            x: value[0],
            y: value[1]
        };
        this._center = value;
    }
    /**
   * Focal point for non-parallel rays on the `x` axis, to use this `parallel` must be set to `false`.
   * @default 0
   */ get centerX() {
        return this.center.x;
    }
    set centerX(value) {
        this.center.x = value;
    }
    /**
   * Focal point for non-parallel rays on the `y` axis, to use this `parallel` must be set to `false`.
   * @default 0
   */ get centerY() {
        return this.center.y;
    }
    set centerY(value) {
        this.center.y = value;
    }
    /**
   * General intensity of the effect. A value closer to 1 will produce a more intense effect,
   * where a value closer to 0 will produce a subtler effect
   * @default 0.5
   */ get gain() {
        return this.uniforms.uRay[0];
    }
    set gain(value) {
        this.uniforms.uRay[0] = value;
    }
    /**
   * The density of the fractal noise.
   * A higher amount produces more rays and a smaller amount produces fewer waves
   * @default 2.5
   */ get lacunarity() {
        return this.uniforms.uRay[1];
    }
    set lacunarity(value) {
        this.uniforms.uRay[1] = value;
    }
    /**
   * The alpha (opacity) of the rays.  0 is fully transparent, 1 is fully opaque.
   * @default 1
   */ get alpha() {
        return this.uniforms.uRay[2];
    }
    set alpha(value) {
        this.uniforms.uRay[2] = value;
    }
};
/** Default values for options. */ $5c2adae217f01dae$var$__publicField($5c2adae217f01dae$var$_GodrayFilter, "DEFAULT_OPTIONS", {
    angle: 30,
    gain: 0.5,
    lacunarity: 2.5,
    parallel: true,
    time: 0,
    center: {
        x: 0,
        y: 0
    },
    alpha: 1
});
let $5c2adae217f01dae$export$9f73ef882e89e91 = $5c2adae217f01dae$var$_GodrayFilter;



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $9be0feb33c164a9c$export$2e2bcd8739ae039 = "in vec2 vTextureCoord;\n\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\n\n// https://en.wikipedia.org/wiki/Luma_(video)\nconst vec3 weight = vec3(0.299, 0.587, 0.114);\n\nvoid main()\n{\n    vec4 c = texture(uTexture, vTextureCoord);\n    finalColor = vec4(\n        vec3(c.r * weight.r + c.g * weight.g  + c.b * weight.b),\n        c.a\n    );\n}\n";


var $34ce5ddcf3a7ba27$export$2e2bcd8739ae039 = "@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>,\n  @builtin(position) position: vec4<f32>\n) -> @location(0) vec4<f32> {\n  let color: vec4<f32> = textureSample(uTexture, uSampler, uv);\n\n  let g: f32 = dot(color.rgb, vec3<f32>(0.299, 0.587, 0.114));\n  return vec4<f32>(vec3<f32>(g), 1.);\n}";


class $9686b11f0dd5d4e4$export$cae29994b9b0c1a8 extends (0, $ld81y.Filter) {
    constructor(){
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $34ce5ddcf3a7ba27$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $9be0feb33c164a9c$export$2e2bcd8739ae039,
            name: "grayscale-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {}
        });
    }
}



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $ce30bd31d971ff45$export$2e2bcd8739ae039 = "in vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec3 uHsl;\nuniform float uAlpha;\nuniform float uColorize;\n\n// https://en.wikipedia.org/wiki/Luma_(video)\nconst vec3 weight = vec3(0.299, 0.587, 0.114);\n\nfloat getWeightedAverage(vec3 rgb) {\n    return rgb.r * weight.r + rgb.g * weight.g + rgb.b * weight.b;\n}\n\n// https://gist.github.com/mairod/a75e7b44f68110e1576d77419d608786?permalink_comment_id=3195243#gistcomment-3195243\nconst vec3 k = vec3(0.57735, 0.57735, 0.57735);\n\nvec3 hueShift(vec3 color, float angle) {\n    float cosAngle = cos(angle);\n    return vec3(\n    color * cosAngle +\n    cross(k, color) * sin(angle) +\n    k * dot(k, color) * (1.0 - cosAngle)\n    );\n}\n\nvoid main()\n{\n    vec4 color = texture(uTexture, vTextureCoord);\n    vec3 resultRGB = color.rgb;\n\n    float hue = uHsl[0];\n    float saturation = uHsl[1];\n    float lightness = uHsl[2];\n\n    // colorize\n    if (uColorize > 0.5) {\n        resultRGB = vec3(getWeightedAverage(resultRGB), 0., 0.);\n    }\n\n    // hue\n    resultRGB = hueShift(resultRGB, hue);\n\n    // saturation\n    // https://github.com/evanw/glfx.js/blob/master/src/filters/adjust/huesaturation.js\n    float average = (resultRGB.r + resultRGB.g + resultRGB.b) / 3.0;\n\n    if (saturation > 0.) {\n        resultRGB += (average - resultRGB) * (1. - 1. / (1.001 - saturation));\n    } else {\n        resultRGB -= (average - resultRGB) * saturation;\n    }\n\n    // lightness\n    resultRGB = mix(resultRGB, vec3(ceil(lightness)) * color.a, abs(lightness));\n\n    // alpha\n    finalColor = mix(color, vec4(resultRGB, color.a), uAlpha);\n}\n";


var $00fe47cf0ce426e5$export$2e2bcd8739ae039 = "struct HslUniforms {\n  uHsl:vec3<f32>,\n  uColorize:f32,\n  uAlpha:f32,\n};\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> hslUniforms : HslUniforms;\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>,\n  @builtin(position) position: vec4<f32>\n) -> @location(0) vec4<f32> {\n    let color: vec4<f32> = textureSample(uTexture, uSampler, uv);\n    var resultRGB: vec3<f32> = color.rgb;\n\n    let hue: f32 = hslUniforms.uHsl[0];\n    let saturation: f32 = hslUniforms.uHsl[1];\n    let lightness: f32 = hslUniforms.uHsl[2];\n\n    // colorize\n    if (hslUniforms.uColorize > 0.5) {\n        resultRGB = vec3<f32>(dot(color.rgb, vec3<f32>(0.299, 0.587, 0.114)), 0., 0.);\n    }\n\n    // hue\n    resultRGB = hueShift(resultRGB, hue);\n\n    // saturation\n    // https://github.com/evanw/glfx.js/blob/master/src/filters/adjust/huesaturation.js\n    let average: f32 = (resultRGB.r + resultRGB.g + resultRGB.b) / 3.0;\n\n    if (saturation > 0.) {\n        resultRGB += (average - resultRGB) * (1. - 1. / (1.001 - saturation));\n    } else {\n        resultRGB -= (average - resultRGB) * saturation;\n    }\n\n    // lightness\n    resultRGB = mix(resultRGB, vec3<f32>(ceil(lightness)) * color.a, abs(lightness));\n\n    // alpha\n    return mix(color, vec4<f32>(resultRGB, color.a), hslUniforms.uAlpha);\n}\n\n// https://gist.github.com/mairod/a75e7b44f68110e1576d77419d608786?permalink_comment_id=3195243#gistcomment-3195243\nconst k: vec3<f32> = vec3(0.57735, 0.57735, 0.57735);\n\nfn hueShift(color: vec3<f32>, angle: f32) -> vec3<f32> \n{\n    let cosAngle: f32 = cos(angle);\n    return vec3<f32>(\n    color * cosAngle +\n    cross(k, color) * sin(angle) +\n    k * dot(k, color) * (1.0 - cosAngle)\n    );\n}";


var $d7d0e6a9abf63790$var$__defProp = Object.defineProperty;
var $d7d0e6a9abf63790$var$__defNormalProp = (obj, key, value)=>key in obj ? $d7d0e6a9abf63790$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d7d0e6a9abf63790$var$__publicField = (obj, key, value)=>{
    $d7d0e6a9abf63790$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $d7d0e6a9abf63790$var$_HslAdjustmentFilter = class _HslAdjustmentFilter extends (0, $ld81y.Filter) {
    /**
   * @param options - Options for the HslAdjustmentFilter constructor.
   */ constructor(options){
        options = {
            ..._HslAdjustmentFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $00fe47cf0ce426e5$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $ce30bd31d971ff45$export$2e2bcd8739ae039,
            name: "hsl-adjustment-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                hslUniforms: {
                    uHsl: {
                        value: new Float32Array(3),
                        type: "vec3<f32>"
                    },
                    uColorize: {
                        value: options.colorize ? 1 : 0,
                        type: "f32"
                    },
                    uAlpha: {
                        value: options.alpha,
                        type: "f32"
                    }
                }
            }
        });
        $d7d0e6a9abf63790$var$__publicField(this, "uniforms");
        $d7d0e6a9abf63790$var$__publicField(this, "_hue");
        this.uniforms = this.resources.hslUniforms.uniforms;
        this.hue = options.hue;
    }
    /**
   * The amount of hue in degrees (-180 to 180)
   * @default 0
   */ get hue() {
        return this._hue;
    }
    set hue(value) {
        this._hue = value;
        this.resources.hslUniforms.uniforms.uHsl[0] = value * (Math.PI / 180);
    }
    /**
   * The amount of lightness (-1 to 1)
   * @default 0
   */ get saturation() {
        return this.resources.hslUniforms.uniforms.uHsl[1];
    }
    set saturation(value) {
        this.resources.hslUniforms.uniforms.uHsl[1] = value;
    }
    /**
   * The amount of lightness (-1 to 1)
   * @default 0
   */ get lightness() {
        return this.resources.hslUniforms.uniforms.uHsl[2];
    }
    set lightness(value) {
        this.resources.hslUniforms.uniforms.uHsl[2] = value;
    }
    /**
   * Whether to colorize the image
   * @default false
   */ get colorize() {
        return this.resources.hslUniforms.uniforms.uColorize === 1;
    }
    set colorize(value) {
        this.resources.hslUniforms.uniforms.uColorize = value ? 1 : 0;
    }
    /**
   * The amount of alpha (0 to 1)
   * @default 1
   */ get alpha() {
        return this.resources.hslUniforms.uniforms.uAlpha;
    }
    set alpha(value) {
        this.resources.hslUniforms.uniforms.uAlpha = value;
    }
};
/** Default values for options. */ $d7d0e6a9abf63790$var$__publicField($d7d0e6a9abf63790$var$_HslAdjustmentFilter, "DEFAULT_OPTIONS", {
    hue: 0,
    saturation: 0,
    lightness: 0,
    colorize: false,
    alpha: 1
});
let $d7d0e6a9abf63790$export$7ec1de72e805fe3e = $d7d0e6a9abf63790$var$_HslAdjustmentFilter;




var $lej7S = parcelRequire("lej7S");
var $j0fPb = parcelRequire("j0fPb");
var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $8f89de672101ae57$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec2 uVelocity;\nuniform int uKernelSize;\nuniform float uOffset;\n\nuniform vec4 uInputSize;\n\nconst int MAX_KERNEL_SIZE = 2048;\n\n// Notice:\n// the perfect way:\n//    int kernelSize = min(uKernelSize, MAX_KERNELSIZE);\n// BUT in real use-case , uKernelSize < MAX_KERNELSIZE almost always.\n// So use uKernelSize directly.\n\nvoid main(void)\n{\n    vec4 color = texture(uTexture, vTextureCoord);\n\n    if (uKernelSize == 0)\n    {\n        finalColor = color;\n        return;\n    }\n\n    vec2 velocity = uVelocity / uInputSize.xy;\n    float offset = -uOffset / length(uVelocity) - 0.5;\n    int k = uKernelSize - 1;\n\n    for(int i = 0; i < MAX_KERNEL_SIZE - 1; i++) {\n        if (i == k) {\n            break;\n        }\n        vec2 bias = velocity * (float(i) / float(k) + offset);\n        color += texture(uTexture, vTextureCoord + bias);\n    }\n    finalColor = color / float(uKernelSize);\n}\n";


var $c7949766d5f3a380$export$2e2bcd8739ae039 = "struct MotionBlurUniforms {\n  uVelocity: vec2<f32>,\n  uKernelSize: f32,\n  uOffset: f32,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> motionBlurUniforms : MotionBlurUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let uVelocity = motionBlurUniforms.uVelocity;\n  let uKernelSize = motionBlurUniforms.uKernelSize;\n  let uOffset = motionBlurUniforms.uOffset;\n\n  let velocity: vec2<f32> = uVelocity / gfu.uInputSize.xy;\n  let offset: f32 = -uOffset / length(uVelocity) - 0.5;\n  let k: i32 = i32(min(uKernelSize - 1, MAX_KERNEL_SIZE - 1));\n\n  var color: vec4<f32> = textureSample(uTexture, uSampler, uv);\n\n  for(var i: i32 = 0; i < k; i += 1) {\n    let bias: vec2<f32> = velocity * (f32(i) / f32(k) + offset);\n    color += textureSample(uTexture, uSampler, uv + bias);\n  }\n  \n  return select(color / f32(uKernelSize), textureSample(uTexture, uSampler, uv), uKernelSize == 0);\n}\n\nconst MAX_KERNEL_SIZE: f32 = 2048;";


var $21f39f20a5161df5$var$__defProp = Object.defineProperty;
var $21f39f20a5161df5$var$__defNormalProp = (obj, key, value)=>key in obj ? $21f39f20a5161df5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $21f39f20a5161df5$var$__publicField = (obj, key, value)=>{
    $21f39f20a5161df5$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $21f39f20a5161df5$var$_MotionBlurFilter = class _MotionBlurFilter extends (0, $ld81y.Filter) {
    /** @ignore */ constructor(...args){
        let options = args[0] ?? {};
        if (Array.isArray(options) || "x" in options && "y" in options || options instanceof (0, $lej7S.ObservablePoint)) {
            (0, $j0fPb.deprecation)("6.0.0", "MotionBlurFilter constructor params are now options object. See params: { velocity, kernelSize, offset }");
            const x = "x" in options ? options.x : options[0];
            const y = "y" in options ? options.y : options[1];
            options = {
                velocity: {
                    x: x,
                    y: y
                }
            };
            if (args[1] !== void 0) options.kernelSize = args[1];
            if (args[2] !== void 0) options.offset = args[2];
        }
        options = {
            ..._MotionBlurFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $c7949766d5f3a380$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $8f89de672101ae57$export$2e2bcd8739ae039,
            name: "motion-blur-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                motionBlurUniforms: {
                    uVelocity: {
                        value: options.velocity,
                        type: "vec2<f32>"
                    },
                    uKernelSize: {
                        value: Math.trunc(options.kernelSize ?? 5),
                        type: "f32"
                    },
                    uOffset: {
                        value: options.offset,
                        type: "f32"
                    }
                }
            }
        });
        $21f39f20a5161df5$var$__publicField(this, "uniforms");
        $21f39f20a5161df5$var$__publicField(this, "_kernelSize");
        this.uniforms = this.resources.motionBlurUniforms.uniforms;
        Object.assign(this, options);
    }
    /**
   * Sets the velocity of the motion for blur effect
   * This should be a size 2 array or an object containing `x` and `y` values, you cannot change types
   * once defined in the constructor
   * @default {x:0,y:0}
   */ get velocity() {
        return this.uniforms.uVelocity;
    }
    set velocity(value) {
        if (Array.isArray(value)) value = {
            x: value[0],
            y: value[1]
        };
        this.uniforms.uVelocity = value;
        this._updateDirty();
    }
    /**
   * Sets the velocity of the motion for blur effect on the `x` axis
   * @default 0
   */ get velocityX() {
        return this.velocity.x;
    }
    set velocityX(value) {
        this.velocity.x = value;
        this._updateDirty();
    }
    /**
   * Sets the velocity of the motion for blur effect on the `x` axis
   * @default 0
   */ get velocityY() {
        return this.velocity.y;
    }
    set velocityY(value) {
        this.velocity.y = value;
        this._updateDirty();
    }
    /**
   * The kernelSize of the blur filter. Must be odd number >= 5
   * @default 5
   */ get kernelSize() {
        return this._kernelSize;
    }
    set kernelSize(value) {
        this._kernelSize = value;
        this._updateDirty();
    }
    /**
   * The offset of the blur filter
   * @default 0
   */ get offset() {
        return this.uniforms.uOffset;
    }
    set offset(value) {
        this.uniforms.uOffset = value;
    }
    _updateDirty() {
        this.padding = (Math.max(Math.abs(this.velocityX), Math.abs(this.velocityY)) >> 0) + 1;
        this.uniforms.uKernelSize = this.velocityX !== 0 || this.velocityY !== 0 ? this._kernelSize : 0;
    }
};
/** Default values for options. */ $21f39f20a5161df5$var$__publicField($21f39f20a5161df5$var$_MotionBlurFilter, "DEFAULT_OPTIONS", {
    velocity: {
        x: 0,
        y: 0
    },
    kernelSize: 5,
    offset: 0
});
let $21f39f20a5161df5$export$d65c226804e2a98c = $21f39f20a5161df5$var$_MotionBlurFilter;



var $j0fPb = parcelRequire("j0fPb");
var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $bEj7k = parcelRequire("bEj7k");
var $ld81y = parcelRequire("ld81y");


var $9b5efda2a1b7f821$export$2e2bcd8739ae039 = "in vec2 vTextureCoord;\nout vec4 finalColor;\n\nconst int MAX_COLORS = ${MAX_COLORS};\n\nuniform sampler2D uTexture;\nuniform vec3 uOriginalColors[MAX_COLORS];\nuniform vec3 uTargetColors[MAX_COLORS];\nuniform float uTolerance;\n\nvoid main(void)\n{\n    finalColor = texture(uTexture, vTextureCoord);\n\n    float alpha = finalColor.a;\n    if (alpha < 0.0001)\n    {\n      return;\n    }\n\n    vec3 color = finalColor.rgb / alpha;\n\n    for(int i = 0; i < MAX_COLORS; i++)\n    {\n      vec3 origColor = uOriginalColors[i];\n      if (origColor.r < 0.0)\n      {\n        break;\n      }\n      vec3 colorDiff = origColor - color;\n      if (length(colorDiff) < uTolerance)\n      {\n        vec3 targetColor = uTargetColors[i];\n        finalColor = vec4((targetColor + colorDiff) * alpha, alpha);\n        return;\n      }\n    }\n}\n";


var $19ea5d52d138d6a4$export$2e2bcd8739ae039 = "struct MultiColorReplaceUniforms {\n  uOriginalColors: array<vec3<f32>, MAX_COLORS>,\n  uTargetColors: array<vec3<f32>, MAX_COLORS>,\n  uTolerance:f32,\n};\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> multiColorReplaceUniforms : MultiColorReplaceUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let uOriginalColors = multiColorReplaceUniforms.uOriginalColors;\n  let uTargetColors = multiColorReplaceUniforms.uTargetColors;\n  let uTolerance = multiColorReplaceUniforms.uTolerance;\n\n  var color: vec4<f32> = textureSample(uTexture, uSampler, uv);\n\n  let alpha: f32 = color.a;\n\n  if (alpha > 0.0001)\n  {\n    var modColor: vec3<f32> = vec3<f32>(color.rgb) / alpha;\n\n    for(var i: i32 = 0; i < MAX_COLORS; i += 1)\n    {\n      let origColor: vec3<f32> = uOriginalColors[i];\n      if (origColor.r < 0.0)\n      {\n        break;\n      }\n      let colorDiff: vec3<f32> = origColor - modColor;\n      \n      if (length(colorDiff) < uTolerance)\n      {\n        let targetColor: vec3<f32> = uTargetColors[i];\n        color = vec4((targetColor + colorDiff) * alpha, alpha);\n        return color;\n      }\n    }\n  }\n\n  return color;\n}\n\nconst MAX_COLORS: i32 = ${MAX_COLORS};";


var $4aafbf01c351bce0$var$__defProp = Object.defineProperty;
var $4aafbf01c351bce0$var$__defNormalProp = (obj, key, value)=>key in obj ? $4aafbf01c351bce0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4aafbf01c351bce0$var$__publicField = (obj, key, value)=>{
    $4aafbf01c351bce0$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $4aafbf01c351bce0$var$_MultiColorReplaceFilter = class _MultiColorReplaceFilter extends (0, $ld81y.Filter) {
    /** @ignore */ constructor(...args){
        let options = args[0] ?? {};
        if (Array.isArray(options)) {
            (0, $j0fPb.deprecation)("6.0.0", "MultiColorReplaceFilter constructor params are now options object. See params: { replacements, tolerance, maxColors }");
            options = {
                replacements: options
            };
            if (args[1]) options.tolerance = args[1];
            if (args[2]) options.maxColors = args[2];
        }
        options = {
            ..._MultiColorReplaceFilter.DEFAULT_OPTIONS,
            ...options
        };
        const maxColors = options.maxColors ?? options.replacements.length;
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: (0, $19ea5d52d138d6a4$export$2e2bcd8739ae039).replace(/\$\{MAX_COLORS\}/g, maxColors.toFixed(0)),
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: (0, $9b5efda2a1b7f821$export$2e2bcd8739ae039).replace(/\$\{MAX_COLORS\}/g, maxColors.toFixed(0)),
            name: "multi-color-replace-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                multiColorReplaceUniforms: {
                    uOriginalColors: {
                        value: new Float32Array(3 * maxColors),
                        type: "vec3<f32>",
                        size: maxColors
                    },
                    uTargetColors: {
                        value: new Float32Array(3 * maxColors),
                        type: "vec3<f32>",
                        size: maxColors
                    },
                    uTolerance: {
                        value: options.tolerance,
                        type: "f32"
                    }
                }
            }
        });
        $4aafbf01c351bce0$var$__publicField(this, "uniforms");
        $4aafbf01c351bce0$var$__publicField(this, "_replacements", []);
        $4aafbf01c351bce0$var$__publicField(this, "_maxColors");
        this._maxColors = maxColors;
        this.uniforms = this.resources.multiColorReplaceUniforms.uniforms;
        this.replacements = options.replacements;
    }
    /**
   * The collection of replacement items. Each item is color-pair
   * (an array length is 2). In the pair, the first value is original color , the second value is target color
   */ set replacements(replacements) {
        const originals = this.uniforms.uOriginalColors;
        const targets = this.uniforms.uTargetColors;
        const colorCount = replacements.length;
        const color = new (0, $bEj7k.Color)();
        if (colorCount > this._maxColors) throw new Error(`Length of replacements (${colorCount}) exceeds the maximum colors length (${this._maxColors})`);
        originals[colorCount * 3] = -1;
        let r;
        let g;
        let b;
        for(let i = 0; i < colorCount; i++){
            const pair = replacements[i];
            color.setValue(pair[0]);
            [r, g, b] = color.toArray();
            originals[i * 3] = r;
            originals[i * 3 + 1] = g;
            originals[i * 3 + 2] = b;
            color.setValue(pair[1]);
            [r, g, b] = color.toArray();
            targets[i * 3] = r;
            targets[i * 3 + 1] = g;
            targets[i * 3 + 2] = b;
        }
        this._replacements = replacements;
    }
    get replacements() {
        return this._replacements;
    }
    /**
    * Should be called after changing any of the contents of the replacements.
    * This is a convenience method for resetting the `replacements`.
    * @todo implement nested proxy to remove the need for this function
    */ refresh() {
        this.replacements = this._replacements;
    }
    /**
    * The maximum number of color replacements supported by this filter. Can be changed
    * _only_ during construction.
    * @readonly
    */ get maxColors() {
        return this._maxColors;
    }
    /**
    * Tolerance of the floating-point comparison between colors (lower = more exact, higher = more inclusive)
    * @default 0.05
    */ get tolerance() {
        return this.uniforms.uTolerance;
    }
    set tolerance(value) {
        this.uniforms.uTolerance = value;
    }
    /**
   * @deprecated since 6.0.0
   *
   * Tolerance of the floating-point comparison between colors (lower = more exact, higher = more inclusive)
   * @default 0.05
   */ set epsilon(value) {
        (0, $j0fPb.deprecation)("6.0.0", "MultiColorReplaceFilter.epsilon is deprecated, please use MultiColorReplaceFilter.tolerance instead");
        this.tolerance = value;
    }
    get epsilon() {
        (0, $j0fPb.deprecation)("6.0.0", "MultiColorReplaceFilter.epsilon is deprecated, please use MultiColorReplaceFilter.tolerance instead");
        return this.tolerance;
    }
};
/** Default values for options. */ $4aafbf01c351bce0$var$__publicField($4aafbf01c351bce0$var$_MultiColorReplaceFilter, "DEFAULT_OPTIONS", {
    replacements: [
        [
            16711680,
            255
        ]
    ],
    tolerance: 0.05,
    maxColors: void 0
});
let $4aafbf01c351bce0$export$ad0913c096ecbd2f = $4aafbf01c351bce0$var$_MultiColorReplaceFilter;



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $e5334d4fe19b89ef$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform float uSepia;\nuniform vec2 uNoise;\nuniform vec3 uScratch;\nuniform vec3 uVignetting;\nuniform float uSeed;\nuniform vec2 uDimensions;\n\nuniform vec4 uInputSize;\n\nconst float SQRT_2 = 1.414213;\nconst vec3 SEPIA_RGB = vec3(112.0 / 255.0, 66.0 / 255.0, 20.0 / 255.0);\n\nfloat rand(vec2 co) {\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvec3 Overlay(vec3 src, vec3 dst)\n{\n    // if (dst <= 0.5) then: 2 * src * dst\n    // if (dst > 0.5) then: 1 - 2 * (1 - dst) * (1 - src)\n    return vec3((dst.x <= 0.5) ? (2.0 * src.x * dst.x) : (1.0 - 2.0 * (1.0 - dst.x) * (1.0 - src.x)),\n                (dst.y <= 0.5) ? (2.0 * src.y * dst.y) : (1.0 - 2.0 * (1.0 - dst.y) * (1.0 - src.y)),\n                (dst.z <= 0.5) ? (2.0 * src.z * dst.z) : (1.0 - 2.0 * (1.0 - dst.z) * (1.0 - src.z)));\n}\n\n\nvoid main()\n{\n    finalColor = texture(uTexture, vTextureCoord);\n    vec3 color = finalColor.rgb;\n\n    if (uSepia > 0.0)\n    {\n        float gray = (color.x + color.y + color.z) / 3.0;\n        vec3 grayscale = vec3(gray);\n\n        color = Overlay(SEPIA_RGB, grayscale);\n\n        color = grayscale + uSepia * (color - grayscale);\n    }\n\n    vec2 coord = vTextureCoord * uInputSize.xy / uDimensions.xy;\n\n    float vignette = uVignetting[0];\n    float vignetteAlpha = uVignetting[1];\n    float vignetteBlur = uVignetting[2];\n\n    if (vignette > 0.0)\n    {\n        float outter = SQRT_2 - vignette * SQRT_2;\n        vec2 dir = vec2(vec2(0.5, 0.5) - coord);\n        dir.y *= uDimensions.y / uDimensions.x;\n        float darker = clamp((outter - length(dir) * SQRT_2) / ( 0.00001 + vignetteBlur * SQRT_2), 0.0, 1.0);\n        color.rgb *= darker + (1.0 - darker) * (1.0 - vignetteAlpha);\n    }\n\n    float scratch = uScratch[0];\n    float scratchDensity = uScratch[1];\n    float scratchWidth = uScratch[2];\n\n    if (scratchDensity > uSeed && scratch != 0.0)\n    {\n        float phase = uSeed * 256.0;\n        float s = mod(floor(phase), 2.0);\n        float dist = 1.0 / scratchDensity;\n        float d = distance(coord, vec2(uSeed * dist, abs(s - uSeed * dist)));\n        if (d < uSeed * 0.6 + 0.4)\n        {\n            highp float period = scratchDensity * 10.0;\n\n            float xx = coord.x * period + phase;\n            float aa = abs(mod(xx, 0.5) * 4.0);\n            float bb = mod(floor(xx / 0.5), 2.0);\n            float yy = (1.0 - bb) * aa + bb * (2.0 - aa);\n\n            float kk = 2.0 * period;\n            float dw = scratchWidth / uDimensions.x * (0.75 + uSeed);\n            float dh = dw * kk;\n\n            float tine = (yy - (2.0 - dh));\n\n            if (tine > 0.0) {\n                float _sign = sign(scratch);\n\n                tine = s * tine / period + scratch + 0.1;\n                tine = clamp(tine + 1.0, 0.5 + _sign * 0.5, 1.5 + _sign * 0.5);\n\n                color.rgb *= tine;\n            }\n        }\n    }\n\n    float noise = uNoise[0];\n    float noiseSize = uNoise[1];\n\n    if (noise > 0.0 && noiseSize > 0.0)\n    {\n        vec2 pixelCoord = vTextureCoord.xy * uInputSize.xy;\n        pixelCoord.x = floor(pixelCoord.x / noiseSize);\n        pixelCoord.y = floor(pixelCoord.y / noiseSize);\n        // vec2 d = pixelCoord * noiseSize * vec2(1024.0 + uSeed * 512.0, 1024.0 - uSeed * 512.0);\n        // float _noise = snoise(d) * 0.5;\n        float _noise = rand(pixelCoord * noiseSize * uSeed) - 0.5;\n        color += _noise * noise;\n    }\n\n    finalColor.rgb = color;\n}";


var $ddfb66e0f7417c3c$export$2e2bcd8739ae039 = "struct OldFilmUniforms {\n    uSepia: f32,\n    uNoise: vec2<f32>,\n    uScratch: vec3<f32>,\n    uVignetting: vec3<f32>,\n    uSeed: f32,\n    uDimensions: vec2<f32>,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> oldFilmUniforms : OldFilmUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  var color: vec4<f32> = textureSample(uTexture, uSampler, uv);\n\n  if (oldFilmUniforms.uSepia > 0.)\n  {\n    color = vec4<f32>(sepia(color.rgb), color.a);\n  }\n\n  let coord: vec2<f32> = uv * gfu.uInputSize.xy / oldFilmUniforms.uDimensions;\n\n  if (oldFilmUniforms.uVignetting[0] > 0.)\n  {\n    color *= vec4<f32>(vec3<f32>(vignette(color.rgb, coord)), color.a);\n  }\n\n  let uScratch = oldFilmUniforms.uScratch; \n\n  if (uScratch[1] > oldFilmUniforms.uSeed && uScratch[0] != 0.)\n  {\n    color = vec4<f32>(scratch(color.rgb, coord), color.a);\n  }\n\n  let uNoise = oldFilmUniforms.uNoise;\n\n  if (uNoise[0] > 0.0 && uNoise[1] > 0.0)\n  {\n    color += vec4<f32>(vec3<f32>(noise(uv)), color.a);\n  }\n\n  return color;\n}\n\nconst SQRT_2: f32 = 1.414213;\nconst SEPIA_RGB: vec3<f32> = vec3<f32>(112.0 / 255.0, 66.0 / 255.0, 20.0 / 255.0);\n\nfn modulo(x: f32, y: f32) -> f32\n{\n  return x - y * floor(x/y);\n}\n\nfn rand(co: vec2<f32>) -> f32\n{\n  return fract(sin(dot(co, vec2<f32>(12.9898, 78.233))) * 43758.5453);\n}\n\nfn overlay(src: vec3<f32>, dst: vec3<f32>) -> vec3<f32>\n{\n    // if (dst <= 0.5) then: 2 * src * dst\n    // if (dst > 0.5) then: 1 - 2 * (1 - dst) * (1 - src)\n\n    return vec3<f32>(\n      select((1.0 - 2.0 * (1.0 - dst.x) * (1.0 - src.x)), (2.0 * src.x * dst.x), (dst.x <= 0.5)), \n      select((1.0 - 2.0 * (1.0 - dst.y) * (1.0 - src.y)), (2.0 * src.y * dst.y), (dst.y <= 0.5)),\n      select((1.0 - 2.0 * (1.0 - dst.z) * (1.0 - src.z)), (2.0 * src.z * dst.z), (dst.z <= 0.5))\n    );\n}\n\nfn sepia(co: vec3<f32>) -> vec3<f32>\n{\n  let gray: f32 = (co.x + co.y + co.z) / 3.0;\n  let grayscale: vec3<f32> = vec3<f32>(gray);\n  let color = overlay(SEPIA_RGB, grayscale);\n  return grayscale + oldFilmUniforms.uSepia * (color - grayscale);\n}\n\nfn vignette(co: vec3<f32>, coord: vec2<f32>) -> f32\n{\n  let uVignetting = oldFilmUniforms.uVignetting;\n  let uDimensions = oldFilmUniforms.uDimensions;\n  \n  let outter: f32 = SQRT_2 - uVignetting[0] * SQRT_2;\n  var dir: vec2<f32> = vec2<f32>(vec2<f32>(0.5) - coord);\n  dir.y *= uDimensions.y / uDimensions.x;\n  let darker: f32 = clamp((outter - length(dir) * SQRT_2) / ( 0.00001 + uVignetting[2] * SQRT_2), 0.0, 1.0);\n  return darker + (1.0 - darker) * (1.0 - uVignetting[1]);\n}\n\nfn scratch(co: vec3<f32>, coord: vec2<f32>) -> vec3<f32>\n{\n  var color = co;\n  let uScratch = oldFilmUniforms.uScratch;\n  let uSeed = oldFilmUniforms.uSeed;\n  let uDimensions = oldFilmUniforms.uDimensions;\n\n  let phase: f32 = uSeed * 256.0;\n  let s: f32 = modulo(floor(phase), 2.0);\n  let dist: f32 = 1.0 / uScratch[1];\n  let d: f32 = distance(coord, vec2<f32>(uSeed * dist, abs(s - uSeed * dist)));\n\n  if (d < uSeed * 0.6 + 0.4)\n  {\n    let period: f32 = uScratch[1] * 10.0;\n\n    let xx: f32 = coord.x * period + phase;\n    let aa: f32 = abs(modulo(xx, 0.5) * 4.0);\n    let bb: f32 = modulo(floor(xx / 0.5), 2.0);\n    let yy: f32 = (1.0 - bb) * aa + bb * (2.0 - aa);\n\n    let kk: f32 = 2.0 * period;\n    let dw: f32 = uScratch[2] / uDimensions.x * (0.75 + uSeed);\n    let dh: f32 = dw * kk;\n\n    var tine: f32 = (yy - (2.0 - dh));\n\n    if (tine > 0.0) {\n        let _sign: f32 = sign(uScratch[0]);\n\n        tine = s * tine / period + uScratch[0] + 0.1;\n        tine = clamp(tine + 1.0, 0.5 + _sign * 0.5, 1.5 + _sign * 0.5);\n\n        color *= tine;\n    }\n  }\n\n  return color;\n}\n\nfn noise(coord: vec2<f32>) -> f32\n{\n  let uNoise = oldFilmUniforms.uNoise;\n  let uSeed = oldFilmUniforms.uSeed;\n\n  var pixelCoord: vec2<f32> = coord * gfu.uInputSize.xy;\n  pixelCoord.x = floor(pixelCoord.x / uNoise[1]);\n  pixelCoord.y = floor(pixelCoord.y / uNoise[1]);\n  return (rand(pixelCoord * uNoise[1] * uSeed) - 0.5) * uNoise[0];\n}";


var $8ce2822185422c4b$var$__defProp = Object.defineProperty;
var $8ce2822185422c4b$var$__defNormalProp = (obj, key, value)=>key in obj ? $8ce2822185422c4b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8ce2822185422c4b$var$__publicField = (obj, key, value)=>{
    $8ce2822185422c4b$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $8ce2822185422c4b$var$_OldFilmFilter = class _OldFilmFilter extends (0, $ld81y.Filter) {
    /**
   * @param options - Options for the OldFilmFilter constructor.
   */ constructor(options){
        options = {
            ..._OldFilmFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $ddfb66e0f7417c3c$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $e5334d4fe19b89ef$export$2e2bcd8739ae039,
            name: "old-film-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                oldFilmUniforms: {
                    uSepia: {
                        value: options.sepia,
                        type: "f32"
                    },
                    uNoise: {
                        value: new Float32Array(2),
                        type: "vec2<f32>"
                    },
                    uScratch: {
                        value: new Float32Array(3),
                        type: "vec3<f32>"
                    },
                    uVignetting: {
                        value: new Float32Array(3),
                        type: "vec3<f32>"
                    },
                    uSeed: {
                        value: options.seed,
                        type: "f32"
                    },
                    uDimensions: {
                        value: new Float32Array(2),
                        type: "vec2<f32>"
                    }
                }
            }
        });
        $8ce2822185422c4b$var$__publicField(this, "uniforms");
        /**
     * A seed value to apply to the random noise generation
     * @default 0
     */ $8ce2822185422c4b$var$__publicField(this, "seed");
        this.uniforms = this.resources.oldFilmUniforms.uniforms;
        Object.assign(this, options);
    }
    /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */ apply(filterManager, input, output, clearMode) {
        this.uniforms.uDimensions[0] = input.frame.width;
        this.uniforms.uDimensions[1] = input.frame.height;
        this.uniforms.uSeed = this.seed;
        filterManager.applyFilter(this, input, output, clearMode);
    }
    /**
   * The amount of saturation of sepia effect,
   * a value of `1` is more saturation and closer to `0` is less, and a value of `0` produces no sepia effect
   * @default 0.3
   */ get sepia() {
        return this.uniforms.uSepia;
    }
    set sepia(value) {
        this.uniforms.uSepia = value;
    }
    /**
   * Opacity/intensity of the noise effect between `0` and `1`
   * @default 0.3
   */ get noise() {
        return this.uniforms.uNoise[0];
    }
    set noise(value) {
        this.uniforms.uNoise[0] = value;
    }
    /**
   * The size of the noise particles
   * @default 1
   */ get noiseSize() {
        return this.uniforms.uNoise[1];
    }
    set noiseSize(value) {
        this.uniforms.uNoise[1] = value;
    }
    /**
   * How often scratches appear
   * @default 0.5
   */ get scratch() {
        return this.uniforms.uScratch[0];
    }
    set scratch(value) {
        this.uniforms.uScratch[0] = value;
    }
    /**
   * The density of the number of scratches
   * @default 0.3
   */ get scratchDensity() {
        return this.uniforms.uScratch[1];
    }
    set scratchDensity(value) {
        this.uniforms.uScratch[1] = value;
    }
    /**
   * The width of the scratches
   * @default 1
   */ get scratchWidth() {
        return this.uniforms.uScratch[2];
    }
    set scratchWidth(value) {
        this.uniforms.uScratch[2] = value;
    }
    /**
   * The radius of the vignette effect, smaller values produces a smaller vignette
   * @default 0.3
   */ get vignetting() {
        return this.uniforms.uVignetting[0];
    }
    set vignetting(value) {
        this.uniforms.uVignetting[0] = value;
    }
    /**
   * Amount of opacity on the vignette
   * @default 1
   */ get vignettingAlpha() {
        return this.uniforms.uVignetting[1];
    }
    set vignettingAlpha(value) {
        this.uniforms.uVignetting[1] = value;
    }
    /**
   * Blur intensity of the vignette
   * @default 1
   */ get vignettingBlur() {
        return this.uniforms.uVignetting[2];
    }
    set vignettingBlur(value) {
        this.uniforms.uVignetting[2] = value;
    }
};
/** Default values for options. */ $8ce2822185422c4b$var$__publicField($8ce2822185422c4b$var$_OldFilmFilter, "DEFAULT_OPTIONS", {
    sepia: 0.3,
    noise: 0.3,
    noiseSize: 1,
    scratch: 0.5,
    scratchDensity: 0.3,
    scratchWidth: 1,
    vignetting: 0.3,
    vignettingAlpha: 1,
    vignettingBlur: 0.3,
    seed: 0
});
let $8ce2822185422c4b$export$4ea6953a37e049ea = $8ce2822185422c4b$var$_OldFilmFilter;



var $j0fPb = parcelRequire("j0fPb");
var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $bEj7k = parcelRequire("bEj7k");
var $ld81y = parcelRequire("ld81y");


var $5947629ed8de4f6b$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec2 uThickness;\nuniform vec3 uColor;\nuniform float uAlpha;\nuniform float uKnockout;\n\nuniform vec4 uInputClamp;\n\nconst float DOUBLE_PI = 2. * 3.14159265358979323846264;\nconst float ANGLE_STEP = ${ANGLE_STEP};\n\nfloat outlineMaxAlphaAtPos(vec2 pos) {\n    if (uThickness.x == 0. || uThickness.y == 0.) {\n        return 0.;\n    }\n\n    vec4 displacedColor;\n    vec2 displacedPos;\n    float maxAlpha = 0.;\n\n    for (float angle = 0.; angle <= DOUBLE_PI; angle += ANGLE_STEP) {\n        displacedPos.x = vTextureCoord.x + uThickness.x * cos(angle);\n        displacedPos.y = vTextureCoord.y + uThickness.y * sin(angle);\n        displacedColor = texture(uTexture, clamp(displacedPos, uInputClamp.xy, uInputClamp.zw));\n        maxAlpha = max(maxAlpha, displacedColor.a);\n    }\n\n    return maxAlpha;\n}\n\nvoid main(void) {\n    vec4 sourceColor = texture(uTexture, vTextureCoord);\n    vec4 contentColor = sourceColor * float(uKnockout < 0.5);\n    float outlineAlpha = uAlpha * outlineMaxAlphaAtPos(vTextureCoord.xy) * (1.-sourceColor.a);\n    vec4 outlineColor = vec4(vec3(uColor) * outlineAlpha, outlineAlpha);\n    finalColor = contentColor + outlineColor;\n}\n";


var $bf1f98c0b1a6f328$export$2e2bcd8739ae039 = "struct OutlineUniforms {\n  uThickness:vec2<f32>,\n  uColor:vec3<f32>,\n  uAlpha:f32,\n  uAngleStep:f32,\n  uKnockout:f32,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> outlineUniforms : OutlineUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let sourceColor: vec4<f32> = textureSample(uTexture, uSampler, uv);\n  let contentColor: vec4<f32> = sourceColor * (1. - outlineUniforms.uKnockout);\n  \n  let outlineAlpha: f32 = outlineUniforms.uAlpha * outlineMaxAlphaAtPos(uv) * (1. - sourceColor.a);\n  let outlineColor: vec4<f32> = vec4<f32>(vec3<f32>(outlineUniforms.uColor) * outlineAlpha, outlineAlpha);\n  \n  return contentColor + outlineColor;\n}\n\nfn outlineMaxAlphaAtPos(uv: vec2<f32>) -> f32 {\n  let thickness = outlineUniforms.uThickness;\n\n  if (thickness.x == 0. || thickness.y == 0.) {\n    return 0.;\n  }\n  \n  let angleStep = outlineUniforms.uAngleStep;\n\n  var displacedColor: vec4<f32>;\n  var displacedPos: vec2<f32>;\n\n  var maxAlpha: f32 = 0.;\n  var displaced: vec2<f32>;\n  var curColor: vec4<f32>;\n\n  for (var angle = 0.; angle <= DOUBLE_PI; angle += angleStep)\n  {\n    displaced.x = uv.x + thickness.x * cos(angle);\n    displaced.y = uv.y + thickness.y * sin(angle);\n    curColor = textureSample(uTexture, uSampler, clamp(displaced, gfu.uInputClamp.xy, gfu.uInputClamp.zw));\n    maxAlpha = max(maxAlpha, curColor.a);\n  }\n\n  return maxAlpha;\n}\n\nconst DOUBLE_PI: f32 = 3.14159265358979323846264 * 2.;";


var $46c687782dcb4f1e$var$__defProp = Object.defineProperty;
var $46c687782dcb4f1e$var$__defNormalProp = (obj, key, value)=>key in obj ? $46c687782dcb4f1e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $46c687782dcb4f1e$var$__publicField = (obj, key, value)=>{
    $46c687782dcb4f1e$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $46c687782dcb4f1e$var$_OutlineFilter = class _OutlineFilter extends (0, $ld81y.Filter) {
    /** @ignore */ constructor(...args){
        let options = args[0] ?? {};
        if (typeof options === "number") {
            (0, $j0fPb.deprecation)("6.0.0", "OutlineFilter constructor params are now options object. See params: { thickness, color, quality, alpha, knockout }");
            options = {
                thickness: options
            };
            if (args[1] !== void 0) options.color = args[1];
            if (args[2] !== void 0) options.quality = args[2];
            if (args[3] !== void 0) options.alpha = args[3];
            if (args[4] !== void 0) options.knockout = args[4];
        }
        options = {
            ..._OutlineFilter.DEFAULT_OPTIONS,
            ...options
        };
        const quality = options.quality ?? 0.1;
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $bf1f98c0b1a6f328$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: (0, $5947629ed8de4f6b$export$2e2bcd8739ae039).replace(/\$\{ANGLE_STEP\}/, _OutlineFilter.getAngleStep(quality).toFixed(7)),
            name: "outline-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                outlineUniforms: {
                    uThickness: {
                        value: new Float32Array(2),
                        type: "vec2<f32>"
                    },
                    uColor: {
                        value: new Float32Array(3),
                        type: "vec3<f32>"
                    },
                    uAlpha: {
                        value: options.alpha,
                        type: "f32"
                    },
                    uAngleStep: {
                        value: 0,
                        type: "f32"
                    },
                    uKnockout: {
                        value: options.knockout ? 1 : 0,
                        type: "f32"
                    }
                }
            }
        });
        $46c687782dcb4f1e$var$__publicField(this, "uniforms");
        $46c687782dcb4f1e$var$__publicField(this, "_thickness");
        $46c687782dcb4f1e$var$__publicField(this, "_quality");
        $46c687782dcb4f1e$var$__publicField(this, "_color");
        this.uniforms = this.resources.outlineUniforms.uniforms;
        this.uniforms.uAngleStep = _OutlineFilter.getAngleStep(quality);
        this._color = new (0, $bEj7k.Color)();
        this.color = options.color ?? 0;
        Object.assign(this, options);
    }
    /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */ apply(filterManager, input, output, clearMode) {
        this.uniforms.uThickness[0] = this.thickness / input.source.width;
        this.uniforms.uThickness[1] = this.thickness / input.source.height;
        filterManager.applyFilter(this, input, output, clearMode);
    }
    /**
   * Get the angleStep by quality
   * @param quality
   */ static getAngleStep(quality) {
        return parseFloat((Math.PI * 2 / Math.max(quality * _OutlineFilter.MAX_SAMPLES, _OutlineFilter.MIN_SAMPLES)).toFixed(7));
    }
    /**
   * The thickness of the outline
   * @default 1
   */ get thickness() {
        return this._thickness;
    }
    set thickness(value) {
        this._thickness = this.padding = value;
    }
    /**
   * The color value of the ambient color
   * @example [1.0, 1.0, 1.0] = 0xffffff
   * @default 0x000000
   */ get color() {
        return this._color.value;
    }
    set color(value) {
        this._color.setValue(value);
        const [r, g, b] = this._color.toArray();
        this.uniforms.uColor[0] = r;
        this.uniforms.uColor[1] = g;
        this.uniforms.uColor[2] = b;
    }
    /**
   * Coefficient for alpha multiplication
   * @default 1
   */ get alpha() {
        return this.uniforms.uAlpha;
    }
    set alpha(value) {
        this.uniforms.uAlpha = value;
    }
    /**
   * The quality of the outline from `0` to `1`.
   * Using a higher quality setting will result in more accuracy but slower performance
   * @default 0.1
   */ get quality() {
        return this._quality;
    }
    set quality(value) {
        this._quality = value;
        this.uniforms.uAngleStep = _OutlineFilter.getAngleStep(value);
    }
    /**
   * Whether to only render outline, not the contents.
   * @default false
   */ get knockout() {
        return this.uniforms.uKnockout === 1;
    }
    set knockout(value) {
        this.uniforms.uKnockout = value ? 1 : 0;
    }
};
/** Default values for options. */ $46c687782dcb4f1e$var$__publicField($46c687782dcb4f1e$var$_OutlineFilter, "DEFAULT_OPTIONS", {
    thickness: 1,
    color: 0,
    alpha: 1,
    quality: 0.1,
    knockout: false
});
/** The minimum number of samples for rendering outline. */ $46c687782dcb4f1e$var$__publicField($46c687782dcb4f1e$var$_OutlineFilter, "MIN_SAMPLES", 1);
/** The maximum number of samples for rendering outline. */ $46c687782dcb4f1e$var$__publicField($46c687782dcb4f1e$var$_OutlineFilter, "MAX_SAMPLES", 100);
let $46c687782dcb4f1e$export$ea1238a366116160 = $46c687782dcb4f1e$var$_OutlineFilter;



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $bwMhC = parcelRequire("bwMhC");
var $ld81y = parcelRequire("ld81y");


var $82890f46c78de535$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform vec2 uSize;\nuniform sampler2D uTexture;\nuniform vec4 uInputSize;\n\nvec2 mapCoord( vec2 coord )\n{\n    coord *= uInputSize.xy;\n    coord += uInputSize.zw;\n\n    return coord;\n}\n\nvec2 unmapCoord( vec2 coord )\n{\n    coord -= uInputSize.zw;\n    coord /= uInputSize.xy;\n\n    return coord;\n}\n\nvec2 pixelate(vec2 coord, vec2 uSize)\n{\n	return floor( coord / uSize ) * uSize;\n}\n\nvoid main(void)\n{\n    vec2 coord = mapCoord(vTextureCoord);\n    coord = pixelate(coord, uSize);\n    coord = unmapCoord(coord);\n    finalColor = texture(uTexture, coord);\n}\n";


var $ac7d71c4cbfb8c5d$export$2e2bcd8739ae039 = "struct PixelateUniforms {\n  uSize:vec2<f32>,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> pixelateUniforms : PixelateUniforms;\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>,\n  @builtin(position) position: vec4<f32>\n) -> @location(0) vec4<f32> {\n  let pixelSize: vec2<f32> = pixelateUniforms.uSize;\n  let coord: vec2<f32> = mapCoord(uv);\n\n  var pixCoord: vec2<f32> = pixelate(coord, pixelSize);\n  pixCoord = unmapCoord(pixCoord);\n\n  return textureSample(uTexture, uSampler, pixCoord);\n}\n\nfn mapCoord(coord: vec2<f32> ) -> vec2<f32>\n{\n  var mappedCoord: vec2<f32> = coord;\n  mappedCoord *= gfu.uInputSize.xy;\n  mappedCoord += gfu.uOutputFrame.xy;\n  return mappedCoord;\n}\n\nfn unmapCoord(coord: vec2<f32> ) -> vec2<f32>\n{\n  var mappedCoord: vec2<f32> = coord;\n  mappedCoord -= gfu.uOutputFrame.xy;\n  mappedCoord /= gfu.uInputSize.xy;\n  return mappedCoord;\n}\n\nfn pixelate(coord: vec2<f32>, size: vec2<f32>) -> vec2<f32>\n{\n  return floor( coord / size ) * size;\n}\n\n";


class $9938139ced401e1e$export$8ec99043c41c044 extends (0, $ld81y.Filter) {
    /**
   * @param {Point|Array<number>|number} [size=10] - Either the width/height of the size of the pixels, or square size
   */ constructor(size = 10){
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $ac7d71c4cbfb8c5d$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $82890f46c78de535$export$2e2bcd8739ae039,
            name: "pixelate-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                pixelateUniforms: {
                    uSize: {
                        value: new Float32Array(2),
                        type: "vec2<f32>"
                    }
                }
            }
        });
        this.size = size;
    }
    /**
   * The size of the pixels
   * @default [10,10]
   */ get size() {
        return this.resources.pixelateUniforms.uniforms.uSize;
    }
    set size(value) {
        if (value instanceof (0, $bwMhC.Point)) {
            this.sizeX = value.x;
            this.sizeY = value.y;
        } else if (Array.isArray(value)) this.resources.pixelateUniforms.uniforms.uSize = value;
        else this.sizeX = this.sizeY = value;
    }
    /**
  * The size of the pixels on the `x` axis
  * @default 10
  */ get sizeX() {
        return this.resources.pixelateUniforms.uniforms.uSize[0];
    }
    set sizeX(value) {
        this.resources.pixelateUniforms.uniforms.uSize[0] = value;
    }
    /**
  * The size of the pixels on the `y` axis
  * @default 10
  */ get sizeY() {
        return this.resources.pixelateUniforms.uniforms.uSize[1];
    }
    set sizeY(value) {
        this.resources.pixelateUniforms.uniforms.uSize[1] = value;
    }
}



var $j0fPb = parcelRequire("j0fPb");
var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $347481168ceb1c26$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform float uRadian;\nuniform vec2 uCenter;\nuniform float uRadius;\nuniform int uKernelSize;\n\nuniform vec4 uInputSize;\n\nconst int MAX_KERNEL_SIZE = 2048;\n\nvoid main(void)\n{\n    vec4 color = texture(uTexture, vTextureCoord);\n\n    if (uKernelSize == 0)\n    {\n        finalColor = color;\n        return;\n    }\n\n    float aspect = uInputSize.y / uInputSize.x;\n    vec2 center = uCenter.xy / uInputSize.xy;\n    float gradient = uRadius / uInputSize.x * 0.3;\n    float radius = uRadius / uInputSize.x - gradient * 0.5;\n    int k = uKernelSize - 1;\n\n    vec2 coord = vTextureCoord;\n    vec2 dir = vec2(center - coord);\n    float dist = length(vec2(dir.x, dir.y * aspect));\n\n    float radianStep = uRadian;\n    if (radius >= 0.0 && dist > radius) {\n        float delta = dist - radius;\n        float gap = gradient;\n        float scale = 1.0 - abs(delta / gap);\n        if (scale <= 0.0) {\n            finalColor = color;\n            return;\n        }\n        radianStep *= scale;\n    }\n    radianStep /= float(k);\n\n    float s = sin(radianStep);\n    float c = cos(radianStep);\n    mat2 rotationMatrix = mat2(vec2(c, -s), vec2(s, c));\n\n    for(int i = 0; i < MAX_KERNEL_SIZE - 1; i++) {\n        if (i == k) {\n            break;\n        }\n\n        coord -= center;\n        coord.y *= aspect;\n        coord = rotationMatrix * coord;\n        coord.y /= aspect;\n        coord += center;\n\n        vec4 sample = texture(uTexture, coord);\n\n        // switch to pre-multiplied alpha to correctly blur transparent images\n        // sample.rgb *= sample.a;\n\n        color += sample;\n    }\n\n    finalColor = color / float(uKernelSize);\n}\n";


var $56ca868d39d0b2cd$export$2e2bcd8739ae039 = "struct RadialBlurUniforms {\n  uRadian: f32,\n  uCenter: vec2<f32>,\n  uKernelSize: f32,\n  uRadius: f32,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> radialBlurUniforms : RadialBlurUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let uRadian = radialBlurUniforms.uRadian;\n  let uCenter = radialBlurUniforms.uCenter;\n  let uKernelSize = radialBlurUniforms.uKernelSize;\n  let uRadius = radialBlurUniforms.uRadius;\n  \n  var returnColorOnly = false;\n\n  if (uKernelSize == 0)\n  {\n    returnColorOnly = true;\n  }\n\n  let aspect: f32 = gfu.uInputSize.y / gfu.uInputSize.x;\n  let center: vec2<f32> = uCenter.xy / gfu.uInputSize.xy;\n  let gradient: f32 = uRadius / gfu.uInputSize.x * 0.3;\n  let radius: f32 = uRadius / gfu.uInputSize.x - gradient * 0.5;\n  let k: i32 = i32(uKernelSize - 1);\n\n  var coord: vec2<f32> = uv;\n  let dir: vec2<f32> = vec2<f32>(center - coord);\n  let dist: f32 = length(vec2<f32>(dir.x, dir.y * aspect));\n\n  var radianStep: f32 = uRadian;\n  \n  if (radius >= 0.0 && dist > radius)\n  {\n    let delta: f32 = dist - radius;\n    let gap: f32 = gradient;\n    let scale: f32 = 1.0 - abs(delta / gap);\n    if (scale <= 0.0) {\n      returnColorOnly = true;\n    }\n    radianStep *= scale;\n  }\n\n  radianStep /= f32(k);\n\n  let s: f32 = sin(radianStep);\n  let c: f32 = cos(radianStep);\n  let rotationMatrix: mat2x2<f32> = mat2x2<f32>(vec2<f32>(c, -s), vec2<f32>(s, c));\n  \n  var color: vec4<f32> = textureSample(uTexture, uSampler, uv);\n  let baseColor = vec4<f32>(color);\n\n  let minK: i32 = min(i32(uKernelSize) - 1, MAX_KERNEL_SIZE - 1);\n\n  for(var i: i32 = 0; i < minK; i += 1) \n  {\n    coord -= center;\n    coord.y *= aspect;\n    coord = rotationMatrix * coord;\n    coord.y /= aspect;\n    coord += center;\n    let sample: vec4<f32> = textureSample(uTexture, uSampler, coord);\n    // switch to pre-multiplied alpha to correctly blur transparent images\n    // sample.rgb *= sample.a;\n    color += sample;\n  }\n\n  return select(color / f32(uKernelSize), baseColor, returnColorOnly);\n}\n\nconst MAX_KERNEL_SIZE: i32 = 2048;";


var $c56de849f764f1fc$var$__defProp = Object.defineProperty;
var $c56de849f764f1fc$var$__defNormalProp = (obj, key, value)=>key in obj ? $c56de849f764f1fc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c56de849f764f1fc$var$__publicField = (obj, key, value)=>{
    $c56de849f764f1fc$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $c56de849f764f1fc$var$_RadialBlurFilter = class _RadialBlurFilter extends (0, $ld81y.Filter) {
    /** @ignore */ constructor(...args){
        let options = args[0] ?? {};
        if (typeof options === "number") {
            (0, $j0fPb.deprecation)("6.0.0", "RadialBlurFilter constructor params are now options object. See params: { angle, center, kernelSize, radius }");
            options = {
                angle: options
            };
            if (args[1]) {
                const x = "x" in args[1] ? args[1].x : args[1][0];
                const y = "y" in args[1] ? args[1].y : args[1][1];
                options.center = {
                    x: x,
                    y: y
                };
            }
            if (args[2]) options.kernelSize = args[2];
            if (args[3]) options.radius = args[3];
        }
        options = {
            ..._RadialBlurFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $56ca868d39d0b2cd$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $347481168ceb1c26$export$2e2bcd8739ae039,
            name: "radial-blur-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                radialBlurUniforms: {
                    uRadian: {
                        value: 0,
                        type: "f32"
                    },
                    uCenter: {
                        value: options.center,
                        type: "vec2<f32>"
                    },
                    uKernelSize: {
                        value: options.kernelSize,
                        type: "i32"
                    },
                    uRadius: {
                        value: options.radius,
                        type: "f32"
                    }
                }
            }
        });
        $c56de849f764f1fc$var$__publicField(this, "uniforms");
        $c56de849f764f1fc$var$__publicField(this, "_angle");
        $c56de849f764f1fc$var$__publicField(this, "_kernelSize");
        this.uniforms = this.resources.radialBlurUniforms.uniforms;
        Object.assign(this, options);
    }
    _updateKernelSize() {
        this.uniforms.uKernelSize = this._angle !== 0 ? this.kernelSize : 0;
    }
    /**
   * Sets the angle in degrees of the motion for blur effect.
   * @default 0
   */ get angle() {
        return this._angle;
    }
    set angle(value) {
        this._angle = value;
        this.uniforms.uRadian = value * Math.PI / 180;
        this._updateKernelSize();
    }
    /**
   * The `x` and `y` offset coordinates to change the position of the center of the circle of effect.
   * This should be a size 2 array or an object containing `x` and `y` values, you cannot change types
   * once defined in the constructor
   * @default {x:0,y:0}
   */ get center() {
        return this.uniforms.uCenter;
    }
    set center(value) {
        if (Array.isArray(value)) value = {
            x: value[0],
            y: value[1]
        };
        this.uniforms.uCenter = value;
    }
    /**
   * Sets the velocity of the motion for blur effect on the `x` axis
   * @default 0
   */ get centerX() {
        return this.center.x;
    }
    set centerX(value) {
        this.center.x = value;
    }
    /**
   * Sets the velocity of the motion for blur effect on the `x` axis
   * @default 0
   */ get centerY() {
        return this.center.y;
    }
    set centerY(value) {
        this.center.y = value;
    }
    /**
   * The kernelSize of the blur filter. Must be odd number >= 3
   * @default 5
   */ get kernelSize() {
        return this._kernelSize;
    }
    set kernelSize(value) {
        this._kernelSize = value;
        this._updateKernelSize();
    }
    /**
   * The maximum size of the blur radius, less than `0` equates to infinity
   * @default -1
   */ get radius() {
        return this.uniforms.uRadius;
    }
    set radius(value) {
        this.uniforms.uRadius = value < 0 || value === Infinity ? -1 : value;
    }
};
/** Default values for options. */ $c56de849f764f1fc$var$__publicField($c56de849f764f1fc$var$_RadialBlurFilter, "DEFAULT_OPTIONS", {
    angle: 0,
    center: {
        x: 0,
        y: 0
    },
    kernelSize: 5,
    radius: -1
});
let $c56de849f764f1fc$export$365864b37518d56d = $c56de849f764f1fc$var$_RadialBlurFilter;



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $f761e5d67807579c$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform float uMirror;\nuniform float uBoundary;\nuniform vec2 uAmplitude;\nuniform vec2 uWavelength;\nuniform vec2 uAlpha;\nuniform float uTime;\nuniform vec2 uDimensions;\n\nuniform vec4 uInputSize;\nuniform vec4 uInputClamp;\n\nfloat rand(vec2 co) {\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvoid main(void)\n{\n    vec2 pixelCoord = vTextureCoord.xy * uInputSize.xy;\n    vec2 coord = pixelCoord / uDimensions;\n\n    if (coord.y < uBoundary) {\n        finalColor = texture(uTexture, vTextureCoord);\n        return;\n    }\n\n    float k = (coord.y - uBoundary) / (1. - uBoundary + 0.0001);\n    float areaY = uBoundary * uDimensions.y / uInputSize.y;\n    float v = areaY + areaY - vTextureCoord.y;\n    float y = uMirror > 0.5 ? v : vTextureCoord.y;\n\n    float _amplitude = ((uAmplitude.y - uAmplitude.x) * k + uAmplitude.x ) / uInputSize.x;\n    float _waveLength = ((uWavelength.y - uWavelength.x) * k + uWavelength.x) / uInputSize.y;\n    float _alpha = (uAlpha.y - uAlpha.x) * k + uAlpha.x;\n\n    float x = vTextureCoord.x + cos(v * 6.28 / _waveLength - uTime) * _amplitude;\n    x = clamp(x, uInputClamp.x, uInputClamp.z);\n\n    vec4 color = texture(uTexture, vec2(x, y));\n\n    finalColor = color * _alpha;\n}\n";


var $35cde960d6692dd1$export$2e2bcd8739ae039 = "struct ReflectionUniforms {\n  uMirror: f32,\n  uBoundary: f32,\n  uAmplitude: vec2<f32>,\n  uWavelength: vec2<f32>,\n  uAlpha: vec2<f32>,\n  uTime: f32,\n  uDimensions: vec2<f32>,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> reflectionUniforms : ReflectionUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let uDimensions: vec2<f32> = reflectionUniforms.uDimensions;\n  let uBoundary: f32 = reflectionUniforms.uBoundary;\n  let uMirror: bool = reflectionUniforms.uMirror > 0.5;\n  let uAmplitude: vec2<f32> = reflectionUniforms.uAmplitude;\n  let uWavelength: vec2<f32> = reflectionUniforms.uWavelength;\n  let uAlpha: vec2<f32> = reflectionUniforms.uAlpha;\n  let uTime: f32 = reflectionUniforms.uTime;\n\n  let pixelCoord: vec2<f32> = uv * gfu.uInputSize.xy;\n  let coord: vec2<f32> = pixelCoord /uDimensions;\n  var returnColorOnly: bool = false;\n\n  if (coord.y < uBoundary) {\n    returnColorOnly = true;\n  }\n\n  let k: f32 = (coord.y - uBoundary) / (1. - uBoundary + 0.0001);\n  let areaY: f32 = uBoundary * uDimensions.y / gfu.uInputSize.y;\n  let v: f32 = areaY + areaY - uv.y;\n  let y: f32 = select(uv.y, v, uMirror);\n\n  let amplitude: f32 = ((uAmplitude.y - uAmplitude.x) * k + uAmplitude.x ) / gfu.uInputSize.x;\n  let waveLength: f32 = ((uWavelength.y - uWavelength.x) * k + uWavelength.x) / gfu.uInputSize.y;\n  let alpha: f32 = select((uAlpha.y - uAlpha.x) * k + uAlpha.x, 1., returnColorOnly);\n\n  var x: f32 = uv.x + cos(v * 6.28 / waveLength - uTime) * amplitude;\n  x = clamp(x, gfu.uInputClamp.x, gfu.uInputClamp.z);\n  \n  return textureSample(uTexture, uSampler, select(vec2<f32>(x, y), uv, returnColorOnly)) * alpha;\n}\n\nfn rand(co: vec2<f32>) -> f32 \n{\n  return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}";


var $736c03d4748db210$var$__defProp = Object.defineProperty;
var $736c03d4748db210$var$__defNormalProp = (obj, key, value)=>key in obj ? $736c03d4748db210$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $736c03d4748db210$var$__publicField = (obj, key, value)=>{
    $736c03d4748db210$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $736c03d4748db210$var$_ReflectionFilter = class _ReflectionFilter extends (0, $ld81y.Filter) {
    /**
   * @param options - Options for the ReflectionFilter constructor.
   */ constructor(options){
        options = {
            ..._ReflectionFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $35cde960d6692dd1$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $f761e5d67807579c$export$2e2bcd8739ae039,
            name: "reflection-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                reflectionUniforms: {
                    uMirror: {
                        value: options.mirror ? 1 : 0,
                        type: "f32"
                    },
                    uBoundary: {
                        value: options.boundary,
                        type: "f32"
                    },
                    uAmplitude: {
                        value: options.amplitude,
                        type: "vec2<f32>"
                    },
                    uWavelength: {
                        value: options.waveLength,
                        type: "vec2<f32>"
                    },
                    uAlpha: {
                        value: options.alpha,
                        type: "vec2<f32>"
                    },
                    uTime: {
                        value: options.time,
                        type: "f32"
                    },
                    uDimensions: {
                        value: new Float32Array(2),
                        type: "vec2<f32>"
                    }
                }
            }
        });
        $736c03d4748db210$var$__publicField(this, "uniforms");
        /**
     * Time for animating position of waves
     * @default 0
     */ $736c03d4748db210$var$__publicField(this, "time", 0);
        this.uniforms = this.resources.reflectionUniforms.uniforms;
        Object.assign(this, options);
    }
    /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */ apply(filterManager, input, output, clearMode) {
        this.uniforms.uDimensions[0] = input.frame.width;
        this.uniforms.uDimensions[1] = input.frame.height;
        this.uniforms.uTime = this.time;
        filterManager.applyFilter(this, input, output, clearMode);
    }
    /**
   * `true` to reflect the image, `false` for waves-only
   * @default true
   */ get mirror() {
        return this.uniforms.uMirror > 0.5;
    }
    set mirror(value) {
        this.uniforms.uMirror = value ? 1 : 0;
    }
    /**
   * Vertical position of the reflection point, default is 50% (middle)
   * smaller numbers produce a larger reflection, larger numbers produce a smaller reflection.
   * @default 0.5
   */ get boundary() {
        return this.uniforms.uBoundary;
    }
    set boundary(value) {
        this.uniforms.uBoundary = value;
    }
    /**
   * Starting and ending amplitude of waves
   * @default [0,20]
   */ get amplitude() {
        return Array.from(this.uniforms.uAmplitude);
    }
    set amplitude(value) {
        this.uniforms.uAmplitude[0] = value[0];
        this.uniforms.uAmplitude[1] = value[1];
    }
    /**
   * Starting amplitude of waves
   * @default 0
   */ get amplitudeStart() {
        return this.uniforms.uAmplitude[0];
    }
    set amplitudeStart(value) {
        this.uniforms.uAmplitude[0] = value;
    }
    /**
   * Starting amplitude of waves
   * @default 20
   */ get amplitudeEnd() {
        return this.uniforms.uAmplitude[1];
    }
    set amplitudeEnd(value) {
        this.uniforms.uAmplitude[1] = value;
    }
    /**
   * Starting and ending length of waves
   * @default [30,100]
   */ get waveLength() {
        return Array.from(this.uniforms.uWavelength);
    }
    set waveLength(value) {
        this.uniforms.uWavelength[0] = value[0];
        this.uniforms.uWavelength[1] = value[1];
    }
    /**
   * Starting wavelength of waves
   * @default 30
   */ get wavelengthStart() {
        return this.uniforms.uWavelength[0];
    }
    set wavelengthStart(value) {
        this.uniforms.uWavelength[0] = value;
    }
    /**
   * Starting wavelength of waves
   * @default 100
   */ get wavelengthEnd() {
        return this.uniforms.uWavelength[1];
    }
    set wavelengthEnd(value) {
        this.uniforms.uWavelength[1] = value;
    }
    /**
   * Starting and ending alpha values
   * @default [1,1]
   */ get alpha() {
        return Array.from(this.uniforms.uAlpha);
    }
    set alpha(value) {
        this.uniforms.uAlpha[0] = value[0];
        this.uniforms.uAlpha[1] = value[1];
    }
    /**
   * Starting wavelength of waves
   * @default 1
   */ get alphaStart() {
        return this.uniforms.uAlpha[0];
    }
    set alphaStart(value) {
        this.uniforms.uAlpha[0] = value;
    }
    /**
   * Starting wavelength of waves
   * @default 1
   */ get alphaEnd() {
        return this.uniforms.uAlpha[1];
    }
    set alphaEnd(value) {
        this.uniforms.uAlpha[1] = value;
    }
};
/** Default values for options. */ $736c03d4748db210$var$__publicField($736c03d4748db210$var$_ReflectionFilter, "DEFAULT_OPTIONS", {
    mirror: true,
    boundary: 0.5,
    amplitude: [
        0,
        20
    ],
    waveLength: [
        30,
        100
    ],
    alpha: [
        1,
        1
    ],
    time: 0
});
let $736c03d4748db210$export$92cc156c1a64ee47 = $736c03d4748db210$var$_ReflectionFilter;



var $j0fPb = parcelRequire("j0fPb");
var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $0be1dc6f819e397d$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec4 uInputSize;\nuniform vec2 uRed;\nuniform vec2 uGreen;\nuniform vec2 uBlue;\n\nvoid main(void)\n{\n   float r = texture(uTexture, vTextureCoord + uRed/uInputSize.xy).r;\n   float g = texture(uTexture, vTextureCoord + uGreen/uInputSize.xy).g;\n   float b = texture(uTexture, vTextureCoord + uBlue/uInputSize.xy).b;\n   float a = texture(uTexture, vTextureCoord).a;\n   finalColor = vec4(r, g, b, a);\n}\n";


var $b90a1354ff1b5814$export$2e2bcd8739ae039 = "struct RgbSplitUniforms {\n    uRed: vec2<f32>,\n    uGreen: vec2<f32>,\n    uBlue: vec3<f32>,\n};\n\nstruct GlobalFilterUniforms {\n    uInputSize:vec4<f32>,\n    uInputPixel:vec4<f32>,\n    uInputClamp:vec4<f32>,\n    uOutputFrame:vec4<f32>,\n    uGlobalFrame:vec4<f32>,\n    uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> rgbSplitUniforms : RgbSplitUniforms;\n\n@fragment\nfn mainFragment(\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n    let r = textureSample(uTexture, uSampler, uv + vec2<f32>(rgbSplitUniforms.uRed.x / gfu.uInputSize.x, rgbSplitUniforms.uRed.y / gfu.uInputSize.y)).r;\n    let g = textureSample(uTexture, uSampler, uv + vec2<f32>(rgbSplitUniforms.uGreen.x / gfu.uInputSize.x, rgbSplitUniforms.uGreen.y / gfu.uInputSize.y)).g;\n    let b = textureSample(uTexture, uSampler, uv + vec2<f32>(rgbSplitUniforms.uBlue.x / gfu.uInputSize.x, rgbSplitUniforms.uBlue.y / gfu.uInputSize.y)).b;\n    let a = textureSample(uTexture, uSampler, uv).a;\n    return vec4<f32>(r, g, b, a);\n}\n";


var $4ebe3c2e2ae24bd0$var$__defProp = Object.defineProperty;
var $4ebe3c2e2ae24bd0$var$__defNormalProp = (obj, key, value)=>key in obj ? $4ebe3c2e2ae24bd0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4ebe3c2e2ae24bd0$var$__publicField = (obj, key, value)=>{
    $4ebe3c2e2ae24bd0$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $4ebe3c2e2ae24bd0$var$_RGBSplitFilter = class _RGBSplitFilter extends (0, $ld81y.Filter) {
    /** @ignore */ constructor(...args){
        let options = args[0] ?? {};
        if (Array.isArray(options) || "x" in options && "y" in options) {
            (0, $j0fPb.deprecation)("6.0.0", "RGBSplitFilter constructor params are now options object. See params: { red, green, blue }");
            options = {
                red: options
            };
            if (args[1] !== void 0) options.green = args[1];
            if (args[2] !== void 0) options.blue = args[2];
        }
        options = {
            ..._RGBSplitFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $b90a1354ff1b5814$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $0be1dc6f819e397d$export$2e2bcd8739ae039,
            name: "rgb-split-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                rgbSplitUniforms: {
                    uRed: {
                        value: options.red,
                        type: "vec2<f32>"
                    },
                    uGreen: {
                        value: options.green,
                        type: "vec2<f32>"
                    },
                    uBlue: {
                        value: options.blue,
                        type: "vec2<f32>"
                    }
                }
            }
        });
        $4ebe3c2e2ae24bd0$var$__publicField(this, "uniforms");
        this.uniforms = this.resources.rgbSplitUniforms.uniforms;
        Object.assign(this, options);
    }
    /**
   * Red channel offset.
   * @default {x:-10,y:0}
   */ get red() {
        return this.uniforms.uRed;
    }
    set red(value) {
        if (Array.isArray(value)) value = {
            x: value[0],
            y: value[1]
        };
        this.uniforms.uRed = value;
    }
    /**
   * Amount of x-axis offset for the red channel.
   * @default -10
   */ get redX() {
        return this.red.x;
    }
    set redX(value) {
        this.red.x = value;
    }
    /**
   * Amount of y-axis offset for the red channel.
   * @default 0
   */ get redY() {
        return this.red.y;
    }
    set redY(value) {
        this.red.y = value;
    }
    /**
   * Green channel offset.
   * @default {x:0,y:10}
   */ get green() {
        return this.uniforms.uGreen;
    }
    set green(value) {
        if (Array.isArray(value)) value = {
            x: value[0],
            y: value[1]
        };
        this.uniforms.uGreen = value;
    }
    /**
   * Amount of x-axis offset for the green channel.
   * @default 0
   */ get greenX() {
        return this.green.x;
    }
    set greenX(value) {
        this.green.x = value;
    }
    /**
   * Amount of y-axis offset for the green channel.
   * @default 10
   */ get greenY() {
        return this.green.y;
    }
    set greenY(value) {
        this.green.y = value;
    }
    /**
   * Blue channel offset.
   * @default {x:0,y:0}
   */ get blue() {
        return this.uniforms.uBlue;
    }
    set blue(value) {
        if (Array.isArray(value)) value = {
            x: value[0],
            y: value[1]
        };
        this.uniforms.uBlue = value;
    }
    /**
   * Amount of x-axis offset for the blue channel.
   * @default 0
   */ get blueX() {
        return this.blue.x;
    }
    set blueX(value) {
        this.blue.x = value;
    }
    /**
   * Amount of y-axis offset for the blue channel.
   * @default 0
   */ get blueY() {
        return this.blue.y;
    }
    set blueY(value) {
        this.blue.y = value;
    }
};
/** Default values for options. */ $4ebe3c2e2ae24bd0$var$__publicField($4ebe3c2e2ae24bd0$var$_RGBSplitFilter, "DEFAULT_OPTIONS", {
    red: {
        x: -10,
        y: 0
    },
    green: {
        x: 0,
        y: 10
    },
    blue: {
        x: 0,
        y: 0
    }
});
let $4ebe3c2e2ae24bd0$export$4f8410d721b3e55e = $4ebe3c2e2ae24bd0$var$_RGBSplitFilter;



var $j0fPb = parcelRequire("j0fPb");
var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $9d8de452e631775c$export$2e2bcd8739ae039 = "\nprecision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec2 uCenter;\nuniform float uTime;\nuniform float uSpeed;\nuniform vec4 uWave;\n\nuniform vec4 uInputSize;\nuniform vec4 uInputClamp;\n\nconst float PI = 3.14159;\n\nvoid main()\n{\n    float uAmplitude = uWave[0];\n    float uWavelength = uWave[1];\n    float uBrightness = uWave[2];\n    float uRadius = uWave[3];\n\n    float halfWavelength = uWavelength * 0.5 / uInputSize.x;\n    float maxRadius = uRadius / uInputSize.x;\n    float currentRadius = uTime * uSpeed / uInputSize.x;\n\n    float fade = 1.0;\n\n    if (maxRadius > 0.0) {\n        if (currentRadius > maxRadius) {\n            finalColor = texture(uTexture, vTextureCoord);\n            return;\n        }\n        fade = 1.0 - pow(currentRadius / maxRadius, 2.0);\n    }\n\n    vec2 dir = vec2(vTextureCoord - uCenter / uInputSize.xy);\n    dir.y *= uInputSize.y / uInputSize.x;\n    float dist = length(dir);\n\n    if (dist <= 0.0 || dist < currentRadius - halfWavelength || dist > currentRadius + halfWavelength) {\n        finalColor = texture(uTexture, vTextureCoord);\n        return;\n    }\n\n    vec2 diffUV = normalize(dir);\n\n    float diff = (dist - currentRadius) / halfWavelength;\n\n    float p = 1.0 - pow(abs(diff), 2.0);\n\n    // float powDiff = diff * pow(p, 2.0) * ( amplitude * fade );\n    float powDiff = 1.25 * sin(diff * PI) * p * ( uAmplitude * fade );\n\n    vec2 offset = diffUV * powDiff / uInputSize.xy;\n\n    // Do clamp :\n    vec2 coord = vTextureCoord + offset;\n    vec2 clampedCoord = clamp(coord, uInputClamp.xy, uInputClamp.zw);\n    vec4 color = texture(uTexture, clampedCoord);\n    if (coord != clampedCoord) {\n        color *= max(0.0, 1.0 - length(coord - clampedCoord));\n    }\n\n    // No clamp :\n    // finalColor = texture(uTexture, vTextureCoord + offset);\n\n    color.rgb *= 1.0 + (uBrightness - 1.0) * p * fade;\n\n    finalColor = color;\n}\n";


var $ec7ddc25e33a824f$export$2e2bcd8739ae039 = "\nstruct ShockWaveUniforms {\n    uTime: f32,\n    uOffset: vec2<f32>,\n    uSpeed: f32,\n    uWave: vec4<f32>,\n};\n\nstruct GlobalFilterUniforms {\n    uInputSize:vec4<f32>,\n    uInputPixel:vec4<f32>,\n    uInputClamp:vec4<f32>,\n    uOutputFrame:vec4<f32>,\n    uGlobalFrame:vec4<f32>,\n    uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> shockwaveUniforms : ShockWaveUniforms;\n\n@fragment\nfn mainFragment(\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n\n    let uTime = shockwaveUniforms.uTime;\n    let uOffset = shockwaveUniforms.uOffset;\n    let uSpeed = shockwaveUniforms.uSpeed;\n    let uAmplitude = shockwaveUniforms.uWave[0];\n    let uWavelength = shockwaveUniforms.uWave[1];\n    let uBrightness = shockwaveUniforms.uWave[2];\n    let uRadius = shockwaveUniforms.uWave[3];\n    let halfWavelength: f32 = uWavelength * 0.5 / gfu.uInputSize.x;\n    let maxRadius: f32 = uRadius / gfu.uInputSize.x;\n    let currentRadius: f32 = uTime * uSpeed / gfu.uInputSize.x;\n    var fade: f32 = 1.0;\n    var returnColorOnly: bool = false;\n    \n    if (maxRadius > 0.0) {\n        if (currentRadius > maxRadius) {\n            returnColorOnly = true;\n        }\n        fade = 1.0 - pow(currentRadius / maxRadius, 2.0);\n    }\n    var dir: vec2<f32> = vec2<f32>(uv - uOffset / gfu.uInputSize.xy);\n    dir.y *= gfu.uInputSize.y / gfu.uInputSize.x;\n\n    let dist:f32 = length(dir);\n\n    if (dist <= 0.0 || dist < currentRadius - halfWavelength || dist > currentRadius + halfWavelength) {\n        returnColorOnly = true;\n    }\n\n    let diffUV: vec2<f32> = normalize(dir);\n    let diff: f32 = (dist - currentRadius) / halfWavelength;\n    let p: f32 = 1.0 - pow(abs(diff), 2.0);\n    let powDiff: f32 = 1.25 * sin(diff * PI) * p * ( uAmplitude * fade );\n    let offset: vec2<f32> = diffUV * powDiff / gfu.uInputSize.xy;\n    // Do clamp :\n    let coord: vec2<f32> = uv + offset;\n    let clampedCoord: vec2<f32> = clamp(coord, gfu.uInputClamp.xy, gfu.uInputClamp.zw);\n\n    var clampedColor: vec4<f32> = textureSample(uTexture, uSampler, clampedCoord);\n    \n    if (boolVec2(coord, clampedCoord)) \n    {\n        clampedColor *= max(0.0, 1.0 - length(coord - clampedCoord));\n    }\n    // No clamp :\n    var finalColor = clampedColor;\n\n    return select(finalColor, textureSample(uTexture, uSampler, uv), returnColorOnly);\n}\n\nfn boolVec2(x: vec2<f32>, y: vec2<f32>) -> bool\n{\n    if (x.x == y.x && x.y == y.y)\n    {\n        return true;\n    }\n    \n    return false;\n}\n\nconst PI: f32 = 3.14159265358979323846264;\n";


var $5a2cab84e52ac2a2$var$__defProp = Object.defineProperty;
var $5a2cab84e52ac2a2$var$__defNormalProp = (obj, key, value)=>key in obj ? $5a2cab84e52ac2a2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5a2cab84e52ac2a2$var$__publicField = (obj, key, value)=>{
    $5a2cab84e52ac2a2$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $5a2cab84e52ac2a2$var$_ShockwaveFilter = class _ShockwaveFilter extends (0, $ld81y.Filter) {
    /** @ignore */ // eslint-disable-next-line max-len
    constructor(...args){
        let options = args[0] ?? {};
        if (Array.isArray(options) || "x" in options && "y" in options) {
            (0, $j0fPb.deprecation)("6.0.0", "ShockwaveFilter constructor params are now options object. See params: { center, speed, amplitude, wavelength, brightness, radius, time }");
            options = {
                center: options,
                ...args[1]
            };
            if (args[2] !== void 0) options.time = args[2];
        }
        options = {
            ..._ShockwaveFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $ec7ddc25e33a824f$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $9d8de452e631775c$export$2e2bcd8739ae039,
            name: "shockwave-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                shockwaveUniforms: {
                    uTime: {
                        value: options.time,
                        type: "f32"
                    },
                    uCenter: {
                        value: options.center,
                        type: "vec2<f32>"
                    },
                    uSpeed: {
                        value: options.speed,
                        type: "f32"
                    },
                    uWave: {
                        value: new Float32Array(4),
                        type: "vec4<f32>"
                    }
                }
            }
        });
        $5a2cab84e52ac2a2$var$__publicField(this, "uniforms");
        /** Sets the elapsed time of the shockwave. It could control the current size of shockwave. */ $5a2cab84e52ac2a2$var$__publicField(this, "time");
        this.time = 0;
        this.uniforms = this.resources.shockwaveUniforms.uniforms;
        Object.assign(this, options);
    }
    apply(filterManager, input, output, clearMode) {
        this.uniforms.uTime = this.time;
        filterManager.applyFilter(this, input, output, clearMode);
    }
    /**
   * The `x` and `y` center coordinates to change the position of the center of the circle of effect.
   * @default [0,0]
   */ get center() {
        return this.uniforms.uCenter;
    }
    set center(value) {
        if (Array.isArray(value)) value = {
            x: value[0],
            y: value[1]
        };
        this.uniforms.uCenter = value;
    }
    /**
   * Sets the center of the effect in normalized screen coords on the `x` axis
   * @default 0
   */ get centerX() {
        return this.uniforms.uCenter.x;
    }
    set centerX(value) {
        this.uniforms.uCenter.x = value;
    }
    /**
   * Sets the center of the effect in normalized screen coords on the `y` axis
   * @default 0
   */ get centerY() {
        return this.uniforms.uCenter.y;
    }
    set centerY(value) {
        this.uniforms.uCenter.y = value;
    }
    /**
   * The speed about the shockwave ripples out. The unit is `pixel-per-second`
   * @default 500
   */ get speed() {
        return this.uniforms.uSpeed;
    }
    set speed(value) {
        this.uniforms.uSpeed = value;
    }
    /**
   * The amplitude of the shockwave
   * @default 30
   */ get amplitude() {
        return this.uniforms.uWave[0];
    }
    set amplitude(value) {
        this.uniforms.uWave[0] = value;
    }
    /**
   * The wavelength of the shockwave
   * @default 160
   */ get wavelength() {
        return this.uniforms.uWave[1];
    }
    set wavelength(value) {
        this.uniforms.uWave[1] = value;
    }
    /**
   * The brightness of the shockwave
   * @default 1
   */ get brightness() {
        return this.uniforms.uWave[2];
    }
    set brightness(value) {
        this.uniforms.uWave[2] = value;
    }
    /**
   * The maximum radius of shockwave. less than `0` means the max is an infinite distance
   * @default -1
   */ get radius() {
        return this.uniforms.uWave[3];
    }
    set radius(value) {
        this.uniforms.uWave[3] = value;
    }
};
/** Default shockwave filter options */ $5a2cab84e52ac2a2$var$__publicField($5a2cab84e52ac2a2$var$_ShockwaveFilter, "DEFAULT_OPTIONS", {
    /** The `x` and `y` center coordinates to change the position of the center of the circle of effect. */ center: {
        x: 0,
        y: 0
    },
    /** The speed about the shockwave ripples out. The unit is `pixel-per-second` */ speed: 500,
    /** The amplitude of the shockwave */ amplitude: 30,
    /** The wavelength of the shockwave */ wavelength: 160,
    /** The brightness of the shockwave */ brightness: 1,
    /** The maximum radius of shockwave. less than `0` means the max is an infinite distance */ radius: -1
});
let $5a2cab84e52ac2a2$export$4c9c000eb13436fd = $5a2cab84e52ac2a2$var$_ShockwaveFilter;



var $jollT = parcelRequire("jollT");
var $j0fPb = parcelRequire("j0fPb");
var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $bEj7k = parcelRequire("bEj7k");
var $ld81y = parcelRequire("ld81y");


var $50095b24d36ebf74$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform sampler2D uMapTexture;\nuniform vec3 uColor;\nuniform float uAlpha;\nuniform vec2 uDimensions;\n\nuniform vec4 uInputSize;\n\nvoid main() {\n    vec4 diffuseColor = texture(uTexture, vTextureCoord);\n    vec2 lightCoord = (vTextureCoord * uInputSize.xy) / uDimensions;\n    vec4 light = texture(uMapTexture, lightCoord);\n    vec3 ambient = uColor.rgb * uAlpha;\n    vec3 intensity = ambient + light.rgb;\n    vec3 color = diffuseColor.rgb * intensity;\n    finalColor = vec4(color, diffuseColor.a);\n}\n";


var $526d486bde044920$export$2e2bcd8739ae039 = "struct SimpleLightmapUniforms {\n  uColor: vec3<f32>,\n  uAlpha: f32,\n  uDimensions: vec2<f32>,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> simpleLightmapUniforms : SimpleLightmapUniforms;\n@group(1) @binding(1) var uMapTexture: texture_2d<f32>;\n@group(1) @binding(2) var uMapSampler: sampler;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>,\n) -> @location(0) vec4<f32> {\n  let uColor = simpleLightmapUniforms.uColor;\n  let uAlpha = simpleLightmapUniforms.uAlpha;\n  let uDimensions = simpleLightmapUniforms.uDimensions;\n\n  let diffuseColor: vec4<f32> = textureSample(uTexture, uSampler, uv);\n  let lightCoord: vec2<f32> = (uv * gfu.uInputSize.xy) / simpleLightmapUniforms.uDimensions;\n  let light: vec4<f32> = textureSample(uMapTexture, uMapSampler, lightCoord);\n  let ambient: vec3<f32> = uColor * uAlpha;\n  let intensity: vec3<f32> = ambient + light.rgb;\n  let finalColor: vec3<f32> = diffuseColor.rgb * intensity;\n  return vec4<f32>(finalColor, diffuseColor.a);\n}";


var $93418b42d331e63b$var$__defProp = Object.defineProperty;
var $93418b42d331e63b$var$__defNormalProp = (obj, key, value)=>key in obj ? $93418b42d331e63b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $93418b42d331e63b$var$__publicField = (obj, key, value)=>{
    $93418b42d331e63b$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $93418b42d331e63b$var$_SimpleLightmapFilter = class _SimpleLightmapFilter extends (0, $ld81y.Filter) {
    /** @ignore */ constructor(...args){
        let options = args[0] ?? {};
        if (options instanceof (0, $jollT.Texture)) {
            (0, $j0fPb.deprecation)("6.0.0", "SimpleLightmapFilter constructor params are now options object. See params: { lightMap, color, alpha }");
            options = {
                lightMap: options
            };
            if (args[1] !== void 0) options.color = args[1];
            if (args[2] !== void 0) options.alpha = args[2];
        }
        options = {
            ..._SimpleLightmapFilter.DEFAULT_OPTIONS,
            ...options
        };
        if (!options.lightMap) throw Error("No light map texture source was provided to SimpleLightmapFilter");
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $526d486bde044920$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $50095b24d36ebf74$export$2e2bcd8739ae039,
            name: "simple-lightmap-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                simpleLightmapUniforms: {
                    uColor: {
                        value: new Float32Array(3),
                        type: "vec3<f32>"
                    },
                    uAlpha: {
                        value: options.alpha,
                        type: "f32"
                    },
                    uDimensions: {
                        value: new Float32Array(2),
                        type: "vec2<f32>"
                    }
                },
                uMapTexture: options.lightMap.source,
                uMapSampler: options.lightMap.source.style
            }
        });
        $93418b42d331e63b$var$__publicField(this, "uniforms");
        $93418b42d331e63b$var$__publicField(this, "_color");
        $93418b42d331e63b$var$__publicField(this, "_lightMap");
        this.uniforms = this.resources.simpleLightmapUniforms.uniforms;
        this._color = new (0, $bEj7k.Color)();
        this.color = options.color ?? 0;
        Object.assign(this, options);
    }
    /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */ apply(filterManager, input, output, clearMode) {
        this.uniforms.uDimensions[0] = input.frame.width;
        this.uniforms.uDimensions[1] = input.frame.height;
        filterManager.applyFilter(this, input, output, clearMode);
    }
    /** A sprite where your lightmap is rendered */ get lightMap() {
        return this._lightMap;
    }
    set lightMap(value) {
        this._lightMap = value;
        this.resources.uMapTexture = value.source;
        this.resources.uMapSampler = value.source.style;
    }
    /**
   * The color value of the ambient color
   * @example [1.0, 1.0, 1.0] = 0xffffff
   * @default 0x000000
   */ get color() {
        return this._color.value;
    }
    set color(value) {
        this._color.setValue(value);
        const [r, g, b] = this._color.toArray();
        this.uniforms.uColor[0] = r;
        this.uniforms.uColor[1] = g;
        this.uniforms.uColor[2] = b;
    }
    /**
   * Coefficient for alpha multiplication
   * @default 1
   */ get alpha() {
        return this.uniforms.uAlpha;
    }
    set alpha(value) {
        this.uniforms.uAlpha = value;
    }
};
/** Default values for options. */ $93418b42d331e63b$var$__publicField($93418b42d331e63b$var$_SimpleLightmapFilter, "DEFAULT_OPTIONS", {
    lightMap: (0, $jollT.Texture).WHITE,
    color: 0,
    alpha: 1
});
let $93418b42d331e63b$export$b228cfd61a4fbcd2 = $93418b42d331e63b$var$_SimpleLightmapFilter;



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $237b1a540c910f61$export$2e2bcd8739ae039 = "in vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec2 uBlur;\nuniform vec2 uStart;\nuniform vec2 uEnd;\nuniform vec2 uDelta;\nuniform vec2 uTexSize;\n\nfloat random(vec3 scale, float seed)\n{\n    return fract(sin(dot(gl_FragCoord.xyz + seed, scale)) * 43758.5453 + seed);\n}\n\nvoid main(void)\n{\n    vec4 color = vec4(0.0);\n    float total = 0.0;\n\n    float blur = uBlur[0];\n    float gradientBlur = uBlur[1];\n\n    float offset = random(vec3(12.9898, 78.233, 151.7182), 0.0);\n    vec2 normal = normalize(vec2(uStart.y - uEnd.y, uEnd.x - uStart.x));\n    float radius = smoothstep(0.0, 1.0, abs(dot(vTextureCoord * uTexSize - uStart, normal)) / gradientBlur) * blur;\n\n    for (float t = -30.0; t <= 30.0; t++)\n    {\n        float percent = (t + offset - 0.5) / 30.0;\n        float weight = 1.0 - abs(percent);\n        vec4 sample = texture(uTexture, vTextureCoord + uDelta / uTexSize * percent * radius);\n        sample.rgb *= sample.a;\n        color += sample * weight;\n        total += weight;\n    }\n\n    color /= total;\n    color.rgb /= color.a + 0.00001;\n\n    finalColor = color;\n}\n";


var $43195b056438e22e$export$2e2bcd8739ae039 = "struct TiltShiftUniforms {\n  uBlur: vec2<f32>,\n  uStart: vec2<f32>,\n  uEnd: vec2<f32>,\n  uDelta: vec2<f32>,\n  uTexSize: vec2<f32>,\n};\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> tiltShiftUniforms : TiltShiftUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let uBlur = tiltShiftUniforms.uBlur[0];\n  let uBlurGradient = tiltShiftUniforms.uBlur[1];\n  let uStart = tiltShiftUniforms.uStart;\n  let uEnd = tiltShiftUniforms.uEnd;\n  let uDelta = tiltShiftUniforms.uDelta;\n  let uTexSize = tiltShiftUniforms.uTexSize;\n\n  var color: vec4<f32> = vec4<f32>(0.0);\n  var total: f32 = 0.0;\n\n  let offset: f32 = random(position, vec3<f32>(12.9898, 78.233, 151.7182), 0.0);\n  let normal: vec2<f32> = normalize(vec2<f32>(uStart.y - uEnd.y, uEnd.x - uStart.x));\n  let radius: f32 = smoothstep(0.0, 1.0, abs(dot(uv * uTexSize - uStart, normal)) / uBlurGradient) * uBlur;\n\n  for (var t: f32 = -30.0; t <= 30.0; t += 1.0)\n  {\n    var percent: f32 = (t + offset - 0.5) / 30.0;\n    var weight: f32 = 1.0 - abs(percent);\n    var sample: vec4<f32> = textureSample(uTexture, uSampler, uv + uDelta / uTexSize * percent * radius);\n    sample = vec4<f32>(sample.xyz * sample.a, sample.a); // multiply sample.rgb with sample.a\n    color += sample * weight;\n    total += weight;\n  }\n\n  color /= total;\n  color = vec4<f32>(color.xyz / (color.a + 0.00001), color.a); // divide color.rgb by color.a + 0.00001\n\n  return color;\n}\n\n\nfn random(position: vec4<f32>, scale: vec3<f32>, seed: f32) -> f32\n{\n  return fract(sin(dot(position.xyz + seed, scale)) * 43758.5453 + seed);\n}";


var $81bb3501ee887083$var$__defProp = Object.defineProperty;
var $81bb3501ee887083$var$__defNormalProp = (obj, key, value)=>key in obj ? $81bb3501ee887083$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $81bb3501ee887083$var$__publicField = (obj, key, value)=>{
    $81bb3501ee887083$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $81bb3501ee887083$var$_TiltShiftAxisFilter = class _TiltShiftAxisFilter extends (0, $ld81y.Filter) {
    constructor(options){
        options = {
            ..._TiltShiftAxisFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $43195b056438e22e$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $237b1a540c910f61$export$2e2bcd8739ae039,
            name: "tilt-shift-axis-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                tiltShiftUniforms: {
                    uBlur: {
                        value: new Float32Array([
                            options.blur ?? 100,
                            options.gradientBlur ?? 600
                        ]),
                        type: "vec2<f32>"
                    },
                    uStart: {
                        value: options.start,
                        type: "vec2<f32>"
                    },
                    uEnd: {
                        value: options.end,
                        type: "vec2<f32>"
                    },
                    uDelta: {
                        value: new Float32Array([
                            30,
                            30
                        ]),
                        type: "vec2<f32>"
                    },
                    uTexSize: {
                        value: new Float32Array([
                            window.innerWidth,
                            window.innerHeight
                        ]),
                        type: "vec2<f32>"
                    }
                }
            }
        });
        $81bb3501ee887083$var$__publicField(this, "uniforms");
        $81bb3501ee887083$var$__publicField(this, "_tiltAxis");
        this.uniforms = this.resources.tiltShiftUniforms.uniforms;
        this._tiltAxis = options.axis;
        this.updateDelta();
    }
    /** Updates the filter delta values. */ updateDelta() {
        this.uniforms.uDelta[0] = 0;
        this.uniforms.uDelta[1] = 0;
        if (this._tiltAxis === void 0) return;
        const end = this.uniforms.uEnd;
        const start = this.uniforms.uStart;
        const dx = end.x - start.x;
        const dy = end.y - start.y;
        const d = Math.sqrt(dx * dx + dy * dy);
        const isVert = this._tiltAxis === "vertical";
        this.uniforms.uDelta[0] = !isVert ? dx / d : -dy / d;
        this.uniforms.uDelta[1] = !isVert ? dy / d : dx / d;
    }
};
/** Default values for options. */ $81bb3501ee887083$var$__publicField($81bb3501ee887083$var$_TiltShiftAxisFilter, "DEFAULT_OPTIONS", {
    /** The strength of the blur. */ blur: 100,
    /** The strength of the blur gradient */ gradientBlur: 600,
    /** The position to start the effect at. */ start: {
        x: 0,
        y: window.innerHeight / 2
    },
    /** The position to end the effect at. */ end: {
        x: 600,
        y: window.innerHeight / 2
    }
});
let $81bb3501ee887083$export$f5de69891142c6a6 = $81bb3501ee887083$var$_TiltShiftAxisFilter;



var $g5CeI = parcelRequire("g5CeI");

var $73ed46fc1621eeb3$var$__defProp = Object.defineProperty;
var $73ed46fc1621eeb3$var$__defNormalProp = (obj, key, value)=>key in obj ? $73ed46fc1621eeb3$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $73ed46fc1621eeb3$var$__publicField = (obj, key, value)=>{
    $73ed46fc1621eeb3$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
class $73ed46fc1621eeb3$export$b40f9a78a0b88d5d extends (0, $81bb3501ee887083$export$f5de69891142c6a6) {
    /**
   * @param options - Options for the TiltShiftFilter constructor.
   */ constructor(options){
        options = {
            ...(0, $81bb3501ee887083$export$f5de69891142c6a6).DEFAULT_OPTIONS,
            ...options
        };
        super({
            ...options,
            axis: "horizontal"
        });
        $73ed46fc1621eeb3$var$__publicField(this, "_tiltShiftYFilter");
        this._tiltShiftYFilter = new (0, $81bb3501ee887083$export$f5de69891142c6a6)({
            ...options,
            axis: "vertical"
        });
        Object.assign(this, options);
    }
    /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */ apply(filterManager, input, output, clearMode) {
        const renderTarget = (0, $g5CeI.TexturePool).getSameSizeTexture(input);
        filterManager.applyFilter(this, input, renderTarget, true);
        filterManager.applyFilter(this._tiltShiftYFilter, renderTarget, output, clearMode);
        (0, $g5CeI.TexturePool).returnTexture(renderTarget);
    }
    /** The strength of the blur. */ get blur() {
        return this.uniforms.uBlur[0];
    }
    set blur(value) {
        this.uniforms.uBlur[0] = this._tiltShiftYFilter.uniforms.uBlur[0] = value;
    }
    /** The strength of the gradient blur. */ get gradientBlur() {
        return this.uniforms.uBlur[1];
    }
    set gradientBlur(value) {
        this.uniforms.uBlur[1] = this._tiltShiftYFilter.uniforms.uBlur[1] = value;
    }
    /** The position to start the effect at. */ get start() {
        return this.uniforms.uStart;
    }
    set start(value) {
        this.uniforms.uStart = this._tiltShiftYFilter.uniforms.uStart = value;
    }
    /** The position to start the effect at on the `x` axis. */ get startX() {
        return this.start.x;
    }
    set startX(value) {
        this.start.x = value;
    }
    /** The position to start the effect at on the `x` axis. */ get startY() {
        return this.start.y;
    }
    set startY(value) {
        this.start.y = value;
    }
    /** The position to end the effect at. */ get end() {
        return this.uniforms.uEnd;
    }
    set end(value) {
        this.uniforms.uEnd = this._tiltShiftYFilter.uniforms.uEnd = value;
    }
    /** The position to end the effect at on the `x` axis. */ get endX() {
        return this.end.x;
    }
    set endX(value) {
        this.end.x = value;
    }
    /** The position to end the effect at on the `y` axis. */ get endY() {
        return this.end.y;
    }
    set endY(value) {
        this.end.y = value;
    }
}



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $b64248a8fd7ff7eb$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec2 uTwist;\nuniform vec2 uOffset;\nuniform vec4 uInputSize;\n\nvec2 mapCoord( vec2 coord )\n{\n    coord *= uInputSize.xy;\n    coord += uInputSize.zw;\n\n    return coord;\n}\n\nvec2 unmapCoord( vec2 coord )\n{\n    coord -= uInputSize.zw;\n    coord /= uInputSize.xy;\n\n    return coord;\n}\n\nvec2 twist(vec2 coord)\n{\n    coord -= uOffset;\n\n    float dist = length(coord);\n    float uRadius = uTwist[0];\n    float uAngle = uTwist[1];\n\n    if (dist < uRadius)\n    {\n        float ratioDist = (uRadius - dist) / uRadius;\n        float angleMod = ratioDist * ratioDist * uAngle;\n        float s = sin(angleMod);\n        float c = cos(angleMod);\n        coord = vec2(coord.x * c - coord.y * s, coord.x * s + coord.y * c);\n    }\n\n    coord += uOffset;\n\n    return coord;\n}\n\nvoid main(void)\n{\n    vec2 coord = mapCoord(vTextureCoord);\n    coord = twist(coord);\n    coord = unmapCoord(coord);\n    finalColor = texture(uTexture, coord);\n}\n";


var $7e6c43de85901b67$export$2e2bcd8739ae039 = "struct TwistUniforms {\n  uTwist:vec2<f32>,\n  uOffset:vec2<f32>,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> twistUniforms : TwistUniforms;\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>,\n  @builtin(position) position: vec4<f32>\n) -> @location(0) vec4<f32> {\n  return textureSample(uTexture, uSampler, unmapCoord(twist(mapCoord(uv))));\n}\n\nfn mapCoord(coord: vec2<f32> ) -> vec2<f32>\n{\n  var mappedCoord: vec2<f32> = coord;\n  mappedCoord *= gfu.uInputSize.xy;\n  mappedCoord += gfu.uOutputFrame.xy;\n  return mappedCoord;\n}\n\nfn unmapCoord(coord: vec2<f32> ) -> vec2<f32>\n{\n  var mappedCoord: vec2<f32> = coord;\n  mappedCoord -= gfu.uOutputFrame.xy;\n  mappedCoord /= gfu.uInputSize.xy;\n  return mappedCoord;\n}\n\nfn twist(coord: vec2<f32>) -> vec2<f32>\n{\n  var twistedCoord: vec2<f32> = coord;\n  let uRadius = twistUniforms.uTwist[0];\n  let uAngle = twistUniforms.uTwist[1];\n  let uOffset = twistUniforms.uOffset;\n\n  twistedCoord -= uOffset;\n  \n  let dist = length(twistedCoord);\n\n  if (dist < uRadius)\n  {\n    let ratioDist: f32 = (uRadius - dist) / uRadius;\n    let angleMod: f32 = ratioDist * ratioDist * uAngle;\n    let s: f32 = sin(angleMod);\n    let c: f32 = cos(angleMod);\n    twistedCoord = vec2<f32>(twistedCoord.x * c - twistedCoord.y * s, twistedCoord.x * s + twistedCoord.y * c);\n  }\n\n  twistedCoord += uOffset;\n  return twistedCoord;\n}\n";


var $22cd8d554d6865cb$var$__defProp = Object.defineProperty;
var $22cd8d554d6865cb$var$__defNormalProp = (obj, key, value)=>key in obj ? $22cd8d554d6865cb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $22cd8d554d6865cb$var$__publicField = (obj, key, value)=>{
    $22cd8d554d6865cb$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $22cd8d554d6865cb$var$_TwistFilter = class _TwistFilter extends (0, $ld81y.Filter) {
    /**
   * @param options - Options for the TwistFilter constructor.
   */ constructor(options){
        options = {
            ..._TwistFilter.DEFAULT_OPTIONS,
            ...options
        };
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $7e6c43de85901b67$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: $b64248a8fd7ff7eb$export$2e2bcd8739ae039,
            name: "twist-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                twistUniforms: {
                    uTwist: {
                        value: [
                            options.radius ?? 0,
                            options.angle ?? 0
                        ],
                        type: "vec2<f32>"
                    },
                    uOffset: {
                        value: options.offset,
                        type: "vec2<f32>"
                    }
                }
            },
            ...options
        });
        $22cd8d554d6865cb$var$__publicField(this, "uniforms");
        this.uniforms = this.resources.twistUniforms.uniforms;
    }
    /**
   * The radius of the twist
   * @default 200
   */ get radius() {
        return this.uniforms.uTwist[0];
    }
    set radius(value) {
        this.uniforms.uTwist[0] = value;
    }
    /**
   * The angle of the twist
   * @default 4
   */ get angle() {
        return this.uniforms.uTwist[1];
    }
    set angle(value) {
        this.uniforms.uTwist[1] = value;
    }
    /**
   * The `x` offset coordinate to change the position of the center of the circle of effect
   * @default 0
   */ get offset() {
        return this.uniforms.uOffset;
    }
    set offset(value) {
        this.uniforms.uOffset = value;
    }
    /**
   * The `x` offset coordinate to change the position of the center of the circle of effect
   * @default 0
   */ get offsetX() {
        return this.offset.x;
    }
    set offsetX(value) {
        this.offset.x = value;
    }
    /**
   * The `y` offset coordinate to change the position of the center of the circle of effect
   * @default 0
   */ get offsetY() {
        return this.offset.y;
    }
    set offsetY(value) {
        this.offset.y = value;
    }
};
/** Default values for options. */ $22cd8d554d6865cb$var$__publicField($22cd8d554d6865cb$var$_TwistFilter, "DEFAULT_OPTIONS", {
    padding: 20,
    radius: 200,
    angle: 4,
    offset: {
        x: 0,
        y: 0
    }
});
let $22cd8d554d6865cb$export$d9119bded5bc57d4 = $22cd8d554d6865cb$var$_TwistFilter;



var $9E2kA = parcelRequire("9E2kA");
var $339HX = parcelRequire("339HX");
var $ld81y = parcelRequire("ld81y");


var $91c26556d45cd2f6$export$2e2bcd8739ae039 = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform float uStrength;\nuniform vec2 uCenter;\nuniform vec2 uRadii;\n\nuniform vec4 uInputSize;\n\nconst float MAX_KERNEL_SIZE = ${MAX_KERNEL_SIZE};\n\n// author: http://byteblacksmith.com/improvements-to-the-canonical-one-liner-glsl-rand-for-opengl-es-2-0/\nhighp float rand(vec2 co, float seed) {\n    const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n    highp float dt = dot(co + seed, vec2(a, b)), sn = mod(dt, 3.14159);\n    return fract(sin(sn) * c + seed);\n}\n\nvoid main() {\n    float minGradient = uRadii[0] * 0.3;\n    float innerRadius = (uRadii[0] + minGradient * 0.5) / uInputSize.x;\n\n    float gradient = uRadii[1] * 0.3;\n    float radius = (uRadii[1] - gradient * 0.5) / uInputSize.x;\n\n    float countLimit = MAX_KERNEL_SIZE;\n\n    vec2 dir = vec2(uCenter.xy / uInputSize.xy - vTextureCoord);\n    float dist = length(vec2(dir.x, dir.y * uInputSize.y / uInputSize.x));\n\n    float strength = uStrength;\n\n    float delta = 0.0;\n    float gap;\n    if (dist < innerRadius) {\n        delta = innerRadius - dist;\n        gap = minGradient;\n    } else if (radius >= 0.0 && dist > radius) { // radius < 0 means it's infinity\n        delta = dist - radius;\n        gap = gradient;\n    }\n\n    if (delta > 0.0) {\n        float normalCount = gap / uInputSize.x;\n        delta = (normalCount - delta) / normalCount;\n        countLimit *= delta;\n        strength *= delta;\n        if (countLimit < 1.0)\n        {\n            gl_FragColor = texture(uTexture, vTextureCoord);\n            return;\n        }\n    }\n\n    // randomize the lookup values to hide the fixed number of samples\n    float offset = rand(vTextureCoord, 0.0);\n\n    float total = 0.0;\n    vec4 color = vec4(0.0);\n\n    dir *= strength;\n\n    for (float t = 0.0; t < MAX_KERNEL_SIZE; t++) {\n        float percent = (t + offset) / MAX_KERNEL_SIZE;\n        float weight = 4.0 * (percent - percent * percent);\n        vec2 p = vTextureCoord + dir * percent;\n        vec4 sample = texture(uTexture, p);\n\n        // switch to pre-multiplied alpha to correctly blur transparent images\n        // sample.rgb *= sample.a;\n\n        color += sample * weight;\n        total += weight;\n\n        if (t > countLimit){\n            break;\n        }\n    }\n\n    color /= total;\n    // switch back from pre-multiplied alpha\n    // color.rgb /= color.a + 0.00001;\n\n    gl_FragColor = color;\n}\n";


var $dabd4dcf59ca3f82$export$2e2bcd8739ae039 = "struct ZoomBlurUniforms {\n    uStrength:f32,\n    uCenter:vec2<f32>,\n    uRadii:vec2<f32>,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> zoomBlurUniforms : ZoomBlurUniforms;\n\n@fragment\nfn mainFragment(\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let uStrength = zoomBlurUniforms.uStrength;\n  let uCenter = zoomBlurUniforms.uCenter;\n  let uRadii = zoomBlurUniforms.uRadii;\n\n  let minGradient: f32 = uRadii[0] * 0.3;\n  let innerRadius: f32 = (uRadii[0] + minGradient * 0.5) / gfu.uInputSize.x;\n\n  let gradient: f32 = uRadii[1] * 0.3;\n  let radius: f32 = (uRadii[1] - gradient * 0.5) / gfu.uInputSize.x;\n\n  let MAX_KERNEL_SIZE: f32 = ${MAX_KERNEL_SIZE};\n\n  var countLimit: f32 = MAX_KERNEL_SIZE;\n\n  var dir: vec2<f32> = vec2<f32>(uCenter / gfu.uInputSize.xy - uv);\n  let dist: f32 = length(vec2<f32>(dir.x, dir.y * gfu.uInputSize.y / gfu.uInputSize.x));\n\n  var strength: f32 = uStrength;\n\n  var delta: f32 = 0.0;\n  var gap: f32;\n\n  if (dist < innerRadius) {\n      delta = innerRadius - dist;\n      gap = minGradient;\n  } else if (radius >= 0.0 && dist > radius) { // radius < 0 means it's infinity\n      delta = dist - radius;\n      gap = gradient;\n  }\n\n  var returnColorOnly: bool = false;\n\n  if (delta > 0.0) {\n    let normalCount: f32 = gap / gfu.uInputSize.x;\n    delta = (normalCount - delta) / normalCount;\n    countLimit *= delta;\n    strength *= delta;\n    \n    if (countLimit < 1.0)\n    {\n      returnColorOnly = true;;\n    }\n  }\n\n  // randomize the lookup values to hide the fixed number of samples\n  let offset: f32 = rand(uv, 0.0);\n\n  var total: f32 = 0.0;\n  var color: vec4<f32> = vec4<f32>(0.);\n\n  dir *= strength;\n\n  for (var t = 0.0; t < MAX_KERNEL_SIZE; t += 1.0) {\n    let percent: f32 = (t + offset) / MAX_KERNEL_SIZE;\n    let weight: f32 = 4.0 * (percent - percent * percent);\n    let p: vec2<f32> = uv + dir * percent;\n    let sample: vec4<f32> = textureSample(uTexture, uSampler, p);\n    \n    if (t < countLimit)\n    {\n      color += sample * weight;\n      total += weight;\n    }\n  }\n\n  color /= total;\n\n  return select(color, textureSample(uTexture, uSampler, uv), returnColorOnly);\n}\n\nfn modulo(x: f32, y: f32) -> f32\n{\n  return x - y * floor(x/y);\n}\n\n// author: http://byteblacksmith.com/improvements-to-the-canonical-one-liner-glsl-rand-for-opengl-es-2-0/\nfn rand(co: vec2<f32>, seed: f32) -> f32\n{\n  let a: f32 = 12.9898;\n  let b: f32 = 78.233;\n  let c: f32 = 43758.5453;\n  let dt: f32 = dot(co + seed, vec2<f32>(a, b));\n  let sn: f32 = modulo(dt, 3.14159);\n  return fract(sin(sn) * c + seed);\n}";


var $d0d08225214168ef$var$__defProp = Object.defineProperty;
var $d0d08225214168ef$var$__defNormalProp = (obj, key, value)=>key in obj ? $d0d08225214168ef$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d0d08225214168ef$var$__publicField = (obj, key, value)=>{
    $d0d08225214168ef$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $d0d08225214168ef$var$_ZoomBlurFilter = class _ZoomBlurFilter extends (0, $ld81y.Filter) {
    /**
   * @param options - Options for the ZoomBlurFilter constructor.
   */ constructor(options){
        options = {
            ..._ZoomBlurFilter.DEFAULT_OPTIONS,
            ...options
        };
        const kernelSize = options.maxKernelSize ?? 32;
        const gpuProgram = (0, $9E2kA.GpuProgram).from({
            vertex: {
                source: (0, $69d09aa8ffdf58e2$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            },
            fragment: {
                source: (0, $dabd4dcf59ca3f82$export$2e2bcd8739ae039).replace("${MAX_KERNEL_SIZE}", kernelSize.toFixed(1)),
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $339HX.GlProgram).from({
            vertex: $ec78c175a89a0f54$export$2e2bcd8739ae039,
            fragment: (0, $91c26556d45cd2f6$export$2e2bcd8739ae039).replace("${MAX_KERNEL_SIZE}", kernelSize.toFixed(1)),
            name: "zoom-blur-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                zoomBlurUniforms: {
                    uStrength: {
                        value: options.strength,
                        type: "f32"
                    },
                    uCenter: {
                        value: options.center,
                        type: "vec2<f32>"
                    },
                    uRadii: {
                        value: new Float32Array(2),
                        type: "vec2<f32>"
                    }
                }
            }
        });
        $d0d08225214168ef$var$__publicField(this, "uniforms");
        this.uniforms = this.resources.zoomBlurUniforms.uniforms;
        Object.assign(this, options);
    }
    /**
   * Sets the strength of the zoom blur effect
   * @default 0.1
   */ get strength() {
        return this.uniforms.uStrength;
    }
    set strength(value) {
        this.uniforms.uStrength = value;
    }
    /**
   * The center of the zoom
   * @default [0,0]
   */ get center() {
        return this.uniforms.uCenter;
    }
    set center(value) {
        if (Array.isArray(value)) value = {
            x: value[0],
            y: value[1]
        };
        this.uniforms.uCenter = value;
    }
    /**
   * Sets the center of the effect in normalized screen coords on the `x` axis
   * @default 0
   */ get centerX() {
        return this.uniforms.uCenter.x;
    }
    set centerX(value) {
        this.uniforms.uCenter.x = value;
    }
    /**
   * Sets the center of the effect in normalized screen coords on the `y` axis
   * @default 0
   */ get centerY() {
        return this.uniforms.uCenter.y;
    }
    set centerY(value) {
        this.uniforms.uCenter.y = value;
    }
    /**
   * The inner radius of zoom. The part in inner circle won't apply zoom blur effect
   * @default 0
   */ get innerRadius() {
        return this.uniforms.uRadii[0];
    }
    set innerRadius(value) {
        this.uniforms.uRadii[0] = value;
    }
    /**
   * Outer radius of the effect. less than `0` equates to infinity
   * @default -1
   */ get radius() {
        return this.uniforms.uRadii[1];
    }
    set radius(value) {
        this.uniforms.uRadii[1] = value < 0 || value === Infinity ? -1 : value;
    }
};
/** Default values for options. */ $d0d08225214168ef$var$__publicField($d0d08225214168ef$var$_ZoomBlurFilter, "DEFAULT_OPTIONS", {
    strength: 0.1,
    center: {
        x: 0,
        y: 0
    },
    innerRadius: 0,
    radius: -1,
    maxKernelSize: 32
});
let $d0d08225214168ef$export$f0d024e48d4abe00 = $d0d08225214168ef$var$_ZoomBlurFilter;





var $e0Ilp = parcelRequire("e0Ilp");

class $8d9f3cef48de1ddd$export$2e2bcd8739ae039 extends (0, $e0Ilp.Container) {
    constructor(){
        super();
        this.desiredPosition = new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)(0, 0);
        this.zoom = 1;
        this.desiredZoom = 0.25;
    }
    screenToWorldPoint(screenPosition) {
        const screenPos = new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)(-this.position.x + screenPosition.x, -this.position.y + screenPosition.y);
        const rotatedScreenPos = screenPos.rotate(-this.rotation);
        const pos = new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)((this.pivot.x * this.zoom + rotatedScreenPos.x) / this.zoom, (this.pivot.y * this.zoom + rotatedScreenPos.y) / this.zoom);
        return pos;
    }
    Update(dt) {
        const dZoom = Math.exp(this.desiredZoom) - 1 - this.zoom;
        this.zoom = +this.zoom + dZoom * dt / 15;
        this.scale.x = this.zoom;
        this.scale.y = this.zoom;
        const dPos = {
            x: this.desiredPosition.x - this.pivot.x,
            y: this.desiredPosition.y - this.pivot.y
        };
        this.pivot.x = this.pivot.x + dPos.x * dt / 15;
        this.pivot.y = this.pivot.y + dPos.y * dt / 15;
    }
}


const $3dfcb00c48470562$export$fc9f9b64b84f941f = (object)=>{
    return object.Update !== undefined;
};





var $j5g5m = parcelRequire("j5g5m");
var $8VCQS = parcelRequire("8VCQS");
const $713f438c8484fefc$export$e2d8d536c8fc9c6f = (object)=>{
    return object.onStack !== undefined;
};



var $j5g5m = parcelRequire("j5g5m");
var $8VCQS = parcelRequire("8VCQS");

const $e3e0d3802040b351$export$5d532f06a6d2ef56 = (object)=>{
    return object.onDrag !== undefined;
};



var $e0Ilp = parcelRequire("e0Ilp");
let $bc2c310e4f4b9933$export$8122402e62ffa7ac = 0;
var $bc2c310e4f4b9933$export$2e2bcd8739ae039 = ()=>{
    return $bc2c310e4f4b9933$export$8122402e62ffa7ac++;
};
const $bc2c310e4f4b9933$export$2fca005cbdb9bc0f = (value)=>{
    $bc2c310e4f4b9933$export$8122402e62ffa7ac = value;
};




class $a03da0212fa80d5e$export$2e2bcd8739ae039 extends (0, $e0Ilp.Container) {
    constructor(){
        super();
        this.id = (0, $bc2c310e4f4b9933$export$2e2bcd8739ae039)();
        this.desiredPosition = new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)(this.x, this.y);
        this.baseZindex = 0;
        this.force = new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)();
        this.friction = 1;
        this.locked = false;
        this.filters = [];
        this.filtersMap = new Map();
        gm.gameObjects.set(this.id, this);
        this.on("destroyed", ()=>{
            gm.gameObjects.delete(this.id);
        });
        this.on("pointerover", ()=>{
            if (!this.locked) {
                this.addFilter("outline", new (0, $46c687782dcb4f1e$export$ea1238a366116160)({
                    thickness: 5,
                    color: "yellow"
                }));
                this.cursor = "grab";
            }
            if (gm.hoverTarget && !gm.hoverTarget.destroyed && gm.hoverTarget !== this && !gm.targets.includes(gm.hoverTarget)) gm.hoverTarget.removeFilter("outline");
            gm.hoverTarget = this;
        });
        this.on("pointerout", ()=>{
            if (!gm.targets.includes(this)) this.removeFilter("outline");
            gm.hoverTarget = null;
        });
    }
    addFilter(key, filter) {
        filter.antialias = "on";
        if (!this.filtersMap.has(key)) {
            this.filtersMap.set(key, filter);
            this.filters = [
                ...this.filters,
                filter
            ];
            if (filter instanceof (0, $e234fabd83f60df8$export$57214e398098d4e3)) filter._offset = new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)(filter.offsetX, filter.offsetY);
        }
    }
    removeFilter(key) {
        const filter = this.filtersMap.get(key);
        this.filters = [
            ...this.filters.filter((f)=>f !== filter)
        ];
        this.filtersMap.delete(key);
    }
    Update(dt) {
        this.force.x -= this.force.x * this.friction * dt;
        this.force.y -= this.force.y * this.friction * dt;
        this.desiredPosition.x = this.desiredPosition.x + this.force.x * dt * 2;
        this.desiredPosition.y = this.desiredPosition.y + this.force.y * dt * 2;
        const dx = this.desiredPosition.x - this.x;
        const dy = this.desiredPosition.y - this.y;
        this.x += dx * dt / 2;
        this.y += dy * dt / 2;
        this.filters.forEach((filter)=>{
            if (filter instanceof (0, $e234fabd83f60df8$export$57214e398098d4e3)) {
                filter.offsetX = filter._offset.x * gm.camera.scale.x;
                filter.offsetY = filter._offset.y * gm.camera.scale.y;
            }
        });
    }
    toString() {
        return "";
    }
    serialize() {
        return {
            type: "object",
            id: this.id,
            x: this.x,
            y: this.y,
            locked: this.locked,
            angle: this.angle
        };
    }
}



const $1f0ef112743f5763$export$bf29a109eabc0057 = (object)=>{
    return object.flip !== undefined;
};




let $a4a95632c8795d75$export$9544d5bb712b01ea;
function $a4a95632c8795d75$export$7fbc60ba12697434(sound) {
    $a4a95632c8795d75$export$9544d5bb712b01ea = sound;
    return sound;
}
function $a4a95632c8795d75$export$8bedcca5bbd73999() {
    return $a4a95632c8795d75$export$9544d5bb712b01ea;
}


class $fc329676127dccbc$export$ec91da630f36d5ea {
    /**
   * @param {AudioNode} destination - The audio node to use as the destination for the input AudioNode
   * @param {AudioNode} [source] - Optional output node, defaults to destination node. This is useful
   *        when creating filters which contains multiple AudioNode elements chained together.
   */ constructor(destination, source){
        this.init(destination, source);
    }
    /** Reinitialize */ init(destination, source) {
        this.destination = destination;
        this.source = source || destination;
    }
    /**
   * Connect to the destination.
   * @param {AudioNode} destination - The destination node to connect the output to
   */ connect(destination) {
        this.source?.connect(destination);
    }
    /** Completely disconnect filter from destination and source nodes. */ disconnect() {
        this.source?.disconnect();
    }
    /** Destroy the filter and don't use after this. */ destroy() {
        this.disconnect();
        this.destination = null;
        this.source = null;
    }
}


class $5336a6929eea1257$export$60a770664ca75ef2 extends (0, $fc329676127dccbc$export$ec91da630f36d5ea) {
    /** @param amount - The amount of distoration from 0 to 1. */ constructor(amount = 0){
        let distortion;
        if (!(0, $a4a95632c8795d75$export$8bedcca5bbd73999)().useLegacy) {
            const { audioContext: audioContext } = (0, $a4a95632c8795d75$export$8bedcca5bbd73999)().context;
            distortion = audioContext.createWaveShaper();
        }
        super(distortion);
        this._distortion = distortion;
        this.amount = amount;
    }
    /** The amount of distortion to set. */ set amount(value) {
        this._amount = value;
        if ((0, $a4a95632c8795d75$export$8bedcca5bbd73999)().useLegacy) return;
        const scaledValue = value * 1e3;
        const samples = 44100;
        const curve = new Float32Array(samples);
        const deg = Math.PI / 180;
        let i = 0;
        let x;
        for(; i < samples; ++i){
            x = i * 2 / samples - 1;
            curve[i] = (3 + scaledValue) * x * 20 * deg / (Math.PI + scaledValue * Math.abs(x));
        }
        this._distortion.curve = curve;
        this._distortion.oversample = "4x";
    }
    get amount() {
        return this._amount;
    }
    destroy() {
        this._distortion = null;
        super.destroy();
    }
}




class $662264ced6fafb54$export$5caed31a857b7191 {
    /**
   * Dezippering is removed in the future Web Audio API, instead
   * we use the `setValueAtTime` method, however, this is not available
   * in all environments (e.g., Android webview), so we fallback to the `value` setter.
   * @param param - AudioNode parameter object
   * @param value - Value to set
   * @return The value set
   */ static setParamValue(param, value) {
        if (param.setValueAtTime) {
            const context = (0, $a4a95632c8795d75$export$8bedcca5bbd73999)().context;
            param.setValueAtTime(value, context.audioContext.currentTime);
        } else param.value = value;
        return value;
    }
}



const $3a603b247f1d4ece$var$_EqualizerFilter = class extends (0, $fc329676127dccbc$export$ec91da630f36d5ea) {
    /**
   * @param f32 - Default gain for 32 Hz
   * @param f64 - Default gain for 64 Hz
   * @param f125 - Default gain for 125 Hz
   * @param f250 - Default gain for 250 Hz
   * @param f500 - Default gain for 500 Hz
   * @param f1k - Default gain for 1000 Hz
   * @param f2k - Default gain for 2000 Hz
   * @param f4k - Default gain for 4000 Hz
   * @param f8k - Default gain for 8000 Hz
   * @param f16k - Default gain for 16000 Hz
   */ constructor(f32 = 0, f64 = 0, f125 = 0, f250 = 0, f500 = 0, f1k = 0, f2k = 0, f4k = 0, f8k = 0, f16k = 0){
        let bands = [];
        const equalizerBands = [
            {
                f: $3a603b247f1d4ece$var$_EqualizerFilter.F32,
                type: "lowshelf",
                gain: f32
            },
            {
                f: $3a603b247f1d4ece$var$_EqualizerFilter.F64,
                type: "peaking",
                gain: f64
            },
            {
                f: $3a603b247f1d4ece$var$_EqualizerFilter.F125,
                type: "peaking",
                gain: f125
            },
            {
                f: $3a603b247f1d4ece$var$_EqualizerFilter.F250,
                type: "peaking",
                gain: f250
            },
            {
                f: $3a603b247f1d4ece$var$_EqualizerFilter.F500,
                type: "peaking",
                gain: f500
            },
            {
                f: $3a603b247f1d4ece$var$_EqualizerFilter.F1K,
                type: "peaking",
                gain: f1k
            },
            {
                f: $3a603b247f1d4ece$var$_EqualizerFilter.F2K,
                type: "peaking",
                gain: f2k
            },
            {
                f: $3a603b247f1d4ece$var$_EqualizerFilter.F4K,
                type: "peaking",
                gain: f4k
            },
            {
                f: $3a603b247f1d4ece$var$_EqualizerFilter.F8K,
                type: "peaking",
                gain: f8k
            },
            {
                f: $3a603b247f1d4ece$var$_EqualizerFilter.F16K,
                type: "highshelf",
                gain: f16k
            }
        ];
        if (!(0, $a4a95632c8795d75$export$8bedcca5bbd73999)().useLegacy) bands = equalizerBands.map((band)=>{
            const node = (0, $a4a95632c8795d75$export$8bedcca5bbd73999)().context.audioContext.createBiquadFilter();
            node.type = band.type;
            (0, $662264ced6fafb54$export$5caed31a857b7191).setParamValue(node.Q, 1);
            node.frequency.value = band.f;
            (0, $662264ced6fafb54$export$5caed31a857b7191).setParamValue(node.gain, band.gain);
            return node;
        });
        super(bands[0], bands[bands.length - 1]);
        this.bands = bands;
        this.bandsMap = {};
        for(let i = 0; i < this.bands.length; i++){
            const node = this.bands[i];
            if (i > 0) this.bands[i - 1].connect(node);
            this.bandsMap[node.frequency.value] = node;
        }
    }
    /**
   * Set gain on a specific frequency.
   * @param frequency - The frequency, see EqualizerFilter.F* for bands
   * @param gain - Recommended -40 to 40.
   */ setGain(frequency, gain = 0) {
        if (!this.bandsMap[frequency]) throw new Error(`No band found for frequency ${frequency}`);
        (0, $662264ced6fafb54$export$5caed31a857b7191).setParamValue(this.bandsMap[frequency].gain, gain);
    }
    /**
   * Get gain amount on a specific frequency.
   * @return The amount of gain set.
   */ getGain(frequency) {
        if (!this.bandsMap[frequency]) throw new Error(`No band found for frequency ${frequency}`);
        return this.bandsMap[frequency].gain.value;
    }
    /**
   * Gain at 32 Hz frequencey.
   * @default 0
   */ set f32(value) {
        this.setGain($3a603b247f1d4ece$var$_EqualizerFilter.F32, value);
    }
    get f32() {
        return this.getGain($3a603b247f1d4ece$var$_EqualizerFilter.F32);
    }
    /**
   * Gain at 64 Hz frequencey.
   * @default 0
   */ set f64(value) {
        this.setGain($3a603b247f1d4ece$var$_EqualizerFilter.F64, value);
    }
    get f64() {
        return this.getGain($3a603b247f1d4ece$var$_EqualizerFilter.F64);
    }
    /**
   * Gain at 125 Hz frequencey.
   * @default 0
   */ set f125(value) {
        this.setGain($3a603b247f1d4ece$var$_EqualizerFilter.F125, value);
    }
    get f125() {
        return this.getGain($3a603b247f1d4ece$var$_EqualizerFilter.F125);
    }
    /**
   * Gain at 250 Hz frequencey.
   * @default 0
   */ set f250(value) {
        this.setGain($3a603b247f1d4ece$var$_EqualizerFilter.F250, value);
    }
    get f250() {
        return this.getGain($3a603b247f1d4ece$var$_EqualizerFilter.F250);
    }
    /**
   * Gain at 500 Hz frequencey.
   * @default 0
   */ set f500(value) {
        this.setGain($3a603b247f1d4ece$var$_EqualizerFilter.F500, value);
    }
    get f500() {
        return this.getGain($3a603b247f1d4ece$var$_EqualizerFilter.F500);
    }
    /**
   * Gain at 1 KHz frequencey.
   * @default 0
   */ set f1k(value) {
        this.setGain($3a603b247f1d4ece$var$_EqualizerFilter.F1K, value);
    }
    get f1k() {
        return this.getGain($3a603b247f1d4ece$var$_EqualizerFilter.F1K);
    }
    /**
   * Gain at 2 KHz frequencey.
   * @default 0
   */ set f2k(value) {
        this.setGain($3a603b247f1d4ece$var$_EqualizerFilter.F2K, value);
    }
    get f2k() {
        return this.getGain($3a603b247f1d4ece$var$_EqualizerFilter.F2K);
    }
    /**
   * Gain at 4 KHz frequencey.
   * @default 0
   */ set f4k(value) {
        this.setGain($3a603b247f1d4ece$var$_EqualizerFilter.F4K, value);
    }
    get f4k() {
        return this.getGain($3a603b247f1d4ece$var$_EqualizerFilter.F4K);
    }
    /**
   * Gain at 8 KHz frequencey.
   * @default 0
   */ set f8k(value) {
        this.setGain($3a603b247f1d4ece$var$_EqualizerFilter.F8K, value);
    }
    get f8k() {
        return this.getGain($3a603b247f1d4ece$var$_EqualizerFilter.F8K);
    }
    /**
   * Gain at 16 KHz frequencey.
   * @default 0
   */ set f16k(value) {
        this.setGain($3a603b247f1d4ece$var$_EqualizerFilter.F16K, value);
    }
    get f16k() {
        return this.getGain($3a603b247f1d4ece$var$_EqualizerFilter.F16K);
    }
    /** Reset all frequency bands to have gain of 0 */ reset() {
        this.bands.forEach((band)=>{
            (0, $662264ced6fafb54$export$5caed31a857b7191).setParamValue(band.gain, 0);
        });
    }
    destroy() {
        this.bands.forEach((band)=>{
            band.disconnect();
        });
        this.bands = null;
        this.bandsMap = null;
    }
};
let $3a603b247f1d4ece$export$da9588c63637d4bd = $3a603b247f1d4ece$var$_EqualizerFilter;
/**
 * Band at 32 Hz
 * @readonly
 */ $3a603b247f1d4ece$export$da9588c63637d4bd.F32 = 32;
/**
 * Band at 64 Hz
 * @readonly
 */ $3a603b247f1d4ece$export$da9588c63637d4bd.F64 = 64;
/**
 * Band at 125 Hz
 * @readonly
 */ $3a603b247f1d4ece$export$da9588c63637d4bd.F125 = 125;
/**
 * Band at 250 Hz
 * @readonly
 */ $3a603b247f1d4ece$export$da9588c63637d4bd.F250 = 250;
/**
 * Band at 500 Hz
 * @readonly
 */ $3a603b247f1d4ece$export$da9588c63637d4bd.F500 = 500;
/**
 * Band at 1000 Hz
 * @readonly
 */ $3a603b247f1d4ece$export$da9588c63637d4bd.F1K = 1e3;
/**
 * Band at 2000 Hz
 * @readonly
 */ $3a603b247f1d4ece$export$da9588c63637d4bd.F2K = 2e3;
/**
 * Band at 4000 Hz
 * @readonly
 */ $3a603b247f1d4ece$export$da9588c63637d4bd.F4K = 4e3;
/**
 * Band at 8000 Hz
 * @readonly
 */ $3a603b247f1d4ece$export$da9588c63637d4bd.F8K = 8e3;
/**
 * Band at 16000 Hz
 * @readonly
 */ $3a603b247f1d4ece$export$da9588c63637d4bd.F16K = 16e3;





class $760ea5d75d24137c$export$6237f62c652e6374 extends (0, $fc329676127dccbc$export$ec91da630f36d5ea) {
    constructor(){
        let merger;
        let splitter;
        if (!(0, $a4a95632c8795d75$export$8bedcca5bbd73999)().useLegacy) {
            const { audioContext: audioContext } = (0, $a4a95632c8795d75$export$8bedcca5bbd73999)().context;
            splitter = audioContext.createChannelSplitter();
            merger = audioContext.createChannelMerger();
            merger.connect(splitter);
        }
        super(merger, splitter);
        this._merger = merger;
    }
    destroy() {
        this._merger?.disconnect();
        this._merger = null;
        super.destroy();
    }
}




class $abf827643b0a756d$export$cbbc92373fb81e3b extends (0, $fc329676127dccbc$export$ec91da630f36d5ea) {
    /**
   * @param seconds - Seconds for reverb
   * @param decay - The decay length
   * @param reverse - Reverse reverb
   */ constructor(seconds = 3, decay = 2, reverse = false){
        super(null);
        this._seconds = this._clamp(seconds, 1, 50);
        this._decay = this._clamp(decay, 0, 100);
        this._reverse = reverse;
        this._rebuild();
    }
    /**
   * Clamp a value
   * @param value
   * @param min - Minimum value
   * @param max - Maximum value
   * @return Clamped number
   */ _clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
    }
    /**
   * Length of reverb in seconds from 1 to 50
   * @default 3
   */ get seconds() {
        return this._seconds;
    }
    set seconds(seconds) {
        this._seconds = this._clamp(seconds, 1, 50);
        this._rebuild();
    }
    /**
   * Decay value from 0 to 100
   * @default 2
   */ get decay() {
        return this._decay;
    }
    set decay(decay) {
        this._decay = this._clamp(decay, 0, 100);
        this._rebuild();
    }
    /**
   * Reverse value from 0 to 1
   * @default false
   */ get reverse() {
        return this._reverse;
    }
    set reverse(reverse) {
        this._reverse = reverse;
        this._rebuild();
    }
    /**
   * Utility function for building an impulse response
   * from the module parameters.
   */ _rebuild() {
        if ((0, $a4a95632c8795d75$export$8bedcca5bbd73999)().useLegacy) return;
        const { audioContext: audioContext } = (0, $a4a95632c8795d75$export$8bedcca5bbd73999)().context;
        const rate = audioContext.sampleRate;
        const length = rate * this._seconds;
        const impulse = audioContext.createBuffer(2, length, rate);
        const impulseL = impulse.getChannelData(0);
        const impulseR = impulse.getChannelData(1);
        let n;
        for(let i = 0; i < length; i++){
            n = this._reverse ? length - i : i;
            impulseL[i] = (Math.random() * 2 - 1) * Math.pow(1 - n / length, this._decay);
            impulseR[i] = (Math.random() * 2 - 1) * Math.pow(1 - n / length, this._decay);
        }
        const convolver = audioContext.createConvolver();
        convolver.buffer = impulse;
        this.init(convolver);
    }
}





class $fee9d437c599f38b$export$3f75220355fd576e extends (0, $fc329676127dccbc$export$ec91da630f36d5ea) {
    /** @param pan - The amount of panning, -1 is left, 1 is right, 0 is centered. */ constructor(pan = 0){
        let stereo;
        let panner;
        let destination;
        if (!(0, $a4a95632c8795d75$export$8bedcca5bbd73999)().useLegacy) {
            const { audioContext: audioContext } = (0, $a4a95632c8795d75$export$8bedcca5bbd73999)().context;
            if (audioContext.createStereoPanner) {
                stereo = audioContext.createStereoPanner();
                destination = stereo;
            } else {
                panner = audioContext.createPanner();
                panner.panningModel = "equalpower";
                destination = panner;
            }
        }
        super(destination);
        this._stereo = stereo;
        this._panner = panner;
        this.pan = pan;
    }
    /** Set the amount of panning, where -1 is left, 1 is right, and 0 is centered */ set pan(value) {
        this._pan = value;
        if (this._stereo) (0, $662264ced6fafb54$export$5caed31a857b7191).setParamValue(this._stereo.pan, value);
        else if (this._panner) this._panner.setPosition(value, 0, 1 - Math.abs(value));
    }
    get pan() {
        return this._pan;
    }
    destroy() {
        super.destroy();
        this._stereo = null;
        this._panner = null;
    }
}




class $cc3775206786ef82$export$a54bec6fd61dbe35 extends (0, $fc329676127dccbc$export$ec91da630f36d5ea) {
    constructor(){
        let destination;
        let source;
        if (!(0, $a4a95632c8795d75$export$8bedcca5bbd73999)().useLegacy) {
            const { audioContext: audioContext } = (0, $a4a95632c8795d75$export$8bedcca5bbd73999)().context;
            destination = audioContext.createMediaStreamDestination();
            source = audioContext.createMediaStreamSource(destination.stream);
        }
        super(destination, source);
        this._stream = destination?.stream;
    }
    get stream() {
        return this._stream;
    }
    destroy() {
        this._stream = null;
        super.destroy();
    }
}





class $cefd16cc14448c79$export$e75cce85db5659f7 extends (0, $fc329676127dccbc$export$ec91da630f36d5ea) {
    constructor(){
        let destination;
        let source;
        if (!(0, $a4a95632c8795d75$export$8bedcca5bbd73999)().useLegacy) {
            const { audioContext: audioContext } = (0, $a4a95632c8795d75$export$8bedcca5bbd73999)().context;
            const lpf1 = audioContext.createBiquadFilter();
            const lpf2 = audioContext.createBiquadFilter();
            const hpf1 = audioContext.createBiquadFilter();
            const hpf2 = audioContext.createBiquadFilter();
            lpf1.type = "lowpass";
            (0, $662264ced6fafb54$export$5caed31a857b7191).setParamValue(lpf1.frequency, 2e3);
            lpf2.type = "lowpass";
            (0, $662264ced6fafb54$export$5caed31a857b7191).setParamValue(lpf2.frequency, 2e3);
            hpf1.type = "highpass";
            (0, $662264ced6fafb54$export$5caed31a857b7191).setParamValue(hpf1.frequency, 500);
            hpf2.type = "highpass";
            (0, $662264ced6fafb54$export$5caed31a857b7191).setParamValue(hpf2.frequency, 500);
            lpf1.connect(lpf2);
            lpf2.connect(hpf1);
            hpf1.connect(hpf2);
            destination = lpf1;
            source = hpf2;
        }
        super(destination, source);
    }
}





var $gpXaq = parcelRequire("gpXaq");
class $1872b082f1ff739a$export$135605210c0a871c extends (0, (/*@__PURE__*/$parcel$interopDefault($gpXaq))) {
    constructor(){
        super(...arguments);
        /** Current global speed from 0 to 1 */ this.speed = 1;
        /** Current muted status of the context */ this.muted = false;
        /** Current volume from 0 to 1  */ this.volume = 1;
        /** Current paused status */ this.paused = false;
    }
    /** Internal trigger when volume, mute or speed changes */ refresh() {
        this.emit("refresh");
    }
    /** Internal trigger paused changes */ refreshPaused() {
        this.emit("refreshPaused");
    }
    /**
   * HTML Audio does not support filters, this is non-functional API.
   */ get filters() {
        console.warn("HTML Audio does not support filters");
        return null;
    }
    set filters(_filters) {
        console.warn("HTML Audio does not support filters");
    }
    /**
   * HTML Audio does not support `audioContext`
   * @readonly
   * @type {AudioContext}
   */ get audioContext() {
        console.warn("HTML Audio does not support audioContext");
        return null;
    }
    /**
   * Toggles the muted state.
   * @return The current muted state.
   */ toggleMute() {
        this.muted = !this.muted;
        this.refresh();
        return this.muted;
    }
    /**
   * Toggles the paused state.
   * @return The current paused state.
   */ togglePause() {
        this.paused = !this.paused;
        this.refreshPaused();
        return this.paused;
    }
    /** Destroy and don't use after this */ destroy() {
        this.removeAllListeners();
    }
}



var $4CJdx = parcelRequire("4CJdx");
var $gpXaq = parcelRequire("gpXaq");
let $95a9532458010ce6$var$id = 0;
const $95a9532458010ce6$var$_HTMLAudioInstance = class extends (0, (/*@__PURE__*/$parcel$interopDefault($gpXaq))) {
    /** @param parent - Parent element */ constructor(parent){
        super();
        this.id = $95a9532458010ce6$var$id++;
        this.init(parent);
    }
    /**
   * Set a property by name, this makes it easy to chain values
   * @param name - Name of the property to set
   * @param value - Value to set property to
   */ set(name, value) {
        if (this[name] === void 0) throw new Error(`Property with name ${name} does not exist.`);
        else switch(name){
            case "speed":
                this.speed = value;
                break;
            case "volume":
                this.volume = value;
                break;
            case "paused":
                this.paused = value;
                break;
            case "loop":
                this.loop = value;
                break;
            case "muted":
                this.muted = value;
                break;
        }
        return this;
    }
    /** The current playback progress from 0 to 1. */ get progress() {
        const { currentTime: currentTime } = this._source;
        return currentTime / this._duration;
    }
    /** Pauses the sound. */ get paused() {
        return this._paused;
    }
    set paused(paused) {
        this._paused = paused;
        this.refreshPaused();
    }
    /**
   * Reference: http://stackoverflow.com/a/40370077
   * @private
   */ _onPlay() {
        this._playing = true;
    }
    /**
   * Reference: http://stackoverflow.com/a/40370077
   * @private
   */ _onPause() {
        this._playing = false;
    }
    /**
   * Initialize the instance.
   * @param {htmlaudio.HTMLAudioMedia} media - Same as constructor
   */ init(media) {
        this._playing = false;
        this._duration = media.source.duration;
        const source = this._source = media.source.cloneNode(false);
        source.src = media.parent.url;
        source.onplay = this._onPlay.bind(this);
        source.onpause = this._onPause.bind(this);
        media.context.on("refresh", this.refresh, this);
        media.context.on("refreshPaused", this.refreshPaused, this);
        this._media = media;
    }
    /**
   * Stop the sound playing
   * @private
   */ _internalStop() {
        if (this._source && this._playing) {
            this._source.onended = null;
            this._source.pause();
        }
    }
    /** Stop the sound playing */ stop() {
        this._internalStop();
        if (this._source) this.emit("stop");
    }
    /** Set the instance speed from 0 to 1 */ get speed() {
        return this._speed;
    }
    set speed(speed) {
        this._speed = speed;
        this.refresh();
    }
    /** Get the set the volume for this instance from 0 to 1 */ get volume() {
        return this._volume;
    }
    set volume(volume) {
        this._volume = volume;
        this.refresh();
    }
    /** If the sound instance should loop playback */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        this._loop = loop;
        this.refresh();
    }
    /** `true` if the sound is muted */ get muted() {
        return this._muted;
    }
    set muted(muted) {
        this._muted = muted;
        this.refresh();
    }
    /**
   * HTML Audio does not support filters, this is non-functional API.
   */ get filters() {
        console.warn("HTML Audio does not support filters");
        return null;
    }
    set filters(_filters) {
        console.warn("HTML Audio does not support filters");
    }
    /** Call whenever the loop, speed or volume changes */ refresh() {
        const global = this._media.context;
        const sound = this._media.parent;
        this._source.loop = this._loop || sound.loop;
        const globalVolume = global.volume * (global.muted ? 0 : 1);
        const soundVolume = sound.volume * (sound.muted ? 0 : 1);
        const instanceVolume = this._volume * (this._muted ? 0 : 1);
        this._source.volume = instanceVolume * globalVolume * soundVolume;
        this._source.playbackRate = this._speed * global.speed * sound.speed;
    }
    /** Handle changes in paused state, either globally or sound or instance */ refreshPaused() {
        const global = this._media.context;
        const sound = this._media.parent;
        const pausedReal = this._paused || sound.paused || global.paused;
        if (pausedReal !== this._pausedReal) {
            this._pausedReal = pausedReal;
            if (pausedReal) {
                this._internalStop();
                this.emit("paused");
            } else {
                this.emit("resumed");
                this.play({
                    start: this._source.currentTime,
                    end: this._end,
                    volume: this._volume,
                    speed: this._speed,
                    loop: this._loop
                });
            }
            this.emit("pause", pausedReal);
        }
    }
    /** Start playing the sound/ */ play(options) {
        const { start: start, end: end, speed: speed, loop: loop, volume: volume, muted: muted } = options;
        if (end) console.assert(end > start, "End time is before start time");
        this._speed = speed;
        this._volume = volume;
        this._loop = !!loop;
        this._muted = muted;
        this.refresh();
        if (this.loop && end !== null) {
            console.warn('Looping not support when specifying an "end" time');
            this.loop = false;
        }
        this._start = start;
        this._end = end || this._duration;
        this._start = Math.max(0, this._start - $95a9532458010ce6$var$_HTMLAudioInstance.PADDING);
        this._end = Math.min(this._end + $95a9532458010ce6$var$_HTMLAudioInstance.PADDING, this._duration);
        this._source.onloadedmetadata = ()=>{
            if (this._source) {
                this._source.currentTime = start;
                this._source.onloadedmetadata = null;
                this.emit("progress", start, this._duration);
                (0, $4CJdx.Ticker).shared.add(this._onUpdate, this);
            }
        };
        this._source.onended = this._onComplete.bind(this);
        this._source.play();
        this.emit("start");
    }
    /**
   * Handle time update on sound.
   * @private
   */ _onUpdate() {
        this.emit("progress", this.progress, this._duration);
        if (this._source.currentTime >= this._end && !this._source.loop) this._onComplete();
    }
    /**
   * Callback when completed.
   * @private
   */ _onComplete() {
        (0, $4CJdx.Ticker).shared.remove(this._onUpdate, this);
        this._internalStop();
        this.emit("progress", 1, this._duration);
        this.emit("end", this);
    }
    /** Don't use after this. */ destroy() {
        (0, $4CJdx.Ticker).shared.remove(this._onUpdate, this);
        this.removeAllListeners();
        const source = this._source;
        if (source) {
            source.onended = null;
            source.onplay = null;
            source.onpause = null;
            this._internalStop();
        }
        this._source = null;
        this._speed = 1;
        this._volume = 1;
        this._loop = false;
        this._end = null;
        this._start = 0;
        this._duration = 0;
        this._playing = false;
        this._pausedReal = false;
        this._paused = false;
        this._muted = false;
        if (this._media) {
            this._media.context.off("refresh", this.refresh, this);
            this._media.context.off("refreshPaused", this.refreshPaused, this);
            this._media = null;
        }
    }
    /**
   * To string method for instance.
   * @return The string representation of instance.
   */ toString() {
        return `[HTMLAudioInstance id=${this.id}]`;
    }
};
let $95a9532458010ce6$export$5ba2228815fb4afb = $95a9532458010ce6$var$_HTMLAudioInstance;
/** Extra padding, in seconds, to deal with low-latecy of HTMLAudio. */ $95a9532458010ce6$export$5ba2228815fb4afb.PADDING = 0.1;



var $gpXaq = parcelRequire("gpXaq");

class $5dc14bfe4f3859c1$export$e5eedbe48857dcd extends (0, (/*@__PURE__*/$parcel$interopDefault($gpXaq))) {
    init(parent) {
        this.parent = parent;
        this._source = parent.options.source || new Audio();
        if (parent.url) this._source.src = parent.url;
    }
    // Implement create
    create() {
        return new (0, $95a9532458010ce6$export$5ba2228815fb4afb)(this);
    }
    /**
   * If the audio media is playable (ready).
   * @readonly
   */ get isPlayable() {
        return !!this._source && this._source.readyState === 4;
    }
    /**
   * THe duration of the media in seconds.
   * @readonly
   */ get duration() {
        return this._source.duration;
    }
    /**
   * Reference to the context.
   * @readonly
   */ get context() {
        return this.parent.context;
    }
    /** The collection of filters, does not apply to HTML Audio. */ get filters() {
        return null;
    }
    set filters(_filters) {
        console.warn("HTML Audio does not support filters");
    }
    // Override the destroy
    destroy() {
        this.removeAllListeners();
        this.parent = null;
        if (this._source) {
            this._source.src = "";
            this._source.load();
            this._source = null;
        }
    }
    /**
   * Get the audio source element.
   * @type {HTMLAudioElement}
   * @readonly
   */ get source() {
        return this._source;
    }
    // Implement the method to being preloading
    load(callback) {
        const source = this._source;
        const sound = this.parent;
        if (source.readyState === 4) {
            sound.isLoaded = true;
            const instance = sound.autoPlayStart();
            if (callback) setTimeout(()=>{
                callback(null, sound, instance);
            }, 0);
            return;
        }
        if (!sound.url) {
            callback(new Error("sound.url or sound.source must be set"));
            return;
        }
        source.src = sound.url;
        const onLoad = ()=>{
            removeListeners();
            sound.isLoaded = true;
            const instance = sound.autoPlayStart();
            if (callback) callback(null, sound, instance);
        };
        const onAbort = ()=>{
            removeListeners();
            if (callback) callback(new Error("Sound loading has been aborted"));
        };
        const onError = ()=>{
            removeListeners();
            const message = `Failed to load audio element (code: ${source.error.code})`;
            if (callback) callback(new Error(message));
            else console.error(message);
        };
        const removeListeners = ()=>{
            source.removeEventListener("canplaythrough", onLoad);
            source.removeEventListener("load", onLoad);
            source.removeEventListener("abort", onAbort);
            source.removeEventListener("error", onError);
        };
        source.addEventListener("canplaythrough", onLoad, false);
        source.addEventListener("load", onLoad, false);
        source.addEventListener("abort", onAbort, false);
        source.addEventListener("error", onError, false);
        source.load();
    }
}







var $6sETp = parcelRequire("6sETp");


class $ccab683a57754a98$export$fae5af5bab2ccf8 {
    /**
   * @param parent - The parent sound
   * @param options - Data associated with object.
   */ constructor(parent, options){
        this.parent = parent;
        Object.assign(this, options);
        this.duration = this.end - this.start;
        console.assert(this.duration > 0, "End time must be after start time");
    }
    /**
   * Play the sound sprite.
   * @param {Function} [complete] - Function call when complete
   * @return Sound instance being played.
   */ play(complete) {
        return this.parent.play({
            complete: complete,
            speed: this.speed || this.parent.speed,
            end: this.end,
            start: this.start,
            loop: this.loop
        });
    }
    /** Destroy and don't use after this */ destroy() {
        this.parent = null;
    }
}


const $fa1eb0234d458053$export$cc3e2d3244e01b7f = [
    "ogg",
    "oga",
    "opus",
    "m4a",
    "mp3",
    "mpeg",
    "wav",
    "aiff",
    "wma",
    "mid",
    "caf"
];
const $fa1eb0234d458053$export$8114c8bcb5760e77 = [
    "audio/mpeg",
    "audio/ogg"
];
const $fa1eb0234d458053$export$5f747a46dc0eb6ee = {};
function $fa1eb0234d458053$export$ca906cd9daab0e17(typeOverrides) {
    const overrides = {
        m4a: "audio/mp4",
        oga: "audio/ogg",
        opus: 'audio/ogg; codecs="opus"',
        caf: 'audio/x-caf; codecs="opus"',
        ...typeOverrides || {}
    };
    const audio = document.createElement("audio");
    const formats = {};
    const no = /^no$/;
    $fa1eb0234d458053$export$cc3e2d3244e01b7f.forEach((ext)=>{
        const canByExt = audio.canPlayType(`audio/${ext}`).replace(no, "");
        const canByType = overrides[ext] ? audio.canPlayType(overrides[ext]).replace(no, "") : "";
        formats[ext] = !!canByExt || !!canByType;
    });
    Object.assign($fa1eb0234d458053$export$5f747a46dc0eb6ee, formats);
}
$fa1eb0234d458053$export$ca906cd9daab0e17();



var $2NruG = parcelRequire("2NruG");

var $4CJdx = parcelRequire("4CJdx");
var $gpXaq = parcelRequire("gpXaq");

let $aa12cdbc4b1a1c00$var$id = 0;
class $aa12cdbc4b1a1c00$export$2af5ef044257da25 extends (0, (/*@__PURE__*/$parcel$interopDefault($gpXaq))) {
    constructor(media){
        super();
        this.id = $aa12cdbc4b1a1c00$var$id++;
        this._media = null;
        this._paused = false;
        this._muted = false;
        this._elapsed = 0;
        this.init(media);
    }
    /**
   * Set a property by name, this makes it easy to chain values
   * @param name - Name of the property to set.
   * @param value - Value to set property to.
   */ set(name, value) {
        if (this[name] === void 0) throw new Error(`Property with name ${name} does not exist.`);
        else switch(name){
            case "speed":
                this.speed = value;
                break;
            case "volume":
                this.volume = value;
                break;
            case "muted":
                this.muted = value;
                break;
            case "loop":
                this.loop = value;
                break;
            case "paused":
                this.paused = value;
                break;
        }
        return this;
    }
    /** Stops the instance, don't use after this. */ stop() {
        if (this._source) {
            this._internalStop();
            this.emit("stop");
        }
    }
    /** Set the instance speed from 0 to 1 */ get speed() {
        return this._speed;
    }
    set speed(speed) {
        this._speed = speed;
        this.refresh();
        this._update(true);
    }
    /** Get the set the volume for this instance from 0 to 1 */ get volume() {
        return this._volume;
    }
    set volume(volume) {
        this._volume = volume;
        this.refresh();
    }
    /** `true` if the sound is muted */ get muted() {
        return this._muted;
    }
    set muted(muted) {
        this._muted = muted;
        this.refresh();
    }
    /** If the sound instance should loop playback */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        this._loop = loop;
        this.refresh();
    }
    /** The collection of filters. */ get filters() {
        return this._filters;
    }
    set filters(filters) {
        if (this._filters) {
            this._filters?.filter((filter)=>filter).forEach((filter)=>filter.disconnect());
            this._filters = null;
            this._source.connect(this._gain);
        }
        this._filters = filters?.length ? filters.slice(0) : null;
        this.refresh();
    }
    /** Refresh loop, volume and speed based on changes to parent */ refresh() {
        if (!this._source) return;
        const global = this._media.context;
        const sound = this._media.parent;
        this._source.loop = this._loop || sound.loop;
        const globalVolume = global.volume * (global.muted ? 0 : 1);
        const soundVolume = sound.volume * (sound.muted ? 0 : 1);
        const instanceVolume = this._volume * (this._muted ? 0 : 1);
        (0, $662264ced6fafb54$export$5caed31a857b7191).setParamValue(this._gain.gain, instanceVolume * soundVolume * globalVolume);
        (0, $662264ced6fafb54$export$5caed31a857b7191).setParamValue(this._source.playbackRate, this._speed * sound.speed * global.speed);
        this.applyFilters();
    }
    /** Connect filters nodes to audio context */ applyFilters() {
        if (this._filters?.length) {
            this._source.disconnect();
            let source = this._source;
            this._filters.forEach((filter)=>{
                source.connect(filter.destination);
                source = filter;
            });
            source.connect(this._gain);
        }
    }
    /** Handle changes in paused state, either globally or sound or instance */ refreshPaused() {
        const global = this._media.context;
        const sound = this._media.parent;
        const pausedReal = this._paused || sound.paused || global.paused;
        if (pausedReal !== this._pausedReal) {
            this._pausedReal = pausedReal;
            if (pausedReal) {
                this._internalStop();
                this.emit("paused");
            } else {
                this.emit("resumed");
                this.play({
                    start: this._elapsed % this._duration,
                    end: this._end,
                    speed: this._speed,
                    loop: this._loop,
                    volume: this._volume
                });
            }
            this.emit("pause", pausedReal);
        }
    }
    /**
   * Plays the sound.
   * @param options - Play options.
   */ play(options) {
        const { start: start, end: end, speed: speed, loop: loop, volume: volume, muted: muted, filters: filters } = options;
        if (end) console.assert(end > start, "End time is before start time");
        this._paused = false;
        const { source: source, gain: gain } = this._media.nodes.cloneBufferSource();
        this._source = source;
        this._gain = gain;
        this._speed = speed;
        this._volume = volume;
        this._loop = !!loop;
        this._muted = muted;
        this._filters = filters;
        this.refresh();
        const duration = this._source.buffer.duration;
        this._duration = duration;
        this._end = end;
        this._lastUpdate = this._now();
        this._elapsed = start;
        this._source.onended = this._onComplete.bind(this);
        if (this._loop) {
            this._source.loopEnd = end;
            this._source.loopStart = start;
            this._source.start(0, start);
        } else if (end) this._source.start(0, start, end - start);
        else this._source.start(0, start);
        this.emit("start");
        this._update(true);
        this.enableTicker(true);
    }
    /** Start the update progress. */ enableTicker(enabled) {
        (0, $4CJdx.Ticker).shared.remove(this._updateListener, this);
        if (enabled) (0, $4CJdx.Ticker).shared.add(this._updateListener, this);
    }
    /** The current playback progress from 0 to 1. */ get progress() {
        return this._progress;
    }
    /** Pauses the sound. */ get paused() {
        return this._paused;
    }
    set paused(paused) {
        this._paused = paused;
        this.refreshPaused();
    }
    /** Don't use after this. */ destroy() {
        this.removeAllListeners();
        this._internalStop();
        if (this._gain) {
            this._gain.disconnect();
            this._gain = null;
        }
        if (this._media) {
            this._media.context.events.off("refresh", this.refresh, this);
            this._media.context.events.off("refreshPaused", this.refreshPaused, this);
            this._media = null;
        }
        this._filters?.forEach((filter)=>filter.disconnect());
        this._filters = null;
        this._end = null;
        this._speed = 1;
        this._volume = 1;
        this._loop = false;
        this._elapsed = 0;
        this._duration = 0;
        this._paused = false;
        this._muted = false;
        this._pausedReal = false;
    }
    /**
   * To string method for instance.
   * @return The string representation of instance.
   */ toString() {
        return `[WebAudioInstance id=${this.id}]`;
    }
    /**
   * Get the current time in seconds.
   * @return Seconds since start of context
   */ _now() {
        return this._media.context.audioContext.currentTime;
    }
    /** Callback for update listener */ _updateListener() {
        this._update();
    }
    /** Internal update the progress. */ _update(force = false) {
        if (this._source) {
            const now = this._now();
            const delta = now - this._lastUpdate;
            if (delta > 0 || force) {
                const speed = this._source.playbackRate.value;
                this._elapsed += delta * speed;
                this._lastUpdate = now;
                const duration = this._duration;
                let progress;
                if (this._source.loopStart) {
                    const soundLength = this._source.loopEnd - this._source.loopStart;
                    progress = (this._source.loopStart + this._elapsed % soundLength) / duration;
                } else progress = this._elapsed % duration / duration;
                this._progress = progress;
                this.emit("progress", this._progress, duration);
            }
        }
    }
    /** Initializes the instance. */ init(media) {
        this._media = media;
        media.context.events.on("refresh", this.refresh, this);
        media.context.events.on("refreshPaused", this.refreshPaused, this);
    }
    /** Stops the instance. */ _internalStop() {
        if (this._source) {
            this.enableTicker(false);
            this._source.onended = null;
            this._source.stop(0);
            this._source.disconnect();
            try {
                this._source.buffer = null;
            } catch (err) {
                console.warn("Failed to set AudioBufferSourceNode.buffer to null:", err);
            }
            this._source = null;
        }
    }
    /** Callback when completed. */ _onComplete() {
        if (this._source) {
            this.enableTicker(false);
            this._source.onended = null;
            this._source.disconnect();
            try {
                this._source.buffer = null;
            } catch (err) {
                console.warn("Failed to set AudioBufferSourceNode.buffer to null:", err);
            }
        }
        this._source = null;
        this._progress = 1;
        this.emit("progress", 1, this._duration);
        this.emit("end", this);
    }
}


class $3738067917da3fbd$export$d00e1c48fb621173 {
    /**
   * @param input - The source audio node
   * @param output - The output audio node
   */ constructor(input, output){
        this._output = output;
        this._input = input;
    }
    /** The destination output audio node */ get destination() {
        return this._input;
    }
    /** The collection of filters. */ get filters() {
        return this._filters;
    }
    set filters(filters) {
        if (this._filters) {
            this._filters.forEach((filter)=>{
                if (filter) filter.disconnect();
            });
            this._filters = null;
            this._input.connect(this._output);
        }
        if (filters && filters.length) {
            this._filters = filters.slice(0);
            this._input.disconnect();
            let prevFilter = null;
            filters.forEach((filter)=>{
                if (prevFilter === null) this._input.connect(filter.destination);
                else prevFilter.connect(filter.destination);
                prevFilter = filter;
            });
            prevFilter.connect(this._output);
        }
    }
    /** Cleans up. */ destroy() {
        this.filters = null;
        this._input = null;
        this._output = null;
    }
}



const $dc97339a5bcb5f66$var$_WebAudioNodes = class extends (0, $3738067917da3fbd$export$d00e1c48fb621173) {
    /**
   * @param context - The audio context.
   */ constructor(context){
        const audioContext = context.audioContext;
        const bufferSource = audioContext.createBufferSource();
        const gain = audioContext.createGain();
        const analyser = audioContext.createAnalyser();
        bufferSource.connect(analyser);
        analyser.connect(gain);
        gain.connect(context.destination);
        super(analyser, gain);
        this.context = context;
        this.bufferSource = bufferSource;
        this.gain = gain;
        this.analyser = analyser;
    }
    /**
   * Get the script processor node.
   * @readonly
   */ get script() {
        if (!this._script) {
            this._script = this.context.audioContext.createScriptProcessor($dc97339a5bcb5f66$var$_WebAudioNodes.BUFFER_SIZE);
            this._script.connect(this.context.destination);
        }
        return this._script;
    }
    /** Cleans up. */ destroy() {
        super.destroy();
        this.bufferSource.disconnect();
        if (this._script) this._script.disconnect();
        this.gain.disconnect();
        this.analyser.disconnect();
        this.bufferSource = null;
        this._script = null;
        this.gain = null;
        this.analyser = null;
        this.context = null;
    }
    /**
   * Clones the bufferSource. Used just before playing a sound.
   * @returns {SourceClone} The clone AudioBufferSourceNode.
   */ cloneBufferSource() {
        const orig = this.bufferSource;
        const source = this.context.audioContext.createBufferSource();
        source.buffer = orig.buffer;
        (0, $662264ced6fafb54$export$5caed31a857b7191).setParamValue(source.playbackRate, orig.playbackRate.value);
        source.loop = orig.loop;
        const gain = this.context.audioContext.createGain();
        source.connect(gain);
        gain.connect(this.destination);
        return {
            source: source,
            gain: gain
        };
    }
    /**
   * Get buffer size of `ScriptProcessorNode`.
   * @readonly
   */ get bufferSize() {
        return this.script.bufferSize;
    }
};
let $dc97339a5bcb5f66$export$b248c21a702795c4 = $dc97339a5bcb5f66$var$_WebAudioNodes;
/**
 * The buffer size for script processor, default is `0` which auto-detects. If you plan to use
 * script node on iOS, you'll need to provide a non-zero amount.
 * @default 0
 */ $dc97339a5bcb5f66$export$b248c21a702795c4.BUFFER_SIZE = 0;


class $42f36c7d048a5f26$export$9ea3865f5a7f2b06 {
    /**
   * Re-initialize without constructing.
   * @param parent - - Instance of parent Sound container
   */ init(parent) {
        this.parent = parent;
        this._nodes = new (0, $dc97339a5bcb5f66$export$b248c21a702795c4)(this.context);
        this._source = this._nodes.bufferSource;
        this.source = parent.options.source;
    }
    /** Destructor, safer to use `SoundLibrary.remove(alias)` to remove this sound. */ destroy() {
        this.parent = null;
        this._nodes.destroy();
        this._nodes = null;
        try {
            this._source.buffer = null;
        } catch (err) {
            console.warn("Failed to set AudioBufferSourceNode.buffer to null:", err);
        }
        this._source = null;
        this.source = null;
    }
    // Implement create
    create() {
        return new (0, $aa12cdbc4b1a1c00$export$2af5ef044257da25)(this);
    }
    // Implement context
    get context() {
        return this.parent.context;
    }
    // Implement isPlayable
    get isPlayable() {
        return !!this._source && !!this._source.buffer;
    }
    // Implement filters
    get filters() {
        return this._nodes.filters;
    }
    set filters(filters) {
        this._nodes.filters = filters;
    }
    // Implements duration
    get duration() {
        console.assert(this.isPlayable, "Sound not yet playable, no duration");
        return this._source.buffer.duration;
    }
    /** Gets and sets the buffer. */ get buffer() {
        return this._source.buffer;
    }
    set buffer(buffer) {
        this._source.buffer = buffer;
    }
    /** Get the current chained nodes object */ get nodes() {
        return this._nodes;
    }
    // Implements load
    load(callback) {
        if (this.source) this._decode(this.source, callback);
        else if (this.parent.url) this._loadUrl(callback);
        else if (callback) callback(new Error("sound.url or sound.source must be set"));
        else console.error("sound.url or sound.source must be set");
    }
    /** Loads a sound using XHMLHttpRequest object. */ async _loadUrl(callback) {
        const url = this.parent.url;
        const response = await (0, $2NruG.DOMAdapter).get().fetch(url);
        this._decode(await response.arrayBuffer(), callback);
    }
    /**
   * Decodes the array buffer.
   * @param arrayBuffer - From load.
   * @param {Function} callback - Callback optional
   */ _decode(arrayBuffer, callback) {
        const audioBufferReadyFn = (err, buffer)=>{
            if (err) {
                if (callback) callback(err);
            } else {
                this.parent.isLoaded = true;
                this.buffer = buffer;
                const instance = this.parent.autoPlayStart();
                if (callback) callback(null, this.parent, instance);
            }
        };
        if (arrayBuffer instanceof AudioBuffer) audioBufferReadyFn(null, arrayBuffer);
        else {
            const context = this.parent.context;
            context.decode(arrayBuffer, audioBufferReadyFn);
        }
    }
}


const $01970872f34cf625$var$_Sound = class {
    /**
   * Create a new sound instance from source.
   * @param source - Either the path or url to the source file.
   *        or the object of options to use.
   * @return Created sound instance.
   */ static from(source) {
        let options = {};
        if (typeof source === "string") options.url = source;
        else if (source instanceof ArrayBuffer || source instanceof AudioBuffer || source instanceof HTMLAudioElement) options.source = source;
        else if (Array.isArray(source)) options.url = source;
        else options = source;
        options = {
            autoPlay: false,
            singleInstance: false,
            url: null,
            source: null,
            preload: false,
            volume: 1,
            speed: 1,
            complete: null,
            loaded: null,
            loop: false,
            ...options
        };
        Object.freeze(options);
        const media = (0, $a4a95632c8795d75$export$8bedcca5bbd73999)().useLegacy ? new (0, $5dc14bfe4f3859c1$export$e5eedbe48857dcd)() : new (0, $42f36c7d048a5f26$export$9ea3865f5a7f2b06)();
        return new $01970872f34cf625$var$_Sound(media, options);
    }
    /**
   * Use `Sound.from`
   * @ignore
   */ constructor(media, options){
        this.media = media;
        this.options = options;
        this._instances = [];
        this._sprites = {};
        this.media.init(this);
        const complete = options.complete;
        this._autoPlayOptions = complete ? {
            complete: complete
        } : null;
        this.isLoaded = false;
        this._preloadQueue = null;
        this.isPlaying = false;
        this.autoPlay = options.autoPlay;
        this.singleInstance = options.singleInstance;
        this.preload = options.preload || this.autoPlay;
        this.url = Array.isArray(options.url) ? this.preferUrl(options.url) : options.url;
        this.speed = options.speed;
        this.volume = options.volume;
        this.loop = options.loop;
        if (options.sprites) this.addSprites(options.sprites);
        if (this.preload) this._preload(options.loaded);
    }
    /**
   * Internal help for resolving which file to use if there are multiple provide
   * this is especially helpful for working with bundlers (non Assets loading).
   */ preferUrl(urls) {
        const [file] = urls.map((url)=>({
                url: url,
                ext: (0, $6sETp.path).extname(url).slice(1)
            })).filter(({ ext: ext })=>(0, $fa1eb0234d458053$export$5f747a46dc0eb6ee)[ext]).sort((a, b)=>(0, $fa1eb0234d458053$export$cc3e2d3244e01b7f).indexOf(a.ext) - (0, $fa1eb0234d458053$export$cc3e2d3244e01b7f).indexOf(b.ext));
        if (!file) throw new Error("No supported file type found");
        return file.url;
    }
    /** Instance of the media context. */ get context() {
        return (0, $a4a95632c8795d75$export$8bedcca5bbd73999)().context;
    }
    /** Stops all the instances of this sound from playing. */ pause() {
        this.isPlaying = false;
        this.paused = true;
        return this;
    }
    /** Resuming all the instances of this sound from playing */ resume() {
        this.isPlaying = this._instances.length > 0;
        this.paused = false;
        return this;
    }
    /** Stops all the instances of this sound from playing. */ get paused() {
        return this._paused;
    }
    set paused(paused) {
        this._paused = paused;
        this.refreshPaused();
    }
    /** The playback rate. */ get speed() {
        return this._speed;
    }
    set speed(speed) {
        this._speed = speed;
        this.refresh();
    }
    /** Set the filters. Only supported with WebAudio. */ get filters() {
        return this.media.filters;
    }
    set filters(filters) {
        this.media.filters = filters;
    }
    /**
   * @ignore
   */ addSprites(source, data) {
        if (typeof source === "object") {
            const results = {};
            for(const alias in source)results[alias] = this.addSprites(alias, source[alias]);
            return results;
        }
        console.assert(!this._sprites[source], `Alias ${source} is already taken`);
        const sprite = new (0, $ccab683a57754a98$export$fae5af5bab2ccf8)(this, data);
        this._sprites[source] = sprite;
        return sprite;
    }
    /** Destructor, safer to use `SoundLibrary.remove(alias)` to remove this sound. */ destroy() {
        this._removeInstances();
        this.removeSprites();
        this.media.destroy();
        this.media = null;
        this._sprites = null;
        this._instances = null;
    }
    /**
   * Remove a sound sprite.
   * @param alias - The unique name of the sound sprite, if alias is omitted, removes all sprites.
   */ removeSprites(alias) {
        if (!alias) for(const name in this._sprites)this.removeSprites(name);
        else {
            const sprite = this._sprites[alias];
            if (sprite !== void 0) {
                sprite.destroy();
                delete this._sprites[alias];
            }
        }
        return this;
    }
    /** If the current sound is playable (loaded). */ get isPlayable() {
        return this.isLoaded && this.media && this.media.isPlayable;
    }
    /** Stops all the instances of this sound from playing. */ stop() {
        if (!this.isPlayable) {
            this.autoPlay = false;
            this._autoPlayOptions = null;
            return this;
        }
        this.isPlaying = false;
        for(let i = this._instances.length - 1; i >= 0; i--)this._instances[i].stop();
        return this;
    }
    // Overloaded function
    play(source, complete) {
        let options;
        if (typeof source === "string") {
            const sprite = source;
            options = {
                sprite: sprite,
                loop: this.loop,
                complete: complete
            };
        } else if (typeof source === "function") {
            options = {};
            options.complete = source;
        } else options = source;
        options = {
            complete: null,
            loaded: null,
            sprite: null,
            end: null,
            start: 0,
            volume: 1,
            speed: 1,
            muted: false,
            loop: false,
            ...options || {}
        };
        if (options.sprite) {
            const alias = options.sprite;
            console.assert(!!this._sprites[alias], `Alias ${alias} is not available`);
            const sprite = this._sprites[alias];
            options.start = sprite.start + (options.start || 0);
            options.end = sprite.end;
            options.speed = sprite.speed || 1;
            options.loop = sprite.loop || options.loop;
            delete options.sprite;
        }
        if (options.offset) options.start = options.offset;
        if (!this.isLoaded) {
            if (this._preloadQueue) return new Promise((resolve)=>{
                this._preloadQueue.push(()=>{
                    resolve(this.play(options));
                });
            });
            this._preloadQueue = [];
            this.autoPlay = true;
            this._autoPlayOptions = options;
            return new Promise((resolve, reject)=>{
                this._preload((err, sound, media)=>{
                    this._preloadQueue.forEach((resolve2)=>resolve2());
                    this._preloadQueue = null;
                    if (err) reject(err);
                    else {
                        if (options.loaded) options.loaded(err, sound, media);
                        resolve(media);
                    }
                });
            });
        }
        if (this.singleInstance || options.singleInstance) this._removeInstances();
        const instance = this._createInstance();
        this._instances.push(instance);
        this.isPlaying = true;
        instance.once("end", ()=>{
            if (options.complete) options.complete(this);
            this._onComplete(instance);
        });
        instance.once("stop", ()=>{
            this._onComplete(instance);
        });
        instance.play(options);
        return instance;
    }
    /** Internal only, speed, loop, volume change occured. */ refresh() {
        const len = this._instances.length;
        for(let i = 0; i < len; i++)this._instances[i].refresh();
    }
    /** Handle changes in paused state. Internal only. */ refreshPaused() {
        const len = this._instances.length;
        for(let i = 0; i < len; i++)this._instances[i].refreshPaused();
    }
    /** Gets and sets the volume. */ get volume() {
        return this._volume;
    }
    set volume(volume) {
        this._volume = volume;
        this.refresh();
    }
    /** Gets and sets the muted flag. */ get muted() {
        return this._muted;
    }
    set muted(muted) {
        this._muted = muted;
        this.refresh();
    }
    /** Gets and sets the looping. */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        this._loop = loop;
        this.refresh();
    }
    /** Starts the preloading of sound. */ _preload(callback) {
        this.media.load(callback);
    }
    /** Gets the list of instances that are currently being played of this sound. */ get instances() {
        return this._instances;
    }
    /** Get the map of sprites. */ get sprites() {
        return this._sprites;
    }
    /** Get the duration of the audio in seconds. */ get duration() {
        return this.media.duration;
    }
    /** Auto play the first instance. */ autoPlayStart() {
        let instance;
        if (this.autoPlay) instance = this.play(this._autoPlayOptions);
        return instance;
    }
    /** Removes all instances. */ _removeInstances() {
        for(let i = this._instances.length - 1; i >= 0; i--)this._poolInstance(this._instances[i]);
        this._instances.length = 0;
    }
    /**
   * Sound instance completed.
   * @param instance
   */ _onComplete(instance) {
        if (this._instances) {
            const index = this._instances.indexOf(instance);
            if (index > -1) this._instances.splice(index, 1);
            this.isPlaying = this._instances.length > 0;
        }
        this._poolInstance(instance);
    }
    /** Create a new instance. */ _createInstance() {
        if ($01970872f34cf625$var$_Sound._pool.length > 0) {
            const instance = $01970872f34cf625$var$_Sound._pool.pop();
            instance.init(this.media);
            return instance;
        }
        return this.media.create();
    }
    /**
   * Destroy/recycling the instance object.
   * @param instance - Instance to recycle
   */ _poolInstance(instance) {
        instance.destroy();
        if ($01970872f34cf625$var$_Sound._pool.indexOf(instance) < 0) $01970872f34cf625$var$_Sound._pool.push(instance);
    }
};
let $01970872f34cf625$export$85990f0f98a390bb = $01970872f34cf625$var$_Sound;
/** Pool of instances */ $01970872f34cf625$export$85990f0f98a390bb._pool = [];



var $gpXaq = parcelRequire("gpXaq");

class $c913ce4ef3905112$export$25289944de7a55e4 extends (0, $3738067917da3fbd$export$d00e1c48fb621173) {
    constructor(){
        const win = window;
        const ctx = new $c913ce4ef3905112$export$25289944de7a55e4.AudioContext();
        const compressor = ctx.createDynamicsCompressor();
        const analyser = ctx.createAnalyser();
        analyser.connect(compressor);
        compressor.connect(ctx.destination);
        super(analyser, compressor);
        /** Set to false ignore suspending when window is blurred */ this.autoPause = true;
        this._ctx = ctx;
        this._offlineCtx = new $c913ce4ef3905112$export$25289944de7a55e4.OfflineAudioContext(1, 2, win.OfflineAudioContext ? Math.max(8e3, Math.min(96e3, ctx.sampleRate)) : 44100);
        this.compressor = compressor;
        this.analyser = analyser;
        this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($gpXaq)))();
        this.volume = 1;
        this.speed = 1;
        this.muted = false;
        this.paused = false;
        this._locked = ctx.state === "suspended" && ("ontouchstart" in globalThis || "onclick" in globalThis);
        if (this._locked) {
            this._unlock();
            this._unlock = this._unlock.bind(this);
            document.addEventListener("mousedown", this._unlock, true);
            document.addEventListener("touchstart", this._unlock, true);
            document.addEventListener("touchend", this._unlock, true);
        }
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        globalThis.addEventListener("focus", this.onFocus);
        globalThis.addEventListener("blur", this.onBlur);
    }
    /** Handle mobile WebAudio context resume */ onFocus() {
        if (!this.autoPause) return;
        const state = this._ctx.state;
        if (state === "suspended" || state === "interrupted" || !this._locked) {
            this.paused = this._pausedOnBlur;
            this.refreshPaused();
        }
    }
    /** Handle mobile WebAudio context suspend */ onBlur() {
        if (!this.autoPause) return;
        if (!this._locked) {
            this._pausedOnBlur = this._paused;
            this.paused = true;
            this.refreshPaused();
        }
    }
    /**
   * Try to unlock audio on iOS. This is triggered from either WebAudio plugin setup (which will work if inside of
   * a `mousedown` or `touchend` event stack), or the first document touchend/mousedown event. If it fails (touchend
   * will fail if the user presses for too long, indicating a scroll event instead of a click event.
   *
   * Note that earlier versions of iOS supported `touchstart` for this, but iOS9 removed this functionality. Adding
   * a `touchstart` event to support older platforms may preclude a `mousedown` even from getting fired on iOS9, so we
   * stick with `mousedown` and `touchend`.
   */ _unlock() {
        if (!this._locked) return;
        this.playEmptySound();
        if (this._ctx.state === "running") {
            document.removeEventListener("mousedown", this._unlock, true);
            document.removeEventListener("touchend", this._unlock, true);
            document.removeEventListener("touchstart", this._unlock, true);
            this._locked = false;
        }
    }
    /**
   * Plays an empty sound in the web audio context.  This is used to enable web audio on iOS devices, as they
   * require the first sound to be played inside of a user initiated event (touch/click).
   */ playEmptySound() {
        const source = this._ctx.createBufferSource();
        source.buffer = this._ctx.createBuffer(1, 1, 22050);
        source.connect(this._ctx.destination);
        source.start(0, 0, 0);
        if (source.context.state === "suspended") source.context.resume();
    }
    /**
   * Get AudioContext class, if not supported returns `null`
   * @type {AudioContext}
   * @readonly
   */ static get AudioContext() {
        const win = window;
        return win.AudioContext || win.webkitAudioContext || null;
    }
    /**
   * Get OfflineAudioContext class, if not supported returns `null`
   * @type {OfflineAudioContext}
   * @readonly
   */ static get OfflineAudioContext() {
        const win = window;
        return win.OfflineAudioContext || win.webkitOfflineAudioContext || null;
    }
    /** Destroy this context. */ destroy() {
        super.destroy();
        const ctx = this._ctx;
        if (typeof ctx.close !== "undefined") ctx.close();
        globalThis.removeEventListener("focus", this.onFocus);
        globalThis.removeEventListener("blur", this.onBlur);
        this.events.removeAllListeners();
        this.analyser.disconnect();
        this.compressor.disconnect();
        this.analyser = null;
        this.compressor = null;
        this.events = null;
        this._offlineCtx = null;
        this._ctx = null;
    }
    /**
   * The WebAudio API AudioContext object.
   * @readonly
   * @type {AudioContext}
   */ get audioContext() {
        return this._ctx;
    }
    /**
   * The WebAudio API OfflineAudioContext object.
   * @readonly
   * @type {OfflineAudioContext}
   */ get offlineContext() {
        return this._offlineCtx;
    }
    /**
   * Pauses all sounds, even though we handle this at the instance
   * level, we'll also pause the audioContext so that the
   * time used to compute progress isn't messed up.
   * @default false
   */ set paused(paused) {
        if (paused && this._ctx.state === "running") this._ctx.suspend();
        else if (!paused && this._ctx.state === "suspended") this._ctx.resume();
        this._paused = paused;
    }
    get paused() {
        return this._paused;
    }
    /** Emit event when muted, volume or speed changes */ refresh() {
        this.events.emit("refresh");
    }
    /** Emit event when muted, volume or speed changes */ refreshPaused() {
        this.events.emit("refreshPaused");
    }
    /**
   * Toggles the muted state.
   * @return The current muted state.
   */ toggleMute() {
        this.muted = !this.muted;
        this.refresh();
        return this.muted;
    }
    /**
   * Toggles the paused state.
   * @return The current muted state.
   */ togglePause() {
        this.paused = !this.paused;
        this.refreshPaused();
        return this._paused;
    }
    /**
   * Decode the audio data
   * @param arrayBuffer - Buffer from loader
   * @param callback - When completed, error and audioBuffer are parameters.
   */ decode(arrayBuffer, callback) {
        const handleError = (err)=>{
            callback(new Error(err?.message || "Unable to decode file"));
        };
        const result = this._offlineCtx.decodeAudioData(arrayBuffer, (buffer)=>{
            callback(null, buffer);
        }, handleError);
        if (result) result.catch(handleError);
    }
}


class $27be23e45c62f885$export$8f62fda960fa1546 {
    constructor(){
        this.init();
    }
    /**
   * Re-initialize the sound library, this will
   * recreate the AudioContext. If there's a hardware-failure
   * call `close` and then `init`.
   * @return Sound instance
   */ init() {
        if (this.supported) this._webAudioContext = new (0, $c913ce4ef3905112$export$25289944de7a55e4)();
        this._htmlAudioContext = new (0, $1872b082f1ff739a$export$135605210c0a871c)();
        this._sounds = {};
        this.useLegacy = !this.supported;
        return this;
    }
    /**
   * The global context to use.
   * @readonly
   */ get context() {
        return this._context;
    }
    /**
   * Apply filters to all sounds. Can be useful
   * for setting global planning or global effects.
   * **Only supported with WebAudio.**
   * @example
   * import { sound, filters } from '@pixi/sound';
   * // Adds a filter to pan all output left
   * sound.filtersAll = [
   *     new filters.StereoFilter(-1)
   * ];
   */ get filtersAll() {
        if (!this.useLegacy) return this._context.filters;
        return [];
    }
    set filtersAll(filtersAll) {
        if (!this.useLegacy) this._context.filters = filtersAll;
    }
    /**
   * `true` if WebAudio is supported on the current browser.
   */ get supported() {
        return (0, $c913ce4ef3905112$export$25289944de7a55e4).AudioContext !== null;
    }
    /**
   * @ignore
   */ add(source, sourceOptions) {
        if (typeof source === "object") {
            const results = {};
            for(const alias in source){
                const options2 = this._getOptions(source[alias], sourceOptions);
                results[alias] = this.add(alias, options2);
            }
            return results;
        }
        console.assert(!this._sounds[source], `Sound with alias ${source} already exists.`);
        if (sourceOptions instanceof (0, $01970872f34cf625$export$85990f0f98a390bb)) {
            this._sounds[source] = sourceOptions;
            return sourceOptions;
        }
        const options = this._getOptions(sourceOptions);
        const sound = (0, $01970872f34cf625$export$85990f0f98a390bb).from(options);
        this._sounds[source] = sound;
        return sound;
    }
    /**
   * Internal methods for getting the options object
   * @private
   * @param source - The source options
   * @param overrides - Override default options
   * @return The construction options
   */ _getOptions(source, overrides) {
        let options;
        if (typeof source === "string") options = {
            url: source
        };
        else if (Array.isArray(source)) options = {
            url: source
        };
        else if (source instanceof ArrayBuffer || source instanceof AudioBuffer || source instanceof HTMLAudioElement) options = {
            source: source
        };
        else options = source;
        options = {
            ...options,
            ...overrides || {}
        };
        return options;
    }
    /**
   * Do not use WebAudio, force the use of legacy. This **must** be called before loading any files.
   */ get useLegacy() {
        return this._useLegacy;
    }
    set useLegacy(legacy) {
        this._useLegacy = legacy;
        this._context = !legacy && this.supported ? this._webAudioContext : this._htmlAudioContext;
    }
    /**
   * This disables auto-pause all playback when the window blurs (WebAudio only).
   * This is helpful to keep from playing sounds when the user switches tabs.
   * However, if you're running content within an iframe, this may be undesirable
   * and you should disable (set to `true`) this behavior.
   * @default false
   */ get disableAutoPause() {
        return !this._webAudioContext.autoPause;
    }
    set disableAutoPause(autoPause) {
        this._webAudioContext.autoPause = !autoPause;
    }
    /**
   * Removes a sound by alias.
   * @param alias - The sound alias reference.
   * @return Instance for chaining.
   */ remove(alias) {
        this.exists(alias, true);
        this._sounds[alias].destroy();
        delete this._sounds[alias];
        return this;
    }
    /**
   * Set the global volume for all sounds. To set per-sound volume see {@link SoundLibrary#volume}.
   */ get volumeAll() {
        return this._context.volume;
    }
    set volumeAll(volume) {
        this._context.volume = volume;
        this._context.refresh();
    }
    /**
   * Set the global speed for all sounds. To set per-sound speed see {@link SoundLibrary#speed}.
   */ get speedAll() {
        return this._context.speed;
    }
    set speedAll(speed) {
        this._context.speed = speed;
        this._context.refresh();
    }
    /**
   * Toggle paused property for all sounds.
   * @return `true` if all sounds are paused.
   */ togglePauseAll() {
        return this._context.togglePause();
    }
    /**
   * Pauses any playing sounds.
   * @return Instance for chaining.
   */ pauseAll() {
        this._context.paused = true;
        this._context.refreshPaused();
        return this;
    }
    /**
   * Resumes any sounds.
   * @return Instance for chaining.
   */ resumeAll() {
        this._context.paused = false;
        this._context.refreshPaused();
        return this;
    }
    /**
   * Toggle muted property for all sounds.
   * @return `true` if all sounds are muted.
   */ toggleMuteAll() {
        return this._context.toggleMute();
    }
    /**
   * Mutes all playing sounds.
   * @return Instance for chaining.
   */ muteAll() {
        this._context.muted = true;
        this._context.refresh();
        return this;
    }
    /**
   * Unmutes all playing sounds.
   * @return Instance for chaining.
   */ unmuteAll() {
        this._context.muted = false;
        this._context.refresh();
        return this;
    }
    /**
   * Stops and removes all sounds. They cannot be used after this.
   * @return Instance for chaining.
   */ removeAll() {
        for(const alias in this._sounds){
            this._sounds[alias].destroy();
            delete this._sounds[alias];
        }
        return this;
    }
    /**
   * Stops all sounds.
   * @return Instance for chaining.
   */ stopAll() {
        for(const alias in this._sounds)this._sounds[alias].stop();
        return this;
    }
    /**
   * Checks if a sound by alias exists.
   * @param alias - Check for alias.
   * @param assert - Whether enable console.assert.
   * @return true if the sound exists.
   */ exists(alias, assert = false) {
        const exists = !!this._sounds[alias];
        if (assert) console.assert(exists, `No sound matching alias '${alias}'.`);
        return exists;
    }
    /**
   * Convenience function to check to see if any sound is playing.
   * @returns `true` if any sound is currently playing.
   */ isPlaying() {
        for(const alias in this._sounds){
            if (this._sounds[alias].isPlaying) return true;
        }
        return false;
    }
    /**
   * Find a sound by alias.
   * @param alias - The sound alias reference.
   * @return Sound object.
   */ find(alias) {
        this.exists(alias, true);
        return this._sounds[alias];
    }
    /**
   * Plays a sound.
   * @method play
   * @instance
   * @param {string} alias - The sound alias reference.
   * @param {string} sprite - The alias of the sprite to play.
   * @return {IMediaInstance|null} The sound instance, this cannot be reused
   *         after it is done playing. Returns `null` if the sound has not yet loaded.
   */ /**
   * Plays a sound.
   * @param alias - The sound alias reference.
   * @param {PlayOptions|Function} options - The options or callback when done.
   * @return The sound instance,
   *        this cannot be reused after it is done playing. Returns a Promise if the sound
   *        has not yet loaded.
   */ play(alias, options) {
        return this.find(alias).play(options);
    }
    /**
   * Stops a sound.
   * @param alias - The sound alias reference.
   * @return Sound object.
   */ stop(alias) {
        return this.find(alias).stop();
    }
    /**
   * Pauses a sound.
   * @param alias - The sound alias reference.
   * @return Sound object.
   */ pause(alias) {
        return this.find(alias).pause();
    }
    /**
   * Resumes a sound.
   * @param alias - The sound alias reference.
   * @return Instance for chaining.
   */ resume(alias) {
        return this.find(alias).resume();
    }
    /**
   * Get or set the volume for a sound.
   * @param alias - The sound alias reference.
   * @param volume - Optional current volume to set.
   * @return The current volume.
   */ volume(alias, volume) {
        const sound = this.find(alias);
        if (volume !== void 0) sound.volume = volume;
        return sound.volume;
    }
    /**
   * Get or set the speed for a sound.
   * @param alias - The sound alias reference.
   * @param speed - Optional current speed to set.
   * @return The current speed.
   */ speed(alias, speed) {
        const sound = this.find(alias);
        if (speed !== void 0) sound.speed = speed;
        return sound.speed;
    }
    /**
   * Get the length of a sound in seconds.
   * @param alias - The sound alias reference.
   * @return The current duration in seconds.
   */ duration(alias) {
        return this.find(alias).duration;
    }
    /**
   * Closes the sound library. This will release/destroy
   * the AudioContext(s). Can be used safely if you want to
   * initialize the sound library later. Use `init` method.
   */ close() {
        this.removeAll();
        this._sounds = null;
        if (this._webAudioContext) {
            this._webAudioContext.destroy();
            this._webAudioContext = null;
        }
        if (this._htmlAudioContext) {
            this._htmlAudioContext.destroy();
            this._htmlAudioContext = null;
        }
        this._context = null;
        return this;
    }
}



let $d3ca7b4802e69f38$export$75d5873f93626b73 = 0;
function $d3ca7b4802e69f38$export$24b8a725481a84c8(url, callback) {
    const alias = `alias${$d3ca7b4802e69f38$export$75d5873f93626b73++}`;
    (0, $a4a95632c8795d75$export$8bedcca5bbd73999)().add(alias, {
        url: url,
        preload: true,
        autoPlay: true,
        loaded: (err)=>{
            if (err) {
                console.error(err);
                (0, $a4a95632c8795d75$export$8bedcca5bbd73999)().remove(alias);
                if (callback) callback(err);
            }
        },
        complete: ()=>{
            (0, $a4a95632c8795d75$export$8bedcca5bbd73999)().remove(alias);
            if (callback) callback(null);
        }
    });
    return alias;
}



var $keToW = parcelRequire("keToW");

function $b201a14e5b143438$export$b3890eb0ae9dca99(sound, options) {
    const canvas = document.createElement("canvas");
    options = {
        width: 512,
        height: 128,
        fill: "black",
        ...options || {}
    };
    canvas.width = options.width;
    canvas.height = options.height;
    const textureSource = new (0, $keToW.CanvasSource)({
        resource: canvas
    });
    if (!(sound.media instanceof (0, $42f36c7d048a5f26$export$9ea3865f5a7f2b06))) return textureSource;
    const media = sound.media;
    console.assert(!!media.buffer, "No buffer found, load first");
    const context = canvas.getContext("2d");
    context.fillStyle = options.fill;
    const data = media.buffer.getChannelData(0);
    const step = Math.ceil(data.length / options.width);
    const amp = options.height / 2;
    for(let i = 0; i < options.width; i++){
        let min = 1;
        let max = -1;
        for(let j = 0; j < step; j++){
            const datum = data[i * step + j];
            if (datum < min) min = datum;
            if (datum > max) max = datum;
        }
        context.fillRect(i, (1 + min) * amp, 1, Math.max(1, (max - min) * amp));
    }
    return textureSource;
}




function $9789391ee865248a$export$174af12dde0cc01(hertz = 200, seconds = 1) {
    const sound = (0, $01970872f34cf625$export$85990f0f98a390bb).from({
        singleInstance: true
    });
    if (!(sound.media instanceof (0, $42f36c7d048a5f26$export$9ea3865f5a7f2b06))) return sound;
    const media = sound.media;
    const context = sound.context;
    const nChannels = 1;
    const sampleRate = 48e3;
    const amplitude = 2;
    const buffer = context.audioContext.createBuffer(nChannels, seconds * sampleRate, sampleRate);
    const fArray = buffer.getChannelData(0);
    for(let i = 0; i < fArray.length; i++){
        const time = i / buffer.sampleRate;
        const angle = hertz * time * 2 * Math.PI;
        fArray[i] = Math.sin(angle) * amplitude;
    }
    media.buffer = buffer;
    sound.isLoaded = true;
    return sound;
}
















var $6sETp = parcelRequire("6sETp");
var $aqljF = parcelRequire("aqljF");
var $9uHEw = parcelRequire("9uHEw");



const $91735897ac640fc6$var$getAlias = (asset)=>{
    const src = asset.src;
    let alias = asset?.alias?.[0];
    if (!alias || asset.src === alias) alias = (0, $6sETp.path).basename(src, (0, $6sETp.path).extname(src));
    return alias;
};
const $91735897ac640fc6$export$ac5ef27803a8e50 = {
    extension: (0, $aqljF.ExtensionType).Asset,
    detection: {
        test: async ()=>true,
        add: async (formats)=>[
                ...formats,
                ...(0, $fa1eb0234d458053$export$cc3e2d3244e01b7f).filter((ext)=>(0, $fa1eb0234d458053$export$5f747a46dc0eb6ee)[ext])
            ],
        remove: async (formats)=>formats.filter((ext)=>formats.includes(ext))
    },
    loader: {
        name: "sound",
        extension: {
            type: [
                (0, $aqljF.ExtensionType).LoadParser
            ],
            priority: (0, $9uHEw.LoaderParserPriority).High
        },
        /** Should we attempt to load this file? */ test (url) {
            const ext = (0, $6sETp.path).extname(url).slice(1);
            return !!(0, $fa1eb0234d458053$export$5f747a46dc0eb6ee)[ext] || (0, $fa1eb0234d458053$export$8114c8bcb5760e77).some((mime)=>url.startsWith(`data:${mime}`));
        },
        /** Load the sound file, this is mostly handled by Sound.from() */ async load (url, asset) {
            const sound = await new Promise((resolve, reject)=>(0, $01970872f34cf625$export$85990f0f98a390bb).from({
                    ...asset.data,
                    url: url,
                    preload: true,
                    loaded (err, sound2) {
                        if (err) reject(err);
                        else resolve(sound2);
                        asset.data?.loaded?.(err, sound2);
                    }
                }));
            (0, $a4a95632c8795d75$export$8bedcca5bbd73999)().add($91735897ac640fc6$var$getAlias(asset), sound);
            return sound;
        },
        /** Remove the sound from the library */ async unload (_sound, asset) {
            (0, $a4a95632c8795d75$export$8bedcca5bbd73999)().remove($91735897ac640fc6$var$getAlias(asset));
        }
    }
};
(0, $aqljF.extensions).add($91735897ac640fc6$export$ac5ef27803a8e50);



const $a5a2646157cfe94d$export$eab32dcfc4ded11c = (0, $a4a95632c8795d75$export$7fbc60ba12697434)(new (0, $27be23e45c62f885$export$8f62fda960fa1546)());


class $52837665fc953d6d$export$2e2bcd8739ae039 extends (0, $a03da0212fa80d5e$export$2e2bcd8739ae039) {
    constructor(items){
        super();
        this.items = items;
        this.items.forEach((i)=>{
            i.stack = this;
        });
        this.eventMode = "dynamic";
        this.addFilter("deck-details", new (0, $e234fabd83f60df8$export$57214e398098d4e3)({
            offset: {
                x: 0,
                y: this.items.length * 2 * gm.camera.scale.x
            },
            color: 0xcccccc,
            blur: 0,
            alpha: 1
        }));
        this.canStack = true;
        this.on("destroyed", ()=>{
            this.items.forEach((item)=>item.destroy());
        });
        this.on("pointerdown", ()=>{
            this.onDragStart();
        });
        this.on("pointerup", ()=>{
            if (gm.dragInfo.isDragging) gm.targets.forEach((target)=>{
                if (target && (0, $713f438c8484fefc$export$e2d8d536c8fc9c6f)(target)) {
                    const objectToStack = target;
                    this.onStack(objectToStack);
                    gm.room.send({
                        type: "stack-object",
                        message: {
                            target: this.id,
                            object_to_stack: objectToStack.id
                        }
                    });
                }
            });
        });
        this.currentGraphics = new (0, $j5g5m.Sprite)();
        this.currentGraphics.anchor.x = 0.5;
        this.currentGraphics.anchor.y = 0.5;
        this.addChild(this.currentGraphics);
        this.updateGraphics();
        this.mmask = new (0, $8VCQS.Graphics)().roundRect(-this.currentGraphics.width / 2, -this.currentGraphics.height / 2, this.currentGraphics.width, this.currentGraphics.height, 10).fill(0xfff);
        this.addChild(this.mmask);
        this.currentGraphics.mask = this.mmask;
        this.updateGraphics();
    }
    roll(randSeeded) {
        for(var i = this.items.length - 1; i > 0; i--){
            var j = Math.floor(randSeeded() * (i + 1));
            var temp = this.items[i];
            this.items[i] = this.items[j];
            this.items[j] = temp;
        }
        (0, $a5a2646157cfe94d$export$eab32dcfc4ded11c).play("shuffle");
        this.updateGraphics();
    }
    flip() {
        this.items.forEach((i)=>{
            if ((0, $1f0ef112743f5763$export$bf29a109eabc0057)(i)) i.flip();
        });
        this.items.reverse();
        this.updateGraphics();
    }
    updateGraphics() {
        this.currentGraphics.texture = this.items[this.items.length - 1].currentGraphics.texture;
        this.currentGraphics.y = -this.items.length * 2;
        if (this.mmask) this.mmask.y = -this.items.length * 2;
        this.currentGraphics.width = this.items[this.items.length - 1].width;
        this.currentGraphics.height = this.items[this.items.length - 1].height;
        const deckFilter = this.filtersMap.get("deck-details");
        if (deckFilter) deckFilter._offset.y = this.items.length * 2;
    }
    onTakeFromStack(item, point) {
        const itemIndex = this.items.findIndex((i)=>i.id === item.id);
        this.items.splice(itemIndex, 1);
        this.updateGraphics();
        item.stack = null;
        item.x = this.x;
        item.y = this.y - this.items.length * 2;
        item.desiredPosition.x = point.x;
        item.desiredPosition.y = point.y;
        item.angle = this.angle;
        gm.camera.addChild(item);
        if (this.items.length === 1) {
            const lastItem = this.items.pop();
            lastItem.stack = null;
            lastItem.x = this.x;
            lastItem.y = this.y;
            lastItem.desiredPosition.x = this.x;
            lastItem.desiredPosition.y = this.y;
            lastItem.angle = this.angle;
            gm.camera.addChild(lastItem);
        }
        if (this.items.length === 0) this.destroy();
        return item || null;
    }
    getItems() {
        return this.items;
    }
    onDragStart() {
        if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("shift") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).HELD) {
            gm.onDragStart(this);
            return;
        }
        const top = this.items[this.items.length - 1];
        if (top) {
            const mouseWorldPos = gm.camera.screenToWorldPoint((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.mouse.position);
            const item = this.onTakeFromStack(top, mouseWorldPos);
            if (item) gm.room.send({
                type: "take-object-from-stack",
                message: {
                    target: this.id,
                    object_from_stack: item.id,
                    point: mouseWorldPos
                }
            });
            if ((0, $e3e0d3802040b351$export$5d532f06a6d2ef56)(item)) item.onDragStart();
        }
    }
    onDrag() {}
    onDragEnd() {}
    onStack(item) {
        const newItems = item.getItems();
        newItems.forEach((i)=>i.stack = this);
        this.items.push(...newItems);
        gm.targets = gm.targets.filter((i)=>{
            if ((0, $713f438c8484fefc$export$e2d8d536c8fc9c6f)(i)) return i.stack === null;
            return true;
        });
        this.updateGraphics();
        item.removeFromParent();
        if (item instanceof $52837665fc953d6d$export$2e2bcd8739ae039) {
            item.items = [];
            item.destroy();
        }
        return this;
    }
    serialize() {
        return {
            ...super.serialize(),
            type: "stack",
            items: this.items.map((i)=>i.id)
        };
    }
    toString() {
        return "" + this.items.length;
    }
    reloadTextures() {
        this.currentGraphics.texture = (0, $f43313d21d3fd8e2$export$cbe7bb95f4f6b11d)(this.currentGraphics.texture.label);
        this.currentGraphics.width = this.items[this.items.length - 1].width;
        this.currentGraphics.height = this.items[this.items.length - 1].height;
    }
}




class $d5cc4c6c246ec93a$export$2e2bcd8739ae039 extends (0, $a03da0212fa80d5e$export$2e2bcd8739ae039) {
    constructor(face, back, width = 200, height = 280, borderRadius = 10){
        super();
        this.face = face;
        this.back = back;
        this.stack = null;
        this.cardWidth = width;
        this.cardHeight = height;
        this.cardBorderRadius = borderRadius;
        if (this.cardWidth === -1 && this.cardHeight === -1) this.currentGraphics = new (0, $j5g5m.Sprite)({
            texture: face,
            width: this.face.width,
            height: this.face.height
        });
        else this.currentGraphics = new (0, $j5g5m.Sprite)({
            texture: face,
            width: this.cardWidth,
            height: this.cardHeight
        });
        this.currentGraphics.anchor.x = 0.5;
        this.currentGraphics.anchor.y = 0.5;
        this.canStack = true;
        const mask = new (0, $8VCQS.Graphics)().roundRect(-this.currentGraphics.width / 2, -this.currentGraphics.height / 2, this.currentGraphics.width, this.currentGraphics.height, this.cardBorderRadius).fill(0xfff);
        this.addChild(mask);
        this.currentGraphics.mask = mask;
        this.addChild(this.currentGraphics);
        this.friction = 0.15;
        this.eventMode = "static";
        this.on("pointerdown", this.onDragStart);
        this.on("pointerup", ()=>{
            if (!this.locked && this.canStack) {
                if (gm.dragInfo.isDragging) {
                    let stack = this;
                    gm.targets.forEach((target)=>{
                        if (target && (0, $713f438c8484fefc$export$e2d8d536c8fc9c6f)(target)) {
                            const objectToStack = target;
                            const newStack = stack.onStack(objectToStack);
                            gm.room.send({
                                type: "stack-object",
                                message: {
                                    target: stack.id,
                                    object_to_stack: objectToStack.id
                                }
                            });
                            stack = newStack;
                        }
                    });
                }
            }
        });
    }
    onTakeFromStack() {
        throw new Error("Method not implemented.");
    }
    hide() {
        if (this.currentGraphics.texture !== this.back) {
            this.currentGraphics.texture = this.back;
            if (this.cardWidth === -1 && this.cardHeight === -1) {
                this.currentGraphics.width = this.currentGraphics.texture.width;
                this.currentGraphics.height = this.currentGraphics.texture.height;
            } else {
                this.currentGraphics.width = this.cardWidth;
                this.currentGraphics.height = this.cardHeight;
            }
            const mask = this.currentGraphics.mask;
            mask.clear().roundRect(-this.currentGraphics.width / 2, -this.currentGraphics.height / 2, this.currentGraphics.width, this.currentGraphics.height, this.cardBorderRadius).fill(0xfff);
        }
    }
    show() {
        if (!this.isFlipped) {
            this.currentGraphics.texture = this.face;
            if (this.cardWidth === -1 && this.cardHeight === -1) {
                this.currentGraphics.width = this.currentGraphics.texture.width;
                this.currentGraphics.height = this.currentGraphics.texture.height;
            } else {
                this.currentGraphics.width = this.cardWidth;
                this.currentGraphics.height = this.cardHeight;
            }
            const mask = this.currentGraphics.mask;
            mask.clear().roundRect(-this.currentGraphics.width / 2, -this.currentGraphics.height / 2, this.currentGraphics.width, this.currentGraphics.height, this.cardBorderRadius).fill(0xfff);
        }
    }
    flip() {
        if (this.isFlipped) {
            this.currentGraphics.texture = this.face;
            this.isFlipped = false;
        } else {
            this.currentGraphics.texture = this.back;
            this.isFlipped = true;
        }
        if (this.cardWidth === -1 && this.cardHeight === -1) {
            this.currentGraphics.width = this.currentGraphics.texture.width;
            this.currentGraphics.height = this.currentGraphics.texture.height;
        } else {
            this.currentGraphics.width = this.cardWidth;
            this.currentGraphics.height = this.cardHeight;
        }
        const mask = this.currentGraphics.mask;
        mask.clear().roundRect(-this.currentGraphics.width / 2, -this.currentGraphics.height / 2, this.currentGraphics.width, this.currentGraphics.height, this.cardBorderRadius).fill(0xfff);
    }
    getItems() {
        return [
            this
        ];
    }
    onStack(item) {
        const stack = new (0, $52837665fc953d6d$export$2e2bcd8739ae039)([
            this,
            ...item.getItems()
        ]);
        const parent = this.parent;
        this.removeFromParent();
        item.removeFromParent();
        if (item instanceof (0, $52837665fc953d6d$export$2e2bcd8739ae039)) {
            item.items = [];
            item.destroy();
        }
        parent.addChild(stack);
        stack.x = this.x;
        stack.y = this.y;
        stack.desiredPosition.x = this.x;
        stack.desiredPosition.y = this.y;
        stack.angle = this.angle;
        return stack;
    }
    onDragStart() {
        gm.onDragStart(this);
    }
    onDrag() {}
    onDragEnd() {}
    serialize() {
        return {
            ...super.serialize(),
            type: "card",
            face: this.face.label,
            back: this.back.label,
            isFlipped: this.isFlipped,
            inStack: this.stack !== null,
            width: this.cardWidth,
            height: this.cardHeight
        };
    }
    reloadTextures() {
        this.face = (0, $f43313d21d3fd8e2$export$cbe7bb95f4f6b11d)(this.face.label);
        this.back = (0, $f43313d21d3fd8e2$export$cbe7bb95f4f6b11d)(this.back.label);
        this.currentGraphics.texture = (0, $f43313d21d3fd8e2$export$cbe7bb95f4f6b11d)(this.currentGraphics.texture.label);
        if (this.cardWidth === -1) this.currentGraphics.width = this.currentGraphics.texture.width;
        else this.currentGraphics.width = this.cardWidth;
        if (this.cardHeight === -1) this.currentGraphics.height = this.currentGraphics.texture.height;
        else this.currentGraphics.height = this.cardHeight;
        const mask = this.currentGraphics.mask;
        mask.clear().roundRect(-this.currentGraphics.width / 2, -this.currentGraphics.height / 2, this.currentGraphics.width, this.currentGraphics.height, this.cardBorderRadius).fill(0xfff);
    }
}




const $f7d0d3a8648ac5ea$export$dd125ccf68502e85 = (object)=>{
    return object.roll !== undefined;
};




function $6de2ed3e5d01eb29$export$2e2bcd8739ae039(seed) {
    return function() {
        let t = seed += 0x6D2B79F5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}





var $j5g5m = parcelRequire("j5g5m");


class $57d08a272d763299$export$2e2bcd8739ae039 extends (0, $j5g5m.Sprite) {
    constructor(texture, x, y, durationMS = 1500, tint = 0xffffff, silent = false){
        super(texture);
        this.animCount = 0;
        this.x = x;
        this.y = y;
        this.zIndex = 1000;
        this.width = 40;
        this.height = 40;
        this.anchor.x = 0.5;
        this.anchor.y = 1;
        this.tint = tint;
        this.scale.x = 0.08 / gm.camera.scale.x;
        this.scale.y = 0.08 / gm.camera.scale.y;
        (0, $a5a2646157cfe94d$export$eab32dcfc4ded11c).play("ping");
        if (!silent) gm.room.send({
            type: "ping-point",
            message: {
                position: new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)(this.x, this.y),
                texture: texture.label,
                tint: tint,
                duration: durationMS
            }
        });
        setTimeout(()=>this.destroy(), durationMS);
    }
    Update(dt) {
        this.animCount += dt;
        const animShrink = (Math.sin(this.animCount / 10) + 1) / 2 + 0.5;
        this.scale.x = 0.08 / gm.camera.scale.x;
        this.scale.y = 0.08 / gm.camera.scale.y * animShrink;
    }
}




var $8VCQS = parcelRequire("8VCQS");
var $hFBUu = parcelRequire("hFBUu");
var $e0Ilp = parcelRequire("e0Ilp");

const $8f75d6937d385d56$export$d11bc97a9f479a6a = (value, a, b)=>{
    if (a > b) return Math.min(Math.max(value, b), a);
    return Math.min(Math.max(value, a), b);
};
const $8f75d6937d385d56$export$84c22a5f9b6eeb71 = (dColor)=>{
    return "#" + ("000000" + dColor.toString(16)).slice(-6);
};


class $97e23afb2f7c7109$export$2e2bcd8739ae039 extends (0, $e0Ilp.Container) {
    get items() {
        return this.itemsContainer.children;
    }
    constructor(x, y, width, height, color = 0xffffff){
        super();
        this.player = null;
        this.label = "hand";
        this.cursor = "grab";
        this.handWidth = width;
        this.handHeight = height;
        this.hidden = false;
        this.pivot.x = this.handWidth / 2;
        this.eventMode = "static";
        this.color = color;
        const g = new (0, $8VCQS.Graphics)();
        g.roundRect(0, 0, this.handWidth, this.handHeight, 20).stroke({
            color: 0x202020,
            width: 8
        });
        this.addChild(g);
        this.playerNameText = new (0, $f7554d64cbb05d0f$export$5f1af8db9871e1d6)();
        this.playerNameText.text = "Take this Seat";
        this.addChild(this.playerNameText);
        this.playerNameText.anchor.x = 0.5;
        this.playerNameText.style.fontSize = 120;
        this.playerNameText.style.fill = color;
        this.playerNameText.style.fontWeight = "bold";
        this.playerNameText.x = this.handWidth / 2;
        this.playerNameText.y = this.handHeight / 2 - this.playerNameText.height / 2;
        this.x = x;
        this.y = y;
        this.hitArea = new (0, $hFBUu.Rectangle)(0, 0, this.handWidth, this.handHeight);
        this.zIndex = 0;
        this.itemsContainer = new (0, $e0Ilp.Container)();
        this.itemsContainer.label = "hand_container";
        const dropShadowFilter = new (0, $e234fabd83f60df8$export$57214e398098d4e3)({
            blur: 16,
            offset: {
                x: 6,
                y: 32
            },
            pixelSize: {
                x: 1,
                y: 1
            },
            quality: 8
        });
        dropShadowFilter.antialias = "on";
        this.itemsContainer.filters = [
            dropShadowFilter
        ];
        this.addChild(this.itemsContainer);
        this.interactiveChildren = true;
        this.playerNameText.eventMode = "static";
        this.playerNameText.on("pointerdown", (event)=>{
            this.setPlayer(gm.room.address());
            gm.room.send({
                type: "player-choose-hand",
                message: {
                    handIndex: gm.hands.findIndex((hand)=>hand === this)
                }
            });
        });
        const clamp = (val, min, max)=>Math.min(Math.max(val, min), max);
        this.on("pointerup", (event)=>{
            if (gm.dragInfo.isDragging) {
                gm.targets.sort((a, b)=>this.toLocal(a).x - this.toLocal(b).x);
                let index = 0;
                if (gm.targets.length > 0) {
                    const x = this.itemsContainer.toLocal(event.global).x;
                    const ratio = clamp(x + gm.targets[0].width / 2, 0, this.itemsContainer.width || 10) / (this.itemsContainer.width || 10);
                    index = Math.round(ratio * this.itemsContainer.children.length);
                }
                gm.targets.forEach((target)=>{
                    if (target && target instanceof (0, $d5cc4c6c246ec93a$export$2e2bcd8739ae039)) {
                        this.putCardAt(target, index);
                        gm.room.send({
                            type: "put-card-in-hand",
                            message: {
                                card_id: target.id,
                                index: index++,
                                handIndex: gm.hands.findIndex((hand)=>hand === this)
                            }
                        });
                    }
                });
            }
        });
        this.on("pointerenter", ()=>{
            if (gm.dragInfo.isDragging) gm.targets.forEach((target)=>{
                if (target && target instanceof (0, $d5cc4c6c246ec93a$export$2e2bcd8739ae039)) {
                    this.updateCardHidden(target, "enter");
                    gm.room.send({
                        type: "update-card-hidden",
                        message: {
                            card_id: target.id,
                            state: "enter",
                            handIndex: gm.hands.findIndex((hand)=>hand === this)
                        }
                    });
                }
            });
        });
        this.on("pointerleave", ()=>{
            if (gm.dragInfo.isDragging) gm.targets.forEach((target)=>{
                if (target && target instanceof (0, $d5cc4c6c246ec93a$export$2e2bcd8739ae039)) {
                    this.updateCardHidden(target, "leave");
                    gm.room.send({
                        type: "update-card-hidden",
                        message: {
                            card_id: target.id,
                            state: "leave",
                            handIndex: gm.hands.findIndex((hand)=>hand === this)
                        }
                    });
                }
            });
        });
    }
    updateCardHidden(card, state) {
        if (state === "enter") {
            card.canStack = false;
            card.angle = this.angle;
            if (this.hidden && card.currentGraphics.texture !== card.back) card.hide();
        } else {
            card.canStack = true;
            if (!card.isFlipped) card.show();
        }
    }
    putCardAt(card, index) {
        card.canStack = false;
        this.itemsContainer.addChild(card);
        this.itemsContainer.setChildIndex(card, index);
        card.position = this.itemsContainer.toLocal(card, gm.camera);
        card.desiredPosition.y = this.handHeight / 2;
        card.angle += -this.angle;
    }
    setPlayer(player) {
        if (player === null) {
            this.player = null;
            this.playerNameText.text = "Take this Seat";
            this.playerNameText.y = this.handHeight / 2 - this.playerNameText.height / 2;
            return;
        }
        gm.hands.forEach((hand)=>{
            if (hand.player === player) hand.setPlayer(null);
        });
        if (gm.players.has(player)) gm.players.get(player).hand = this;
        this.player = player;
        this.playerNameText.text = player;
        this.playerNameText.y = this.handHeight + 50;
        const playerElement = gm.playersListElement.querySelector(`div[address=${player}]`);
        if (playerElement) playerElement.style.color = (0, $8f75d6937d385d56$export$84c22a5f9b6eeb71)(this.color);
    }
    Update(dt) {
        this.hidden = this.player !== gm.room.address();
        const n = this.itemsContainer.children.length;
        for(let i = 0; i < n; i++){
            const card = this.itemsContainer.children[i];
            const wholeWidth = 0.8 * Math.min(this.handWidth, card.width * n) - card.width;
            card.desiredPosition.x = i / Math.max(1, n - 1) * wholeWidth;
            this.itemsContainer.x = this.handWidth / 2 - wholeWidth / 2;
            if (gm.dragInfo.isDragging === false && gm.hoverTarget === card) card.desiredPosition.y = this.handHeight / 2 - 10;
            else card.desiredPosition.y = this.handHeight / 2;
            if (this.hidden && card.currentGraphics.texture !== card.back) card.hide();
            card.Update(dt);
        }
    }
}





class $dbb95c5fa1fbd446$export$2e2bcd8739ae039 extends (0, $a03da0212fa80d5e$export$2e2bcd8739ae039) {
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
        console.log("hit");
        this.currentGraphics.texture = Object.values(this.spritesheet.textures)[value - 1];
    }
    constructor(spritesheet, size){
        super();
        this.eventMode = "static";
        this.on("pointerdown", this.onDragStart);
        this.currentGraphics = new (0, $df1779dbe35539ec$export$dae599798687ad3c)(spritesheet.animations["roll"]);
        this.spritesheet = spritesheet;
        this.value = 1;
        this.friction = 0.1;
        this.currentGraphics.animationSpeed = 0.16;
        this.currentGraphics.anchor = {
            x: 0.5,
            y: 0.5
        };
        this.baseZindex = 10;
        this.addChild(this.currentGraphics);
        this.size = size;
        this.addFilter("dice-shadow", new (0, $e234fabd83f60df8$export$57214e398098d4e3)({
            blur: 2,
            offset: {
                x: 4,
                y: 20
            },
            pixelSize: {
                x: 1,
                y: 1
            }
        }));
    }
    roll(randSeeded) {
        this.currentGraphics.play();
        setTimeout(()=>{
            this.currentGraphics.stop();
            this.value = Math.floor(randSeeded() * this.size) + 1;
            this.angle = randSeeded() * 360;
        }, 500);
    }
    onDragStart() {
        gm.onDragStart(this);
    }
    onDrag() {}
    onDragEnd() {}
    serialize() {
        return {
            ...super.serialize(),
            type: "dice",
            size: this.size,
            value: this.value
        };
    }
    toString() {
        return "" + this.value;
    }
    reloadTextures() {}
}





class $a315f4ffaa4fa6a1$export$2e2bcd8739ae039 extends (0, $dbb95c5fa1fbd446$export$2e2bcd8739ae039) {
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
        if (this.text) this.text.text = value;
        this.currentGraphics.gotoAndStop(0);
    }
    constructor(spritesheet, size){
        super(spritesheet, size);
        this.text = new (0, $f7554d64cbb05d0f$export$5f1af8db9871e1d6)();
        this.text.style.fill = 0xffffff;
        this.text.anchor = {
            x: 0.5,
            y: 0.5
        };
        if (size === 4 || size === 20) this.text.anchor.y = 0.3;
        this.currentGraphics.animationSpeed = 0.5;
        this.value = 1;
        this.addChild(this.text);
    }
    roll(randSeeded) {
        this.currentGraphics.play();
        this.text.text = "";
        (0, $a5a2646157cfe94d$export$eab32dcfc4ded11c).play("roll");
        setTimeout(()=>{
            this.value = Math.floor(randSeeded() * this.size) + 1;
            this.angle = randSeeded() * 360;
        }, 500);
    }
    serialize() {
        return {
            ...super.serialize(),
            type: "text-dice",
            size: this.size,
            value: this.value
        };
    }
    toString() {
        return "" + this.value;
    }
    reloadTextures() {}
}



const $da5e019e55829610$var$colors = [
    0xEE4B2B,
    0x0096FF,
    0xF0C05A,
    0xffffff,
    0xB163A3,
    0x7F00FF
];
class $da5e019e55829610$export$2e2bcd8739ae039 {
    constructor(app, room, isHost){
        this.peekViewZoom = 0.5;
        this.dragInfo = {
            isDragging: false,
            offsets: new Map()
        };
        this.targets = [];
        this.hoverTarget = null;
        this.app = app;
        this.camera = new (0, $8d9f3cef48de1ddd$export$2e2bcd8739ae039)();
        this.app.stage.addChild(this.camera);
        this.room = room;
        this.players = new Map();
        this.gameObjects = new Map();
        this.isHost = isHost;
        this.playersListElement = document.querySelector("#players-list");
        const element = document.createElement("div");
        element.textContent = room.address();
        element.setAttribute("address", this.room.address());
        this.playersListElement.appendChild(element);
        console.log("isHost", isHost);
        room.on("message", (address, { type: type, message: message })=>{
            if (address !== room.address()) console.log(type);
            switch(type){
                case "announce":
                    if (address !== room.address()) {
                        const element = document.createElement("div");
                        element.textContent = address;
                        element.setAttribute("address", address);
                        this.playersListElement.appendChild(element);
                        console.log(address, "connected!");
                        if (isHost) this.sync();
                    }
                    break;
                case "player-disconnected":
                    if (address !== room.address()) {
                        const player = this.players.get(address);
                        if (player) {
                            player.hand?.setPlayer(null);
                            this.players.delete(address);
                        }
                        const playerElement = gm.playersListElement.querySelector(`div[address=${address}]`);
                        if (playerElement) playerElement.remove();
                        const cursor = camera.children.find((child)=>child.label === address);
                        if (cursor) cursor.destroy();
                        console.log(address, "disconnected!");
                    }
                    break;
                case "sync-objects":
                    if (address !== room.address()) this.syncObjects(message);
                    break;
                case "player-cursor":
                    if (address !== room.address()) this.onPlayerCursor(address, message);
                    break;
                case "request-resource":
                    if (address !== room.address()) room.sendTo(address, {
                        type: "sync-resources",
                        message: message.map((item)=>{
                            const spritesheetMatch = item.alias.match(/(.+)-sheet$/);
                            if (spritesheetMatch) {
                                const spritesheet = (0, $7eb272839e01564b$export$c8eca95e306f7116).get(item.alias);
                                return {
                                    alias: spritesheetMatch[1],
                                    spritesheetData: spritesheet.data,
                                    src: spritesheet.textureSource.label
                                };
                            }
                            return {
                                alias: item.alias,
                                src: (0, $f43313d21d3fd8e2$export$cbe7bb95f4f6b11d)(item.alias).source.label
                            };
                        })
                    });
                    break;
                case "sync-resources":
                    if (address !== room.address()) {
                        console.log("started syncing resources");
                        Promise.all(message.map(async ({ alias: alias, src: src, spritesheetData: spritesheetData })=>{
                            if (spritesheetData) {
                                (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
                                    alias: alias,
                                    src: src
                                });
                                await (0, $7eb272839e01564b$export$c8eca95e306f7116).load([
                                    alias
                                ]);
                                const texture = (0, $f43313d21d3fd8e2$export$cbe7bb95f4f6b11d)(alias);
                                const spritesheet = new (0, $jxXUM.Spritesheet)(texture, spritesheetData);
                                await spritesheet.parse();
                                (0, $7eb272839e01564b$export$c8eca95e306f7116).cache.set(`${alias}-sheet`, spritesheet);
                            } else (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
                                alias: alias,
                                src: src
                            });
                        })).then(()=>{
                            (0, $7eb272839e01564b$export$c8eca95e306f7116).load(message.map((ass)=>ass.alias)).then(()=>{
                                this.gameObjects.forEach((go)=>go.reloadTextures());
                            });
                        });
                    }
                    break;
                case "ping-point":
                    if (address !== room.address()) this.camera.addChild(new (0, $57d08a272d763299$export$2e2bcd8739ae039)((0, $f43313d21d3fd8e2$export$cbe7bb95f4f6b11d)(message.texture), message.position.x, message.position.y, message.duration, message.tint, true));
                    break;
                case "move-start-object":
                    if (address !== room.address()) {
                        const item = this.gameObjects.get(message.target);
                        if (item) this.onMoveStart(item);
                    }
                    break;
                case "move-object":
                    if (address !== room.address()) this.onObjectMove(address, message);
                    break;
                case "move-end-object":
                    if (address !== room.address()) {
                        const item = this.gameObjects.get(message.target);
                        if (item) {
                            item.desiredPosition = message.position;
                            item.force = message.force;
                            this.onMoveEnd(item);
                        }
                    }
                    break;
                case "rotate-object":
                    if (address !== room.address()) {
                        const item = this.gameObjects.get(message.target);
                        if (item) item.angle = message.angle;
                    }
                    break;
                case "roll-object":
                    if (address !== room.address()) {
                        const item = this.gameObjects.get(message.target);
                        if (item && (0, $f7d0d3a8648ac5ea$export$dd125ccf68502e85)(item)) item.roll((0, $6de2ed3e5d01eb29$export$2e2bcd8739ae039)(message.seed));
                    }
                    break;
                case "flip-object":
                    if (address !== room.address()) {
                        const item = this.gameObjects.get(message.target);
                        if (item && (0, $1f0ef112743f5763$export$bf29a109eabc0057)(item)) item.flip();
                    }
                    break;
                case "stack-object":
                    if (address !== room.address()) this.onObjectStack(address, message);
                    break;
                case "take-object-from-stack":
                    if (address !== room.address()) this.onTakeObjectFromStack(address, message);
                    break;
                case "player-choose-hand":
                    if (address !== room.address()) {
                        if (this.players.has(address)) {
                            this.players.get(address).hand = this.hands[message.handIndex];
                            this.hands[message.handIndex].setPlayer(address);
                        }
                    }
                    break;
                case "put-card-in-hand":
                    if (address !== room.address()) {
                        const card = this.gameObjects.get(message.card_id);
                        if (card && card instanceof (0, $d5cc4c6c246ec93a$export$2e2bcd8739ae039)) this.hands[message.handIndex].putCardAt(card, message.index);
                    }
                    break;
                case "update-card-hidden":
                    if (address !== room.address()) {
                        const card = this.gameObjects.get(message.card_id);
                        if (card && card instanceof (0, $d5cc4c6c246ec93a$export$2e2bcd8739ae039)) this.hands[message.handIndex].updateCardHidden(card, message.state);
                    }
                    break;
                case "lock-object":
                    if (address !== room.address()) {
                        const object = this.gameObjects.get(message.target);
                        if (object) object.locked = message.locked;
                    }
                    break;
                case "destroy-object":
                    if (address !== room.address()) {
                        const object = this.gameObjects.get(message.target);
                        if (object) object.destroy();
                    }
                    break;
                case "clone-object":
                    if (address !== room.address()) {
                        const object = this.gameObjects.get(message.target);
                        if (object) this.duplicateObject(object);
                    }
                    break;
            }
        });
    }
    deserialize(object) {
        let createdObject = null;
        if (object.type === "card") {
            const card = new (0, $d5cc4c6c246ec93a$export$2e2bcd8739ae039)((0, $f43313d21d3fd8e2$export$cbe7bb95f4f6b11d)(object.face), (0, $f43313d21d3fd8e2$export$cbe7bb95f4f6b11d)(object.back), object.width, object.height);
            if (object.isFlipped) card.flip();
            if (!object.inStack) this.camera.addChild(card);
            createdObject = card;
        }
        if (object.type === "stack") {
            const cards = object.items.map((i)=>this.gameObjects.get(i));
            const stack = new (0, $52837665fc953d6d$export$2e2bcd8739ae039)(cards);
            this.camera.addChild(stack);
            createdObject = stack;
        }
        if (object.type === "dice" || object.type === "text-dice") {
            const spritesheet = (0, $7eb272839e01564b$export$c8eca95e306f7116).get(`d${object.size}-sheet`);
            let dice;
            switch(object.type){
                case "dice":
                    dice = new (0, $dbb95c5fa1fbd446$export$2e2bcd8739ae039)(spritesheet, object.size);
                    break;
                case "text-dice":
                    dice = new (0, $a315f4ffaa4fa6a1$export$2e2bcd8739ae039)(spritesheet, object.size);
                    break;
            }
            this.camera.addChild(dice);
            dice.value = object.value;
            createdObject = dice;
        }
        if (createdObject) {
            createdObject.x = object.x;
            createdObject.y = object.y;
            createdObject.desiredPosition.x = object.x;
            createdObject.desiredPosition.y = object.y;
            createdObject.angle = object.angle;
            createdObject.locked = object.locked;
        }
        return createdObject;
    }
    syncObjects(state) {
        console.log("started syncing objects", state);
        this.gameObjects.forEach((i)=>i.destroy({
                children: true
            }));
        this.gameObjects.clear();
        (0, $bc2c310e4f4b9933$export$2fca005cbdb9bc0f)(-100000);
        state.gameObjects.sort((a, b)=>a.type.localeCompare(b.type));
        for (let obj of state.gameObjects){
            const createdObject = this.deserialize(obj);
            if (createdObject) {
                this.gameObjects.delete(createdObject.id);
                createdObject.id = obj.id;
                this.gameObjects.set(createdObject.id, createdObject);
            }
        }
        for(let i = 0; i < state.hands.length; i++){
            const hand = state.hands[i];
            this.hands[i].setPlayer(hand.player);
            for(let cardIndex = 0; cardIndex < hand.items.length; cardIndex++){
                const card = this.gameObjects.get(hand.items[cardIndex]);
                if (card && card instanceof (0, $d5cc4c6c246ec93a$export$2e2bcd8739ae039)) this.hands[i].putCardAt(card, cardIndex);
            }
        }
        (0, $bc2c310e4f4b9933$export$2fca005cbdb9bc0f)(state.nextUID);
    }
    sync() {
        const objectSerialized = [];
        for (let obj of this.gameObjects.values())objectSerialized.push(obj.serialize());
        this.room.send({
            type: "sync-objects",
            message: {
                gameObjects: objectSerialized,
                hands: this.hands.map((hand)=>({
                        player: hand.player,
                        items: hand.items.map((item)=>item.id)
                    })),
                nextUID: (0, $bc2c310e4f4b9933$export$8122402e62ffa7ac)
            }
        });
    }
    onPlayerCursor(address, data) {
        if (this.players.has(address)) {
            const player = this.players.get(address);
            player.position.x = data.position.x;
            player.position.y = data.position.y;
        } else {
            const player = {
                position: data.position,
                hand: null
            };
            this.players.set(address, player);
            const cursorSprite = new (0, $j5g5m.Sprite)({
                anchor: {
                    x: 0.5,
                    y: 0.5
                },
                texture: (0, $jollT.Texture).from("cursor"),
                width: 24,
                height: 24,
                x: player.position.x,
                y: player.position.y,
                zIndex: 1000
            });
            cursorSprite.label = address;
            this.camera.addChild(cursorSprite);
        }
    }
    onObjectMove(address, data) {
        const item = this.gameObjects.get(data.target);
        if (item) item.desiredPosition = data.position;
    }
    onObjectStack(address, data) {
        const target = this.gameObjects.get(data.target);
        const item = this.gameObjects.get(data.object_to_stack);
        if ((0, $713f438c8484fefc$export$e2d8d536c8fc9c6f)(target) && (0, $713f438c8484fefc$export$e2d8d536c8fc9c6f)(item)) target.onStack(item);
    }
    onTakeObjectFromStack(address, data) {
        const object = this.gameObjects.get(data.object_from_stack);
        if ((0, $713f438c8484fefc$export$e2d8d536c8fc9c6f)(object)) {
            const target = object.stack;
            if (target && (0, $713f438c8484fefc$export$e2d8d536c8fc9c6f)(target)) {
                const item = target.onTakeFromStack(object, data.point);
                if (item) this.onMoveStart(item);
            }
        }
    }
    onMoveStart(target) {
        if (target.parent.label === "hand_container" && (0, $713f438c8484fefc$export$e2d8d536c8fc9c6f)(target)) {
            target.canStack = false;
            const center = this.camera.toLocal(target.position, target.parent);
            target.x = center.x;
            target.y = center.y;
            target.desiredPosition.x = center.x;
            target.desiredPosition.y = center.y;
            target.angle += target.parent.parent.angle;
            this.camera.addChild(target);
        }
        if (target.parent !== this.camera) {
            this.camera.addChild(target);
            const mousePos = (0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.mouse.position;
            const center = this.camera.screenToWorldPoint(new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)(mousePos.x, mousePos.y));
            target.x = center.x;
            target.y = center.y;
        }
        if (target instanceof (0, $d5cc4c6c246ec93a$export$2e2bcd8739ae039)) target.canStack = true;
        target.eventMode = "none";
        target.zIndex = 100;
        if (!target.parent) this.camera.addChild(target);
        (0, $a5a2646157cfe94d$export$eab32dcfc4ded11c).play("pick");
        target.addFilter("shadow", new (0, $e234fabd83f60df8$export$57214e398098d4e3)({
            blur: 4,
            offset: {
                x: 8,
                y: 30
            },
            pixelSize: {
                x: 1,
                y: 1
            },
            quality: 8
        }));
    }
    onMoveEnd(target) {
        target.eventMode = "static";
        target.zIndex = target.baseZindex;
        (0, $a5a2646157cfe94d$export$eab32dcfc4ded11c).play("pick");
        target.removeFilter("shadow");
    }
    onDragStart(item) {
        if (!this.targets.includes(item)) {
            this.targets.forEach((i)=>!i.destroyed && i.removeFilter("outline"));
            this.targets.length = 0;
            item.addFilter("outline", new (0, $46c687782dcb4f1e$export$ea1238a366116160)({
                thickness: 5,
                color: "yellow"
            }));
            this.targets.push(item);
        }
        const itemOffset = this.camera.toLocal(item, item.parent);
        this.targets.forEach((target)=>{
            if (target.locked) return;
            if ((0, $e3e0d3802040b351$export$5d532f06a6d2ef56)(target)) {
                const targetWorld = this.camera.toLocal(target, target.parent);
                this.dragInfo.offsets.set(target.id, new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)(targetWorld.x - itemOffset.x, targetWorld.y - itemOffset.y));
                this.onMoveStart(target);
                this.room.send({
                    type: "move-start-object",
                    message: {
                        target: target.id
                    }
                });
            }
        });
        this.dragInfo.isDragging = true;
        this.app.stage.on("pointermove", this.onDragMove, this);
    }
    onDragMove(event) {
        if (this.dragInfo.isDragging === false) return;
        this.targets.forEach((item)=>{
            if ((0, $e3e0d3802040b351$export$5d532f06a6d2ef56)(item) && !item.destroyed) {
                if (item.parent) {
                    const center = this.camera.screenToWorldPoint(new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)(event.screen.x, event.screen.y));
                    const offset = this.dragInfo.offsets.get(item.id);
                    item.desiredPosition.x = center.x + offset.x;
                    item.desiredPosition.y = center.y + offset.y;
                } else this.onDragEnd(event);
                item.onDrag();
                this.room.send({
                    type: "move-object",
                    message: {
                        target: item.id,
                        position: new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)(item.x, item.y)
                    }
                });
            }
        });
    }
    onDragEnd(event) {
        if (this.dragInfo.isDragging === false) return;
        this.targets.forEach((item)=>{
            if ((0, $e3e0d3802040b351$export$5d532f06a6d2ef56)(item)) {
                if (!item.destroyed) {
                    item.onDragEnd();
                    const newDesiredPos = this.camera.screenToWorldPoint(new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)(event.screen.x, event.screen.y));
                    const offset = this.dragInfo.offsets.get(item.id);
                    item.desiredPosition.x = newDesiredPos.x + offset.x;
                    item.desiredPosition.y = newDesiredPos.y + offset.y;
                    const force = new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)();
                    const mouseMovement = (0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.mouse.movement;
                    if (mouseMovement.length > 2) {
                        const dir = mouseMovement.normalized.rotate(-this.camera.rotation);
                        const len = Math.min(mouseMovement.length, 5);
                        force.x = dir.x * len * 10;
                        force.y = dir.y * len * 10;
                        item.force = force;
                        if (item instanceof (0, $dbb95c5fa1fbd446$export$2e2bcd8739ae039)) {
                            const seed = Date.now() + item.id;
                            const randSeeded = (0, $6de2ed3e5d01eb29$export$2e2bcd8739ae039)(seed);
                            if (item && (0, $f7d0d3a8648ac5ea$export$dd125ccf68502e85)(item)) {
                                item.roll(randSeeded);
                                this.room.send({
                                    type: "roll-object",
                                    message: {
                                        target: item.id,
                                        seed: seed
                                    }
                                });
                            }
                        }
                    }
                    this.onMoveEnd(item);
                    this.room.send({
                        type: "move-end-object",
                        message: {
                            target: item.id,
                            position: item.desiredPosition,
                            force: force
                        }
                    });
                }
            }
        });
        this.app.stage.off("pointermove", this.onDragMove, this);
        if (this.targets.length === 1) this.targets.length = 0;
        this.dragInfo.isDragging = false;
    }
    takeCardsToHand(amount) {
        const hand = this.hands.find((hand)=>hand.player === this.room.address());
        const currentTargets = [
            ...this.targets
        ];
        if (this.hoverTarget && !currentTargets.includes(this.hoverTarget)) currentTargets.push(this.hoverTarget);
        currentTargets.forEach((target)=>{
            if (hand && target && !target.locked && hand.items.indexOf(target) === -1) {
                if (target instanceof (0, $d5cc4c6c246ec93a$export$2e2bcd8739ae039)) {
                    target.canStack = false;
                    target.angle = hand.angle;
                    hand.putCardAt(target, hand.items.length);
                }
                if (target instanceof (0, $52837665fc953d6d$export$2e2bcd8739ae039)) {
                    const mousePos = this.camera.screenToWorldPoint((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.mouse.position);
                    for(let i = 0; i < amount; i++)if (target.items.length > 1) {
                        const item = target.onTakeFromStack(target.items[target.items.length - 1], mousePos);
                        item.angle = hand.angle;
                        hand.putCardAt(item, hand.items.length);
                    }
                }
            }
        });
    }
    duplicateObject(target) {
        let duplicatedObject = null;
        if (target instanceof (0, $52837665fc953d6d$export$2e2bcd8739ae039)) {
            if (target.canStack) {
                const items = target.items.map((item)=>{
                    return this.deserialize(item.serialize()).id;
                });
                const serializedStack = target.serialize();
                if (serializedStack.type === "stack") serializedStack.items = items;
                duplicatedObject = this.deserialize(serializedStack);
            }
        } else duplicatedObject = this.deserialize(target.serialize());
        if (duplicatedObject) {
            duplicatedObject.desiredPosition.x += duplicatedObject.width + 10;
            duplicatedObject.desiredPosition.y += 10;
        }
    }
    async startGame() {
        this.hands = [];
        let hand = new (0, $97e23afb2f7c7109$export$2e2bcd8739ae039)(1000, 1000, 1200, 400, $da5e019e55829610$var$colors[0]);
        this.hands.push(hand);
        hand = new (0, $97e23afb2f7c7109$export$2e2bcd8739ae039)(-1000, 1000, 1200, 400, $da5e019e55829610$var$colors[1]);
        this.hands.push(hand);
        hand = new (0, $97e23afb2f7c7109$export$2e2bcd8739ae039)(-1800, 0, 1200, 400, $da5e019e55829610$var$colors[2]);
        hand.angle = 90;
        this.hands.push(hand);
        hand = new (0, $97e23afb2f7c7109$export$2e2bcd8739ae039)(-1000, -1000, 1200, 400, $da5e019e55829610$var$colors[3]);
        hand.angle = 180;
        this.hands.push(hand);
        hand = new (0, $97e23afb2f7c7109$export$2e2bcd8739ae039)(1000, -1000, 1200, 400, $da5e019e55829610$var$colors[4]);
        hand.angle = 180;
        this.hands.push(hand);
        hand = new (0, $97e23afb2f7c7109$export$2e2bcd8739ae039)(1800, 0, 1200, 400, $da5e019e55829610$var$colors[5]);
        hand.angle = 270;
        this.hands.push(hand);
        this.hands.forEach((hand)=>{
            this.camera.addChild(hand);
        });
        this.tooltip = new (0, $f7554d64cbb05d0f$export$5f1af8db9871e1d6)();
        this.tooltip.zIndex = 1400;
        this.tooltip.eventMode = "none";
        this.tooltip.style.fill = 0xffffff;
        this.tooltip.anchor = {
            x: 0.5,
            y: 1
        };
        this.app.stage.addChild(this.tooltip);
        this.peekView = new (0, $j5g5m.Sprite)();
        this.peekView.eventMode = "none";
        this.peekView.zIndex = 1500;
        this.peekView.anchor = {
            x: 1,
            y: 0.5
        };
        this.app.stage.addChild(this.peekView);
        const selectionBox = new (0, $8VCQS.Graphics)();
        selectionBox.rect(0, 0, 10, 10).fill({
            color: 0x000000,
            alpha: 0.1
        });
        this.app.stage.addChild(selectionBox);
        let selectionFirstPoint = null;
        this.app.stage.on("pointerdown", (event)=>{
            if (event.button === 0) {
                const local = event.global;
                selectionFirstPoint = new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)(local.x, local.y);
            }
        });
        this.app.stage.on("pointerup", (event)=>{
            selectionFirstPoint = null;
        });
        this.app.stage.on("pointerupoutside", ()=>{
            selectionFirstPoint = null;
        });
        this.app.stage.on("pointermove", (event)=>{
            if (selectionFirstPoint !== null && !this.dragInfo.isDragging) {
                const local = event.global;
                const minX = Math.min(local.x, selectionFirstPoint.x);
                const minY = Math.min(local.y, selectionFirstPoint.y);
                const maxX = Math.max(local.x, selectionFirstPoint.x);
                const maxY = Math.max(local.y, selectionFirstPoint.y);
                selectionBox.x = minX;
                selectionBox.y = minY;
                selectionBox.width = maxX - minX;
                selectionBox.height = maxY - minY;
                const bounds = selectionBox.getBounds(true);
                this.targets.length = 0;
                this.gameObjects.forEach((go)=>{
                    if (go.parent) {
                        const global = go.parent.toGlobal(go.position);
                        if (bounds.containsPoint(global.x, global.y)) {
                            go.addFilter("outline", new (0, $46c687782dcb4f1e$export$ea1238a366116160)({
                                thickness: 5,
                                color: "yellow"
                            }));
                            this.targets.push(go);
                        } else go.removeFilter("outline");
                    }
                });
            } else {
                selectionBox.width = 1;
                selectionBox.height = 1;
            }
        });
        this.app.stage.on("pointerup", this.onDragEnd, this);
        this.app.stage.on("pointerupoutside", this.onDragEnd, this);
        this.app.stage.on("wheel", (event)=>{
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("alt") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).HELD) this.peekViewZoom = Math.min(Math.max(this.peekViewZoom - event.deltaY / 2000, 0.03), 6);
            else this.camera.desiredZoom = Math.min(Math.max(this.camera.desiredZoom - event.deltaY / 2000, 0.2), 2);
        });
        this.app.stage.on("pointermove", ()=>{
            this.room.send({
                type: "player-cursor",
                message: {
                    position: this.camera.screenToWorldPoint((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.mouse.position)
                }
            });
        });
        (0, $6BsCn.EventsTicker).interactionFrequency = 1;
        this.app.stage.eventMode = "dynamic";
        this.app.stage.hitArea = this.app.screen;
        const center = new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)(this.app.screen.width / 2, this.app.screen.height / 2);
        this.camera.position.x = center.x;
        this.camera.position.y = center.y;
        window.addEventListener("resize", ()=>{
            requestAnimationFrame(()=>{
                this.app.queueResize();
                const center = new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)(this.app.screen.width / 2, this.app.screen.height / 2);
                this.camera.position.x = center.x;
                this.camera.position.y = center.y;
            });
            console.log("resize");
        });
        this.app.ticker.add((ticker)=>{
            for (const child of this.app.stage.children)if ((0, $3dfcb00c48470562$export$fc9f9b64b84f941f)(child)) child.Update(ticker.deltaTime);
            for (const child of this.camera.children){
                if (child.label && this.players.has(child.label)) {
                    const player = this.players.get(child.label);
                    child.x = player.position.x;
                    child.y = player.position.y;
                    child.scale.x = 0.08 / this.camera.scale.x;
                    child.scale.y = 0.08 / this.camera.scale.y;
                    if (player.hand) child.tint = player.hand.color;
                }
                if ((0, $3dfcb00c48470562$export$fc9f9b64b84f941f)(child)) child.Update(ticker.deltaTime);
            }
            const input = new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)();
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("control") !== (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).HELD) {
                if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("w") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).HELD) input.y += -1;
                if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("a") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).HELD) input.x += -1;
                if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("s") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).HELD) input.y += 1;
                if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("d") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).HELD) input.x += 1;
            }
            const currentTargets = [
                ...this.targets
            ];
            if (this.hoverTarget) {
                const hoverIndex = currentTargets.indexOf(this.hoverTarget);
                if (hoverIndex > -1) currentTargets.splice(hoverIndex, 1);
                currentTargets.unshift(this.hoverTarget);
            }
            if (currentTargets.length > 0) {
                let total = 0;
                const values = currentTargets.map((item)=>{
                    return +item.toString();
                });
                total = values.reduce((total, current)=>total + current);
                if (currentTargets[0] && !currentTargets[0].destroyed) {
                    this.tooltip.position = this.app.stage.toLocal(currentTargets[0], currentTargets[0].parent);
                    this.tooltip.position.y = currentTargets[0].getBounds().top - 10;
                    if (currentTargets.length > 1 && currentTargets.every((item)=>item instanceof (0, $dbb95c5fa1fbd446$export$2e2bcd8739ae039))) this.tooltip.text = `${values.join(" + ")} = ${total}`;
                    else this.tooltip.text = currentTargets[0].toString();
                } else this.tooltip.text = "";
            } else this.tooltip.text = "";
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("l") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).PRESSED) currentTargets.forEach((target)=>{
                if (target) {
                    target.locked = !target.locked;
                    this.room.send({
                        type: "lock-object",
                        message: {
                            target: target.id,
                            locked: target.locked
                        }
                    });
                }
            });
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("f") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).PRESSED) currentTargets.forEach((target)=>{
                if (target && !target.locked && (0, $1f0ef112743f5763$export$bf29a109eabc0057)(target)) {
                    target.flip();
                    this.room.send({
                        type: "flip-object",
                        message: {
                            target: target.id
                        }
                    });
                }
            });
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("r") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).PRESSED) currentTargets.forEach((target)=>{
                const seed = Date.now() + target.id;
                const randSeeded = (0, $6de2ed3e5d01eb29$export$2e2bcd8739ae039)(seed);
                if (target && !target.locked && (0, $f7d0d3a8648ac5ea$export$dd125ccf68502e85)(target)) {
                    target.roll(randSeeded);
                    this.room.send({
                        type: "roll-object",
                        message: {
                            target: target.id,
                            seed: seed
                        }
                    });
                }
            });
            let angle = 0;
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("q") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).HELD) angle -= 1;
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("e") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).HELD) angle += 1;
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("delete") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).PRESSED) currentTargets.forEach((target)=>{
                target.destroy();
                gm.room.send({
                    type: "destroy-object",
                    message: {
                        target: target.id
                    }
                });
            });
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("control") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).HELD && (0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("d") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).PRESSED) this.targets.forEach((target)=>{
                this.duplicateObject(target);
                this.room.send({
                    type: "clone-object",
                    message: {
                        target: target.id
                    }
                });
            });
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("alt") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).HELD) {
                if (this.hoverTarget) {
                    this.peekView.texture = this.hoverTarget.currentGraphics.texture;
                    this.peekView.width = this.hoverTarget.currentGraphics.width / this.hoverTarget.currentGraphics.height * this.app.screen.height / 2;
                    this.peekView.height = this.app.screen.height / 2;
                }
                this.peekView.scale.x = this.peekViewZoom;
                this.peekView.scale.y = this.peekViewZoom;
                this.peekView.x = this.app.screen.right - 100;
                this.peekView.y = this.app.screen.height / 2;
            } else this.peekView.texture = null;
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("tab") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).PRESSED) {
                const mousePos = this.camera.screenToWorldPoint((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.mouse.position);
                const myHand = this.hands.find((hand)=>hand.player === this.room.address());
                this.camera.addChild(new (0, $57d08a272d763299$export$2e2bcd8739ae039)((0, $f43313d21d3fd8e2$export$cbe7bb95f4f6b11d)("arrow"), mousePos.x, mousePos.y, 1500, myHand ? myHand.color : 0xffffff));
            }
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("1") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).PRESSED) this.takeCardsToHand(1);
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("2") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).PRESSED) this.takeCardsToHand(2);
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("3") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).PRESSED) this.takeCardsToHand(3);
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("4") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).PRESSED) this.takeCardsToHand(4);
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("5") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).PRESSED) this.takeCardsToHand(5);
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("6") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).PRESSED) this.takeCardsToHand(6);
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("7") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).PRESSED) this.takeCardsToHand(7);
            if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get("8") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).PRESSED) this.takeCardsToHand(8);
            if (angle !== 0) {
                if ((0, $45fe05e25c77474d$export$2e2bcd8739ae039).instance.keyboard.get(" ") === (0, $45fe05e25c77474d$export$9e9c3b4596bcb2e8).HELD) this.camera.angle -= angle * ticker.deltaTime;
                else currentTargets.forEach((target)=>{
                    if (target && !target.locked) {
                        target.angle += angle * ticker.deltaTime * 2;
                        this.room.send({
                            type: "rotate-object",
                            message: {
                                target: target.id,
                                angle: target.angle
                            }
                        });
                    }
                });
            }
            input.rotate(-this.camera.rotation);
            this.camera.desiredPosition.x += input.x * ticker.deltaTime * 20;
            this.camera.desiredPosition.y += input.y * ticker.deltaTime * 20;
            this.camera.Update(ticker.deltaTime);
        });
    }
}






var $4f935bb8b4cfed5e$exports = {};
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8dff54558831dec9$export$a143d493d941bafc;
var $8dff54558831dec9$export$e4cf37d7f6fb9e0a;
var $8dff54558831dec9$export$f99ded8fe4b79145;
var $8dff54558831dec9$export$599f31c3813fae4d;
"use strict";
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
"use strict";
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup["-".charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup["_".charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $8dff54558831dec9$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$8dff54558831dec9$export$a143d493d941bafc = $8dff54558831dec9$var$Buffer;
$8dff54558831dec9$export$e4cf37d7f6fb9e0a = $8dff54558831dec9$var$SlowBuffer;
$8dff54558831dec9$export$f99ded8fe4b79145 = 50;
const $8dff54558831dec9$var$K_MAX_LENGTH = 0x7fffffff;
$8dff54558831dec9$export$599f31c3813fae4d = $8dff54558831dec9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT = $8dff54558831dec9$var$typedArraySupport();
if (!$8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8dff54558831dec9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8dff54558831dec9$var$createBuffer(length) {
    if (length > $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8dff54558831dec9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8dff54558831dec9$var$allocUnsafe(arg);
    }
    return $8dff54558831dec9$var$from(arg, encodingOrOffset, length);
}
$8dff54558831dec9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8dff54558831dec9$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $8dff54558831dec9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8dff54558831dec9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8dff54558831dec9$var$isInstance(value, ArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, ArrayBuffer)) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($8dff54558831dec9$var$isInstance(value, SharedArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, SharedArrayBuffer))) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8dff54558831dec9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8dff54558831dec9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $8dff54558831dec9$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8dff54558831dec9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8dff54558831dec9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8dff54558831dec9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8dff54558831dec9$var$Buffer, Uint8Array);
function $8dff54558831dec9$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8dff54558831dec9$var$alloc(size, fill, encoding) {
    $8dff54558831dec9$var$assertSize(size);
    if (size <= 0) return $8dff54558831dec9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $8dff54558831dec9$var$createBuffer(size).fill(fill, encoding) : $8dff54558831dec9$var$createBuffer(size).fill(fill);
    return $8dff54558831dec9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8dff54558831dec9$var$Buffer.alloc = function(size, fill, encoding) {
    return $8dff54558831dec9$var$alloc(size, fill, encoding);
};
function $8dff54558831dec9$var$allocUnsafe(size) {
    $8dff54558831dec9$var$assertSize(size);
    return $8dff54558831dec9$var$createBuffer(size < 0 ? 0 : $8dff54558831dec9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8dff54558831dec9$var$Buffer.allocUnsafe = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8dff54558831dec9$var$Buffer.allocUnsafeSlow = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
function $8dff54558831dec9$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $8dff54558831dec9$var$byteLength(string, encoding) | 0;
    let buf = $8dff54558831dec9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8dff54558831dec9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8dff54558831dec9$var$checked(array.length) | 0;
    const buf = $8dff54558831dec9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8dff54558831dec9$var$fromArrayView(arrayView) {
    if ($8dff54558831dec9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8dff54558831dec9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8dff54558831dec9$var$fromArrayLike(arrayView);
}
function $8dff54558831dec9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
function $8dff54558831dec9$var$fromObject(obj) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(obj)) {
        const len = $8dff54558831dec9$var$checked(obj.length) | 0;
        const buf = $8dff54558831dec9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $8dff54558831dec9$var$numberIsNaN(obj.length)) return $8dff54558831dec9$var$createBuffer(0);
        return $8dff54558831dec9$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $8dff54558831dec9$var$fromArrayLike(obj.data);
}
function $8dff54558831dec9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8dff54558831dec9$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $8dff54558831dec9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8dff54558831dec9$var$Buffer.alloc(+length);
}
$8dff54558831dec9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8dff54558831dec9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8dff54558831dec9$var$Buffer.compare = function compare(a, b) {
    if ($8dff54558831dec9$var$isInstance(a, Uint8Array)) a = $8dff54558831dec9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8dff54558831dec9$var$isInstance(b, Uint8Array)) b = $8dff54558831dec9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(a) || !$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8dff54558831dec9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$8dff54558831dec9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8dff54558831dec9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8dff54558831dec9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8dff54558831dec9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) buf = $8dff54558831dec9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8dff54558831dec9$var$byteLength(string, encoding) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8dff54558831dec9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $8dff54558831dec9$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $8dff54558831dec9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8dff54558831dec9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8dff54558831dec9$var$Buffer.byteLength = $8dff54558831dec9$var$byteLength;
function $8dff54558831dec9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $8dff54558831dec9$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $8dff54558831dec9$var$utf8Slice(this, start, end);
        case "ascii":
            return $8dff54558831dec9$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $8dff54558831dec9$var$latin1Slice(this, start, end);
        case "base64":
            return $8dff54558831dec9$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8dff54558831dec9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8dff54558831dec9$var$Buffer.prototype._isBuffer = true;
function $8dff54558831dec9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8dff54558831dec9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$8dff54558831dec9$var$swap(this, i, i + 1);
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $8dff54558831dec9$var$swap(this, i, i + 3);
        $8dff54558831dec9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $8dff54558831dec9$var$swap(this, i, i + 7);
        $8dff54558831dec9$var$swap(this, i + 1, i + 6);
        $8dff54558831dec9$var$swap(this, i + 2, i + 5);
        $8dff54558831dec9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $8dff54558831dec9$var$utf8Slice(this, 0, length);
    return $8dff54558831dec9$var$slowToString.apply(this, arguments);
};
$8dff54558831dec9$var$Buffer.prototype.toLocaleString = $8dff54558831dec9$var$Buffer.prototype.toString;
$8dff54558831dec9$var$Buffer.prototype.equals = function equals(b) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $8dff54558831dec9$var$Buffer.compare(this, b) === 0;
};
$8dff54558831dec9$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $8dff54558831dec9$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($8dff54558831dec9$var$customInspectSymbol) $8dff54558831dec9$var$Buffer.prototype[$8dff54558831dec9$var$customInspectSymbol] = $8dff54558831dec9$var$Buffer.prototype.inspect;
$8dff54558831dec9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8dff54558831dec9$var$isInstance(target, Uint8Array)) target = $8dff54558831dec9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8dff54558831dec9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8dff54558831dec9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $8dff54558831dec9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8dff54558831dec9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8dff54558831dec9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8dff54558831dec9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $8dff54558831dec9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8dff54558831dec9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8dff54558831dec9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8dff54558831dec9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8dff54558831dec9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8dff54558831dec9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8dff54558831dec9$var$utf8Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8dff54558831dec9$var$asciiWrite(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$asciiToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$base64Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$base64ToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$ucs2Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8dff54558831dec9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $8dff54558831dec9$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $8dff54558831dec9$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $8dff54558831dec9$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $8dff54558831dec9$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8dff54558831dec9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8dff54558831dec9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8dff54558831dec9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $4a6eda7d0e4e0857$export$6100ba28696e12de(buf);
    else return $4a6eda7d0e4e0857$export$6100ba28696e12de(buf.slice(start, end));
}
function $8dff54558831dec9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8dff54558831dec9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8dff54558831dec9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8dff54558831dec9$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8dff54558831dec9$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8dff54558831dec9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $8dff54558831dec9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8dff54558831dec9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8dff54558831dec9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8dff54558831dec9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8dff54558831dec9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$8dff54558831dec9$var$Buffer.prototype.readUintLE = $8dff54558831dec9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUintBE = $8dff54558831dec9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUint8 = $8dff54558831dec9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8dff54558831dec9$var$Buffer.prototype.readUint16LE = $8dff54558831dec9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8dff54558831dec9$var$Buffer.prototype.readUint16BE = $8dff54558831dec9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8dff54558831dec9$var$Buffer.prototype.readUint32LE = $8dff54558831dec9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8dff54558831dec9$var$Buffer.prototype.readUint32BE = $8dff54558831dec9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8dff54558831dec9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8dff54558831dec9$var$Buffer.prototype.readBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8dff54558831dec9$var$Buffer.prototype.readBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8dff54558831dec9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $8dff54558831dec9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$8dff54558831dec9$var$Buffer.prototype.writeUintLE = $8dff54558831dec9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUintBE = $8dff54558831dec9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint8 = $8dff54558831dec9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8dff54558831dec9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8dff54558831dec9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$8dff54558831dec9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $8dff54558831dec9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $8dff54558831dec9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $11cd8afb6c84e33a$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8dff54558831dec9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, false, noAssert);
};
function $8dff54558831dec9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $11cd8afb6c84e33a$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8dff54558831dec9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8dff54558831dec9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8dff54558831dec9$var$Buffer.isBuffer(val) ? val : $8dff54558831dec9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8dff54558831dec9$var$errors = {};
function $8dff54558831dec9$var$E(sym, getMessage, Base) {
    $8dff54558831dec9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8dff54558831dec9$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$8dff54558831dec9$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8dff54558831dec9$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8dff54558831dec9$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8dff54558831dec9$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8dff54558831dec9$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8dff54558831dec9$var$checkBounds(buf, offset, byteLength) {
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8dff54558831dec9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $8dff54558831dec9$var$checkBounds(buf, offset, byteLength);
}
function $8dff54558831dec9$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $8dff54558831dec9$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $8dff54558831dec9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8dff54558831dec9$var$validateNumber(value, type);
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $8dff54558831dec9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8dff54558831dec9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8dff54558831dec9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8dff54558831dec9$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $8dff54558831dec9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $8dff54558831dec9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8dff54558831dec9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8dff54558831dec9$var$base64ToBytes(str) {
    return $4a6eda7d0e4e0857$export$d622b2ad8d90c771($8dff54558831dec9$var$base64clean(str));
}
function $8dff54558831dec9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8dff54558831dec9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8dff54558831dec9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8dff54558831dec9$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8dff54558831dec9$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $8dff54558831dec9$var$BufferBigIntNotDefined : fn;
}
function $8dff54558831dec9$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $4f935bb8b4cfed5e$require$Buffer = $8dff54558831dec9$export$a143d493d941bafc;

!function(e) {
    $4f935bb8b4cfed5e$exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $4f935bb8b4cfed5e$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($4f935bb8b4cfed5e$require$Buffer.from && $4f935bb8b4cfed5e$require$Buffer.from !== Uint8Array.from) return $4f935bb8b4cfed5e$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $4f935bb8b4cfed5e$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($4f935bb8b4cfed5e$require$Buffer.alloc) return $4f935bb8b4cfed5e$require$Buffer.alloc(e);
                        var t = new $4f935bb8b4cfed5e$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $4f935bb8b4cfed5e$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK\x03\x04", r.CENTRAL_FILE_HEADER = "PK\x01\x02", r.CENTRAL_DIRECTORY_END = "PK\x05\x06", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06", r.DATA_DESCRIPTOR = "PK\x07\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $4f935bb8b4cfed5e$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $4f935bb8b4cfed5e$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $371a3837fd81d701$exports.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});


var $ed2b12aa71a74467$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($ed2b12aa71a74467$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $ed2b12aa71a74467$exports = g;
});



const $7e30ca88d40c2428$var$dragElement = (dialog)=>{
    const lastPos = new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)();
    const dragMouseDown = (e)=>{
        e.preventDefault();
        dialog.style.zIndex = "1";
        lastPos.x = e.clientX;
        lastPos.y = e.clientY;
        document.addEventListener("mouseup", closeDragElement);
        document.addEventListener("mousemove", elementDrag);
    };
    const elementDrag = (e)=>{
        e.preventDefault();
        const dx = lastPos.x - e.clientX;
        const dy = lastPos.y - e.clientY;
        lastPos.x = e.clientX;
        lastPos.y = e.clientY;
        dialog.style.top = dialog.offsetTop - dy + "px";
        dialog.style.left = dialog.offsetLeft - dx + "px";
    };
    const closeDragElement = ()=>{
        dialog.style.zIndex = "0";
        document.removeEventListener("mouseup", closeDragElement);
        document.removeEventListener("mousemove", elementDrag);
    };
    const header = dialog.querySelector(".dialog-header");
    if (header) header.addEventListener("mousedown", dragMouseDown);
    else dialog.addEventListener("mousedown", dragMouseDown);
    return dialog;
};
var $7e30ca88d40c2428$export$2e2bcd8739ae039 = $7e30ca88d40c2428$var$dragElement;


const $1e3ba84e9ce044db$export$2ba01fb71ed41cb6 = (selector, onClick)=>{
    const button = document.querySelector(selector);
    if (onClick) button?.addEventListener("click", onClick);
    return button;
};
const $1e3ba84e9ce044db$export$e03c1c3201ee8bb7 = (button, view)=>{
    button.addEventListener("click", ()=>{
        view.hidden = !view.hidden;
    });
    return button;
};
const $1e3ba84e9ce044db$export$6210fa4921d2a466 = (selector, onSubmit)=>{
    const form = document.querySelector(selector);
    if (onSubmit) form?.addEventListener("submit", onSubmit);
    return form;
};




const $f43313d21d3fd8e2$var$canvas = document.querySelector("canvas");
$f43313d21d3fd8e2$var$canvas.tabIndex = 0;
$f43313d21d3fd8e2$var$canvas.autofocus = true;
const $f43313d21d3fd8e2$var$mainMenuView = document.querySelector("div#main-menu");
const $f43313d21d3fd8e2$var$nicknameInput = document.querySelector("input#nickname");
const $f43313d21d3fd8e2$var$hostBtn = document.querySelector("button#host");
const $f43313d21d3fd8e2$var$lobbyInput = document.querySelector("input#lobby");
const $f43313d21d3fd8e2$var$joinBtn = document.querySelector("button#join");
const $f43313d21d3fd8e2$var$closeBtns = document.querySelectorAll(".close");
$f43313d21d3fd8e2$var$closeBtns.forEach((btn)=>{
    btn.onclick = (e)=>e.target.parentElement.parentElement.hidden = true;
});
const $f43313d21d3fd8e2$var$storedNickname = localStorage.getItem("nickname");
if ($f43313d21d3fd8e2$var$storedNickname) $f43313d21d3fd8e2$var$nicknameInput.value = $f43313d21d3fd8e2$var$storedNickname;
let $f43313d21d3fd8e2$var$room = null;
function $f43313d21d3fd8e2$var$getDataURL(file) {
    const reader = new FileReader();
    const newFile = new File([
        file
    ], "temp", {
        type: file.type || "image/jpeg"
    });
    return new Promise((resolve)=>{
        reader.onload = (ev)=>{
            resolve(reader.result);
        };
        reader.readAsDataURL(newFile);
    });
}
const $f43313d21d3fd8e2$var$aliasesToFetch = new Set();
let $f43313d21d3fd8e2$var$fetchTimeout;
const $f43313d21d3fd8e2$export$cbe7bb95f4f6b11d = (key)=>{
    let texture = (0, $7eb272839e01564b$export$c8eca95e306f7116).get(key);
    if (!texture) {
        const isSpritesheetMatch = key.match(/(.+)-\d+$/);
        if (isSpritesheetMatch) $f43313d21d3fd8e2$var$aliasesToFetch.add(`${isSpritesheetMatch[1]}-sheet`);
        else $f43313d21d3fd8e2$var$aliasesToFetch.add(key);
        if ($f43313d21d3fd8e2$var$fetchTimeout) clearTimeout($f43313d21d3fd8e2$var$fetchTimeout);
        $f43313d21d3fd8e2$var$fetchTimeout = setTimeout(()=>{
            console.log("request-resource");
            $f43313d21d3fd8e2$var$room?.send({
                type: "request-resource",
                message: Array.from($f43313d21d3fd8e2$var$aliasesToFetch.values()).map((key)=>({
                        alias: key
                    }))
            });
            $f43313d21d3fd8e2$var$aliasesToFetch.clear();
        }, 1000);
        texture = new (0, $jollT.Texture)((0, $7eb272839e01564b$export$c8eca95e306f7116).get("card"));
    }
    texture.label = key;
    return texture;
};
let $f43313d21d3fd8e2$var$uiInitialized = false;
const $f43313d21d3fd8e2$var$init = async ()=>{
    const app = new (0, $3b122057363041d2$export$16975c34e60e1e61)();
    $f43313d21d3fd8e2$var$canvas.oncontextmenu = (event)=>{
        event.preventDefault();
    };
    await app.init({
        canvas: $f43313d21d3fd8e2$var$canvas,
        resizeTo: window,
        backgroundColor: "#1E553E",
        antialias: true,
        roundPixels: true
    });
    new (0, $45fe05e25c77474d$export$2e2bcd8739ae039)($f43313d21d3fd8e2$var$canvas);
    (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
        alias: "card",
        src: "assets/card.png"
    });
    (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
        alias: "card-face",
        src: "assets/card-face.png"
    });
    (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
        alias: "cursor",
        src: "assets/cursor.png"
    });
    (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
        alias: "arrow",
        src: "assets/arrow.png"
    });
    (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
        alias: "d20",
        src: "assets/d20.json"
    });
    (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
        alias: "d4-sheet",
        src: "assets/dices/d4_sheet.json"
    });
    (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
        alias: "d6-sheet",
        src: "assets/dices/d6_sheet.json"
    });
    (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
        alias: "d8-sheet",
        src: "assets/dices/d8_sheet.json"
    });
    (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
        alias: "d12-sheet",
        src: "assets/dices/d12_sheet.json"
    });
    (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
        alias: "d20-sheet",
        src: "assets/dices/d20_sheet.json"
    });
    // await Assets.load(['card', 'cursor', 'arrow', 'card-face', 'cards-sheet']);
    await (0, $7eb272839e01564b$export$c8eca95e306f7116).load([
        "card",
        "cursor",
        "arrow",
        "card-face",
        "d20",
        "d4-sheet",
        "d6-sheet",
        "d8-sheet",
        "d12-sheet",
        "d20-sheet"
    ]);
    (0, $a5a2646157cfe94d$export$eab32dcfc4ded11c).add("ping", {
        url: "assets/sounds/ping.mp3",
        volume: 1
    });
    (0, $a5a2646157cfe94d$export$eab32dcfc4ded11c).add("roll", {
        url: "assets/sounds/roll-dice.mp3",
        volume: 0.8
    });
    (0, $a5a2646157cfe94d$export$eab32dcfc4ded11c).add("pick", {
        url: "assets/sounds/pick.mp3",
        volume: 0.3
    });
    (0, $a5a2646157cfe94d$export$eab32dcfc4ded11c).add("shuffle", {
        url: "assets/sounds/card-shuffle.mp3",
        volume: 0.8
    });
    const connectToLobby = (nickname, lobbyKey)=>{
        localStorage.setItem("nickname", nickname);
        $f43313d21d3fd8e2$var$room = new (0, $455fa7c8daf8d6b7$export$c53a55e8a0b56c58)(nickname);
        const isHost = !lobbyKey;
        if (!isHost) {
            console.log("connect");
            $f43313d21d3fd8e2$var$room.connectToMember(lobbyKey);
        }
        $f43313d21d3fd8e2$var$mainMenuView.hidden = true;
        const gameManager = new (0, $da5e019e55829610$export$2e2bcd8739ae039)(app, $f43313d21d3fd8e2$var$room, isHost);
        if (!$f43313d21d3fd8e2$var$uiInitialized) {
            $f43313d21d3fd8e2$var$ui(gameManager, app);
            $f43313d21d3fd8e2$var$uiInitialized = true;
        }
        globalThis.gm = gameManager;
        gameManager.startGame();
        document.querySelector("#toolbar").hidden = false;
        window.addEventListener("beforeunload", function(e) {
            e.stopPropagation();
            e.preventDefault();
            return false;
        });
    };
    $f43313d21d3fd8e2$var$hostBtn.addEventListener("click", (e)=>{
        connectToLobby($f43313d21d3fd8e2$var$nicknameInput.value);
    });
    $f43313d21d3fd8e2$var$joinBtn.addEventListener("click", (e)=>{
        connectToLobby($f43313d21d3fd8e2$var$nicknameInput.value, $f43313d21d3fd8e2$var$lobbyInput.value);
    });
};
$f43313d21d3fd8e2$var$init();
function $f43313d21d3fd8e2$var$ui(gameManager, app) {
    (0, $1e3ba84e9ce044db$export$2ba01fb71ed41cb6)("#sync-btn", async ()=>gameManager.sync());
    (0, $1e3ba84e9ce044db$export$e03c1c3201ee8bb7)((0, $1e3ba84e9ce044db$export$2ba01fb71ed41cb6)("#save-btn"), (0, $7e30ca88d40c2428$export$2e2bcd8739ae039)((0, $1e3ba84e9ce044db$export$6210fa4921d2a466)("#save-dialog", async (e)=>{
        e.preventDefault();
        const formData = new FormData(e.target);
        const name = formData.get("name");
        const isPackingTextures = formData.get("pack-textures") === "on";
        const objectSerialized = [];
        const aliasesToSave = new Set();
        const textures = [];
        const getTexture = (texture)=>{
            const isSpritesheetMatch = texture.label.match(/(.+)-\d+$/);
            if (isSpritesheetMatch) {
                if (!aliasesToSave.has(`${isSpritesheetMatch[1]}-sheet`)) {
                    aliasesToSave.add(`${isSpritesheetMatch[1]}-sheet`);
                    const spritesheet = (0, $7eb272839e01564b$export$c8eca95e306f7116).get(`${isSpritesheetMatch[1]}-sheet`);
                    textures.push({
                        alias: isSpritesheetMatch[1],
                        spritesheetData: spritesheet.data,
                        src: texture.source.label
                    });
                }
            } else if (!aliasesToSave.has(texture.label)) textures.push({
                alias: texture.label,
                src: texture.source.label
            });
        };
        for (let obj of gameManager.gameObjects.values()){
            objectSerialized.push(obj.serialize());
            if (isPackingTextures) {
                if (obj instanceof (0, $d5cc4c6c246ec93a$export$2e2bcd8739ae039)) {
                    getTexture(obj.face);
                    getTexture(obj.back);
                }
            }
        }
        const zip = new (0, (/*@__PURE__*/$parcel$interopDefault($4f935bb8b4cfed5e$exports)))();
        if (isPackingTextures) {
            const texturesFolder = zip.folder("textures");
            textures.forEach((texture)=>{
                texturesFolder?.file(texture.alias, texture.src.replace(/^data:image\/?[A-z]*;base64,/, ""), {
                    base64: true
                });
                if (texture.spritesheetData) texturesFolder?.file(`${texture.alias}.json`, JSON.stringify(texture.spritesheetData));
            });
        }
        const state = {
            gameObjects: objectSerialized,
            hands: gameManager.hands.map((hand)=>({
                    player: null,
                    items: hand.items.map((item)=>item.id)
                })),
            nextUID: (0, $bc2c310e4f4b9933$export$8122402e62ffa7ac),
            name: name,
            meta: {
                timestamp: Date.now()
            }
        };
        const storageRoot = await navigator.storage.getDirectory();
        const saveFile = await storageRoot.getFileHandle(`${name}.json`, {
            create: true
        });
        const texturesFile = await storageRoot.getFileHandle(`${name}_textures.zip`, {
            create: true
        });
        zip.generateAsync({
            type: "blob",
            compression: "DEFLATE"
        }).then(async (content)=>{
            if (e.submitter.id === "save-table-to-disk") {
                const blob = new Blob([
                    JSON.stringify(state)
                ], {
                    type: "plain/text"
                });
                (0, $ed2b12aa71a74467$exports.saveAs)(blob, `${name}.json`);
                if (isPackingTextures) (0, $ed2b12aa71a74467$exports.saveAs)(content, `${name}_textures.zip`);
            } else {
                const stream = await saveFile.createWritable();
                try {
                    await stream.write(JSON.stringify(state));
                } finally{
                    await stream.close();
                }
                if (isPackingTextures) {
                    const streamTextures = await texturesFile.createWritable();
                    try {
                        await streamTextures.write(content);
                    } finally{
                        await streamTextures.close();
                    }
                }
            }
        });
    })));
    (0, $1e3ba84e9ce044db$export$e03c1c3201ee8bb7)((0, $1e3ba84e9ce044db$export$2ba01fb71ed41cb6)("#load-btn", async ()=>{
        // show saves
        const listContainer = document.querySelector("#saves-list");
        listContainer.innerHTML = "";
        const storageRoot = await navigator.storage.getDirectory();
        const entries = storageRoot.entries();
        for await (const [path, fileHandle] of entries)if (path.endsWith(".json")) {
            const item = document.createElement("div");
            item.className = "save-list-item";
            const itemImage = document.createElement("img");
            itemImage.src = "https://icons.iconarchive.com/icons/iconcubic/dnd-dice/32/d20-icon.png";
            itemImage.height = 35;
            item.appendChild(itemImage);
            const itemInfoContainer = document.createElement("div");
            const itemText = document.createElement("p");
            itemText.innerText = path.replace(".json", "");
            itemInfoContainer.appendChild(itemText);
            const saveHandle = await storageRoot.getFileHandle(path);
            const saveFile = await saveHandle.getFile();
            const itemMeta = document.createElement("p");
            itemMeta.className = "meta";
            item.appendChild(itemInfoContainer);
            try {
                const state = JSON.parse(await saveFile.text());
                itemMeta.innerText = new Date(state.meta.timestamp).toLocaleString();
                const itemLoad = document.createElement("button");
                itemLoad.addEventListener("click", async ()=>{
                    const texturesFileHandle = await storageRoot.getFileHandle(`${path.replace(".json", "")}_textures.zip`);
                    await loadTextures(await texturesFileHandle.getFile());
                    loadSave(state);
                });
                itemLoad.innerText = "Load";
                item.appendChild(itemLoad);
            } catch (e) {
                itemMeta.innerText = "CORRUPTED";
                itemMeta.style.color = "red";
                itemMeta.style.fontWeight = "bold";
            }
            itemInfoContainer.appendChild(itemMeta);
            const itemRemove = document.createElement("button");
            itemRemove.innerText = "x";
            itemRemove.addEventListener("click", async ()=>{
                await storageRoot.removeEntry(path);
                item.remove();
            });
            item.appendChild(itemRemove);
            listContainer.appendChild(item);
        }
    }), (0, $7e30ca88d40c2428$export$2e2bcd8739ae039)((0, $1e3ba84e9ce044db$export$6210fa4921d2a466)("#load-dialog", async (e)=>{
        e.preventDefault();
        if (e.submitter?.id === "load-table") {
            const formData = new FormData(e.target);
            const saveFile = formData.get("save-file");
            const state = JSON.parse(await saveFile.text());
            loadSave(state);
        }
    })));
    const loadTextures = async (texturesFile)=>{
        const zip = new (0, (/*@__PURE__*/$parcel$interopDefault($4f935bb8b4cfed5e$exports)))();
        const zipObject = await zip.loadAsync(await texturesFile.arrayBuffer(), {
            createFolders: true
        });
        const textureAliases = [];
        const spritesheetsToResolve = [];
        const filesTextures = [];
        zipObject.folder("textures").forEach((path, file)=>filesTextures.push({
                path: path,
                file: file
            }));
        for (const { path: path, file: file } of filesTextures)if (path.endsWith("json")) spritesheetsToResolve.push({
            path: path,
            spriteSheetData: JSON.parse(await file.async("string"))
        });
        else {
            const blob = await file.async("blob");
            const src = await $f43313d21d3fd8e2$var$getDataURL(blob);
            textureAliases.push(path);
            (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
                alias: path,
                src: src
            });
        }
        await (0, $7eb272839e01564b$export$c8eca95e306f7116).load(textureAliases);
        spritesheetsToResolve.forEach(async ({ path: path, spriteSheetData: spriteSheetData })=>{
            const alias = path.replace(".json", "");
            const texture = $f43313d21d3fd8e2$export$cbe7bb95f4f6b11d(alias);
            const spritesheet = new (0, $jxXUM.Spritesheet)(texture, spriteSheetData);
            await spritesheet.parse();
            (0, $7eb272839e01564b$export$c8eca95e306f7116).cache.set(`${alias}-sheet`, spritesheet);
        });
    };
    const loadSave = async (state)=>{
        gameManager.syncObjects({
            gameObjects: state.gameObjects,
            nextUID: state.nextUID,
            hands: state.hands
        });
        gameManager.sync();
    };
    (0, $1e3ba84e9ce044db$export$e03c1c3201ee8bb7)((0, $1e3ba84e9ce044db$export$2ba01fb71ed41cb6)("#create-card-btn"), (0, $7e30ca88d40c2428$export$2e2bcd8739ae039)((0, $1e3ba84e9ce044db$export$6210fa4921d2a466)("#card-dialog", async (e)=>{
        e.preventDefault();
        const formData = new FormData(e.target);
        const faceFile = formData.get("face");
        const backFile = formData.get("back");
        if (!((0, $7eb272839e01564b$export$c8eca95e306f7116).cache.has(faceFile.name) && (0, $7eb272839e01564b$export$c8eca95e306f7116).cache.has(backFile.name))) {
            const [faceUrl, backUrl] = await Promise.all([
                $f43313d21d3fd8e2$var$getDataURL(faceFile),
                $f43313d21d3fd8e2$var$getDataURL(backFile)
            ]);
            (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
                alias: faceFile.name,
                src: faceUrl
            });
            (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
                alias: backFile.name,
                src: backUrl
            });
            await (0, $7eb272839e01564b$export$c8eca95e306f7116).load([
                faceFile.name,
                backFile.name
            ]);
        }
        const cardSize = formData.get("card-size");
        const size = new (0, $5aa23f633f590d4c$export$9b781de7bf37bf48)();
        switch(cardSize){
            case "image":
                size.x = -1;
                size.y = -1;
                break;
            case "custom":
                size.x = +(formData.get("width") || 200);
                size.y = +(formData.get("height") || 280);
                break;
            case "default":
            default:
                size.x = 200;
                size.y = 280;
                break;
        }
        const card = new (0, $d5cc4c6c246ec93a$export$2e2bcd8739ae039)($f43313d21d3fd8e2$export$cbe7bb95f4f6b11d(faceFile.name), $f43313d21d3fd8e2$export$cbe7bb95f4f6b11d(backFile.name), size.x, size.y);
        gameManager.camera.addChild(card);
        gameManager.sync();
    })));
    const cardSizeToggle = document.querySelectorAll("#card-size-options > input");
    const customSizeValuesDiv = document.querySelector("#card-size-custom-values");
    const cardSizeToggleHandler = (event)=>{
        customSizeValuesDiv.hidden = event.target.value !== "custom";
    };
    cardSizeToggle.forEach((input)=>input.addEventListener("change", cardSizeToggleHandler));
    (0, $1e3ba84e9ce044db$export$e03c1c3201ee8bb7)((0, $1e3ba84e9ce044db$export$2ba01fb71ed41cb6)("#create-deck-btn"), (0, $7e30ca88d40c2428$export$2e2bcd8739ae039)((0, $1e3ba84e9ce044db$export$6210fa4921d2a466)("#deck-dialog", async (e)=>{
        e.preventDefault();
        const formData = new FormData(e.target);
        const spritesheetFile = formData.get("spritesheet");
        const backFile = formData.get("back");
        const backIndex = +formData.get("back-index");
        const cols = +formData.get("cols");
        const rows = +formData.get("rows");
        const isBackSeparate = formData.get("back-separate") === "on";
        let itemsToSend = null;
        if (!((0, $7eb272839e01564b$export$c8eca95e306f7116).cache.has(`${spritesheetFile.name}-sheet`) && (!isBackSeparate || isBackSeparate && (0, $7eb272839e01564b$export$c8eca95e306f7116).cache.has(backFile.name)))) {
            const spriteSheetTextureUrl = await $f43313d21d3fd8e2$var$getDataURL(spritesheetFile);
            (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
                alias: spritesheetFile.name,
                src: spriteSheetTextureUrl
            });
            await (0, $7eb272839e01564b$export$c8eca95e306f7116).load([
                spritesheetFile.name
            ]);
            const texture = $f43313d21d3fd8e2$export$cbe7bb95f4f6b11d(spritesheetFile.name);
            const width = texture.width;
            const height = texture.height;
            const frames = {};
            for(let j = 0; j < rows; j++)for(let i = 0; i < cols; i++)frames[`${spritesheetFile.name}-${j * cols + i + 1}`] = {
                frame: {
                    x: width / cols * i,
                    y: height / rows * j,
                    w: width / cols,
                    h: height / rows
                },
                sourceSize: {
                    w: width / cols,
                    h: height / rows
                },
                spriteSourceSize: {
                    x: 0,
                    y: 0,
                    w: width / cols,
                    h: height / rows
                }
            };
            const spritesheetData = {
                frames: frames,
                meta: {
                    scale: 1,
                    size: {
                        w: width,
                        h: height
                    }
                }
            };
            const spritesheet = new (0, $jxXUM.Spritesheet)(texture, spritesheetData);
            await spritesheet.parse();
            (0, $7eb272839e01564b$export$c8eca95e306f7116).cache.set(`${spritesheetFile.name}-sheet`, spritesheet);
            itemsToSend = [
                {
                    alias: spritesheetFile.name,
                    spritesheetData: spritesheetData,
                    src: spriteSheetTextureUrl
                }
            ];
            if (isBackSeparate) {
                const backUrl = await $f43313d21d3fd8e2$var$getDataURL(backFile);
                (0, $7eb272839e01564b$export$c8eca95e306f7116).add({
                    alias: backFile.name,
                    src: backUrl
                });
                await (0, $7eb272839e01564b$export$c8eca95e306f7116).load([
                    backFile.name
                ]);
                itemsToSend.push({
                    alias: backFile.name,
                    src: backUrl
                });
            }
        }
        const spritesheet = (0, $7eb272839e01564b$export$c8eca95e306f7116).get(`${spritesheetFile.name}-sheet`);
        const backTexture = isBackSeparate ? $f43313d21d3fd8e2$export$cbe7bb95f4f6b11d(backFile.name) : spritesheet.textures[`${spritesheetFile.name}-${backIndex}`];
        const cards = [];
        for(let i = 0; i < Object.keys(spritesheet.textures).length - 1 + +isBackSeparate; i++){
            const card = new (0, $d5cc4c6c246ec93a$export$2e2bcd8739ae039)(spritesheet.textures[`${spritesheetFile.name}-${i + 1}`], backTexture);
            cards.push(card);
        }
        gameManager.camera.addChild(new (0, $52837665fc953d6d$export$2e2bcd8739ae039)(cards));
        gameManager.sync();
    })));
    const backSeparateCheckBox = document.querySelector("#back-separate");
    backSeparateCheckBox.onchange = (e)=>{
        document.querySelector("#back-index").hidden = e.target.checked;
        document.querySelector("#back-file").hidden = !e.target.checked;
    };
    (0, $1e3ba84e9ce044db$export$2ba01fb71ed41cb6)("#dice-d4", ()=>{
        const d4spritesheet = (0, $7eb272839e01564b$export$c8eca95e306f7116).get("d4-sheet");
        const d4 = new (0, $a315f4ffaa4fa6a1$export$2e2bcd8739ae039)(d4spritesheet, 4);
        gameManager.camera.addChild(d4);
        gameManager.sync();
    });
    (0, $1e3ba84e9ce044db$export$2ba01fb71ed41cb6)("#dice-d6", ()=>{
        const d6spritesheet = (0, $7eb272839e01564b$export$c8eca95e306f7116).get("d6-sheet");
        const d6 = new (0, $a315f4ffaa4fa6a1$export$2e2bcd8739ae039)(d6spritesheet, 6);
        gameManager.camera.addChild(d6);
        gameManager.sync();
    });
    (0, $1e3ba84e9ce044db$export$2ba01fb71ed41cb6)("#dice-d8", ()=>{
        const d8spritesheet = (0, $7eb272839e01564b$export$c8eca95e306f7116).get("d8-sheet");
        const d8 = new (0, $a315f4ffaa4fa6a1$export$2e2bcd8739ae039)(d8spritesheet, 8);
        gameManager.camera.addChild(d8);
        gameManager.sync();
    });
    (0, $1e3ba84e9ce044db$export$2ba01fb71ed41cb6)("#dice-d12", ()=>{
        const d12spritesheet = (0, $7eb272839e01564b$export$c8eca95e306f7116).get("d12-sheet");
        const d12 = new (0, $a315f4ffaa4fa6a1$export$2e2bcd8739ae039)(d12spritesheet, 12);
        gameManager.camera.addChild(d12);
        gameManager.sync();
    });
    (0, $1e3ba84e9ce044db$export$2ba01fb71ed41cb6)("#dice-d20", ()=>{
        const d20spritesheet = (0, $7eb272839e01564b$export$c8eca95e306f7116).get("d20-sheet");
        const d20 = new (0, $a315f4ffaa4fa6a1$export$2e2bcd8739ae039)(d20spritesheet, 20);
        gameManager.camera.addChild(d20);
        gameManager.sync();
    });
}


//# sourceMappingURL=index.e1118833.js.map
